/* eslint-disable */
/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const mediaarchiver = $root.mediaarchiver = (() => {

    /**
     * Namespace mediaarchiver.
     * @exports mediaarchiver
     * @namespace
     */
    const mediaarchiver = {};

    /**
     * UserFunctionalities enum.
     * @name mediaarchiver.UserFunctionalities
     * @enum {number}
     * @property {number} FUNCTIONALITY_UNKNOWN=0 FUNCTIONALITY_UNKNOWN value
     * @property {number} FUNCTIONALITY_ANNOTATIONS=1 FUNCTIONALITY_ANNOTATIONS value
     * @property {number} FUNCTIONALITY_EXTRACTIONS=2 FUNCTIONALITY_EXTRACTIONS value
     * @property {number} FUNCTIONALITY_EXTRACTION_QUALITIES=3 FUNCTIONALITY_EXTRACTION_QUALITIES value
     * @property {number} FUNCTIONALITY_POLITICAL=4 FUNCTIONALITY_POLITICAL value
     * @property {number} FUNCTIONALITY_POLITICAL_SUPERVISOR_EDIT=5 FUNCTIONALITY_POLITICAL_SUPERVISOR_EDIT value
     * @property {number} FUNCTIONALITY_POLITICAL_SUPERVISOR_DELETE=6 FUNCTIONALITY_POLITICAL_SUPERVISOR_DELETE value
     * @property {number} FUNCTIONALITY_STT=7 FUNCTIONALITY_STT value
     */
    mediaarchiver.UserFunctionalities = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "FUNCTIONALITY_UNKNOWN"] = 0;
        values[valuesById[1] = "FUNCTIONALITY_ANNOTATIONS"] = 1;
        values[valuesById[2] = "FUNCTIONALITY_EXTRACTIONS"] = 2;
        values[valuesById[3] = "FUNCTIONALITY_EXTRACTION_QUALITIES"] = 3;
        values[valuesById[4] = "FUNCTIONALITY_POLITICAL"] = 4;
        values[valuesById[5] = "FUNCTIONALITY_POLITICAL_SUPERVISOR_EDIT"] = 5;
        values[valuesById[6] = "FUNCTIONALITY_POLITICAL_SUPERVISOR_DELETE"] = 6;
        values[valuesById[7] = "FUNCTIONALITY_STT"] = 7;
        return values;
    })();

    /**
     * UserOptions enum.
     * @name mediaarchiver.UserOptions
     * @enum {number}
     * @property {number} USER_OPTION_UNKNOWN=0 USER_OPTION_UNKNOWN value
     * @property {number} USER_OPTION_MAIL_NOTIFICATIONS=1 USER_OPTION_MAIL_NOTIFICATIONS value
     * @property {number} USER_OPTION_QUALITY_CHOICE=2 USER_OPTION_QUALITY_CHOICE value
     * @property {number} USER_OPTION_AUTOPLAY_ARCHIVES=3 USER_OPTION_AUTOPLAY_ARCHIVES value
     * @property {number} USER_OPTION_BROWSER_NOTIFICATIONS=4 USER_OPTION_BROWSER_NOTIFICATIONS value
     * @property {number} USER_OPTION_PAUSE_AFTER_IN_OUT=5 USER_OPTION_PAUSE_AFTER_IN_OUT value
     * @property {number} USER_OPTION_NO_AUTOPLAY_WHEN_PLAY_CONTENT=6 USER_OPTION_NO_AUTOPLAY_WHEN_PLAY_CONTENT value
     * @property {number} USER_OPTION_TIMELINE_FOLLOW_CURSOR=7 USER_OPTION_TIMELINE_FOLLOW_CURSOR value
     */
    mediaarchiver.UserOptions = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "USER_OPTION_UNKNOWN"] = 0;
        values[valuesById[1] = "USER_OPTION_MAIL_NOTIFICATIONS"] = 1;
        values[valuesById[2] = "USER_OPTION_QUALITY_CHOICE"] = 2;
        values[valuesById[3] = "USER_OPTION_AUTOPLAY_ARCHIVES"] = 3;
        values[valuesById[4] = "USER_OPTION_BROWSER_NOTIFICATIONS"] = 4;
        values[valuesById[5] = "USER_OPTION_PAUSE_AFTER_IN_OUT"] = 5;
        values[valuesById[6] = "USER_OPTION_NO_AUTOPLAY_WHEN_PLAY_CONTENT"] = 6;
        values[valuesById[7] = "USER_OPTION_TIMELINE_FOLLOW_CURSOR"] = 7;
        return values;
    })();

    mediaarchiver.UserOptionsList = (function() {

        /**
         * Properties of a UserOptionsList.
         * @memberof mediaarchiver
         * @interface IUserOptionsList
         * @property {Array.<mediaarchiver.UserOptions>|null} [Options] UserOptionsList Options
         */

        /**
         * Constructs a new UserOptionsList.
         * @memberof mediaarchiver
         * @classdesc Represents a UserOptionsList.
         * @implements IUserOptionsList
         * @constructor
         * @param {mediaarchiver.IUserOptionsList=} [properties] Properties to set
         */
        function UserOptionsList(properties) {
            this.Options = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UserOptionsList Options.
         * @member {Array.<mediaarchiver.UserOptions>} Options
         * @memberof mediaarchiver.UserOptionsList
         * @instance
         */
        UserOptionsList.prototype.Options = $util.emptyArray;

        /**
         * Creates a new UserOptionsList instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.UserOptionsList
         * @static
         * @param {mediaarchiver.IUserOptionsList=} [properties] Properties to set
         * @returns {mediaarchiver.UserOptionsList} UserOptionsList instance
         */
        UserOptionsList.create = function create(properties) {
            return new UserOptionsList(properties);
        };

        /**
         * Encodes the specified UserOptionsList message. Does not implicitly {@link mediaarchiver.UserOptionsList.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.UserOptionsList
         * @static
         * @param {mediaarchiver.IUserOptionsList} message UserOptionsList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserOptionsList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Options != null && message.Options.length) {
                writer.uint32(/* id 1, wireType 2 =*/10).fork();
                for (let i = 0; i < message.Options.length; ++i)
                    writer.int32(message.Options[i]);
                writer.ldelim();
            }
            return writer;
        };

        /**
         * Encodes the specified UserOptionsList message, length delimited. Does not implicitly {@link mediaarchiver.UserOptionsList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.UserOptionsList
         * @static
         * @param {mediaarchiver.IUserOptionsList} message UserOptionsList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserOptionsList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a UserOptionsList message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.UserOptionsList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.UserOptionsList} UserOptionsList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserOptionsList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.UserOptionsList();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.Options && message.Options.length))
                        message.Options = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.Options.push(reader.int32());
                    } else
                        message.Options.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a UserOptionsList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.UserOptionsList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.UserOptionsList} UserOptionsList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserOptionsList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a UserOptionsList message.
         * @function verify
         * @memberof mediaarchiver.UserOptionsList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UserOptionsList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Options != null && message.hasOwnProperty("Options")) {
                if (!Array.isArray(message.Options))
                    return "Options: array expected";
                for (let i = 0; i < message.Options.length; ++i)
                    switch (message.Options[i]) {
                    default:
                        return "Options: enum value[] expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                        break;
                    }
            }
            return null;
        };

        /**
         * Creates a UserOptionsList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.UserOptionsList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.UserOptionsList} UserOptionsList
         */
        UserOptionsList.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.UserOptionsList)
                return object;
            let message = new $root.mediaarchiver.UserOptionsList();
            if (object.Options) {
                if (!Array.isArray(object.Options))
                    throw TypeError(".mediaarchiver.UserOptionsList.Options: array expected");
                message.Options = [];
                for (let i = 0; i < object.Options.length; ++i)
                    switch (object.Options[i]) {
                    default:
                    case "USER_OPTION_UNKNOWN":
                    case 0:
                        message.Options[i] = 0;
                        break;
                    case "USER_OPTION_MAIL_NOTIFICATIONS":
                    case 1:
                        message.Options[i] = 1;
                        break;
                    case "USER_OPTION_QUALITY_CHOICE":
                    case 2:
                        message.Options[i] = 2;
                        break;
                    case "USER_OPTION_AUTOPLAY_ARCHIVES":
                    case 3:
                        message.Options[i] = 3;
                        break;
                    case "USER_OPTION_BROWSER_NOTIFICATIONS":
                    case 4:
                        message.Options[i] = 4;
                        break;
                    case "USER_OPTION_PAUSE_AFTER_IN_OUT":
                    case 5:
                        message.Options[i] = 5;
                        break;
                    case "USER_OPTION_NO_AUTOPLAY_WHEN_PLAY_CONTENT":
                    case 6:
                        message.Options[i] = 6;
                        break;
                    case "USER_OPTION_TIMELINE_FOLLOW_CURSOR":
                    case 7:
                        message.Options[i] = 7;
                        break;
                    }
            }
            return message;
        };

        /**
         * Creates a plain object from a UserOptionsList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.UserOptionsList
         * @static
         * @param {mediaarchiver.UserOptionsList} message UserOptionsList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UserOptionsList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Options = [];
            if (message.Options && message.Options.length) {
                object.Options = [];
                for (let j = 0; j < message.Options.length; ++j)
                    object.Options[j] = options.enums === String ? $root.mediaarchiver.UserOptions[message.Options[j]] : message.Options[j];
            }
            return object;
        };

        /**
         * Converts this UserOptionsList to JSON.
         * @function toJSON
         * @memberof mediaarchiver.UserOptionsList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UserOptionsList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UserOptionsList;
    })();

    mediaarchiver.User = (function() {

        /**
         * Properties of a User.
         * @memberof mediaarchiver
         * @interface IUser
         * @property {string|null} [SessionID] User SessionID
         * @property {boolean|null} [LoggedIn] User LoggedIn
         * @property {number|null} [ID] User ID
         * @property {number|null} [Group] User Group
         * @property {string|null} [Login] User Login
         * @property {string|null} [FirstName] User FirstName
         * @property {string|null} [LastName] User LastName
         * @property {string|null} [Email] User Email
         * @property {Array.<mediaarchiver.EPGType>|null} [AllowedEPGTypes] User AllowedEPGTypes
         * @property {Array.<mediaarchiver.UserFunctionalities>|null} [Functionalities] User Functionalities
         * @property {Array.<mediaarchiver.UserOptions>|null} [Options] User Options
         * @property {boolean|null} [Share] User Share
         * @property {mediaarchiver.IUserShareParams|null} [ShareParams] User ShareParams
         * @property {string|null} [GroupName] User GroupName
         * @property {string|null} [Phone] User Phone
         */

        /**
         * Constructs a new User.
         * @memberof mediaarchiver
         * @classdesc Represents a User.
         * @implements IUser
         * @constructor
         * @param {mediaarchiver.IUser=} [properties] Properties to set
         */
        function User(properties) {
            this.AllowedEPGTypes = [];
            this.Functionalities = [];
            this.Options = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User SessionID.
         * @member {string} SessionID
         * @memberof mediaarchiver.User
         * @instance
         */
        User.prototype.SessionID = "";

        /**
         * User LoggedIn.
         * @member {boolean} LoggedIn
         * @memberof mediaarchiver.User
         * @instance
         */
        User.prototype.LoggedIn = false;

        /**
         * User ID.
         * @member {number} ID
         * @memberof mediaarchiver.User
         * @instance
         */
        User.prototype.ID = 0;

        /**
         * User Group.
         * @member {number} Group
         * @memberof mediaarchiver.User
         * @instance
         */
        User.prototype.Group = 0;

        /**
         * User Login.
         * @member {string} Login
         * @memberof mediaarchiver.User
         * @instance
         */
        User.prototype.Login = "";

        /**
         * User FirstName.
         * @member {string} FirstName
         * @memberof mediaarchiver.User
         * @instance
         */
        User.prototype.FirstName = "";

        /**
         * User LastName.
         * @member {string} LastName
         * @memberof mediaarchiver.User
         * @instance
         */
        User.prototype.LastName = "";

        /**
         * User Email.
         * @member {string} Email
         * @memberof mediaarchiver.User
         * @instance
         */
        User.prototype.Email = "";

        /**
         * User AllowedEPGTypes.
         * @member {Array.<mediaarchiver.EPGType>} AllowedEPGTypes
         * @memberof mediaarchiver.User
         * @instance
         */
        User.prototype.AllowedEPGTypes = $util.emptyArray;

        /**
         * User Functionalities.
         * @member {Array.<mediaarchiver.UserFunctionalities>} Functionalities
         * @memberof mediaarchiver.User
         * @instance
         */
        User.prototype.Functionalities = $util.emptyArray;

        /**
         * User Options.
         * @member {Array.<mediaarchiver.UserOptions>} Options
         * @memberof mediaarchiver.User
         * @instance
         */
        User.prototype.Options = $util.emptyArray;

        /**
         * User Share.
         * @member {boolean} Share
         * @memberof mediaarchiver.User
         * @instance
         */
        User.prototype.Share = false;

        /**
         * User ShareParams.
         * @member {mediaarchiver.IUserShareParams|null|undefined} ShareParams
         * @memberof mediaarchiver.User
         * @instance
         */
        User.prototype.ShareParams = null;

        /**
         * User GroupName.
         * @member {string} GroupName
         * @memberof mediaarchiver.User
         * @instance
         */
        User.prototype.GroupName = "";

        /**
         * User Phone.
         * @member {string} Phone
         * @memberof mediaarchiver.User
         * @instance
         */
        User.prototype.Phone = "";

        /**
         * Creates a new User instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.User
         * @static
         * @param {mediaarchiver.IUser=} [properties] Properties to set
         * @returns {mediaarchiver.User} User instance
         */
        User.create = function create(properties) {
            return new User(properties);
        };

        /**
         * Encodes the specified User message. Does not implicitly {@link mediaarchiver.User.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.User
         * @static
         * @param {mediaarchiver.IUser} message User message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.SessionID != null && Object.hasOwnProperty.call(message, "SessionID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.SessionID);
            if (message.LoggedIn != null && Object.hasOwnProperty.call(message, "LoggedIn"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.LoggedIn);
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ID);
            if (message.Group != null && Object.hasOwnProperty.call(message, "Group"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.Group);
            if (message.Login != null && Object.hasOwnProperty.call(message, "Login"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.Login);
            if (message.FirstName != null && Object.hasOwnProperty.call(message, "FirstName"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.FirstName);
            if (message.LastName != null && Object.hasOwnProperty.call(message, "LastName"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.LastName);
            if (message.Email != null && Object.hasOwnProperty.call(message, "Email"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.Email);
            if (message.AllowedEPGTypes != null && message.AllowedEPGTypes.length) {
                writer.uint32(/* id 9, wireType 2 =*/74).fork();
                for (let i = 0; i < message.AllowedEPGTypes.length; ++i)
                    writer.int32(message.AllowedEPGTypes[i]);
                writer.ldelim();
            }
            if (message.Functionalities != null && message.Functionalities.length) {
                writer.uint32(/* id 10, wireType 2 =*/82).fork();
                for (let i = 0; i < message.Functionalities.length; ++i)
                    writer.int32(message.Functionalities[i]);
                writer.ldelim();
            }
            if (message.Options != null && message.Options.length) {
                writer.uint32(/* id 11, wireType 2 =*/90).fork();
                for (let i = 0; i < message.Options.length; ++i)
                    writer.int32(message.Options[i]);
                writer.ldelim();
            }
            if (message.Share != null && Object.hasOwnProperty.call(message, "Share"))
                writer.uint32(/* id 12, wireType 0 =*/96).bool(message.Share);
            if (message.ShareParams != null && Object.hasOwnProperty.call(message, "ShareParams"))
                $root.mediaarchiver.UserShareParams.encode(message.ShareParams, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
            if (message.GroupName != null && Object.hasOwnProperty.call(message, "GroupName"))
                writer.uint32(/* id 14, wireType 2 =*/114).string(message.GroupName);
            if (message.Phone != null && Object.hasOwnProperty.call(message, "Phone"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.Phone);
            return writer;
        };

        /**
         * Encodes the specified User message, length delimited. Does not implicitly {@link mediaarchiver.User.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.User
         * @static
         * @param {mediaarchiver.IUser} message User message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.User
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.User} User
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.User();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.SessionID = reader.string();
                    break;
                case 2:
                    message.LoggedIn = reader.bool();
                    break;
                case 3:
                    message.ID = reader.uint32();
                    break;
                case 4:
                    message.Group = reader.uint32();
                    break;
                case 5:
                    message.Login = reader.string();
                    break;
                case 6:
                    message.FirstName = reader.string();
                    break;
                case 7:
                    message.LastName = reader.string();
                    break;
                case 8:
                    message.Email = reader.string();
                    break;
                case 9:
                    if (!(message.AllowedEPGTypes && message.AllowedEPGTypes.length))
                        message.AllowedEPGTypes = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.AllowedEPGTypes.push(reader.int32());
                    } else
                        message.AllowedEPGTypes.push(reader.int32());
                    break;
                case 10:
                    if (!(message.Functionalities && message.Functionalities.length))
                        message.Functionalities = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.Functionalities.push(reader.int32());
                    } else
                        message.Functionalities.push(reader.int32());
                    break;
                case 11:
                    if (!(message.Options && message.Options.length))
                        message.Options = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.Options.push(reader.int32());
                    } else
                        message.Options.push(reader.int32());
                    break;
                case 12:
                    message.Share = reader.bool();
                    break;
                case 13:
                    message.ShareParams = $root.mediaarchiver.UserShareParams.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.GroupName = reader.string();
                    break;
                case 15:
                    message.Phone = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.User
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.User} User
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User message.
         * @function verify
         * @memberof mediaarchiver.User
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.SessionID != null && message.hasOwnProperty("SessionID"))
                if (!$util.isString(message.SessionID))
                    return "SessionID: string expected";
            if (message.LoggedIn != null && message.hasOwnProperty("LoggedIn"))
                if (typeof message.LoggedIn !== "boolean")
                    return "LoggedIn: boolean expected";
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isInteger(message.ID))
                    return "ID: integer expected";
            if (message.Group != null && message.hasOwnProperty("Group"))
                if (!$util.isInteger(message.Group))
                    return "Group: integer expected";
            if (message.Login != null && message.hasOwnProperty("Login"))
                if (!$util.isString(message.Login))
                    return "Login: string expected";
            if (message.FirstName != null && message.hasOwnProperty("FirstName"))
                if (!$util.isString(message.FirstName))
                    return "FirstName: string expected";
            if (message.LastName != null && message.hasOwnProperty("LastName"))
                if (!$util.isString(message.LastName))
                    return "LastName: string expected";
            if (message.Email != null && message.hasOwnProperty("Email"))
                if (!$util.isString(message.Email))
                    return "Email: string expected";
            if (message.AllowedEPGTypes != null && message.hasOwnProperty("AllowedEPGTypes")) {
                if (!Array.isArray(message.AllowedEPGTypes))
                    return "AllowedEPGTypes: array expected";
                for (let i = 0; i < message.AllowedEPGTypes.length; ++i)
                    switch (message.AllowedEPGTypes[i]) {
                    default:
                        return "AllowedEPGTypes: enum value[] expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 16:
                    case 17:
                    case 18:
                    case 19:
                    case 20:
                    case 21:
                    case 22:
                    case 23:
                    case 24:
                    case 25:
                    case 26:
                    case 27:
                    case 28:
                    case 29:
                    case 30:
                    case 31:
                    case 32:
                    case 33:
                    case 34:
                    case 35:
                    case 36:
                    case 37:
                    case 38:
                    case 39:
                    case 40:
                    case 41:
                    case 42:
                    case 43:
                        break;
                    }
            }
            if (message.Functionalities != null && message.hasOwnProperty("Functionalities")) {
                if (!Array.isArray(message.Functionalities))
                    return "Functionalities: array expected";
                for (let i = 0; i < message.Functionalities.length; ++i)
                    switch (message.Functionalities[i]) {
                    default:
                        return "Functionalities: enum value[] expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                        break;
                    }
            }
            if (message.Options != null && message.hasOwnProperty("Options")) {
                if (!Array.isArray(message.Options))
                    return "Options: array expected";
                for (let i = 0; i < message.Options.length; ++i)
                    switch (message.Options[i]) {
                    default:
                        return "Options: enum value[] expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                        break;
                    }
            }
            if (message.Share != null && message.hasOwnProperty("Share"))
                if (typeof message.Share !== "boolean")
                    return "Share: boolean expected";
            if (message.ShareParams != null && message.hasOwnProperty("ShareParams")) {
                let error = $root.mediaarchiver.UserShareParams.verify(message.ShareParams);
                if (error)
                    return "ShareParams." + error;
            }
            if (message.GroupName != null && message.hasOwnProperty("GroupName"))
                if (!$util.isString(message.GroupName))
                    return "GroupName: string expected";
            if (message.Phone != null && message.hasOwnProperty("Phone"))
                if (!$util.isString(message.Phone))
                    return "Phone: string expected";
            return null;
        };

        /**
         * Creates a User message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.User
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.User} User
         */
        User.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.User)
                return object;
            let message = new $root.mediaarchiver.User();
            if (object.SessionID != null)
                message.SessionID = String(object.SessionID);
            if (object.LoggedIn != null)
                message.LoggedIn = Boolean(object.LoggedIn);
            if (object.ID != null)
                message.ID = object.ID >>> 0;
            if (object.Group != null)
                message.Group = object.Group >>> 0;
            if (object.Login != null)
                message.Login = String(object.Login);
            if (object.FirstName != null)
                message.FirstName = String(object.FirstName);
            if (object.LastName != null)
                message.LastName = String(object.LastName);
            if (object.Email != null)
                message.Email = String(object.Email);
            if (object.AllowedEPGTypes) {
                if (!Array.isArray(object.AllowedEPGTypes))
                    throw TypeError(".mediaarchiver.User.AllowedEPGTypes: array expected");
                message.AllowedEPGTypes = [];
                for (let i = 0; i < object.AllowedEPGTypes.length; ++i)
                    switch (object.AllowedEPGTypes[i]) {
                    default:
                    case "DECLARATIVE":
                    case 0:
                        message.AllowedEPGTypes[i] = 0;
                        break;
                    case "READJUSTED1":
                    case 1:
                        message.AllowedEPGTypes[i] = 1;
                        break;
                    case "READJUSTED2":
                    case 2:
                        message.AllowedEPGTypes[i] = 2;
                        break;
                    case "MUSIC":
                    case 3:
                        message.AllowedEPGTypes[i] = 3;
                        break;
                    case "TALK":
                    case 4:
                        message.AllowedEPGTypes[i] = 4;
                        break;
                    case "ANNOTATIONS":
                    case 5:
                        message.AllowedEPGTypes[i] = 5;
                        break;
                    case "AUDIENCE":
                    case 6:
                        message.AllowedEPGTypes[i] = 6;
                        break;
                    case "METADATA":
                    case 7:
                        message.AllowedEPGTypes[i] = 7;
                        break;
                    case "BACKGROUND":
                    case 8:
                        message.AllowedEPGTypes[i] = 8;
                        break;
                    case "STT":
                    case 9:
                        message.AllowedEPGTypes[i] = 9;
                        break;
                    case "BROADCASTER1":
                    case 10:
                        message.AllowedEPGTypes[i] = 10;
                        break;
                    case "BROADCASTER2":
                    case 11:
                        message.AllowedEPGTypes[i] = 11;
                        break;
                    case "DECLARATIVERADIO1":
                    case 12:
                        message.AllowedEPGTypes[i] = 12;
                        break;
                    case "DECLARATIVERADIO2":
                    case 13:
                        message.AllowedEPGTypes[i] = 13;
                        break;
                    case "CROSSBUCKET":
                    case 14:
                        message.AllowedEPGTypes[i] = 14;
                        break;
                    case "EXTRACTRESULTS":
                    case 15:
                        message.AllowedEPGTypes[i] = 15;
                        break;
                    case "BRUTPHONO1":
                    case 16:
                        message.AllowedEPGTypes[i] = 16;
                        break;
                    case "BRUTPHONO2":
                    case 17:
                        message.AllowedEPGTypes[i] = 17;
                        break;
                    case "BRUTPHONO3":
                    case 18:
                        message.AllowedEPGTypes[i] = 18;
                        break;
                    case "BRUTPHONO4":
                    case 19:
                        message.AllowedEPGTypes[i] = 19;
                        break;
                    case "LEONV11":
                    case 20:
                        message.AllowedEPGTypes[i] = 20;
                        break;
                    case "LEONV12":
                    case 21:
                        message.AllowedEPGTypes[i] = 21;
                        break;
                    case "LEONV13":
                    case 22:
                        message.AllowedEPGTypes[i] = 22;
                        break;
                    case "LEONV14":
                    case 23:
                        message.AllowedEPGTypes[i] = 23;
                        break;
                    case "NIKITAMONOBUCKET1":
                    case 24:
                        message.AllowedEPGTypes[i] = 24;
                        break;
                    case "NIKITAMONOBUCKET2":
                    case 25:
                        message.AllowedEPGTypes[i] = 25;
                        break;
                    case "NIKITAMONOBUCKET3":
                    case 26:
                        message.AllowedEPGTypes[i] = 26;
                        break;
                    case "NIKITAMONOBUCKET4":
                    case 27:
                        message.AllowedEPGTypes[i] = 27;
                        break;
                    case "ARPP":
                    case 28:
                        message.AllowedEPGTypes[i] = 28;
                        break;
                    case "BACKGROUNDSTG":
                    case 29:
                        message.AllowedEPGTypes[i] = 29;
                        break;
                    case "CROSSBUCKETSTG":
                    case 30:
                        message.AllowedEPGTypes[i] = 30;
                        break;
                    case "MNM0":
                    case 31:
                        message.AllowedEPGTypes[i] = 31;
                        break;
                    case "MNM1":
                    case 32:
                        message.AllowedEPGTypes[i] = 32;
                        break;
                    case "MNMXB0":
                    case 33:
                        message.AllowedEPGTypes[i] = 33;
                        break;
                    case "MNMXB1":
                    case 34:
                        message.AllowedEPGTypes[i] = 34;
                        break;
                    case "SPONSORING":
                    case 35:
                        message.AllowedEPGTypes[i] = 35;
                        break;
                    case "MNIONLY0":
                    case 36:
                        message.AllowedEPGTypes[i] = 36;
                        break;
                    case "MNIONLY1":
                    case 37:
                        message.AllowedEPGTypes[i] = 37;
                        break;
                    case "OCR1":
                    case 38:
                        message.AllowedEPGTypes[i] = 38;
                        break;
                    case "OCR2":
                    case 39:
                        message.AllowedEPGTypes[i] = 39;
                        break;
                    case "TALKDETAILS1":
                    case 40:
                        message.AllowedEPGTypes[i] = 40;
                        break;
                    case "TALKDETAILS2":
                    case 41:
                        message.AllowedEPGTypes[i] = 41;
                        break;
                    case "OCRTITLE1":
                    case 42:
                        message.AllowedEPGTypes[i] = 42;
                        break;
                    case "OCRTITLE2":
                    case 43:
                        message.AllowedEPGTypes[i] = 43;
                        break;
                    }
            }
            if (object.Functionalities) {
                if (!Array.isArray(object.Functionalities))
                    throw TypeError(".mediaarchiver.User.Functionalities: array expected");
                message.Functionalities = [];
                for (let i = 0; i < object.Functionalities.length; ++i)
                    switch (object.Functionalities[i]) {
                    default:
                    case "FUNCTIONALITY_UNKNOWN":
                    case 0:
                        message.Functionalities[i] = 0;
                        break;
                    case "FUNCTIONALITY_ANNOTATIONS":
                    case 1:
                        message.Functionalities[i] = 1;
                        break;
                    case "FUNCTIONALITY_EXTRACTIONS":
                    case 2:
                        message.Functionalities[i] = 2;
                        break;
                    case "FUNCTIONALITY_EXTRACTION_QUALITIES":
                    case 3:
                        message.Functionalities[i] = 3;
                        break;
                    case "FUNCTIONALITY_POLITICAL":
                    case 4:
                        message.Functionalities[i] = 4;
                        break;
                    case "FUNCTIONALITY_POLITICAL_SUPERVISOR_EDIT":
                    case 5:
                        message.Functionalities[i] = 5;
                        break;
                    case "FUNCTIONALITY_POLITICAL_SUPERVISOR_DELETE":
                    case 6:
                        message.Functionalities[i] = 6;
                        break;
                    case "FUNCTIONALITY_STT":
                    case 7:
                        message.Functionalities[i] = 7;
                        break;
                    }
            }
            if (object.Options) {
                if (!Array.isArray(object.Options))
                    throw TypeError(".mediaarchiver.User.Options: array expected");
                message.Options = [];
                for (let i = 0; i < object.Options.length; ++i)
                    switch (object.Options[i]) {
                    default:
                    case "USER_OPTION_UNKNOWN":
                    case 0:
                        message.Options[i] = 0;
                        break;
                    case "USER_OPTION_MAIL_NOTIFICATIONS":
                    case 1:
                        message.Options[i] = 1;
                        break;
                    case "USER_OPTION_QUALITY_CHOICE":
                    case 2:
                        message.Options[i] = 2;
                        break;
                    case "USER_OPTION_AUTOPLAY_ARCHIVES":
                    case 3:
                        message.Options[i] = 3;
                        break;
                    case "USER_OPTION_BROWSER_NOTIFICATIONS":
                    case 4:
                        message.Options[i] = 4;
                        break;
                    case "USER_OPTION_PAUSE_AFTER_IN_OUT":
                    case 5:
                        message.Options[i] = 5;
                        break;
                    case "USER_OPTION_NO_AUTOPLAY_WHEN_PLAY_CONTENT":
                    case 6:
                        message.Options[i] = 6;
                        break;
                    case "USER_OPTION_TIMELINE_FOLLOW_CURSOR":
                    case 7:
                        message.Options[i] = 7;
                        break;
                    }
            }
            if (object.Share != null)
                message.Share = Boolean(object.Share);
            if (object.ShareParams != null) {
                if (typeof object.ShareParams !== "object")
                    throw TypeError(".mediaarchiver.User.ShareParams: object expected");
                message.ShareParams = $root.mediaarchiver.UserShareParams.fromObject(object.ShareParams);
            }
            if (object.GroupName != null)
                message.GroupName = String(object.GroupName);
            if (object.Phone != null)
                message.Phone = String(object.Phone);
            return message;
        };

        /**
         * Creates a plain object from a User message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.User
         * @static
         * @param {mediaarchiver.User} message User
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.AllowedEPGTypes = [];
                object.Functionalities = [];
                object.Options = [];
            }
            if (options.defaults) {
                object.SessionID = "";
                object.LoggedIn = false;
                object.ID = 0;
                object.Group = 0;
                object.Login = "";
                object.FirstName = "";
                object.LastName = "";
                object.Email = "";
                object.Share = false;
                object.ShareParams = null;
                object.GroupName = "";
                object.Phone = "";
            }
            if (message.SessionID != null && message.hasOwnProperty("SessionID"))
                object.SessionID = message.SessionID;
            if (message.LoggedIn != null && message.hasOwnProperty("LoggedIn"))
                object.LoggedIn = message.LoggedIn;
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            if (message.Group != null && message.hasOwnProperty("Group"))
                object.Group = message.Group;
            if (message.Login != null && message.hasOwnProperty("Login"))
                object.Login = message.Login;
            if (message.FirstName != null && message.hasOwnProperty("FirstName"))
                object.FirstName = message.FirstName;
            if (message.LastName != null && message.hasOwnProperty("LastName"))
                object.LastName = message.LastName;
            if (message.Email != null && message.hasOwnProperty("Email"))
                object.Email = message.Email;
            if (message.AllowedEPGTypes && message.AllowedEPGTypes.length) {
                object.AllowedEPGTypes = [];
                for (let j = 0; j < message.AllowedEPGTypes.length; ++j)
                    object.AllowedEPGTypes[j] = options.enums === String ? $root.mediaarchiver.EPGType[message.AllowedEPGTypes[j]] : message.AllowedEPGTypes[j];
            }
            if (message.Functionalities && message.Functionalities.length) {
                object.Functionalities = [];
                for (let j = 0; j < message.Functionalities.length; ++j)
                    object.Functionalities[j] = options.enums === String ? $root.mediaarchiver.UserFunctionalities[message.Functionalities[j]] : message.Functionalities[j];
            }
            if (message.Options && message.Options.length) {
                object.Options = [];
                for (let j = 0; j < message.Options.length; ++j)
                    object.Options[j] = options.enums === String ? $root.mediaarchiver.UserOptions[message.Options[j]] : message.Options[j];
            }
            if (message.Share != null && message.hasOwnProperty("Share"))
                object.Share = message.Share;
            if (message.ShareParams != null && message.hasOwnProperty("ShareParams"))
                object.ShareParams = $root.mediaarchiver.UserShareParams.toObject(message.ShareParams, options);
            if (message.GroupName != null && message.hasOwnProperty("GroupName"))
                object.GroupName = message.GroupName;
            if (message.Phone != null && message.hasOwnProperty("Phone"))
                object.Phone = message.Phone;
            return object;
        };

        /**
         * Converts this User to JSON.
         * @function toJSON
         * @memberof mediaarchiver.User
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return User;
    })();

    mediaarchiver.UserShareParams = (function() {

        /**
         * Properties of a UserShareParams.
         * @memberof mediaarchiver
         * @interface IUserShareParams
         * @property {number|Long|null} [Start] UserShareParams Start
         * @property {number|Long|null} [End] UserShareParams End
         * @property {number|null} [Media] UserShareParams Media
         * @property {Array.<mediaarchiver.EPGType>|null} [Types] UserShareParams Types
         * @property {string|null} [MediaName] UserShareParams MediaName
         * @property {number|null} [MediaType] UserShareParams MediaType
         * @property {number|null} [ViewCount] UserShareParams ViewCount
         * @property {string|null} [ArchiveTitle] UserShareParams ArchiveTitle
         * @property {string|null} [Sender] UserShareParams Sender
         * @property {string|null} [Type] UserShareParams Type
         * @property {string|null} [DataToken] UserShareParams DataToken
         * @property {string|null} [StreamerToken] UserShareParams StreamerToken
         */

        /**
         * Constructs a new UserShareParams.
         * @memberof mediaarchiver
         * @classdesc Represents a UserShareParams.
         * @implements IUserShareParams
         * @constructor
         * @param {mediaarchiver.IUserShareParams=} [properties] Properties to set
         */
        function UserShareParams(properties) {
            this.Types = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UserShareParams Start.
         * @member {number|Long} Start
         * @memberof mediaarchiver.UserShareParams
         * @instance
         */
        UserShareParams.prototype.Start = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * UserShareParams End.
         * @member {number|Long} End
         * @memberof mediaarchiver.UserShareParams
         * @instance
         */
        UserShareParams.prototype.End = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * UserShareParams Media.
         * @member {number} Media
         * @memberof mediaarchiver.UserShareParams
         * @instance
         */
        UserShareParams.prototype.Media = 0;

        /**
         * UserShareParams Types.
         * @member {Array.<mediaarchiver.EPGType>} Types
         * @memberof mediaarchiver.UserShareParams
         * @instance
         */
        UserShareParams.prototype.Types = $util.emptyArray;

        /**
         * UserShareParams MediaName.
         * @member {string} MediaName
         * @memberof mediaarchiver.UserShareParams
         * @instance
         */
        UserShareParams.prototype.MediaName = "";

        /**
         * UserShareParams MediaType.
         * @member {number} MediaType
         * @memberof mediaarchiver.UserShareParams
         * @instance
         */
        UserShareParams.prototype.MediaType = 0;

        /**
         * UserShareParams ViewCount.
         * @member {number} ViewCount
         * @memberof mediaarchiver.UserShareParams
         * @instance
         */
        UserShareParams.prototype.ViewCount = 0;

        /**
         * UserShareParams ArchiveTitle.
         * @member {string} ArchiveTitle
         * @memberof mediaarchiver.UserShareParams
         * @instance
         */
        UserShareParams.prototype.ArchiveTitle = "";

        /**
         * UserShareParams Sender.
         * @member {string} Sender
         * @memberof mediaarchiver.UserShareParams
         * @instance
         */
        UserShareParams.prototype.Sender = "";

        /**
         * UserShareParams Type.
         * @member {string} Type
         * @memberof mediaarchiver.UserShareParams
         * @instance
         */
        UserShareParams.prototype.Type = "";

        /**
         * UserShareParams DataToken.
         * @member {string} DataToken
         * @memberof mediaarchiver.UserShareParams
         * @instance
         */
        UserShareParams.prototype.DataToken = "";

        /**
         * UserShareParams StreamerToken.
         * @member {string} StreamerToken
         * @memberof mediaarchiver.UserShareParams
         * @instance
         */
        UserShareParams.prototype.StreamerToken = "";

        /**
         * Creates a new UserShareParams instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.UserShareParams
         * @static
         * @param {mediaarchiver.IUserShareParams=} [properties] Properties to set
         * @returns {mediaarchiver.UserShareParams} UserShareParams instance
         */
        UserShareParams.create = function create(properties) {
            return new UserShareParams(properties);
        };

        /**
         * Encodes the specified UserShareParams message. Does not implicitly {@link mediaarchiver.UserShareParams.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.UserShareParams
         * @static
         * @param {mediaarchiver.IUserShareParams} message UserShareParams message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserShareParams.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Start != null && Object.hasOwnProperty.call(message, "Start"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.Start);
            if (message.End != null && Object.hasOwnProperty.call(message, "End"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.End);
            if (message.Media != null && Object.hasOwnProperty.call(message, "Media"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.Media);
            if (message.Types != null && message.Types.length) {
                writer.uint32(/* id 4, wireType 2 =*/34).fork();
                for (let i = 0; i < message.Types.length; ++i)
                    writer.int32(message.Types[i]);
                writer.ldelim();
            }
            if (message.MediaName != null && Object.hasOwnProperty.call(message, "MediaName"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.MediaName);
            if (message.MediaType != null && Object.hasOwnProperty.call(message, "MediaType"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.MediaType);
            if (message.ViewCount != null && Object.hasOwnProperty.call(message, "ViewCount"))
                writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.ViewCount);
            if (message.ArchiveTitle != null && Object.hasOwnProperty.call(message, "ArchiveTitle"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.ArchiveTitle);
            if (message.Sender != null && Object.hasOwnProperty.call(message, "Sender"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.Sender);
            if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.Type);
            if (message.DataToken != null && Object.hasOwnProperty.call(message, "DataToken"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.DataToken);
            if (message.StreamerToken != null && Object.hasOwnProperty.call(message, "StreamerToken"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.StreamerToken);
            return writer;
        };

        /**
         * Encodes the specified UserShareParams message, length delimited. Does not implicitly {@link mediaarchiver.UserShareParams.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.UserShareParams
         * @static
         * @param {mediaarchiver.IUserShareParams} message UserShareParams message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserShareParams.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a UserShareParams message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.UserShareParams
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.UserShareParams} UserShareParams
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserShareParams.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.UserShareParams();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Start = reader.int64();
                    break;
                case 2:
                    message.End = reader.int64();
                    break;
                case 3:
                    message.Media = reader.uint32();
                    break;
                case 4:
                    if (!(message.Types && message.Types.length))
                        message.Types = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.Types.push(reader.int32());
                    } else
                        message.Types.push(reader.int32());
                    break;
                case 5:
                    message.MediaName = reader.string();
                    break;
                case 6:
                    message.MediaType = reader.uint32();
                    break;
                case 7:
                    message.ViewCount = reader.uint32();
                    break;
                case 8:
                    message.ArchiveTitle = reader.string();
                    break;
                case 9:
                    message.Sender = reader.string();
                    break;
                case 10:
                    message.Type = reader.string();
                    break;
                case 11:
                    message.DataToken = reader.string();
                    break;
                case 12:
                    message.StreamerToken = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a UserShareParams message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.UserShareParams
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.UserShareParams} UserShareParams
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserShareParams.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a UserShareParams message.
         * @function verify
         * @memberof mediaarchiver.UserShareParams
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UserShareParams.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (!$util.isInteger(message.Start) && !(message.Start && $util.isInteger(message.Start.low) && $util.isInteger(message.Start.high)))
                    return "Start: integer|Long expected";
            if (message.End != null && message.hasOwnProperty("End"))
                if (!$util.isInteger(message.End) && !(message.End && $util.isInteger(message.End.low) && $util.isInteger(message.End.high)))
                    return "End: integer|Long expected";
            if (message.Media != null && message.hasOwnProperty("Media"))
                if (!$util.isInteger(message.Media))
                    return "Media: integer expected";
            if (message.Types != null && message.hasOwnProperty("Types")) {
                if (!Array.isArray(message.Types))
                    return "Types: array expected";
                for (let i = 0; i < message.Types.length; ++i)
                    switch (message.Types[i]) {
                    default:
                        return "Types: enum value[] expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 16:
                    case 17:
                    case 18:
                    case 19:
                    case 20:
                    case 21:
                    case 22:
                    case 23:
                    case 24:
                    case 25:
                    case 26:
                    case 27:
                    case 28:
                    case 29:
                    case 30:
                    case 31:
                    case 32:
                    case 33:
                    case 34:
                    case 35:
                    case 36:
                    case 37:
                    case 38:
                    case 39:
                    case 40:
                    case 41:
                    case 42:
                    case 43:
                        break;
                    }
            }
            if (message.MediaName != null && message.hasOwnProperty("MediaName"))
                if (!$util.isString(message.MediaName))
                    return "MediaName: string expected";
            if (message.MediaType != null && message.hasOwnProperty("MediaType"))
                if (!$util.isInteger(message.MediaType))
                    return "MediaType: integer expected";
            if (message.ViewCount != null && message.hasOwnProperty("ViewCount"))
                if (!$util.isInteger(message.ViewCount))
                    return "ViewCount: integer expected";
            if (message.ArchiveTitle != null && message.hasOwnProperty("ArchiveTitle"))
                if (!$util.isString(message.ArchiveTitle))
                    return "ArchiveTitle: string expected";
            if (message.Sender != null && message.hasOwnProperty("Sender"))
                if (!$util.isString(message.Sender))
                    return "Sender: string expected";
            if (message.Type != null && message.hasOwnProperty("Type"))
                if (!$util.isString(message.Type))
                    return "Type: string expected";
            if (message.DataToken != null && message.hasOwnProperty("DataToken"))
                if (!$util.isString(message.DataToken))
                    return "DataToken: string expected";
            if (message.StreamerToken != null && message.hasOwnProperty("StreamerToken"))
                if (!$util.isString(message.StreamerToken))
                    return "StreamerToken: string expected";
            return null;
        };

        /**
         * Creates a UserShareParams message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.UserShareParams
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.UserShareParams} UserShareParams
         */
        UserShareParams.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.UserShareParams)
                return object;
            let message = new $root.mediaarchiver.UserShareParams();
            if (object.Start != null)
                if ($util.Long)
                    (message.Start = $util.Long.fromValue(object.Start)).unsigned = false;
                else if (typeof object.Start === "string")
                    message.Start = parseInt(object.Start, 10);
                else if (typeof object.Start === "number")
                    message.Start = object.Start;
                else if (typeof object.Start === "object")
                    message.Start = new $util.LongBits(object.Start.low >>> 0, object.Start.high >>> 0).toNumber();
            if (object.End != null)
                if ($util.Long)
                    (message.End = $util.Long.fromValue(object.End)).unsigned = false;
                else if (typeof object.End === "string")
                    message.End = parseInt(object.End, 10);
                else if (typeof object.End === "number")
                    message.End = object.End;
                else if (typeof object.End === "object")
                    message.End = new $util.LongBits(object.End.low >>> 0, object.End.high >>> 0).toNumber();
            if (object.Media != null)
                message.Media = object.Media >>> 0;
            if (object.Types) {
                if (!Array.isArray(object.Types))
                    throw TypeError(".mediaarchiver.UserShareParams.Types: array expected");
                message.Types = [];
                for (let i = 0; i < object.Types.length; ++i)
                    switch (object.Types[i]) {
                    default:
                    case "DECLARATIVE":
                    case 0:
                        message.Types[i] = 0;
                        break;
                    case "READJUSTED1":
                    case 1:
                        message.Types[i] = 1;
                        break;
                    case "READJUSTED2":
                    case 2:
                        message.Types[i] = 2;
                        break;
                    case "MUSIC":
                    case 3:
                        message.Types[i] = 3;
                        break;
                    case "TALK":
                    case 4:
                        message.Types[i] = 4;
                        break;
                    case "ANNOTATIONS":
                    case 5:
                        message.Types[i] = 5;
                        break;
                    case "AUDIENCE":
                    case 6:
                        message.Types[i] = 6;
                        break;
                    case "METADATA":
                    case 7:
                        message.Types[i] = 7;
                        break;
                    case "BACKGROUND":
                    case 8:
                        message.Types[i] = 8;
                        break;
                    case "STT":
                    case 9:
                        message.Types[i] = 9;
                        break;
                    case "BROADCASTER1":
                    case 10:
                        message.Types[i] = 10;
                        break;
                    case "BROADCASTER2":
                    case 11:
                        message.Types[i] = 11;
                        break;
                    case "DECLARATIVERADIO1":
                    case 12:
                        message.Types[i] = 12;
                        break;
                    case "DECLARATIVERADIO2":
                    case 13:
                        message.Types[i] = 13;
                        break;
                    case "CROSSBUCKET":
                    case 14:
                        message.Types[i] = 14;
                        break;
                    case "EXTRACTRESULTS":
                    case 15:
                        message.Types[i] = 15;
                        break;
                    case "BRUTPHONO1":
                    case 16:
                        message.Types[i] = 16;
                        break;
                    case "BRUTPHONO2":
                    case 17:
                        message.Types[i] = 17;
                        break;
                    case "BRUTPHONO3":
                    case 18:
                        message.Types[i] = 18;
                        break;
                    case "BRUTPHONO4":
                    case 19:
                        message.Types[i] = 19;
                        break;
                    case "LEONV11":
                    case 20:
                        message.Types[i] = 20;
                        break;
                    case "LEONV12":
                    case 21:
                        message.Types[i] = 21;
                        break;
                    case "LEONV13":
                    case 22:
                        message.Types[i] = 22;
                        break;
                    case "LEONV14":
                    case 23:
                        message.Types[i] = 23;
                        break;
                    case "NIKITAMONOBUCKET1":
                    case 24:
                        message.Types[i] = 24;
                        break;
                    case "NIKITAMONOBUCKET2":
                    case 25:
                        message.Types[i] = 25;
                        break;
                    case "NIKITAMONOBUCKET3":
                    case 26:
                        message.Types[i] = 26;
                        break;
                    case "NIKITAMONOBUCKET4":
                    case 27:
                        message.Types[i] = 27;
                        break;
                    case "ARPP":
                    case 28:
                        message.Types[i] = 28;
                        break;
                    case "BACKGROUNDSTG":
                    case 29:
                        message.Types[i] = 29;
                        break;
                    case "CROSSBUCKETSTG":
                    case 30:
                        message.Types[i] = 30;
                        break;
                    case "MNM0":
                    case 31:
                        message.Types[i] = 31;
                        break;
                    case "MNM1":
                    case 32:
                        message.Types[i] = 32;
                        break;
                    case "MNMXB0":
                    case 33:
                        message.Types[i] = 33;
                        break;
                    case "MNMXB1":
                    case 34:
                        message.Types[i] = 34;
                        break;
                    case "SPONSORING":
                    case 35:
                        message.Types[i] = 35;
                        break;
                    case "MNIONLY0":
                    case 36:
                        message.Types[i] = 36;
                        break;
                    case "MNIONLY1":
                    case 37:
                        message.Types[i] = 37;
                        break;
                    case "OCR1":
                    case 38:
                        message.Types[i] = 38;
                        break;
                    case "OCR2":
                    case 39:
                        message.Types[i] = 39;
                        break;
                    case "TALKDETAILS1":
                    case 40:
                        message.Types[i] = 40;
                        break;
                    case "TALKDETAILS2":
                    case 41:
                        message.Types[i] = 41;
                        break;
                    case "OCRTITLE1":
                    case 42:
                        message.Types[i] = 42;
                        break;
                    case "OCRTITLE2":
                    case 43:
                        message.Types[i] = 43;
                        break;
                    }
            }
            if (object.MediaName != null)
                message.MediaName = String(object.MediaName);
            if (object.MediaType != null)
                message.MediaType = object.MediaType >>> 0;
            if (object.ViewCount != null)
                message.ViewCount = object.ViewCount >>> 0;
            if (object.ArchiveTitle != null)
                message.ArchiveTitle = String(object.ArchiveTitle);
            if (object.Sender != null)
                message.Sender = String(object.Sender);
            if (object.Type != null)
                message.Type = String(object.Type);
            if (object.DataToken != null)
                message.DataToken = String(object.DataToken);
            if (object.StreamerToken != null)
                message.StreamerToken = String(object.StreamerToken);
            return message;
        };

        /**
         * Creates a plain object from a UserShareParams message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.UserShareParams
         * @static
         * @param {mediaarchiver.UserShareParams} message UserShareParams
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UserShareParams.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Types = [];
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.Start = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.Start = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.End = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.End = options.longs === String ? "0" : 0;
                object.Media = 0;
                object.MediaName = "";
                object.MediaType = 0;
                object.ViewCount = 0;
                object.ArchiveTitle = "";
                object.Sender = "";
                object.Type = "";
                object.DataToken = "";
                object.StreamerToken = "";
            }
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (typeof message.Start === "number")
                    object.Start = options.longs === String ? String(message.Start) : message.Start;
                else
                    object.Start = options.longs === String ? $util.Long.prototype.toString.call(message.Start) : options.longs === Number ? new $util.LongBits(message.Start.low >>> 0, message.Start.high >>> 0).toNumber() : message.Start;
            if (message.End != null && message.hasOwnProperty("End"))
                if (typeof message.End === "number")
                    object.End = options.longs === String ? String(message.End) : message.End;
                else
                    object.End = options.longs === String ? $util.Long.prototype.toString.call(message.End) : options.longs === Number ? new $util.LongBits(message.End.low >>> 0, message.End.high >>> 0).toNumber() : message.End;
            if (message.Media != null && message.hasOwnProperty("Media"))
                object.Media = message.Media;
            if (message.Types && message.Types.length) {
                object.Types = [];
                for (let j = 0; j < message.Types.length; ++j)
                    object.Types[j] = options.enums === String ? $root.mediaarchiver.EPGType[message.Types[j]] : message.Types[j];
            }
            if (message.MediaName != null && message.hasOwnProperty("MediaName"))
                object.MediaName = message.MediaName;
            if (message.MediaType != null && message.hasOwnProperty("MediaType"))
                object.MediaType = message.MediaType;
            if (message.ViewCount != null && message.hasOwnProperty("ViewCount"))
                object.ViewCount = message.ViewCount;
            if (message.ArchiveTitle != null && message.hasOwnProperty("ArchiveTitle"))
                object.ArchiveTitle = message.ArchiveTitle;
            if (message.Sender != null && message.hasOwnProperty("Sender"))
                object.Sender = message.Sender;
            if (message.Type != null && message.hasOwnProperty("Type"))
                object.Type = message.Type;
            if (message.DataToken != null && message.hasOwnProperty("DataToken"))
                object.DataToken = message.DataToken;
            if (message.StreamerToken != null && message.hasOwnProperty("StreamerToken"))
                object.StreamerToken = message.StreamerToken;
            return object;
        };

        /**
         * Converts this UserShareParams to JSON.
         * @function toJSON
         * @memberof mediaarchiver.UserShareParams
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UserShareParams.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UserShareParams;
    })();

    mediaarchiver.ExpiringToken = (function() {

        /**
         * Properties of an ExpiringToken.
         * @memberof mediaarchiver
         * @interface IExpiringToken
         * @property {string|null} [Token] ExpiringToken Token
         * @property {number|Long|null} [Expires] ExpiringToken Expires
         * @property {string|null} [Login] ExpiringToken Login
         */

        /**
         * Constructs a new ExpiringToken.
         * @memberof mediaarchiver
         * @classdesc Represents an ExpiringToken.
         * @implements IExpiringToken
         * @constructor
         * @param {mediaarchiver.IExpiringToken=} [properties] Properties to set
         */
        function ExpiringToken(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ExpiringToken Token.
         * @member {string} Token
         * @memberof mediaarchiver.ExpiringToken
         * @instance
         */
        ExpiringToken.prototype.Token = "";

        /**
         * ExpiringToken Expires.
         * @member {number|Long} Expires
         * @memberof mediaarchiver.ExpiringToken
         * @instance
         */
        ExpiringToken.prototype.Expires = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ExpiringToken Login.
         * @member {string} Login
         * @memberof mediaarchiver.ExpiringToken
         * @instance
         */
        ExpiringToken.prototype.Login = "";

        /**
         * Creates a new ExpiringToken instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ExpiringToken
         * @static
         * @param {mediaarchiver.IExpiringToken=} [properties] Properties to set
         * @returns {mediaarchiver.ExpiringToken} ExpiringToken instance
         */
        ExpiringToken.create = function create(properties) {
            return new ExpiringToken(properties);
        };

        /**
         * Encodes the specified ExpiringToken message. Does not implicitly {@link mediaarchiver.ExpiringToken.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ExpiringToken
         * @static
         * @param {mediaarchiver.IExpiringToken} message ExpiringToken message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExpiringToken.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Token != null && Object.hasOwnProperty.call(message, "Token"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Token);
            if (message.Expires != null && Object.hasOwnProperty.call(message, "Expires"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.Expires);
            if (message.Login != null && Object.hasOwnProperty.call(message, "Login"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.Login);
            return writer;
        };

        /**
         * Encodes the specified ExpiringToken message, length delimited. Does not implicitly {@link mediaarchiver.ExpiringToken.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ExpiringToken
         * @static
         * @param {mediaarchiver.IExpiringToken} message ExpiringToken message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExpiringToken.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ExpiringToken message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ExpiringToken
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ExpiringToken} ExpiringToken
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExpiringToken.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ExpiringToken();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Token = reader.string();
                    break;
                case 2:
                    message.Expires = reader.int64();
                    break;
                case 3:
                    message.Login = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ExpiringToken message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ExpiringToken
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ExpiringToken} ExpiringToken
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExpiringToken.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ExpiringToken message.
         * @function verify
         * @memberof mediaarchiver.ExpiringToken
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ExpiringToken.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Token != null && message.hasOwnProperty("Token"))
                if (!$util.isString(message.Token))
                    return "Token: string expected";
            if (message.Expires != null && message.hasOwnProperty("Expires"))
                if (!$util.isInteger(message.Expires) && !(message.Expires && $util.isInteger(message.Expires.low) && $util.isInteger(message.Expires.high)))
                    return "Expires: integer|Long expected";
            if (message.Login != null && message.hasOwnProperty("Login"))
                if (!$util.isString(message.Login))
                    return "Login: string expected";
            return null;
        };

        /**
         * Creates an ExpiringToken message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ExpiringToken
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ExpiringToken} ExpiringToken
         */
        ExpiringToken.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ExpiringToken)
                return object;
            let message = new $root.mediaarchiver.ExpiringToken();
            if (object.Token != null)
                message.Token = String(object.Token);
            if (object.Expires != null)
                if ($util.Long)
                    (message.Expires = $util.Long.fromValue(object.Expires)).unsigned = false;
                else if (typeof object.Expires === "string")
                    message.Expires = parseInt(object.Expires, 10);
                else if (typeof object.Expires === "number")
                    message.Expires = object.Expires;
                else if (typeof object.Expires === "object")
                    message.Expires = new $util.LongBits(object.Expires.low >>> 0, object.Expires.high >>> 0).toNumber();
            if (object.Login != null)
                message.Login = String(object.Login);
            return message;
        };

        /**
         * Creates a plain object from an ExpiringToken message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ExpiringToken
         * @static
         * @param {mediaarchiver.ExpiringToken} message ExpiringToken
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ExpiringToken.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.Token = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.Expires = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.Expires = options.longs === String ? "0" : 0;
                object.Login = "";
            }
            if (message.Token != null && message.hasOwnProperty("Token"))
                object.Token = message.Token;
            if (message.Expires != null && message.hasOwnProperty("Expires"))
                if (typeof message.Expires === "number")
                    object.Expires = options.longs === String ? String(message.Expires) : message.Expires;
                else
                    object.Expires = options.longs === String ? $util.Long.prototype.toString.call(message.Expires) : options.longs === Number ? new $util.LongBits(message.Expires.low >>> 0, message.Expires.high >>> 0).toNumber() : message.Expires;
            if (message.Login != null && message.hasOwnProperty("Login"))
                object.Login = message.Login;
            return object;
        };

        /**
         * Converts this ExpiringToken to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ExpiringToken
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ExpiringToken.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ExpiringToken;
    })();

    /**
     * EPGType enum.
     * @name mediaarchiver.EPGType
     * @enum {number}
     * @property {number} DECLARATIVE=0 DECLARATIVE value
     * @property {number} READJUSTED1=1 READJUSTED1 value
     * @property {number} READJUSTED2=2 READJUSTED2 value
     * @property {number} MUSIC=3 MUSIC value
     * @property {number} TALK=4 TALK value
     * @property {number} ANNOTATIONS=5 ANNOTATIONS value
     * @property {number} AUDIENCE=6 AUDIENCE value
     * @property {number} METADATA=7 METADATA value
     * @property {number} BACKGROUND=8 BACKGROUND value
     * @property {number} STT=9 STT value
     * @property {number} BROADCASTER1=10 BROADCASTER1 value
     * @property {number} BROADCASTER2=11 BROADCASTER2 value
     * @property {number} DECLARATIVERADIO1=12 DECLARATIVERADIO1 value
     * @property {number} DECLARATIVERADIO2=13 DECLARATIVERADIO2 value
     * @property {number} CROSSBUCKET=14 CROSSBUCKET value
     * @property {number} EXTRACTRESULTS=15 EXTRACTRESULTS value
     * @property {number} BRUTPHONO1=16 BRUTPHONO1 value
     * @property {number} BRUTPHONO2=17 BRUTPHONO2 value
     * @property {number} BRUTPHONO3=18 BRUTPHONO3 value
     * @property {number} BRUTPHONO4=19 BRUTPHONO4 value
     * @property {number} LEONV11=20 LEONV11 value
     * @property {number} LEONV12=21 LEONV12 value
     * @property {number} LEONV13=22 LEONV13 value
     * @property {number} LEONV14=23 LEONV14 value
     * @property {number} NIKITAMONOBUCKET1=24 NIKITAMONOBUCKET1 value
     * @property {number} NIKITAMONOBUCKET2=25 NIKITAMONOBUCKET2 value
     * @property {number} NIKITAMONOBUCKET3=26 NIKITAMONOBUCKET3 value
     * @property {number} NIKITAMONOBUCKET4=27 NIKITAMONOBUCKET4 value
     * @property {number} ARPP=28 ARPP value
     * @property {number} BACKGROUNDSTG=29 BACKGROUNDSTG value
     * @property {number} CROSSBUCKETSTG=30 CROSSBUCKETSTG value
     * @property {number} MNM0=31 MNM0 value
     * @property {number} MNM1=32 MNM1 value
     * @property {number} MNMXB0=33 MNMXB0 value
     * @property {number} MNMXB1=34 MNMXB1 value
     * @property {number} SPONSORING=35 SPONSORING value
     * @property {number} MNIONLY0=36 MNIONLY0 value
     * @property {number} MNIONLY1=37 MNIONLY1 value
     * @property {number} OCR1=38 OCR1 value
     * @property {number} OCR2=39 OCR2 value
     * @property {number} TALKDETAILS1=40 TALKDETAILS1 value
     * @property {number} TALKDETAILS2=41 TALKDETAILS2 value
     * @property {number} OCRTITLE1=42 OCRTITLE1 value
     * @property {number} OCRTITLE2=43 OCRTITLE2 value
     */
    mediaarchiver.EPGType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DECLARATIVE"] = 0;
        values[valuesById[1] = "READJUSTED1"] = 1;
        values[valuesById[2] = "READJUSTED2"] = 2;
        values[valuesById[3] = "MUSIC"] = 3;
        values[valuesById[4] = "TALK"] = 4;
        values[valuesById[5] = "ANNOTATIONS"] = 5;
        values[valuesById[6] = "AUDIENCE"] = 6;
        values[valuesById[7] = "METADATA"] = 7;
        values[valuesById[8] = "BACKGROUND"] = 8;
        values[valuesById[9] = "STT"] = 9;
        values[valuesById[10] = "BROADCASTER1"] = 10;
        values[valuesById[11] = "BROADCASTER2"] = 11;
        values[valuesById[12] = "DECLARATIVERADIO1"] = 12;
        values[valuesById[13] = "DECLARATIVERADIO2"] = 13;
        values[valuesById[14] = "CROSSBUCKET"] = 14;
        values[valuesById[15] = "EXTRACTRESULTS"] = 15;
        values[valuesById[16] = "BRUTPHONO1"] = 16;
        values[valuesById[17] = "BRUTPHONO2"] = 17;
        values[valuesById[18] = "BRUTPHONO3"] = 18;
        values[valuesById[19] = "BRUTPHONO4"] = 19;
        values[valuesById[20] = "LEONV11"] = 20;
        values[valuesById[21] = "LEONV12"] = 21;
        values[valuesById[22] = "LEONV13"] = 22;
        values[valuesById[23] = "LEONV14"] = 23;
        values[valuesById[24] = "NIKITAMONOBUCKET1"] = 24;
        values[valuesById[25] = "NIKITAMONOBUCKET2"] = 25;
        values[valuesById[26] = "NIKITAMONOBUCKET3"] = 26;
        values[valuesById[27] = "NIKITAMONOBUCKET4"] = 27;
        values[valuesById[28] = "ARPP"] = 28;
        values[valuesById[29] = "BACKGROUNDSTG"] = 29;
        values[valuesById[30] = "CROSSBUCKETSTG"] = 30;
        values[valuesById[31] = "MNM0"] = 31;
        values[valuesById[32] = "MNM1"] = 32;
        values[valuesById[33] = "MNMXB0"] = 33;
        values[valuesById[34] = "MNMXB1"] = 34;
        values[valuesById[35] = "SPONSORING"] = 35;
        values[valuesById[36] = "MNIONLY0"] = 36;
        values[valuesById[37] = "MNIONLY1"] = 37;
        values[valuesById[38] = "OCR1"] = 38;
        values[valuesById[39] = "OCR2"] = 39;
        values[valuesById[40] = "TALKDETAILS1"] = 40;
        values[valuesById[41] = "TALKDETAILS2"] = 41;
        values[valuesById[42] = "OCRTITLE1"] = 42;
        values[valuesById[43] = "OCRTITLE2"] = 43;
        return values;
    })();

    mediaarchiver.EPGProgram = (function() {

        /**
         * Properties of a EPGProgram.
         * @memberof mediaarchiver
         * @interface IEPGProgram
         * @property {string|null} [Category] EPGProgram Category
         * @property {string|null} [CategoryText] EPGProgram CategoryText
         * @property {number|null} [DurationMS] EPGProgram DurationMS
         * @property {string|null} [Title] EPGProgram Title
         * @property {number|Long|null} [Start] EPGProgram Start
         * @property {string|null} [Subtitle] EPGProgram Subtitle
         * @property {string|null} [Synopsis] EPGProgram Synopsis
         * @property {string|null} [Vignette] EPGProgram Vignette
         * @property {Object.<string,string>|null} [Metas] EPGProgram Metas
         */

        /**
         * Constructs a new EPGProgram.
         * @memberof mediaarchiver
         * @classdesc Represents a EPGProgram.
         * @implements IEPGProgram
         * @constructor
         * @param {mediaarchiver.IEPGProgram=} [properties] Properties to set
         */
        function EPGProgram(properties) {
            this.Metas = {};
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EPGProgram Category.
         * @member {string} Category
         * @memberof mediaarchiver.EPGProgram
         * @instance
         */
        EPGProgram.prototype.Category = "";

        /**
         * EPGProgram CategoryText.
         * @member {string} CategoryText
         * @memberof mediaarchiver.EPGProgram
         * @instance
         */
        EPGProgram.prototype.CategoryText = "";

        /**
         * EPGProgram DurationMS.
         * @member {number} DurationMS
         * @memberof mediaarchiver.EPGProgram
         * @instance
         */
        EPGProgram.prototype.DurationMS = 0;

        /**
         * EPGProgram Title.
         * @member {string} Title
         * @memberof mediaarchiver.EPGProgram
         * @instance
         */
        EPGProgram.prototype.Title = "";

        /**
         * EPGProgram Start.
         * @member {number|Long} Start
         * @memberof mediaarchiver.EPGProgram
         * @instance
         */
        EPGProgram.prototype.Start = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * EPGProgram Subtitle.
         * @member {string} Subtitle
         * @memberof mediaarchiver.EPGProgram
         * @instance
         */
        EPGProgram.prototype.Subtitle = "";

        /**
         * EPGProgram Synopsis.
         * @member {string} Synopsis
         * @memberof mediaarchiver.EPGProgram
         * @instance
         */
        EPGProgram.prototype.Synopsis = "";

        /**
         * EPGProgram Vignette.
         * @member {string} Vignette
         * @memberof mediaarchiver.EPGProgram
         * @instance
         */
        EPGProgram.prototype.Vignette = "";

        /**
         * EPGProgram Metas.
         * @member {Object.<string,string>} Metas
         * @memberof mediaarchiver.EPGProgram
         * @instance
         */
        EPGProgram.prototype.Metas = $util.emptyObject;

        /**
         * Creates a new EPGProgram instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.EPGProgram
         * @static
         * @param {mediaarchiver.IEPGProgram=} [properties] Properties to set
         * @returns {mediaarchiver.EPGProgram} EPGProgram instance
         */
        EPGProgram.create = function create(properties) {
            return new EPGProgram(properties);
        };

        /**
         * Encodes the specified EPGProgram message. Does not implicitly {@link mediaarchiver.EPGProgram.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.EPGProgram
         * @static
         * @param {mediaarchiver.IEPGProgram} message EPGProgram message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EPGProgram.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Category != null && Object.hasOwnProperty.call(message, "Category"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Category);
            if (message.CategoryText != null && Object.hasOwnProperty.call(message, "CategoryText"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.CategoryText);
            if (message.DurationMS != null && Object.hasOwnProperty.call(message, "DurationMS"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.DurationMS);
            if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.Title);
            if (message.Start != null && Object.hasOwnProperty.call(message, "Start"))
                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.Start);
            if (message.Subtitle != null && Object.hasOwnProperty.call(message, "Subtitle"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.Subtitle);
            if (message.Synopsis != null && Object.hasOwnProperty.call(message, "Synopsis"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.Synopsis);
            if (message.Vignette != null && Object.hasOwnProperty.call(message, "Vignette"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.Vignette);
            if (message.Metas != null && Object.hasOwnProperty.call(message, "Metas"))
                for (let keys = Object.keys(message.Metas), i = 0; i < keys.length; ++i)
                    writer.uint32(/* id 9, wireType 2 =*/74).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.Metas[keys[i]]).ldelim();
            return writer;
        };

        /**
         * Encodes the specified EPGProgram message, length delimited. Does not implicitly {@link mediaarchiver.EPGProgram.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.EPGProgram
         * @static
         * @param {mediaarchiver.IEPGProgram} message EPGProgram message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EPGProgram.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a EPGProgram message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.EPGProgram
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.EPGProgram} EPGProgram
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EPGProgram.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.EPGProgram(), key, value;
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Category = reader.string();
                    break;
                case 2:
                    message.CategoryText = reader.string();
                    break;
                case 3:
                    message.DurationMS = reader.uint32();
                    break;
                case 4:
                    message.Title = reader.string();
                    break;
                case 5:
                    message.Start = reader.int64();
                    break;
                case 6:
                    message.Subtitle = reader.string();
                    break;
                case 7:
                    message.Synopsis = reader.string();
                    break;
                case 8:
                    message.Vignette = reader.string();
                    break;
                case 9:
                    if (message.Metas === $util.emptyObject)
                        message.Metas = {};
                    let end2 = reader.uint32() + reader.pos;
                    key = "";
                    value = "";
                    while (reader.pos < end2) {
                        let tag2 = reader.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            key = reader.string();
                            break;
                        case 2:
                            value = reader.string();
                            break;
                        default:
                            reader.skipType(tag2 & 7);
                            break;
                        }
                    }
                    message.Metas[key] = value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a EPGProgram message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.EPGProgram
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.EPGProgram} EPGProgram
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EPGProgram.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a EPGProgram message.
         * @function verify
         * @memberof mediaarchiver.EPGProgram
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EPGProgram.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Category != null && message.hasOwnProperty("Category"))
                if (!$util.isString(message.Category))
                    return "Category: string expected";
            if (message.CategoryText != null && message.hasOwnProperty("CategoryText"))
                if (!$util.isString(message.CategoryText))
                    return "CategoryText: string expected";
            if (message.DurationMS != null && message.hasOwnProperty("DurationMS"))
                if (!$util.isInteger(message.DurationMS))
                    return "DurationMS: integer expected";
            if (message.Title != null && message.hasOwnProperty("Title"))
                if (!$util.isString(message.Title))
                    return "Title: string expected";
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (!$util.isInteger(message.Start) && !(message.Start && $util.isInteger(message.Start.low) && $util.isInteger(message.Start.high)))
                    return "Start: integer|Long expected";
            if (message.Subtitle != null && message.hasOwnProperty("Subtitle"))
                if (!$util.isString(message.Subtitle))
                    return "Subtitle: string expected";
            if (message.Synopsis != null && message.hasOwnProperty("Synopsis"))
                if (!$util.isString(message.Synopsis))
                    return "Synopsis: string expected";
            if (message.Vignette != null && message.hasOwnProperty("Vignette"))
                if (!$util.isString(message.Vignette))
                    return "Vignette: string expected";
            if (message.Metas != null && message.hasOwnProperty("Metas")) {
                if (!$util.isObject(message.Metas))
                    return "Metas: object expected";
                let key = Object.keys(message.Metas);
                for (let i = 0; i < key.length; ++i)
                    if (!$util.isString(message.Metas[key[i]]))
                        return "Metas: string{k:string} expected";
            }
            return null;
        };

        /**
         * Creates a EPGProgram message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.EPGProgram
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.EPGProgram} EPGProgram
         */
        EPGProgram.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.EPGProgram)
                return object;
            let message = new $root.mediaarchiver.EPGProgram();
            if (object.Category != null)
                message.Category = String(object.Category);
            if (object.CategoryText != null)
                message.CategoryText = String(object.CategoryText);
            if (object.DurationMS != null)
                message.DurationMS = object.DurationMS >>> 0;
            if (object.Title != null)
                message.Title = String(object.Title);
            if (object.Start != null)
                if ($util.Long)
                    (message.Start = $util.Long.fromValue(object.Start)).unsigned = false;
                else if (typeof object.Start === "string")
                    message.Start = parseInt(object.Start, 10);
                else if (typeof object.Start === "number")
                    message.Start = object.Start;
                else if (typeof object.Start === "object")
                    message.Start = new $util.LongBits(object.Start.low >>> 0, object.Start.high >>> 0).toNumber();
            if (object.Subtitle != null)
                message.Subtitle = String(object.Subtitle);
            if (object.Synopsis != null)
                message.Synopsis = String(object.Synopsis);
            if (object.Vignette != null)
                message.Vignette = String(object.Vignette);
            if (object.Metas) {
                if (typeof object.Metas !== "object")
                    throw TypeError(".mediaarchiver.EPGProgram.Metas: object expected");
                message.Metas = {};
                for (let keys = Object.keys(object.Metas), i = 0; i < keys.length; ++i)
                    message.Metas[keys[i]] = String(object.Metas[keys[i]]);
            }
            return message;
        };

        /**
         * Creates a plain object from a EPGProgram message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.EPGProgram
         * @static
         * @param {mediaarchiver.EPGProgram} message EPGProgram
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EPGProgram.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.objects || options.defaults)
                object.Metas = {};
            if (options.defaults) {
                object.Category = "";
                object.CategoryText = "";
                object.DurationMS = 0;
                object.Title = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.Start = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.Start = options.longs === String ? "0" : 0;
                object.Subtitle = "";
                object.Synopsis = "";
                object.Vignette = "";
            }
            if (message.Category != null && message.hasOwnProperty("Category"))
                object.Category = message.Category;
            if (message.CategoryText != null && message.hasOwnProperty("CategoryText"))
                object.CategoryText = message.CategoryText;
            if (message.DurationMS != null && message.hasOwnProperty("DurationMS"))
                object.DurationMS = message.DurationMS;
            if (message.Title != null && message.hasOwnProperty("Title"))
                object.Title = message.Title;
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (typeof message.Start === "number")
                    object.Start = options.longs === String ? String(message.Start) : message.Start;
                else
                    object.Start = options.longs === String ? $util.Long.prototype.toString.call(message.Start) : options.longs === Number ? new $util.LongBits(message.Start.low >>> 0, message.Start.high >>> 0).toNumber() : message.Start;
            if (message.Subtitle != null && message.hasOwnProperty("Subtitle"))
                object.Subtitle = message.Subtitle;
            if (message.Synopsis != null && message.hasOwnProperty("Synopsis"))
                object.Synopsis = message.Synopsis;
            if (message.Vignette != null && message.hasOwnProperty("Vignette"))
                object.Vignette = message.Vignette;
            let keys2;
            if (message.Metas && (keys2 = Object.keys(message.Metas)).length) {
                object.Metas = {};
                for (let j = 0; j < keys2.length; ++j)
                    object.Metas[keys2[j]] = message.Metas[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this EPGProgram to JSON.
         * @function toJSON
         * @memberof mediaarchiver.EPGProgram
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EPGProgram.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EPGProgram;
    })();

    mediaarchiver.EPG = (function() {

        /**
         * Properties of a EPG.
         * @memberof mediaarchiver
         * @interface IEPG
         * @property {mediaarchiver.EPGType|null} [Type] EPG Type
         * @property {Array.<mediaarchiver.IEPGProgram>|null} [Programs] EPG Programs
         */

        /**
         * Constructs a new EPG.
         * @memberof mediaarchiver
         * @classdesc Represents a EPG.
         * @implements IEPG
         * @constructor
         * @param {mediaarchiver.IEPG=} [properties] Properties to set
         */
        function EPG(properties) {
            this.Programs = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EPG Type.
         * @member {mediaarchiver.EPGType} Type
         * @memberof mediaarchiver.EPG
         * @instance
         */
        EPG.prototype.Type = 0;

        /**
         * EPG Programs.
         * @member {Array.<mediaarchiver.IEPGProgram>} Programs
         * @memberof mediaarchiver.EPG
         * @instance
         */
        EPG.prototype.Programs = $util.emptyArray;

        /**
         * Creates a new EPG instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.EPG
         * @static
         * @param {mediaarchiver.IEPG=} [properties] Properties to set
         * @returns {mediaarchiver.EPG} EPG instance
         */
        EPG.create = function create(properties) {
            return new EPG(properties);
        };

        /**
         * Encodes the specified EPG message. Does not implicitly {@link mediaarchiver.EPG.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.EPG
         * @static
         * @param {mediaarchiver.IEPG} message EPG message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EPG.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Type);
            if (message.Programs != null && message.Programs.length)
                for (let i = 0; i < message.Programs.length; ++i)
                    $root.mediaarchiver.EPGProgram.encode(message.Programs[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified EPG message, length delimited. Does not implicitly {@link mediaarchiver.EPG.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.EPG
         * @static
         * @param {mediaarchiver.IEPG} message EPG message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EPG.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a EPG message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.EPG
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.EPG} EPG
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EPG.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.EPG();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Type = reader.int32();
                    break;
                case 2:
                    if (!(message.Programs && message.Programs.length))
                        message.Programs = [];
                    message.Programs.push($root.mediaarchiver.EPGProgram.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a EPG message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.EPG
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.EPG} EPG
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EPG.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a EPG message.
         * @function verify
         * @memberof mediaarchiver.EPG
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EPG.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Type != null && message.hasOwnProperty("Type"))
                switch (message.Type) {
                default:
                    return "Type: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 20:
                case 21:
                case 22:
                case 23:
                case 24:
                case 25:
                case 26:
                case 27:
                case 28:
                case 29:
                case 30:
                case 31:
                case 32:
                case 33:
                case 34:
                case 35:
                case 36:
                case 37:
                case 38:
                case 39:
                case 40:
                case 41:
                case 42:
                case 43:
                    break;
                }
            if (message.Programs != null && message.hasOwnProperty("Programs")) {
                if (!Array.isArray(message.Programs))
                    return "Programs: array expected";
                for (let i = 0; i < message.Programs.length; ++i) {
                    let error = $root.mediaarchiver.EPGProgram.verify(message.Programs[i]);
                    if (error)
                        return "Programs." + error;
                }
            }
            return null;
        };

        /**
         * Creates a EPG message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.EPG
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.EPG} EPG
         */
        EPG.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.EPG)
                return object;
            let message = new $root.mediaarchiver.EPG();
            switch (object.Type) {
            case "DECLARATIVE":
            case 0:
                message.Type = 0;
                break;
            case "READJUSTED1":
            case 1:
                message.Type = 1;
                break;
            case "READJUSTED2":
            case 2:
                message.Type = 2;
                break;
            case "MUSIC":
            case 3:
                message.Type = 3;
                break;
            case "TALK":
            case 4:
                message.Type = 4;
                break;
            case "ANNOTATIONS":
            case 5:
                message.Type = 5;
                break;
            case "AUDIENCE":
            case 6:
                message.Type = 6;
                break;
            case "METADATA":
            case 7:
                message.Type = 7;
                break;
            case "BACKGROUND":
            case 8:
                message.Type = 8;
                break;
            case "STT":
            case 9:
                message.Type = 9;
                break;
            case "BROADCASTER1":
            case 10:
                message.Type = 10;
                break;
            case "BROADCASTER2":
            case 11:
                message.Type = 11;
                break;
            case "DECLARATIVERADIO1":
            case 12:
                message.Type = 12;
                break;
            case "DECLARATIVERADIO2":
            case 13:
                message.Type = 13;
                break;
            case "CROSSBUCKET":
            case 14:
                message.Type = 14;
                break;
            case "EXTRACTRESULTS":
            case 15:
                message.Type = 15;
                break;
            case "BRUTPHONO1":
            case 16:
                message.Type = 16;
                break;
            case "BRUTPHONO2":
            case 17:
                message.Type = 17;
                break;
            case "BRUTPHONO3":
            case 18:
                message.Type = 18;
                break;
            case "BRUTPHONO4":
            case 19:
                message.Type = 19;
                break;
            case "LEONV11":
            case 20:
                message.Type = 20;
                break;
            case "LEONV12":
            case 21:
                message.Type = 21;
                break;
            case "LEONV13":
            case 22:
                message.Type = 22;
                break;
            case "LEONV14":
            case 23:
                message.Type = 23;
                break;
            case "NIKITAMONOBUCKET1":
            case 24:
                message.Type = 24;
                break;
            case "NIKITAMONOBUCKET2":
            case 25:
                message.Type = 25;
                break;
            case "NIKITAMONOBUCKET3":
            case 26:
                message.Type = 26;
                break;
            case "NIKITAMONOBUCKET4":
            case 27:
                message.Type = 27;
                break;
            case "ARPP":
            case 28:
                message.Type = 28;
                break;
            case "BACKGROUNDSTG":
            case 29:
                message.Type = 29;
                break;
            case "CROSSBUCKETSTG":
            case 30:
                message.Type = 30;
                break;
            case "MNM0":
            case 31:
                message.Type = 31;
                break;
            case "MNM1":
            case 32:
                message.Type = 32;
                break;
            case "MNMXB0":
            case 33:
                message.Type = 33;
                break;
            case "MNMXB1":
            case 34:
                message.Type = 34;
                break;
            case "SPONSORING":
            case 35:
                message.Type = 35;
                break;
            case "MNIONLY0":
            case 36:
                message.Type = 36;
                break;
            case "MNIONLY1":
            case 37:
                message.Type = 37;
                break;
            case "OCR1":
            case 38:
                message.Type = 38;
                break;
            case "OCR2":
            case 39:
                message.Type = 39;
                break;
            case "TALKDETAILS1":
            case 40:
                message.Type = 40;
                break;
            case "TALKDETAILS2":
            case 41:
                message.Type = 41;
                break;
            case "OCRTITLE1":
            case 42:
                message.Type = 42;
                break;
            case "OCRTITLE2":
            case 43:
                message.Type = 43;
                break;
            }
            if (object.Programs) {
                if (!Array.isArray(object.Programs))
                    throw TypeError(".mediaarchiver.EPG.Programs: array expected");
                message.Programs = [];
                for (let i = 0; i < object.Programs.length; ++i) {
                    if (typeof object.Programs[i] !== "object")
                        throw TypeError(".mediaarchiver.EPG.Programs: object expected");
                    message.Programs[i] = $root.mediaarchiver.EPGProgram.fromObject(object.Programs[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a EPG message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.EPG
         * @static
         * @param {mediaarchiver.EPG} message EPG
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EPG.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Programs = [];
            if (options.defaults)
                object.Type = options.enums === String ? "DECLARATIVE" : 0;
            if (message.Type != null && message.hasOwnProperty("Type"))
                object.Type = options.enums === String ? $root.mediaarchiver.EPGType[message.Type] : message.Type;
            if (message.Programs && message.Programs.length) {
                object.Programs = [];
                for (let j = 0; j < message.Programs.length; ++j)
                    object.Programs[j] = $root.mediaarchiver.EPGProgram.toObject(message.Programs[j], options);
            }
            return object;
        };

        /**
         * Converts this EPG to JSON.
         * @function toJSON
         * @memberof mediaarchiver.EPG
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EPG.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EPG;
    })();

    mediaarchiver.ArgumentsEPG = (function() {

        /**
         * Properties of an ArgumentsEPG.
         * @memberof mediaarchiver
         * @interface IArgumentsEPG
         * @property {number|null} [MediaID] ArgumentsEPG MediaID
         * @property {number|Long|null} [From] ArgumentsEPG From
         * @property {number|Long|null} [To] ArgumentsEPG To
         * @property {Array.<mediaarchiver.IEPG>|null} [Data] ArgumentsEPG Data
         */

        /**
         * Constructs a new ArgumentsEPG.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsEPG.
         * @implements IArgumentsEPG
         * @constructor
         * @param {mediaarchiver.IArgumentsEPG=} [properties] Properties to set
         */
        function ArgumentsEPG(properties) {
            this.Data = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsEPG MediaID.
         * @member {number} MediaID
         * @memberof mediaarchiver.ArgumentsEPG
         * @instance
         */
        ArgumentsEPG.prototype.MediaID = 0;

        /**
         * ArgumentsEPG From.
         * @member {number|Long} From
         * @memberof mediaarchiver.ArgumentsEPG
         * @instance
         */
        ArgumentsEPG.prototype.From = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ArgumentsEPG To.
         * @member {number|Long} To
         * @memberof mediaarchiver.ArgumentsEPG
         * @instance
         */
        ArgumentsEPG.prototype.To = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ArgumentsEPG Data.
         * @member {Array.<mediaarchiver.IEPG>} Data
         * @memberof mediaarchiver.ArgumentsEPG
         * @instance
         */
        ArgumentsEPG.prototype.Data = $util.emptyArray;

        /**
         * Creates a new ArgumentsEPG instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsEPG
         * @static
         * @param {mediaarchiver.IArgumentsEPG=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsEPG} ArgumentsEPG instance
         */
        ArgumentsEPG.create = function create(properties) {
            return new ArgumentsEPG(properties);
        };

        /**
         * Encodes the specified ArgumentsEPG message. Does not implicitly {@link mediaarchiver.ArgumentsEPG.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsEPG
         * @static
         * @param {mediaarchiver.IArgumentsEPG} message ArgumentsEPG message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsEPG.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.MediaID != null && Object.hasOwnProperty.call(message, "MediaID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.MediaID);
            if (message.From != null && Object.hasOwnProperty.call(message, "From"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.From);
            if (message.To != null && Object.hasOwnProperty.call(message, "To"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.To);
            if (message.Data != null && message.Data.length)
                for (let i = 0; i < message.Data.length; ++i)
                    $root.mediaarchiver.EPG.encode(message.Data[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ArgumentsEPG message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsEPG.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsEPG
         * @static
         * @param {mediaarchiver.IArgumentsEPG} message ArgumentsEPG message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsEPG.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsEPG message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsEPG
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsEPG} ArgumentsEPG
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsEPG.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsEPG();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.MediaID = reader.uint32();
                    break;
                case 2:
                    message.From = reader.int64();
                    break;
                case 3:
                    message.To = reader.int64();
                    break;
                case 4:
                    if (!(message.Data && message.Data.length))
                        message.Data = [];
                    message.Data.push($root.mediaarchiver.EPG.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsEPG message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsEPG
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsEPG} ArgumentsEPG
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsEPG.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsEPG message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsEPG
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsEPG.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.MediaID != null && message.hasOwnProperty("MediaID"))
                if (!$util.isInteger(message.MediaID))
                    return "MediaID: integer expected";
            if (message.From != null && message.hasOwnProperty("From"))
                if (!$util.isInteger(message.From) && !(message.From && $util.isInteger(message.From.low) && $util.isInteger(message.From.high)))
                    return "From: integer|Long expected";
            if (message.To != null && message.hasOwnProperty("To"))
                if (!$util.isInteger(message.To) && !(message.To && $util.isInteger(message.To.low) && $util.isInteger(message.To.high)))
                    return "To: integer|Long expected";
            if (message.Data != null && message.hasOwnProperty("Data")) {
                if (!Array.isArray(message.Data))
                    return "Data: array expected";
                for (let i = 0; i < message.Data.length; ++i) {
                    let error = $root.mediaarchiver.EPG.verify(message.Data[i]);
                    if (error)
                        return "Data." + error;
                }
            }
            return null;
        };

        /**
         * Creates an ArgumentsEPG message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsEPG
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsEPG} ArgumentsEPG
         */
        ArgumentsEPG.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsEPG)
                return object;
            let message = new $root.mediaarchiver.ArgumentsEPG();
            if (object.MediaID != null)
                message.MediaID = object.MediaID >>> 0;
            if (object.From != null)
                if ($util.Long)
                    (message.From = $util.Long.fromValue(object.From)).unsigned = false;
                else if (typeof object.From === "string")
                    message.From = parseInt(object.From, 10);
                else if (typeof object.From === "number")
                    message.From = object.From;
                else if (typeof object.From === "object")
                    message.From = new $util.LongBits(object.From.low >>> 0, object.From.high >>> 0).toNumber();
            if (object.To != null)
                if ($util.Long)
                    (message.To = $util.Long.fromValue(object.To)).unsigned = false;
                else if (typeof object.To === "string")
                    message.To = parseInt(object.To, 10);
                else if (typeof object.To === "number")
                    message.To = object.To;
                else if (typeof object.To === "object")
                    message.To = new $util.LongBits(object.To.low >>> 0, object.To.high >>> 0).toNumber();
            if (object.Data) {
                if (!Array.isArray(object.Data))
                    throw TypeError(".mediaarchiver.ArgumentsEPG.Data: array expected");
                message.Data = [];
                for (let i = 0; i < object.Data.length; ++i) {
                    if (typeof object.Data[i] !== "object")
                        throw TypeError(".mediaarchiver.ArgumentsEPG.Data: object expected");
                    message.Data[i] = $root.mediaarchiver.EPG.fromObject(object.Data[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsEPG message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsEPG
         * @static
         * @param {mediaarchiver.ArgumentsEPG} message ArgumentsEPG
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsEPG.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Data = [];
            if (options.defaults) {
                object.MediaID = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.From = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.From = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.To = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.To = options.longs === String ? "0" : 0;
            }
            if (message.MediaID != null && message.hasOwnProperty("MediaID"))
                object.MediaID = message.MediaID;
            if (message.From != null && message.hasOwnProperty("From"))
                if (typeof message.From === "number")
                    object.From = options.longs === String ? String(message.From) : message.From;
                else
                    object.From = options.longs === String ? $util.Long.prototype.toString.call(message.From) : options.longs === Number ? new $util.LongBits(message.From.low >>> 0, message.From.high >>> 0).toNumber() : message.From;
            if (message.To != null && message.hasOwnProperty("To"))
                if (typeof message.To === "number")
                    object.To = options.longs === String ? String(message.To) : message.To;
                else
                    object.To = options.longs === String ? $util.Long.prototype.toString.call(message.To) : options.longs === Number ? new $util.LongBits(message.To.low >>> 0, message.To.high >>> 0).toNumber() : message.To;
            if (message.Data && message.Data.length) {
                object.Data = [];
                for (let j = 0; j < message.Data.length; ++j)
                    object.Data[j] = $root.mediaarchiver.EPG.toObject(message.Data[j], options);
            }
            return object;
        };

        /**
         * Converts this ArgumentsEPG to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsEPG
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsEPG.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsEPG;
    })();

    mediaarchiver.ArgumentsGetMediasBackground = (function() {

        /**
         * Properties of an ArgumentsGetMediasBackground.
         * @memberof mediaarchiver
         * @interface IArgumentsGetMediasBackground
         * @property {boolean|null} [TV] ArgumentsGetMediasBackground TV
         * @property {boolean|null} [Radio] ArgumentsGetMediasBackground Radio
         */

        /**
         * Constructs a new ArgumentsGetMediasBackground.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsGetMediasBackground.
         * @implements IArgumentsGetMediasBackground
         * @constructor
         * @param {mediaarchiver.IArgumentsGetMediasBackground=} [properties] Properties to set
         */
        function ArgumentsGetMediasBackground(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsGetMediasBackground TV.
         * @member {boolean} TV
         * @memberof mediaarchiver.ArgumentsGetMediasBackground
         * @instance
         */
        ArgumentsGetMediasBackground.prototype.TV = false;

        /**
         * ArgumentsGetMediasBackground Radio.
         * @member {boolean} Radio
         * @memberof mediaarchiver.ArgumentsGetMediasBackground
         * @instance
         */
        ArgumentsGetMediasBackground.prototype.Radio = false;

        /**
         * Creates a new ArgumentsGetMediasBackground instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsGetMediasBackground
         * @static
         * @param {mediaarchiver.IArgumentsGetMediasBackground=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsGetMediasBackground} ArgumentsGetMediasBackground instance
         */
        ArgumentsGetMediasBackground.create = function create(properties) {
            return new ArgumentsGetMediasBackground(properties);
        };

        /**
         * Encodes the specified ArgumentsGetMediasBackground message. Does not implicitly {@link mediaarchiver.ArgumentsGetMediasBackground.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsGetMediasBackground
         * @static
         * @param {mediaarchiver.IArgumentsGetMediasBackground} message ArgumentsGetMediasBackground message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetMediasBackground.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.TV != null && Object.hasOwnProperty.call(message, "TV"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.TV);
            if (message.Radio != null && Object.hasOwnProperty.call(message, "Radio"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.Radio);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsGetMediasBackground message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsGetMediasBackground.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsGetMediasBackground
         * @static
         * @param {mediaarchiver.IArgumentsGetMediasBackground} message ArgumentsGetMediasBackground message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetMediasBackground.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsGetMediasBackground message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsGetMediasBackground
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsGetMediasBackground} ArgumentsGetMediasBackground
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetMediasBackground.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsGetMediasBackground();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.TV = reader.bool();
                    break;
                case 2:
                    message.Radio = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsGetMediasBackground message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsGetMediasBackground
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsGetMediasBackground} ArgumentsGetMediasBackground
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetMediasBackground.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsGetMediasBackground message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsGetMediasBackground
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsGetMediasBackground.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.TV != null && message.hasOwnProperty("TV"))
                if (typeof message.TV !== "boolean")
                    return "TV: boolean expected";
            if (message.Radio != null && message.hasOwnProperty("Radio"))
                if (typeof message.Radio !== "boolean")
                    return "Radio: boolean expected";
            return null;
        };

        /**
         * Creates an ArgumentsGetMediasBackground message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsGetMediasBackground
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsGetMediasBackground} ArgumentsGetMediasBackground
         */
        ArgumentsGetMediasBackground.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsGetMediasBackground)
                return object;
            let message = new $root.mediaarchiver.ArgumentsGetMediasBackground();
            if (object.TV != null)
                message.TV = Boolean(object.TV);
            if (object.Radio != null)
                message.Radio = Boolean(object.Radio);
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsGetMediasBackground message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsGetMediasBackground
         * @static
         * @param {mediaarchiver.ArgumentsGetMediasBackground} message ArgumentsGetMediasBackground
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsGetMediasBackground.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.TV = false;
                object.Radio = false;
            }
            if (message.TV != null && message.hasOwnProperty("TV"))
                object.TV = message.TV;
            if (message.Radio != null && message.hasOwnProperty("Radio"))
                object.Radio = message.Radio;
            return object;
        };

        /**
         * Converts this ArgumentsGetMediasBackground to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsGetMediasBackground
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsGetMediasBackground.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsGetMediasBackground;
    })();

    mediaarchiver.ArgumentsWhoYouAre = (function() {

        /**
         * Properties of an ArgumentsWhoYouAre.
         * @memberof mediaarchiver
         * @interface IArgumentsWhoYouAre
         * @property {boolean|null} [LoggedIn] ArgumentsWhoYouAre LoggedIn
         * @property {mediaarchiver.IUser|null} [Identitiy] ArgumentsWhoYouAre Identitiy
         * @property {string|null} [Session] ArgumentsWhoYouAre Session
         */

        /**
         * Constructs a new ArgumentsWhoYouAre.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsWhoYouAre.
         * @implements IArgumentsWhoYouAre
         * @constructor
         * @param {mediaarchiver.IArgumentsWhoYouAre=} [properties] Properties to set
         */
        function ArgumentsWhoYouAre(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsWhoYouAre LoggedIn.
         * @member {boolean} LoggedIn
         * @memberof mediaarchiver.ArgumentsWhoYouAre
         * @instance
         */
        ArgumentsWhoYouAre.prototype.LoggedIn = false;

        /**
         * ArgumentsWhoYouAre Identitiy.
         * @member {mediaarchiver.IUser|null|undefined} Identitiy
         * @memberof mediaarchiver.ArgumentsWhoYouAre
         * @instance
         */
        ArgumentsWhoYouAre.prototype.Identitiy = null;

        /**
         * ArgumentsWhoYouAre Session.
         * @member {string} Session
         * @memberof mediaarchiver.ArgumentsWhoYouAre
         * @instance
         */
        ArgumentsWhoYouAre.prototype.Session = "";

        /**
         * Creates a new ArgumentsWhoYouAre instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsWhoYouAre
         * @static
         * @param {mediaarchiver.IArgumentsWhoYouAre=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsWhoYouAre} ArgumentsWhoYouAre instance
         */
        ArgumentsWhoYouAre.create = function create(properties) {
            return new ArgumentsWhoYouAre(properties);
        };

        /**
         * Encodes the specified ArgumentsWhoYouAre message. Does not implicitly {@link mediaarchiver.ArgumentsWhoYouAre.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsWhoYouAre
         * @static
         * @param {mediaarchiver.IArgumentsWhoYouAre} message ArgumentsWhoYouAre message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsWhoYouAre.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.LoggedIn != null && Object.hasOwnProperty.call(message, "LoggedIn"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.LoggedIn);
            if (message.Identitiy != null && Object.hasOwnProperty.call(message, "Identitiy"))
                $root.mediaarchiver.User.encode(message.Identitiy, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.Session);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsWhoYouAre message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsWhoYouAre.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsWhoYouAre
         * @static
         * @param {mediaarchiver.IArgumentsWhoYouAre} message ArgumentsWhoYouAre message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsWhoYouAre.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsWhoYouAre message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsWhoYouAre
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsWhoYouAre} ArgumentsWhoYouAre
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsWhoYouAre.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsWhoYouAre();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.LoggedIn = reader.bool();
                    break;
                case 2:
                    message.Identitiy = $root.mediaarchiver.User.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.Session = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsWhoYouAre message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsWhoYouAre
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsWhoYouAre} ArgumentsWhoYouAre
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsWhoYouAre.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsWhoYouAre message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsWhoYouAre
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsWhoYouAre.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.LoggedIn != null && message.hasOwnProperty("LoggedIn"))
                if (typeof message.LoggedIn !== "boolean")
                    return "LoggedIn: boolean expected";
            if (message.Identitiy != null && message.hasOwnProperty("Identitiy")) {
                let error = $root.mediaarchiver.User.verify(message.Identitiy);
                if (error)
                    return "Identitiy." + error;
            }
            if (message.Session != null && message.hasOwnProperty("Session"))
                if (!$util.isString(message.Session))
                    return "Session: string expected";
            return null;
        };

        /**
         * Creates an ArgumentsWhoYouAre message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsWhoYouAre
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsWhoYouAre} ArgumentsWhoYouAre
         */
        ArgumentsWhoYouAre.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsWhoYouAre)
                return object;
            let message = new $root.mediaarchiver.ArgumentsWhoYouAre();
            if (object.LoggedIn != null)
                message.LoggedIn = Boolean(object.LoggedIn);
            if (object.Identitiy != null) {
                if (typeof object.Identitiy !== "object")
                    throw TypeError(".mediaarchiver.ArgumentsWhoYouAre.Identitiy: object expected");
                message.Identitiy = $root.mediaarchiver.User.fromObject(object.Identitiy);
            }
            if (object.Session != null)
                message.Session = String(object.Session);
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsWhoYouAre message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsWhoYouAre
         * @static
         * @param {mediaarchiver.ArgumentsWhoYouAre} message ArgumentsWhoYouAre
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsWhoYouAre.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.LoggedIn = false;
                object.Identitiy = null;
                object.Session = "";
            }
            if (message.LoggedIn != null && message.hasOwnProperty("LoggedIn"))
                object.LoggedIn = message.LoggedIn;
            if (message.Identitiy != null && message.hasOwnProperty("Identitiy"))
                object.Identitiy = $root.mediaarchiver.User.toObject(message.Identitiy, options);
            if (message.Session != null && message.hasOwnProperty("Session"))
                object.Session = message.Session;
            return object;
        };

        /**
         * Converts this ArgumentsWhoYouAre to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsWhoYouAre
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsWhoYouAre.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsWhoYouAre;
    })();

    mediaarchiver.Review = (function() {

        /**
         * Properties of a Review.
         * @memberof mediaarchiver
         * @interface IReview
         * @property {string|null} [ID] Review ID
         * @property {string|null} [Name] Review Name
         * @property {string|null} [Description] Review Description
         * @property {string|null} [Created] Review Created
         * @property {Array.<string>|null} [Tags] Review Tags
         * @property {Array.<mediaarchiver.IArchive>|null} [Archives] Review Archives
         * @property {number|null} [Owner] Review Owner
         */

        /**
         * Constructs a new Review.
         * @memberof mediaarchiver
         * @classdesc Represents a Review.
         * @implements IReview
         * @constructor
         * @param {mediaarchiver.IReview=} [properties] Properties to set
         */
        function Review(properties) {
            this.Tags = [];
            this.Archives = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Review ID.
         * @member {string} ID
         * @memberof mediaarchiver.Review
         * @instance
         */
        Review.prototype.ID = "";

        /**
         * Review Name.
         * @member {string} Name
         * @memberof mediaarchiver.Review
         * @instance
         */
        Review.prototype.Name = "";

        /**
         * Review Description.
         * @member {string} Description
         * @memberof mediaarchiver.Review
         * @instance
         */
        Review.prototype.Description = "";

        /**
         * Review Created.
         * @member {string} Created
         * @memberof mediaarchiver.Review
         * @instance
         */
        Review.prototype.Created = "";

        /**
         * Review Tags.
         * @member {Array.<string>} Tags
         * @memberof mediaarchiver.Review
         * @instance
         */
        Review.prototype.Tags = $util.emptyArray;

        /**
         * Review Archives.
         * @member {Array.<mediaarchiver.IArchive>} Archives
         * @memberof mediaarchiver.Review
         * @instance
         */
        Review.prototype.Archives = $util.emptyArray;

        /**
         * Review Owner.
         * @member {number} Owner
         * @memberof mediaarchiver.Review
         * @instance
         */
        Review.prototype.Owner = 0;

        /**
         * Creates a new Review instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.Review
         * @static
         * @param {mediaarchiver.IReview=} [properties] Properties to set
         * @returns {mediaarchiver.Review} Review instance
         */
        Review.create = function create(properties) {
            return new Review(properties);
        };

        /**
         * Encodes the specified Review message. Does not implicitly {@link mediaarchiver.Review.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.Review
         * @static
         * @param {mediaarchiver.IReview} message Review message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Review.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.ID);
            if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
            if (message.Description != null && Object.hasOwnProperty.call(message, "Description"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.Description);
            if (message.Created != null && Object.hasOwnProperty.call(message, "Created"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.Created);
            if (message.Tags != null && message.Tags.length)
                for (let i = 0; i < message.Tags.length; ++i)
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.Tags[i]);
            if (message.Archives != null && message.Archives.length)
                for (let i = 0; i < message.Archives.length; ++i)
                    $root.mediaarchiver.Archive.encode(message.Archives[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            if (message.Owner != null && Object.hasOwnProperty.call(message, "Owner"))
                writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.Owner);
            return writer;
        };

        /**
         * Encodes the specified Review message, length delimited. Does not implicitly {@link mediaarchiver.Review.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.Review
         * @static
         * @param {mediaarchiver.IReview} message Review message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Review.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Review message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.Review
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.Review} Review
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Review.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.Review();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ID = reader.string();
                    break;
                case 2:
                    message.Name = reader.string();
                    break;
                case 3:
                    message.Description = reader.string();
                    break;
                case 4:
                    message.Created = reader.string();
                    break;
                case 5:
                    if (!(message.Tags && message.Tags.length))
                        message.Tags = [];
                    message.Tags.push(reader.string());
                    break;
                case 6:
                    if (!(message.Archives && message.Archives.length))
                        message.Archives = [];
                    message.Archives.push($root.mediaarchiver.Archive.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.Owner = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Review message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.Review
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.Review} Review
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Review.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Review message.
         * @function verify
         * @memberof mediaarchiver.Review
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Review.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isString(message.ID))
                    return "ID: string expected";
            if (message.Name != null && message.hasOwnProperty("Name"))
                if (!$util.isString(message.Name))
                    return "Name: string expected";
            if (message.Description != null && message.hasOwnProperty("Description"))
                if (!$util.isString(message.Description))
                    return "Description: string expected";
            if (message.Created != null && message.hasOwnProperty("Created"))
                if (!$util.isString(message.Created))
                    return "Created: string expected";
            if (message.Tags != null && message.hasOwnProperty("Tags")) {
                if (!Array.isArray(message.Tags))
                    return "Tags: array expected";
                for (let i = 0; i < message.Tags.length; ++i)
                    if (!$util.isString(message.Tags[i]))
                        return "Tags: string[] expected";
            }
            if (message.Archives != null && message.hasOwnProperty("Archives")) {
                if (!Array.isArray(message.Archives))
                    return "Archives: array expected";
                for (let i = 0; i < message.Archives.length; ++i) {
                    let error = $root.mediaarchiver.Archive.verify(message.Archives[i]);
                    if (error)
                        return "Archives." + error;
                }
            }
            if (message.Owner != null && message.hasOwnProperty("Owner"))
                if (!$util.isInteger(message.Owner))
                    return "Owner: integer expected";
            return null;
        };

        /**
         * Creates a Review message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.Review
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.Review} Review
         */
        Review.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.Review)
                return object;
            let message = new $root.mediaarchiver.Review();
            if (object.ID != null)
                message.ID = String(object.ID);
            if (object.Name != null)
                message.Name = String(object.Name);
            if (object.Description != null)
                message.Description = String(object.Description);
            if (object.Created != null)
                message.Created = String(object.Created);
            if (object.Tags) {
                if (!Array.isArray(object.Tags))
                    throw TypeError(".mediaarchiver.Review.Tags: array expected");
                message.Tags = [];
                for (let i = 0; i < object.Tags.length; ++i)
                    message.Tags[i] = String(object.Tags[i]);
            }
            if (object.Archives) {
                if (!Array.isArray(object.Archives))
                    throw TypeError(".mediaarchiver.Review.Archives: array expected");
                message.Archives = [];
                for (let i = 0; i < object.Archives.length; ++i) {
                    if (typeof object.Archives[i] !== "object")
                        throw TypeError(".mediaarchiver.Review.Archives: object expected");
                    message.Archives[i] = $root.mediaarchiver.Archive.fromObject(object.Archives[i]);
                }
            }
            if (object.Owner != null)
                message.Owner = object.Owner >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Review message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.Review
         * @static
         * @param {mediaarchiver.Review} message Review
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Review.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.Tags = [];
                object.Archives = [];
            }
            if (options.defaults) {
                object.ID = "";
                object.Name = "";
                object.Description = "";
                object.Created = "";
                object.Owner = 0;
            }
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            if (message.Name != null && message.hasOwnProperty("Name"))
                object.Name = message.Name;
            if (message.Description != null && message.hasOwnProperty("Description"))
                object.Description = message.Description;
            if (message.Created != null && message.hasOwnProperty("Created"))
                object.Created = message.Created;
            if (message.Tags && message.Tags.length) {
                object.Tags = [];
                for (let j = 0; j < message.Tags.length; ++j)
                    object.Tags[j] = message.Tags[j];
            }
            if (message.Archives && message.Archives.length) {
                object.Archives = [];
                for (let j = 0; j < message.Archives.length; ++j)
                    object.Archives[j] = $root.mediaarchiver.Archive.toObject(message.Archives[j], options);
            }
            if (message.Owner != null && message.hasOwnProperty("Owner"))
                object.Owner = message.Owner;
            return object;
        };

        /**
         * Converts this Review to JSON.
         * @function toJSON
         * @memberof mediaarchiver.Review
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Review.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Review;
    })();

    mediaarchiver.ArgumentsReviews = (function() {

        /**
         * Properties of an ArgumentsReviews.
         * @memberof mediaarchiver
         * @interface IArgumentsReviews
         * @property {number|null} [Offset] ArgumentsReviews Offset
         * @property {number|null} [Count] ArgumentsReviews Count
         * @property {Array.<mediaarchiver.IReview>|null} [Reviews] ArgumentsReviews Reviews
         */

        /**
         * Constructs a new ArgumentsReviews.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsReviews.
         * @implements IArgumentsReviews
         * @constructor
         * @param {mediaarchiver.IArgumentsReviews=} [properties] Properties to set
         */
        function ArgumentsReviews(properties) {
            this.Reviews = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsReviews Offset.
         * @member {number} Offset
         * @memberof mediaarchiver.ArgumentsReviews
         * @instance
         */
        ArgumentsReviews.prototype.Offset = 0;

        /**
         * ArgumentsReviews Count.
         * @member {number} Count
         * @memberof mediaarchiver.ArgumentsReviews
         * @instance
         */
        ArgumentsReviews.prototype.Count = 0;

        /**
         * ArgumentsReviews Reviews.
         * @member {Array.<mediaarchiver.IReview>} Reviews
         * @memberof mediaarchiver.ArgumentsReviews
         * @instance
         */
        ArgumentsReviews.prototype.Reviews = $util.emptyArray;

        /**
         * Creates a new ArgumentsReviews instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsReviews
         * @static
         * @param {mediaarchiver.IArgumentsReviews=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsReviews} ArgumentsReviews instance
         */
        ArgumentsReviews.create = function create(properties) {
            return new ArgumentsReviews(properties);
        };

        /**
         * Encodes the specified ArgumentsReviews message. Does not implicitly {@link mediaarchiver.ArgumentsReviews.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsReviews
         * @static
         * @param {mediaarchiver.IArgumentsReviews} message ArgumentsReviews message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsReviews.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Offset != null && Object.hasOwnProperty.call(message, "Offset"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Offset);
            if (message.Count != null && Object.hasOwnProperty.call(message, "Count"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Count);
            if (message.Reviews != null && message.Reviews.length)
                for (let i = 0; i < message.Reviews.length; ++i)
                    $root.mediaarchiver.Review.encode(message.Reviews[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ArgumentsReviews message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsReviews.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsReviews
         * @static
         * @param {mediaarchiver.IArgumentsReviews} message ArgumentsReviews message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsReviews.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsReviews message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsReviews
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsReviews} ArgumentsReviews
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsReviews.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsReviews();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Offset = reader.uint32();
                    break;
                case 2:
                    message.Count = reader.uint32();
                    break;
                case 3:
                    if (!(message.Reviews && message.Reviews.length))
                        message.Reviews = [];
                    message.Reviews.push($root.mediaarchiver.Review.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsReviews message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsReviews
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsReviews} ArgumentsReviews
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsReviews.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsReviews message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsReviews
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsReviews.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                if (!$util.isInteger(message.Offset))
                    return "Offset: integer expected";
            if (message.Count != null && message.hasOwnProperty("Count"))
                if (!$util.isInteger(message.Count))
                    return "Count: integer expected";
            if (message.Reviews != null && message.hasOwnProperty("Reviews")) {
                if (!Array.isArray(message.Reviews))
                    return "Reviews: array expected";
                for (let i = 0; i < message.Reviews.length; ++i) {
                    let error = $root.mediaarchiver.Review.verify(message.Reviews[i]);
                    if (error)
                        return "Reviews." + error;
                }
            }
            return null;
        };

        /**
         * Creates an ArgumentsReviews message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsReviews
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsReviews} ArgumentsReviews
         */
        ArgumentsReviews.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsReviews)
                return object;
            let message = new $root.mediaarchiver.ArgumentsReviews();
            if (object.Offset != null)
                message.Offset = object.Offset >>> 0;
            if (object.Count != null)
                message.Count = object.Count >>> 0;
            if (object.Reviews) {
                if (!Array.isArray(object.Reviews))
                    throw TypeError(".mediaarchiver.ArgumentsReviews.Reviews: array expected");
                message.Reviews = [];
                for (let i = 0; i < object.Reviews.length; ++i) {
                    if (typeof object.Reviews[i] !== "object")
                        throw TypeError(".mediaarchiver.ArgumentsReviews.Reviews: object expected");
                    message.Reviews[i] = $root.mediaarchiver.Review.fromObject(object.Reviews[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsReviews message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsReviews
         * @static
         * @param {mediaarchiver.ArgumentsReviews} message ArgumentsReviews
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsReviews.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Reviews = [];
            if (options.defaults) {
                object.Offset = 0;
                object.Count = 0;
            }
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                object.Offset = message.Offset;
            if (message.Count != null && message.hasOwnProperty("Count"))
                object.Count = message.Count;
            if (message.Reviews && message.Reviews.length) {
                object.Reviews = [];
                for (let j = 0; j < message.Reviews.length; ++j)
                    object.Reviews[j] = $root.mediaarchiver.Review.toObject(message.Reviews[j], options);
            }
            return object;
        };

        /**
         * Converts this ArgumentsReviews to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsReviews
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsReviews.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsReviews;
    })();

    mediaarchiver.ArgumentsGetReviews = (function() {

        /**
         * Properties of an ArgumentsGetReviews.
         * @memberof mediaarchiver
         * @interface IArgumentsGetReviews
         * @property {number|null} [Limit] ArgumentsGetReviews Limit
         * @property {number|null} [Offset] ArgumentsGetReviews Offset
         * @property {string|null} [Term] ArgumentsGetReviews Term
         */

        /**
         * Constructs a new ArgumentsGetReviews.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsGetReviews.
         * @implements IArgumentsGetReviews
         * @constructor
         * @param {mediaarchiver.IArgumentsGetReviews=} [properties] Properties to set
         */
        function ArgumentsGetReviews(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsGetReviews Limit.
         * @member {number} Limit
         * @memberof mediaarchiver.ArgumentsGetReviews
         * @instance
         */
        ArgumentsGetReviews.prototype.Limit = 0;

        /**
         * ArgumentsGetReviews Offset.
         * @member {number} Offset
         * @memberof mediaarchiver.ArgumentsGetReviews
         * @instance
         */
        ArgumentsGetReviews.prototype.Offset = 0;

        /**
         * ArgumentsGetReviews Term.
         * @member {string} Term
         * @memberof mediaarchiver.ArgumentsGetReviews
         * @instance
         */
        ArgumentsGetReviews.prototype.Term = "";

        /**
         * Creates a new ArgumentsGetReviews instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsGetReviews
         * @static
         * @param {mediaarchiver.IArgumentsGetReviews=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsGetReviews} ArgumentsGetReviews instance
         */
        ArgumentsGetReviews.create = function create(properties) {
            return new ArgumentsGetReviews(properties);
        };

        /**
         * Encodes the specified ArgumentsGetReviews message. Does not implicitly {@link mediaarchiver.ArgumentsGetReviews.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsGetReviews
         * @static
         * @param {mediaarchiver.IArgumentsGetReviews} message ArgumentsGetReviews message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetReviews.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Limit != null && Object.hasOwnProperty.call(message, "Limit"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Limit);
            if (message.Offset != null && Object.hasOwnProperty.call(message, "Offset"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Offset);
            if (message.Term != null && Object.hasOwnProperty.call(message, "Term"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.Term);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsGetReviews message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsGetReviews.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsGetReviews
         * @static
         * @param {mediaarchiver.IArgumentsGetReviews} message ArgumentsGetReviews message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetReviews.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsGetReviews message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsGetReviews
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsGetReviews} ArgumentsGetReviews
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetReviews.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsGetReviews();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Limit = reader.uint32();
                    break;
                case 2:
                    message.Offset = reader.uint32();
                    break;
                case 3:
                    message.Term = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsGetReviews message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsGetReviews
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsGetReviews} ArgumentsGetReviews
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetReviews.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsGetReviews message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsGetReviews
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsGetReviews.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Limit != null && message.hasOwnProperty("Limit"))
                if (!$util.isInteger(message.Limit))
                    return "Limit: integer expected";
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                if (!$util.isInteger(message.Offset))
                    return "Offset: integer expected";
            if (message.Term != null && message.hasOwnProperty("Term"))
                if (!$util.isString(message.Term))
                    return "Term: string expected";
            return null;
        };

        /**
         * Creates an ArgumentsGetReviews message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsGetReviews
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsGetReviews} ArgumentsGetReviews
         */
        ArgumentsGetReviews.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsGetReviews)
                return object;
            let message = new $root.mediaarchiver.ArgumentsGetReviews();
            if (object.Limit != null)
                message.Limit = object.Limit >>> 0;
            if (object.Offset != null)
                message.Offset = object.Offset >>> 0;
            if (object.Term != null)
                message.Term = String(object.Term);
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsGetReviews message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsGetReviews
         * @static
         * @param {mediaarchiver.ArgumentsGetReviews} message ArgumentsGetReviews
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsGetReviews.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.Limit = 0;
                object.Offset = 0;
                object.Term = "";
            }
            if (message.Limit != null && message.hasOwnProperty("Limit"))
                object.Limit = message.Limit;
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                object.Offset = message.Offset;
            if (message.Term != null && message.hasOwnProperty("Term"))
                object.Term = message.Term;
            return object;
        };

        /**
         * Converts this ArgumentsGetReviews to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsGetReviews
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsGetReviews.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsGetReviews;
    })();

    /**
     * ArchiveThumbFormats enum.
     * @name mediaarchiver.ArchiveThumbFormats
     * @enum {number}
     * @property {number} ARCHIVE_THUMB_FORMAT_UNKNOWN=0 ARCHIVE_THUMB_FORMAT_UNKNOWN value
     * @property {number} ARCHIVE_THUMB_FORMAT_PNG=1 ARCHIVE_THUMB_FORMAT_PNG value
     * @property {number} ARCHIVE_THUMB_FORMAT_JPEG=2 ARCHIVE_THUMB_FORMAT_JPEG value
     */
    mediaarchiver.ArchiveThumbFormats = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ARCHIVE_THUMB_FORMAT_UNKNOWN"] = 0;
        values[valuesById[1] = "ARCHIVE_THUMB_FORMAT_PNG"] = 1;
        values[valuesById[2] = "ARCHIVE_THUMB_FORMAT_JPEG"] = 2;
        return values;
    })();

    /**
     * ArchiveStatus enum.
     * @name mediaarchiver.ArchiveStatus
     * @enum {number}
     * @property {number} ARCHIVE_STATUS_UNKNOWN=0 ARCHIVE_STATUS_UNKNOWN value
     * @property {number} ARCHIVE_STATUS_SCHEDULED=1 ARCHIVE_STATUS_SCHEDULED value
     * @property {number} ARCHIVE_STATUS_RUNNING=2 ARCHIVE_STATUS_RUNNING value
     * @property {number} ARCHIVE_STATUS_ERROR=3 ARCHIVE_STATUS_ERROR value
     * @property {number} ARCHIVE_STATUS_OK=4 ARCHIVE_STATUS_OK value
     * @property {number} ARCHIVE_STATUS_EXPIRED=5 ARCHIVE_STATUS_EXPIRED value
     */
    mediaarchiver.ArchiveStatus = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ARCHIVE_STATUS_UNKNOWN"] = 0;
        values[valuesById[1] = "ARCHIVE_STATUS_SCHEDULED"] = 1;
        values[valuesById[2] = "ARCHIVE_STATUS_RUNNING"] = 2;
        values[valuesById[3] = "ARCHIVE_STATUS_ERROR"] = 3;
        values[valuesById[4] = "ARCHIVE_STATUS_OK"] = 4;
        values[valuesById[5] = "ARCHIVE_STATUS_EXPIRED"] = 5;
        return values;
    })();

    mediaarchiver.Archive = (function() {

        /**
         * Properties of an Archive.
         * @memberof mediaarchiver
         * @interface IArchive
         * @property {string|null} [ID] Archive ID
         * @property {string|null} [Name] Archive Name
         * @property {number|null} [Created] Archive Created
         * @property {number|null} [MediaID] Archive MediaID
         * @property {number|Long|null} [Start] Archive Start
         * @property {number|null} [DurationMS] Archive DurationMS
         * @property {mediaarchiver.ArchiveThumbFormats|null} [ThumbFormat] Archive ThumbFormat
         * @property {string|null} [Comment] Archive Comment
         * @property {Array.<string>|null} [Tags] Archive Tags
         * @property {string|null} [VignetteURL] Archive VignetteURL
         * @property {number|null} [Views] Archive Views
         * @property {number|null} [Downloads] Archive Downloads
         * @property {Array.<string>|null} [ToContacts] Archive ToContacts
         * @property {string|null} [ToFTP] Archive ToFTP
         * @property {string|null} [ToSFTP] Archive ToSFTP
         * @property {string|null} [ToPressReview] Archive ToPressReview
         * @property {string|null} [Url] Archive Url
         * @property {mediaarchiver.ArchiveStatus|null} [Status] Archive Status
         * @property {string|null} [Retranscription] Archive Retranscription
         * @property {number|null} [Owner] Archive Owner
         * @property {number|null} [MediaType] Archive MediaType
         * @property {number|Long|null} [ExpiresMS] Archive ExpiresMS
         * @property {boolean|null} [Gif] Archive Gif
         * @property {number|null} [Retries] Archive Retries
         * @property {boolean|null} [ExpirationNotified] Archive ExpirationNotified
         */

        /**
         * Constructs a new Archive.
         * @memberof mediaarchiver
         * @classdesc Represents an Archive.
         * @implements IArchive
         * @constructor
         * @param {mediaarchiver.IArchive=} [properties] Properties to set
         */
        function Archive(properties) {
            this.Tags = [];
            this.ToContacts = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Archive ID.
         * @member {string} ID
         * @memberof mediaarchiver.Archive
         * @instance
         */
        Archive.prototype.ID = "";

        /**
         * Archive Name.
         * @member {string} Name
         * @memberof mediaarchiver.Archive
         * @instance
         */
        Archive.prototype.Name = "";

        /**
         * Archive Created.
         * @member {number} Created
         * @memberof mediaarchiver.Archive
         * @instance
         */
        Archive.prototype.Created = 0;

        /**
         * Archive MediaID.
         * @member {number} MediaID
         * @memberof mediaarchiver.Archive
         * @instance
         */
        Archive.prototype.MediaID = 0;

        /**
         * Archive Start.
         * @member {number|Long} Start
         * @memberof mediaarchiver.Archive
         * @instance
         */
        Archive.prototype.Start = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Archive DurationMS.
         * @member {number} DurationMS
         * @memberof mediaarchiver.Archive
         * @instance
         */
        Archive.prototype.DurationMS = 0;

        /**
         * Archive ThumbFormat.
         * @member {mediaarchiver.ArchiveThumbFormats} ThumbFormat
         * @memberof mediaarchiver.Archive
         * @instance
         */
        Archive.prototype.ThumbFormat = 0;

        /**
         * Archive Comment.
         * @member {string} Comment
         * @memberof mediaarchiver.Archive
         * @instance
         */
        Archive.prototype.Comment = "";

        /**
         * Archive Tags.
         * @member {Array.<string>} Tags
         * @memberof mediaarchiver.Archive
         * @instance
         */
        Archive.prototype.Tags = $util.emptyArray;

        /**
         * Archive VignetteURL.
         * @member {string} VignetteURL
         * @memberof mediaarchiver.Archive
         * @instance
         */
        Archive.prototype.VignetteURL = "";

        /**
         * Archive Views.
         * @member {number} Views
         * @memberof mediaarchiver.Archive
         * @instance
         */
        Archive.prototype.Views = 0;

        /**
         * Archive Downloads.
         * @member {number} Downloads
         * @memberof mediaarchiver.Archive
         * @instance
         */
        Archive.prototype.Downloads = 0;

        /**
         * Archive ToContacts.
         * @member {Array.<string>} ToContacts
         * @memberof mediaarchiver.Archive
         * @instance
         */
        Archive.prototype.ToContacts = $util.emptyArray;

        /**
         * Archive ToFTP.
         * @member {string} ToFTP
         * @memberof mediaarchiver.Archive
         * @instance
         */
        Archive.prototype.ToFTP = "";

        /**
         * Archive ToSFTP.
         * @member {string} ToSFTP
         * @memberof mediaarchiver.Archive
         * @instance
         */
        Archive.prototype.ToSFTP = "";

        /**
         * Archive ToPressReview.
         * @member {string} ToPressReview
         * @memberof mediaarchiver.Archive
         * @instance
         */
        Archive.prototype.ToPressReview = "";

        /**
         * Archive Url.
         * @member {string} Url
         * @memberof mediaarchiver.Archive
         * @instance
         */
        Archive.prototype.Url = "";

        /**
         * Archive Status.
         * @member {mediaarchiver.ArchiveStatus} Status
         * @memberof mediaarchiver.Archive
         * @instance
         */
        Archive.prototype.Status = 0;

        /**
         * Archive Retranscription.
         * @member {string} Retranscription
         * @memberof mediaarchiver.Archive
         * @instance
         */
        Archive.prototype.Retranscription = "";

        /**
         * Archive Owner.
         * @member {number} Owner
         * @memberof mediaarchiver.Archive
         * @instance
         */
        Archive.prototype.Owner = 0;

        /**
         * Archive MediaType.
         * @member {number} MediaType
         * @memberof mediaarchiver.Archive
         * @instance
         */
        Archive.prototype.MediaType = 0;

        /**
         * Archive ExpiresMS.
         * @member {number|Long} ExpiresMS
         * @memberof mediaarchiver.Archive
         * @instance
         */
        Archive.prototype.ExpiresMS = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Archive Gif.
         * @member {boolean} Gif
         * @memberof mediaarchiver.Archive
         * @instance
         */
        Archive.prototype.Gif = false;

        /**
         * Archive Retries.
         * @member {number} Retries
         * @memberof mediaarchiver.Archive
         * @instance
         */
        Archive.prototype.Retries = 0;

        /**
         * Archive ExpirationNotified.
         * @member {boolean} ExpirationNotified
         * @memberof mediaarchiver.Archive
         * @instance
         */
        Archive.prototype.ExpirationNotified = false;

        /**
         * Creates a new Archive instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.Archive
         * @static
         * @param {mediaarchiver.IArchive=} [properties] Properties to set
         * @returns {mediaarchiver.Archive} Archive instance
         */
        Archive.create = function create(properties) {
            return new Archive(properties);
        };

        /**
         * Encodes the specified Archive message. Does not implicitly {@link mediaarchiver.Archive.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.Archive
         * @static
         * @param {mediaarchiver.IArchive} message Archive message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Archive.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.ID);
            if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
            if (message.Created != null && Object.hasOwnProperty.call(message, "Created"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.Created);
            if (message.MediaID != null && Object.hasOwnProperty.call(message, "MediaID"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.MediaID);
            if (message.Start != null && Object.hasOwnProperty.call(message, "Start"))
                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.Start);
            if (message.DurationMS != null && Object.hasOwnProperty.call(message, "DurationMS"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.DurationMS);
            if (message.ThumbFormat != null && Object.hasOwnProperty.call(message, "ThumbFormat"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.ThumbFormat);
            if (message.Comment != null && Object.hasOwnProperty.call(message, "Comment"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.Comment);
            if (message.Tags != null && message.Tags.length)
                for (let i = 0; i < message.Tags.length; ++i)
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.Tags[i]);
            if (message.VignetteURL != null && Object.hasOwnProperty.call(message, "VignetteURL"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.VignetteURL);
            if (message.Views != null && Object.hasOwnProperty.call(message, "Views"))
                writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.Views);
            if (message.Downloads != null && Object.hasOwnProperty.call(message, "Downloads"))
                writer.uint32(/* id 12, wireType 0 =*/96).uint32(message.Downloads);
            if (message.ToContacts != null && message.ToContacts.length)
                for (let i = 0; i < message.ToContacts.length; ++i)
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.ToContacts[i]);
            if (message.ToFTP != null && Object.hasOwnProperty.call(message, "ToFTP"))
                writer.uint32(/* id 14, wireType 2 =*/114).string(message.ToFTP);
            if (message.ToSFTP != null && Object.hasOwnProperty.call(message, "ToSFTP"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.ToSFTP);
            if (message.ToPressReview != null && Object.hasOwnProperty.call(message, "ToPressReview"))
                writer.uint32(/* id 16, wireType 2 =*/130).string(message.ToPressReview);
            if (message.Url != null && Object.hasOwnProperty.call(message, "Url"))
                writer.uint32(/* id 17, wireType 2 =*/138).string(message.Url);
            if (message.Status != null && Object.hasOwnProperty.call(message, "Status"))
                writer.uint32(/* id 18, wireType 0 =*/144).int32(message.Status);
            if (message.Retranscription != null && Object.hasOwnProperty.call(message, "Retranscription"))
                writer.uint32(/* id 19, wireType 2 =*/154).string(message.Retranscription);
            if (message.Owner != null && Object.hasOwnProperty.call(message, "Owner"))
                writer.uint32(/* id 20, wireType 0 =*/160).uint32(message.Owner);
            if (message.MediaType != null && Object.hasOwnProperty.call(message, "MediaType"))
                writer.uint32(/* id 21, wireType 0 =*/168).uint32(message.MediaType);
            if (message.ExpiresMS != null && Object.hasOwnProperty.call(message, "ExpiresMS"))
                writer.uint32(/* id 22, wireType 0 =*/176).int64(message.ExpiresMS);
            if (message.Gif != null && Object.hasOwnProperty.call(message, "Gif"))
                writer.uint32(/* id 23, wireType 0 =*/184).bool(message.Gif);
            if (message.Retries != null && Object.hasOwnProperty.call(message, "Retries"))
                writer.uint32(/* id 24, wireType 0 =*/192).uint32(message.Retries);
            if (message.ExpirationNotified != null && Object.hasOwnProperty.call(message, "ExpirationNotified"))
                writer.uint32(/* id 25, wireType 0 =*/200).bool(message.ExpirationNotified);
            return writer;
        };

        /**
         * Encodes the specified Archive message, length delimited. Does not implicitly {@link mediaarchiver.Archive.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.Archive
         * @static
         * @param {mediaarchiver.IArchive} message Archive message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Archive.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Archive message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.Archive
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.Archive} Archive
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Archive.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.Archive();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ID = reader.string();
                    break;
                case 2:
                    message.Name = reader.string();
                    break;
                case 3:
                    message.Created = reader.uint32();
                    break;
                case 4:
                    message.MediaID = reader.uint32();
                    break;
                case 5:
                    message.Start = reader.int64();
                    break;
                case 6:
                    message.DurationMS = reader.uint32();
                    break;
                case 7:
                    message.ThumbFormat = reader.int32();
                    break;
                case 8:
                    message.Comment = reader.string();
                    break;
                case 9:
                    if (!(message.Tags && message.Tags.length))
                        message.Tags = [];
                    message.Tags.push(reader.string());
                    break;
                case 10:
                    message.VignetteURL = reader.string();
                    break;
                case 11:
                    message.Views = reader.uint32();
                    break;
                case 12:
                    message.Downloads = reader.uint32();
                    break;
                case 13:
                    if (!(message.ToContacts && message.ToContacts.length))
                        message.ToContacts = [];
                    message.ToContacts.push(reader.string());
                    break;
                case 14:
                    message.ToFTP = reader.string();
                    break;
                case 15:
                    message.ToSFTP = reader.string();
                    break;
                case 16:
                    message.ToPressReview = reader.string();
                    break;
                case 17:
                    message.Url = reader.string();
                    break;
                case 18:
                    message.Status = reader.int32();
                    break;
                case 19:
                    message.Retranscription = reader.string();
                    break;
                case 20:
                    message.Owner = reader.uint32();
                    break;
                case 21:
                    message.MediaType = reader.uint32();
                    break;
                case 22:
                    message.ExpiresMS = reader.int64();
                    break;
                case 23:
                    message.Gif = reader.bool();
                    break;
                case 24:
                    message.Retries = reader.uint32();
                    break;
                case 25:
                    message.ExpirationNotified = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Archive message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.Archive
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.Archive} Archive
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Archive.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Archive message.
         * @function verify
         * @memberof mediaarchiver.Archive
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Archive.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isString(message.ID))
                    return "ID: string expected";
            if (message.Name != null && message.hasOwnProperty("Name"))
                if (!$util.isString(message.Name))
                    return "Name: string expected";
            if (message.Created != null && message.hasOwnProperty("Created"))
                if (!$util.isInteger(message.Created))
                    return "Created: integer expected";
            if (message.MediaID != null && message.hasOwnProperty("MediaID"))
                if (!$util.isInteger(message.MediaID))
                    return "MediaID: integer expected";
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (!$util.isInteger(message.Start) && !(message.Start && $util.isInteger(message.Start.low) && $util.isInteger(message.Start.high)))
                    return "Start: integer|Long expected";
            if (message.DurationMS != null && message.hasOwnProperty("DurationMS"))
                if (!$util.isInteger(message.DurationMS))
                    return "DurationMS: integer expected";
            if (message.ThumbFormat != null && message.hasOwnProperty("ThumbFormat"))
                switch (message.ThumbFormat) {
                default:
                    return "ThumbFormat: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.Comment != null && message.hasOwnProperty("Comment"))
                if (!$util.isString(message.Comment))
                    return "Comment: string expected";
            if (message.Tags != null && message.hasOwnProperty("Tags")) {
                if (!Array.isArray(message.Tags))
                    return "Tags: array expected";
                for (let i = 0; i < message.Tags.length; ++i)
                    if (!$util.isString(message.Tags[i]))
                        return "Tags: string[] expected";
            }
            if (message.VignetteURL != null && message.hasOwnProperty("VignetteURL"))
                if (!$util.isString(message.VignetteURL))
                    return "VignetteURL: string expected";
            if (message.Views != null && message.hasOwnProperty("Views"))
                if (!$util.isInteger(message.Views))
                    return "Views: integer expected";
            if (message.Downloads != null && message.hasOwnProperty("Downloads"))
                if (!$util.isInteger(message.Downloads))
                    return "Downloads: integer expected";
            if (message.ToContacts != null && message.hasOwnProperty("ToContacts")) {
                if (!Array.isArray(message.ToContacts))
                    return "ToContacts: array expected";
                for (let i = 0; i < message.ToContacts.length; ++i)
                    if (!$util.isString(message.ToContacts[i]))
                        return "ToContacts: string[] expected";
            }
            if (message.ToFTP != null && message.hasOwnProperty("ToFTP"))
                if (!$util.isString(message.ToFTP))
                    return "ToFTP: string expected";
            if (message.ToSFTP != null && message.hasOwnProperty("ToSFTP"))
                if (!$util.isString(message.ToSFTP))
                    return "ToSFTP: string expected";
            if (message.ToPressReview != null && message.hasOwnProperty("ToPressReview"))
                if (!$util.isString(message.ToPressReview))
                    return "ToPressReview: string expected";
            if (message.Url != null && message.hasOwnProperty("Url"))
                if (!$util.isString(message.Url))
                    return "Url: string expected";
            if (message.Status != null && message.hasOwnProperty("Status"))
                switch (message.Status) {
                default:
                    return "Status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.Retranscription != null && message.hasOwnProperty("Retranscription"))
                if (!$util.isString(message.Retranscription))
                    return "Retranscription: string expected";
            if (message.Owner != null && message.hasOwnProperty("Owner"))
                if (!$util.isInteger(message.Owner))
                    return "Owner: integer expected";
            if (message.MediaType != null && message.hasOwnProperty("MediaType"))
                if (!$util.isInteger(message.MediaType))
                    return "MediaType: integer expected";
            if (message.ExpiresMS != null && message.hasOwnProperty("ExpiresMS"))
                if (!$util.isInteger(message.ExpiresMS) && !(message.ExpiresMS && $util.isInteger(message.ExpiresMS.low) && $util.isInteger(message.ExpiresMS.high)))
                    return "ExpiresMS: integer|Long expected";
            if (message.Gif != null && message.hasOwnProperty("Gif"))
                if (typeof message.Gif !== "boolean")
                    return "Gif: boolean expected";
            if (message.Retries != null && message.hasOwnProperty("Retries"))
                if (!$util.isInteger(message.Retries))
                    return "Retries: integer expected";
            if (message.ExpirationNotified != null && message.hasOwnProperty("ExpirationNotified"))
                if (typeof message.ExpirationNotified !== "boolean")
                    return "ExpirationNotified: boolean expected";
            return null;
        };

        /**
         * Creates an Archive message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.Archive
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.Archive} Archive
         */
        Archive.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.Archive)
                return object;
            let message = new $root.mediaarchiver.Archive();
            if (object.ID != null)
                message.ID = String(object.ID);
            if (object.Name != null)
                message.Name = String(object.Name);
            if (object.Created != null)
                message.Created = object.Created >>> 0;
            if (object.MediaID != null)
                message.MediaID = object.MediaID >>> 0;
            if (object.Start != null)
                if ($util.Long)
                    (message.Start = $util.Long.fromValue(object.Start)).unsigned = false;
                else if (typeof object.Start === "string")
                    message.Start = parseInt(object.Start, 10);
                else if (typeof object.Start === "number")
                    message.Start = object.Start;
                else if (typeof object.Start === "object")
                    message.Start = new $util.LongBits(object.Start.low >>> 0, object.Start.high >>> 0).toNumber();
            if (object.DurationMS != null)
                message.DurationMS = object.DurationMS >>> 0;
            switch (object.ThumbFormat) {
            case "ARCHIVE_THUMB_FORMAT_UNKNOWN":
            case 0:
                message.ThumbFormat = 0;
                break;
            case "ARCHIVE_THUMB_FORMAT_PNG":
            case 1:
                message.ThumbFormat = 1;
                break;
            case "ARCHIVE_THUMB_FORMAT_JPEG":
            case 2:
                message.ThumbFormat = 2;
                break;
            }
            if (object.Comment != null)
                message.Comment = String(object.Comment);
            if (object.Tags) {
                if (!Array.isArray(object.Tags))
                    throw TypeError(".mediaarchiver.Archive.Tags: array expected");
                message.Tags = [];
                for (let i = 0; i < object.Tags.length; ++i)
                    message.Tags[i] = String(object.Tags[i]);
            }
            if (object.VignetteURL != null)
                message.VignetteURL = String(object.VignetteURL);
            if (object.Views != null)
                message.Views = object.Views >>> 0;
            if (object.Downloads != null)
                message.Downloads = object.Downloads >>> 0;
            if (object.ToContacts) {
                if (!Array.isArray(object.ToContacts))
                    throw TypeError(".mediaarchiver.Archive.ToContacts: array expected");
                message.ToContacts = [];
                for (let i = 0; i < object.ToContacts.length; ++i)
                    message.ToContacts[i] = String(object.ToContacts[i]);
            }
            if (object.ToFTP != null)
                message.ToFTP = String(object.ToFTP);
            if (object.ToSFTP != null)
                message.ToSFTP = String(object.ToSFTP);
            if (object.ToPressReview != null)
                message.ToPressReview = String(object.ToPressReview);
            if (object.Url != null)
                message.Url = String(object.Url);
            switch (object.Status) {
            case "ARCHIVE_STATUS_UNKNOWN":
            case 0:
                message.Status = 0;
                break;
            case "ARCHIVE_STATUS_SCHEDULED":
            case 1:
                message.Status = 1;
                break;
            case "ARCHIVE_STATUS_RUNNING":
            case 2:
                message.Status = 2;
                break;
            case "ARCHIVE_STATUS_ERROR":
            case 3:
                message.Status = 3;
                break;
            case "ARCHIVE_STATUS_OK":
            case 4:
                message.Status = 4;
                break;
            case "ARCHIVE_STATUS_EXPIRED":
            case 5:
                message.Status = 5;
                break;
            }
            if (object.Retranscription != null)
                message.Retranscription = String(object.Retranscription);
            if (object.Owner != null)
                message.Owner = object.Owner >>> 0;
            if (object.MediaType != null)
                message.MediaType = object.MediaType >>> 0;
            if (object.ExpiresMS != null)
                if ($util.Long)
                    (message.ExpiresMS = $util.Long.fromValue(object.ExpiresMS)).unsigned = false;
                else if (typeof object.ExpiresMS === "string")
                    message.ExpiresMS = parseInt(object.ExpiresMS, 10);
                else if (typeof object.ExpiresMS === "number")
                    message.ExpiresMS = object.ExpiresMS;
                else if (typeof object.ExpiresMS === "object")
                    message.ExpiresMS = new $util.LongBits(object.ExpiresMS.low >>> 0, object.ExpiresMS.high >>> 0).toNumber();
            if (object.Gif != null)
                message.Gif = Boolean(object.Gif);
            if (object.Retries != null)
                message.Retries = object.Retries >>> 0;
            if (object.ExpirationNotified != null)
                message.ExpirationNotified = Boolean(object.ExpirationNotified);
            return message;
        };

        /**
         * Creates a plain object from an Archive message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.Archive
         * @static
         * @param {mediaarchiver.Archive} message Archive
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Archive.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.Tags = [];
                object.ToContacts = [];
            }
            if (options.defaults) {
                object.ID = "";
                object.Name = "";
                object.Created = 0;
                object.MediaID = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.Start = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.Start = options.longs === String ? "0" : 0;
                object.DurationMS = 0;
                object.ThumbFormat = options.enums === String ? "ARCHIVE_THUMB_FORMAT_UNKNOWN" : 0;
                object.Comment = "";
                object.VignetteURL = "";
                object.Views = 0;
                object.Downloads = 0;
                object.ToFTP = "";
                object.ToSFTP = "";
                object.ToPressReview = "";
                object.Url = "";
                object.Status = options.enums === String ? "ARCHIVE_STATUS_UNKNOWN" : 0;
                object.Retranscription = "";
                object.Owner = 0;
                object.MediaType = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.ExpiresMS = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.ExpiresMS = options.longs === String ? "0" : 0;
                object.Gif = false;
                object.Retries = 0;
                object.ExpirationNotified = false;
            }
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            if (message.Name != null && message.hasOwnProperty("Name"))
                object.Name = message.Name;
            if (message.Created != null && message.hasOwnProperty("Created"))
                object.Created = message.Created;
            if (message.MediaID != null && message.hasOwnProperty("MediaID"))
                object.MediaID = message.MediaID;
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (typeof message.Start === "number")
                    object.Start = options.longs === String ? String(message.Start) : message.Start;
                else
                    object.Start = options.longs === String ? $util.Long.prototype.toString.call(message.Start) : options.longs === Number ? new $util.LongBits(message.Start.low >>> 0, message.Start.high >>> 0).toNumber() : message.Start;
            if (message.DurationMS != null && message.hasOwnProperty("DurationMS"))
                object.DurationMS = message.DurationMS;
            if (message.ThumbFormat != null && message.hasOwnProperty("ThumbFormat"))
                object.ThumbFormat = options.enums === String ? $root.mediaarchiver.ArchiveThumbFormats[message.ThumbFormat] : message.ThumbFormat;
            if (message.Comment != null && message.hasOwnProperty("Comment"))
                object.Comment = message.Comment;
            if (message.Tags && message.Tags.length) {
                object.Tags = [];
                for (let j = 0; j < message.Tags.length; ++j)
                    object.Tags[j] = message.Tags[j];
            }
            if (message.VignetteURL != null && message.hasOwnProperty("VignetteURL"))
                object.VignetteURL = message.VignetteURL;
            if (message.Views != null && message.hasOwnProperty("Views"))
                object.Views = message.Views;
            if (message.Downloads != null && message.hasOwnProperty("Downloads"))
                object.Downloads = message.Downloads;
            if (message.ToContacts && message.ToContacts.length) {
                object.ToContacts = [];
                for (let j = 0; j < message.ToContacts.length; ++j)
                    object.ToContacts[j] = message.ToContacts[j];
            }
            if (message.ToFTP != null && message.hasOwnProperty("ToFTP"))
                object.ToFTP = message.ToFTP;
            if (message.ToSFTP != null && message.hasOwnProperty("ToSFTP"))
                object.ToSFTP = message.ToSFTP;
            if (message.ToPressReview != null && message.hasOwnProperty("ToPressReview"))
                object.ToPressReview = message.ToPressReview;
            if (message.Url != null && message.hasOwnProperty("Url"))
                object.Url = message.Url;
            if (message.Status != null && message.hasOwnProperty("Status"))
                object.Status = options.enums === String ? $root.mediaarchiver.ArchiveStatus[message.Status] : message.Status;
            if (message.Retranscription != null && message.hasOwnProperty("Retranscription"))
                object.Retranscription = message.Retranscription;
            if (message.Owner != null && message.hasOwnProperty("Owner"))
                object.Owner = message.Owner;
            if (message.MediaType != null && message.hasOwnProperty("MediaType"))
                object.MediaType = message.MediaType;
            if (message.ExpiresMS != null && message.hasOwnProperty("ExpiresMS"))
                if (typeof message.ExpiresMS === "number")
                    object.ExpiresMS = options.longs === String ? String(message.ExpiresMS) : message.ExpiresMS;
                else
                    object.ExpiresMS = options.longs === String ? $util.Long.prototype.toString.call(message.ExpiresMS) : options.longs === Number ? new $util.LongBits(message.ExpiresMS.low >>> 0, message.ExpiresMS.high >>> 0).toNumber() : message.ExpiresMS;
            if (message.Gif != null && message.hasOwnProperty("Gif"))
                object.Gif = message.Gif;
            if (message.Retries != null && message.hasOwnProperty("Retries"))
                object.Retries = message.Retries;
            if (message.ExpirationNotified != null && message.hasOwnProperty("ExpirationNotified"))
                object.ExpirationNotified = message.ExpirationNotified;
            return object;
        };

        /**
         * Converts this Archive to JSON.
         * @function toJSON
         * @memberof mediaarchiver.Archive
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Archive.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Archive;
    })();

    mediaarchiver.ArgumentsArchives = (function() {

        /**
         * Properties of an ArgumentsArchives.
         * @memberof mediaarchiver
         * @interface IArgumentsArchives
         * @property {number|null} [Offset] ArgumentsArchives Offset
         * @property {number|null} [Count] ArgumentsArchives Count
         * @property {Array.<mediaarchiver.IArchive>|null} [List] ArgumentsArchives List
         */

        /**
         * Constructs a new ArgumentsArchives.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsArchives.
         * @implements IArgumentsArchives
         * @constructor
         * @param {mediaarchiver.IArgumentsArchives=} [properties] Properties to set
         */
        function ArgumentsArchives(properties) {
            this.List = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsArchives Offset.
         * @member {number} Offset
         * @memberof mediaarchiver.ArgumentsArchives
         * @instance
         */
        ArgumentsArchives.prototype.Offset = 0;

        /**
         * ArgumentsArchives Count.
         * @member {number} Count
         * @memberof mediaarchiver.ArgumentsArchives
         * @instance
         */
        ArgumentsArchives.prototype.Count = 0;

        /**
         * ArgumentsArchives List.
         * @member {Array.<mediaarchiver.IArchive>} List
         * @memberof mediaarchiver.ArgumentsArchives
         * @instance
         */
        ArgumentsArchives.prototype.List = $util.emptyArray;

        /**
         * Creates a new ArgumentsArchives instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsArchives
         * @static
         * @param {mediaarchiver.IArgumentsArchives=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsArchives} ArgumentsArchives instance
         */
        ArgumentsArchives.create = function create(properties) {
            return new ArgumentsArchives(properties);
        };

        /**
         * Encodes the specified ArgumentsArchives message. Does not implicitly {@link mediaarchiver.ArgumentsArchives.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsArchives
         * @static
         * @param {mediaarchiver.IArgumentsArchives} message ArgumentsArchives message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsArchives.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Offset != null && Object.hasOwnProperty.call(message, "Offset"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Offset);
            if (message.Count != null && Object.hasOwnProperty.call(message, "Count"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Count);
            if (message.List != null && message.List.length)
                for (let i = 0; i < message.List.length; ++i)
                    $root.mediaarchiver.Archive.encode(message.List[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ArgumentsArchives message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsArchives.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsArchives
         * @static
         * @param {mediaarchiver.IArgumentsArchives} message ArgumentsArchives message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsArchives.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsArchives message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsArchives
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsArchives} ArgumentsArchives
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsArchives.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsArchives();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Offset = reader.uint32();
                    break;
                case 2:
                    message.Count = reader.uint32();
                    break;
                case 3:
                    if (!(message.List && message.List.length))
                        message.List = [];
                    message.List.push($root.mediaarchiver.Archive.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsArchives message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsArchives
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsArchives} ArgumentsArchives
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsArchives.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsArchives message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsArchives
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsArchives.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                if (!$util.isInteger(message.Offset))
                    return "Offset: integer expected";
            if (message.Count != null && message.hasOwnProperty("Count"))
                if (!$util.isInteger(message.Count))
                    return "Count: integer expected";
            if (message.List != null && message.hasOwnProperty("List")) {
                if (!Array.isArray(message.List))
                    return "List: array expected";
                for (let i = 0; i < message.List.length; ++i) {
                    let error = $root.mediaarchiver.Archive.verify(message.List[i]);
                    if (error)
                        return "List." + error;
                }
            }
            return null;
        };

        /**
         * Creates an ArgumentsArchives message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsArchives
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsArchives} ArgumentsArchives
         */
        ArgumentsArchives.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsArchives)
                return object;
            let message = new $root.mediaarchiver.ArgumentsArchives();
            if (object.Offset != null)
                message.Offset = object.Offset >>> 0;
            if (object.Count != null)
                message.Count = object.Count >>> 0;
            if (object.List) {
                if (!Array.isArray(object.List))
                    throw TypeError(".mediaarchiver.ArgumentsArchives.List: array expected");
                message.List = [];
                for (let i = 0; i < object.List.length; ++i) {
                    if (typeof object.List[i] !== "object")
                        throw TypeError(".mediaarchiver.ArgumentsArchives.List: object expected");
                    message.List[i] = $root.mediaarchiver.Archive.fromObject(object.List[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsArchives message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsArchives
         * @static
         * @param {mediaarchiver.ArgumentsArchives} message ArgumentsArchives
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsArchives.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.List = [];
            if (options.defaults) {
                object.Offset = 0;
                object.Count = 0;
            }
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                object.Offset = message.Offset;
            if (message.Count != null && message.hasOwnProperty("Count"))
                object.Count = message.Count;
            if (message.List && message.List.length) {
                object.List = [];
                for (let j = 0; j < message.List.length; ++j)
                    object.List[j] = $root.mediaarchiver.Archive.toObject(message.List[j], options);
            }
            return object;
        };

        /**
         * Converts this ArgumentsArchives to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsArchives
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsArchives.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsArchives;
    })();

    mediaarchiver.ArgumentsGetArchives = (function() {

        /**
         * Properties of an ArgumentsGetArchives.
         * @memberof mediaarchiver
         * @interface IArgumentsGetArchives
         * @property {string|null} [Name] ArgumentsGetArchives Name
         * @property {number|null} [MediaType] ArgumentsGetArchives MediaType
         * @property {Array.<number>|null} [Medias] ArgumentsGetArchives Medias
         * @property {Array.<string>|null} [Tags] ArgumentsGetArchives Tags
         * @property {number|Long|null} [CreationStart] ArgumentsGetArchives CreationStart
         * @property {number|Long|null} [CreationEnd] ArgumentsGetArchives CreationEnd
         * @property {number|Long|null} [BroadcastStart] ArgumentsGetArchives BroadcastStart
         * @property {number|Long|null} [BroadcastEnd] ArgumentsGetArchives BroadcastEnd
         * @property {number|null} [Limit] ArgumentsGetArchives Limit
         * @property {number|null} [Offset] ArgumentsGetArchives Offset
         * @property {mediaarchiver.ArchiveStatus|null} [Status] ArgumentsGetArchives Status
         */

        /**
         * Constructs a new ArgumentsGetArchives.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsGetArchives.
         * @implements IArgumentsGetArchives
         * @constructor
         * @param {mediaarchiver.IArgumentsGetArchives=} [properties] Properties to set
         */
        function ArgumentsGetArchives(properties) {
            this.Medias = [];
            this.Tags = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsGetArchives Name.
         * @member {string} Name
         * @memberof mediaarchiver.ArgumentsGetArchives
         * @instance
         */
        ArgumentsGetArchives.prototype.Name = "";

        /**
         * ArgumentsGetArchives MediaType.
         * @member {number} MediaType
         * @memberof mediaarchiver.ArgumentsGetArchives
         * @instance
         */
        ArgumentsGetArchives.prototype.MediaType = 0;

        /**
         * ArgumentsGetArchives Medias.
         * @member {Array.<number>} Medias
         * @memberof mediaarchiver.ArgumentsGetArchives
         * @instance
         */
        ArgumentsGetArchives.prototype.Medias = $util.emptyArray;

        /**
         * ArgumentsGetArchives Tags.
         * @member {Array.<string>} Tags
         * @memberof mediaarchiver.ArgumentsGetArchives
         * @instance
         */
        ArgumentsGetArchives.prototype.Tags = $util.emptyArray;

        /**
         * ArgumentsGetArchives CreationStart.
         * @member {number|Long} CreationStart
         * @memberof mediaarchiver.ArgumentsGetArchives
         * @instance
         */
        ArgumentsGetArchives.prototype.CreationStart = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ArgumentsGetArchives CreationEnd.
         * @member {number|Long} CreationEnd
         * @memberof mediaarchiver.ArgumentsGetArchives
         * @instance
         */
        ArgumentsGetArchives.prototype.CreationEnd = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ArgumentsGetArchives BroadcastStart.
         * @member {number|Long} BroadcastStart
         * @memberof mediaarchiver.ArgumentsGetArchives
         * @instance
         */
        ArgumentsGetArchives.prototype.BroadcastStart = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ArgumentsGetArchives BroadcastEnd.
         * @member {number|Long} BroadcastEnd
         * @memberof mediaarchiver.ArgumentsGetArchives
         * @instance
         */
        ArgumentsGetArchives.prototype.BroadcastEnd = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ArgumentsGetArchives Limit.
         * @member {number} Limit
         * @memberof mediaarchiver.ArgumentsGetArchives
         * @instance
         */
        ArgumentsGetArchives.prototype.Limit = 0;

        /**
         * ArgumentsGetArchives Offset.
         * @member {number} Offset
         * @memberof mediaarchiver.ArgumentsGetArchives
         * @instance
         */
        ArgumentsGetArchives.prototype.Offset = 0;

        /**
         * ArgumentsGetArchives Status.
         * @member {mediaarchiver.ArchiveStatus} Status
         * @memberof mediaarchiver.ArgumentsGetArchives
         * @instance
         */
        ArgumentsGetArchives.prototype.Status = 0;

        /**
         * Creates a new ArgumentsGetArchives instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsGetArchives
         * @static
         * @param {mediaarchiver.IArgumentsGetArchives=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsGetArchives} ArgumentsGetArchives instance
         */
        ArgumentsGetArchives.create = function create(properties) {
            return new ArgumentsGetArchives(properties);
        };

        /**
         * Encodes the specified ArgumentsGetArchives message. Does not implicitly {@link mediaarchiver.ArgumentsGetArchives.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsGetArchives
         * @static
         * @param {mediaarchiver.IArgumentsGetArchives} message ArgumentsGetArchives message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetArchives.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Name);
            if (message.MediaType != null && Object.hasOwnProperty.call(message, "MediaType"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.MediaType);
            if (message.Medias != null && message.Medias.length) {
                writer.uint32(/* id 3, wireType 2 =*/26).fork();
                for (let i = 0; i < message.Medias.length; ++i)
                    writer.uint32(message.Medias[i]);
                writer.ldelim();
            }
            if (message.Tags != null && message.Tags.length)
                for (let i = 0; i < message.Tags.length; ++i)
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.Tags[i]);
            if (message.CreationStart != null && Object.hasOwnProperty.call(message, "CreationStart"))
                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.CreationStart);
            if (message.CreationEnd != null && Object.hasOwnProperty.call(message, "CreationEnd"))
                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.CreationEnd);
            if (message.BroadcastStart != null && Object.hasOwnProperty.call(message, "BroadcastStart"))
                writer.uint32(/* id 7, wireType 0 =*/56).int64(message.BroadcastStart);
            if (message.BroadcastEnd != null && Object.hasOwnProperty.call(message, "BroadcastEnd"))
                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.BroadcastEnd);
            if (message.Limit != null && Object.hasOwnProperty.call(message, "Limit"))
                writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.Limit);
            if (message.Offset != null && Object.hasOwnProperty.call(message, "Offset"))
                writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.Offset);
            if (message.Status != null && Object.hasOwnProperty.call(message, "Status"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.Status);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsGetArchives message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsGetArchives.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsGetArchives
         * @static
         * @param {mediaarchiver.IArgumentsGetArchives} message ArgumentsGetArchives message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetArchives.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsGetArchives message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsGetArchives
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsGetArchives} ArgumentsGetArchives
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetArchives.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsGetArchives();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Name = reader.string();
                    break;
                case 2:
                    message.MediaType = reader.uint32();
                    break;
                case 3:
                    if (!(message.Medias && message.Medias.length))
                        message.Medias = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.Medias.push(reader.uint32());
                    } else
                        message.Medias.push(reader.uint32());
                    break;
                case 4:
                    if (!(message.Tags && message.Tags.length))
                        message.Tags = [];
                    message.Tags.push(reader.string());
                    break;
                case 5:
                    message.CreationStart = reader.int64();
                    break;
                case 6:
                    message.CreationEnd = reader.int64();
                    break;
                case 7:
                    message.BroadcastStart = reader.int64();
                    break;
                case 8:
                    message.BroadcastEnd = reader.int64();
                    break;
                case 9:
                    message.Limit = reader.uint32();
                    break;
                case 10:
                    message.Offset = reader.uint32();
                    break;
                case 11:
                    message.Status = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsGetArchives message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsGetArchives
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsGetArchives} ArgumentsGetArchives
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetArchives.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsGetArchives message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsGetArchives
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsGetArchives.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Name != null && message.hasOwnProperty("Name"))
                if (!$util.isString(message.Name))
                    return "Name: string expected";
            if (message.MediaType != null && message.hasOwnProperty("MediaType"))
                if (!$util.isInteger(message.MediaType))
                    return "MediaType: integer expected";
            if (message.Medias != null && message.hasOwnProperty("Medias")) {
                if (!Array.isArray(message.Medias))
                    return "Medias: array expected";
                for (let i = 0; i < message.Medias.length; ++i)
                    if (!$util.isInteger(message.Medias[i]))
                        return "Medias: integer[] expected";
            }
            if (message.Tags != null && message.hasOwnProperty("Tags")) {
                if (!Array.isArray(message.Tags))
                    return "Tags: array expected";
                for (let i = 0; i < message.Tags.length; ++i)
                    if (!$util.isString(message.Tags[i]))
                        return "Tags: string[] expected";
            }
            if (message.CreationStart != null && message.hasOwnProperty("CreationStart"))
                if (!$util.isInteger(message.CreationStart) && !(message.CreationStart && $util.isInteger(message.CreationStart.low) && $util.isInteger(message.CreationStart.high)))
                    return "CreationStart: integer|Long expected";
            if (message.CreationEnd != null && message.hasOwnProperty("CreationEnd"))
                if (!$util.isInteger(message.CreationEnd) && !(message.CreationEnd && $util.isInteger(message.CreationEnd.low) && $util.isInteger(message.CreationEnd.high)))
                    return "CreationEnd: integer|Long expected";
            if (message.BroadcastStart != null && message.hasOwnProperty("BroadcastStart"))
                if (!$util.isInteger(message.BroadcastStart) && !(message.BroadcastStart && $util.isInteger(message.BroadcastStart.low) && $util.isInteger(message.BroadcastStart.high)))
                    return "BroadcastStart: integer|Long expected";
            if (message.BroadcastEnd != null && message.hasOwnProperty("BroadcastEnd"))
                if (!$util.isInteger(message.BroadcastEnd) && !(message.BroadcastEnd && $util.isInteger(message.BroadcastEnd.low) && $util.isInteger(message.BroadcastEnd.high)))
                    return "BroadcastEnd: integer|Long expected";
            if (message.Limit != null && message.hasOwnProperty("Limit"))
                if (!$util.isInteger(message.Limit))
                    return "Limit: integer expected";
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                if (!$util.isInteger(message.Offset))
                    return "Offset: integer expected";
            if (message.Status != null && message.hasOwnProperty("Status"))
                switch (message.Status) {
                default:
                    return "Status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            return null;
        };

        /**
         * Creates an ArgumentsGetArchives message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsGetArchives
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsGetArchives} ArgumentsGetArchives
         */
        ArgumentsGetArchives.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsGetArchives)
                return object;
            let message = new $root.mediaarchiver.ArgumentsGetArchives();
            if (object.Name != null)
                message.Name = String(object.Name);
            if (object.MediaType != null)
                message.MediaType = object.MediaType >>> 0;
            if (object.Medias) {
                if (!Array.isArray(object.Medias))
                    throw TypeError(".mediaarchiver.ArgumentsGetArchives.Medias: array expected");
                message.Medias = [];
                for (let i = 0; i < object.Medias.length; ++i)
                    message.Medias[i] = object.Medias[i] >>> 0;
            }
            if (object.Tags) {
                if (!Array.isArray(object.Tags))
                    throw TypeError(".mediaarchiver.ArgumentsGetArchives.Tags: array expected");
                message.Tags = [];
                for (let i = 0; i < object.Tags.length; ++i)
                    message.Tags[i] = String(object.Tags[i]);
            }
            if (object.CreationStart != null)
                if ($util.Long)
                    (message.CreationStart = $util.Long.fromValue(object.CreationStart)).unsigned = false;
                else if (typeof object.CreationStart === "string")
                    message.CreationStart = parseInt(object.CreationStart, 10);
                else if (typeof object.CreationStart === "number")
                    message.CreationStart = object.CreationStart;
                else if (typeof object.CreationStart === "object")
                    message.CreationStart = new $util.LongBits(object.CreationStart.low >>> 0, object.CreationStart.high >>> 0).toNumber();
            if (object.CreationEnd != null)
                if ($util.Long)
                    (message.CreationEnd = $util.Long.fromValue(object.CreationEnd)).unsigned = false;
                else if (typeof object.CreationEnd === "string")
                    message.CreationEnd = parseInt(object.CreationEnd, 10);
                else if (typeof object.CreationEnd === "number")
                    message.CreationEnd = object.CreationEnd;
                else if (typeof object.CreationEnd === "object")
                    message.CreationEnd = new $util.LongBits(object.CreationEnd.low >>> 0, object.CreationEnd.high >>> 0).toNumber();
            if (object.BroadcastStart != null)
                if ($util.Long)
                    (message.BroadcastStart = $util.Long.fromValue(object.BroadcastStart)).unsigned = false;
                else if (typeof object.BroadcastStart === "string")
                    message.BroadcastStart = parseInt(object.BroadcastStart, 10);
                else if (typeof object.BroadcastStart === "number")
                    message.BroadcastStart = object.BroadcastStart;
                else if (typeof object.BroadcastStart === "object")
                    message.BroadcastStart = new $util.LongBits(object.BroadcastStart.low >>> 0, object.BroadcastStart.high >>> 0).toNumber();
            if (object.BroadcastEnd != null)
                if ($util.Long)
                    (message.BroadcastEnd = $util.Long.fromValue(object.BroadcastEnd)).unsigned = false;
                else if (typeof object.BroadcastEnd === "string")
                    message.BroadcastEnd = parseInt(object.BroadcastEnd, 10);
                else if (typeof object.BroadcastEnd === "number")
                    message.BroadcastEnd = object.BroadcastEnd;
                else if (typeof object.BroadcastEnd === "object")
                    message.BroadcastEnd = new $util.LongBits(object.BroadcastEnd.low >>> 0, object.BroadcastEnd.high >>> 0).toNumber();
            if (object.Limit != null)
                message.Limit = object.Limit >>> 0;
            if (object.Offset != null)
                message.Offset = object.Offset >>> 0;
            switch (object.Status) {
            case "ARCHIVE_STATUS_UNKNOWN":
            case 0:
                message.Status = 0;
                break;
            case "ARCHIVE_STATUS_SCHEDULED":
            case 1:
                message.Status = 1;
                break;
            case "ARCHIVE_STATUS_RUNNING":
            case 2:
                message.Status = 2;
                break;
            case "ARCHIVE_STATUS_ERROR":
            case 3:
                message.Status = 3;
                break;
            case "ARCHIVE_STATUS_OK":
            case 4:
                message.Status = 4;
                break;
            case "ARCHIVE_STATUS_EXPIRED":
            case 5:
                message.Status = 5;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsGetArchives message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsGetArchives
         * @static
         * @param {mediaarchiver.ArgumentsGetArchives} message ArgumentsGetArchives
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsGetArchives.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.Medias = [];
                object.Tags = [];
            }
            if (options.defaults) {
                object.Name = "";
                object.MediaType = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.CreationStart = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.CreationStart = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.CreationEnd = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.CreationEnd = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.BroadcastStart = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.BroadcastStart = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.BroadcastEnd = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.BroadcastEnd = options.longs === String ? "0" : 0;
                object.Limit = 0;
                object.Offset = 0;
                object.Status = options.enums === String ? "ARCHIVE_STATUS_UNKNOWN" : 0;
            }
            if (message.Name != null && message.hasOwnProperty("Name"))
                object.Name = message.Name;
            if (message.MediaType != null && message.hasOwnProperty("MediaType"))
                object.MediaType = message.MediaType;
            if (message.Medias && message.Medias.length) {
                object.Medias = [];
                for (let j = 0; j < message.Medias.length; ++j)
                    object.Medias[j] = message.Medias[j];
            }
            if (message.Tags && message.Tags.length) {
                object.Tags = [];
                for (let j = 0; j < message.Tags.length; ++j)
                    object.Tags[j] = message.Tags[j];
            }
            if (message.CreationStart != null && message.hasOwnProperty("CreationStart"))
                if (typeof message.CreationStart === "number")
                    object.CreationStart = options.longs === String ? String(message.CreationStart) : message.CreationStart;
                else
                    object.CreationStart = options.longs === String ? $util.Long.prototype.toString.call(message.CreationStart) : options.longs === Number ? new $util.LongBits(message.CreationStart.low >>> 0, message.CreationStart.high >>> 0).toNumber() : message.CreationStart;
            if (message.CreationEnd != null && message.hasOwnProperty("CreationEnd"))
                if (typeof message.CreationEnd === "number")
                    object.CreationEnd = options.longs === String ? String(message.CreationEnd) : message.CreationEnd;
                else
                    object.CreationEnd = options.longs === String ? $util.Long.prototype.toString.call(message.CreationEnd) : options.longs === Number ? new $util.LongBits(message.CreationEnd.low >>> 0, message.CreationEnd.high >>> 0).toNumber() : message.CreationEnd;
            if (message.BroadcastStart != null && message.hasOwnProperty("BroadcastStart"))
                if (typeof message.BroadcastStart === "number")
                    object.BroadcastStart = options.longs === String ? String(message.BroadcastStart) : message.BroadcastStart;
                else
                    object.BroadcastStart = options.longs === String ? $util.Long.prototype.toString.call(message.BroadcastStart) : options.longs === Number ? new $util.LongBits(message.BroadcastStart.low >>> 0, message.BroadcastStart.high >>> 0).toNumber() : message.BroadcastStart;
            if (message.BroadcastEnd != null && message.hasOwnProperty("BroadcastEnd"))
                if (typeof message.BroadcastEnd === "number")
                    object.BroadcastEnd = options.longs === String ? String(message.BroadcastEnd) : message.BroadcastEnd;
                else
                    object.BroadcastEnd = options.longs === String ? $util.Long.prototype.toString.call(message.BroadcastEnd) : options.longs === Number ? new $util.LongBits(message.BroadcastEnd.low >>> 0, message.BroadcastEnd.high >>> 0).toNumber() : message.BroadcastEnd;
            if (message.Limit != null && message.hasOwnProperty("Limit"))
                object.Limit = message.Limit;
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                object.Offset = message.Offset;
            if (message.Status != null && message.hasOwnProperty("Status"))
                object.Status = options.enums === String ? $root.mediaarchiver.ArchiveStatus[message.Status] : message.Status;
            return object;
        };

        /**
         * Converts this ArgumentsGetArchives to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsGetArchives
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsGetArchives.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsGetArchives;
    })();

    mediaarchiver.ArgumentsArchivesCount = (function() {

        /**
         * Properties of an ArgumentsArchivesCount.
         * @memberof mediaarchiver
         * @interface IArgumentsArchivesCount
         * @property {number|null} [TVCount] ArgumentsArchivesCount TVCount
         * @property {number|null} [RadioCount] ArgumentsArchivesCount RadioCount
         */

        /**
         * Constructs a new ArgumentsArchivesCount.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsArchivesCount.
         * @implements IArgumentsArchivesCount
         * @constructor
         * @param {mediaarchiver.IArgumentsArchivesCount=} [properties] Properties to set
         */
        function ArgumentsArchivesCount(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsArchivesCount TVCount.
         * @member {number} TVCount
         * @memberof mediaarchiver.ArgumentsArchivesCount
         * @instance
         */
        ArgumentsArchivesCount.prototype.TVCount = 0;

        /**
         * ArgumentsArchivesCount RadioCount.
         * @member {number} RadioCount
         * @memberof mediaarchiver.ArgumentsArchivesCount
         * @instance
         */
        ArgumentsArchivesCount.prototype.RadioCount = 0;

        /**
         * Creates a new ArgumentsArchivesCount instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsArchivesCount
         * @static
         * @param {mediaarchiver.IArgumentsArchivesCount=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsArchivesCount} ArgumentsArchivesCount instance
         */
        ArgumentsArchivesCount.create = function create(properties) {
            return new ArgumentsArchivesCount(properties);
        };

        /**
         * Encodes the specified ArgumentsArchivesCount message. Does not implicitly {@link mediaarchiver.ArgumentsArchivesCount.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsArchivesCount
         * @static
         * @param {mediaarchiver.IArgumentsArchivesCount} message ArgumentsArchivesCount message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsArchivesCount.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.TVCount != null && Object.hasOwnProperty.call(message, "TVCount"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.TVCount);
            if (message.RadioCount != null && Object.hasOwnProperty.call(message, "RadioCount"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.RadioCount);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsArchivesCount message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsArchivesCount.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsArchivesCount
         * @static
         * @param {mediaarchiver.IArgumentsArchivesCount} message ArgumentsArchivesCount message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsArchivesCount.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsArchivesCount message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsArchivesCount
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsArchivesCount} ArgumentsArchivesCount
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsArchivesCount.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsArchivesCount();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.TVCount = reader.uint32();
                    break;
                case 2:
                    message.RadioCount = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsArchivesCount message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsArchivesCount
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsArchivesCount} ArgumentsArchivesCount
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsArchivesCount.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsArchivesCount message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsArchivesCount
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsArchivesCount.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.TVCount != null && message.hasOwnProperty("TVCount"))
                if (!$util.isInteger(message.TVCount))
                    return "TVCount: integer expected";
            if (message.RadioCount != null && message.hasOwnProperty("RadioCount"))
                if (!$util.isInteger(message.RadioCount))
                    return "RadioCount: integer expected";
            return null;
        };

        /**
         * Creates an ArgumentsArchivesCount message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsArchivesCount
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsArchivesCount} ArgumentsArchivesCount
         */
        ArgumentsArchivesCount.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsArchivesCount)
                return object;
            let message = new $root.mediaarchiver.ArgumentsArchivesCount();
            if (object.TVCount != null)
                message.TVCount = object.TVCount >>> 0;
            if (object.RadioCount != null)
                message.RadioCount = object.RadioCount >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsArchivesCount message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsArchivesCount
         * @static
         * @param {mediaarchiver.ArgumentsArchivesCount} message ArgumentsArchivesCount
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsArchivesCount.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.TVCount = 0;
                object.RadioCount = 0;
            }
            if (message.TVCount != null && message.hasOwnProperty("TVCount"))
                object.TVCount = message.TVCount;
            if (message.RadioCount != null && message.hasOwnProperty("RadioCount"))
                object.RadioCount = message.RadioCount;
            return object;
        };

        /**
         * Converts this ArgumentsArchivesCount to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsArchivesCount
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsArchivesCount.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsArchivesCount;
    })();

    mediaarchiver.ArgumentsIncArchiveCounter = (function() {

        /**
         * Properties of an ArgumentsIncArchiveCounter.
         * @memberof mediaarchiver
         * @interface IArgumentsIncArchiveCounter
         * @property {string|null} [ArchiveID] ArgumentsIncArchiveCounter ArchiveID
         * @property {number|null} [Downloads] ArgumentsIncArchiveCounter Downloads
         * @property {number|null} [Views] ArgumentsIncArchiveCounter Views
         */

        /**
         * Constructs a new ArgumentsIncArchiveCounter.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsIncArchiveCounter.
         * @implements IArgumentsIncArchiveCounter
         * @constructor
         * @param {mediaarchiver.IArgumentsIncArchiveCounter=} [properties] Properties to set
         */
        function ArgumentsIncArchiveCounter(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsIncArchiveCounter ArchiveID.
         * @member {string} ArchiveID
         * @memberof mediaarchiver.ArgumentsIncArchiveCounter
         * @instance
         */
        ArgumentsIncArchiveCounter.prototype.ArchiveID = "";

        /**
         * ArgumentsIncArchiveCounter Downloads.
         * @member {number} Downloads
         * @memberof mediaarchiver.ArgumentsIncArchiveCounter
         * @instance
         */
        ArgumentsIncArchiveCounter.prototype.Downloads = 0;

        /**
         * ArgumentsIncArchiveCounter Views.
         * @member {number} Views
         * @memberof mediaarchiver.ArgumentsIncArchiveCounter
         * @instance
         */
        ArgumentsIncArchiveCounter.prototype.Views = 0;

        /**
         * Creates a new ArgumentsIncArchiveCounter instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsIncArchiveCounter
         * @static
         * @param {mediaarchiver.IArgumentsIncArchiveCounter=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsIncArchiveCounter} ArgumentsIncArchiveCounter instance
         */
        ArgumentsIncArchiveCounter.create = function create(properties) {
            return new ArgumentsIncArchiveCounter(properties);
        };

        /**
         * Encodes the specified ArgumentsIncArchiveCounter message. Does not implicitly {@link mediaarchiver.ArgumentsIncArchiveCounter.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsIncArchiveCounter
         * @static
         * @param {mediaarchiver.IArgumentsIncArchiveCounter} message ArgumentsIncArchiveCounter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsIncArchiveCounter.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ArchiveID != null && Object.hasOwnProperty.call(message, "ArchiveID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.ArchiveID);
            if (message.Downloads != null && Object.hasOwnProperty.call(message, "Downloads"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Downloads);
            if (message.Views != null && Object.hasOwnProperty.call(message, "Views"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.Views);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsIncArchiveCounter message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsIncArchiveCounter.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsIncArchiveCounter
         * @static
         * @param {mediaarchiver.IArgumentsIncArchiveCounter} message ArgumentsIncArchiveCounter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsIncArchiveCounter.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsIncArchiveCounter message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsIncArchiveCounter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsIncArchiveCounter} ArgumentsIncArchiveCounter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsIncArchiveCounter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsIncArchiveCounter();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ArchiveID = reader.string();
                    break;
                case 2:
                    message.Downloads = reader.uint32();
                    break;
                case 3:
                    message.Views = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsIncArchiveCounter message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsIncArchiveCounter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsIncArchiveCounter} ArgumentsIncArchiveCounter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsIncArchiveCounter.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsIncArchiveCounter message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsIncArchiveCounter
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsIncArchiveCounter.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ArchiveID != null && message.hasOwnProperty("ArchiveID"))
                if (!$util.isString(message.ArchiveID))
                    return "ArchiveID: string expected";
            if (message.Downloads != null && message.hasOwnProperty("Downloads"))
                if (!$util.isInteger(message.Downloads))
                    return "Downloads: integer expected";
            if (message.Views != null && message.hasOwnProperty("Views"))
                if (!$util.isInteger(message.Views))
                    return "Views: integer expected";
            return null;
        };

        /**
         * Creates an ArgumentsIncArchiveCounter message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsIncArchiveCounter
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsIncArchiveCounter} ArgumentsIncArchiveCounter
         */
        ArgumentsIncArchiveCounter.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsIncArchiveCounter)
                return object;
            let message = new $root.mediaarchiver.ArgumentsIncArchiveCounter();
            if (object.ArchiveID != null)
                message.ArchiveID = String(object.ArchiveID);
            if (object.Downloads != null)
                message.Downloads = object.Downloads >>> 0;
            if (object.Views != null)
                message.Views = object.Views >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsIncArchiveCounter message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsIncArchiveCounter
         * @static
         * @param {mediaarchiver.ArgumentsIncArchiveCounter} message ArgumentsIncArchiveCounter
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsIncArchiveCounter.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.ArchiveID = "";
                object.Downloads = 0;
                object.Views = 0;
            }
            if (message.ArchiveID != null && message.hasOwnProperty("ArchiveID"))
                object.ArchiveID = message.ArchiveID;
            if (message.Downloads != null && message.hasOwnProperty("Downloads"))
                object.Downloads = message.Downloads;
            if (message.Views != null && message.hasOwnProperty("Views"))
                object.Views = message.Views;
            return object;
        };

        /**
         * Converts this ArgumentsIncArchiveCounter to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsIncArchiveCounter
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsIncArchiveCounter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsIncArchiveCounter;
    })();

    mediaarchiver.ArgumentsShareArchive = (function() {

        /**
         * Properties of an ArgumentsShareArchive.
         * @memberof mediaarchiver
         * @interface IArgumentsShareArchive
         * @property {string|null} [ArchiveID] ArgumentsShareArchive ArchiveID
         * @property {string|null} [ToMail] ArgumentsShareArchive ToMail
         * @property {boolean|null} [AllowDownload] ArgumentsShareArchive AllowDownload
         * @property {string|null} [Message] ArgumentsShareArchive Message
         */

        /**
         * Constructs a new ArgumentsShareArchive.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsShareArchive.
         * @implements IArgumentsShareArchive
         * @constructor
         * @param {mediaarchiver.IArgumentsShareArchive=} [properties] Properties to set
         */
        function ArgumentsShareArchive(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsShareArchive ArchiveID.
         * @member {string} ArchiveID
         * @memberof mediaarchiver.ArgumentsShareArchive
         * @instance
         */
        ArgumentsShareArchive.prototype.ArchiveID = "";

        /**
         * ArgumentsShareArchive ToMail.
         * @member {string} ToMail
         * @memberof mediaarchiver.ArgumentsShareArchive
         * @instance
         */
        ArgumentsShareArchive.prototype.ToMail = "";

        /**
         * ArgumentsShareArchive AllowDownload.
         * @member {boolean} AllowDownload
         * @memberof mediaarchiver.ArgumentsShareArchive
         * @instance
         */
        ArgumentsShareArchive.prototype.AllowDownload = false;

        /**
         * ArgumentsShareArchive Message.
         * @member {string} Message
         * @memberof mediaarchiver.ArgumentsShareArchive
         * @instance
         */
        ArgumentsShareArchive.prototype.Message = "";

        /**
         * Creates a new ArgumentsShareArchive instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsShareArchive
         * @static
         * @param {mediaarchiver.IArgumentsShareArchive=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsShareArchive} ArgumentsShareArchive instance
         */
        ArgumentsShareArchive.create = function create(properties) {
            return new ArgumentsShareArchive(properties);
        };

        /**
         * Encodes the specified ArgumentsShareArchive message. Does not implicitly {@link mediaarchiver.ArgumentsShareArchive.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsShareArchive
         * @static
         * @param {mediaarchiver.IArgumentsShareArchive} message ArgumentsShareArchive message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsShareArchive.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ArchiveID != null && Object.hasOwnProperty.call(message, "ArchiveID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.ArchiveID);
            if (message.ToMail != null && Object.hasOwnProperty.call(message, "ToMail"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.ToMail);
            if (message.AllowDownload != null && Object.hasOwnProperty.call(message, "AllowDownload"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.AllowDownload);
            if (message.Message != null && Object.hasOwnProperty.call(message, "Message"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.Message);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsShareArchive message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsShareArchive.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsShareArchive
         * @static
         * @param {mediaarchiver.IArgumentsShareArchive} message ArgumentsShareArchive message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsShareArchive.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsShareArchive message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsShareArchive
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsShareArchive} ArgumentsShareArchive
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsShareArchive.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsShareArchive();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ArchiveID = reader.string();
                    break;
                case 2:
                    message.ToMail = reader.string();
                    break;
                case 3:
                    message.AllowDownload = reader.bool();
                    break;
                case 4:
                    message.Message = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsShareArchive message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsShareArchive
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsShareArchive} ArgumentsShareArchive
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsShareArchive.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsShareArchive message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsShareArchive
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsShareArchive.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ArchiveID != null && message.hasOwnProperty("ArchiveID"))
                if (!$util.isString(message.ArchiveID))
                    return "ArchiveID: string expected";
            if (message.ToMail != null && message.hasOwnProperty("ToMail"))
                if (!$util.isString(message.ToMail))
                    return "ToMail: string expected";
            if (message.AllowDownload != null && message.hasOwnProperty("AllowDownload"))
                if (typeof message.AllowDownload !== "boolean")
                    return "AllowDownload: boolean expected";
            if (message.Message != null && message.hasOwnProperty("Message"))
                if (!$util.isString(message.Message))
                    return "Message: string expected";
            return null;
        };

        /**
         * Creates an ArgumentsShareArchive message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsShareArchive
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsShareArchive} ArgumentsShareArchive
         */
        ArgumentsShareArchive.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsShareArchive)
                return object;
            let message = new $root.mediaarchiver.ArgumentsShareArchive();
            if (object.ArchiveID != null)
                message.ArchiveID = String(object.ArchiveID);
            if (object.ToMail != null)
                message.ToMail = String(object.ToMail);
            if (object.AllowDownload != null)
                message.AllowDownload = Boolean(object.AllowDownload);
            if (object.Message != null)
                message.Message = String(object.Message);
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsShareArchive message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsShareArchive
         * @static
         * @param {mediaarchiver.ArgumentsShareArchive} message ArgumentsShareArchive
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsShareArchive.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.ArchiveID = "";
                object.ToMail = "";
                object.AllowDownload = false;
                object.Message = "";
            }
            if (message.ArchiveID != null && message.hasOwnProperty("ArchiveID"))
                object.ArchiveID = message.ArchiveID;
            if (message.ToMail != null && message.hasOwnProperty("ToMail"))
                object.ToMail = message.ToMail;
            if (message.AllowDownload != null && message.hasOwnProperty("AllowDownload"))
                object.AllowDownload = message.AllowDownload;
            if (message.Message != null && message.hasOwnProperty("Message"))
                object.Message = message.Message;
            return object;
        };

        /**
         * Converts this ArgumentsShareArchive to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsShareArchive
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsShareArchive.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsShareArchive;
    })();

    mediaarchiver.AnnotationTypeField = (function() {

        /**
         * Properties of an AnnotationTypeField.
         * @memberof mediaarchiver
         * @interface IAnnotationTypeField
         * @property {string|null} [Type] AnnotationTypeField Type
         * @property {boolean|null} [Mandatory] AnnotationTypeField Mandatory
         * @property {string|null} [Name] AnnotationTypeField Name
         * @property {string|null} [Description] AnnotationTypeField Description
         * @property {string|null} [Data] AnnotationTypeField Data
         * @property {number|null} [Order] AnnotationTypeField Order
         */

        /**
         * Constructs a new AnnotationTypeField.
         * @memberof mediaarchiver
         * @classdesc Represents an AnnotationTypeField.
         * @implements IAnnotationTypeField
         * @constructor
         * @param {mediaarchiver.IAnnotationTypeField=} [properties] Properties to set
         */
        function AnnotationTypeField(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AnnotationTypeField Type.
         * @member {string} Type
         * @memberof mediaarchiver.AnnotationTypeField
         * @instance
         */
        AnnotationTypeField.prototype.Type = "";

        /**
         * AnnotationTypeField Mandatory.
         * @member {boolean} Mandatory
         * @memberof mediaarchiver.AnnotationTypeField
         * @instance
         */
        AnnotationTypeField.prototype.Mandatory = false;

        /**
         * AnnotationTypeField Name.
         * @member {string} Name
         * @memberof mediaarchiver.AnnotationTypeField
         * @instance
         */
        AnnotationTypeField.prototype.Name = "";

        /**
         * AnnotationTypeField Description.
         * @member {string} Description
         * @memberof mediaarchiver.AnnotationTypeField
         * @instance
         */
        AnnotationTypeField.prototype.Description = "";

        /**
         * AnnotationTypeField Data.
         * @member {string} Data
         * @memberof mediaarchiver.AnnotationTypeField
         * @instance
         */
        AnnotationTypeField.prototype.Data = "";

        /**
         * AnnotationTypeField Order.
         * @member {number} Order
         * @memberof mediaarchiver.AnnotationTypeField
         * @instance
         */
        AnnotationTypeField.prototype.Order = 0;

        /**
         * Creates a new AnnotationTypeField instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.AnnotationTypeField
         * @static
         * @param {mediaarchiver.IAnnotationTypeField=} [properties] Properties to set
         * @returns {mediaarchiver.AnnotationTypeField} AnnotationTypeField instance
         */
        AnnotationTypeField.create = function create(properties) {
            return new AnnotationTypeField(properties);
        };

        /**
         * Encodes the specified AnnotationTypeField message. Does not implicitly {@link mediaarchiver.AnnotationTypeField.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.AnnotationTypeField
         * @static
         * @param {mediaarchiver.IAnnotationTypeField} message AnnotationTypeField message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AnnotationTypeField.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Type);
            if (message.Mandatory != null && Object.hasOwnProperty.call(message, "Mandatory"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.Mandatory);
            if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.Name);
            if (message.Description != null && Object.hasOwnProperty.call(message, "Description"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.Description);
            if (message.Data != null && Object.hasOwnProperty.call(message, "Data"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.Data);
            if (message.Order != null && Object.hasOwnProperty.call(message, "Order"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.Order);
            return writer;
        };

        /**
         * Encodes the specified AnnotationTypeField message, length delimited. Does not implicitly {@link mediaarchiver.AnnotationTypeField.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.AnnotationTypeField
         * @static
         * @param {mediaarchiver.IAnnotationTypeField} message AnnotationTypeField message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AnnotationTypeField.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AnnotationTypeField message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.AnnotationTypeField
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.AnnotationTypeField} AnnotationTypeField
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AnnotationTypeField.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.AnnotationTypeField();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Type = reader.string();
                    break;
                case 2:
                    message.Mandatory = reader.bool();
                    break;
                case 3:
                    message.Name = reader.string();
                    break;
                case 4:
                    message.Description = reader.string();
                    break;
                case 5:
                    message.Data = reader.string();
                    break;
                case 6:
                    message.Order = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AnnotationTypeField message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.AnnotationTypeField
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.AnnotationTypeField} AnnotationTypeField
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AnnotationTypeField.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AnnotationTypeField message.
         * @function verify
         * @memberof mediaarchiver.AnnotationTypeField
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AnnotationTypeField.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Type != null && message.hasOwnProperty("Type"))
                if (!$util.isString(message.Type))
                    return "Type: string expected";
            if (message.Mandatory != null && message.hasOwnProperty("Mandatory"))
                if (typeof message.Mandatory !== "boolean")
                    return "Mandatory: boolean expected";
            if (message.Name != null && message.hasOwnProperty("Name"))
                if (!$util.isString(message.Name))
                    return "Name: string expected";
            if (message.Description != null && message.hasOwnProperty("Description"))
                if (!$util.isString(message.Description))
                    return "Description: string expected";
            if (message.Data != null && message.hasOwnProperty("Data"))
                if (!$util.isString(message.Data))
                    return "Data: string expected";
            if (message.Order != null && message.hasOwnProperty("Order"))
                if (!$util.isInteger(message.Order))
                    return "Order: integer expected";
            return null;
        };

        /**
         * Creates an AnnotationTypeField message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.AnnotationTypeField
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.AnnotationTypeField} AnnotationTypeField
         */
        AnnotationTypeField.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.AnnotationTypeField)
                return object;
            let message = new $root.mediaarchiver.AnnotationTypeField();
            if (object.Type != null)
                message.Type = String(object.Type);
            if (object.Mandatory != null)
                message.Mandatory = Boolean(object.Mandatory);
            if (object.Name != null)
                message.Name = String(object.Name);
            if (object.Description != null)
                message.Description = String(object.Description);
            if (object.Data != null)
                message.Data = String(object.Data);
            if (object.Order != null)
                message.Order = object.Order >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an AnnotationTypeField message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.AnnotationTypeField
         * @static
         * @param {mediaarchiver.AnnotationTypeField} message AnnotationTypeField
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AnnotationTypeField.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.Type = "";
                object.Mandatory = false;
                object.Name = "";
                object.Description = "";
                object.Data = "";
                object.Order = 0;
            }
            if (message.Type != null && message.hasOwnProperty("Type"))
                object.Type = message.Type;
            if (message.Mandatory != null && message.hasOwnProperty("Mandatory"))
                object.Mandatory = message.Mandatory;
            if (message.Name != null && message.hasOwnProperty("Name"))
                object.Name = message.Name;
            if (message.Description != null && message.hasOwnProperty("Description"))
                object.Description = message.Description;
            if (message.Data != null && message.hasOwnProperty("Data"))
                object.Data = message.Data;
            if (message.Order != null && message.hasOwnProperty("Order"))
                object.Order = message.Order;
            return object;
        };

        /**
         * Converts this AnnotationTypeField to JSON.
         * @function toJSON
         * @memberof mediaarchiver.AnnotationTypeField
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AnnotationTypeField.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AnnotationTypeField;
    })();

    mediaarchiver.AnnotationType = (function() {

        /**
         * Properties of an AnnotationType.
         * @memberof mediaarchiver
         * @interface IAnnotationType
         * @property {string|null} [ID] AnnotationType ID
         * @property {number|null} [Owner] AnnotationType Owner
         * @property {string|null} [Name] AnnotationType Name
         * @property {string|null} [Description] AnnotationType Description
         * @property {string|null} [Color] AnnotationType Color
         * @property {Array.<mediaarchiver.IAnnotationTypeField>|null} [Fields] AnnotationType Fields
         * @property {number|null} [Count] AnnotationType Count
         * @property {number|null} [Group] AnnotationType Group
         */

        /**
         * Constructs a new AnnotationType.
         * @memberof mediaarchiver
         * @classdesc Represents an AnnotationType.
         * @implements IAnnotationType
         * @constructor
         * @param {mediaarchiver.IAnnotationType=} [properties] Properties to set
         */
        function AnnotationType(properties) {
            this.Fields = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AnnotationType ID.
         * @member {string} ID
         * @memberof mediaarchiver.AnnotationType
         * @instance
         */
        AnnotationType.prototype.ID = "";

        /**
         * AnnotationType Owner.
         * @member {number} Owner
         * @memberof mediaarchiver.AnnotationType
         * @instance
         */
        AnnotationType.prototype.Owner = 0;

        /**
         * AnnotationType Name.
         * @member {string} Name
         * @memberof mediaarchiver.AnnotationType
         * @instance
         */
        AnnotationType.prototype.Name = "";

        /**
         * AnnotationType Description.
         * @member {string} Description
         * @memberof mediaarchiver.AnnotationType
         * @instance
         */
        AnnotationType.prototype.Description = "";

        /**
         * AnnotationType Color.
         * @member {string} Color
         * @memberof mediaarchiver.AnnotationType
         * @instance
         */
        AnnotationType.prototype.Color = "";

        /**
         * AnnotationType Fields.
         * @member {Array.<mediaarchiver.IAnnotationTypeField>} Fields
         * @memberof mediaarchiver.AnnotationType
         * @instance
         */
        AnnotationType.prototype.Fields = $util.emptyArray;

        /**
         * AnnotationType Count.
         * @member {number} Count
         * @memberof mediaarchiver.AnnotationType
         * @instance
         */
        AnnotationType.prototype.Count = 0;

        /**
         * AnnotationType Group.
         * @member {number} Group
         * @memberof mediaarchiver.AnnotationType
         * @instance
         */
        AnnotationType.prototype.Group = 0;

        /**
         * Creates a new AnnotationType instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.AnnotationType
         * @static
         * @param {mediaarchiver.IAnnotationType=} [properties] Properties to set
         * @returns {mediaarchiver.AnnotationType} AnnotationType instance
         */
        AnnotationType.create = function create(properties) {
            return new AnnotationType(properties);
        };

        /**
         * Encodes the specified AnnotationType message. Does not implicitly {@link mediaarchiver.AnnotationType.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.AnnotationType
         * @static
         * @param {mediaarchiver.IAnnotationType} message AnnotationType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AnnotationType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.ID);
            if (message.Owner != null && Object.hasOwnProperty.call(message, "Owner"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Owner);
            if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.Name);
            if (message.Description != null && Object.hasOwnProperty.call(message, "Description"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.Description);
            if (message.Color != null && Object.hasOwnProperty.call(message, "Color"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.Color);
            if (message.Fields != null && message.Fields.length)
                for (let i = 0; i < message.Fields.length; ++i)
                    $root.mediaarchiver.AnnotationTypeField.encode(message.Fields[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            if (message.Count != null && Object.hasOwnProperty.call(message, "Count"))
                writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.Count);
            if (message.Group != null && Object.hasOwnProperty.call(message, "Group"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.Group);
            return writer;
        };

        /**
         * Encodes the specified AnnotationType message, length delimited. Does not implicitly {@link mediaarchiver.AnnotationType.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.AnnotationType
         * @static
         * @param {mediaarchiver.IAnnotationType} message AnnotationType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AnnotationType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AnnotationType message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.AnnotationType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.AnnotationType} AnnotationType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AnnotationType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.AnnotationType();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ID = reader.string();
                    break;
                case 2:
                    message.Owner = reader.uint32();
                    break;
                case 3:
                    message.Name = reader.string();
                    break;
                case 4:
                    message.Description = reader.string();
                    break;
                case 5:
                    message.Color = reader.string();
                    break;
                case 6:
                    if (!(message.Fields && message.Fields.length))
                        message.Fields = [];
                    message.Fields.push($root.mediaarchiver.AnnotationTypeField.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.Count = reader.uint32();
                    break;
                case 8:
                    message.Group = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AnnotationType message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.AnnotationType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.AnnotationType} AnnotationType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AnnotationType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AnnotationType message.
         * @function verify
         * @memberof mediaarchiver.AnnotationType
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AnnotationType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isString(message.ID))
                    return "ID: string expected";
            if (message.Owner != null && message.hasOwnProperty("Owner"))
                if (!$util.isInteger(message.Owner))
                    return "Owner: integer expected";
            if (message.Name != null && message.hasOwnProperty("Name"))
                if (!$util.isString(message.Name))
                    return "Name: string expected";
            if (message.Description != null && message.hasOwnProperty("Description"))
                if (!$util.isString(message.Description))
                    return "Description: string expected";
            if (message.Color != null && message.hasOwnProperty("Color"))
                if (!$util.isString(message.Color))
                    return "Color: string expected";
            if (message.Fields != null && message.hasOwnProperty("Fields")) {
                if (!Array.isArray(message.Fields))
                    return "Fields: array expected";
                for (let i = 0; i < message.Fields.length; ++i) {
                    let error = $root.mediaarchiver.AnnotationTypeField.verify(message.Fields[i]);
                    if (error)
                        return "Fields." + error;
                }
            }
            if (message.Count != null && message.hasOwnProperty("Count"))
                if (!$util.isInteger(message.Count))
                    return "Count: integer expected";
            if (message.Group != null && message.hasOwnProperty("Group"))
                if (!$util.isInteger(message.Group))
                    return "Group: integer expected";
            return null;
        };

        /**
         * Creates an AnnotationType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.AnnotationType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.AnnotationType} AnnotationType
         */
        AnnotationType.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.AnnotationType)
                return object;
            let message = new $root.mediaarchiver.AnnotationType();
            if (object.ID != null)
                message.ID = String(object.ID);
            if (object.Owner != null)
                message.Owner = object.Owner >>> 0;
            if (object.Name != null)
                message.Name = String(object.Name);
            if (object.Description != null)
                message.Description = String(object.Description);
            if (object.Color != null)
                message.Color = String(object.Color);
            if (object.Fields) {
                if (!Array.isArray(object.Fields))
                    throw TypeError(".mediaarchiver.AnnotationType.Fields: array expected");
                message.Fields = [];
                for (let i = 0; i < object.Fields.length; ++i) {
                    if (typeof object.Fields[i] !== "object")
                        throw TypeError(".mediaarchiver.AnnotationType.Fields: object expected");
                    message.Fields[i] = $root.mediaarchiver.AnnotationTypeField.fromObject(object.Fields[i]);
                }
            }
            if (object.Count != null)
                message.Count = object.Count >>> 0;
            if (object.Group != null)
                message.Group = object.Group >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an AnnotationType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.AnnotationType
         * @static
         * @param {mediaarchiver.AnnotationType} message AnnotationType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AnnotationType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Fields = [];
            if (options.defaults) {
                object.ID = "";
                object.Owner = 0;
                object.Name = "";
                object.Description = "";
                object.Color = "";
                object.Count = 0;
                object.Group = 0;
            }
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            if (message.Owner != null && message.hasOwnProperty("Owner"))
                object.Owner = message.Owner;
            if (message.Name != null && message.hasOwnProperty("Name"))
                object.Name = message.Name;
            if (message.Description != null && message.hasOwnProperty("Description"))
                object.Description = message.Description;
            if (message.Color != null && message.hasOwnProperty("Color"))
                object.Color = message.Color;
            if (message.Fields && message.Fields.length) {
                object.Fields = [];
                for (let j = 0; j < message.Fields.length; ++j)
                    object.Fields[j] = $root.mediaarchiver.AnnotationTypeField.toObject(message.Fields[j], options);
            }
            if (message.Count != null && message.hasOwnProperty("Count"))
                object.Count = message.Count;
            if (message.Group != null && message.hasOwnProperty("Group"))
                object.Group = message.Group;
            return object;
        };

        /**
         * Converts this AnnotationType to JSON.
         * @function toJSON
         * @memberof mediaarchiver.AnnotationType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AnnotationType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AnnotationType;
    })();

    mediaarchiver.ArgumentsAnnotationTypes = (function() {

        /**
         * Properties of an ArgumentsAnnotationTypes.
         * @memberof mediaarchiver
         * @interface IArgumentsAnnotationTypes
         * @property {number|null} [Offset] ArgumentsAnnotationTypes Offset
         * @property {number|null} [Count] ArgumentsAnnotationTypes Count
         * @property {Array.<mediaarchiver.IAnnotationType>|null} [AnnotationTypes] ArgumentsAnnotationTypes AnnotationTypes
         */

        /**
         * Constructs a new ArgumentsAnnotationTypes.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsAnnotationTypes.
         * @implements IArgumentsAnnotationTypes
         * @constructor
         * @param {mediaarchiver.IArgumentsAnnotationTypes=} [properties] Properties to set
         */
        function ArgumentsAnnotationTypes(properties) {
            this.AnnotationTypes = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsAnnotationTypes Offset.
         * @member {number} Offset
         * @memberof mediaarchiver.ArgumentsAnnotationTypes
         * @instance
         */
        ArgumentsAnnotationTypes.prototype.Offset = 0;

        /**
         * ArgumentsAnnotationTypes Count.
         * @member {number} Count
         * @memberof mediaarchiver.ArgumentsAnnotationTypes
         * @instance
         */
        ArgumentsAnnotationTypes.prototype.Count = 0;

        /**
         * ArgumentsAnnotationTypes AnnotationTypes.
         * @member {Array.<mediaarchiver.IAnnotationType>} AnnotationTypes
         * @memberof mediaarchiver.ArgumentsAnnotationTypes
         * @instance
         */
        ArgumentsAnnotationTypes.prototype.AnnotationTypes = $util.emptyArray;

        /**
         * Creates a new ArgumentsAnnotationTypes instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsAnnotationTypes
         * @static
         * @param {mediaarchiver.IArgumentsAnnotationTypes=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsAnnotationTypes} ArgumentsAnnotationTypes instance
         */
        ArgumentsAnnotationTypes.create = function create(properties) {
            return new ArgumentsAnnotationTypes(properties);
        };

        /**
         * Encodes the specified ArgumentsAnnotationTypes message. Does not implicitly {@link mediaarchiver.ArgumentsAnnotationTypes.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsAnnotationTypes
         * @static
         * @param {mediaarchiver.IArgumentsAnnotationTypes} message ArgumentsAnnotationTypes message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsAnnotationTypes.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Offset != null && Object.hasOwnProperty.call(message, "Offset"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Offset);
            if (message.Count != null && Object.hasOwnProperty.call(message, "Count"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Count);
            if (message.AnnotationTypes != null && message.AnnotationTypes.length)
                for (let i = 0; i < message.AnnotationTypes.length; ++i)
                    $root.mediaarchiver.AnnotationType.encode(message.AnnotationTypes[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ArgumentsAnnotationTypes message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsAnnotationTypes.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsAnnotationTypes
         * @static
         * @param {mediaarchiver.IArgumentsAnnotationTypes} message ArgumentsAnnotationTypes message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsAnnotationTypes.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsAnnotationTypes message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsAnnotationTypes
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsAnnotationTypes} ArgumentsAnnotationTypes
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsAnnotationTypes.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsAnnotationTypes();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Offset = reader.uint32();
                    break;
                case 2:
                    message.Count = reader.uint32();
                    break;
                case 3:
                    if (!(message.AnnotationTypes && message.AnnotationTypes.length))
                        message.AnnotationTypes = [];
                    message.AnnotationTypes.push($root.mediaarchiver.AnnotationType.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsAnnotationTypes message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsAnnotationTypes
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsAnnotationTypes} ArgumentsAnnotationTypes
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsAnnotationTypes.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsAnnotationTypes message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsAnnotationTypes
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsAnnotationTypes.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                if (!$util.isInteger(message.Offset))
                    return "Offset: integer expected";
            if (message.Count != null && message.hasOwnProperty("Count"))
                if (!$util.isInteger(message.Count))
                    return "Count: integer expected";
            if (message.AnnotationTypes != null && message.hasOwnProperty("AnnotationTypes")) {
                if (!Array.isArray(message.AnnotationTypes))
                    return "AnnotationTypes: array expected";
                for (let i = 0; i < message.AnnotationTypes.length; ++i) {
                    let error = $root.mediaarchiver.AnnotationType.verify(message.AnnotationTypes[i]);
                    if (error)
                        return "AnnotationTypes." + error;
                }
            }
            return null;
        };

        /**
         * Creates an ArgumentsAnnotationTypes message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsAnnotationTypes
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsAnnotationTypes} ArgumentsAnnotationTypes
         */
        ArgumentsAnnotationTypes.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsAnnotationTypes)
                return object;
            let message = new $root.mediaarchiver.ArgumentsAnnotationTypes();
            if (object.Offset != null)
                message.Offset = object.Offset >>> 0;
            if (object.Count != null)
                message.Count = object.Count >>> 0;
            if (object.AnnotationTypes) {
                if (!Array.isArray(object.AnnotationTypes))
                    throw TypeError(".mediaarchiver.ArgumentsAnnotationTypes.AnnotationTypes: array expected");
                message.AnnotationTypes = [];
                for (let i = 0; i < object.AnnotationTypes.length; ++i) {
                    if (typeof object.AnnotationTypes[i] !== "object")
                        throw TypeError(".mediaarchiver.ArgumentsAnnotationTypes.AnnotationTypes: object expected");
                    message.AnnotationTypes[i] = $root.mediaarchiver.AnnotationType.fromObject(object.AnnotationTypes[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsAnnotationTypes message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsAnnotationTypes
         * @static
         * @param {mediaarchiver.ArgumentsAnnotationTypes} message ArgumentsAnnotationTypes
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsAnnotationTypes.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.AnnotationTypes = [];
            if (options.defaults) {
                object.Offset = 0;
                object.Count = 0;
            }
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                object.Offset = message.Offset;
            if (message.Count != null && message.hasOwnProperty("Count"))
                object.Count = message.Count;
            if (message.AnnotationTypes && message.AnnotationTypes.length) {
                object.AnnotationTypes = [];
                for (let j = 0; j < message.AnnotationTypes.length; ++j)
                    object.AnnotationTypes[j] = $root.mediaarchiver.AnnotationType.toObject(message.AnnotationTypes[j], options);
            }
            return object;
        };

        /**
         * Converts this ArgumentsAnnotationTypes to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsAnnotationTypes
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsAnnotationTypes.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsAnnotationTypes;
    })();

    mediaarchiver.ArgumentsGetAnnotationTypes = (function() {

        /**
         * Properties of an ArgumentsGetAnnotationTypes.
         * @memberof mediaarchiver
         * @interface IArgumentsGetAnnotationTypes
         * @property {number|null} [Limit] ArgumentsGetAnnotationTypes Limit
         * @property {number|null} [Offset] ArgumentsGetAnnotationTypes Offset
         */

        /**
         * Constructs a new ArgumentsGetAnnotationTypes.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsGetAnnotationTypes.
         * @implements IArgumentsGetAnnotationTypes
         * @constructor
         * @param {mediaarchiver.IArgumentsGetAnnotationTypes=} [properties] Properties to set
         */
        function ArgumentsGetAnnotationTypes(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsGetAnnotationTypes Limit.
         * @member {number} Limit
         * @memberof mediaarchiver.ArgumentsGetAnnotationTypes
         * @instance
         */
        ArgumentsGetAnnotationTypes.prototype.Limit = 0;

        /**
         * ArgumentsGetAnnotationTypes Offset.
         * @member {number} Offset
         * @memberof mediaarchiver.ArgumentsGetAnnotationTypes
         * @instance
         */
        ArgumentsGetAnnotationTypes.prototype.Offset = 0;

        /**
         * Creates a new ArgumentsGetAnnotationTypes instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsGetAnnotationTypes
         * @static
         * @param {mediaarchiver.IArgumentsGetAnnotationTypes=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsGetAnnotationTypes} ArgumentsGetAnnotationTypes instance
         */
        ArgumentsGetAnnotationTypes.create = function create(properties) {
            return new ArgumentsGetAnnotationTypes(properties);
        };

        /**
         * Encodes the specified ArgumentsGetAnnotationTypes message. Does not implicitly {@link mediaarchiver.ArgumentsGetAnnotationTypes.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsGetAnnotationTypes
         * @static
         * @param {mediaarchiver.IArgumentsGetAnnotationTypes} message ArgumentsGetAnnotationTypes message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetAnnotationTypes.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Limit != null && Object.hasOwnProperty.call(message, "Limit"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Limit);
            if (message.Offset != null && Object.hasOwnProperty.call(message, "Offset"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Offset);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsGetAnnotationTypes message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsGetAnnotationTypes.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsGetAnnotationTypes
         * @static
         * @param {mediaarchiver.IArgumentsGetAnnotationTypes} message ArgumentsGetAnnotationTypes message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetAnnotationTypes.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsGetAnnotationTypes message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsGetAnnotationTypes
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsGetAnnotationTypes} ArgumentsGetAnnotationTypes
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetAnnotationTypes.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsGetAnnotationTypes();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Limit = reader.uint32();
                    break;
                case 2:
                    message.Offset = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsGetAnnotationTypes message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsGetAnnotationTypes
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsGetAnnotationTypes} ArgumentsGetAnnotationTypes
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetAnnotationTypes.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsGetAnnotationTypes message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsGetAnnotationTypes
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsGetAnnotationTypes.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Limit != null && message.hasOwnProperty("Limit"))
                if (!$util.isInteger(message.Limit))
                    return "Limit: integer expected";
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                if (!$util.isInteger(message.Offset))
                    return "Offset: integer expected";
            return null;
        };

        /**
         * Creates an ArgumentsGetAnnotationTypes message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsGetAnnotationTypes
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsGetAnnotationTypes} ArgumentsGetAnnotationTypes
         */
        ArgumentsGetAnnotationTypes.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsGetAnnotationTypes)
                return object;
            let message = new $root.mediaarchiver.ArgumentsGetAnnotationTypes();
            if (object.Limit != null)
                message.Limit = object.Limit >>> 0;
            if (object.Offset != null)
                message.Offset = object.Offset >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsGetAnnotationTypes message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsGetAnnotationTypes
         * @static
         * @param {mediaarchiver.ArgumentsGetAnnotationTypes} message ArgumentsGetAnnotationTypes
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsGetAnnotationTypes.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.Limit = 0;
                object.Offset = 0;
            }
            if (message.Limit != null && message.hasOwnProperty("Limit"))
                object.Limit = message.Limit;
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                object.Offset = message.Offset;
            return object;
        };

        /**
         * Converts this ArgumentsGetAnnotationTypes to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsGetAnnotationTypes
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsGetAnnotationTypes.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsGetAnnotationTypes;
    })();

    /**
     * TalkStudyType enum.
     * @name mediaarchiver.TalkStudyType
     * @enum {number}
     * @property {number} TALK_TYPE_UNKNOWN=0 TALK_TYPE_UNKNOWN value
     * @property {number} TALK_TYPE_PLURALISM=1 TALK_TYPE_PLURALISM value
     * @property {number} TALK_TYPE_ELECTION=2 TALK_TYPE_ELECTION value
     */
    mediaarchiver.TalkStudyType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TALK_TYPE_UNKNOWN"] = 0;
        values[valuesById[1] = "TALK_TYPE_PLURALISM"] = 1;
        values[valuesById[2] = "TALK_TYPE_ELECTION"] = 2;
        return values;
    })();

    /**
     * TalkTalkType enum.
     * @name mediaarchiver.TalkTalkType
     * @enum {number}
     * @property {number} TALK_TALK_TYPE_UNKNOWN=0 TALK_TALK_TYPE_UNKNOWN value
     * @property {number} TALK_TALK_TYPE_ADJUSTED=1 TALK_TALK_TYPE_ADJUSTED value
     * @property {number} TALK_TALK_TYPE_AGGREGATED=2 TALK_TALK_TYPE_AGGREGATED value
     */
    mediaarchiver.TalkTalkType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TALK_TALK_TYPE_UNKNOWN"] = 0;
        values[valuesById[1] = "TALK_TALK_TYPE_ADJUSTED"] = 1;
        values[valuesById[2] = "TALK_TALK_TYPE_AGGREGATED"] = 2;
        return values;
    })();

    /**
     * TalkTimeType enum.
     * @name mediaarchiver.TalkTimeType
     * @enum {number}
     * @property {number} TALK_TIME_TYPE_UNKNOWN=0 TALK_TIME_TYPE_UNKNOWN value
     * @property {number} TALK_TIME_TYPE_SPEAK=1 TALK_TIME_TYPE_SPEAK value
     * @property {number} TALK_TIME_TYPE_BROADCAST=2 TALK_TIME_TYPE_BROADCAST value
     */
    mediaarchiver.TalkTimeType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TALK_TIME_TYPE_UNKNOWN"] = 0;
        values[valuesById[1] = "TALK_TIME_TYPE_SPEAK"] = 1;
        values[valuesById[2] = "TALK_TIME_TYPE_BROADCAST"] = 2;
        return values;
    })();

    /**
     * TalkSituationType enum.
     * @name mediaarchiver.TalkSituationType
     * @enum {number}
     * @property {number} TALK_SITUATION_TYPE_INVITED=0 TALK_SITUATION_TYPE_INVITED value
     * @property {number} TALK_SITUATION_TYPE_REPORTAGE=1 TALK_SITUATION_TYPE_REPORTAGE value
     */
    mediaarchiver.TalkSituationType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TALK_SITUATION_TYPE_INVITED"] = 0;
        values[valuesById[1] = "TALK_SITUATION_TYPE_REPORTAGE"] = 1;
        return values;
    })();

    mediaarchiver.TalkGroup = (function() {

        /**
         * Properties of a TalkGroup.
         * @memberof mediaarchiver
         * @interface ITalkGroup
         * @property {number|null} [ID] TalkGroup ID
         * @property {string|null} [Name] TalkGroup Name
         * @property {string|null} [Color] TalkGroup Color
         * @property {number|null} [Start] TalkGroup Start
         * @property {number|null} [End] TalkGroup End
         * @property {number|null} [Study] TalkGroup Study
         */

        /**
         * Constructs a new TalkGroup.
         * @memberof mediaarchiver
         * @classdesc Represents a TalkGroup.
         * @implements ITalkGroup
         * @constructor
         * @param {mediaarchiver.ITalkGroup=} [properties] Properties to set
         */
        function TalkGroup(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TalkGroup ID.
         * @member {number} ID
         * @memberof mediaarchiver.TalkGroup
         * @instance
         */
        TalkGroup.prototype.ID = 0;

        /**
         * TalkGroup Name.
         * @member {string} Name
         * @memberof mediaarchiver.TalkGroup
         * @instance
         */
        TalkGroup.prototype.Name = "";

        /**
         * TalkGroup Color.
         * @member {string} Color
         * @memberof mediaarchiver.TalkGroup
         * @instance
         */
        TalkGroup.prototype.Color = "";

        /**
         * TalkGroup Start.
         * @member {number} Start
         * @memberof mediaarchiver.TalkGroup
         * @instance
         */
        TalkGroup.prototype.Start = 0;

        /**
         * TalkGroup End.
         * @member {number} End
         * @memberof mediaarchiver.TalkGroup
         * @instance
         */
        TalkGroup.prototype.End = 0;

        /**
         * TalkGroup Study.
         * @member {number} Study
         * @memberof mediaarchiver.TalkGroup
         * @instance
         */
        TalkGroup.prototype.Study = 0;

        /**
         * Creates a new TalkGroup instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.TalkGroup
         * @static
         * @param {mediaarchiver.ITalkGroup=} [properties] Properties to set
         * @returns {mediaarchiver.TalkGroup} TalkGroup instance
         */
        TalkGroup.create = function create(properties) {
            return new TalkGroup(properties);
        };

        /**
         * Encodes the specified TalkGroup message. Does not implicitly {@link mediaarchiver.TalkGroup.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.TalkGroup
         * @static
         * @param {mediaarchiver.ITalkGroup} message TalkGroup message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkGroup.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ID);
            if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
            if (message.Color != null && Object.hasOwnProperty.call(message, "Color"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.Color);
            if (message.Start != null && Object.hasOwnProperty.call(message, "Start"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.Start);
            if (message.End != null && Object.hasOwnProperty.call(message, "End"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.End);
            if (message.Study != null && Object.hasOwnProperty.call(message, "Study"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.Study);
            return writer;
        };

        /**
         * Encodes the specified TalkGroup message, length delimited. Does not implicitly {@link mediaarchiver.TalkGroup.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.TalkGroup
         * @static
         * @param {mediaarchiver.ITalkGroup} message TalkGroup message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkGroup.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TalkGroup message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.TalkGroup
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.TalkGroup} TalkGroup
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkGroup.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.TalkGroup();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ID = reader.uint32();
                    break;
                case 2:
                    message.Name = reader.string();
                    break;
                case 3:
                    message.Color = reader.string();
                    break;
                case 4:
                    message.Start = reader.uint32();
                    break;
                case 5:
                    message.End = reader.uint32();
                    break;
                case 6:
                    message.Study = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TalkGroup message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.TalkGroup
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.TalkGroup} TalkGroup
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkGroup.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TalkGroup message.
         * @function verify
         * @memberof mediaarchiver.TalkGroup
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TalkGroup.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isInteger(message.ID))
                    return "ID: integer expected";
            if (message.Name != null && message.hasOwnProperty("Name"))
                if (!$util.isString(message.Name))
                    return "Name: string expected";
            if (message.Color != null && message.hasOwnProperty("Color"))
                if (!$util.isString(message.Color))
                    return "Color: string expected";
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (!$util.isInteger(message.Start))
                    return "Start: integer expected";
            if (message.End != null && message.hasOwnProperty("End"))
                if (!$util.isInteger(message.End))
                    return "End: integer expected";
            if (message.Study != null && message.hasOwnProperty("Study"))
                if (!$util.isInteger(message.Study))
                    return "Study: integer expected";
            return null;
        };

        /**
         * Creates a TalkGroup message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.TalkGroup
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.TalkGroup} TalkGroup
         */
        TalkGroup.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.TalkGroup)
                return object;
            let message = new $root.mediaarchiver.TalkGroup();
            if (object.ID != null)
                message.ID = object.ID >>> 0;
            if (object.Name != null)
                message.Name = String(object.Name);
            if (object.Color != null)
                message.Color = String(object.Color);
            if (object.Start != null)
                message.Start = object.Start >>> 0;
            if (object.End != null)
                message.End = object.End >>> 0;
            if (object.Study != null)
                message.Study = object.Study >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a TalkGroup message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.TalkGroup
         * @static
         * @param {mediaarchiver.TalkGroup} message TalkGroup
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TalkGroup.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.ID = 0;
                object.Name = "";
                object.Color = "";
                object.Start = 0;
                object.End = 0;
                object.Study = 0;
            }
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            if (message.Name != null && message.hasOwnProperty("Name"))
                object.Name = message.Name;
            if (message.Color != null && message.hasOwnProperty("Color"))
                object.Color = message.Color;
            if (message.Start != null && message.hasOwnProperty("Start"))
                object.Start = message.Start;
            if (message.End != null && message.hasOwnProperty("End"))
                object.End = message.End;
            if (message.Study != null && message.hasOwnProperty("Study"))
                object.Study = message.Study;
            return object;
        };

        /**
         * Converts this TalkGroup to JSON.
         * @function toJSON
         * @memberof mediaarchiver.TalkGroup
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TalkGroup.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TalkGroup;
    })();

    mediaarchiver.TalkGroups = (function() {

        /**
         * Properties of a TalkGroups.
         * @memberof mediaarchiver
         * @interface ITalkGroups
         * @property {Array.<mediaarchiver.ITalkGroup>|null} [Groups] TalkGroups Groups
         */

        /**
         * Constructs a new TalkGroups.
         * @memberof mediaarchiver
         * @classdesc Represents a TalkGroups.
         * @implements ITalkGroups
         * @constructor
         * @param {mediaarchiver.ITalkGroups=} [properties] Properties to set
         */
        function TalkGroups(properties) {
            this.Groups = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TalkGroups Groups.
         * @member {Array.<mediaarchiver.ITalkGroup>} Groups
         * @memberof mediaarchiver.TalkGroups
         * @instance
         */
        TalkGroups.prototype.Groups = $util.emptyArray;

        /**
         * Creates a new TalkGroups instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.TalkGroups
         * @static
         * @param {mediaarchiver.ITalkGroups=} [properties] Properties to set
         * @returns {mediaarchiver.TalkGroups} TalkGroups instance
         */
        TalkGroups.create = function create(properties) {
            return new TalkGroups(properties);
        };

        /**
         * Encodes the specified TalkGroups message. Does not implicitly {@link mediaarchiver.TalkGroups.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.TalkGroups
         * @static
         * @param {mediaarchiver.ITalkGroups} message TalkGroups message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkGroups.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Groups != null && message.Groups.length)
                for (let i = 0; i < message.Groups.length; ++i)
                    $root.mediaarchiver.TalkGroup.encode(message.Groups[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified TalkGroups message, length delimited. Does not implicitly {@link mediaarchiver.TalkGroups.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.TalkGroups
         * @static
         * @param {mediaarchiver.ITalkGroups} message TalkGroups message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkGroups.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TalkGroups message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.TalkGroups
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.TalkGroups} TalkGroups
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkGroups.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.TalkGroups();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.Groups && message.Groups.length))
                        message.Groups = [];
                    message.Groups.push($root.mediaarchiver.TalkGroup.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TalkGroups message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.TalkGroups
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.TalkGroups} TalkGroups
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkGroups.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TalkGroups message.
         * @function verify
         * @memberof mediaarchiver.TalkGroups
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TalkGroups.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Groups != null && message.hasOwnProperty("Groups")) {
                if (!Array.isArray(message.Groups))
                    return "Groups: array expected";
                for (let i = 0; i < message.Groups.length; ++i) {
                    let error = $root.mediaarchiver.TalkGroup.verify(message.Groups[i]);
                    if (error)
                        return "Groups." + error;
                }
            }
            return null;
        };

        /**
         * Creates a TalkGroups message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.TalkGroups
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.TalkGroups} TalkGroups
         */
        TalkGroups.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.TalkGroups)
                return object;
            let message = new $root.mediaarchiver.TalkGroups();
            if (object.Groups) {
                if (!Array.isArray(object.Groups))
                    throw TypeError(".mediaarchiver.TalkGroups.Groups: array expected");
                message.Groups = [];
                for (let i = 0; i < object.Groups.length; ++i) {
                    if (typeof object.Groups[i] !== "object")
                        throw TypeError(".mediaarchiver.TalkGroups.Groups: object expected");
                    message.Groups[i] = $root.mediaarchiver.TalkGroup.fromObject(object.Groups[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a TalkGroups message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.TalkGroups
         * @static
         * @param {mediaarchiver.TalkGroups} message TalkGroups
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TalkGroups.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Groups = [];
            if (message.Groups && message.Groups.length) {
                object.Groups = [];
                for (let j = 0; j < message.Groups.length; ++j)
                    object.Groups[j] = $root.mediaarchiver.TalkGroup.toObject(message.Groups[j], options);
            }
            return object;
        };

        /**
         * Converts this TalkGroups to JSON.
         * @function toJSON
         * @memberof mediaarchiver.TalkGroups
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TalkGroups.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TalkGroups;
    })();

    mediaarchiver.TalkRegim = (function() {

        /**
         * Properties of a TalkRegim.
         * @memberof mediaarchiver
         * @interface ITalkRegim
         * @property {number|null} [ID] TalkRegim ID
         * @property {string|null} [Name] TalkRegim Name
         * @property {number|null} [Study] TalkRegim Study
         */

        /**
         * Constructs a new TalkRegim.
         * @memberof mediaarchiver
         * @classdesc Represents a TalkRegim.
         * @implements ITalkRegim
         * @constructor
         * @param {mediaarchiver.ITalkRegim=} [properties] Properties to set
         */
        function TalkRegim(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TalkRegim ID.
         * @member {number} ID
         * @memberof mediaarchiver.TalkRegim
         * @instance
         */
        TalkRegim.prototype.ID = 0;

        /**
         * TalkRegim Name.
         * @member {string} Name
         * @memberof mediaarchiver.TalkRegim
         * @instance
         */
        TalkRegim.prototype.Name = "";

        /**
         * TalkRegim Study.
         * @member {number} Study
         * @memberof mediaarchiver.TalkRegim
         * @instance
         */
        TalkRegim.prototype.Study = 0;

        /**
         * Creates a new TalkRegim instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.TalkRegim
         * @static
         * @param {mediaarchiver.ITalkRegim=} [properties] Properties to set
         * @returns {mediaarchiver.TalkRegim} TalkRegim instance
         */
        TalkRegim.create = function create(properties) {
            return new TalkRegim(properties);
        };

        /**
         * Encodes the specified TalkRegim message. Does not implicitly {@link mediaarchiver.TalkRegim.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.TalkRegim
         * @static
         * @param {mediaarchiver.ITalkRegim} message TalkRegim message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkRegim.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ID);
            if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
            if (message.Study != null && Object.hasOwnProperty.call(message, "Study"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.Study);
            return writer;
        };

        /**
         * Encodes the specified TalkRegim message, length delimited. Does not implicitly {@link mediaarchiver.TalkRegim.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.TalkRegim
         * @static
         * @param {mediaarchiver.ITalkRegim} message TalkRegim message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkRegim.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TalkRegim message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.TalkRegim
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.TalkRegim} TalkRegim
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkRegim.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.TalkRegim();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ID = reader.uint32();
                    break;
                case 2:
                    message.Name = reader.string();
                    break;
                case 3:
                    message.Study = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TalkRegim message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.TalkRegim
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.TalkRegim} TalkRegim
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkRegim.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TalkRegim message.
         * @function verify
         * @memberof mediaarchiver.TalkRegim
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TalkRegim.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isInteger(message.ID))
                    return "ID: integer expected";
            if (message.Name != null && message.hasOwnProperty("Name"))
                if (!$util.isString(message.Name))
                    return "Name: string expected";
            if (message.Study != null && message.hasOwnProperty("Study"))
                if (!$util.isInteger(message.Study))
                    return "Study: integer expected";
            return null;
        };

        /**
         * Creates a TalkRegim message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.TalkRegim
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.TalkRegim} TalkRegim
         */
        TalkRegim.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.TalkRegim)
                return object;
            let message = new $root.mediaarchiver.TalkRegim();
            if (object.ID != null)
                message.ID = object.ID >>> 0;
            if (object.Name != null)
                message.Name = String(object.Name);
            if (object.Study != null)
                message.Study = object.Study >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a TalkRegim message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.TalkRegim
         * @static
         * @param {mediaarchiver.TalkRegim} message TalkRegim
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TalkRegim.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.ID = 0;
                object.Name = "";
                object.Study = 0;
            }
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            if (message.Name != null && message.hasOwnProperty("Name"))
                object.Name = message.Name;
            if (message.Study != null && message.hasOwnProperty("Study"))
                object.Study = message.Study;
            return object;
        };

        /**
         * Converts this TalkRegim to JSON.
         * @function toJSON
         * @memberof mediaarchiver.TalkRegim
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TalkRegim.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TalkRegim;
    })();

    mediaarchiver.TalkRegims = (function() {

        /**
         * Properties of a TalkRegims.
         * @memberof mediaarchiver
         * @interface ITalkRegims
         * @property {Array.<mediaarchiver.ITalkRegim>|null} [Regims] TalkRegims Regims
         */

        /**
         * Constructs a new TalkRegims.
         * @memberof mediaarchiver
         * @classdesc Represents a TalkRegims.
         * @implements ITalkRegims
         * @constructor
         * @param {mediaarchiver.ITalkRegims=} [properties] Properties to set
         */
        function TalkRegims(properties) {
            this.Regims = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TalkRegims Regims.
         * @member {Array.<mediaarchiver.ITalkRegim>} Regims
         * @memberof mediaarchiver.TalkRegims
         * @instance
         */
        TalkRegims.prototype.Regims = $util.emptyArray;

        /**
         * Creates a new TalkRegims instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.TalkRegims
         * @static
         * @param {mediaarchiver.ITalkRegims=} [properties] Properties to set
         * @returns {mediaarchiver.TalkRegims} TalkRegims instance
         */
        TalkRegims.create = function create(properties) {
            return new TalkRegims(properties);
        };

        /**
         * Encodes the specified TalkRegims message. Does not implicitly {@link mediaarchiver.TalkRegims.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.TalkRegims
         * @static
         * @param {mediaarchiver.ITalkRegims} message TalkRegims message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkRegims.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Regims != null && message.Regims.length)
                for (let i = 0; i < message.Regims.length; ++i)
                    $root.mediaarchiver.TalkRegim.encode(message.Regims[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified TalkRegims message, length delimited. Does not implicitly {@link mediaarchiver.TalkRegims.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.TalkRegims
         * @static
         * @param {mediaarchiver.ITalkRegims} message TalkRegims message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkRegims.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TalkRegims message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.TalkRegims
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.TalkRegims} TalkRegims
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkRegims.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.TalkRegims();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.Regims && message.Regims.length))
                        message.Regims = [];
                    message.Regims.push($root.mediaarchiver.TalkRegim.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TalkRegims message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.TalkRegims
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.TalkRegims} TalkRegims
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkRegims.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TalkRegims message.
         * @function verify
         * @memberof mediaarchiver.TalkRegims
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TalkRegims.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Regims != null && message.hasOwnProperty("Regims")) {
                if (!Array.isArray(message.Regims))
                    return "Regims: array expected";
                for (let i = 0; i < message.Regims.length; ++i) {
                    let error = $root.mediaarchiver.TalkRegim.verify(message.Regims[i]);
                    if (error)
                        return "Regims." + error;
                }
            }
            return null;
        };

        /**
         * Creates a TalkRegims message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.TalkRegims
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.TalkRegims} TalkRegims
         */
        TalkRegims.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.TalkRegims)
                return object;
            let message = new $root.mediaarchiver.TalkRegims();
            if (object.Regims) {
                if (!Array.isArray(object.Regims))
                    throw TypeError(".mediaarchiver.TalkRegims.Regims: array expected");
                message.Regims = [];
                for (let i = 0; i < object.Regims.length; ++i) {
                    if (typeof object.Regims[i] !== "object")
                        throw TypeError(".mediaarchiver.TalkRegims.Regims: object expected");
                    message.Regims[i] = $root.mediaarchiver.TalkRegim.fromObject(object.Regims[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a TalkRegims message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.TalkRegims
         * @static
         * @param {mediaarchiver.TalkRegims} message TalkRegims
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TalkRegims.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Regims = [];
            if (message.Regims && message.Regims.length) {
                object.Regims = [];
                for (let j = 0; j < message.Regims.length; ++j)
                    object.Regims[j] = $root.mediaarchiver.TalkRegim.toObject(message.Regims[j], options);
            }
            return object;
        };

        /**
         * Converts this TalkRegims to JSON.
         * @function toJSON
         * @memberof mediaarchiver.TalkRegims
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TalkRegims.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TalkRegims;
    })();

    mediaarchiver.TalkTitle = (function() {

        /**
         * Properties of a TalkTitle.
         * @memberof mediaarchiver
         * @interface ITalkTitle
         * @property {string|null} [Title] TalkTitle Title
         * @property {number|null} [Study] TalkTitle Study
         */

        /**
         * Constructs a new TalkTitle.
         * @memberof mediaarchiver
         * @classdesc Represents a TalkTitle.
         * @implements ITalkTitle
         * @constructor
         * @param {mediaarchiver.ITalkTitle=} [properties] Properties to set
         */
        function TalkTitle(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TalkTitle Title.
         * @member {string} Title
         * @memberof mediaarchiver.TalkTitle
         * @instance
         */
        TalkTitle.prototype.Title = "";

        /**
         * TalkTitle Study.
         * @member {number} Study
         * @memberof mediaarchiver.TalkTitle
         * @instance
         */
        TalkTitle.prototype.Study = 0;

        /**
         * Creates a new TalkTitle instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.TalkTitle
         * @static
         * @param {mediaarchiver.ITalkTitle=} [properties] Properties to set
         * @returns {mediaarchiver.TalkTitle} TalkTitle instance
         */
        TalkTitle.create = function create(properties) {
            return new TalkTitle(properties);
        };

        /**
         * Encodes the specified TalkTitle message. Does not implicitly {@link mediaarchiver.TalkTitle.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.TalkTitle
         * @static
         * @param {mediaarchiver.ITalkTitle} message TalkTitle message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkTitle.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Title);
            if (message.Study != null && Object.hasOwnProperty.call(message, "Study"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Study);
            return writer;
        };

        /**
         * Encodes the specified TalkTitle message, length delimited. Does not implicitly {@link mediaarchiver.TalkTitle.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.TalkTitle
         * @static
         * @param {mediaarchiver.ITalkTitle} message TalkTitle message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkTitle.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TalkTitle message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.TalkTitle
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.TalkTitle} TalkTitle
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkTitle.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.TalkTitle();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Title = reader.string();
                    break;
                case 2:
                    message.Study = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TalkTitle message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.TalkTitle
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.TalkTitle} TalkTitle
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkTitle.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TalkTitle message.
         * @function verify
         * @memberof mediaarchiver.TalkTitle
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TalkTitle.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Title != null && message.hasOwnProperty("Title"))
                if (!$util.isString(message.Title))
                    return "Title: string expected";
            if (message.Study != null && message.hasOwnProperty("Study"))
                if (!$util.isInteger(message.Study))
                    return "Study: integer expected";
            return null;
        };

        /**
         * Creates a TalkTitle message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.TalkTitle
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.TalkTitle} TalkTitle
         */
        TalkTitle.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.TalkTitle)
                return object;
            let message = new $root.mediaarchiver.TalkTitle();
            if (object.Title != null)
                message.Title = String(object.Title);
            if (object.Study != null)
                message.Study = object.Study >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a TalkTitle message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.TalkTitle
         * @static
         * @param {mediaarchiver.TalkTitle} message TalkTitle
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TalkTitle.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.Title = "";
                object.Study = 0;
            }
            if (message.Title != null && message.hasOwnProperty("Title"))
                object.Title = message.Title;
            if (message.Study != null && message.hasOwnProperty("Study"))
                object.Study = message.Study;
            return object;
        };

        /**
         * Converts this TalkTitle to JSON.
         * @function toJSON
         * @memberof mediaarchiver.TalkTitle
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TalkTitle.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TalkTitle;
    })();

    mediaarchiver.TalkTitles = (function() {

        /**
         * Properties of a TalkTitles.
         * @memberof mediaarchiver
         * @interface ITalkTitles
         * @property {Array.<mediaarchiver.ITalkTitle>|null} [Titles] TalkTitles Titles
         */

        /**
         * Constructs a new TalkTitles.
         * @memberof mediaarchiver
         * @classdesc Represents a TalkTitles.
         * @implements ITalkTitles
         * @constructor
         * @param {mediaarchiver.ITalkTitles=} [properties] Properties to set
         */
        function TalkTitles(properties) {
            this.Titles = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TalkTitles Titles.
         * @member {Array.<mediaarchiver.ITalkTitle>} Titles
         * @memberof mediaarchiver.TalkTitles
         * @instance
         */
        TalkTitles.prototype.Titles = $util.emptyArray;

        /**
         * Creates a new TalkTitles instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.TalkTitles
         * @static
         * @param {mediaarchiver.ITalkTitles=} [properties] Properties to set
         * @returns {mediaarchiver.TalkTitles} TalkTitles instance
         */
        TalkTitles.create = function create(properties) {
            return new TalkTitles(properties);
        };

        /**
         * Encodes the specified TalkTitles message. Does not implicitly {@link mediaarchiver.TalkTitles.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.TalkTitles
         * @static
         * @param {mediaarchiver.ITalkTitles} message TalkTitles message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkTitles.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Titles != null && message.Titles.length)
                for (let i = 0; i < message.Titles.length; ++i)
                    $root.mediaarchiver.TalkTitle.encode(message.Titles[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified TalkTitles message, length delimited. Does not implicitly {@link mediaarchiver.TalkTitles.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.TalkTitles
         * @static
         * @param {mediaarchiver.ITalkTitles} message TalkTitles message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkTitles.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TalkTitles message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.TalkTitles
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.TalkTitles} TalkTitles
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkTitles.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.TalkTitles();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.Titles && message.Titles.length))
                        message.Titles = [];
                    message.Titles.push($root.mediaarchiver.TalkTitle.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TalkTitles message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.TalkTitles
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.TalkTitles} TalkTitles
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkTitles.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TalkTitles message.
         * @function verify
         * @memberof mediaarchiver.TalkTitles
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TalkTitles.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Titles != null && message.hasOwnProperty("Titles")) {
                if (!Array.isArray(message.Titles))
                    return "Titles: array expected";
                for (let i = 0; i < message.Titles.length; ++i) {
                    let error = $root.mediaarchiver.TalkTitle.verify(message.Titles[i]);
                    if (error)
                        return "Titles." + error;
                }
            }
            return null;
        };

        /**
         * Creates a TalkTitles message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.TalkTitles
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.TalkTitles} TalkTitles
         */
        TalkTitles.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.TalkTitles)
                return object;
            let message = new $root.mediaarchiver.TalkTitles();
            if (object.Titles) {
                if (!Array.isArray(object.Titles))
                    throw TypeError(".mediaarchiver.TalkTitles.Titles: array expected");
                message.Titles = [];
                for (let i = 0; i < object.Titles.length; ++i) {
                    if (typeof object.Titles[i] !== "object")
                        throw TypeError(".mediaarchiver.TalkTitles.Titles: object expected");
                    message.Titles[i] = $root.mediaarchiver.TalkTitle.fromObject(object.Titles[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a TalkTitles message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.TalkTitles
         * @static
         * @param {mediaarchiver.TalkTitles} message TalkTitles
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TalkTitles.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Titles = [];
            if (message.Titles && message.Titles.length) {
                object.Titles = [];
                for (let j = 0; j < message.Titles.length; ++j)
                    object.Titles[j] = $root.mediaarchiver.TalkTitle.toObject(message.Titles[j], options);
            }
            return object;
        };

        /**
         * Converts this TalkTitles to JSON.
         * @function toJSON
         * @memberof mediaarchiver.TalkTitles
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TalkTitles.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TalkTitles;
    })();

    mediaarchiver.TalkPersonSugg = (function() {

        /**
         * Properties of a TalkPersonSugg.
         * @memberof mediaarchiver
         * @interface ITalkPersonSugg
         * @property {string|null} [ID] TalkPersonSugg ID
         * @property {string|null} [Name] TalkPersonSugg Name
         * @property {number|null} [Start] TalkPersonSugg Start
         * @property {number|null} [End] TalkPersonSugg End
         */

        /**
         * Constructs a new TalkPersonSugg.
         * @memberof mediaarchiver
         * @classdesc Represents a TalkPersonSugg.
         * @implements ITalkPersonSugg
         * @constructor
         * @param {mediaarchiver.ITalkPersonSugg=} [properties] Properties to set
         */
        function TalkPersonSugg(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TalkPersonSugg ID.
         * @member {string} ID
         * @memberof mediaarchiver.TalkPersonSugg
         * @instance
         */
        TalkPersonSugg.prototype.ID = "";

        /**
         * TalkPersonSugg Name.
         * @member {string} Name
         * @memberof mediaarchiver.TalkPersonSugg
         * @instance
         */
        TalkPersonSugg.prototype.Name = "";

        /**
         * TalkPersonSugg Start.
         * @member {number} Start
         * @memberof mediaarchiver.TalkPersonSugg
         * @instance
         */
        TalkPersonSugg.prototype.Start = 0;

        /**
         * TalkPersonSugg End.
         * @member {number} End
         * @memberof mediaarchiver.TalkPersonSugg
         * @instance
         */
        TalkPersonSugg.prototype.End = 0;

        /**
         * Creates a new TalkPersonSugg instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.TalkPersonSugg
         * @static
         * @param {mediaarchiver.ITalkPersonSugg=} [properties] Properties to set
         * @returns {mediaarchiver.TalkPersonSugg} TalkPersonSugg instance
         */
        TalkPersonSugg.create = function create(properties) {
            return new TalkPersonSugg(properties);
        };

        /**
         * Encodes the specified TalkPersonSugg message. Does not implicitly {@link mediaarchiver.TalkPersonSugg.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.TalkPersonSugg
         * @static
         * @param {mediaarchiver.ITalkPersonSugg} message TalkPersonSugg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkPersonSugg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.ID);
            if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.Name);
            if (message.Start != null && Object.hasOwnProperty.call(message, "Start"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.Start);
            if (message.End != null && Object.hasOwnProperty.call(message, "End"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.End);
            return writer;
        };

        /**
         * Encodes the specified TalkPersonSugg message, length delimited. Does not implicitly {@link mediaarchiver.TalkPersonSugg.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.TalkPersonSugg
         * @static
         * @param {mediaarchiver.ITalkPersonSugg} message TalkPersonSugg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkPersonSugg.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TalkPersonSugg message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.TalkPersonSugg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.TalkPersonSugg} TalkPersonSugg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkPersonSugg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.TalkPersonSugg();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ID = reader.string();
                    break;
                case 3:
                    message.Name = reader.string();
                    break;
                case 4:
                    message.Start = reader.uint32();
                    break;
                case 5:
                    message.End = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TalkPersonSugg message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.TalkPersonSugg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.TalkPersonSugg} TalkPersonSugg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkPersonSugg.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TalkPersonSugg message.
         * @function verify
         * @memberof mediaarchiver.TalkPersonSugg
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TalkPersonSugg.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isString(message.ID))
                    return "ID: string expected";
            if (message.Name != null && message.hasOwnProperty("Name"))
                if (!$util.isString(message.Name))
                    return "Name: string expected";
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (!$util.isInteger(message.Start))
                    return "Start: integer expected";
            if (message.End != null && message.hasOwnProperty("End"))
                if (!$util.isInteger(message.End))
                    return "End: integer expected";
            return null;
        };

        /**
         * Creates a TalkPersonSugg message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.TalkPersonSugg
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.TalkPersonSugg} TalkPersonSugg
         */
        TalkPersonSugg.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.TalkPersonSugg)
                return object;
            let message = new $root.mediaarchiver.TalkPersonSugg();
            if (object.ID != null)
                message.ID = String(object.ID);
            if (object.Name != null)
                message.Name = String(object.Name);
            if (object.Start != null)
                message.Start = object.Start >>> 0;
            if (object.End != null)
                message.End = object.End >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a TalkPersonSugg message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.TalkPersonSugg
         * @static
         * @param {mediaarchiver.TalkPersonSugg} message TalkPersonSugg
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TalkPersonSugg.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.ID = "";
                object.Name = "";
                object.Start = 0;
                object.End = 0;
            }
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            if (message.Name != null && message.hasOwnProperty("Name"))
                object.Name = message.Name;
            if (message.Start != null && message.hasOwnProperty("Start"))
                object.Start = message.Start;
            if (message.End != null && message.hasOwnProperty("End"))
                object.End = message.End;
            return object;
        };

        /**
         * Converts this TalkPersonSugg to JSON.
         * @function toJSON
         * @memberof mediaarchiver.TalkPersonSugg
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TalkPersonSugg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TalkPersonSugg;
    })();

    mediaarchiver.TalkPersonSuggs = (function() {

        /**
         * Properties of a TalkPersonSuggs.
         * @memberof mediaarchiver
         * @interface ITalkPersonSuggs
         * @property {Array.<mediaarchiver.ITalkPersonSugg>|null} [Suggs] TalkPersonSuggs Suggs
         */

        /**
         * Constructs a new TalkPersonSuggs.
         * @memberof mediaarchiver
         * @classdesc Represents a TalkPersonSuggs.
         * @implements ITalkPersonSuggs
         * @constructor
         * @param {mediaarchiver.ITalkPersonSuggs=} [properties] Properties to set
         */
        function TalkPersonSuggs(properties) {
            this.Suggs = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TalkPersonSuggs Suggs.
         * @member {Array.<mediaarchiver.ITalkPersonSugg>} Suggs
         * @memberof mediaarchiver.TalkPersonSuggs
         * @instance
         */
        TalkPersonSuggs.prototype.Suggs = $util.emptyArray;

        /**
         * Creates a new TalkPersonSuggs instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.TalkPersonSuggs
         * @static
         * @param {mediaarchiver.ITalkPersonSuggs=} [properties] Properties to set
         * @returns {mediaarchiver.TalkPersonSuggs} TalkPersonSuggs instance
         */
        TalkPersonSuggs.create = function create(properties) {
            return new TalkPersonSuggs(properties);
        };

        /**
         * Encodes the specified TalkPersonSuggs message. Does not implicitly {@link mediaarchiver.TalkPersonSuggs.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.TalkPersonSuggs
         * @static
         * @param {mediaarchiver.ITalkPersonSuggs} message TalkPersonSuggs message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkPersonSuggs.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Suggs != null && message.Suggs.length)
                for (let i = 0; i < message.Suggs.length; ++i)
                    $root.mediaarchiver.TalkPersonSugg.encode(message.Suggs[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified TalkPersonSuggs message, length delimited. Does not implicitly {@link mediaarchiver.TalkPersonSuggs.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.TalkPersonSuggs
         * @static
         * @param {mediaarchiver.ITalkPersonSuggs} message TalkPersonSuggs message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkPersonSuggs.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TalkPersonSuggs message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.TalkPersonSuggs
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.TalkPersonSuggs} TalkPersonSuggs
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkPersonSuggs.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.TalkPersonSuggs();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.Suggs && message.Suggs.length))
                        message.Suggs = [];
                    message.Suggs.push($root.mediaarchiver.TalkPersonSugg.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TalkPersonSuggs message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.TalkPersonSuggs
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.TalkPersonSuggs} TalkPersonSuggs
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkPersonSuggs.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TalkPersonSuggs message.
         * @function verify
         * @memberof mediaarchiver.TalkPersonSuggs
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TalkPersonSuggs.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Suggs != null && message.hasOwnProperty("Suggs")) {
                if (!Array.isArray(message.Suggs))
                    return "Suggs: array expected";
                for (let i = 0; i < message.Suggs.length; ++i) {
                    let error = $root.mediaarchiver.TalkPersonSugg.verify(message.Suggs[i]);
                    if (error)
                        return "Suggs." + error;
                }
            }
            return null;
        };

        /**
         * Creates a TalkPersonSuggs message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.TalkPersonSuggs
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.TalkPersonSuggs} TalkPersonSuggs
         */
        TalkPersonSuggs.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.TalkPersonSuggs)
                return object;
            let message = new $root.mediaarchiver.TalkPersonSuggs();
            if (object.Suggs) {
                if (!Array.isArray(object.Suggs))
                    throw TypeError(".mediaarchiver.TalkPersonSuggs.Suggs: array expected");
                message.Suggs = [];
                for (let i = 0; i < object.Suggs.length; ++i) {
                    if (typeof object.Suggs[i] !== "object")
                        throw TypeError(".mediaarchiver.TalkPersonSuggs.Suggs: object expected");
                    message.Suggs[i] = $root.mediaarchiver.TalkPersonSugg.fromObject(object.Suggs[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a TalkPersonSuggs message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.TalkPersonSuggs
         * @static
         * @param {mediaarchiver.TalkPersonSuggs} message TalkPersonSuggs
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TalkPersonSuggs.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Suggs = [];
            if (message.Suggs && message.Suggs.length) {
                object.Suggs = [];
                for (let j = 0; j < message.Suggs.length; ++j)
                    object.Suggs[j] = $root.mediaarchiver.TalkPersonSugg.toObject(message.Suggs[j], options);
            }
            return object;
        };

        /**
         * Converts this TalkPersonSuggs to JSON.
         * @function toJSON
         * @memberof mediaarchiver.TalkPersonSuggs
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TalkPersonSuggs.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TalkPersonSuggs;
    })();

    mediaarchiver.TalkPersonSpecifications = (function() {

        /**
         * Properties of a TalkPersonSpecifications.
         * @memberof mediaarchiver
         * @interface ITalkPersonSpecifications
         * @property {mediaarchiver.ITalkGroup|null} [Group] TalkPersonSpecifications Group
         * @property {mediaarchiver.ITalkTitle|null} [Title] TalkPersonSpecifications Title
         * @property {mediaarchiver.ITalkRegim|null} [Regim] TalkPersonSpecifications Regim
         * @property {number|null} [Start] TalkPersonSpecifications Start
         * @property {number|null} [End] TalkPersonSpecifications End
         * @property {number|null} [Study] TalkPersonSpecifications Study
         */

        /**
         * Constructs a new TalkPersonSpecifications.
         * @memberof mediaarchiver
         * @classdesc Represents a TalkPersonSpecifications.
         * @implements ITalkPersonSpecifications
         * @constructor
         * @param {mediaarchiver.ITalkPersonSpecifications=} [properties] Properties to set
         */
        function TalkPersonSpecifications(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TalkPersonSpecifications Group.
         * @member {mediaarchiver.ITalkGroup|null|undefined} Group
         * @memberof mediaarchiver.TalkPersonSpecifications
         * @instance
         */
        TalkPersonSpecifications.prototype.Group = null;

        /**
         * TalkPersonSpecifications Title.
         * @member {mediaarchiver.ITalkTitle|null|undefined} Title
         * @memberof mediaarchiver.TalkPersonSpecifications
         * @instance
         */
        TalkPersonSpecifications.prototype.Title = null;

        /**
         * TalkPersonSpecifications Regim.
         * @member {mediaarchiver.ITalkRegim|null|undefined} Regim
         * @memberof mediaarchiver.TalkPersonSpecifications
         * @instance
         */
        TalkPersonSpecifications.prototype.Regim = null;

        /**
         * TalkPersonSpecifications Start.
         * @member {number} Start
         * @memberof mediaarchiver.TalkPersonSpecifications
         * @instance
         */
        TalkPersonSpecifications.prototype.Start = 0;

        /**
         * TalkPersonSpecifications End.
         * @member {number} End
         * @memberof mediaarchiver.TalkPersonSpecifications
         * @instance
         */
        TalkPersonSpecifications.prototype.End = 0;

        /**
         * TalkPersonSpecifications Study.
         * @member {number} Study
         * @memberof mediaarchiver.TalkPersonSpecifications
         * @instance
         */
        TalkPersonSpecifications.prototype.Study = 0;

        /**
         * Creates a new TalkPersonSpecifications instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.TalkPersonSpecifications
         * @static
         * @param {mediaarchiver.ITalkPersonSpecifications=} [properties] Properties to set
         * @returns {mediaarchiver.TalkPersonSpecifications} TalkPersonSpecifications instance
         */
        TalkPersonSpecifications.create = function create(properties) {
            return new TalkPersonSpecifications(properties);
        };

        /**
         * Encodes the specified TalkPersonSpecifications message. Does not implicitly {@link mediaarchiver.TalkPersonSpecifications.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.TalkPersonSpecifications
         * @static
         * @param {mediaarchiver.ITalkPersonSpecifications} message TalkPersonSpecifications message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkPersonSpecifications.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Group != null && Object.hasOwnProperty.call(message, "Group"))
                $root.mediaarchiver.TalkGroup.encode(message.Group, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                $root.mediaarchiver.TalkTitle.encode(message.Title, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.Regim != null && Object.hasOwnProperty.call(message, "Regim"))
                $root.mediaarchiver.TalkRegim.encode(message.Regim, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.Start != null && Object.hasOwnProperty.call(message, "Start"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.Start);
            if (message.End != null && Object.hasOwnProperty.call(message, "End"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.End);
            if (message.Study != null && Object.hasOwnProperty.call(message, "Study"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.Study);
            return writer;
        };

        /**
         * Encodes the specified TalkPersonSpecifications message, length delimited. Does not implicitly {@link mediaarchiver.TalkPersonSpecifications.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.TalkPersonSpecifications
         * @static
         * @param {mediaarchiver.ITalkPersonSpecifications} message TalkPersonSpecifications message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkPersonSpecifications.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TalkPersonSpecifications message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.TalkPersonSpecifications
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.TalkPersonSpecifications} TalkPersonSpecifications
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkPersonSpecifications.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.TalkPersonSpecifications();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Group = $root.mediaarchiver.TalkGroup.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.Title = $root.mediaarchiver.TalkTitle.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.Regim = $root.mediaarchiver.TalkRegim.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.Start = reader.uint32();
                    break;
                case 5:
                    message.End = reader.uint32();
                    break;
                case 6:
                    message.Study = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TalkPersonSpecifications message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.TalkPersonSpecifications
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.TalkPersonSpecifications} TalkPersonSpecifications
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkPersonSpecifications.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TalkPersonSpecifications message.
         * @function verify
         * @memberof mediaarchiver.TalkPersonSpecifications
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TalkPersonSpecifications.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Group != null && message.hasOwnProperty("Group")) {
                let error = $root.mediaarchiver.TalkGroup.verify(message.Group);
                if (error)
                    return "Group." + error;
            }
            if (message.Title != null && message.hasOwnProperty("Title")) {
                let error = $root.mediaarchiver.TalkTitle.verify(message.Title);
                if (error)
                    return "Title." + error;
            }
            if (message.Regim != null && message.hasOwnProperty("Regim")) {
                let error = $root.mediaarchiver.TalkRegim.verify(message.Regim);
                if (error)
                    return "Regim." + error;
            }
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (!$util.isInteger(message.Start))
                    return "Start: integer expected";
            if (message.End != null && message.hasOwnProperty("End"))
                if (!$util.isInteger(message.End))
                    return "End: integer expected";
            if (message.Study != null && message.hasOwnProperty("Study"))
                if (!$util.isInteger(message.Study))
                    return "Study: integer expected";
            return null;
        };

        /**
         * Creates a TalkPersonSpecifications message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.TalkPersonSpecifications
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.TalkPersonSpecifications} TalkPersonSpecifications
         */
        TalkPersonSpecifications.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.TalkPersonSpecifications)
                return object;
            let message = new $root.mediaarchiver.TalkPersonSpecifications();
            if (object.Group != null) {
                if (typeof object.Group !== "object")
                    throw TypeError(".mediaarchiver.TalkPersonSpecifications.Group: object expected");
                message.Group = $root.mediaarchiver.TalkGroup.fromObject(object.Group);
            }
            if (object.Title != null) {
                if (typeof object.Title !== "object")
                    throw TypeError(".mediaarchiver.TalkPersonSpecifications.Title: object expected");
                message.Title = $root.mediaarchiver.TalkTitle.fromObject(object.Title);
            }
            if (object.Regim != null) {
                if (typeof object.Regim !== "object")
                    throw TypeError(".mediaarchiver.TalkPersonSpecifications.Regim: object expected");
                message.Regim = $root.mediaarchiver.TalkRegim.fromObject(object.Regim);
            }
            if (object.Start != null)
                message.Start = object.Start >>> 0;
            if (object.End != null)
                message.End = object.End >>> 0;
            if (object.Study != null)
                message.Study = object.Study >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a TalkPersonSpecifications message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.TalkPersonSpecifications
         * @static
         * @param {mediaarchiver.TalkPersonSpecifications} message TalkPersonSpecifications
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TalkPersonSpecifications.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.Group = null;
                object.Title = null;
                object.Regim = null;
                object.Start = 0;
                object.End = 0;
                object.Study = 0;
            }
            if (message.Group != null && message.hasOwnProperty("Group"))
                object.Group = $root.mediaarchiver.TalkGroup.toObject(message.Group, options);
            if (message.Title != null && message.hasOwnProperty("Title"))
                object.Title = $root.mediaarchiver.TalkTitle.toObject(message.Title, options);
            if (message.Regim != null && message.hasOwnProperty("Regim"))
                object.Regim = $root.mediaarchiver.TalkRegim.toObject(message.Regim, options);
            if (message.Start != null && message.hasOwnProperty("Start"))
                object.Start = message.Start;
            if (message.End != null && message.hasOwnProperty("End"))
                object.End = message.End;
            if (message.Study != null && message.hasOwnProperty("Study"))
                object.Study = message.Study;
            return object;
        };

        /**
         * Converts this TalkPersonSpecifications to JSON.
         * @function toJSON
         * @memberof mediaarchiver.TalkPersonSpecifications
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TalkPersonSpecifications.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TalkPersonSpecifications;
    })();

    mediaarchiver.TalkPerson = (function() {

        /**
         * Properties of a TalkPerson.
         * @memberof mediaarchiver
         * @interface ITalkPerson
         * @property {string|null} [ID] TalkPerson ID
         * @property {string|null} [Name] TalkPerson Name
         * @property {number|null} [Gender] TalkPerson Gender
         * @property {Array.<mediaarchiver.ITalkPersonSpecifications>|null} [Specifications] TalkPerson Specifications
         */

        /**
         * Constructs a new TalkPerson.
         * @memberof mediaarchiver
         * @classdesc Represents a TalkPerson.
         * @implements ITalkPerson
         * @constructor
         * @param {mediaarchiver.ITalkPerson=} [properties] Properties to set
         */
        function TalkPerson(properties) {
            this.Specifications = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TalkPerson ID.
         * @member {string} ID
         * @memberof mediaarchiver.TalkPerson
         * @instance
         */
        TalkPerson.prototype.ID = "";

        /**
         * TalkPerson Name.
         * @member {string} Name
         * @memberof mediaarchiver.TalkPerson
         * @instance
         */
        TalkPerson.prototype.Name = "";

        /**
         * TalkPerson Gender.
         * @member {number} Gender
         * @memberof mediaarchiver.TalkPerson
         * @instance
         */
        TalkPerson.prototype.Gender = 0;

        /**
         * TalkPerson Specifications.
         * @member {Array.<mediaarchiver.ITalkPersonSpecifications>} Specifications
         * @memberof mediaarchiver.TalkPerson
         * @instance
         */
        TalkPerson.prototype.Specifications = $util.emptyArray;

        /**
         * Creates a new TalkPerson instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.TalkPerson
         * @static
         * @param {mediaarchiver.ITalkPerson=} [properties] Properties to set
         * @returns {mediaarchiver.TalkPerson} TalkPerson instance
         */
        TalkPerson.create = function create(properties) {
            return new TalkPerson(properties);
        };

        /**
         * Encodes the specified TalkPerson message. Does not implicitly {@link mediaarchiver.TalkPerson.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.TalkPerson
         * @static
         * @param {mediaarchiver.ITalkPerson} message TalkPerson message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkPerson.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.ID);
            if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
            if (message.Gender != null && Object.hasOwnProperty.call(message, "Gender"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.Gender);
            if (message.Specifications != null && message.Specifications.length)
                for (let i = 0; i < message.Specifications.length; ++i)
                    $root.mediaarchiver.TalkPersonSpecifications.encode(message.Specifications[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified TalkPerson message, length delimited. Does not implicitly {@link mediaarchiver.TalkPerson.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.TalkPerson
         * @static
         * @param {mediaarchiver.ITalkPerson} message TalkPerson message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkPerson.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TalkPerson message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.TalkPerson
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.TalkPerson} TalkPerson
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkPerson.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.TalkPerson();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ID = reader.string();
                    break;
                case 2:
                    message.Name = reader.string();
                    break;
                case 3:
                    message.Gender = reader.uint32();
                    break;
                case 4:
                    if (!(message.Specifications && message.Specifications.length))
                        message.Specifications = [];
                    message.Specifications.push($root.mediaarchiver.TalkPersonSpecifications.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TalkPerson message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.TalkPerson
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.TalkPerson} TalkPerson
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkPerson.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TalkPerson message.
         * @function verify
         * @memberof mediaarchiver.TalkPerson
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TalkPerson.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isString(message.ID))
                    return "ID: string expected";
            if (message.Name != null && message.hasOwnProperty("Name"))
                if (!$util.isString(message.Name))
                    return "Name: string expected";
            if (message.Gender != null && message.hasOwnProperty("Gender"))
                if (!$util.isInteger(message.Gender))
                    return "Gender: integer expected";
            if (message.Specifications != null && message.hasOwnProperty("Specifications")) {
                if (!Array.isArray(message.Specifications))
                    return "Specifications: array expected";
                for (let i = 0; i < message.Specifications.length; ++i) {
                    let error = $root.mediaarchiver.TalkPersonSpecifications.verify(message.Specifications[i]);
                    if (error)
                        return "Specifications." + error;
                }
            }
            return null;
        };

        /**
         * Creates a TalkPerson message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.TalkPerson
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.TalkPerson} TalkPerson
         */
        TalkPerson.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.TalkPerson)
                return object;
            let message = new $root.mediaarchiver.TalkPerson();
            if (object.ID != null)
                message.ID = String(object.ID);
            if (object.Name != null)
                message.Name = String(object.Name);
            if (object.Gender != null)
                message.Gender = object.Gender >>> 0;
            if (object.Specifications) {
                if (!Array.isArray(object.Specifications))
                    throw TypeError(".mediaarchiver.TalkPerson.Specifications: array expected");
                message.Specifications = [];
                for (let i = 0; i < object.Specifications.length; ++i) {
                    if (typeof object.Specifications[i] !== "object")
                        throw TypeError(".mediaarchiver.TalkPerson.Specifications: object expected");
                    message.Specifications[i] = $root.mediaarchiver.TalkPersonSpecifications.fromObject(object.Specifications[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a TalkPerson message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.TalkPerson
         * @static
         * @param {mediaarchiver.TalkPerson} message TalkPerson
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TalkPerson.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Specifications = [];
            if (options.defaults) {
                object.ID = "";
                object.Name = "";
                object.Gender = 0;
            }
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            if (message.Name != null && message.hasOwnProperty("Name"))
                object.Name = message.Name;
            if (message.Gender != null && message.hasOwnProperty("Gender"))
                object.Gender = message.Gender;
            if (message.Specifications && message.Specifications.length) {
                object.Specifications = [];
                for (let j = 0; j < message.Specifications.length; ++j)
                    object.Specifications[j] = $root.mediaarchiver.TalkPersonSpecifications.toObject(message.Specifications[j], options);
            }
            return object;
        };

        /**
         * Converts this TalkPerson to JSON.
         * @function toJSON
         * @memberof mediaarchiver.TalkPerson
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TalkPerson.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TalkPerson;
    })();

    mediaarchiver.TalkStudy = (function() {

        /**
         * Properties of a TalkStudy.
         * @memberof mediaarchiver
         * @interface ITalkStudy
         * @property {number|null} [ID] TalkStudy ID
         * @property {string|null} [Name] TalkStudy Name
         * @property {mediaarchiver.TalkStudyType|null} [Type] TalkStudy Type
         * @property {number|null} [Start] TalkStudy Start
         * @property {number|null} [End] TalkStudy End
         * @property {boolean|null} [HasDistricts] TalkStudy HasDistricts
         * @property {string|null} [Code] TalkStudy Code
         */

        /**
         * Constructs a new TalkStudy.
         * @memberof mediaarchiver
         * @classdesc Represents a TalkStudy.
         * @implements ITalkStudy
         * @constructor
         * @param {mediaarchiver.ITalkStudy=} [properties] Properties to set
         */
        function TalkStudy(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TalkStudy ID.
         * @member {number} ID
         * @memberof mediaarchiver.TalkStudy
         * @instance
         */
        TalkStudy.prototype.ID = 0;

        /**
         * TalkStudy Name.
         * @member {string} Name
         * @memberof mediaarchiver.TalkStudy
         * @instance
         */
        TalkStudy.prototype.Name = "";

        /**
         * TalkStudy Type.
         * @member {mediaarchiver.TalkStudyType} Type
         * @memberof mediaarchiver.TalkStudy
         * @instance
         */
        TalkStudy.prototype.Type = 0;

        /**
         * TalkStudy Start.
         * @member {number} Start
         * @memberof mediaarchiver.TalkStudy
         * @instance
         */
        TalkStudy.prototype.Start = 0;

        /**
         * TalkStudy End.
         * @member {number} End
         * @memberof mediaarchiver.TalkStudy
         * @instance
         */
        TalkStudy.prototype.End = 0;

        /**
         * TalkStudy HasDistricts.
         * @member {boolean} HasDistricts
         * @memberof mediaarchiver.TalkStudy
         * @instance
         */
        TalkStudy.prototype.HasDistricts = false;

        /**
         * TalkStudy Code.
         * @member {string} Code
         * @memberof mediaarchiver.TalkStudy
         * @instance
         */
        TalkStudy.prototype.Code = "";

        /**
         * Creates a new TalkStudy instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.TalkStudy
         * @static
         * @param {mediaarchiver.ITalkStudy=} [properties] Properties to set
         * @returns {mediaarchiver.TalkStudy} TalkStudy instance
         */
        TalkStudy.create = function create(properties) {
            return new TalkStudy(properties);
        };

        /**
         * Encodes the specified TalkStudy message. Does not implicitly {@link mediaarchiver.TalkStudy.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.TalkStudy
         * @static
         * @param {mediaarchiver.ITalkStudy} message TalkStudy message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkStudy.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ID);
            if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
            if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.Type);
            if (message.Start != null && Object.hasOwnProperty.call(message, "Start"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.Start);
            if (message.End != null && Object.hasOwnProperty.call(message, "End"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.End);
            if (message.HasDistricts != null && Object.hasOwnProperty.call(message, "HasDistricts"))
                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.HasDistricts);
            if (message.Code != null && Object.hasOwnProperty.call(message, "Code"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.Code);
            return writer;
        };

        /**
         * Encodes the specified TalkStudy message, length delimited. Does not implicitly {@link mediaarchiver.TalkStudy.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.TalkStudy
         * @static
         * @param {mediaarchiver.ITalkStudy} message TalkStudy message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkStudy.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TalkStudy message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.TalkStudy
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.TalkStudy} TalkStudy
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkStudy.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.TalkStudy();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ID = reader.uint32();
                    break;
                case 2:
                    message.Name = reader.string();
                    break;
                case 3:
                    message.Type = reader.int32();
                    break;
                case 4:
                    message.Start = reader.uint32();
                    break;
                case 5:
                    message.End = reader.uint32();
                    break;
                case 6:
                    message.HasDistricts = reader.bool();
                    break;
                case 7:
                    message.Code = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TalkStudy message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.TalkStudy
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.TalkStudy} TalkStudy
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkStudy.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TalkStudy message.
         * @function verify
         * @memberof mediaarchiver.TalkStudy
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TalkStudy.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isInteger(message.ID))
                    return "ID: integer expected";
            if (message.Name != null && message.hasOwnProperty("Name"))
                if (!$util.isString(message.Name))
                    return "Name: string expected";
            if (message.Type != null && message.hasOwnProperty("Type"))
                switch (message.Type) {
                default:
                    return "Type: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (!$util.isInteger(message.Start))
                    return "Start: integer expected";
            if (message.End != null && message.hasOwnProperty("End"))
                if (!$util.isInteger(message.End))
                    return "End: integer expected";
            if (message.HasDistricts != null && message.hasOwnProperty("HasDistricts"))
                if (typeof message.HasDistricts !== "boolean")
                    return "HasDistricts: boolean expected";
            if (message.Code != null && message.hasOwnProperty("Code"))
                if (!$util.isString(message.Code))
                    return "Code: string expected";
            return null;
        };

        /**
         * Creates a TalkStudy message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.TalkStudy
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.TalkStudy} TalkStudy
         */
        TalkStudy.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.TalkStudy)
                return object;
            let message = new $root.mediaarchiver.TalkStudy();
            if (object.ID != null)
                message.ID = object.ID >>> 0;
            if (object.Name != null)
                message.Name = String(object.Name);
            switch (object.Type) {
            case "TALK_TYPE_UNKNOWN":
            case 0:
                message.Type = 0;
                break;
            case "TALK_TYPE_PLURALISM":
            case 1:
                message.Type = 1;
                break;
            case "TALK_TYPE_ELECTION":
            case 2:
                message.Type = 2;
                break;
            }
            if (object.Start != null)
                message.Start = object.Start >>> 0;
            if (object.End != null)
                message.End = object.End >>> 0;
            if (object.HasDistricts != null)
                message.HasDistricts = Boolean(object.HasDistricts);
            if (object.Code != null)
                message.Code = String(object.Code);
            return message;
        };

        /**
         * Creates a plain object from a TalkStudy message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.TalkStudy
         * @static
         * @param {mediaarchiver.TalkStudy} message TalkStudy
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TalkStudy.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.ID = 0;
                object.Name = "";
                object.Type = options.enums === String ? "TALK_TYPE_UNKNOWN" : 0;
                object.Start = 0;
                object.End = 0;
                object.HasDistricts = false;
                object.Code = "";
            }
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            if (message.Name != null && message.hasOwnProperty("Name"))
                object.Name = message.Name;
            if (message.Type != null && message.hasOwnProperty("Type"))
                object.Type = options.enums === String ? $root.mediaarchiver.TalkStudyType[message.Type] : message.Type;
            if (message.Start != null && message.hasOwnProperty("Start"))
                object.Start = message.Start;
            if (message.End != null && message.hasOwnProperty("End"))
                object.End = message.End;
            if (message.HasDistricts != null && message.hasOwnProperty("HasDistricts"))
                object.HasDistricts = message.HasDistricts;
            if (message.Code != null && message.hasOwnProperty("Code"))
                object.Code = message.Code;
            return object;
        };

        /**
         * Converts this TalkStudy to JSON.
         * @function toJSON
         * @memberof mediaarchiver.TalkStudy
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TalkStudy.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TalkStudy;
    })();

    mediaarchiver.TalkStudies = (function() {

        /**
         * Properties of a TalkStudies.
         * @memberof mediaarchiver
         * @interface ITalkStudies
         * @property {Array.<mediaarchiver.ITalkStudy>|null} [Studies] TalkStudies Studies
         */

        /**
         * Constructs a new TalkStudies.
         * @memberof mediaarchiver
         * @classdesc Represents a TalkStudies.
         * @implements ITalkStudies
         * @constructor
         * @param {mediaarchiver.ITalkStudies=} [properties] Properties to set
         */
        function TalkStudies(properties) {
            this.Studies = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TalkStudies Studies.
         * @member {Array.<mediaarchiver.ITalkStudy>} Studies
         * @memberof mediaarchiver.TalkStudies
         * @instance
         */
        TalkStudies.prototype.Studies = $util.emptyArray;

        /**
         * Creates a new TalkStudies instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.TalkStudies
         * @static
         * @param {mediaarchiver.ITalkStudies=} [properties] Properties to set
         * @returns {mediaarchiver.TalkStudies} TalkStudies instance
         */
        TalkStudies.create = function create(properties) {
            return new TalkStudies(properties);
        };

        /**
         * Encodes the specified TalkStudies message. Does not implicitly {@link mediaarchiver.TalkStudies.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.TalkStudies
         * @static
         * @param {mediaarchiver.ITalkStudies} message TalkStudies message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkStudies.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Studies != null && message.Studies.length)
                for (let i = 0; i < message.Studies.length; ++i)
                    $root.mediaarchiver.TalkStudy.encode(message.Studies[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified TalkStudies message, length delimited. Does not implicitly {@link mediaarchiver.TalkStudies.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.TalkStudies
         * @static
         * @param {mediaarchiver.ITalkStudies} message TalkStudies message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkStudies.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TalkStudies message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.TalkStudies
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.TalkStudies} TalkStudies
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkStudies.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.TalkStudies();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.Studies && message.Studies.length))
                        message.Studies = [];
                    message.Studies.push($root.mediaarchiver.TalkStudy.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TalkStudies message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.TalkStudies
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.TalkStudies} TalkStudies
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkStudies.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TalkStudies message.
         * @function verify
         * @memberof mediaarchiver.TalkStudies
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TalkStudies.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Studies != null && message.hasOwnProperty("Studies")) {
                if (!Array.isArray(message.Studies))
                    return "Studies: array expected";
                for (let i = 0; i < message.Studies.length; ++i) {
                    let error = $root.mediaarchiver.TalkStudy.verify(message.Studies[i]);
                    if (error)
                        return "Studies." + error;
                }
            }
            return null;
        };

        /**
         * Creates a TalkStudies message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.TalkStudies
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.TalkStudies} TalkStudies
         */
        TalkStudies.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.TalkStudies)
                return object;
            let message = new $root.mediaarchiver.TalkStudies();
            if (object.Studies) {
                if (!Array.isArray(object.Studies))
                    throw TypeError(".mediaarchiver.TalkStudies.Studies: array expected");
                message.Studies = [];
                for (let i = 0; i < object.Studies.length; ++i) {
                    if (typeof object.Studies[i] !== "object")
                        throw TypeError(".mediaarchiver.TalkStudies.Studies: object expected");
                    message.Studies[i] = $root.mediaarchiver.TalkStudy.fromObject(object.Studies[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a TalkStudies message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.TalkStudies
         * @static
         * @param {mediaarchiver.TalkStudies} message TalkStudies
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TalkStudies.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Studies = [];
            if (message.Studies && message.Studies.length) {
                object.Studies = [];
                for (let j = 0; j < message.Studies.length; ++j)
                    object.Studies[j] = $root.mediaarchiver.TalkStudy.toObject(message.Studies[j], options);
            }
            return object;
        };

        /**
         * Converts this TalkStudies to JSON.
         * @function toJSON
         * @memberof mediaarchiver.TalkStudies
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TalkStudies.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TalkStudies;
    })();

    mediaarchiver.TalkProgramType = (function() {

        /**
         * Properties of a TalkProgramType.
         * @memberof mediaarchiver
         * @interface ITalkProgramType
         * @property {number|null} [ID] TalkProgramType ID
         * @property {string|null} [Name] TalkProgramType Name
         * @property {string|null} [Code] TalkProgramType Code
         */

        /**
         * Constructs a new TalkProgramType.
         * @memberof mediaarchiver
         * @classdesc Represents a TalkProgramType.
         * @implements ITalkProgramType
         * @constructor
         * @param {mediaarchiver.ITalkProgramType=} [properties] Properties to set
         */
        function TalkProgramType(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TalkProgramType ID.
         * @member {number} ID
         * @memberof mediaarchiver.TalkProgramType
         * @instance
         */
        TalkProgramType.prototype.ID = 0;

        /**
         * TalkProgramType Name.
         * @member {string} Name
         * @memberof mediaarchiver.TalkProgramType
         * @instance
         */
        TalkProgramType.prototype.Name = "";

        /**
         * TalkProgramType Code.
         * @member {string} Code
         * @memberof mediaarchiver.TalkProgramType
         * @instance
         */
        TalkProgramType.prototype.Code = "";

        /**
         * Creates a new TalkProgramType instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.TalkProgramType
         * @static
         * @param {mediaarchiver.ITalkProgramType=} [properties] Properties to set
         * @returns {mediaarchiver.TalkProgramType} TalkProgramType instance
         */
        TalkProgramType.create = function create(properties) {
            return new TalkProgramType(properties);
        };

        /**
         * Encodes the specified TalkProgramType message. Does not implicitly {@link mediaarchiver.TalkProgramType.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.TalkProgramType
         * @static
         * @param {mediaarchiver.ITalkProgramType} message TalkProgramType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkProgramType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ID);
            if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
            if (message.Code != null && Object.hasOwnProperty.call(message, "Code"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.Code);
            return writer;
        };

        /**
         * Encodes the specified TalkProgramType message, length delimited. Does not implicitly {@link mediaarchiver.TalkProgramType.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.TalkProgramType
         * @static
         * @param {mediaarchiver.ITalkProgramType} message TalkProgramType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkProgramType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TalkProgramType message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.TalkProgramType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.TalkProgramType} TalkProgramType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkProgramType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.TalkProgramType();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ID = reader.uint32();
                    break;
                case 2:
                    message.Name = reader.string();
                    break;
                case 3:
                    message.Code = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TalkProgramType message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.TalkProgramType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.TalkProgramType} TalkProgramType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkProgramType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TalkProgramType message.
         * @function verify
         * @memberof mediaarchiver.TalkProgramType
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TalkProgramType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isInteger(message.ID))
                    return "ID: integer expected";
            if (message.Name != null && message.hasOwnProperty("Name"))
                if (!$util.isString(message.Name))
                    return "Name: string expected";
            if (message.Code != null && message.hasOwnProperty("Code"))
                if (!$util.isString(message.Code))
                    return "Code: string expected";
            return null;
        };

        /**
         * Creates a TalkProgramType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.TalkProgramType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.TalkProgramType} TalkProgramType
         */
        TalkProgramType.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.TalkProgramType)
                return object;
            let message = new $root.mediaarchiver.TalkProgramType();
            if (object.ID != null)
                message.ID = object.ID >>> 0;
            if (object.Name != null)
                message.Name = String(object.Name);
            if (object.Code != null)
                message.Code = String(object.Code);
            return message;
        };

        /**
         * Creates a plain object from a TalkProgramType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.TalkProgramType
         * @static
         * @param {mediaarchiver.TalkProgramType} message TalkProgramType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TalkProgramType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.ID = 0;
                object.Name = "";
                object.Code = "";
            }
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            if (message.Name != null && message.hasOwnProperty("Name"))
                object.Name = message.Name;
            if (message.Code != null && message.hasOwnProperty("Code"))
                object.Code = message.Code;
            return object;
        };

        /**
         * Converts this TalkProgramType to JSON.
         * @function toJSON
         * @memberof mediaarchiver.TalkProgramType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TalkProgramType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TalkProgramType;
    })();

    mediaarchiver.TalkProgramTypes = (function() {

        /**
         * Properties of a TalkProgramTypes.
         * @memberof mediaarchiver
         * @interface ITalkProgramTypes
         * @property {Array.<mediaarchiver.ITalkProgramType>|null} [Types] TalkProgramTypes Types
         */

        /**
         * Constructs a new TalkProgramTypes.
         * @memberof mediaarchiver
         * @classdesc Represents a TalkProgramTypes.
         * @implements ITalkProgramTypes
         * @constructor
         * @param {mediaarchiver.ITalkProgramTypes=} [properties] Properties to set
         */
        function TalkProgramTypes(properties) {
            this.Types = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TalkProgramTypes Types.
         * @member {Array.<mediaarchiver.ITalkProgramType>} Types
         * @memberof mediaarchiver.TalkProgramTypes
         * @instance
         */
        TalkProgramTypes.prototype.Types = $util.emptyArray;

        /**
         * Creates a new TalkProgramTypes instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.TalkProgramTypes
         * @static
         * @param {mediaarchiver.ITalkProgramTypes=} [properties] Properties to set
         * @returns {mediaarchiver.TalkProgramTypes} TalkProgramTypes instance
         */
        TalkProgramTypes.create = function create(properties) {
            return new TalkProgramTypes(properties);
        };

        /**
         * Encodes the specified TalkProgramTypes message. Does not implicitly {@link mediaarchiver.TalkProgramTypes.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.TalkProgramTypes
         * @static
         * @param {mediaarchiver.ITalkProgramTypes} message TalkProgramTypes message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkProgramTypes.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Types != null && message.Types.length)
                for (let i = 0; i < message.Types.length; ++i)
                    $root.mediaarchiver.TalkProgramType.encode(message.Types[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified TalkProgramTypes message, length delimited. Does not implicitly {@link mediaarchiver.TalkProgramTypes.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.TalkProgramTypes
         * @static
         * @param {mediaarchiver.ITalkProgramTypes} message TalkProgramTypes message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkProgramTypes.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TalkProgramTypes message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.TalkProgramTypes
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.TalkProgramTypes} TalkProgramTypes
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkProgramTypes.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.TalkProgramTypes();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.Types && message.Types.length))
                        message.Types = [];
                    message.Types.push($root.mediaarchiver.TalkProgramType.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TalkProgramTypes message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.TalkProgramTypes
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.TalkProgramTypes} TalkProgramTypes
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkProgramTypes.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TalkProgramTypes message.
         * @function verify
         * @memberof mediaarchiver.TalkProgramTypes
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TalkProgramTypes.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Types != null && message.hasOwnProperty("Types")) {
                if (!Array.isArray(message.Types))
                    return "Types: array expected";
                for (let i = 0; i < message.Types.length; ++i) {
                    let error = $root.mediaarchiver.TalkProgramType.verify(message.Types[i]);
                    if (error)
                        return "Types." + error;
                }
            }
            return null;
        };

        /**
         * Creates a TalkProgramTypes message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.TalkProgramTypes
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.TalkProgramTypes} TalkProgramTypes
         */
        TalkProgramTypes.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.TalkProgramTypes)
                return object;
            let message = new $root.mediaarchiver.TalkProgramTypes();
            if (object.Types) {
                if (!Array.isArray(object.Types))
                    throw TypeError(".mediaarchiver.TalkProgramTypes.Types: array expected");
                message.Types = [];
                for (let i = 0; i < object.Types.length; ++i) {
                    if (typeof object.Types[i] !== "object")
                        throw TypeError(".mediaarchiver.TalkProgramTypes.Types: object expected");
                    message.Types[i] = $root.mediaarchiver.TalkProgramType.fromObject(object.Types[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a TalkProgramTypes message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.TalkProgramTypes
         * @static
         * @param {mediaarchiver.TalkProgramTypes} message TalkProgramTypes
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TalkProgramTypes.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Types = [];
            if (message.Types && message.Types.length) {
                object.Types = [];
                for (let j = 0; j < message.Types.length; ++j)
                    object.Types[j] = $root.mediaarchiver.TalkProgramType.toObject(message.Types[j], options);
            }
            return object;
        };

        /**
         * Converts this TalkProgramTypes to JSON.
         * @function toJSON
         * @memberof mediaarchiver.TalkProgramTypes
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TalkProgramTypes.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TalkProgramTypes;
    })();

    mediaarchiver.TalkGetDistricts = (function() {

        /**
         * Properties of a TalkGetDistricts.
         * @memberof mediaarchiver
         * @interface ITalkGetDistricts
         * @property {number|null} [StudyID] TalkGetDistricts StudyID
         * @property {string|null} [Typed] TalkGetDistricts Typed
         */

        /**
         * Constructs a new TalkGetDistricts.
         * @memberof mediaarchiver
         * @classdesc Represents a TalkGetDistricts.
         * @implements ITalkGetDistricts
         * @constructor
         * @param {mediaarchiver.ITalkGetDistricts=} [properties] Properties to set
         */
        function TalkGetDistricts(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TalkGetDistricts StudyID.
         * @member {number} StudyID
         * @memberof mediaarchiver.TalkGetDistricts
         * @instance
         */
        TalkGetDistricts.prototype.StudyID = 0;

        /**
         * TalkGetDistricts Typed.
         * @member {string} Typed
         * @memberof mediaarchiver.TalkGetDistricts
         * @instance
         */
        TalkGetDistricts.prototype.Typed = "";

        /**
         * Creates a new TalkGetDistricts instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.TalkGetDistricts
         * @static
         * @param {mediaarchiver.ITalkGetDistricts=} [properties] Properties to set
         * @returns {mediaarchiver.TalkGetDistricts} TalkGetDistricts instance
         */
        TalkGetDistricts.create = function create(properties) {
            return new TalkGetDistricts(properties);
        };

        /**
         * Encodes the specified TalkGetDistricts message. Does not implicitly {@link mediaarchiver.TalkGetDistricts.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.TalkGetDistricts
         * @static
         * @param {mediaarchiver.ITalkGetDistricts} message TalkGetDistricts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkGetDistricts.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.StudyID != null && Object.hasOwnProperty.call(message, "StudyID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.StudyID);
            if (message.Typed != null && Object.hasOwnProperty.call(message, "Typed"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Typed);
            return writer;
        };

        /**
         * Encodes the specified TalkGetDistricts message, length delimited. Does not implicitly {@link mediaarchiver.TalkGetDistricts.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.TalkGetDistricts
         * @static
         * @param {mediaarchiver.ITalkGetDistricts} message TalkGetDistricts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkGetDistricts.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TalkGetDistricts message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.TalkGetDistricts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.TalkGetDistricts} TalkGetDistricts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkGetDistricts.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.TalkGetDistricts();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.StudyID = reader.uint32();
                    break;
                case 2:
                    message.Typed = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TalkGetDistricts message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.TalkGetDistricts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.TalkGetDistricts} TalkGetDistricts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkGetDistricts.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TalkGetDistricts message.
         * @function verify
         * @memberof mediaarchiver.TalkGetDistricts
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TalkGetDistricts.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.StudyID != null && message.hasOwnProperty("StudyID"))
                if (!$util.isInteger(message.StudyID))
                    return "StudyID: integer expected";
            if (message.Typed != null && message.hasOwnProperty("Typed"))
                if (!$util.isString(message.Typed))
                    return "Typed: string expected";
            return null;
        };

        /**
         * Creates a TalkGetDistricts message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.TalkGetDistricts
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.TalkGetDistricts} TalkGetDistricts
         */
        TalkGetDistricts.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.TalkGetDistricts)
                return object;
            let message = new $root.mediaarchiver.TalkGetDistricts();
            if (object.StudyID != null)
                message.StudyID = object.StudyID >>> 0;
            if (object.Typed != null)
                message.Typed = String(object.Typed);
            return message;
        };

        /**
         * Creates a plain object from a TalkGetDistricts message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.TalkGetDistricts
         * @static
         * @param {mediaarchiver.TalkGetDistricts} message TalkGetDistricts
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TalkGetDistricts.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.StudyID = 0;
                object.Typed = "";
            }
            if (message.StudyID != null && message.hasOwnProperty("StudyID"))
                object.StudyID = message.StudyID;
            if (message.Typed != null && message.hasOwnProperty("Typed"))
                object.Typed = message.Typed;
            return object;
        };

        /**
         * Converts this TalkGetDistricts to JSON.
         * @function toJSON
         * @memberof mediaarchiver.TalkGetDistricts
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TalkGetDistricts.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TalkGetDistricts;
    })();

    mediaarchiver.TalkDistrict = (function() {

        /**
         * Properties of a TalkDistrict.
         * @memberof mediaarchiver
         * @interface ITalkDistrict
         * @property {number|null} [ID] TalkDistrict ID
         * @property {string|null} [Name] TalkDistrict Name
         */

        /**
         * Constructs a new TalkDistrict.
         * @memberof mediaarchiver
         * @classdesc Represents a TalkDistrict.
         * @implements ITalkDistrict
         * @constructor
         * @param {mediaarchiver.ITalkDistrict=} [properties] Properties to set
         */
        function TalkDistrict(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TalkDistrict ID.
         * @member {number} ID
         * @memberof mediaarchiver.TalkDistrict
         * @instance
         */
        TalkDistrict.prototype.ID = 0;

        /**
         * TalkDistrict Name.
         * @member {string} Name
         * @memberof mediaarchiver.TalkDistrict
         * @instance
         */
        TalkDistrict.prototype.Name = "";

        /**
         * Creates a new TalkDistrict instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.TalkDistrict
         * @static
         * @param {mediaarchiver.ITalkDistrict=} [properties] Properties to set
         * @returns {mediaarchiver.TalkDistrict} TalkDistrict instance
         */
        TalkDistrict.create = function create(properties) {
            return new TalkDistrict(properties);
        };

        /**
         * Encodes the specified TalkDistrict message. Does not implicitly {@link mediaarchiver.TalkDistrict.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.TalkDistrict
         * @static
         * @param {mediaarchiver.ITalkDistrict} message TalkDistrict message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkDistrict.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ID);
            if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
            return writer;
        };

        /**
         * Encodes the specified TalkDistrict message, length delimited. Does not implicitly {@link mediaarchiver.TalkDistrict.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.TalkDistrict
         * @static
         * @param {mediaarchiver.ITalkDistrict} message TalkDistrict message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkDistrict.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TalkDistrict message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.TalkDistrict
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.TalkDistrict} TalkDistrict
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkDistrict.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.TalkDistrict();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ID = reader.uint32();
                    break;
                case 2:
                    message.Name = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TalkDistrict message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.TalkDistrict
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.TalkDistrict} TalkDistrict
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkDistrict.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TalkDistrict message.
         * @function verify
         * @memberof mediaarchiver.TalkDistrict
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TalkDistrict.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isInteger(message.ID))
                    return "ID: integer expected";
            if (message.Name != null && message.hasOwnProperty("Name"))
                if (!$util.isString(message.Name))
                    return "Name: string expected";
            return null;
        };

        /**
         * Creates a TalkDistrict message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.TalkDistrict
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.TalkDistrict} TalkDistrict
         */
        TalkDistrict.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.TalkDistrict)
                return object;
            let message = new $root.mediaarchiver.TalkDistrict();
            if (object.ID != null)
                message.ID = object.ID >>> 0;
            if (object.Name != null)
                message.Name = String(object.Name);
            return message;
        };

        /**
         * Creates a plain object from a TalkDistrict message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.TalkDistrict
         * @static
         * @param {mediaarchiver.TalkDistrict} message TalkDistrict
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TalkDistrict.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.ID = 0;
                object.Name = "";
            }
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            if (message.Name != null && message.hasOwnProperty("Name"))
                object.Name = message.Name;
            return object;
        };

        /**
         * Converts this TalkDistrict to JSON.
         * @function toJSON
         * @memberof mediaarchiver.TalkDistrict
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TalkDistrict.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TalkDistrict;
    })();

    mediaarchiver.TalkDistricts = (function() {

        /**
         * Properties of a TalkDistricts.
         * @memberof mediaarchiver
         * @interface ITalkDistricts
         * @property {Array.<mediaarchiver.ITalkDistrict>|null} [Districts] TalkDistricts Districts
         */

        /**
         * Constructs a new TalkDistricts.
         * @memberof mediaarchiver
         * @classdesc Represents a TalkDistricts.
         * @implements ITalkDistricts
         * @constructor
         * @param {mediaarchiver.ITalkDistricts=} [properties] Properties to set
         */
        function TalkDistricts(properties) {
            this.Districts = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TalkDistricts Districts.
         * @member {Array.<mediaarchiver.ITalkDistrict>} Districts
         * @memberof mediaarchiver.TalkDistricts
         * @instance
         */
        TalkDistricts.prototype.Districts = $util.emptyArray;

        /**
         * Creates a new TalkDistricts instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.TalkDistricts
         * @static
         * @param {mediaarchiver.ITalkDistricts=} [properties] Properties to set
         * @returns {mediaarchiver.TalkDistricts} TalkDistricts instance
         */
        TalkDistricts.create = function create(properties) {
            return new TalkDistricts(properties);
        };

        /**
         * Encodes the specified TalkDistricts message. Does not implicitly {@link mediaarchiver.TalkDistricts.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.TalkDistricts
         * @static
         * @param {mediaarchiver.ITalkDistricts} message TalkDistricts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkDistricts.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Districts != null && message.Districts.length)
                for (let i = 0; i < message.Districts.length; ++i)
                    $root.mediaarchiver.TalkDistrict.encode(message.Districts[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified TalkDistricts message, length delimited. Does not implicitly {@link mediaarchiver.TalkDistricts.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.TalkDistricts
         * @static
         * @param {mediaarchiver.ITalkDistricts} message TalkDistricts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkDistricts.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TalkDistricts message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.TalkDistricts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.TalkDistricts} TalkDistricts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkDistricts.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.TalkDistricts();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.Districts && message.Districts.length))
                        message.Districts = [];
                    message.Districts.push($root.mediaarchiver.TalkDistrict.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TalkDistricts message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.TalkDistricts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.TalkDistricts} TalkDistricts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkDistricts.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TalkDistricts message.
         * @function verify
         * @memberof mediaarchiver.TalkDistricts
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TalkDistricts.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Districts != null && message.hasOwnProperty("Districts")) {
                if (!Array.isArray(message.Districts))
                    return "Districts: array expected";
                for (let i = 0; i < message.Districts.length; ++i) {
                    let error = $root.mediaarchiver.TalkDistrict.verify(message.Districts[i]);
                    if (error)
                        return "Districts." + error;
                }
            }
            return null;
        };

        /**
         * Creates a TalkDistricts message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.TalkDistricts
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.TalkDistricts} TalkDistricts
         */
        TalkDistricts.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.TalkDistricts)
                return object;
            let message = new $root.mediaarchiver.TalkDistricts();
            if (object.Districts) {
                if (!Array.isArray(object.Districts))
                    throw TypeError(".mediaarchiver.TalkDistricts.Districts: array expected");
                message.Districts = [];
                for (let i = 0; i < object.Districts.length; ++i) {
                    if (typeof object.Districts[i] !== "object")
                        throw TypeError(".mediaarchiver.TalkDistricts.Districts: object expected");
                    message.Districts[i] = $root.mediaarchiver.TalkDistrict.fromObject(object.Districts[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a TalkDistricts message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.TalkDistricts
         * @static
         * @param {mediaarchiver.TalkDistricts} message TalkDistricts
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TalkDistricts.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Districts = [];
            if (message.Districts && message.Districts.length) {
                object.Districts = [];
                for (let j = 0; j < message.Districts.length; ++j)
                    object.Districts[j] = $root.mediaarchiver.TalkDistrict.toObject(message.Districts[j], options);
            }
            return object;
        };

        /**
         * Converts this TalkDistricts to JSON.
         * @function toJSON
         * @memberof mediaarchiver.TalkDistricts
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TalkDistricts.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TalkDistricts;
    })();

    mediaarchiver.TalkDeprecated = (function() {

        /**
         * Properties of a TalkDeprecated.
         * @memberof mediaarchiver
         * @interface ITalkDeprecated
         * @property {string|null} [ID] TalkDeprecated ID
         * @property {number|null} [Media] TalkDeprecated Media
         * @property {number|null} [DurationMS] TalkDeprecated DurationMS
         * @property {number|Long|null} [Start] TalkDeprecated Start
         * @property {number|null} [Study] TalkDeprecated Study
         * @property {string|null} [PersonName] TalkDeprecated PersonName
         * @property {number|null} [PersonID] TalkDeprecated PersonID
         * @property {number|null} [Group] TalkDeprecated Group
         * @property {string|null} [Title] TalkDeprecated Title
         * @property {number|null} [Regim] TalkDeprecated Regim
         * @property {string|null} [GroupColor] TalkDeprecated GroupColor
         * @property {number|null} [Owner] TalkDeprecated Owner
         * @property {string|null} [OwnerName] TalkDeprecated OwnerName
         * @property {number|null} [Company] TalkDeprecated Company
         * @property {string|null} [Comment] TalkDeprecated Comment
         * @property {string|null} [ProgramName] TalkDeprecated ProgramName
         * @property {number|null} [ProgramType] TalkDeprecated ProgramType
         * @property {number|Long|null} [ProgramStart] TalkDeprecated ProgramStart
         * @property {number|Long|null} [ProgramEnd] TalkDeprecated ProgramEnd
         * @property {number|Long|null} [District] TalkDeprecated District
         * @property {string|null} [ProgramTypeCustom] TalkDeprecated ProgramTypeCustom
         * @property {string|null} [GroupCustom] TalkDeprecated GroupCustom
         * @property {string|null} [RegimCustom] TalkDeprecated RegimCustom
         * @property {mediaarchiver.TalkTimeType|null} [TimeType] TalkDeprecated TimeType
         */

        /**
         * Constructs a new TalkDeprecated.
         * @memberof mediaarchiver
         * @classdesc Represents a TalkDeprecated.
         * @implements ITalkDeprecated
         * @constructor
         * @param {mediaarchiver.ITalkDeprecated=} [properties] Properties to set
         */
        function TalkDeprecated(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TalkDeprecated ID.
         * @member {string} ID
         * @memberof mediaarchiver.TalkDeprecated
         * @instance
         */
        TalkDeprecated.prototype.ID = "";

        /**
         * TalkDeprecated Media.
         * @member {number} Media
         * @memberof mediaarchiver.TalkDeprecated
         * @instance
         */
        TalkDeprecated.prototype.Media = 0;

        /**
         * TalkDeprecated DurationMS.
         * @member {number} DurationMS
         * @memberof mediaarchiver.TalkDeprecated
         * @instance
         */
        TalkDeprecated.prototype.DurationMS = 0;

        /**
         * TalkDeprecated Start.
         * @member {number|Long} Start
         * @memberof mediaarchiver.TalkDeprecated
         * @instance
         */
        TalkDeprecated.prototype.Start = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * TalkDeprecated Study.
         * @member {number} Study
         * @memberof mediaarchiver.TalkDeprecated
         * @instance
         */
        TalkDeprecated.prototype.Study = 0;

        /**
         * TalkDeprecated PersonName.
         * @member {string} PersonName
         * @memberof mediaarchiver.TalkDeprecated
         * @instance
         */
        TalkDeprecated.prototype.PersonName = "";

        /**
         * TalkDeprecated PersonID.
         * @member {number} PersonID
         * @memberof mediaarchiver.TalkDeprecated
         * @instance
         */
        TalkDeprecated.prototype.PersonID = 0;

        /**
         * TalkDeprecated Group.
         * @member {number} Group
         * @memberof mediaarchiver.TalkDeprecated
         * @instance
         */
        TalkDeprecated.prototype.Group = 0;

        /**
         * TalkDeprecated Title.
         * @member {string} Title
         * @memberof mediaarchiver.TalkDeprecated
         * @instance
         */
        TalkDeprecated.prototype.Title = "";

        /**
         * TalkDeprecated Regim.
         * @member {number} Regim
         * @memberof mediaarchiver.TalkDeprecated
         * @instance
         */
        TalkDeprecated.prototype.Regim = 0;

        /**
         * TalkDeprecated GroupColor.
         * @member {string} GroupColor
         * @memberof mediaarchiver.TalkDeprecated
         * @instance
         */
        TalkDeprecated.prototype.GroupColor = "";

        /**
         * TalkDeprecated Owner.
         * @member {number} Owner
         * @memberof mediaarchiver.TalkDeprecated
         * @instance
         */
        TalkDeprecated.prototype.Owner = 0;

        /**
         * TalkDeprecated OwnerName.
         * @member {string} OwnerName
         * @memberof mediaarchiver.TalkDeprecated
         * @instance
         */
        TalkDeprecated.prototype.OwnerName = "";

        /**
         * TalkDeprecated Company.
         * @member {number} Company
         * @memberof mediaarchiver.TalkDeprecated
         * @instance
         */
        TalkDeprecated.prototype.Company = 0;

        /**
         * TalkDeprecated Comment.
         * @member {string} Comment
         * @memberof mediaarchiver.TalkDeprecated
         * @instance
         */
        TalkDeprecated.prototype.Comment = "";

        /**
         * TalkDeprecated ProgramName.
         * @member {string} ProgramName
         * @memberof mediaarchiver.TalkDeprecated
         * @instance
         */
        TalkDeprecated.prototype.ProgramName = "";

        /**
         * TalkDeprecated ProgramType.
         * @member {number} ProgramType
         * @memberof mediaarchiver.TalkDeprecated
         * @instance
         */
        TalkDeprecated.prototype.ProgramType = 0;

        /**
         * TalkDeprecated ProgramStart.
         * @member {number|Long} ProgramStart
         * @memberof mediaarchiver.TalkDeprecated
         * @instance
         */
        TalkDeprecated.prototype.ProgramStart = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * TalkDeprecated ProgramEnd.
         * @member {number|Long} ProgramEnd
         * @memberof mediaarchiver.TalkDeprecated
         * @instance
         */
        TalkDeprecated.prototype.ProgramEnd = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * TalkDeprecated District.
         * @member {number|Long} District
         * @memberof mediaarchiver.TalkDeprecated
         * @instance
         */
        TalkDeprecated.prototype.District = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * TalkDeprecated ProgramTypeCustom.
         * @member {string} ProgramTypeCustom
         * @memberof mediaarchiver.TalkDeprecated
         * @instance
         */
        TalkDeprecated.prototype.ProgramTypeCustom = "";

        /**
         * TalkDeprecated GroupCustom.
         * @member {string} GroupCustom
         * @memberof mediaarchiver.TalkDeprecated
         * @instance
         */
        TalkDeprecated.prototype.GroupCustom = "";

        /**
         * TalkDeprecated RegimCustom.
         * @member {string} RegimCustom
         * @memberof mediaarchiver.TalkDeprecated
         * @instance
         */
        TalkDeprecated.prototype.RegimCustom = "";

        /**
         * TalkDeprecated TimeType.
         * @member {mediaarchiver.TalkTimeType} TimeType
         * @memberof mediaarchiver.TalkDeprecated
         * @instance
         */
        TalkDeprecated.prototype.TimeType = 0;

        /**
         * Creates a new TalkDeprecated instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.TalkDeprecated
         * @static
         * @param {mediaarchiver.ITalkDeprecated=} [properties] Properties to set
         * @returns {mediaarchiver.TalkDeprecated} TalkDeprecated instance
         */
        TalkDeprecated.create = function create(properties) {
            return new TalkDeprecated(properties);
        };

        /**
         * Encodes the specified TalkDeprecated message. Does not implicitly {@link mediaarchiver.TalkDeprecated.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.TalkDeprecated
         * @static
         * @param {mediaarchiver.ITalkDeprecated} message TalkDeprecated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkDeprecated.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.ID);
            if (message.Media != null && Object.hasOwnProperty.call(message, "Media"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Media);
            if (message.DurationMS != null && Object.hasOwnProperty.call(message, "DurationMS"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.DurationMS);
            if (message.Start != null && Object.hasOwnProperty.call(message, "Start"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.Start);
            if (message.Study != null && Object.hasOwnProperty.call(message, "Study"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.Study);
            if (message.PersonName != null && Object.hasOwnProperty.call(message, "PersonName"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.PersonName);
            if (message.PersonID != null && Object.hasOwnProperty.call(message, "PersonID"))
                writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.PersonID);
            if (message.Group != null && Object.hasOwnProperty.call(message, "Group"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.Group);
            if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.Title);
            if (message.Regim != null && Object.hasOwnProperty.call(message, "Regim"))
                writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.Regim);
            if (message.GroupColor != null && Object.hasOwnProperty.call(message, "GroupColor"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.GroupColor);
            if (message.Owner != null && Object.hasOwnProperty.call(message, "Owner"))
                writer.uint32(/* id 12, wireType 0 =*/96).uint32(message.Owner);
            if (message.OwnerName != null && Object.hasOwnProperty.call(message, "OwnerName"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.OwnerName);
            if (message.Company != null && Object.hasOwnProperty.call(message, "Company"))
                writer.uint32(/* id 14, wireType 0 =*/112).uint32(message.Company);
            if (message.Comment != null && Object.hasOwnProperty.call(message, "Comment"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.Comment);
            if (message.ProgramName != null && Object.hasOwnProperty.call(message, "ProgramName"))
                writer.uint32(/* id 16, wireType 2 =*/130).string(message.ProgramName);
            if (message.ProgramType != null && Object.hasOwnProperty.call(message, "ProgramType"))
                writer.uint32(/* id 17, wireType 0 =*/136).uint32(message.ProgramType);
            if (message.ProgramStart != null && Object.hasOwnProperty.call(message, "ProgramStart"))
                writer.uint32(/* id 18, wireType 0 =*/144).int64(message.ProgramStart);
            if (message.ProgramEnd != null && Object.hasOwnProperty.call(message, "ProgramEnd"))
                writer.uint32(/* id 19, wireType 0 =*/152).int64(message.ProgramEnd);
            if (message.District != null && Object.hasOwnProperty.call(message, "District"))
                writer.uint32(/* id 20, wireType 0 =*/160).int64(message.District);
            if (message.ProgramTypeCustom != null && Object.hasOwnProperty.call(message, "ProgramTypeCustom"))
                writer.uint32(/* id 22, wireType 2 =*/178).string(message.ProgramTypeCustom);
            if (message.GroupCustom != null && Object.hasOwnProperty.call(message, "GroupCustom"))
                writer.uint32(/* id 23, wireType 2 =*/186).string(message.GroupCustom);
            if (message.RegimCustom != null && Object.hasOwnProperty.call(message, "RegimCustom"))
                writer.uint32(/* id 24, wireType 2 =*/194).string(message.RegimCustom);
            if (message.TimeType != null && Object.hasOwnProperty.call(message, "TimeType"))
                writer.uint32(/* id 25, wireType 0 =*/200).int32(message.TimeType);
            return writer;
        };

        /**
         * Encodes the specified TalkDeprecated message, length delimited. Does not implicitly {@link mediaarchiver.TalkDeprecated.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.TalkDeprecated
         * @static
         * @param {mediaarchiver.ITalkDeprecated} message TalkDeprecated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkDeprecated.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TalkDeprecated message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.TalkDeprecated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.TalkDeprecated} TalkDeprecated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkDeprecated.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.TalkDeprecated();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ID = reader.string();
                    break;
                case 2:
                    message.Media = reader.uint32();
                    break;
                case 3:
                    message.DurationMS = reader.uint32();
                    break;
                case 4:
                    message.Start = reader.int64();
                    break;
                case 5:
                    message.Study = reader.uint32();
                    break;
                case 6:
                    message.PersonName = reader.string();
                    break;
                case 7:
                    message.PersonID = reader.uint32();
                    break;
                case 8:
                    message.Group = reader.uint32();
                    break;
                case 9:
                    message.Title = reader.string();
                    break;
                case 10:
                    message.Regim = reader.uint32();
                    break;
                case 11:
                    message.GroupColor = reader.string();
                    break;
                case 12:
                    message.Owner = reader.uint32();
                    break;
                case 13:
                    message.OwnerName = reader.string();
                    break;
                case 14:
                    message.Company = reader.uint32();
                    break;
                case 15:
                    message.Comment = reader.string();
                    break;
                case 16:
                    message.ProgramName = reader.string();
                    break;
                case 17:
                    message.ProgramType = reader.uint32();
                    break;
                case 18:
                    message.ProgramStart = reader.int64();
                    break;
                case 19:
                    message.ProgramEnd = reader.int64();
                    break;
                case 20:
                    message.District = reader.int64();
                    break;
                case 22:
                    message.ProgramTypeCustom = reader.string();
                    break;
                case 23:
                    message.GroupCustom = reader.string();
                    break;
                case 24:
                    message.RegimCustom = reader.string();
                    break;
                case 25:
                    message.TimeType = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TalkDeprecated message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.TalkDeprecated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.TalkDeprecated} TalkDeprecated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkDeprecated.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TalkDeprecated message.
         * @function verify
         * @memberof mediaarchiver.TalkDeprecated
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TalkDeprecated.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isString(message.ID))
                    return "ID: string expected";
            if (message.Media != null && message.hasOwnProperty("Media"))
                if (!$util.isInteger(message.Media))
                    return "Media: integer expected";
            if (message.DurationMS != null && message.hasOwnProperty("DurationMS"))
                if (!$util.isInteger(message.DurationMS))
                    return "DurationMS: integer expected";
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (!$util.isInteger(message.Start) && !(message.Start && $util.isInteger(message.Start.low) && $util.isInteger(message.Start.high)))
                    return "Start: integer|Long expected";
            if (message.Study != null && message.hasOwnProperty("Study"))
                if (!$util.isInteger(message.Study))
                    return "Study: integer expected";
            if (message.PersonName != null && message.hasOwnProperty("PersonName"))
                if (!$util.isString(message.PersonName))
                    return "PersonName: string expected";
            if (message.PersonID != null && message.hasOwnProperty("PersonID"))
                if (!$util.isInteger(message.PersonID))
                    return "PersonID: integer expected";
            if (message.Group != null && message.hasOwnProperty("Group"))
                if (!$util.isInteger(message.Group))
                    return "Group: integer expected";
            if (message.Title != null && message.hasOwnProperty("Title"))
                if (!$util.isString(message.Title))
                    return "Title: string expected";
            if (message.Regim != null && message.hasOwnProperty("Regim"))
                if (!$util.isInteger(message.Regim))
                    return "Regim: integer expected";
            if (message.GroupColor != null && message.hasOwnProperty("GroupColor"))
                if (!$util.isString(message.GroupColor))
                    return "GroupColor: string expected";
            if (message.Owner != null && message.hasOwnProperty("Owner"))
                if (!$util.isInteger(message.Owner))
                    return "Owner: integer expected";
            if (message.OwnerName != null && message.hasOwnProperty("OwnerName"))
                if (!$util.isString(message.OwnerName))
                    return "OwnerName: string expected";
            if (message.Company != null && message.hasOwnProperty("Company"))
                if (!$util.isInteger(message.Company))
                    return "Company: integer expected";
            if (message.Comment != null && message.hasOwnProperty("Comment"))
                if (!$util.isString(message.Comment))
                    return "Comment: string expected";
            if (message.ProgramName != null && message.hasOwnProperty("ProgramName"))
                if (!$util.isString(message.ProgramName))
                    return "ProgramName: string expected";
            if (message.ProgramType != null && message.hasOwnProperty("ProgramType"))
                if (!$util.isInteger(message.ProgramType))
                    return "ProgramType: integer expected";
            if (message.ProgramStart != null && message.hasOwnProperty("ProgramStart"))
                if (!$util.isInteger(message.ProgramStart) && !(message.ProgramStart && $util.isInteger(message.ProgramStart.low) && $util.isInteger(message.ProgramStart.high)))
                    return "ProgramStart: integer|Long expected";
            if (message.ProgramEnd != null && message.hasOwnProperty("ProgramEnd"))
                if (!$util.isInteger(message.ProgramEnd) && !(message.ProgramEnd && $util.isInteger(message.ProgramEnd.low) && $util.isInteger(message.ProgramEnd.high)))
                    return "ProgramEnd: integer|Long expected";
            if (message.District != null && message.hasOwnProperty("District"))
                if (!$util.isInteger(message.District) && !(message.District && $util.isInteger(message.District.low) && $util.isInteger(message.District.high)))
                    return "District: integer|Long expected";
            if (message.ProgramTypeCustom != null && message.hasOwnProperty("ProgramTypeCustom"))
                if (!$util.isString(message.ProgramTypeCustom))
                    return "ProgramTypeCustom: string expected";
            if (message.GroupCustom != null && message.hasOwnProperty("GroupCustom"))
                if (!$util.isString(message.GroupCustom))
                    return "GroupCustom: string expected";
            if (message.RegimCustom != null && message.hasOwnProperty("RegimCustom"))
                if (!$util.isString(message.RegimCustom))
                    return "RegimCustom: string expected";
            if (message.TimeType != null && message.hasOwnProperty("TimeType"))
                switch (message.TimeType) {
                default:
                    return "TimeType: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            return null;
        };

        /**
         * Creates a TalkDeprecated message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.TalkDeprecated
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.TalkDeprecated} TalkDeprecated
         */
        TalkDeprecated.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.TalkDeprecated)
                return object;
            let message = new $root.mediaarchiver.TalkDeprecated();
            if (object.ID != null)
                message.ID = String(object.ID);
            if (object.Media != null)
                message.Media = object.Media >>> 0;
            if (object.DurationMS != null)
                message.DurationMS = object.DurationMS >>> 0;
            if (object.Start != null)
                if ($util.Long)
                    (message.Start = $util.Long.fromValue(object.Start)).unsigned = false;
                else if (typeof object.Start === "string")
                    message.Start = parseInt(object.Start, 10);
                else if (typeof object.Start === "number")
                    message.Start = object.Start;
                else if (typeof object.Start === "object")
                    message.Start = new $util.LongBits(object.Start.low >>> 0, object.Start.high >>> 0).toNumber();
            if (object.Study != null)
                message.Study = object.Study >>> 0;
            if (object.PersonName != null)
                message.PersonName = String(object.PersonName);
            if (object.PersonID != null)
                message.PersonID = object.PersonID >>> 0;
            if (object.Group != null)
                message.Group = object.Group >>> 0;
            if (object.Title != null)
                message.Title = String(object.Title);
            if (object.Regim != null)
                message.Regim = object.Regim >>> 0;
            if (object.GroupColor != null)
                message.GroupColor = String(object.GroupColor);
            if (object.Owner != null)
                message.Owner = object.Owner >>> 0;
            if (object.OwnerName != null)
                message.OwnerName = String(object.OwnerName);
            if (object.Company != null)
                message.Company = object.Company >>> 0;
            if (object.Comment != null)
                message.Comment = String(object.Comment);
            if (object.ProgramName != null)
                message.ProgramName = String(object.ProgramName);
            if (object.ProgramType != null)
                message.ProgramType = object.ProgramType >>> 0;
            if (object.ProgramStart != null)
                if ($util.Long)
                    (message.ProgramStart = $util.Long.fromValue(object.ProgramStart)).unsigned = false;
                else if (typeof object.ProgramStart === "string")
                    message.ProgramStart = parseInt(object.ProgramStart, 10);
                else if (typeof object.ProgramStart === "number")
                    message.ProgramStart = object.ProgramStart;
                else if (typeof object.ProgramStart === "object")
                    message.ProgramStart = new $util.LongBits(object.ProgramStart.low >>> 0, object.ProgramStart.high >>> 0).toNumber();
            if (object.ProgramEnd != null)
                if ($util.Long)
                    (message.ProgramEnd = $util.Long.fromValue(object.ProgramEnd)).unsigned = false;
                else if (typeof object.ProgramEnd === "string")
                    message.ProgramEnd = parseInt(object.ProgramEnd, 10);
                else if (typeof object.ProgramEnd === "number")
                    message.ProgramEnd = object.ProgramEnd;
                else if (typeof object.ProgramEnd === "object")
                    message.ProgramEnd = new $util.LongBits(object.ProgramEnd.low >>> 0, object.ProgramEnd.high >>> 0).toNumber();
            if (object.District != null)
                if ($util.Long)
                    (message.District = $util.Long.fromValue(object.District)).unsigned = false;
                else if (typeof object.District === "string")
                    message.District = parseInt(object.District, 10);
                else if (typeof object.District === "number")
                    message.District = object.District;
                else if (typeof object.District === "object")
                    message.District = new $util.LongBits(object.District.low >>> 0, object.District.high >>> 0).toNumber();
            if (object.ProgramTypeCustom != null)
                message.ProgramTypeCustom = String(object.ProgramTypeCustom);
            if (object.GroupCustom != null)
                message.GroupCustom = String(object.GroupCustom);
            if (object.RegimCustom != null)
                message.RegimCustom = String(object.RegimCustom);
            switch (object.TimeType) {
            case "TALK_TIME_TYPE_UNKNOWN":
            case 0:
                message.TimeType = 0;
                break;
            case "TALK_TIME_TYPE_SPEAK":
            case 1:
                message.TimeType = 1;
                break;
            case "TALK_TIME_TYPE_BROADCAST":
            case 2:
                message.TimeType = 2;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a TalkDeprecated message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.TalkDeprecated
         * @static
         * @param {mediaarchiver.TalkDeprecated} message TalkDeprecated
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TalkDeprecated.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.ID = "";
                object.Media = 0;
                object.DurationMS = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.Start = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.Start = options.longs === String ? "0" : 0;
                object.Study = 0;
                object.PersonName = "";
                object.PersonID = 0;
                object.Group = 0;
                object.Title = "";
                object.Regim = 0;
                object.GroupColor = "";
                object.Owner = 0;
                object.OwnerName = "";
                object.Company = 0;
                object.Comment = "";
                object.ProgramName = "";
                object.ProgramType = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.ProgramStart = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.ProgramStart = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.ProgramEnd = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.ProgramEnd = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.District = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.District = options.longs === String ? "0" : 0;
                object.ProgramTypeCustom = "";
                object.GroupCustom = "";
                object.RegimCustom = "";
                object.TimeType = options.enums === String ? "TALK_TIME_TYPE_UNKNOWN" : 0;
            }
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            if (message.Media != null && message.hasOwnProperty("Media"))
                object.Media = message.Media;
            if (message.DurationMS != null && message.hasOwnProperty("DurationMS"))
                object.DurationMS = message.DurationMS;
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (typeof message.Start === "number")
                    object.Start = options.longs === String ? String(message.Start) : message.Start;
                else
                    object.Start = options.longs === String ? $util.Long.prototype.toString.call(message.Start) : options.longs === Number ? new $util.LongBits(message.Start.low >>> 0, message.Start.high >>> 0).toNumber() : message.Start;
            if (message.Study != null && message.hasOwnProperty("Study"))
                object.Study = message.Study;
            if (message.PersonName != null && message.hasOwnProperty("PersonName"))
                object.PersonName = message.PersonName;
            if (message.PersonID != null && message.hasOwnProperty("PersonID"))
                object.PersonID = message.PersonID;
            if (message.Group != null && message.hasOwnProperty("Group"))
                object.Group = message.Group;
            if (message.Title != null && message.hasOwnProperty("Title"))
                object.Title = message.Title;
            if (message.Regim != null && message.hasOwnProperty("Regim"))
                object.Regim = message.Regim;
            if (message.GroupColor != null && message.hasOwnProperty("GroupColor"))
                object.GroupColor = message.GroupColor;
            if (message.Owner != null && message.hasOwnProperty("Owner"))
                object.Owner = message.Owner;
            if (message.OwnerName != null && message.hasOwnProperty("OwnerName"))
                object.OwnerName = message.OwnerName;
            if (message.Company != null && message.hasOwnProperty("Company"))
                object.Company = message.Company;
            if (message.Comment != null && message.hasOwnProperty("Comment"))
                object.Comment = message.Comment;
            if (message.ProgramName != null && message.hasOwnProperty("ProgramName"))
                object.ProgramName = message.ProgramName;
            if (message.ProgramType != null && message.hasOwnProperty("ProgramType"))
                object.ProgramType = message.ProgramType;
            if (message.ProgramStart != null && message.hasOwnProperty("ProgramStart"))
                if (typeof message.ProgramStart === "number")
                    object.ProgramStart = options.longs === String ? String(message.ProgramStart) : message.ProgramStart;
                else
                    object.ProgramStart = options.longs === String ? $util.Long.prototype.toString.call(message.ProgramStart) : options.longs === Number ? new $util.LongBits(message.ProgramStart.low >>> 0, message.ProgramStart.high >>> 0).toNumber() : message.ProgramStart;
            if (message.ProgramEnd != null && message.hasOwnProperty("ProgramEnd"))
                if (typeof message.ProgramEnd === "number")
                    object.ProgramEnd = options.longs === String ? String(message.ProgramEnd) : message.ProgramEnd;
                else
                    object.ProgramEnd = options.longs === String ? $util.Long.prototype.toString.call(message.ProgramEnd) : options.longs === Number ? new $util.LongBits(message.ProgramEnd.low >>> 0, message.ProgramEnd.high >>> 0).toNumber() : message.ProgramEnd;
            if (message.District != null && message.hasOwnProperty("District"))
                if (typeof message.District === "number")
                    object.District = options.longs === String ? String(message.District) : message.District;
                else
                    object.District = options.longs === String ? $util.Long.prototype.toString.call(message.District) : options.longs === Number ? new $util.LongBits(message.District.low >>> 0, message.District.high >>> 0).toNumber() : message.District;
            if (message.ProgramTypeCustom != null && message.hasOwnProperty("ProgramTypeCustom"))
                object.ProgramTypeCustom = message.ProgramTypeCustom;
            if (message.GroupCustom != null && message.hasOwnProperty("GroupCustom"))
                object.GroupCustom = message.GroupCustom;
            if (message.RegimCustom != null && message.hasOwnProperty("RegimCustom"))
                object.RegimCustom = message.RegimCustom;
            if (message.TimeType != null && message.hasOwnProperty("TimeType"))
                object.TimeType = options.enums === String ? $root.mediaarchiver.TalkTimeType[message.TimeType] : message.TimeType;
            return object;
        };

        /**
         * Converts this TalkDeprecated to JSON.
         * @function toJSON
         * @memberof mediaarchiver.TalkDeprecated
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TalkDeprecated.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TalkDeprecated;
    })();

    mediaarchiver.TalkSpeaker = (function() {

        /**
         * Properties of a TalkSpeaker.
         * @memberof mediaarchiver
         * @interface ITalkSpeaker
         * @property {number|Long|null} [Start] TalkSpeaker Start
         * @property {number|null} [DurationMS] TalkSpeaker DurationMS
         * @property {number|null} [ID] TalkSpeaker ID
         * @property {string|null} [Name] TalkSpeaker Name
         * @property {number|null} [Gender] TalkSpeaker Gender
         * @property {number|null} [Group] TalkSpeaker Group
         * @property {string|null} [GroupColor] TalkSpeaker GroupColor
         * @property {string|null} [GroupCustom] TalkSpeaker GroupCustom
         * @property {string|null} [Title] TalkSpeaker Title
         * @property {number|null} [Regim] TalkSpeaker Regim
         * @property {string|null} [RegimCustom] TalkSpeaker RegimCustom
         * @property {mediaarchiver.TalkSituationType|null} [Situation] TalkSpeaker Situation
         */

        /**
         * Constructs a new TalkSpeaker.
         * @memberof mediaarchiver
         * @classdesc Represents a TalkSpeaker.
         * @implements ITalkSpeaker
         * @constructor
         * @param {mediaarchiver.ITalkSpeaker=} [properties] Properties to set
         */
        function TalkSpeaker(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TalkSpeaker Start.
         * @member {number|Long} Start
         * @memberof mediaarchiver.TalkSpeaker
         * @instance
         */
        TalkSpeaker.prototype.Start = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * TalkSpeaker DurationMS.
         * @member {number} DurationMS
         * @memberof mediaarchiver.TalkSpeaker
         * @instance
         */
        TalkSpeaker.prototype.DurationMS = 0;

        /**
         * TalkSpeaker ID.
         * @member {number} ID
         * @memberof mediaarchiver.TalkSpeaker
         * @instance
         */
        TalkSpeaker.prototype.ID = 0;

        /**
         * TalkSpeaker Name.
         * @member {string} Name
         * @memberof mediaarchiver.TalkSpeaker
         * @instance
         */
        TalkSpeaker.prototype.Name = "";

        /**
         * TalkSpeaker Gender.
         * @member {number} Gender
         * @memberof mediaarchiver.TalkSpeaker
         * @instance
         */
        TalkSpeaker.prototype.Gender = 0;

        /**
         * TalkSpeaker Group.
         * @member {number} Group
         * @memberof mediaarchiver.TalkSpeaker
         * @instance
         */
        TalkSpeaker.prototype.Group = 0;

        /**
         * TalkSpeaker GroupColor.
         * @member {string} GroupColor
         * @memberof mediaarchiver.TalkSpeaker
         * @instance
         */
        TalkSpeaker.prototype.GroupColor = "";

        /**
         * TalkSpeaker GroupCustom.
         * @member {string} GroupCustom
         * @memberof mediaarchiver.TalkSpeaker
         * @instance
         */
        TalkSpeaker.prototype.GroupCustom = "";

        /**
         * TalkSpeaker Title.
         * @member {string} Title
         * @memberof mediaarchiver.TalkSpeaker
         * @instance
         */
        TalkSpeaker.prototype.Title = "";

        /**
         * TalkSpeaker Regim.
         * @member {number} Regim
         * @memberof mediaarchiver.TalkSpeaker
         * @instance
         */
        TalkSpeaker.prototype.Regim = 0;

        /**
         * TalkSpeaker RegimCustom.
         * @member {string} RegimCustom
         * @memberof mediaarchiver.TalkSpeaker
         * @instance
         */
        TalkSpeaker.prototype.RegimCustom = "";

        /**
         * TalkSpeaker Situation.
         * @member {mediaarchiver.TalkSituationType} Situation
         * @memberof mediaarchiver.TalkSpeaker
         * @instance
         */
        TalkSpeaker.prototype.Situation = 0;

        /**
         * Creates a new TalkSpeaker instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.TalkSpeaker
         * @static
         * @param {mediaarchiver.ITalkSpeaker=} [properties] Properties to set
         * @returns {mediaarchiver.TalkSpeaker} TalkSpeaker instance
         */
        TalkSpeaker.create = function create(properties) {
            return new TalkSpeaker(properties);
        };

        /**
         * Encodes the specified TalkSpeaker message. Does not implicitly {@link mediaarchiver.TalkSpeaker.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.TalkSpeaker
         * @static
         * @param {mediaarchiver.ITalkSpeaker} message TalkSpeaker message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkSpeaker.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Start != null && Object.hasOwnProperty.call(message, "Start"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.Start);
            if (message.DurationMS != null && Object.hasOwnProperty.call(message, "DurationMS"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.DurationMS);
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ID);
            if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.Name);
            if (message.Gender != null && Object.hasOwnProperty.call(message, "Gender"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.Gender);
            if (message.Group != null && Object.hasOwnProperty.call(message, "Group"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.Group);
            if (message.GroupColor != null && Object.hasOwnProperty.call(message, "GroupColor"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.GroupColor);
            if (message.GroupCustom != null && Object.hasOwnProperty.call(message, "GroupCustom"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.GroupCustom);
            if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.Title);
            if (message.Regim != null && Object.hasOwnProperty.call(message, "Regim"))
                writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.Regim);
            if (message.RegimCustom != null && Object.hasOwnProperty.call(message, "RegimCustom"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.RegimCustom);
            if (message.Situation != null && Object.hasOwnProperty.call(message, "Situation"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.Situation);
            return writer;
        };

        /**
         * Encodes the specified TalkSpeaker message, length delimited. Does not implicitly {@link mediaarchiver.TalkSpeaker.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.TalkSpeaker
         * @static
         * @param {mediaarchiver.ITalkSpeaker} message TalkSpeaker message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkSpeaker.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TalkSpeaker message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.TalkSpeaker
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.TalkSpeaker} TalkSpeaker
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkSpeaker.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.TalkSpeaker();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Start = reader.int64();
                    break;
                case 2:
                    message.DurationMS = reader.uint32();
                    break;
                case 3:
                    message.ID = reader.uint32();
                    break;
                case 4:
                    message.Name = reader.string();
                    break;
                case 5:
                    message.Gender = reader.uint32();
                    break;
                case 6:
                    message.Group = reader.uint32();
                    break;
                case 7:
                    message.GroupColor = reader.string();
                    break;
                case 8:
                    message.GroupCustom = reader.string();
                    break;
                case 9:
                    message.Title = reader.string();
                    break;
                case 10:
                    message.Regim = reader.uint32();
                    break;
                case 11:
                    message.RegimCustom = reader.string();
                    break;
                case 12:
                    message.Situation = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TalkSpeaker message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.TalkSpeaker
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.TalkSpeaker} TalkSpeaker
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkSpeaker.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TalkSpeaker message.
         * @function verify
         * @memberof mediaarchiver.TalkSpeaker
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TalkSpeaker.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (!$util.isInteger(message.Start) && !(message.Start && $util.isInteger(message.Start.low) && $util.isInteger(message.Start.high)))
                    return "Start: integer|Long expected";
            if (message.DurationMS != null && message.hasOwnProperty("DurationMS"))
                if (!$util.isInteger(message.DurationMS))
                    return "DurationMS: integer expected";
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isInteger(message.ID))
                    return "ID: integer expected";
            if (message.Name != null && message.hasOwnProperty("Name"))
                if (!$util.isString(message.Name))
                    return "Name: string expected";
            if (message.Gender != null && message.hasOwnProperty("Gender"))
                if (!$util.isInteger(message.Gender))
                    return "Gender: integer expected";
            if (message.Group != null && message.hasOwnProperty("Group"))
                if (!$util.isInteger(message.Group))
                    return "Group: integer expected";
            if (message.GroupColor != null && message.hasOwnProperty("GroupColor"))
                if (!$util.isString(message.GroupColor))
                    return "GroupColor: string expected";
            if (message.GroupCustom != null && message.hasOwnProperty("GroupCustom"))
                if (!$util.isString(message.GroupCustom))
                    return "GroupCustom: string expected";
            if (message.Title != null && message.hasOwnProperty("Title"))
                if (!$util.isString(message.Title))
                    return "Title: string expected";
            if (message.Regim != null && message.hasOwnProperty("Regim"))
                if (!$util.isInteger(message.Regim))
                    return "Regim: integer expected";
            if (message.RegimCustom != null && message.hasOwnProperty("RegimCustom"))
                if (!$util.isString(message.RegimCustom))
                    return "RegimCustom: string expected";
            if (message.Situation != null && message.hasOwnProperty("Situation"))
                switch (message.Situation) {
                default:
                    return "Situation: enum value expected";
                case 0:
                case 1:
                    break;
                }
            return null;
        };

        /**
         * Creates a TalkSpeaker message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.TalkSpeaker
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.TalkSpeaker} TalkSpeaker
         */
        TalkSpeaker.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.TalkSpeaker)
                return object;
            let message = new $root.mediaarchiver.TalkSpeaker();
            if (object.Start != null)
                if ($util.Long)
                    (message.Start = $util.Long.fromValue(object.Start)).unsigned = false;
                else if (typeof object.Start === "string")
                    message.Start = parseInt(object.Start, 10);
                else if (typeof object.Start === "number")
                    message.Start = object.Start;
                else if (typeof object.Start === "object")
                    message.Start = new $util.LongBits(object.Start.low >>> 0, object.Start.high >>> 0).toNumber();
            if (object.DurationMS != null)
                message.DurationMS = object.DurationMS >>> 0;
            if (object.ID != null)
                message.ID = object.ID >>> 0;
            if (object.Name != null)
                message.Name = String(object.Name);
            if (object.Gender != null)
                message.Gender = object.Gender >>> 0;
            if (object.Group != null)
                message.Group = object.Group >>> 0;
            if (object.GroupColor != null)
                message.GroupColor = String(object.GroupColor);
            if (object.GroupCustom != null)
                message.GroupCustom = String(object.GroupCustom);
            if (object.Title != null)
                message.Title = String(object.Title);
            if (object.Regim != null)
                message.Regim = object.Regim >>> 0;
            if (object.RegimCustom != null)
                message.RegimCustom = String(object.RegimCustom);
            switch (object.Situation) {
            case "TALK_SITUATION_TYPE_INVITED":
            case 0:
                message.Situation = 0;
                break;
            case "TALK_SITUATION_TYPE_REPORTAGE":
            case 1:
                message.Situation = 1;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a TalkSpeaker message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.TalkSpeaker
         * @static
         * @param {mediaarchiver.TalkSpeaker} message TalkSpeaker
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TalkSpeaker.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.Start = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.Start = options.longs === String ? "0" : 0;
                object.DurationMS = 0;
                object.ID = 0;
                object.Name = "";
                object.Gender = 0;
                object.Group = 0;
                object.GroupColor = "";
                object.GroupCustom = "";
                object.Title = "";
                object.Regim = 0;
                object.RegimCustom = "";
                object.Situation = options.enums === String ? "TALK_SITUATION_TYPE_INVITED" : 0;
            }
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (typeof message.Start === "number")
                    object.Start = options.longs === String ? String(message.Start) : message.Start;
                else
                    object.Start = options.longs === String ? $util.Long.prototype.toString.call(message.Start) : options.longs === Number ? new $util.LongBits(message.Start.low >>> 0, message.Start.high >>> 0).toNumber() : message.Start;
            if (message.DurationMS != null && message.hasOwnProperty("DurationMS"))
                object.DurationMS = message.DurationMS;
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            if (message.Name != null && message.hasOwnProperty("Name"))
                object.Name = message.Name;
            if (message.Gender != null && message.hasOwnProperty("Gender"))
                object.Gender = message.Gender;
            if (message.Group != null && message.hasOwnProperty("Group"))
                object.Group = message.Group;
            if (message.GroupColor != null && message.hasOwnProperty("GroupColor"))
                object.GroupColor = message.GroupColor;
            if (message.GroupCustom != null && message.hasOwnProperty("GroupCustom"))
                object.GroupCustom = message.GroupCustom;
            if (message.Title != null && message.hasOwnProperty("Title"))
                object.Title = message.Title;
            if (message.Regim != null && message.hasOwnProperty("Regim"))
                object.Regim = message.Regim;
            if (message.RegimCustom != null && message.hasOwnProperty("RegimCustom"))
                object.RegimCustom = message.RegimCustom;
            if (message.Situation != null && message.hasOwnProperty("Situation"))
                object.Situation = options.enums === String ? $root.mediaarchiver.TalkSituationType[message.Situation] : message.Situation;
            return object;
        };

        /**
         * Converts this TalkSpeaker to JSON.
         * @function toJSON
         * @memberof mediaarchiver.TalkSpeaker
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TalkSpeaker.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TalkSpeaker;
    })();

    mediaarchiver.Talk = (function() {

        /**
         * Properties of a Talk.
         * @memberof mediaarchiver
         * @interface ITalk
         * @property {string|null} [ID] Talk ID
         * @property {mediaarchiver.TalkTalkType|null} [TalkType] Talk TalkType
         * @property {mediaarchiver.TalkTimeType|null} [TimeType] Talk TimeType
         * @property {number|null} [Study] Talk Study
         * @property {string|null} [StudyCode] Talk StudyCode
         * @property {number|null} [District] Talk District
         * @property {number|null} [Owner] Talk Owner
         * @property {string|null} [OwnerName] Talk OwnerName
         * @property {number|null} [Company] Talk Company
         * @property {string|null} [Comment] Talk Comment
         * @property {number|null} [Media] Talk Media
         * @property {number|null} [ProgramID] Talk ProgramID
         * @property {string|null} [ProgramName] Talk ProgramName
         * @property {number|null} [ProgramType] Talk ProgramType
         * @property {string|null} [ProgramTypeCode] Talk ProgramTypeCode
         * @property {string|null} [ProgramTypeCustom] Talk ProgramTypeCustom
         * @property {number|Long|null} [ProgramStart] Talk ProgramStart
         * @property {number|Long|null} [ProgramEnd] Talk ProgramEnd
         * @property {Array.<mediaarchiver.ITalkSpeaker>|null} [Speakers] Talk Speakers
         */

        /**
         * Constructs a new Talk.
         * @memberof mediaarchiver
         * @classdesc Represents a Talk.
         * @implements ITalk
         * @constructor
         * @param {mediaarchiver.ITalk=} [properties] Properties to set
         */
        function Talk(properties) {
            this.Speakers = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Talk ID.
         * @member {string} ID
         * @memberof mediaarchiver.Talk
         * @instance
         */
        Talk.prototype.ID = "";

        /**
         * Talk TalkType.
         * @member {mediaarchiver.TalkTalkType} TalkType
         * @memberof mediaarchiver.Talk
         * @instance
         */
        Talk.prototype.TalkType = 0;

        /**
         * Talk TimeType.
         * @member {mediaarchiver.TalkTimeType} TimeType
         * @memberof mediaarchiver.Talk
         * @instance
         */
        Talk.prototype.TimeType = 0;

        /**
         * Talk Study.
         * @member {number} Study
         * @memberof mediaarchiver.Talk
         * @instance
         */
        Talk.prototype.Study = 0;

        /**
         * Talk StudyCode.
         * @member {string} StudyCode
         * @memberof mediaarchiver.Talk
         * @instance
         */
        Talk.prototype.StudyCode = "";

        /**
         * Talk District.
         * @member {number} District
         * @memberof mediaarchiver.Talk
         * @instance
         */
        Talk.prototype.District = 0;

        /**
         * Talk Owner.
         * @member {number} Owner
         * @memberof mediaarchiver.Talk
         * @instance
         */
        Talk.prototype.Owner = 0;

        /**
         * Talk OwnerName.
         * @member {string} OwnerName
         * @memberof mediaarchiver.Talk
         * @instance
         */
        Talk.prototype.OwnerName = "";

        /**
         * Talk Company.
         * @member {number} Company
         * @memberof mediaarchiver.Talk
         * @instance
         */
        Talk.prototype.Company = 0;

        /**
         * Talk Comment.
         * @member {string} Comment
         * @memberof mediaarchiver.Talk
         * @instance
         */
        Talk.prototype.Comment = "";

        /**
         * Talk Media.
         * @member {number} Media
         * @memberof mediaarchiver.Talk
         * @instance
         */
        Talk.prototype.Media = 0;

        /**
         * Talk ProgramID.
         * @member {number} ProgramID
         * @memberof mediaarchiver.Talk
         * @instance
         */
        Talk.prototype.ProgramID = 0;

        /**
         * Talk ProgramName.
         * @member {string} ProgramName
         * @memberof mediaarchiver.Talk
         * @instance
         */
        Talk.prototype.ProgramName = "";

        /**
         * Talk ProgramType.
         * @member {number} ProgramType
         * @memberof mediaarchiver.Talk
         * @instance
         */
        Talk.prototype.ProgramType = 0;

        /**
         * Talk ProgramTypeCode.
         * @member {string} ProgramTypeCode
         * @memberof mediaarchiver.Talk
         * @instance
         */
        Talk.prototype.ProgramTypeCode = "";

        /**
         * Talk ProgramTypeCustom.
         * @member {string} ProgramTypeCustom
         * @memberof mediaarchiver.Talk
         * @instance
         */
        Talk.prototype.ProgramTypeCustom = "";

        /**
         * Talk ProgramStart.
         * @member {number|Long} ProgramStart
         * @memberof mediaarchiver.Talk
         * @instance
         */
        Talk.prototype.ProgramStart = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Talk ProgramEnd.
         * @member {number|Long} ProgramEnd
         * @memberof mediaarchiver.Talk
         * @instance
         */
        Talk.prototype.ProgramEnd = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Talk Speakers.
         * @member {Array.<mediaarchiver.ITalkSpeaker>} Speakers
         * @memberof mediaarchiver.Talk
         * @instance
         */
        Talk.prototype.Speakers = $util.emptyArray;

        /**
         * Creates a new Talk instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.Talk
         * @static
         * @param {mediaarchiver.ITalk=} [properties] Properties to set
         * @returns {mediaarchiver.Talk} Talk instance
         */
        Talk.create = function create(properties) {
            return new Talk(properties);
        };

        /**
         * Encodes the specified Talk message. Does not implicitly {@link mediaarchiver.Talk.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.Talk
         * @static
         * @param {mediaarchiver.ITalk} message Talk message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Talk.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.ID);
            if (message.TalkType != null && Object.hasOwnProperty.call(message, "TalkType"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.TalkType);
            if (message.TimeType != null && Object.hasOwnProperty.call(message, "TimeType"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.TimeType);
            if (message.Study != null && Object.hasOwnProperty.call(message, "Study"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.Study);
            if (message.StudyCode != null && Object.hasOwnProperty.call(message, "StudyCode"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.StudyCode);
            if (message.District != null && Object.hasOwnProperty.call(message, "District"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.District);
            if (message.Owner != null && Object.hasOwnProperty.call(message, "Owner"))
                writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.Owner);
            if (message.OwnerName != null && Object.hasOwnProperty.call(message, "OwnerName"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.OwnerName);
            if (message.Company != null && Object.hasOwnProperty.call(message, "Company"))
                writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.Company);
            if (message.Comment != null && Object.hasOwnProperty.call(message, "Comment"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.Comment);
            if (message.Media != null && Object.hasOwnProperty.call(message, "Media"))
                writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.Media);
            if (message.ProgramID != null && Object.hasOwnProperty.call(message, "ProgramID"))
                writer.uint32(/* id 12, wireType 0 =*/96).uint32(message.ProgramID);
            if (message.ProgramName != null && Object.hasOwnProperty.call(message, "ProgramName"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.ProgramName);
            if (message.ProgramType != null && Object.hasOwnProperty.call(message, "ProgramType"))
                writer.uint32(/* id 14, wireType 0 =*/112).uint32(message.ProgramType);
            if (message.ProgramTypeCode != null && Object.hasOwnProperty.call(message, "ProgramTypeCode"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.ProgramTypeCode);
            if (message.ProgramTypeCustom != null && Object.hasOwnProperty.call(message, "ProgramTypeCustom"))
                writer.uint32(/* id 16, wireType 2 =*/130).string(message.ProgramTypeCustom);
            if (message.ProgramStart != null && Object.hasOwnProperty.call(message, "ProgramStart"))
                writer.uint32(/* id 17, wireType 0 =*/136).int64(message.ProgramStart);
            if (message.ProgramEnd != null && Object.hasOwnProperty.call(message, "ProgramEnd"))
                writer.uint32(/* id 18, wireType 0 =*/144).int64(message.ProgramEnd);
            if (message.Speakers != null && message.Speakers.length)
                for (let i = 0; i < message.Speakers.length; ++i)
                    $root.mediaarchiver.TalkSpeaker.encode(message.Speakers[i], writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Talk message, length delimited. Does not implicitly {@link mediaarchiver.Talk.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.Talk
         * @static
         * @param {mediaarchiver.ITalk} message Talk message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Talk.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Talk message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.Talk
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.Talk} Talk
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Talk.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.Talk();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ID = reader.string();
                    break;
                case 2:
                    message.TalkType = reader.int32();
                    break;
                case 3:
                    message.TimeType = reader.int32();
                    break;
                case 4:
                    message.Study = reader.uint32();
                    break;
                case 5:
                    message.StudyCode = reader.string();
                    break;
                case 6:
                    message.District = reader.uint32();
                    break;
                case 7:
                    message.Owner = reader.uint32();
                    break;
                case 8:
                    message.OwnerName = reader.string();
                    break;
                case 9:
                    message.Company = reader.uint32();
                    break;
                case 10:
                    message.Comment = reader.string();
                    break;
                case 11:
                    message.Media = reader.uint32();
                    break;
                case 12:
                    message.ProgramID = reader.uint32();
                    break;
                case 13:
                    message.ProgramName = reader.string();
                    break;
                case 14:
                    message.ProgramType = reader.uint32();
                    break;
                case 15:
                    message.ProgramTypeCode = reader.string();
                    break;
                case 16:
                    message.ProgramTypeCustom = reader.string();
                    break;
                case 17:
                    message.ProgramStart = reader.int64();
                    break;
                case 18:
                    message.ProgramEnd = reader.int64();
                    break;
                case 19:
                    if (!(message.Speakers && message.Speakers.length))
                        message.Speakers = [];
                    message.Speakers.push($root.mediaarchiver.TalkSpeaker.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Talk message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.Talk
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.Talk} Talk
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Talk.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Talk message.
         * @function verify
         * @memberof mediaarchiver.Talk
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Talk.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isString(message.ID))
                    return "ID: string expected";
            if (message.TalkType != null && message.hasOwnProperty("TalkType"))
                switch (message.TalkType) {
                default:
                    return "TalkType: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.TimeType != null && message.hasOwnProperty("TimeType"))
                switch (message.TimeType) {
                default:
                    return "TimeType: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.Study != null && message.hasOwnProperty("Study"))
                if (!$util.isInteger(message.Study))
                    return "Study: integer expected";
            if (message.StudyCode != null && message.hasOwnProperty("StudyCode"))
                if (!$util.isString(message.StudyCode))
                    return "StudyCode: string expected";
            if (message.District != null && message.hasOwnProperty("District"))
                if (!$util.isInteger(message.District))
                    return "District: integer expected";
            if (message.Owner != null && message.hasOwnProperty("Owner"))
                if (!$util.isInteger(message.Owner))
                    return "Owner: integer expected";
            if (message.OwnerName != null && message.hasOwnProperty("OwnerName"))
                if (!$util.isString(message.OwnerName))
                    return "OwnerName: string expected";
            if (message.Company != null && message.hasOwnProperty("Company"))
                if (!$util.isInteger(message.Company))
                    return "Company: integer expected";
            if (message.Comment != null && message.hasOwnProperty("Comment"))
                if (!$util.isString(message.Comment))
                    return "Comment: string expected";
            if (message.Media != null && message.hasOwnProperty("Media"))
                if (!$util.isInteger(message.Media))
                    return "Media: integer expected";
            if (message.ProgramID != null && message.hasOwnProperty("ProgramID"))
                if (!$util.isInteger(message.ProgramID))
                    return "ProgramID: integer expected";
            if (message.ProgramName != null && message.hasOwnProperty("ProgramName"))
                if (!$util.isString(message.ProgramName))
                    return "ProgramName: string expected";
            if (message.ProgramType != null && message.hasOwnProperty("ProgramType"))
                if (!$util.isInteger(message.ProgramType))
                    return "ProgramType: integer expected";
            if (message.ProgramTypeCode != null && message.hasOwnProperty("ProgramTypeCode"))
                if (!$util.isString(message.ProgramTypeCode))
                    return "ProgramTypeCode: string expected";
            if (message.ProgramTypeCustom != null && message.hasOwnProperty("ProgramTypeCustom"))
                if (!$util.isString(message.ProgramTypeCustom))
                    return "ProgramTypeCustom: string expected";
            if (message.ProgramStart != null && message.hasOwnProperty("ProgramStart"))
                if (!$util.isInteger(message.ProgramStart) && !(message.ProgramStart && $util.isInteger(message.ProgramStart.low) && $util.isInteger(message.ProgramStart.high)))
                    return "ProgramStart: integer|Long expected";
            if (message.ProgramEnd != null && message.hasOwnProperty("ProgramEnd"))
                if (!$util.isInteger(message.ProgramEnd) && !(message.ProgramEnd && $util.isInteger(message.ProgramEnd.low) && $util.isInteger(message.ProgramEnd.high)))
                    return "ProgramEnd: integer|Long expected";
            if (message.Speakers != null && message.hasOwnProperty("Speakers")) {
                if (!Array.isArray(message.Speakers))
                    return "Speakers: array expected";
                for (let i = 0; i < message.Speakers.length; ++i) {
                    let error = $root.mediaarchiver.TalkSpeaker.verify(message.Speakers[i]);
                    if (error)
                        return "Speakers." + error;
                }
            }
            return null;
        };

        /**
         * Creates a Talk message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.Talk
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.Talk} Talk
         */
        Talk.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.Talk)
                return object;
            let message = new $root.mediaarchiver.Talk();
            if (object.ID != null)
                message.ID = String(object.ID);
            switch (object.TalkType) {
            case "TALK_TALK_TYPE_UNKNOWN":
            case 0:
                message.TalkType = 0;
                break;
            case "TALK_TALK_TYPE_ADJUSTED":
            case 1:
                message.TalkType = 1;
                break;
            case "TALK_TALK_TYPE_AGGREGATED":
            case 2:
                message.TalkType = 2;
                break;
            }
            switch (object.TimeType) {
            case "TALK_TIME_TYPE_UNKNOWN":
            case 0:
                message.TimeType = 0;
                break;
            case "TALK_TIME_TYPE_SPEAK":
            case 1:
                message.TimeType = 1;
                break;
            case "TALK_TIME_TYPE_BROADCAST":
            case 2:
                message.TimeType = 2;
                break;
            }
            if (object.Study != null)
                message.Study = object.Study >>> 0;
            if (object.StudyCode != null)
                message.StudyCode = String(object.StudyCode);
            if (object.District != null)
                message.District = object.District >>> 0;
            if (object.Owner != null)
                message.Owner = object.Owner >>> 0;
            if (object.OwnerName != null)
                message.OwnerName = String(object.OwnerName);
            if (object.Company != null)
                message.Company = object.Company >>> 0;
            if (object.Comment != null)
                message.Comment = String(object.Comment);
            if (object.Media != null)
                message.Media = object.Media >>> 0;
            if (object.ProgramID != null)
                message.ProgramID = object.ProgramID >>> 0;
            if (object.ProgramName != null)
                message.ProgramName = String(object.ProgramName);
            if (object.ProgramType != null)
                message.ProgramType = object.ProgramType >>> 0;
            if (object.ProgramTypeCode != null)
                message.ProgramTypeCode = String(object.ProgramTypeCode);
            if (object.ProgramTypeCustom != null)
                message.ProgramTypeCustom = String(object.ProgramTypeCustom);
            if (object.ProgramStart != null)
                if ($util.Long)
                    (message.ProgramStart = $util.Long.fromValue(object.ProgramStart)).unsigned = false;
                else if (typeof object.ProgramStart === "string")
                    message.ProgramStart = parseInt(object.ProgramStart, 10);
                else if (typeof object.ProgramStart === "number")
                    message.ProgramStart = object.ProgramStart;
                else if (typeof object.ProgramStart === "object")
                    message.ProgramStart = new $util.LongBits(object.ProgramStart.low >>> 0, object.ProgramStart.high >>> 0).toNumber();
            if (object.ProgramEnd != null)
                if ($util.Long)
                    (message.ProgramEnd = $util.Long.fromValue(object.ProgramEnd)).unsigned = false;
                else if (typeof object.ProgramEnd === "string")
                    message.ProgramEnd = parseInt(object.ProgramEnd, 10);
                else if (typeof object.ProgramEnd === "number")
                    message.ProgramEnd = object.ProgramEnd;
                else if (typeof object.ProgramEnd === "object")
                    message.ProgramEnd = new $util.LongBits(object.ProgramEnd.low >>> 0, object.ProgramEnd.high >>> 0).toNumber();
            if (object.Speakers) {
                if (!Array.isArray(object.Speakers))
                    throw TypeError(".mediaarchiver.Talk.Speakers: array expected");
                message.Speakers = [];
                for (let i = 0; i < object.Speakers.length; ++i) {
                    if (typeof object.Speakers[i] !== "object")
                        throw TypeError(".mediaarchiver.Talk.Speakers: object expected");
                    message.Speakers[i] = $root.mediaarchiver.TalkSpeaker.fromObject(object.Speakers[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a Talk message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.Talk
         * @static
         * @param {mediaarchiver.Talk} message Talk
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Talk.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Speakers = [];
            if (options.defaults) {
                object.ID = "";
                object.TalkType = options.enums === String ? "TALK_TALK_TYPE_UNKNOWN" : 0;
                object.TimeType = options.enums === String ? "TALK_TIME_TYPE_UNKNOWN" : 0;
                object.Study = 0;
                object.StudyCode = "";
                object.District = 0;
                object.Owner = 0;
                object.OwnerName = "";
                object.Company = 0;
                object.Comment = "";
                object.Media = 0;
                object.ProgramID = 0;
                object.ProgramName = "";
                object.ProgramType = 0;
                object.ProgramTypeCode = "";
                object.ProgramTypeCustom = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.ProgramStart = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.ProgramStart = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.ProgramEnd = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.ProgramEnd = options.longs === String ? "0" : 0;
            }
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            if (message.TalkType != null && message.hasOwnProperty("TalkType"))
                object.TalkType = options.enums === String ? $root.mediaarchiver.TalkTalkType[message.TalkType] : message.TalkType;
            if (message.TimeType != null && message.hasOwnProperty("TimeType"))
                object.TimeType = options.enums === String ? $root.mediaarchiver.TalkTimeType[message.TimeType] : message.TimeType;
            if (message.Study != null && message.hasOwnProperty("Study"))
                object.Study = message.Study;
            if (message.StudyCode != null && message.hasOwnProperty("StudyCode"))
                object.StudyCode = message.StudyCode;
            if (message.District != null && message.hasOwnProperty("District"))
                object.District = message.District;
            if (message.Owner != null && message.hasOwnProperty("Owner"))
                object.Owner = message.Owner;
            if (message.OwnerName != null && message.hasOwnProperty("OwnerName"))
                object.OwnerName = message.OwnerName;
            if (message.Company != null && message.hasOwnProperty("Company"))
                object.Company = message.Company;
            if (message.Comment != null && message.hasOwnProperty("Comment"))
                object.Comment = message.Comment;
            if (message.Media != null && message.hasOwnProperty("Media"))
                object.Media = message.Media;
            if (message.ProgramID != null && message.hasOwnProperty("ProgramID"))
                object.ProgramID = message.ProgramID;
            if (message.ProgramName != null && message.hasOwnProperty("ProgramName"))
                object.ProgramName = message.ProgramName;
            if (message.ProgramType != null && message.hasOwnProperty("ProgramType"))
                object.ProgramType = message.ProgramType;
            if (message.ProgramTypeCode != null && message.hasOwnProperty("ProgramTypeCode"))
                object.ProgramTypeCode = message.ProgramTypeCode;
            if (message.ProgramTypeCustom != null && message.hasOwnProperty("ProgramTypeCustom"))
                object.ProgramTypeCustom = message.ProgramTypeCustom;
            if (message.ProgramStart != null && message.hasOwnProperty("ProgramStart"))
                if (typeof message.ProgramStart === "number")
                    object.ProgramStart = options.longs === String ? String(message.ProgramStart) : message.ProgramStart;
                else
                    object.ProgramStart = options.longs === String ? $util.Long.prototype.toString.call(message.ProgramStart) : options.longs === Number ? new $util.LongBits(message.ProgramStart.low >>> 0, message.ProgramStart.high >>> 0).toNumber() : message.ProgramStart;
            if (message.ProgramEnd != null && message.hasOwnProperty("ProgramEnd"))
                if (typeof message.ProgramEnd === "number")
                    object.ProgramEnd = options.longs === String ? String(message.ProgramEnd) : message.ProgramEnd;
                else
                    object.ProgramEnd = options.longs === String ? $util.Long.prototype.toString.call(message.ProgramEnd) : options.longs === Number ? new $util.LongBits(message.ProgramEnd.low >>> 0, message.ProgramEnd.high >>> 0).toNumber() : message.ProgramEnd;
            if (message.Speakers && message.Speakers.length) {
                object.Speakers = [];
                for (let j = 0; j < message.Speakers.length; ++j)
                    object.Speakers[j] = $root.mediaarchiver.TalkSpeaker.toObject(message.Speakers[j], options);
            }
            return object;
        };

        /**
         * Converts this Talk to JSON.
         * @function toJSON
         * @memberof mediaarchiver.Talk
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Talk.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Talk;
    })();

    mediaarchiver.ArgumentsTalks = (function() {

        /**
         * Properties of an ArgumentsTalks.
         * @memberof mediaarchiver
         * @interface IArgumentsTalks
         * @property {number|null} [Offset] ArgumentsTalks Offset
         * @property {number|null} [Count] ArgumentsTalks Count
         * @property {Array.<mediaarchiver.ITalk>|null} [Talks] ArgumentsTalks Talks
         */

        /**
         * Constructs a new ArgumentsTalks.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsTalks.
         * @implements IArgumentsTalks
         * @constructor
         * @param {mediaarchiver.IArgumentsTalks=} [properties] Properties to set
         */
        function ArgumentsTalks(properties) {
            this.Talks = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsTalks Offset.
         * @member {number} Offset
         * @memberof mediaarchiver.ArgumentsTalks
         * @instance
         */
        ArgumentsTalks.prototype.Offset = 0;

        /**
         * ArgumentsTalks Count.
         * @member {number} Count
         * @memberof mediaarchiver.ArgumentsTalks
         * @instance
         */
        ArgumentsTalks.prototype.Count = 0;

        /**
         * ArgumentsTalks Talks.
         * @member {Array.<mediaarchiver.ITalk>} Talks
         * @memberof mediaarchiver.ArgumentsTalks
         * @instance
         */
        ArgumentsTalks.prototype.Talks = $util.emptyArray;

        /**
         * Creates a new ArgumentsTalks instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsTalks
         * @static
         * @param {mediaarchiver.IArgumentsTalks=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsTalks} ArgumentsTalks instance
         */
        ArgumentsTalks.create = function create(properties) {
            return new ArgumentsTalks(properties);
        };

        /**
         * Encodes the specified ArgumentsTalks message. Does not implicitly {@link mediaarchiver.ArgumentsTalks.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsTalks
         * @static
         * @param {mediaarchiver.IArgumentsTalks} message ArgumentsTalks message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsTalks.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Offset != null && Object.hasOwnProperty.call(message, "Offset"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Offset);
            if (message.Count != null && Object.hasOwnProperty.call(message, "Count"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Count);
            if (message.Talks != null && message.Talks.length)
                for (let i = 0; i < message.Talks.length; ++i)
                    $root.mediaarchiver.Talk.encode(message.Talks[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ArgumentsTalks message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsTalks.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsTalks
         * @static
         * @param {mediaarchiver.IArgumentsTalks} message ArgumentsTalks message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsTalks.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsTalks message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsTalks
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsTalks} ArgumentsTalks
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsTalks.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsTalks();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Offset = reader.uint32();
                    break;
                case 2:
                    message.Count = reader.uint32();
                    break;
                case 3:
                    if (!(message.Talks && message.Talks.length))
                        message.Talks = [];
                    message.Talks.push($root.mediaarchiver.Talk.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsTalks message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsTalks
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsTalks} ArgumentsTalks
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsTalks.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsTalks message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsTalks
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsTalks.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                if (!$util.isInteger(message.Offset))
                    return "Offset: integer expected";
            if (message.Count != null && message.hasOwnProperty("Count"))
                if (!$util.isInteger(message.Count))
                    return "Count: integer expected";
            if (message.Talks != null && message.hasOwnProperty("Talks")) {
                if (!Array.isArray(message.Talks))
                    return "Talks: array expected";
                for (let i = 0; i < message.Talks.length; ++i) {
                    let error = $root.mediaarchiver.Talk.verify(message.Talks[i]);
                    if (error)
                        return "Talks." + error;
                }
            }
            return null;
        };

        /**
         * Creates an ArgumentsTalks message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsTalks
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsTalks} ArgumentsTalks
         */
        ArgumentsTalks.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsTalks)
                return object;
            let message = new $root.mediaarchiver.ArgumentsTalks();
            if (object.Offset != null)
                message.Offset = object.Offset >>> 0;
            if (object.Count != null)
                message.Count = object.Count >>> 0;
            if (object.Talks) {
                if (!Array.isArray(object.Talks))
                    throw TypeError(".mediaarchiver.ArgumentsTalks.Talks: array expected");
                message.Talks = [];
                for (let i = 0; i < object.Talks.length; ++i) {
                    if (typeof object.Talks[i] !== "object")
                        throw TypeError(".mediaarchiver.ArgumentsTalks.Talks: object expected");
                    message.Talks[i] = $root.mediaarchiver.Talk.fromObject(object.Talks[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsTalks message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsTalks
         * @static
         * @param {mediaarchiver.ArgumentsTalks} message ArgumentsTalks
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsTalks.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Talks = [];
            if (options.defaults) {
                object.Offset = 0;
                object.Count = 0;
            }
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                object.Offset = message.Offset;
            if (message.Count != null && message.hasOwnProperty("Count"))
                object.Count = message.Count;
            if (message.Talks && message.Talks.length) {
                object.Talks = [];
                for (let j = 0; j < message.Talks.length; ++j)
                    object.Talks[j] = $root.mediaarchiver.Talk.toObject(message.Talks[j], options);
            }
            return object;
        };

        /**
         * Converts this ArgumentsTalks to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsTalks
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsTalks.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsTalks;
    })();

    mediaarchiver.ArgumentsGetTalks = (function() {

        /**
         * Properties of an ArgumentsGetTalks.
         * @memberof mediaarchiver
         * @interface IArgumentsGetTalks
         * @property {Array.<number>|null} [Medias] ArgumentsGetTalks Medias
         * @property {mediaarchiver.TalkStudyType|null} [Type] ArgumentsGetTalks Type
         * @property {number|Long|null} [DateStart] ArgumentsGetTalks DateStart
         * @property {number|Long|null} [DateEnd] ArgumentsGetTalks DateEnd
         * @property {number|null} [Limit] ArgumentsGetTalks Limit
         * @property {number|null} [Offset] ArgumentsGetTalks Offset
         * @property {string|null} [Sort] ArgumentsGetTalks Sort
         * @property {boolean|null} [SortDesc] ArgumentsGetTalks SortDesc
         */

        /**
         * Constructs a new ArgumentsGetTalks.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsGetTalks.
         * @implements IArgumentsGetTalks
         * @constructor
         * @param {mediaarchiver.IArgumentsGetTalks=} [properties] Properties to set
         */
        function ArgumentsGetTalks(properties) {
            this.Medias = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsGetTalks Medias.
         * @member {Array.<number>} Medias
         * @memberof mediaarchiver.ArgumentsGetTalks
         * @instance
         */
        ArgumentsGetTalks.prototype.Medias = $util.emptyArray;

        /**
         * ArgumentsGetTalks Type.
         * @member {mediaarchiver.TalkStudyType} Type
         * @memberof mediaarchiver.ArgumentsGetTalks
         * @instance
         */
        ArgumentsGetTalks.prototype.Type = 0;

        /**
         * ArgumentsGetTalks DateStart.
         * @member {number|Long} DateStart
         * @memberof mediaarchiver.ArgumentsGetTalks
         * @instance
         */
        ArgumentsGetTalks.prototype.DateStart = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ArgumentsGetTalks DateEnd.
         * @member {number|Long} DateEnd
         * @memberof mediaarchiver.ArgumentsGetTalks
         * @instance
         */
        ArgumentsGetTalks.prototype.DateEnd = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ArgumentsGetTalks Limit.
         * @member {number} Limit
         * @memberof mediaarchiver.ArgumentsGetTalks
         * @instance
         */
        ArgumentsGetTalks.prototype.Limit = 0;

        /**
         * ArgumentsGetTalks Offset.
         * @member {number} Offset
         * @memberof mediaarchiver.ArgumentsGetTalks
         * @instance
         */
        ArgumentsGetTalks.prototype.Offset = 0;

        /**
         * ArgumentsGetTalks Sort.
         * @member {string} Sort
         * @memberof mediaarchiver.ArgumentsGetTalks
         * @instance
         */
        ArgumentsGetTalks.prototype.Sort = "";

        /**
         * ArgumentsGetTalks SortDesc.
         * @member {boolean} SortDesc
         * @memberof mediaarchiver.ArgumentsGetTalks
         * @instance
         */
        ArgumentsGetTalks.prototype.SortDesc = false;

        /**
         * Creates a new ArgumentsGetTalks instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsGetTalks
         * @static
         * @param {mediaarchiver.IArgumentsGetTalks=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsGetTalks} ArgumentsGetTalks instance
         */
        ArgumentsGetTalks.create = function create(properties) {
            return new ArgumentsGetTalks(properties);
        };

        /**
         * Encodes the specified ArgumentsGetTalks message. Does not implicitly {@link mediaarchiver.ArgumentsGetTalks.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsGetTalks
         * @static
         * @param {mediaarchiver.IArgumentsGetTalks} message ArgumentsGetTalks message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetTalks.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Medias != null && message.Medias.length) {
                writer.uint32(/* id 1, wireType 2 =*/10).fork();
                for (let i = 0; i < message.Medias.length; ++i)
                    writer.uint32(message.Medias[i]);
                writer.ldelim();
            }
            if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.Type);
            if (message.DateStart != null && Object.hasOwnProperty.call(message, "DateStart"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.DateStart);
            if (message.DateEnd != null && Object.hasOwnProperty.call(message, "DateEnd"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.DateEnd);
            if (message.Limit != null && Object.hasOwnProperty.call(message, "Limit"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.Limit);
            if (message.Offset != null && Object.hasOwnProperty.call(message, "Offset"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.Offset);
            if (message.Sort != null && Object.hasOwnProperty.call(message, "Sort"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.Sort);
            if (message.SortDesc != null && Object.hasOwnProperty.call(message, "SortDesc"))
                writer.uint32(/* id 8, wireType 0 =*/64).bool(message.SortDesc);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsGetTalks message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsGetTalks.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsGetTalks
         * @static
         * @param {mediaarchiver.IArgumentsGetTalks} message ArgumentsGetTalks message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetTalks.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsGetTalks message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsGetTalks
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsGetTalks} ArgumentsGetTalks
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetTalks.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsGetTalks();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.Medias && message.Medias.length))
                        message.Medias = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.Medias.push(reader.uint32());
                    } else
                        message.Medias.push(reader.uint32());
                    break;
                case 2:
                    message.Type = reader.int32();
                    break;
                case 3:
                    message.DateStart = reader.int64();
                    break;
                case 4:
                    message.DateEnd = reader.int64();
                    break;
                case 5:
                    message.Limit = reader.uint32();
                    break;
                case 6:
                    message.Offset = reader.uint32();
                    break;
                case 7:
                    message.Sort = reader.string();
                    break;
                case 8:
                    message.SortDesc = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsGetTalks message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsGetTalks
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsGetTalks} ArgumentsGetTalks
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetTalks.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsGetTalks message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsGetTalks
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsGetTalks.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Medias != null && message.hasOwnProperty("Medias")) {
                if (!Array.isArray(message.Medias))
                    return "Medias: array expected";
                for (let i = 0; i < message.Medias.length; ++i)
                    if (!$util.isInteger(message.Medias[i]))
                        return "Medias: integer[] expected";
            }
            if (message.Type != null && message.hasOwnProperty("Type"))
                switch (message.Type) {
                default:
                    return "Type: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.DateStart != null && message.hasOwnProperty("DateStart"))
                if (!$util.isInteger(message.DateStart) && !(message.DateStart && $util.isInteger(message.DateStart.low) && $util.isInteger(message.DateStart.high)))
                    return "DateStart: integer|Long expected";
            if (message.DateEnd != null && message.hasOwnProperty("DateEnd"))
                if (!$util.isInteger(message.DateEnd) && !(message.DateEnd && $util.isInteger(message.DateEnd.low) && $util.isInteger(message.DateEnd.high)))
                    return "DateEnd: integer|Long expected";
            if (message.Limit != null && message.hasOwnProperty("Limit"))
                if (!$util.isInteger(message.Limit))
                    return "Limit: integer expected";
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                if (!$util.isInteger(message.Offset))
                    return "Offset: integer expected";
            if (message.Sort != null && message.hasOwnProperty("Sort"))
                if (!$util.isString(message.Sort))
                    return "Sort: string expected";
            if (message.SortDesc != null && message.hasOwnProperty("SortDesc"))
                if (typeof message.SortDesc !== "boolean")
                    return "SortDesc: boolean expected";
            return null;
        };

        /**
         * Creates an ArgumentsGetTalks message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsGetTalks
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsGetTalks} ArgumentsGetTalks
         */
        ArgumentsGetTalks.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsGetTalks)
                return object;
            let message = new $root.mediaarchiver.ArgumentsGetTalks();
            if (object.Medias) {
                if (!Array.isArray(object.Medias))
                    throw TypeError(".mediaarchiver.ArgumentsGetTalks.Medias: array expected");
                message.Medias = [];
                for (let i = 0; i < object.Medias.length; ++i)
                    message.Medias[i] = object.Medias[i] >>> 0;
            }
            switch (object.Type) {
            case "TALK_TYPE_UNKNOWN":
            case 0:
                message.Type = 0;
                break;
            case "TALK_TYPE_PLURALISM":
            case 1:
                message.Type = 1;
                break;
            case "TALK_TYPE_ELECTION":
            case 2:
                message.Type = 2;
                break;
            }
            if (object.DateStart != null)
                if ($util.Long)
                    (message.DateStart = $util.Long.fromValue(object.DateStart)).unsigned = false;
                else if (typeof object.DateStart === "string")
                    message.DateStart = parseInt(object.DateStart, 10);
                else if (typeof object.DateStart === "number")
                    message.DateStart = object.DateStart;
                else if (typeof object.DateStart === "object")
                    message.DateStart = new $util.LongBits(object.DateStart.low >>> 0, object.DateStart.high >>> 0).toNumber();
            if (object.DateEnd != null)
                if ($util.Long)
                    (message.DateEnd = $util.Long.fromValue(object.DateEnd)).unsigned = false;
                else if (typeof object.DateEnd === "string")
                    message.DateEnd = parseInt(object.DateEnd, 10);
                else if (typeof object.DateEnd === "number")
                    message.DateEnd = object.DateEnd;
                else if (typeof object.DateEnd === "object")
                    message.DateEnd = new $util.LongBits(object.DateEnd.low >>> 0, object.DateEnd.high >>> 0).toNumber();
            if (object.Limit != null)
                message.Limit = object.Limit >>> 0;
            if (object.Offset != null)
                message.Offset = object.Offset >>> 0;
            if (object.Sort != null)
                message.Sort = String(object.Sort);
            if (object.SortDesc != null)
                message.SortDesc = Boolean(object.SortDesc);
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsGetTalks message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsGetTalks
         * @static
         * @param {mediaarchiver.ArgumentsGetTalks} message ArgumentsGetTalks
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsGetTalks.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Medias = [];
            if (options.defaults) {
                object.Type = options.enums === String ? "TALK_TYPE_UNKNOWN" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.DateStart = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.DateStart = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.DateEnd = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.DateEnd = options.longs === String ? "0" : 0;
                object.Limit = 0;
                object.Offset = 0;
                object.Sort = "";
                object.SortDesc = false;
            }
            if (message.Medias && message.Medias.length) {
                object.Medias = [];
                for (let j = 0; j < message.Medias.length; ++j)
                    object.Medias[j] = message.Medias[j];
            }
            if (message.Type != null && message.hasOwnProperty("Type"))
                object.Type = options.enums === String ? $root.mediaarchiver.TalkStudyType[message.Type] : message.Type;
            if (message.DateStart != null && message.hasOwnProperty("DateStart"))
                if (typeof message.DateStart === "number")
                    object.DateStart = options.longs === String ? String(message.DateStart) : message.DateStart;
                else
                    object.DateStart = options.longs === String ? $util.Long.prototype.toString.call(message.DateStart) : options.longs === Number ? new $util.LongBits(message.DateStart.low >>> 0, message.DateStart.high >>> 0).toNumber() : message.DateStart;
            if (message.DateEnd != null && message.hasOwnProperty("DateEnd"))
                if (typeof message.DateEnd === "number")
                    object.DateEnd = options.longs === String ? String(message.DateEnd) : message.DateEnd;
                else
                    object.DateEnd = options.longs === String ? $util.Long.prototype.toString.call(message.DateEnd) : options.longs === Number ? new $util.LongBits(message.DateEnd.low >>> 0, message.DateEnd.high >>> 0).toNumber() : message.DateEnd;
            if (message.Limit != null && message.hasOwnProperty("Limit"))
                object.Limit = message.Limit;
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                object.Offset = message.Offset;
            if (message.Sort != null && message.hasOwnProperty("Sort"))
                object.Sort = message.Sort;
            if (message.SortDesc != null && message.hasOwnProperty("SortDesc"))
                object.SortDesc = message.SortDesc;
            return object;
        };

        /**
         * Converts this ArgumentsGetTalks to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsGetTalks
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsGetTalks.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsGetTalks;
    })();

    mediaarchiver.ArgumentsExportTalks = (function() {

        /**
         * Properties of an ArgumentsExportTalks.
         * @memberof mediaarchiver
         * @interface IArgumentsExportTalks
         * @property {Array.<number>|null} [Medias] ArgumentsExportTalks Medias
         * @property {mediaarchiver.TalkStudyType|null} [Type] ArgumentsExportTalks Type
         * @property {number|Long|null} [DateStart] ArgumentsExportTalks DateStart
         * @property {number|Long|null} [DateEnd] ArgumentsExportTalks DateEnd
         */

        /**
         * Constructs a new ArgumentsExportTalks.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsExportTalks.
         * @implements IArgumentsExportTalks
         * @constructor
         * @param {mediaarchiver.IArgumentsExportTalks=} [properties] Properties to set
         */
        function ArgumentsExportTalks(properties) {
            this.Medias = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsExportTalks Medias.
         * @member {Array.<number>} Medias
         * @memberof mediaarchiver.ArgumentsExportTalks
         * @instance
         */
        ArgumentsExportTalks.prototype.Medias = $util.emptyArray;

        /**
         * ArgumentsExportTalks Type.
         * @member {mediaarchiver.TalkStudyType} Type
         * @memberof mediaarchiver.ArgumentsExportTalks
         * @instance
         */
        ArgumentsExportTalks.prototype.Type = 0;

        /**
         * ArgumentsExportTalks DateStart.
         * @member {number|Long} DateStart
         * @memberof mediaarchiver.ArgumentsExportTalks
         * @instance
         */
        ArgumentsExportTalks.prototype.DateStart = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ArgumentsExportTalks DateEnd.
         * @member {number|Long} DateEnd
         * @memberof mediaarchiver.ArgumentsExportTalks
         * @instance
         */
        ArgumentsExportTalks.prototype.DateEnd = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new ArgumentsExportTalks instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsExportTalks
         * @static
         * @param {mediaarchiver.IArgumentsExportTalks=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsExportTalks} ArgumentsExportTalks instance
         */
        ArgumentsExportTalks.create = function create(properties) {
            return new ArgumentsExportTalks(properties);
        };

        /**
         * Encodes the specified ArgumentsExportTalks message. Does not implicitly {@link mediaarchiver.ArgumentsExportTalks.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsExportTalks
         * @static
         * @param {mediaarchiver.IArgumentsExportTalks} message ArgumentsExportTalks message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsExportTalks.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Medias != null && message.Medias.length) {
                writer.uint32(/* id 1, wireType 2 =*/10).fork();
                for (let i = 0; i < message.Medias.length; ++i)
                    writer.uint32(message.Medias[i]);
                writer.ldelim();
            }
            if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.Type);
            if (message.DateStart != null && Object.hasOwnProperty.call(message, "DateStart"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.DateStart);
            if (message.DateEnd != null && Object.hasOwnProperty.call(message, "DateEnd"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.DateEnd);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsExportTalks message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsExportTalks.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsExportTalks
         * @static
         * @param {mediaarchiver.IArgumentsExportTalks} message ArgumentsExportTalks message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsExportTalks.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsExportTalks message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsExportTalks
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsExportTalks} ArgumentsExportTalks
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsExportTalks.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsExportTalks();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.Medias && message.Medias.length))
                        message.Medias = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.Medias.push(reader.uint32());
                    } else
                        message.Medias.push(reader.uint32());
                    break;
                case 2:
                    message.Type = reader.int32();
                    break;
                case 3:
                    message.DateStart = reader.int64();
                    break;
                case 4:
                    message.DateEnd = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsExportTalks message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsExportTalks
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsExportTalks} ArgumentsExportTalks
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsExportTalks.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsExportTalks message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsExportTalks
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsExportTalks.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Medias != null && message.hasOwnProperty("Medias")) {
                if (!Array.isArray(message.Medias))
                    return "Medias: array expected";
                for (let i = 0; i < message.Medias.length; ++i)
                    if (!$util.isInteger(message.Medias[i]))
                        return "Medias: integer[] expected";
            }
            if (message.Type != null && message.hasOwnProperty("Type"))
                switch (message.Type) {
                default:
                    return "Type: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.DateStart != null && message.hasOwnProperty("DateStart"))
                if (!$util.isInteger(message.DateStart) && !(message.DateStart && $util.isInteger(message.DateStart.low) && $util.isInteger(message.DateStart.high)))
                    return "DateStart: integer|Long expected";
            if (message.DateEnd != null && message.hasOwnProperty("DateEnd"))
                if (!$util.isInteger(message.DateEnd) && !(message.DateEnd && $util.isInteger(message.DateEnd.low) && $util.isInteger(message.DateEnd.high)))
                    return "DateEnd: integer|Long expected";
            return null;
        };

        /**
         * Creates an ArgumentsExportTalks message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsExportTalks
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsExportTalks} ArgumentsExportTalks
         */
        ArgumentsExportTalks.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsExportTalks)
                return object;
            let message = new $root.mediaarchiver.ArgumentsExportTalks();
            if (object.Medias) {
                if (!Array.isArray(object.Medias))
                    throw TypeError(".mediaarchiver.ArgumentsExportTalks.Medias: array expected");
                message.Medias = [];
                for (let i = 0; i < object.Medias.length; ++i)
                    message.Medias[i] = object.Medias[i] >>> 0;
            }
            switch (object.Type) {
            case "TALK_TYPE_UNKNOWN":
            case 0:
                message.Type = 0;
                break;
            case "TALK_TYPE_PLURALISM":
            case 1:
                message.Type = 1;
                break;
            case "TALK_TYPE_ELECTION":
            case 2:
                message.Type = 2;
                break;
            }
            if (object.DateStart != null)
                if ($util.Long)
                    (message.DateStart = $util.Long.fromValue(object.DateStart)).unsigned = false;
                else if (typeof object.DateStart === "string")
                    message.DateStart = parseInt(object.DateStart, 10);
                else if (typeof object.DateStart === "number")
                    message.DateStart = object.DateStart;
                else if (typeof object.DateStart === "object")
                    message.DateStart = new $util.LongBits(object.DateStart.low >>> 0, object.DateStart.high >>> 0).toNumber();
            if (object.DateEnd != null)
                if ($util.Long)
                    (message.DateEnd = $util.Long.fromValue(object.DateEnd)).unsigned = false;
                else if (typeof object.DateEnd === "string")
                    message.DateEnd = parseInt(object.DateEnd, 10);
                else if (typeof object.DateEnd === "number")
                    message.DateEnd = object.DateEnd;
                else if (typeof object.DateEnd === "object")
                    message.DateEnd = new $util.LongBits(object.DateEnd.low >>> 0, object.DateEnd.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsExportTalks message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsExportTalks
         * @static
         * @param {mediaarchiver.ArgumentsExportTalks} message ArgumentsExportTalks
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsExportTalks.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Medias = [];
            if (options.defaults) {
                object.Type = options.enums === String ? "TALK_TYPE_UNKNOWN" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.DateStart = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.DateStart = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.DateEnd = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.DateEnd = options.longs === String ? "0" : 0;
            }
            if (message.Medias && message.Medias.length) {
                object.Medias = [];
                for (let j = 0; j < message.Medias.length; ++j)
                    object.Medias[j] = message.Medias[j];
            }
            if (message.Type != null && message.hasOwnProperty("Type"))
                object.Type = options.enums === String ? $root.mediaarchiver.TalkStudyType[message.Type] : message.Type;
            if (message.DateStart != null && message.hasOwnProperty("DateStart"))
                if (typeof message.DateStart === "number")
                    object.DateStart = options.longs === String ? String(message.DateStart) : message.DateStart;
                else
                    object.DateStart = options.longs === String ? $util.Long.prototype.toString.call(message.DateStart) : options.longs === Number ? new $util.LongBits(message.DateStart.low >>> 0, message.DateStart.high >>> 0).toNumber() : message.DateStart;
            if (message.DateEnd != null && message.hasOwnProperty("DateEnd"))
                if (typeof message.DateEnd === "number")
                    object.DateEnd = options.longs === String ? String(message.DateEnd) : message.DateEnd;
                else
                    object.DateEnd = options.longs === String ? $util.Long.prototype.toString.call(message.DateEnd) : options.longs === Number ? new $util.LongBits(message.DateEnd.low >>> 0, message.DateEnd.high >>> 0).toNumber() : message.DateEnd;
            return object;
        };

        /**
         * Converts this ArgumentsExportTalks to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsExportTalks
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsExportTalks.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsExportTalks;
    })();

    mediaarchiver.ArgumentsDeleteTalk = (function() {

        /**
         * Properties of an ArgumentsDeleteTalk.
         * @memberof mediaarchiver
         * @interface IArgumentsDeleteTalk
         * @property {string|null} [ID] ArgumentsDeleteTalk ID
         */

        /**
         * Constructs a new ArgumentsDeleteTalk.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsDeleteTalk.
         * @implements IArgumentsDeleteTalk
         * @constructor
         * @param {mediaarchiver.IArgumentsDeleteTalk=} [properties] Properties to set
         */
        function ArgumentsDeleteTalk(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsDeleteTalk ID.
         * @member {string} ID
         * @memberof mediaarchiver.ArgumentsDeleteTalk
         * @instance
         */
        ArgumentsDeleteTalk.prototype.ID = "";

        /**
         * Creates a new ArgumentsDeleteTalk instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsDeleteTalk
         * @static
         * @param {mediaarchiver.IArgumentsDeleteTalk=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsDeleteTalk} ArgumentsDeleteTalk instance
         */
        ArgumentsDeleteTalk.create = function create(properties) {
            return new ArgumentsDeleteTalk(properties);
        };

        /**
         * Encodes the specified ArgumentsDeleteTalk message. Does not implicitly {@link mediaarchiver.ArgumentsDeleteTalk.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsDeleteTalk
         * @static
         * @param {mediaarchiver.IArgumentsDeleteTalk} message ArgumentsDeleteTalk message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsDeleteTalk.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.ID);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsDeleteTalk message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsDeleteTalk.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsDeleteTalk
         * @static
         * @param {mediaarchiver.IArgumentsDeleteTalk} message ArgumentsDeleteTalk message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsDeleteTalk.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsDeleteTalk message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsDeleteTalk
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsDeleteTalk} ArgumentsDeleteTalk
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsDeleteTalk.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsDeleteTalk();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ID = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsDeleteTalk message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsDeleteTalk
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsDeleteTalk} ArgumentsDeleteTalk
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsDeleteTalk.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsDeleteTalk message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsDeleteTalk
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsDeleteTalk.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isString(message.ID))
                    return "ID: string expected";
            return null;
        };

        /**
         * Creates an ArgumentsDeleteTalk message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsDeleteTalk
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsDeleteTalk} ArgumentsDeleteTalk
         */
        ArgumentsDeleteTalk.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsDeleteTalk)
                return object;
            let message = new $root.mediaarchiver.ArgumentsDeleteTalk();
            if (object.ID != null)
                message.ID = String(object.ID);
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsDeleteTalk message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsDeleteTalk
         * @static
         * @param {mediaarchiver.ArgumentsDeleteTalk} message ArgumentsDeleteTalk
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsDeleteTalk.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.ID = "";
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            return object;
        };

        /**
         * Converts this ArgumentsDeleteTalk to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsDeleteTalk
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsDeleteTalk.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsDeleteTalk;
    })();

    mediaarchiver.TalkAutocompleteName = (function() {

        /**
         * Properties of a TalkAutocompleteName.
         * @memberof mediaarchiver
         * @interface ITalkAutocompleteName
         * @property {string|null} [Typed] TalkAutocompleteName Typed
         * @property {number|null} [Study] TalkAutocompleteName Study
         */

        /**
         * Constructs a new TalkAutocompleteName.
         * @memberof mediaarchiver
         * @classdesc Represents a TalkAutocompleteName.
         * @implements ITalkAutocompleteName
         * @constructor
         * @param {mediaarchiver.ITalkAutocompleteName=} [properties] Properties to set
         */
        function TalkAutocompleteName(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TalkAutocompleteName Typed.
         * @member {string} Typed
         * @memberof mediaarchiver.TalkAutocompleteName
         * @instance
         */
        TalkAutocompleteName.prototype.Typed = "";

        /**
         * TalkAutocompleteName Study.
         * @member {number} Study
         * @memberof mediaarchiver.TalkAutocompleteName
         * @instance
         */
        TalkAutocompleteName.prototype.Study = 0;

        /**
         * Creates a new TalkAutocompleteName instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.TalkAutocompleteName
         * @static
         * @param {mediaarchiver.ITalkAutocompleteName=} [properties] Properties to set
         * @returns {mediaarchiver.TalkAutocompleteName} TalkAutocompleteName instance
         */
        TalkAutocompleteName.create = function create(properties) {
            return new TalkAutocompleteName(properties);
        };

        /**
         * Encodes the specified TalkAutocompleteName message. Does not implicitly {@link mediaarchiver.TalkAutocompleteName.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.TalkAutocompleteName
         * @static
         * @param {mediaarchiver.ITalkAutocompleteName} message TalkAutocompleteName message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkAutocompleteName.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Typed != null && Object.hasOwnProperty.call(message, "Typed"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Typed);
            if (message.Study != null && Object.hasOwnProperty.call(message, "Study"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Study);
            return writer;
        };

        /**
         * Encodes the specified TalkAutocompleteName message, length delimited. Does not implicitly {@link mediaarchiver.TalkAutocompleteName.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.TalkAutocompleteName
         * @static
         * @param {mediaarchiver.ITalkAutocompleteName} message TalkAutocompleteName message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TalkAutocompleteName.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TalkAutocompleteName message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.TalkAutocompleteName
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.TalkAutocompleteName} TalkAutocompleteName
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkAutocompleteName.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.TalkAutocompleteName();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Typed = reader.string();
                    break;
                case 2:
                    message.Study = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TalkAutocompleteName message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.TalkAutocompleteName
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.TalkAutocompleteName} TalkAutocompleteName
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TalkAutocompleteName.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TalkAutocompleteName message.
         * @function verify
         * @memberof mediaarchiver.TalkAutocompleteName
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TalkAutocompleteName.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Typed != null && message.hasOwnProperty("Typed"))
                if (!$util.isString(message.Typed))
                    return "Typed: string expected";
            if (message.Study != null && message.hasOwnProperty("Study"))
                if (!$util.isInteger(message.Study))
                    return "Study: integer expected";
            return null;
        };

        /**
         * Creates a TalkAutocompleteName message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.TalkAutocompleteName
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.TalkAutocompleteName} TalkAutocompleteName
         */
        TalkAutocompleteName.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.TalkAutocompleteName)
                return object;
            let message = new $root.mediaarchiver.TalkAutocompleteName();
            if (object.Typed != null)
                message.Typed = String(object.Typed);
            if (object.Study != null)
                message.Study = object.Study >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a TalkAutocompleteName message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.TalkAutocompleteName
         * @static
         * @param {mediaarchiver.TalkAutocompleteName} message TalkAutocompleteName
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TalkAutocompleteName.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.Typed = "";
                object.Study = 0;
            }
            if (message.Typed != null && message.hasOwnProperty("Typed"))
                object.Typed = message.Typed;
            if (message.Study != null && message.hasOwnProperty("Study"))
                object.Study = message.Study;
            return object;
        };

        /**
         * Converts this TalkAutocompleteName to JSON.
         * @function toJSON
         * @memberof mediaarchiver.TalkAutocompleteName
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TalkAutocompleteName.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TalkAutocompleteName;
    })();

    mediaarchiver.FTPAccount = (function() {

        /**
         * Properties of a FTPAccount.
         * @memberof mediaarchiver
         * @interface IFTPAccount
         * @property {string|null} [ID] FTPAccount ID
         * @property {string|null} [Name] FTPAccount Name
         * @property {string|null} [Hostname] FTPAccount Hostname
         * @property {number|null} [Port] FTPAccount Port
         * @property {string|null} [Login] FTPAccount Login
         * @property {string|null} [Password] FTPAccount Password
         * @property {string|null} [Directory] FTPAccount Directory
         * @property {boolean|null} [Passive] FTPAccount Passive
         * @property {number|null} [Owner] FTPAccount Owner
         */

        /**
         * Constructs a new FTPAccount.
         * @memberof mediaarchiver
         * @classdesc Represents a FTPAccount.
         * @implements IFTPAccount
         * @constructor
         * @param {mediaarchiver.IFTPAccount=} [properties] Properties to set
         */
        function FTPAccount(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FTPAccount ID.
         * @member {string} ID
         * @memberof mediaarchiver.FTPAccount
         * @instance
         */
        FTPAccount.prototype.ID = "";

        /**
         * FTPAccount Name.
         * @member {string} Name
         * @memberof mediaarchiver.FTPAccount
         * @instance
         */
        FTPAccount.prototype.Name = "";

        /**
         * FTPAccount Hostname.
         * @member {string} Hostname
         * @memberof mediaarchiver.FTPAccount
         * @instance
         */
        FTPAccount.prototype.Hostname = "";

        /**
         * FTPAccount Port.
         * @member {number} Port
         * @memberof mediaarchiver.FTPAccount
         * @instance
         */
        FTPAccount.prototype.Port = 0;

        /**
         * FTPAccount Login.
         * @member {string} Login
         * @memberof mediaarchiver.FTPAccount
         * @instance
         */
        FTPAccount.prototype.Login = "";

        /**
         * FTPAccount Password.
         * @member {string} Password
         * @memberof mediaarchiver.FTPAccount
         * @instance
         */
        FTPAccount.prototype.Password = "";

        /**
         * FTPAccount Directory.
         * @member {string} Directory
         * @memberof mediaarchiver.FTPAccount
         * @instance
         */
        FTPAccount.prototype.Directory = "";

        /**
         * FTPAccount Passive.
         * @member {boolean} Passive
         * @memberof mediaarchiver.FTPAccount
         * @instance
         */
        FTPAccount.prototype.Passive = false;

        /**
         * FTPAccount Owner.
         * @member {number} Owner
         * @memberof mediaarchiver.FTPAccount
         * @instance
         */
        FTPAccount.prototype.Owner = 0;

        /**
         * Creates a new FTPAccount instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.FTPAccount
         * @static
         * @param {mediaarchiver.IFTPAccount=} [properties] Properties to set
         * @returns {mediaarchiver.FTPAccount} FTPAccount instance
         */
        FTPAccount.create = function create(properties) {
            return new FTPAccount(properties);
        };

        /**
         * Encodes the specified FTPAccount message. Does not implicitly {@link mediaarchiver.FTPAccount.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.FTPAccount
         * @static
         * @param {mediaarchiver.IFTPAccount} message FTPAccount message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FTPAccount.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.ID);
            if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
            if (message.Hostname != null && Object.hasOwnProperty.call(message, "Hostname"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.Hostname);
            if (message.Port != null && Object.hasOwnProperty.call(message, "Port"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.Port);
            if (message.Login != null && Object.hasOwnProperty.call(message, "Login"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.Login);
            if (message.Password != null && Object.hasOwnProperty.call(message, "Password"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.Password);
            if (message.Directory != null && Object.hasOwnProperty.call(message, "Directory"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.Directory);
            if (message.Passive != null && Object.hasOwnProperty.call(message, "Passive"))
                writer.uint32(/* id 8, wireType 0 =*/64).bool(message.Passive);
            if (message.Owner != null && Object.hasOwnProperty.call(message, "Owner"))
                writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.Owner);
            return writer;
        };

        /**
         * Encodes the specified FTPAccount message, length delimited. Does not implicitly {@link mediaarchiver.FTPAccount.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.FTPAccount
         * @static
         * @param {mediaarchiver.IFTPAccount} message FTPAccount message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FTPAccount.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FTPAccount message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.FTPAccount
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.FTPAccount} FTPAccount
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FTPAccount.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.FTPAccount();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ID = reader.string();
                    break;
                case 2:
                    message.Name = reader.string();
                    break;
                case 3:
                    message.Hostname = reader.string();
                    break;
                case 4:
                    message.Port = reader.uint32();
                    break;
                case 5:
                    message.Login = reader.string();
                    break;
                case 6:
                    message.Password = reader.string();
                    break;
                case 7:
                    message.Directory = reader.string();
                    break;
                case 8:
                    message.Passive = reader.bool();
                    break;
                case 9:
                    message.Owner = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FTPAccount message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.FTPAccount
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.FTPAccount} FTPAccount
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FTPAccount.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FTPAccount message.
         * @function verify
         * @memberof mediaarchiver.FTPAccount
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FTPAccount.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isString(message.ID))
                    return "ID: string expected";
            if (message.Name != null && message.hasOwnProperty("Name"))
                if (!$util.isString(message.Name))
                    return "Name: string expected";
            if (message.Hostname != null && message.hasOwnProperty("Hostname"))
                if (!$util.isString(message.Hostname))
                    return "Hostname: string expected";
            if (message.Port != null && message.hasOwnProperty("Port"))
                if (!$util.isInteger(message.Port))
                    return "Port: integer expected";
            if (message.Login != null && message.hasOwnProperty("Login"))
                if (!$util.isString(message.Login))
                    return "Login: string expected";
            if (message.Password != null && message.hasOwnProperty("Password"))
                if (!$util.isString(message.Password))
                    return "Password: string expected";
            if (message.Directory != null && message.hasOwnProperty("Directory"))
                if (!$util.isString(message.Directory))
                    return "Directory: string expected";
            if (message.Passive != null && message.hasOwnProperty("Passive"))
                if (typeof message.Passive !== "boolean")
                    return "Passive: boolean expected";
            if (message.Owner != null && message.hasOwnProperty("Owner"))
                if (!$util.isInteger(message.Owner))
                    return "Owner: integer expected";
            return null;
        };

        /**
         * Creates a FTPAccount message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.FTPAccount
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.FTPAccount} FTPAccount
         */
        FTPAccount.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.FTPAccount)
                return object;
            let message = new $root.mediaarchiver.FTPAccount();
            if (object.ID != null)
                message.ID = String(object.ID);
            if (object.Name != null)
                message.Name = String(object.Name);
            if (object.Hostname != null)
                message.Hostname = String(object.Hostname);
            if (object.Port != null)
                message.Port = object.Port >>> 0;
            if (object.Login != null)
                message.Login = String(object.Login);
            if (object.Password != null)
                message.Password = String(object.Password);
            if (object.Directory != null)
                message.Directory = String(object.Directory);
            if (object.Passive != null)
                message.Passive = Boolean(object.Passive);
            if (object.Owner != null)
                message.Owner = object.Owner >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a FTPAccount message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.FTPAccount
         * @static
         * @param {mediaarchiver.FTPAccount} message FTPAccount
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FTPAccount.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.ID = "";
                object.Name = "";
                object.Hostname = "";
                object.Port = 0;
                object.Login = "";
                object.Password = "";
                object.Directory = "";
                object.Passive = false;
                object.Owner = 0;
            }
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            if (message.Name != null && message.hasOwnProperty("Name"))
                object.Name = message.Name;
            if (message.Hostname != null && message.hasOwnProperty("Hostname"))
                object.Hostname = message.Hostname;
            if (message.Port != null && message.hasOwnProperty("Port"))
                object.Port = message.Port;
            if (message.Login != null && message.hasOwnProperty("Login"))
                object.Login = message.Login;
            if (message.Password != null && message.hasOwnProperty("Password"))
                object.Password = message.Password;
            if (message.Directory != null && message.hasOwnProperty("Directory"))
                object.Directory = message.Directory;
            if (message.Passive != null && message.hasOwnProperty("Passive"))
                object.Passive = message.Passive;
            if (message.Owner != null && message.hasOwnProperty("Owner"))
                object.Owner = message.Owner;
            return object;
        };

        /**
         * Converts this FTPAccount to JSON.
         * @function toJSON
         * @memberof mediaarchiver.FTPAccount
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FTPAccount.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FTPAccount;
    })();

    mediaarchiver.ArgumentsFTPAccounts = (function() {

        /**
         * Properties of an ArgumentsFTPAccounts.
         * @memberof mediaarchiver
         * @interface IArgumentsFTPAccounts
         * @property {number|null} [Offset] ArgumentsFTPAccounts Offset
         * @property {number|null} [Count] ArgumentsFTPAccounts Count
         * @property {Array.<mediaarchiver.IFTPAccount>|null} [Accounts] ArgumentsFTPAccounts Accounts
         */

        /**
         * Constructs a new ArgumentsFTPAccounts.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsFTPAccounts.
         * @implements IArgumentsFTPAccounts
         * @constructor
         * @param {mediaarchiver.IArgumentsFTPAccounts=} [properties] Properties to set
         */
        function ArgumentsFTPAccounts(properties) {
            this.Accounts = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsFTPAccounts Offset.
         * @member {number} Offset
         * @memberof mediaarchiver.ArgumentsFTPAccounts
         * @instance
         */
        ArgumentsFTPAccounts.prototype.Offset = 0;

        /**
         * ArgumentsFTPAccounts Count.
         * @member {number} Count
         * @memberof mediaarchiver.ArgumentsFTPAccounts
         * @instance
         */
        ArgumentsFTPAccounts.prototype.Count = 0;

        /**
         * ArgumentsFTPAccounts Accounts.
         * @member {Array.<mediaarchiver.IFTPAccount>} Accounts
         * @memberof mediaarchiver.ArgumentsFTPAccounts
         * @instance
         */
        ArgumentsFTPAccounts.prototype.Accounts = $util.emptyArray;

        /**
         * Creates a new ArgumentsFTPAccounts instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsFTPAccounts
         * @static
         * @param {mediaarchiver.IArgumentsFTPAccounts=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsFTPAccounts} ArgumentsFTPAccounts instance
         */
        ArgumentsFTPAccounts.create = function create(properties) {
            return new ArgumentsFTPAccounts(properties);
        };

        /**
         * Encodes the specified ArgumentsFTPAccounts message. Does not implicitly {@link mediaarchiver.ArgumentsFTPAccounts.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsFTPAccounts
         * @static
         * @param {mediaarchiver.IArgumentsFTPAccounts} message ArgumentsFTPAccounts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsFTPAccounts.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Offset != null && Object.hasOwnProperty.call(message, "Offset"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Offset);
            if (message.Count != null && Object.hasOwnProperty.call(message, "Count"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Count);
            if (message.Accounts != null && message.Accounts.length)
                for (let i = 0; i < message.Accounts.length; ++i)
                    $root.mediaarchiver.FTPAccount.encode(message.Accounts[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ArgumentsFTPAccounts message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsFTPAccounts.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsFTPAccounts
         * @static
         * @param {mediaarchiver.IArgumentsFTPAccounts} message ArgumentsFTPAccounts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsFTPAccounts.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsFTPAccounts message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsFTPAccounts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsFTPAccounts} ArgumentsFTPAccounts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsFTPAccounts.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsFTPAccounts();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Offset = reader.uint32();
                    break;
                case 2:
                    message.Count = reader.uint32();
                    break;
                case 3:
                    if (!(message.Accounts && message.Accounts.length))
                        message.Accounts = [];
                    message.Accounts.push($root.mediaarchiver.FTPAccount.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsFTPAccounts message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsFTPAccounts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsFTPAccounts} ArgumentsFTPAccounts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsFTPAccounts.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsFTPAccounts message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsFTPAccounts
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsFTPAccounts.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                if (!$util.isInteger(message.Offset))
                    return "Offset: integer expected";
            if (message.Count != null && message.hasOwnProperty("Count"))
                if (!$util.isInteger(message.Count))
                    return "Count: integer expected";
            if (message.Accounts != null && message.hasOwnProperty("Accounts")) {
                if (!Array.isArray(message.Accounts))
                    return "Accounts: array expected";
                for (let i = 0; i < message.Accounts.length; ++i) {
                    let error = $root.mediaarchiver.FTPAccount.verify(message.Accounts[i]);
                    if (error)
                        return "Accounts." + error;
                }
            }
            return null;
        };

        /**
         * Creates an ArgumentsFTPAccounts message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsFTPAccounts
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsFTPAccounts} ArgumentsFTPAccounts
         */
        ArgumentsFTPAccounts.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsFTPAccounts)
                return object;
            let message = new $root.mediaarchiver.ArgumentsFTPAccounts();
            if (object.Offset != null)
                message.Offset = object.Offset >>> 0;
            if (object.Count != null)
                message.Count = object.Count >>> 0;
            if (object.Accounts) {
                if (!Array.isArray(object.Accounts))
                    throw TypeError(".mediaarchiver.ArgumentsFTPAccounts.Accounts: array expected");
                message.Accounts = [];
                for (let i = 0; i < object.Accounts.length; ++i) {
                    if (typeof object.Accounts[i] !== "object")
                        throw TypeError(".mediaarchiver.ArgumentsFTPAccounts.Accounts: object expected");
                    message.Accounts[i] = $root.mediaarchiver.FTPAccount.fromObject(object.Accounts[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsFTPAccounts message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsFTPAccounts
         * @static
         * @param {mediaarchiver.ArgumentsFTPAccounts} message ArgumentsFTPAccounts
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsFTPAccounts.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Accounts = [];
            if (options.defaults) {
                object.Offset = 0;
                object.Count = 0;
            }
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                object.Offset = message.Offset;
            if (message.Count != null && message.hasOwnProperty("Count"))
                object.Count = message.Count;
            if (message.Accounts && message.Accounts.length) {
                object.Accounts = [];
                for (let j = 0; j < message.Accounts.length; ++j)
                    object.Accounts[j] = $root.mediaarchiver.FTPAccount.toObject(message.Accounts[j], options);
            }
            return object;
        };

        /**
         * Converts this ArgumentsFTPAccounts to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsFTPAccounts
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsFTPAccounts.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsFTPAccounts;
    })();

    mediaarchiver.ArgumentsGetFTPAccounts = (function() {

        /**
         * Properties of an ArgumentsGetFTPAccounts.
         * @memberof mediaarchiver
         * @interface IArgumentsGetFTPAccounts
         * @property {number|null} [Limit] ArgumentsGetFTPAccounts Limit
         * @property {number|null} [Offset] ArgumentsGetFTPAccounts Offset
         */

        /**
         * Constructs a new ArgumentsGetFTPAccounts.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsGetFTPAccounts.
         * @implements IArgumentsGetFTPAccounts
         * @constructor
         * @param {mediaarchiver.IArgumentsGetFTPAccounts=} [properties] Properties to set
         */
        function ArgumentsGetFTPAccounts(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsGetFTPAccounts Limit.
         * @member {number} Limit
         * @memberof mediaarchiver.ArgumentsGetFTPAccounts
         * @instance
         */
        ArgumentsGetFTPAccounts.prototype.Limit = 0;

        /**
         * ArgumentsGetFTPAccounts Offset.
         * @member {number} Offset
         * @memberof mediaarchiver.ArgumentsGetFTPAccounts
         * @instance
         */
        ArgumentsGetFTPAccounts.prototype.Offset = 0;

        /**
         * Creates a new ArgumentsGetFTPAccounts instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsGetFTPAccounts
         * @static
         * @param {mediaarchiver.IArgumentsGetFTPAccounts=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsGetFTPAccounts} ArgumentsGetFTPAccounts instance
         */
        ArgumentsGetFTPAccounts.create = function create(properties) {
            return new ArgumentsGetFTPAccounts(properties);
        };

        /**
         * Encodes the specified ArgumentsGetFTPAccounts message. Does not implicitly {@link mediaarchiver.ArgumentsGetFTPAccounts.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsGetFTPAccounts
         * @static
         * @param {mediaarchiver.IArgumentsGetFTPAccounts} message ArgumentsGetFTPAccounts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetFTPAccounts.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Limit != null && Object.hasOwnProperty.call(message, "Limit"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Limit);
            if (message.Offset != null && Object.hasOwnProperty.call(message, "Offset"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Offset);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsGetFTPAccounts message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsGetFTPAccounts.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsGetFTPAccounts
         * @static
         * @param {mediaarchiver.IArgumentsGetFTPAccounts} message ArgumentsGetFTPAccounts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetFTPAccounts.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsGetFTPAccounts message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsGetFTPAccounts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsGetFTPAccounts} ArgumentsGetFTPAccounts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetFTPAccounts.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsGetFTPAccounts();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Limit = reader.uint32();
                    break;
                case 2:
                    message.Offset = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsGetFTPAccounts message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsGetFTPAccounts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsGetFTPAccounts} ArgumentsGetFTPAccounts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetFTPAccounts.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsGetFTPAccounts message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsGetFTPAccounts
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsGetFTPAccounts.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Limit != null && message.hasOwnProperty("Limit"))
                if (!$util.isInteger(message.Limit))
                    return "Limit: integer expected";
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                if (!$util.isInteger(message.Offset))
                    return "Offset: integer expected";
            return null;
        };

        /**
         * Creates an ArgumentsGetFTPAccounts message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsGetFTPAccounts
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsGetFTPAccounts} ArgumentsGetFTPAccounts
         */
        ArgumentsGetFTPAccounts.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsGetFTPAccounts)
                return object;
            let message = new $root.mediaarchiver.ArgumentsGetFTPAccounts();
            if (object.Limit != null)
                message.Limit = object.Limit >>> 0;
            if (object.Offset != null)
                message.Offset = object.Offset >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsGetFTPAccounts message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsGetFTPAccounts
         * @static
         * @param {mediaarchiver.ArgumentsGetFTPAccounts} message ArgumentsGetFTPAccounts
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsGetFTPAccounts.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.Limit = 0;
                object.Offset = 0;
            }
            if (message.Limit != null && message.hasOwnProperty("Limit"))
                object.Limit = message.Limit;
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                object.Offset = message.Offset;
            return object;
        };

        /**
         * Converts this ArgumentsGetFTPAccounts to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsGetFTPAccounts
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsGetFTPAccounts.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsGetFTPAccounts;
    })();

    mediaarchiver.ArgumentsGetMediasCrossBucket = (function() {

        /**
         * Properties of an ArgumentsGetMediasCrossBucket.
         * @memberof mediaarchiver
         * @interface IArgumentsGetMediasCrossBucket
         * @property {boolean|null} [TV] ArgumentsGetMediasCrossBucket TV
         * @property {boolean|null} [Radio] ArgumentsGetMediasCrossBucket Radio
         */

        /**
         * Constructs a new ArgumentsGetMediasCrossBucket.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsGetMediasCrossBucket.
         * @implements IArgumentsGetMediasCrossBucket
         * @constructor
         * @param {mediaarchiver.IArgumentsGetMediasCrossBucket=} [properties] Properties to set
         */
        function ArgumentsGetMediasCrossBucket(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsGetMediasCrossBucket TV.
         * @member {boolean} TV
         * @memberof mediaarchiver.ArgumentsGetMediasCrossBucket
         * @instance
         */
        ArgumentsGetMediasCrossBucket.prototype.TV = false;

        /**
         * ArgumentsGetMediasCrossBucket Radio.
         * @member {boolean} Radio
         * @memberof mediaarchiver.ArgumentsGetMediasCrossBucket
         * @instance
         */
        ArgumentsGetMediasCrossBucket.prototype.Radio = false;

        /**
         * Creates a new ArgumentsGetMediasCrossBucket instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsGetMediasCrossBucket
         * @static
         * @param {mediaarchiver.IArgumentsGetMediasCrossBucket=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsGetMediasCrossBucket} ArgumentsGetMediasCrossBucket instance
         */
        ArgumentsGetMediasCrossBucket.create = function create(properties) {
            return new ArgumentsGetMediasCrossBucket(properties);
        };

        /**
         * Encodes the specified ArgumentsGetMediasCrossBucket message. Does not implicitly {@link mediaarchiver.ArgumentsGetMediasCrossBucket.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsGetMediasCrossBucket
         * @static
         * @param {mediaarchiver.IArgumentsGetMediasCrossBucket} message ArgumentsGetMediasCrossBucket message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetMediasCrossBucket.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.TV != null && Object.hasOwnProperty.call(message, "TV"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.TV);
            if (message.Radio != null && Object.hasOwnProperty.call(message, "Radio"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.Radio);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsGetMediasCrossBucket message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsGetMediasCrossBucket.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsGetMediasCrossBucket
         * @static
         * @param {mediaarchiver.IArgumentsGetMediasCrossBucket} message ArgumentsGetMediasCrossBucket message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetMediasCrossBucket.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsGetMediasCrossBucket message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsGetMediasCrossBucket
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsGetMediasCrossBucket} ArgumentsGetMediasCrossBucket
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetMediasCrossBucket.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsGetMediasCrossBucket();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.TV = reader.bool();
                    break;
                case 2:
                    message.Radio = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsGetMediasCrossBucket message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsGetMediasCrossBucket
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsGetMediasCrossBucket} ArgumentsGetMediasCrossBucket
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetMediasCrossBucket.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsGetMediasCrossBucket message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsGetMediasCrossBucket
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsGetMediasCrossBucket.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.TV != null && message.hasOwnProperty("TV"))
                if (typeof message.TV !== "boolean")
                    return "TV: boolean expected";
            if (message.Radio != null && message.hasOwnProperty("Radio"))
                if (typeof message.Radio !== "boolean")
                    return "Radio: boolean expected";
            return null;
        };

        /**
         * Creates an ArgumentsGetMediasCrossBucket message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsGetMediasCrossBucket
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsGetMediasCrossBucket} ArgumentsGetMediasCrossBucket
         */
        ArgumentsGetMediasCrossBucket.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsGetMediasCrossBucket)
                return object;
            let message = new $root.mediaarchiver.ArgumentsGetMediasCrossBucket();
            if (object.TV != null)
                message.TV = Boolean(object.TV);
            if (object.Radio != null)
                message.Radio = Boolean(object.Radio);
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsGetMediasCrossBucket message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsGetMediasCrossBucket
         * @static
         * @param {mediaarchiver.ArgumentsGetMediasCrossBucket} message ArgumentsGetMediasCrossBucket
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsGetMediasCrossBucket.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.TV = false;
                object.Radio = false;
            }
            if (message.TV != null && message.hasOwnProperty("TV"))
                object.TV = message.TV;
            if (message.Radio != null && message.hasOwnProperty("Radio"))
                object.Radio = message.Radio;
            return object;
        };

        /**
         * Converts this ArgumentsGetMediasCrossBucket to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsGetMediasCrossBucket
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsGetMediasCrossBucket.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsGetMediasCrossBucket;
    })();

    mediaarchiver.ArgumentsChunk = (function() {

        /**
         * Properties of an ArgumentsChunk.
         * @memberof mediaarchiver
         * @interface IArgumentsChunk
         * @property {string|null} [URL] ArgumentsChunk URL
         * @property {number|Long|null} [Start] ArgumentsChunk Start
         * @property {number|null} [MediaID] ArgumentsChunk MediaID
         */

        /**
         * Constructs a new ArgumentsChunk.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsChunk.
         * @implements IArgumentsChunk
         * @constructor
         * @param {mediaarchiver.IArgumentsChunk=} [properties] Properties to set
         */
        function ArgumentsChunk(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsChunk URL.
         * @member {string} URL
         * @memberof mediaarchiver.ArgumentsChunk
         * @instance
         */
        ArgumentsChunk.prototype.URL = "";

        /**
         * ArgumentsChunk Start.
         * @member {number|Long} Start
         * @memberof mediaarchiver.ArgumentsChunk
         * @instance
         */
        ArgumentsChunk.prototype.Start = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ArgumentsChunk MediaID.
         * @member {number} MediaID
         * @memberof mediaarchiver.ArgumentsChunk
         * @instance
         */
        ArgumentsChunk.prototype.MediaID = 0;

        /**
         * Creates a new ArgumentsChunk instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsChunk
         * @static
         * @param {mediaarchiver.IArgumentsChunk=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsChunk} ArgumentsChunk instance
         */
        ArgumentsChunk.create = function create(properties) {
            return new ArgumentsChunk(properties);
        };

        /**
         * Encodes the specified ArgumentsChunk message. Does not implicitly {@link mediaarchiver.ArgumentsChunk.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsChunk
         * @static
         * @param {mediaarchiver.IArgumentsChunk} message ArgumentsChunk message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsChunk.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.URL != null && Object.hasOwnProperty.call(message, "URL"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.URL);
            if (message.Start != null && Object.hasOwnProperty.call(message, "Start"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.Start);
            if (message.MediaID != null && Object.hasOwnProperty.call(message, "MediaID"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.MediaID);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsChunk message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsChunk.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsChunk
         * @static
         * @param {mediaarchiver.IArgumentsChunk} message ArgumentsChunk message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsChunk.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsChunk message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsChunk
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsChunk} ArgumentsChunk
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsChunk.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsChunk();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.URL = reader.string();
                    break;
                case 2:
                    message.Start = reader.int64();
                    break;
                case 3:
                    message.MediaID = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsChunk message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsChunk
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsChunk} ArgumentsChunk
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsChunk.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsChunk message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsChunk
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsChunk.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.URL != null && message.hasOwnProperty("URL"))
                if (!$util.isString(message.URL))
                    return "URL: string expected";
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (!$util.isInteger(message.Start) && !(message.Start && $util.isInteger(message.Start.low) && $util.isInteger(message.Start.high)))
                    return "Start: integer|Long expected";
            if (message.MediaID != null && message.hasOwnProperty("MediaID"))
                if (!$util.isInteger(message.MediaID))
                    return "MediaID: integer expected";
            return null;
        };

        /**
         * Creates an ArgumentsChunk message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsChunk
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsChunk} ArgumentsChunk
         */
        ArgumentsChunk.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsChunk)
                return object;
            let message = new $root.mediaarchiver.ArgumentsChunk();
            if (object.URL != null)
                message.URL = String(object.URL);
            if (object.Start != null)
                if ($util.Long)
                    (message.Start = $util.Long.fromValue(object.Start)).unsigned = false;
                else if (typeof object.Start === "string")
                    message.Start = parseInt(object.Start, 10);
                else if (typeof object.Start === "number")
                    message.Start = object.Start;
                else if (typeof object.Start === "object")
                    message.Start = new $util.LongBits(object.Start.low >>> 0, object.Start.high >>> 0).toNumber();
            if (object.MediaID != null)
                message.MediaID = object.MediaID >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsChunk message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsChunk
         * @static
         * @param {mediaarchiver.ArgumentsChunk} message ArgumentsChunk
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsChunk.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.URL = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.Start = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.Start = options.longs === String ? "0" : 0;
                object.MediaID = 0;
            }
            if (message.URL != null && message.hasOwnProperty("URL"))
                object.URL = message.URL;
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (typeof message.Start === "number")
                    object.Start = options.longs === String ? String(message.Start) : message.Start;
                else
                    object.Start = options.longs === String ? $util.Long.prototype.toString.call(message.Start) : options.longs === Number ? new $util.LongBits(message.Start.low >>> 0, message.Start.high >>> 0).toNumber() : message.Start;
            if (message.MediaID != null && message.hasOwnProperty("MediaID"))
                object.MediaID = message.MediaID;
            return object;
        };

        /**
         * Converts this ArgumentsChunk to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsChunk
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsChunk.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsChunk;
    })();

    mediaarchiver.ArgumentsStream = (function() {

        /**
         * Properties of an ArgumentsStream.
         * @memberof mediaarchiver
         * @interface IArgumentsStream
         * @property {number|null} [MediaID] ArgumentsStream MediaID
         * @property {number|Long|null} [Start] ArgumentsStream Start
         * @property {string|null} [URL] ArgumentsStream URL
         * @property {string|null} [Token] ArgumentsStream Token
         */

        /**
         * Constructs a new ArgumentsStream.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsStream.
         * @implements IArgumentsStream
         * @constructor
         * @param {mediaarchiver.IArgumentsStream=} [properties] Properties to set
         */
        function ArgumentsStream(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsStream MediaID.
         * @member {number} MediaID
         * @memberof mediaarchiver.ArgumentsStream
         * @instance
         */
        ArgumentsStream.prototype.MediaID = 0;

        /**
         * ArgumentsStream Start.
         * @member {number|Long} Start
         * @memberof mediaarchiver.ArgumentsStream
         * @instance
         */
        ArgumentsStream.prototype.Start = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ArgumentsStream URL.
         * @member {string} URL
         * @memberof mediaarchiver.ArgumentsStream
         * @instance
         */
        ArgumentsStream.prototype.URL = "";

        /**
         * ArgumentsStream Token.
         * @member {string} Token
         * @memberof mediaarchiver.ArgumentsStream
         * @instance
         */
        ArgumentsStream.prototype.Token = "";

        /**
         * Creates a new ArgumentsStream instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsStream
         * @static
         * @param {mediaarchiver.IArgumentsStream=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsStream} ArgumentsStream instance
         */
        ArgumentsStream.create = function create(properties) {
            return new ArgumentsStream(properties);
        };

        /**
         * Encodes the specified ArgumentsStream message. Does not implicitly {@link mediaarchiver.ArgumentsStream.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsStream
         * @static
         * @param {mediaarchiver.IArgumentsStream} message ArgumentsStream message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsStream.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.MediaID != null && Object.hasOwnProperty.call(message, "MediaID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.MediaID);
            if (message.Start != null && Object.hasOwnProperty.call(message, "Start"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.Start);
            if (message.URL != null && Object.hasOwnProperty.call(message, "URL"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.URL);
            if (message.Token != null && Object.hasOwnProperty.call(message, "Token"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.Token);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsStream message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsStream.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsStream
         * @static
         * @param {mediaarchiver.IArgumentsStream} message ArgumentsStream message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsStream.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsStream message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsStream
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsStream} ArgumentsStream
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsStream.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsStream();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.MediaID = reader.uint32();
                    break;
                case 2:
                    message.Start = reader.int64();
                    break;
                case 3:
                    message.URL = reader.string();
                    break;
                case 4:
                    message.Token = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsStream message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsStream
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsStream} ArgumentsStream
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsStream.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsStream message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsStream
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsStream.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.MediaID != null && message.hasOwnProperty("MediaID"))
                if (!$util.isInteger(message.MediaID))
                    return "MediaID: integer expected";
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (!$util.isInteger(message.Start) && !(message.Start && $util.isInteger(message.Start.low) && $util.isInteger(message.Start.high)))
                    return "Start: integer|Long expected";
            if (message.URL != null && message.hasOwnProperty("URL"))
                if (!$util.isString(message.URL))
                    return "URL: string expected";
            if (message.Token != null && message.hasOwnProperty("Token"))
                if (!$util.isString(message.Token))
                    return "Token: string expected";
            return null;
        };

        /**
         * Creates an ArgumentsStream message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsStream
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsStream} ArgumentsStream
         */
        ArgumentsStream.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsStream)
                return object;
            let message = new $root.mediaarchiver.ArgumentsStream();
            if (object.MediaID != null)
                message.MediaID = object.MediaID >>> 0;
            if (object.Start != null)
                if ($util.Long)
                    (message.Start = $util.Long.fromValue(object.Start)).unsigned = false;
                else if (typeof object.Start === "string")
                    message.Start = parseInt(object.Start, 10);
                else if (typeof object.Start === "number")
                    message.Start = object.Start;
                else if (typeof object.Start === "object")
                    message.Start = new $util.LongBits(object.Start.low >>> 0, object.Start.high >>> 0).toNumber();
            if (object.URL != null)
                message.URL = String(object.URL);
            if (object.Token != null)
                message.Token = String(object.Token);
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsStream message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsStream
         * @static
         * @param {mediaarchiver.ArgumentsStream} message ArgumentsStream
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsStream.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.MediaID = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.Start = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.Start = options.longs === String ? "0" : 0;
                object.URL = "";
                object.Token = "";
            }
            if (message.MediaID != null && message.hasOwnProperty("MediaID"))
                object.MediaID = message.MediaID;
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (typeof message.Start === "number")
                    object.Start = options.longs === String ? String(message.Start) : message.Start;
                else
                    object.Start = options.longs === String ? $util.Long.prototype.toString.call(message.Start) : options.longs === Number ? new $util.LongBits(message.Start.low >>> 0, message.Start.high >>> 0).toNumber() : message.Start;
            if (message.URL != null && message.hasOwnProperty("URL"))
                object.URL = message.URL;
            if (message.Token != null && message.hasOwnProperty("Token"))
                object.Token = message.Token;
            return object;
        };

        /**
         * Converts this ArgumentsStream to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsStream
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsStream.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsStream;
    })();

    mediaarchiver.SearchKind = (function() {

        /**
         * Properties of a SearchKind.
         * @memberof mediaarchiver
         * @interface ISearchKind
         * @property {string|null} [Code] SearchKind Code
         * @property {string|null} [Name] SearchKind Name
         * @property {Array.<mediaarchiver.ISearchKind>|null} [Children] SearchKind Children
         */

        /**
         * Constructs a new SearchKind.
         * @memberof mediaarchiver
         * @classdesc Represents a SearchKind.
         * @implements ISearchKind
         * @constructor
         * @param {mediaarchiver.ISearchKind=} [properties] Properties to set
         */
        function SearchKind(properties) {
            this.Children = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SearchKind Code.
         * @member {string} Code
         * @memberof mediaarchiver.SearchKind
         * @instance
         */
        SearchKind.prototype.Code = "";

        /**
         * SearchKind Name.
         * @member {string} Name
         * @memberof mediaarchiver.SearchKind
         * @instance
         */
        SearchKind.prototype.Name = "";

        /**
         * SearchKind Children.
         * @member {Array.<mediaarchiver.ISearchKind>} Children
         * @memberof mediaarchiver.SearchKind
         * @instance
         */
        SearchKind.prototype.Children = $util.emptyArray;

        /**
         * Creates a new SearchKind instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.SearchKind
         * @static
         * @param {mediaarchiver.ISearchKind=} [properties] Properties to set
         * @returns {mediaarchiver.SearchKind} SearchKind instance
         */
        SearchKind.create = function create(properties) {
            return new SearchKind(properties);
        };

        /**
         * Encodes the specified SearchKind message. Does not implicitly {@link mediaarchiver.SearchKind.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.SearchKind
         * @static
         * @param {mediaarchiver.ISearchKind} message SearchKind message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchKind.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Code != null && Object.hasOwnProperty.call(message, "Code"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Code);
            if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
            if (message.Children != null && message.Children.length)
                for (let i = 0; i < message.Children.length; ++i)
                    $root.mediaarchiver.SearchKind.encode(message.Children[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SearchKind message, length delimited. Does not implicitly {@link mediaarchiver.SearchKind.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.SearchKind
         * @static
         * @param {mediaarchiver.ISearchKind} message SearchKind message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchKind.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SearchKind message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.SearchKind
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.SearchKind} SearchKind
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchKind.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.SearchKind();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Code = reader.string();
                    break;
                case 2:
                    message.Name = reader.string();
                    break;
                case 3:
                    if (!(message.Children && message.Children.length))
                        message.Children = [];
                    message.Children.push($root.mediaarchiver.SearchKind.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SearchKind message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.SearchKind
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.SearchKind} SearchKind
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchKind.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SearchKind message.
         * @function verify
         * @memberof mediaarchiver.SearchKind
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SearchKind.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Code != null && message.hasOwnProperty("Code"))
                if (!$util.isString(message.Code))
                    return "Code: string expected";
            if (message.Name != null && message.hasOwnProperty("Name"))
                if (!$util.isString(message.Name))
                    return "Name: string expected";
            if (message.Children != null && message.hasOwnProperty("Children")) {
                if (!Array.isArray(message.Children))
                    return "Children: array expected";
                for (let i = 0; i < message.Children.length; ++i) {
                    let error = $root.mediaarchiver.SearchKind.verify(message.Children[i]);
                    if (error)
                        return "Children." + error;
                }
            }
            return null;
        };

        /**
         * Creates a SearchKind message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.SearchKind
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.SearchKind} SearchKind
         */
        SearchKind.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.SearchKind)
                return object;
            let message = new $root.mediaarchiver.SearchKind();
            if (object.Code != null)
                message.Code = String(object.Code);
            if (object.Name != null)
                message.Name = String(object.Name);
            if (object.Children) {
                if (!Array.isArray(object.Children))
                    throw TypeError(".mediaarchiver.SearchKind.Children: array expected");
                message.Children = [];
                for (let i = 0; i < object.Children.length; ++i) {
                    if (typeof object.Children[i] !== "object")
                        throw TypeError(".mediaarchiver.SearchKind.Children: object expected");
                    message.Children[i] = $root.mediaarchiver.SearchKind.fromObject(object.Children[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a SearchKind message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.SearchKind
         * @static
         * @param {mediaarchiver.SearchKind} message SearchKind
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SearchKind.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Children = [];
            if (options.defaults) {
                object.Code = "";
                object.Name = "";
            }
            if (message.Code != null && message.hasOwnProperty("Code"))
                object.Code = message.Code;
            if (message.Name != null && message.hasOwnProperty("Name"))
                object.Name = message.Name;
            if (message.Children && message.Children.length) {
                object.Children = [];
                for (let j = 0; j < message.Children.length; ++j)
                    object.Children[j] = $root.mediaarchiver.SearchKind.toObject(message.Children[j], options);
            }
            return object;
        };

        /**
         * Converts this SearchKind to JSON.
         * @function toJSON
         * @memberof mediaarchiver.SearchKind
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SearchKind.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SearchKind;
    })();

    mediaarchiver.SearchKindResult = (function() {

        /**
         * Properties of a SearchKindResult.
         * @memberof mediaarchiver
         * @interface ISearchKindResult
         * @property {Array.<mediaarchiver.ISearchKind>|null} [Result] SearchKindResult Result
         */

        /**
         * Constructs a new SearchKindResult.
         * @memberof mediaarchiver
         * @classdesc Represents a SearchKindResult.
         * @implements ISearchKindResult
         * @constructor
         * @param {mediaarchiver.ISearchKindResult=} [properties] Properties to set
         */
        function SearchKindResult(properties) {
            this.Result = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SearchKindResult Result.
         * @member {Array.<mediaarchiver.ISearchKind>} Result
         * @memberof mediaarchiver.SearchKindResult
         * @instance
         */
        SearchKindResult.prototype.Result = $util.emptyArray;

        /**
         * Creates a new SearchKindResult instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.SearchKindResult
         * @static
         * @param {mediaarchiver.ISearchKindResult=} [properties] Properties to set
         * @returns {mediaarchiver.SearchKindResult} SearchKindResult instance
         */
        SearchKindResult.create = function create(properties) {
            return new SearchKindResult(properties);
        };

        /**
         * Encodes the specified SearchKindResult message. Does not implicitly {@link mediaarchiver.SearchKindResult.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.SearchKindResult
         * @static
         * @param {mediaarchiver.ISearchKindResult} message SearchKindResult message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchKindResult.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Result != null && message.Result.length)
                for (let i = 0; i < message.Result.length; ++i)
                    $root.mediaarchiver.SearchKind.encode(message.Result[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SearchKindResult message, length delimited. Does not implicitly {@link mediaarchiver.SearchKindResult.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.SearchKindResult
         * @static
         * @param {mediaarchiver.ISearchKindResult} message SearchKindResult message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchKindResult.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SearchKindResult message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.SearchKindResult
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.SearchKindResult} SearchKindResult
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchKindResult.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.SearchKindResult();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.Result && message.Result.length))
                        message.Result = [];
                    message.Result.push($root.mediaarchiver.SearchKind.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SearchKindResult message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.SearchKindResult
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.SearchKindResult} SearchKindResult
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchKindResult.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SearchKindResult message.
         * @function verify
         * @memberof mediaarchiver.SearchKindResult
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SearchKindResult.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Result != null && message.hasOwnProperty("Result")) {
                if (!Array.isArray(message.Result))
                    return "Result: array expected";
                for (let i = 0; i < message.Result.length; ++i) {
                    let error = $root.mediaarchiver.SearchKind.verify(message.Result[i]);
                    if (error)
                        return "Result." + error;
                }
            }
            return null;
        };

        /**
         * Creates a SearchKindResult message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.SearchKindResult
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.SearchKindResult} SearchKindResult
         */
        SearchKindResult.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.SearchKindResult)
                return object;
            let message = new $root.mediaarchiver.SearchKindResult();
            if (object.Result) {
                if (!Array.isArray(object.Result))
                    throw TypeError(".mediaarchiver.SearchKindResult.Result: array expected");
                message.Result = [];
                for (let i = 0; i < object.Result.length; ++i) {
                    if (typeof object.Result[i] !== "object")
                        throw TypeError(".mediaarchiver.SearchKindResult.Result: object expected");
                    message.Result[i] = $root.mediaarchiver.SearchKind.fromObject(object.Result[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a SearchKindResult message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.SearchKindResult
         * @static
         * @param {mediaarchiver.SearchKindResult} message SearchKindResult
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SearchKindResult.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Result = [];
            if (message.Result && message.Result.length) {
                object.Result = [];
                for (let j = 0; j < message.Result.length; ++j)
                    object.Result[j] = $root.mediaarchiver.SearchKind.toObject(message.Result[j], options);
            }
            return object;
        };

        /**
         * Converts this SearchKindResult to JSON.
         * @function toJSON
         * @memberof mediaarchiver.SearchKindResult
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SearchKindResult.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SearchKindResult;
    })();

    mediaarchiver.ArgumentsSearchPrograms = (function() {

        /**
         * Properties of an ArgumentsSearchPrograms.
         * @memberof mediaarchiver
         * @interface IArgumentsSearchPrograms
         * @property {number|Long|null} [Start] ArgumentsSearchPrograms Start
         * @property {number|Long|null} [End] ArgumentsSearchPrograms End
         * @property {Array.<number>|null} [Medias] ArgumentsSearchPrograms Medias
         * @property {Array.<string>|null} [Kinds] ArgumentsSearchPrograms Kinds
         * @property {string|null} [Text] ArgumentsSearchPrograms Text
         * @property {number|null} [Page] ArgumentsSearchPrograms Page
         * @property {number|null} [PageSize] ArgumentsSearchPrograms PageSize
         */

        /**
         * Constructs a new ArgumentsSearchPrograms.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsSearchPrograms.
         * @implements IArgumentsSearchPrograms
         * @constructor
         * @param {mediaarchiver.IArgumentsSearchPrograms=} [properties] Properties to set
         */
        function ArgumentsSearchPrograms(properties) {
            this.Medias = [];
            this.Kinds = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsSearchPrograms Start.
         * @member {number|Long} Start
         * @memberof mediaarchiver.ArgumentsSearchPrograms
         * @instance
         */
        ArgumentsSearchPrograms.prototype.Start = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ArgumentsSearchPrograms End.
         * @member {number|Long} End
         * @memberof mediaarchiver.ArgumentsSearchPrograms
         * @instance
         */
        ArgumentsSearchPrograms.prototype.End = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ArgumentsSearchPrograms Medias.
         * @member {Array.<number>} Medias
         * @memberof mediaarchiver.ArgumentsSearchPrograms
         * @instance
         */
        ArgumentsSearchPrograms.prototype.Medias = $util.emptyArray;

        /**
         * ArgumentsSearchPrograms Kinds.
         * @member {Array.<string>} Kinds
         * @memberof mediaarchiver.ArgumentsSearchPrograms
         * @instance
         */
        ArgumentsSearchPrograms.prototype.Kinds = $util.emptyArray;

        /**
         * ArgumentsSearchPrograms Text.
         * @member {string} Text
         * @memberof mediaarchiver.ArgumentsSearchPrograms
         * @instance
         */
        ArgumentsSearchPrograms.prototype.Text = "";

        /**
         * ArgumentsSearchPrograms Page.
         * @member {number} Page
         * @memberof mediaarchiver.ArgumentsSearchPrograms
         * @instance
         */
        ArgumentsSearchPrograms.prototype.Page = 0;

        /**
         * ArgumentsSearchPrograms PageSize.
         * @member {number} PageSize
         * @memberof mediaarchiver.ArgumentsSearchPrograms
         * @instance
         */
        ArgumentsSearchPrograms.prototype.PageSize = 0;

        /**
         * Creates a new ArgumentsSearchPrograms instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsSearchPrograms
         * @static
         * @param {mediaarchiver.IArgumentsSearchPrograms=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsSearchPrograms} ArgumentsSearchPrograms instance
         */
        ArgumentsSearchPrograms.create = function create(properties) {
            return new ArgumentsSearchPrograms(properties);
        };

        /**
         * Encodes the specified ArgumentsSearchPrograms message. Does not implicitly {@link mediaarchiver.ArgumentsSearchPrograms.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsSearchPrograms
         * @static
         * @param {mediaarchiver.IArgumentsSearchPrograms} message ArgumentsSearchPrograms message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsSearchPrograms.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Start != null && Object.hasOwnProperty.call(message, "Start"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.Start);
            if (message.End != null && Object.hasOwnProperty.call(message, "End"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.End);
            if (message.Medias != null && message.Medias.length) {
                writer.uint32(/* id 3, wireType 2 =*/26).fork();
                for (let i = 0; i < message.Medias.length; ++i)
                    writer.uint32(message.Medias[i]);
                writer.ldelim();
            }
            if (message.Kinds != null && message.Kinds.length)
                for (let i = 0; i < message.Kinds.length; ++i)
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.Kinds[i]);
            if (message.Text != null && Object.hasOwnProperty.call(message, "Text"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.Text);
            if (message.Page != null && Object.hasOwnProperty.call(message, "Page"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.Page);
            if (message.PageSize != null && Object.hasOwnProperty.call(message, "PageSize"))
                writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.PageSize);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsSearchPrograms message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsSearchPrograms.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsSearchPrograms
         * @static
         * @param {mediaarchiver.IArgumentsSearchPrograms} message ArgumentsSearchPrograms message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsSearchPrograms.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsSearchPrograms message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsSearchPrograms
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsSearchPrograms} ArgumentsSearchPrograms
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsSearchPrograms.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsSearchPrograms();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Start = reader.int64();
                    break;
                case 2:
                    message.End = reader.int64();
                    break;
                case 3:
                    if (!(message.Medias && message.Medias.length))
                        message.Medias = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.Medias.push(reader.uint32());
                    } else
                        message.Medias.push(reader.uint32());
                    break;
                case 4:
                    if (!(message.Kinds && message.Kinds.length))
                        message.Kinds = [];
                    message.Kinds.push(reader.string());
                    break;
                case 5:
                    message.Text = reader.string();
                    break;
                case 6:
                    message.Page = reader.uint32();
                    break;
                case 7:
                    message.PageSize = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsSearchPrograms message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsSearchPrograms
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsSearchPrograms} ArgumentsSearchPrograms
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsSearchPrograms.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsSearchPrograms message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsSearchPrograms
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsSearchPrograms.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (!$util.isInteger(message.Start) && !(message.Start && $util.isInteger(message.Start.low) && $util.isInteger(message.Start.high)))
                    return "Start: integer|Long expected";
            if (message.End != null && message.hasOwnProperty("End"))
                if (!$util.isInteger(message.End) && !(message.End && $util.isInteger(message.End.low) && $util.isInteger(message.End.high)))
                    return "End: integer|Long expected";
            if (message.Medias != null && message.hasOwnProperty("Medias")) {
                if (!Array.isArray(message.Medias))
                    return "Medias: array expected";
                for (let i = 0; i < message.Medias.length; ++i)
                    if (!$util.isInteger(message.Medias[i]))
                        return "Medias: integer[] expected";
            }
            if (message.Kinds != null && message.hasOwnProperty("Kinds")) {
                if (!Array.isArray(message.Kinds))
                    return "Kinds: array expected";
                for (let i = 0; i < message.Kinds.length; ++i)
                    if (!$util.isString(message.Kinds[i]))
                        return "Kinds: string[] expected";
            }
            if (message.Text != null && message.hasOwnProperty("Text"))
                if (!$util.isString(message.Text))
                    return "Text: string expected";
            if (message.Page != null && message.hasOwnProperty("Page"))
                if (!$util.isInteger(message.Page))
                    return "Page: integer expected";
            if (message.PageSize != null && message.hasOwnProperty("PageSize"))
                if (!$util.isInteger(message.PageSize))
                    return "PageSize: integer expected";
            return null;
        };

        /**
         * Creates an ArgumentsSearchPrograms message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsSearchPrograms
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsSearchPrograms} ArgumentsSearchPrograms
         */
        ArgumentsSearchPrograms.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsSearchPrograms)
                return object;
            let message = new $root.mediaarchiver.ArgumentsSearchPrograms();
            if (object.Start != null)
                if ($util.Long)
                    (message.Start = $util.Long.fromValue(object.Start)).unsigned = false;
                else if (typeof object.Start === "string")
                    message.Start = parseInt(object.Start, 10);
                else if (typeof object.Start === "number")
                    message.Start = object.Start;
                else if (typeof object.Start === "object")
                    message.Start = new $util.LongBits(object.Start.low >>> 0, object.Start.high >>> 0).toNumber();
            if (object.End != null)
                if ($util.Long)
                    (message.End = $util.Long.fromValue(object.End)).unsigned = false;
                else if (typeof object.End === "string")
                    message.End = parseInt(object.End, 10);
                else if (typeof object.End === "number")
                    message.End = object.End;
                else if (typeof object.End === "object")
                    message.End = new $util.LongBits(object.End.low >>> 0, object.End.high >>> 0).toNumber();
            if (object.Medias) {
                if (!Array.isArray(object.Medias))
                    throw TypeError(".mediaarchiver.ArgumentsSearchPrograms.Medias: array expected");
                message.Medias = [];
                for (let i = 0; i < object.Medias.length; ++i)
                    message.Medias[i] = object.Medias[i] >>> 0;
            }
            if (object.Kinds) {
                if (!Array.isArray(object.Kinds))
                    throw TypeError(".mediaarchiver.ArgumentsSearchPrograms.Kinds: array expected");
                message.Kinds = [];
                for (let i = 0; i < object.Kinds.length; ++i)
                    message.Kinds[i] = String(object.Kinds[i]);
            }
            if (object.Text != null)
                message.Text = String(object.Text);
            if (object.Page != null)
                message.Page = object.Page >>> 0;
            if (object.PageSize != null)
                message.PageSize = object.PageSize >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsSearchPrograms message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsSearchPrograms
         * @static
         * @param {mediaarchiver.ArgumentsSearchPrograms} message ArgumentsSearchPrograms
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsSearchPrograms.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.Medias = [];
                object.Kinds = [];
            }
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.Start = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.Start = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.End = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.End = options.longs === String ? "0" : 0;
                object.Text = "";
                object.Page = 0;
                object.PageSize = 0;
            }
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (typeof message.Start === "number")
                    object.Start = options.longs === String ? String(message.Start) : message.Start;
                else
                    object.Start = options.longs === String ? $util.Long.prototype.toString.call(message.Start) : options.longs === Number ? new $util.LongBits(message.Start.low >>> 0, message.Start.high >>> 0).toNumber() : message.Start;
            if (message.End != null && message.hasOwnProperty("End"))
                if (typeof message.End === "number")
                    object.End = options.longs === String ? String(message.End) : message.End;
                else
                    object.End = options.longs === String ? $util.Long.prototype.toString.call(message.End) : options.longs === Number ? new $util.LongBits(message.End.low >>> 0, message.End.high >>> 0).toNumber() : message.End;
            if (message.Medias && message.Medias.length) {
                object.Medias = [];
                for (let j = 0; j < message.Medias.length; ++j)
                    object.Medias[j] = message.Medias[j];
            }
            if (message.Kinds && message.Kinds.length) {
                object.Kinds = [];
                for (let j = 0; j < message.Kinds.length; ++j)
                    object.Kinds[j] = message.Kinds[j];
            }
            if (message.Text != null && message.hasOwnProperty("Text"))
                object.Text = message.Text;
            if (message.Page != null && message.hasOwnProperty("Page"))
                object.Page = message.Page;
            if (message.PageSize != null && message.hasOwnProperty("PageSize"))
                object.PageSize = message.PageSize;
            return object;
        };

        /**
         * Converts this ArgumentsSearchPrograms to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsSearchPrograms
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsSearchPrograms.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsSearchPrograms;
    })();

    mediaarchiver.SearchResult = (function() {

        /**
         * Properties of a SearchResult.
         * @memberof mediaarchiver
         * @interface ISearchResult
         * @property {string|null} [Title] SearchResult Title
         * @property {string|null} [Subtitle] SearchResult Subtitle
         * @property {number|null} [MediaID] SearchResult MediaID
         * @property {string|null} [MediaName] SearchResult MediaName
         * @property {number|Long|null} [Start] SearchResult Start
         * @property {number|null} [DurationMS] SearchResult DurationMS
         * @property {string|null} [Kind] SearchResult Kind
         * @property {string|null} [Synopsis] SearchResult Synopsis
         * @property {string|null} [PlannedID] SearchResult PlannedID
         * @property {string|null} [ReadjustedID] SearchResult ReadjustedID
         * @property {number|null} [Level] SearchResult Level
         * @property {Array.<mediaarchiver.ISearchResult>|null} [Children] SearchResult Children
         */

        /**
         * Constructs a new SearchResult.
         * @memberof mediaarchiver
         * @classdesc Represents a SearchResult.
         * @implements ISearchResult
         * @constructor
         * @param {mediaarchiver.ISearchResult=} [properties] Properties to set
         */
        function SearchResult(properties) {
            this.Children = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SearchResult Title.
         * @member {string} Title
         * @memberof mediaarchiver.SearchResult
         * @instance
         */
        SearchResult.prototype.Title = "";

        /**
         * SearchResult Subtitle.
         * @member {string} Subtitle
         * @memberof mediaarchiver.SearchResult
         * @instance
         */
        SearchResult.prototype.Subtitle = "";

        /**
         * SearchResult MediaID.
         * @member {number} MediaID
         * @memberof mediaarchiver.SearchResult
         * @instance
         */
        SearchResult.prototype.MediaID = 0;

        /**
         * SearchResult MediaName.
         * @member {string} MediaName
         * @memberof mediaarchiver.SearchResult
         * @instance
         */
        SearchResult.prototype.MediaName = "";

        /**
         * SearchResult Start.
         * @member {number|Long} Start
         * @memberof mediaarchiver.SearchResult
         * @instance
         */
        SearchResult.prototype.Start = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SearchResult DurationMS.
         * @member {number} DurationMS
         * @memberof mediaarchiver.SearchResult
         * @instance
         */
        SearchResult.prototype.DurationMS = 0;

        /**
         * SearchResult Kind.
         * @member {string} Kind
         * @memberof mediaarchiver.SearchResult
         * @instance
         */
        SearchResult.prototype.Kind = "";

        /**
         * SearchResult Synopsis.
         * @member {string} Synopsis
         * @memberof mediaarchiver.SearchResult
         * @instance
         */
        SearchResult.prototype.Synopsis = "";

        /**
         * SearchResult PlannedID.
         * @member {string} PlannedID
         * @memberof mediaarchiver.SearchResult
         * @instance
         */
        SearchResult.prototype.PlannedID = "";

        /**
         * SearchResult ReadjustedID.
         * @member {string} ReadjustedID
         * @memberof mediaarchiver.SearchResult
         * @instance
         */
        SearchResult.prototype.ReadjustedID = "";

        /**
         * SearchResult Level.
         * @member {number} Level
         * @memberof mediaarchiver.SearchResult
         * @instance
         */
        SearchResult.prototype.Level = 0;

        /**
         * SearchResult Children.
         * @member {Array.<mediaarchiver.ISearchResult>} Children
         * @memberof mediaarchiver.SearchResult
         * @instance
         */
        SearchResult.prototype.Children = $util.emptyArray;

        /**
         * Creates a new SearchResult instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.SearchResult
         * @static
         * @param {mediaarchiver.ISearchResult=} [properties] Properties to set
         * @returns {mediaarchiver.SearchResult} SearchResult instance
         */
        SearchResult.create = function create(properties) {
            return new SearchResult(properties);
        };

        /**
         * Encodes the specified SearchResult message. Does not implicitly {@link mediaarchiver.SearchResult.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.SearchResult
         * @static
         * @param {mediaarchiver.ISearchResult} message SearchResult message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchResult.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Title);
            if (message.Subtitle != null && Object.hasOwnProperty.call(message, "Subtitle"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Subtitle);
            if (message.MediaID != null && Object.hasOwnProperty.call(message, "MediaID"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.MediaID);
            if (message.MediaName != null && Object.hasOwnProperty.call(message, "MediaName"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.MediaName);
            if (message.Start != null && Object.hasOwnProperty.call(message, "Start"))
                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.Start);
            if (message.DurationMS != null && Object.hasOwnProperty.call(message, "DurationMS"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.DurationMS);
            if (message.Kind != null && Object.hasOwnProperty.call(message, "Kind"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.Kind);
            if (message.Synopsis != null && Object.hasOwnProperty.call(message, "Synopsis"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.Synopsis);
            if (message.PlannedID != null && Object.hasOwnProperty.call(message, "PlannedID"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.PlannedID);
            if (message.ReadjustedID != null && Object.hasOwnProperty.call(message, "ReadjustedID"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.ReadjustedID);
            if (message.Level != null && Object.hasOwnProperty.call(message, "Level"))
                writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.Level);
            if (message.Children != null && message.Children.length)
                for (let i = 0; i < message.Children.length; ++i)
                    $root.mediaarchiver.SearchResult.encode(message.Children[i], writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SearchResult message, length delimited. Does not implicitly {@link mediaarchiver.SearchResult.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.SearchResult
         * @static
         * @param {mediaarchiver.ISearchResult} message SearchResult message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchResult.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SearchResult message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.SearchResult
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.SearchResult} SearchResult
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchResult.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.SearchResult();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Title = reader.string();
                    break;
                case 2:
                    message.Subtitle = reader.string();
                    break;
                case 3:
                    message.MediaID = reader.uint32();
                    break;
                case 4:
                    message.MediaName = reader.string();
                    break;
                case 5:
                    message.Start = reader.int64();
                    break;
                case 6:
                    message.DurationMS = reader.uint32();
                    break;
                case 7:
                    message.Kind = reader.string();
                    break;
                case 8:
                    message.Synopsis = reader.string();
                    break;
                case 9:
                    message.PlannedID = reader.string();
                    break;
                case 10:
                    message.ReadjustedID = reader.string();
                    break;
                case 11:
                    message.Level = reader.uint32();
                    break;
                case 12:
                    if (!(message.Children && message.Children.length))
                        message.Children = [];
                    message.Children.push($root.mediaarchiver.SearchResult.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SearchResult message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.SearchResult
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.SearchResult} SearchResult
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchResult.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SearchResult message.
         * @function verify
         * @memberof mediaarchiver.SearchResult
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SearchResult.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Title != null && message.hasOwnProperty("Title"))
                if (!$util.isString(message.Title))
                    return "Title: string expected";
            if (message.Subtitle != null && message.hasOwnProperty("Subtitle"))
                if (!$util.isString(message.Subtitle))
                    return "Subtitle: string expected";
            if (message.MediaID != null && message.hasOwnProperty("MediaID"))
                if (!$util.isInteger(message.MediaID))
                    return "MediaID: integer expected";
            if (message.MediaName != null && message.hasOwnProperty("MediaName"))
                if (!$util.isString(message.MediaName))
                    return "MediaName: string expected";
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (!$util.isInteger(message.Start) && !(message.Start && $util.isInteger(message.Start.low) && $util.isInteger(message.Start.high)))
                    return "Start: integer|Long expected";
            if (message.DurationMS != null && message.hasOwnProperty("DurationMS"))
                if (!$util.isInteger(message.DurationMS))
                    return "DurationMS: integer expected";
            if (message.Kind != null && message.hasOwnProperty("Kind"))
                if (!$util.isString(message.Kind))
                    return "Kind: string expected";
            if (message.Synopsis != null && message.hasOwnProperty("Synopsis"))
                if (!$util.isString(message.Synopsis))
                    return "Synopsis: string expected";
            if (message.PlannedID != null && message.hasOwnProperty("PlannedID"))
                if (!$util.isString(message.PlannedID))
                    return "PlannedID: string expected";
            if (message.ReadjustedID != null && message.hasOwnProperty("ReadjustedID"))
                if (!$util.isString(message.ReadjustedID))
                    return "ReadjustedID: string expected";
            if (message.Level != null && message.hasOwnProperty("Level"))
                if (!$util.isInteger(message.Level))
                    return "Level: integer expected";
            if (message.Children != null && message.hasOwnProperty("Children")) {
                if (!Array.isArray(message.Children))
                    return "Children: array expected";
                for (let i = 0; i < message.Children.length; ++i) {
                    let error = $root.mediaarchiver.SearchResult.verify(message.Children[i]);
                    if (error)
                        return "Children." + error;
                }
            }
            return null;
        };

        /**
         * Creates a SearchResult message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.SearchResult
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.SearchResult} SearchResult
         */
        SearchResult.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.SearchResult)
                return object;
            let message = new $root.mediaarchiver.SearchResult();
            if (object.Title != null)
                message.Title = String(object.Title);
            if (object.Subtitle != null)
                message.Subtitle = String(object.Subtitle);
            if (object.MediaID != null)
                message.MediaID = object.MediaID >>> 0;
            if (object.MediaName != null)
                message.MediaName = String(object.MediaName);
            if (object.Start != null)
                if ($util.Long)
                    (message.Start = $util.Long.fromValue(object.Start)).unsigned = false;
                else if (typeof object.Start === "string")
                    message.Start = parseInt(object.Start, 10);
                else if (typeof object.Start === "number")
                    message.Start = object.Start;
                else if (typeof object.Start === "object")
                    message.Start = new $util.LongBits(object.Start.low >>> 0, object.Start.high >>> 0).toNumber();
            if (object.DurationMS != null)
                message.DurationMS = object.DurationMS >>> 0;
            if (object.Kind != null)
                message.Kind = String(object.Kind);
            if (object.Synopsis != null)
                message.Synopsis = String(object.Synopsis);
            if (object.PlannedID != null)
                message.PlannedID = String(object.PlannedID);
            if (object.ReadjustedID != null)
                message.ReadjustedID = String(object.ReadjustedID);
            if (object.Level != null)
                message.Level = object.Level >>> 0;
            if (object.Children) {
                if (!Array.isArray(object.Children))
                    throw TypeError(".mediaarchiver.SearchResult.Children: array expected");
                message.Children = [];
                for (let i = 0; i < object.Children.length; ++i) {
                    if (typeof object.Children[i] !== "object")
                        throw TypeError(".mediaarchiver.SearchResult.Children: object expected");
                    message.Children[i] = $root.mediaarchiver.SearchResult.fromObject(object.Children[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a SearchResult message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.SearchResult
         * @static
         * @param {mediaarchiver.SearchResult} message SearchResult
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SearchResult.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Children = [];
            if (options.defaults) {
                object.Title = "";
                object.Subtitle = "";
                object.MediaID = 0;
                object.MediaName = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.Start = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.Start = options.longs === String ? "0" : 0;
                object.DurationMS = 0;
                object.Kind = "";
                object.Synopsis = "";
                object.PlannedID = "";
                object.ReadjustedID = "";
                object.Level = 0;
            }
            if (message.Title != null && message.hasOwnProperty("Title"))
                object.Title = message.Title;
            if (message.Subtitle != null && message.hasOwnProperty("Subtitle"))
                object.Subtitle = message.Subtitle;
            if (message.MediaID != null && message.hasOwnProperty("MediaID"))
                object.MediaID = message.MediaID;
            if (message.MediaName != null && message.hasOwnProperty("MediaName"))
                object.MediaName = message.MediaName;
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (typeof message.Start === "number")
                    object.Start = options.longs === String ? String(message.Start) : message.Start;
                else
                    object.Start = options.longs === String ? $util.Long.prototype.toString.call(message.Start) : options.longs === Number ? new $util.LongBits(message.Start.low >>> 0, message.Start.high >>> 0).toNumber() : message.Start;
            if (message.DurationMS != null && message.hasOwnProperty("DurationMS"))
                object.DurationMS = message.DurationMS;
            if (message.Kind != null && message.hasOwnProperty("Kind"))
                object.Kind = message.Kind;
            if (message.Synopsis != null && message.hasOwnProperty("Synopsis"))
                object.Synopsis = message.Synopsis;
            if (message.PlannedID != null && message.hasOwnProperty("PlannedID"))
                object.PlannedID = message.PlannedID;
            if (message.ReadjustedID != null && message.hasOwnProperty("ReadjustedID"))
                object.ReadjustedID = message.ReadjustedID;
            if (message.Level != null && message.hasOwnProperty("Level"))
                object.Level = message.Level;
            if (message.Children && message.Children.length) {
                object.Children = [];
                for (let j = 0; j < message.Children.length; ++j)
                    object.Children[j] = $root.mediaarchiver.SearchResult.toObject(message.Children[j], options);
            }
            return object;
        };

        /**
         * Converts this SearchResult to JSON.
         * @function toJSON
         * @memberof mediaarchiver.SearchResult
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SearchResult.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SearchResult;
    })();

    mediaarchiver.StructuredSearchResult = (function() {

        /**
         * Properties of a StructuredSearchResult.
         * @memberof mediaarchiver
         * @interface IStructuredSearchResult
         * @property {Array.<mediaarchiver.ISearchResult>|null} [Planned] StructuredSearchResult Planned
         * @property {mediaarchiver.ISearchResult|null} [Readjusted] StructuredSearchResult Readjusted
         * @property {string|null} [ID] StructuredSearchResult ID
         * @property {number|null} [MediaID] StructuredSearchResult MediaID
         */

        /**
         * Constructs a new StructuredSearchResult.
         * @memberof mediaarchiver
         * @classdesc Represents a StructuredSearchResult.
         * @implements IStructuredSearchResult
         * @constructor
         * @param {mediaarchiver.IStructuredSearchResult=} [properties] Properties to set
         */
        function StructuredSearchResult(properties) {
            this.Planned = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StructuredSearchResult Planned.
         * @member {Array.<mediaarchiver.ISearchResult>} Planned
         * @memberof mediaarchiver.StructuredSearchResult
         * @instance
         */
        StructuredSearchResult.prototype.Planned = $util.emptyArray;

        /**
         * StructuredSearchResult Readjusted.
         * @member {mediaarchiver.ISearchResult|null|undefined} Readjusted
         * @memberof mediaarchiver.StructuredSearchResult
         * @instance
         */
        StructuredSearchResult.prototype.Readjusted = null;

        /**
         * StructuredSearchResult ID.
         * @member {string} ID
         * @memberof mediaarchiver.StructuredSearchResult
         * @instance
         */
        StructuredSearchResult.prototype.ID = "";

        /**
         * StructuredSearchResult MediaID.
         * @member {number} MediaID
         * @memberof mediaarchiver.StructuredSearchResult
         * @instance
         */
        StructuredSearchResult.prototype.MediaID = 0;

        /**
         * Creates a new StructuredSearchResult instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.StructuredSearchResult
         * @static
         * @param {mediaarchiver.IStructuredSearchResult=} [properties] Properties to set
         * @returns {mediaarchiver.StructuredSearchResult} StructuredSearchResult instance
         */
        StructuredSearchResult.create = function create(properties) {
            return new StructuredSearchResult(properties);
        };

        /**
         * Encodes the specified StructuredSearchResult message. Does not implicitly {@link mediaarchiver.StructuredSearchResult.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.StructuredSearchResult
         * @static
         * @param {mediaarchiver.IStructuredSearchResult} message StructuredSearchResult message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StructuredSearchResult.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Planned != null && message.Planned.length)
                for (let i = 0; i < message.Planned.length; ++i)
                    $root.mediaarchiver.SearchResult.encode(message.Planned[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.Readjusted != null && Object.hasOwnProperty.call(message, "Readjusted"))
                $root.mediaarchiver.SearchResult.encode(message.Readjusted, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.ID);
            if (message.MediaID != null && Object.hasOwnProperty.call(message, "MediaID"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.MediaID);
            return writer;
        };

        /**
         * Encodes the specified StructuredSearchResult message, length delimited. Does not implicitly {@link mediaarchiver.StructuredSearchResult.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.StructuredSearchResult
         * @static
         * @param {mediaarchiver.IStructuredSearchResult} message StructuredSearchResult message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StructuredSearchResult.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a StructuredSearchResult message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.StructuredSearchResult
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.StructuredSearchResult} StructuredSearchResult
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StructuredSearchResult.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.StructuredSearchResult();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.Planned && message.Planned.length))
                        message.Planned = [];
                    message.Planned.push($root.mediaarchiver.SearchResult.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.Readjusted = $root.mediaarchiver.SearchResult.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.ID = reader.string();
                    break;
                case 4:
                    message.MediaID = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a StructuredSearchResult message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.StructuredSearchResult
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.StructuredSearchResult} StructuredSearchResult
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StructuredSearchResult.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a StructuredSearchResult message.
         * @function verify
         * @memberof mediaarchiver.StructuredSearchResult
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        StructuredSearchResult.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Planned != null && message.hasOwnProperty("Planned")) {
                if (!Array.isArray(message.Planned))
                    return "Planned: array expected";
                for (let i = 0; i < message.Planned.length; ++i) {
                    let error = $root.mediaarchiver.SearchResult.verify(message.Planned[i]);
                    if (error)
                        return "Planned." + error;
                }
            }
            if (message.Readjusted != null && message.hasOwnProperty("Readjusted")) {
                let error = $root.mediaarchiver.SearchResult.verify(message.Readjusted);
                if (error)
                    return "Readjusted." + error;
            }
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isString(message.ID))
                    return "ID: string expected";
            if (message.MediaID != null && message.hasOwnProperty("MediaID"))
                if (!$util.isInteger(message.MediaID))
                    return "MediaID: integer expected";
            return null;
        };

        /**
         * Creates a StructuredSearchResult message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.StructuredSearchResult
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.StructuredSearchResult} StructuredSearchResult
         */
        StructuredSearchResult.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.StructuredSearchResult)
                return object;
            let message = new $root.mediaarchiver.StructuredSearchResult();
            if (object.Planned) {
                if (!Array.isArray(object.Planned))
                    throw TypeError(".mediaarchiver.StructuredSearchResult.Planned: array expected");
                message.Planned = [];
                for (let i = 0; i < object.Planned.length; ++i) {
                    if (typeof object.Planned[i] !== "object")
                        throw TypeError(".mediaarchiver.StructuredSearchResult.Planned: object expected");
                    message.Planned[i] = $root.mediaarchiver.SearchResult.fromObject(object.Planned[i]);
                }
            }
            if (object.Readjusted != null) {
                if (typeof object.Readjusted !== "object")
                    throw TypeError(".mediaarchiver.StructuredSearchResult.Readjusted: object expected");
                message.Readjusted = $root.mediaarchiver.SearchResult.fromObject(object.Readjusted);
            }
            if (object.ID != null)
                message.ID = String(object.ID);
            if (object.MediaID != null)
                message.MediaID = object.MediaID >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a StructuredSearchResult message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.StructuredSearchResult
         * @static
         * @param {mediaarchiver.StructuredSearchResult} message StructuredSearchResult
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StructuredSearchResult.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Planned = [];
            if (options.defaults) {
                object.Readjusted = null;
                object.ID = "";
                object.MediaID = 0;
            }
            if (message.Planned && message.Planned.length) {
                object.Planned = [];
                for (let j = 0; j < message.Planned.length; ++j)
                    object.Planned[j] = $root.mediaarchiver.SearchResult.toObject(message.Planned[j], options);
            }
            if (message.Readjusted != null && message.hasOwnProperty("Readjusted"))
                object.Readjusted = $root.mediaarchiver.SearchResult.toObject(message.Readjusted, options);
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            if (message.MediaID != null && message.hasOwnProperty("MediaID"))
                object.MediaID = message.MediaID;
            return object;
        };

        /**
         * Converts this StructuredSearchResult to JSON.
         * @function toJSON
         * @memberof mediaarchiver.StructuredSearchResult
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StructuredSearchResult.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return StructuredSearchResult;
    })();

    mediaarchiver.ArgumentsSearchResults = (function() {

        /**
         * Properties of an ArgumentsSearchResults.
         * @memberof mediaarchiver
         * @interface IArgumentsSearchResults
         * @property {Array.<mediaarchiver.ISearchResult>|null} [Results] ArgumentsSearchResults Results
         * @property {number|null} [Total] ArgumentsSearchResults Total
         * @property {number|null} [Page] ArgumentsSearchResults Page
         * @property {Array.<mediaarchiver.IStructuredSearchResult>|null} [StructuredResults] ArgumentsSearchResults StructuredResults
         */

        /**
         * Constructs a new ArgumentsSearchResults.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsSearchResults.
         * @implements IArgumentsSearchResults
         * @constructor
         * @param {mediaarchiver.IArgumentsSearchResults=} [properties] Properties to set
         */
        function ArgumentsSearchResults(properties) {
            this.Results = [];
            this.StructuredResults = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsSearchResults Results.
         * @member {Array.<mediaarchiver.ISearchResult>} Results
         * @memberof mediaarchiver.ArgumentsSearchResults
         * @instance
         */
        ArgumentsSearchResults.prototype.Results = $util.emptyArray;

        /**
         * ArgumentsSearchResults Total.
         * @member {number} Total
         * @memberof mediaarchiver.ArgumentsSearchResults
         * @instance
         */
        ArgumentsSearchResults.prototype.Total = 0;

        /**
         * ArgumentsSearchResults Page.
         * @member {number} Page
         * @memberof mediaarchiver.ArgumentsSearchResults
         * @instance
         */
        ArgumentsSearchResults.prototype.Page = 0;

        /**
         * ArgumentsSearchResults StructuredResults.
         * @member {Array.<mediaarchiver.IStructuredSearchResult>} StructuredResults
         * @memberof mediaarchiver.ArgumentsSearchResults
         * @instance
         */
        ArgumentsSearchResults.prototype.StructuredResults = $util.emptyArray;

        /**
         * Creates a new ArgumentsSearchResults instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsSearchResults
         * @static
         * @param {mediaarchiver.IArgumentsSearchResults=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsSearchResults} ArgumentsSearchResults instance
         */
        ArgumentsSearchResults.create = function create(properties) {
            return new ArgumentsSearchResults(properties);
        };

        /**
         * Encodes the specified ArgumentsSearchResults message. Does not implicitly {@link mediaarchiver.ArgumentsSearchResults.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsSearchResults
         * @static
         * @param {mediaarchiver.IArgumentsSearchResults} message ArgumentsSearchResults message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsSearchResults.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Results != null && message.Results.length)
                for (let i = 0; i < message.Results.length; ++i)
                    $root.mediaarchiver.SearchResult.encode(message.Results[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.Total != null && Object.hasOwnProperty.call(message, "Total"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Total);
            if (message.Page != null && Object.hasOwnProperty.call(message, "Page"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.Page);
            if (message.StructuredResults != null && message.StructuredResults.length)
                for (let i = 0; i < message.StructuredResults.length; ++i)
                    $root.mediaarchiver.StructuredSearchResult.encode(message.StructuredResults[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ArgumentsSearchResults message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsSearchResults.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsSearchResults
         * @static
         * @param {mediaarchiver.IArgumentsSearchResults} message ArgumentsSearchResults message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsSearchResults.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsSearchResults message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsSearchResults
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsSearchResults} ArgumentsSearchResults
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsSearchResults.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsSearchResults();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.Results && message.Results.length))
                        message.Results = [];
                    message.Results.push($root.mediaarchiver.SearchResult.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.Total = reader.uint32();
                    break;
                case 3:
                    message.Page = reader.uint32();
                    break;
                case 4:
                    if (!(message.StructuredResults && message.StructuredResults.length))
                        message.StructuredResults = [];
                    message.StructuredResults.push($root.mediaarchiver.StructuredSearchResult.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsSearchResults message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsSearchResults
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsSearchResults} ArgumentsSearchResults
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsSearchResults.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsSearchResults message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsSearchResults
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsSearchResults.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Results != null && message.hasOwnProperty("Results")) {
                if (!Array.isArray(message.Results))
                    return "Results: array expected";
                for (let i = 0; i < message.Results.length; ++i) {
                    let error = $root.mediaarchiver.SearchResult.verify(message.Results[i]);
                    if (error)
                        return "Results." + error;
                }
            }
            if (message.Total != null && message.hasOwnProperty("Total"))
                if (!$util.isInteger(message.Total))
                    return "Total: integer expected";
            if (message.Page != null && message.hasOwnProperty("Page"))
                if (!$util.isInteger(message.Page))
                    return "Page: integer expected";
            if (message.StructuredResults != null && message.hasOwnProperty("StructuredResults")) {
                if (!Array.isArray(message.StructuredResults))
                    return "StructuredResults: array expected";
                for (let i = 0; i < message.StructuredResults.length; ++i) {
                    let error = $root.mediaarchiver.StructuredSearchResult.verify(message.StructuredResults[i]);
                    if (error)
                        return "StructuredResults." + error;
                }
            }
            return null;
        };

        /**
         * Creates an ArgumentsSearchResults message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsSearchResults
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsSearchResults} ArgumentsSearchResults
         */
        ArgumentsSearchResults.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsSearchResults)
                return object;
            let message = new $root.mediaarchiver.ArgumentsSearchResults();
            if (object.Results) {
                if (!Array.isArray(object.Results))
                    throw TypeError(".mediaarchiver.ArgumentsSearchResults.Results: array expected");
                message.Results = [];
                for (let i = 0; i < object.Results.length; ++i) {
                    if (typeof object.Results[i] !== "object")
                        throw TypeError(".mediaarchiver.ArgumentsSearchResults.Results: object expected");
                    message.Results[i] = $root.mediaarchiver.SearchResult.fromObject(object.Results[i]);
                }
            }
            if (object.Total != null)
                message.Total = object.Total >>> 0;
            if (object.Page != null)
                message.Page = object.Page >>> 0;
            if (object.StructuredResults) {
                if (!Array.isArray(object.StructuredResults))
                    throw TypeError(".mediaarchiver.ArgumentsSearchResults.StructuredResults: array expected");
                message.StructuredResults = [];
                for (let i = 0; i < object.StructuredResults.length; ++i) {
                    if (typeof object.StructuredResults[i] !== "object")
                        throw TypeError(".mediaarchiver.ArgumentsSearchResults.StructuredResults: object expected");
                    message.StructuredResults[i] = $root.mediaarchiver.StructuredSearchResult.fromObject(object.StructuredResults[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsSearchResults message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsSearchResults
         * @static
         * @param {mediaarchiver.ArgumentsSearchResults} message ArgumentsSearchResults
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsSearchResults.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.Results = [];
                object.StructuredResults = [];
            }
            if (options.defaults) {
                object.Total = 0;
                object.Page = 0;
            }
            if (message.Results && message.Results.length) {
                object.Results = [];
                for (let j = 0; j < message.Results.length; ++j)
                    object.Results[j] = $root.mediaarchiver.SearchResult.toObject(message.Results[j], options);
            }
            if (message.Total != null && message.hasOwnProperty("Total"))
                object.Total = message.Total;
            if (message.Page != null && message.hasOwnProperty("Page"))
                object.Page = message.Page;
            if (message.StructuredResults && message.StructuredResults.length) {
                object.StructuredResults = [];
                for (let j = 0; j < message.StructuredResults.length; ++j)
                    object.StructuredResults[j] = $root.mediaarchiver.StructuredSearchResult.toObject(message.StructuredResults[j], options);
            }
            return object;
        };

        /**
         * Converts this ArgumentsSearchResults to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsSearchResults
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsSearchResults.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsSearchResults;
    })();

    mediaarchiver.PlayerStatsChunks = (function() {

        /**
         * Properties of a PlayerStatsChunks.
         * @memberof mediaarchiver
         * @interface IPlayerStatsChunks
         * @property {number|null} [ChunksSuccessCount] PlayerStatsChunks ChunksSuccessCount
         * @property {number|null} [ChunksErrorCount] PlayerStatsChunks ChunksErrorCount
         * @property {Array.<number>|null} [ChunksDurations] PlayerStatsChunks ChunksDurations
         * @property {number|null} [ChunksBandwidth] PlayerStatsChunks ChunksBandwidth
         */

        /**
         * Constructs a new PlayerStatsChunks.
         * @memberof mediaarchiver
         * @classdesc Represents a PlayerStatsChunks.
         * @implements IPlayerStatsChunks
         * @constructor
         * @param {mediaarchiver.IPlayerStatsChunks=} [properties] Properties to set
         */
        function PlayerStatsChunks(properties) {
            this.ChunksDurations = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PlayerStatsChunks ChunksSuccessCount.
         * @member {number} ChunksSuccessCount
         * @memberof mediaarchiver.PlayerStatsChunks
         * @instance
         */
        PlayerStatsChunks.prototype.ChunksSuccessCount = 0;

        /**
         * PlayerStatsChunks ChunksErrorCount.
         * @member {number} ChunksErrorCount
         * @memberof mediaarchiver.PlayerStatsChunks
         * @instance
         */
        PlayerStatsChunks.prototype.ChunksErrorCount = 0;

        /**
         * PlayerStatsChunks ChunksDurations.
         * @member {Array.<number>} ChunksDurations
         * @memberof mediaarchiver.PlayerStatsChunks
         * @instance
         */
        PlayerStatsChunks.prototype.ChunksDurations = $util.emptyArray;

        /**
         * PlayerStatsChunks ChunksBandwidth.
         * @member {number} ChunksBandwidth
         * @memberof mediaarchiver.PlayerStatsChunks
         * @instance
         */
        PlayerStatsChunks.prototype.ChunksBandwidth = 0;

        /**
         * Creates a new PlayerStatsChunks instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.PlayerStatsChunks
         * @static
         * @param {mediaarchiver.IPlayerStatsChunks=} [properties] Properties to set
         * @returns {mediaarchiver.PlayerStatsChunks} PlayerStatsChunks instance
         */
        PlayerStatsChunks.create = function create(properties) {
            return new PlayerStatsChunks(properties);
        };

        /**
         * Encodes the specified PlayerStatsChunks message. Does not implicitly {@link mediaarchiver.PlayerStatsChunks.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.PlayerStatsChunks
         * @static
         * @param {mediaarchiver.IPlayerStatsChunks} message PlayerStatsChunks message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PlayerStatsChunks.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ChunksSuccessCount != null && Object.hasOwnProperty.call(message, "ChunksSuccessCount"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ChunksSuccessCount);
            if (message.ChunksErrorCount != null && Object.hasOwnProperty.call(message, "ChunksErrorCount"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ChunksErrorCount);
            if (message.ChunksDurations != null && message.ChunksDurations.length) {
                writer.uint32(/* id 3, wireType 2 =*/26).fork();
                for (let i = 0; i < message.ChunksDurations.length; ++i)
                    writer.uint32(message.ChunksDurations[i]);
                writer.ldelim();
            }
            if (message.ChunksBandwidth != null && Object.hasOwnProperty.call(message, "ChunksBandwidth"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.ChunksBandwidth);
            return writer;
        };

        /**
         * Encodes the specified PlayerStatsChunks message, length delimited. Does not implicitly {@link mediaarchiver.PlayerStatsChunks.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.PlayerStatsChunks
         * @static
         * @param {mediaarchiver.IPlayerStatsChunks} message PlayerStatsChunks message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PlayerStatsChunks.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PlayerStatsChunks message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.PlayerStatsChunks
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.PlayerStatsChunks} PlayerStatsChunks
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PlayerStatsChunks.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.PlayerStatsChunks();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ChunksSuccessCount = reader.uint32();
                    break;
                case 2:
                    message.ChunksErrorCount = reader.uint32();
                    break;
                case 3:
                    if (!(message.ChunksDurations && message.ChunksDurations.length))
                        message.ChunksDurations = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.ChunksDurations.push(reader.uint32());
                    } else
                        message.ChunksDurations.push(reader.uint32());
                    break;
                case 4:
                    message.ChunksBandwidth = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PlayerStatsChunks message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.PlayerStatsChunks
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.PlayerStatsChunks} PlayerStatsChunks
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PlayerStatsChunks.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PlayerStatsChunks message.
         * @function verify
         * @memberof mediaarchiver.PlayerStatsChunks
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PlayerStatsChunks.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ChunksSuccessCount != null && message.hasOwnProperty("ChunksSuccessCount"))
                if (!$util.isInteger(message.ChunksSuccessCount))
                    return "ChunksSuccessCount: integer expected";
            if (message.ChunksErrorCount != null && message.hasOwnProperty("ChunksErrorCount"))
                if (!$util.isInteger(message.ChunksErrorCount))
                    return "ChunksErrorCount: integer expected";
            if (message.ChunksDurations != null && message.hasOwnProperty("ChunksDurations")) {
                if (!Array.isArray(message.ChunksDurations))
                    return "ChunksDurations: array expected";
                for (let i = 0; i < message.ChunksDurations.length; ++i)
                    if (!$util.isInteger(message.ChunksDurations[i]))
                        return "ChunksDurations: integer[] expected";
            }
            if (message.ChunksBandwidth != null && message.hasOwnProperty("ChunksBandwidth"))
                if (!$util.isInteger(message.ChunksBandwidth))
                    return "ChunksBandwidth: integer expected";
            return null;
        };

        /**
         * Creates a PlayerStatsChunks message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.PlayerStatsChunks
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.PlayerStatsChunks} PlayerStatsChunks
         */
        PlayerStatsChunks.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.PlayerStatsChunks)
                return object;
            let message = new $root.mediaarchiver.PlayerStatsChunks();
            if (object.ChunksSuccessCount != null)
                message.ChunksSuccessCount = object.ChunksSuccessCount >>> 0;
            if (object.ChunksErrorCount != null)
                message.ChunksErrorCount = object.ChunksErrorCount >>> 0;
            if (object.ChunksDurations) {
                if (!Array.isArray(object.ChunksDurations))
                    throw TypeError(".mediaarchiver.PlayerStatsChunks.ChunksDurations: array expected");
                message.ChunksDurations = [];
                for (let i = 0; i < object.ChunksDurations.length; ++i)
                    message.ChunksDurations[i] = object.ChunksDurations[i] >>> 0;
            }
            if (object.ChunksBandwidth != null)
                message.ChunksBandwidth = object.ChunksBandwidth >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a PlayerStatsChunks message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.PlayerStatsChunks
         * @static
         * @param {mediaarchiver.PlayerStatsChunks} message PlayerStatsChunks
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PlayerStatsChunks.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.ChunksDurations = [];
            if (options.defaults) {
                object.ChunksSuccessCount = 0;
                object.ChunksErrorCount = 0;
                object.ChunksBandwidth = 0;
            }
            if (message.ChunksSuccessCount != null && message.hasOwnProperty("ChunksSuccessCount"))
                object.ChunksSuccessCount = message.ChunksSuccessCount;
            if (message.ChunksErrorCount != null && message.hasOwnProperty("ChunksErrorCount"))
                object.ChunksErrorCount = message.ChunksErrorCount;
            if (message.ChunksDurations && message.ChunksDurations.length) {
                object.ChunksDurations = [];
                for (let j = 0; j < message.ChunksDurations.length; ++j)
                    object.ChunksDurations[j] = message.ChunksDurations[j];
            }
            if (message.ChunksBandwidth != null && message.hasOwnProperty("ChunksBandwidth"))
                object.ChunksBandwidth = message.ChunksBandwidth;
            return object;
        };

        /**
         * Converts this PlayerStatsChunks to JSON.
         * @function toJSON
         * @memberof mediaarchiver.PlayerStatsChunks
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PlayerStatsChunks.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PlayerStatsChunks;
    })();

    mediaarchiver.PlayerStatsManifest = (function() {

        /**
         * Properties of a PlayerStatsManifest.
         * @memberof mediaarchiver
         * @interface IPlayerStatsManifest
         * @property {number|null} [ManifestSuccessCount] PlayerStatsManifest ManifestSuccessCount
         * @property {number|null} [ManifestErrorCount] PlayerStatsManifest ManifestErrorCount
         * @property {Array.<number>|null} [ManifestDurations] PlayerStatsManifest ManifestDurations
         */

        /**
         * Constructs a new PlayerStatsManifest.
         * @memberof mediaarchiver
         * @classdesc Represents a PlayerStatsManifest.
         * @implements IPlayerStatsManifest
         * @constructor
         * @param {mediaarchiver.IPlayerStatsManifest=} [properties] Properties to set
         */
        function PlayerStatsManifest(properties) {
            this.ManifestDurations = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PlayerStatsManifest ManifestSuccessCount.
         * @member {number} ManifestSuccessCount
         * @memberof mediaarchiver.PlayerStatsManifest
         * @instance
         */
        PlayerStatsManifest.prototype.ManifestSuccessCount = 0;

        /**
         * PlayerStatsManifest ManifestErrorCount.
         * @member {number} ManifestErrorCount
         * @memberof mediaarchiver.PlayerStatsManifest
         * @instance
         */
        PlayerStatsManifest.prototype.ManifestErrorCount = 0;

        /**
         * PlayerStatsManifest ManifestDurations.
         * @member {Array.<number>} ManifestDurations
         * @memberof mediaarchiver.PlayerStatsManifest
         * @instance
         */
        PlayerStatsManifest.prototype.ManifestDurations = $util.emptyArray;

        /**
         * Creates a new PlayerStatsManifest instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.PlayerStatsManifest
         * @static
         * @param {mediaarchiver.IPlayerStatsManifest=} [properties] Properties to set
         * @returns {mediaarchiver.PlayerStatsManifest} PlayerStatsManifest instance
         */
        PlayerStatsManifest.create = function create(properties) {
            return new PlayerStatsManifest(properties);
        };

        /**
         * Encodes the specified PlayerStatsManifest message. Does not implicitly {@link mediaarchiver.PlayerStatsManifest.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.PlayerStatsManifest
         * @static
         * @param {mediaarchiver.IPlayerStatsManifest} message PlayerStatsManifest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PlayerStatsManifest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ManifestSuccessCount != null && Object.hasOwnProperty.call(message, "ManifestSuccessCount"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ManifestSuccessCount);
            if (message.ManifestErrorCount != null && Object.hasOwnProperty.call(message, "ManifestErrorCount"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ManifestErrorCount);
            if (message.ManifestDurations != null && message.ManifestDurations.length) {
                writer.uint32(/* id 3, wireType 2 =*/26).fork();
                for (let i = 0; i < message.ManifestDurations.length; ++i)
                    writer.uint32(message.ManifestDurations[i]);
                writer.ldelim();
            }
            return writer;
        };

        /**
         * Encodes the specified PlayerStatsManifest message, length delimited. Does not implicitly {@link mediaarchiver.PlayerStatsManifest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.PlayerStatsManifest
         * @static
         * @param {mediaarchiver.IPlayerStatsManifest} message PlayerStatsManifest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PlayerStatsManifest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PlayerStatsManifest message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.PlayerStatsManifest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.PlayerStatsManifest} PlayerStatsManifest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PlayerStatsManifest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.PlayerStatsManifest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ManifestSuccessCount = reader.uint32();
                    break;
                case 2:
                    message.ManifestErrorCount = reader.uint32();
                    break;
                case 3:
                    if (!(message.ManifestDurations && message.ManifestDurations.length))
                        message.ManifestDurations = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.ManifestDurations.push(reader.uint32());
                    } else
                        message.ManifestDurations.push(reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PlayerStatsManifest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.PlayerStatsManifest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.PlayerStatsManifest} PlayerStatsManifest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PlayerStatsManifest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PlayerStatsManifest message.
         * @function verify
         * @memberof mediaarchiver.PlayerStatsManifest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PlayerStatsManifest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ManifestSuccessCount != null && message.hasOwnProperty("ManifestSuccessCount"))
                if (!$util.isInteger(message.ManifestSuccessCount))
                    return "ManifestSuccessCount: integer expected";
            if (message.ManifestErrorCount != null && message.hasOwnProperty("ManifestErrorCount"))
                if (!$util.isInteger(message.ManifestErrorCount))
                    return "ManifestErrorCount: integer expected";
            if (message.ManifestDurations != null && message.hasOwnProperty("ManifestDurations")) {
                if (!Array.isArray(message.ManifestDurations))
                    return "ManifestDurations: array expected";
                for (let i = 0; i < message.ManifestDurations.length; ++i)
                    if (!$util.isInteger(message.ManifestDurations[i]))
                        return "ManifestDurations: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a PlayerStatsManifest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.PlayerStatsManifest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.PlayerStatsManifest} PlayerStatsManifest
         */
        PlayerStatsManifest.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.PlayerStatsManifest)
                return object;
            let message = new $root.mediaarchiver.PlayerStatsManifest();
            if (object.ManifestSuccessCount != null)
                message.ManifestSuccessCount = object.ManifestSuccessCount >>> 0;
            if (object.ManifestErrorCount != null)
                message.ManifestErrorCount = object.ManifestErrorCount >>> 0;
            if (object.ManifestDurations) {
                if (!Array.isArray(object.ManifestDurations))
                    throw TypeError(".mediaarchiver.PlayerStatsManifest.ManifestDurations: array expected");
                message.ManifestDurations = [];
                for (let i = 0; i < object.ManifestDurations.length; ++i)
                    message.ManifestDurations[i] = object.ManifestDurations[i] >>> 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a PlayerStatsManifest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.PlayerStatsManifest
         * @static
         * @param {mediaarchiver.PlayerStatsManifest} message PlayerStatsManifest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PlayerStatsManifest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.ManifestDurations = [];
            if (options.defaults) {
                object.ManifestSuccessCount = 0;
                object.ManifestErrorCount = 0;
            }
            if (message.ManifestSuccessCount != null && message.hasOwnProperty("ManifestSuccessCount"))
                object.ManifestSuccessCount = message.ManifestSuccessCount;
            if (message.ManifestErrorCount != null && message.hasOwnProperty("ManifestErrorCount"))
                object.ManifestErrorCount = message.ManifestErrorCount;
            if (message.ManifestDurations && message.ManifestDurations.length) {
                object.ManifestDurations = [];
                for (let j = 0; j < message.ManifestDurations.length; ++j)
                    object.ManifestDurations[j] = message.ManifestDurations[j];
            }
            return object;
        };

        /**
         * Converts this PlayerStatsManifest to JSON.
         * @function toJSON
         * @memberof mediaarchiver.PlayerStatsManifest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PlayerStatsManifest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PlayerStatsManifest;
    })();

    mediaarchiver.ArgumentsBlockMail = (function() {

        /**
         * Properties of an ArgumentsBlockMail.
         * @memberof mediaarchiver
         * @interface IArgumentsBlockMail
         * @property {string|null} [Email] ArgumentsBlockMail Email
         * @property {string|null} [MailReason] ArgumentsBlockMail MailReason
         */

        /**
         * Constructs a new ArgumentsBlockMail.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsBlockMail.
         * @implements IArgumentsBlockMail
         * @constructor
         * @param {mediaarchiver.IArgumentsBlockMail=} [properties] Properties to set
         */
        function ArgumentsBlockMail(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsBlockMail Email.
         * @member {string} Email
         * @memberof mediaarchiver.ArgumentsBlockMail
         * @instance
         */
        ArgumentsBlockMail.prototype.Email = "";

        /**
         * ArgumentsBlockMail MailReason.
         * @member {string} MailReason
         * @memberof mediaarchiver.ArgumentsBlockMail
         * @instance
         */
        ArgumentsBlockMail.prototype.MailReason = "";

        /**
         * Creates a new ArgumentsBlockMail instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsBlockMail
         * @static
         * @param {mediaarchiver.IArgumentsBlockMail=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsBlockMail} ArgumentsBlockMail instance
         */
        ArgumentsBlockMail.create = function create(properties) {
            return new ArgumentsBlockMail(properties);
        };

        /**
         * Encodes the specified ArgumentsBlockMail message. Does not implicitly {@link mediaarchiver.ArgumentsBlockMail.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsBlockMail
         * @static
         * @param {mediaarchiver.IArgumentsBlockMail} message ArgumentsBlockMail message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsBlockMail.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Email != null && Object.hasOwnProperty.call(message, "Email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Email);
            if (message.MailReason != null && Object.hasOwnProperty.call(message, "MailReason"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.MailReason);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsBlockMail message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsBlockMail.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsBlockMail
         * @static
         * @param {mediaarchiver.IArgumentsBlockMail} message ArgumentsBlockMail message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsBlockMail.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsBlockMail message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsBlockMail
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsBlockMail} ArgumentsBlockMail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsBlockMail.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsBlockMail();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Email = reader.string();
                    break;
                case 2:
                    message.MailReason = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsBlockMail message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsBlockMail
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsBlockMail} ArgumentsBlockMail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsBlockMail.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsBlockMail message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsBlockMail
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsBlockMail.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Email != null && message.hasOwnProperty("Email"))
                if (!$util.isString(message.Email))
                    return "Email: string expected";
            if (message.MailReason != null && message.hasOwnProperty("MailReason"))
                if (!$util.isString(message.MailReason))
                    return "MailReason: string expected";
            return null;
        };

        /**
         * Creates an ArgumentsBlockMail message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsBlockMail
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsBlockMail} ArgumentsBlockMail
         */
        ArgumentsBlockMail.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsBlockMail)
                return object;
            let message = new $root.mediaarchiver.ArgumentsBlockMail();
            if (object.Email != null)
                message.Email = String(object.Email);
            if (object.MailReason != null)
                message.MailReason = String(object.MailReason);
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsBlockMail message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsBlockMail
         * @static
         * @param {mediaarchiver.ArgumentsBlockMail} message ArgumentsBlockMail
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsBlockMail.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.Email = "";
                object.MailReason = "";
            }
            if (message.Email != null && message.hasOwnProperty("Email"))
                object.Email = message.Email;
            if (message.MailReason != null && message.hasOwnProperty("MailReason"))
                object.MailReason = message.MailReason;
            return object;
        };

        /**
         * Converts this ArgumentsBlockMail to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsBlockMail
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsBlockMail.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsBlockMail;
    })();

    mediaarchiver.ArgumentsMessageAck = (function() {

        /**
         * Properties of an ArgumentsMessageAck.
         * @memberof mediaarchiver
         * @interface IArgumentsMessageAck
         * @property {string|null} [MessageID] ArgumentsMessageAck MessageID
         * @property {boolean|null} [Success] ArgumentsMessageAck Success
         * @property {string|null} [Error] ArgumentsMessageAck Error
         */

        /**
         * Constructs a new ArgumentsMessageAck.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsMessageAck.
         * @implements IArgumentsMessageAck
         * @constructor
         * @param {mediaarchiver.IArgumentsMessageAck=} [properties] Properties to set
         */
        function ArgumentsMessageAck(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsMessageAck MessageID.
         * @member {string} MessageID
         * @memberof mediaarchiver.ArgumentsMessageAck
         * @instance
         */
        ArgumentsMessageAck.prototype.MessageID = "";

        /**
         * ArgumentsMessageAck Success.
         * @member {boolean} Success
         * @memberof mediaarchiver.ArgumentsMessageAck
         * @instance
         */
        ArgumentsMessageAck.prototype.Success = false;

        /**
         * ArgumentsMessageAck Error.
         * @member {string} Error
         * @memberof mediaarchiver.ArgumentsMessageAck
         * @instance
         */
        ArgumentsMessageAck.prototype.Error = "";

        /**
         * Creates a new ArgumentsMessageAck instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsMessageAck
         * @static
         * @param {mediaarchiver.IArgumentsMessageAck=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsMessageAck} ArgumentsMessageAck instance
         */
        ArgumentsMessageAck.create = function create(properties) {
            return new ArgumentsMessageAck(properties);
        };

        /**
         * Encodes the specified ArgumentsMessageAck message. Does not implicitly {@link mediaarchiver.ArgumentsMessageAck.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsMessageAck
         * @static
         * @param {mediaarchiver.IArgumentsMessageAck} message ArgumentsMessageAck message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsMessageAck.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.MessageID != null && Object.hasOwnProperty.call(message, "MessageID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.MessageID);
            if (message.Success != null && Object.hasOwnProperty.call(message, "Success"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.Success);
            if (message.Error != null && Object.hasOwnProperty.call(message, "Error"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.Error);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsMessageAck message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsMessageAck.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsMessageAck
         * @static
         * @param {mediaarchiver.IArgumentsMessageAck} message ArgumentsMessageAck message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsMessageAck.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsMessageAck message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsMessageAck
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsMessageAck} ArgumentsMessageAck
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsMessageAck.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsMessageAck();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.MessageID = reader.string();
                    break;
                case 2:
                    message.Success = reader.bool();
                    break;
                case 3:
                    message.Error = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsMessageAck message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsMessageAck
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsMessageAck} ArgumentsMessageAck
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsMessageAck.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsMessageAck message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsMessageAck
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsMessageAck.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.MessageID != null && message.hasOwnProperty("MessageID"))
                if (!$util.isString(message.MessageID))
                    return "MessageID: string expected";
            if (message.Success != null && message.hasOwnProperty("Success"))
                if (typeof message.Success !== "boolean")
                    return "Success: boolean expected";
            if (message.Error != null && message.hasOwnProperty("Error"))
                if (!$util.isString(message.Error))
                    return "Error: string expected";
            return null;
        };

        /**
         * Creates an ArgumentsMessageAck message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsMessageAck
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsMessageAck} ArgumentsMessageAck
         */
        ArgumentsMessageAck.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsMessageAck)
                return object;
            let message = new $root.mediaarchiver.ArgumentsMessageAck();
            if (object.MessageID != null)
                message.MessageID = String(object.MessageID);
            if (object.Success != null)
                message.Success = Boolean(object.Success);
            if (object.Error != null)
                message.Error = String(object.Error);
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsMessageAck message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsMessageAck
         * @static
         * @param {mediaarchiver.ArgumentsMessageAck} message ArgumentsMessageAck
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsMessageAck.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.MessageID = "";
                object.Success = false;
                object.Error = "";
            }
            if (message.MessageID != null && message.hasOwnProperty("MessageID"))
                object.MessageID = message.MessageID;
            if (message.Success != null && message.hasOwnProperty("Success"))
                object.Success = message.Success;
            if (message.Error != null && message.hasOwnProperty("Error"))
                object.Error = message.Error;
            return object;
        };

        /**
         * Converts this ArgumentsMessageAck to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsMessageAck
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsMessageAck.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsMessageAck;
    })();

    mediaarchiver.ArgumentsGetMediasSTT = (function() {

        /**
         * Properties of an ArgumentsGetMediasSTT.
         * @memberof mediaarchiver
         * @interface IArgumentsGetMediasSTT
         * @property {boolean|null} [TV] ArgumentsGetMediasSTT TV
         * @property {boolean|null} [Radio] ArgumentsGetMediasSTT Radio
         */

        /**
         * Constructs a new ArgumentsGetMediasSTT.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsGetMediasSTT.
         * @implements IArgumentsGetMediasSTT
         * @constructor
         * @param {mediaarchiver.IArgumentsGetMediasSTT=} [properties] Properties to set
         */
        function ArgumentsGetMediasSTT(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsGetMediasSTT TV.
         * @member {boolean} TV
         * @memberof mediaarchiver.ArgumentsGetMediasSTT
         * @instance
         */
        ArgumentsGetMediasSTT.prototype.TV = false;

        /**
         * ArgumentsGetMediasSTT Radio.
         * @member {boolean} Radio
         * @memberof mediaarchiver.ArgumentsGetMediasSTT
         * @instance
         */
        ArgumentsGetMediasSTT.prototype.Radio = false;

        /**
         * Creates a new ArgumentsGetMediasSTT instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsGetMediasSTT
         * @static
         * @param {mediaarchiver.IArgumentsGetMediasSTT=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsGetMediasSTT} ArgumentsGetMediasSTT instance
         */
        ArgumentsGetMediasSTT.create = function create(properties) {
            return new ArgumentsGetMediasSTT(properties);
        };

        /**
         * Encodes the specified ArgumentsGetMediasSTT message. Does not implicitly {@link mediaarchiver.ArgumentsGetMediasSTT.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsGetMediasSTT
         * @static
         * @param {mediaarchiver.IArgumentsGetMediasSTT} message ArgumentsGetMediasSTT message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetMediasSTT.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.TV != null && Object.hasOwnProperty.call(message, "TV"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.TV);
            if (message.Radio != null && Object.hasOwnProperty.call(message, "Radio"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.Radio);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsGetMediasSTT message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsGetMediasSTT.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsGetMediasSTT
         * @static
         * @param {mediaarchiver.IArgumentsGetMediasSTT} message ArgumentsGetMediasSTT message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetMediasSTT.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsGetMediasSTT message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsGetMediasSTT
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsGetMediasSTT} ArgumentsGetMediasSTT
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetMediasSTT.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsGetMediasSTT();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.TV = reader.bool();
                    break;
                case 2:
                    message.Radio = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsGetMediasSTT message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsGetMediasSTT
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsGetMediasSTT} ArgumentsGetMediasSTT
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetMediasSTT.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsGetMediasSTT message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsGetMediasSTT
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsGetMediasSTT.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.TV != null && message.hasOwnProperty("TV"))
                if (typeof message.TV !== "boolean")
                    return "TV: boolean expected";
            if (message.Radio != null && message.hasOwnProperty("Radio"))
                if (typeof message.Radio !== "boolean")
                    return "Radio: boolean expected";
            return null;
        };

        /**
         * Creates an ArgumentsGetMediasSTT message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsGetMediasSTT
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsGetMediasSTT} ArgumentsGetMediasSTT
         */
        ArgumentsGetMediasSTT.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsGetMediasSTT)
                return object;
            let message = new $root.mediaarchiver.ArgumentsGetMediasSTT();
            if (object.TV != null)
                message.TV = Boolean(object.TV);
            if (object.Radio != null)
                message.Radio = Boolean(object.Radio);
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsGetMediasSTT message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsGetMediasSTT
         * @static
         * @param {mediaarchiver.ArgumentsGetMediasSTT} message ArgumentsGetMediasSTT
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsGetMediasSTT.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.TV = false;
                object.Radio = false;
            }
            if (message.TV != null && message.hasOwnProperty("TV"))
                object.TV = message.TV;
            if (message.Radio != null && message.hasOwnProperty("Radio"))
                object.Radio = message.Radio;
            return object;
        };

        /**
         * Converts this ArgumentsGetMediasSTT to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsGetMediasSTT
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsGetMediasSTT.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsGetMediasSTT;
    })();

    mediaarchiver.ArgumentsMedias = (function() {

        /**
         * Properties of an ArgumentsMedias.
         * @memberof mediaarchiver
         * @interface IArgumentsMedias
         * @property {Array.<mediaarchiver.IMedia>|null} [Radio] ArgumentsMedias Radio
         * @property {Array.<mediaarchiver.IMedia>|null} [TV] ArgumentsMedias TV
         */

        /**
         * Constructs a new ArgumentsMedias.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsMedias.
         * @implements IArgumentsMedias
         * @constructor
         * @param {mediaarchiver.IArgumentsMedias=} [properties] Properties to set
         */
        function ArgumentsMedias(properties) {
            this.Radio = [];
            this.TV = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsMedias Radio.
         * @member {Array.<mediaarchiver.IMedia>} Radio
         * @memberof mediaarchiver.ArgumentsMedias
         * @instance
         */
        ArgumentsMedias.prototype.Radio = $util.emptyArray;

        /**
         * ArgumentsMedias TV.
         * @member {Array.<mediaarchiver.IMedia>} TV
         * @memberof mediaarchiver.ArgumentsMedias
         * @instance
         */
        ArgumentsMedias.prototype.TV = $util.emptyArray;

        /**
         * Creates a new ArgumentsMedias instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsMedias
         * @static
         * @param {mediaarchiver.IArgumentsMedias=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsMedias} ArgumentsMedias instance
         */
        ArgumentsMedias.create = function create(properties) {
            return new ArgumentsMedias(properties);
        };

        /**
         * Encodes the specified ArgumentsMedias message. Does not implicitly {@link mediaarchiver.ArgumentsMedias.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsMedias
         * @static
         * @param {mediaarchiver.IArgumentsMedias} message ArgumentsMedias message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsMedias.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Radio != null && message.Radio.length)
                for (let i = 0; i < message.Radio.length; ++i)
                    $root.mediaarchiver.Media.encode(message.Radio[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.TV != null && message.TV.length)
                for (let i = 0; i < message.TV.length; ++i)
                    $root.mediaarchiver.Media.encode(message.TV[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ArgumentsMedias message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsMedias.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsMedias
         * @static
         * @param {mediaarchiver.IArgumentsMedias} message ArgumentsMedias message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsMedias.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsMedias message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsMedias
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsMedias} ArgumentsMedias
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsMedias.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsMedias();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.Radio && message.Radio.length))
                        message.Radio = [];
                    message.Radio.push($root.mediaarchiver.Media.decode(reader, reader.uint32()));
                    break;
                case 2:
                    if (!(message.TV && message.TV.length))
                        message.TV = [];
                    message.TV.push($root.mediaarchiver.Media.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsMedias message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsMedias
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsMedias} ArgumentsMedias
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsMedias.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsMedias message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsMedias
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsMedias.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Radio != null && message.hasOwnProperty("Radio")) {
                if (!Array.isArray(message.Radio))
                    return "Radio: array expected";
                for (let i = 0; i < message.Radio.length; ++i) {
                    let error = $root.mediaarchiver.Media.verify(message.Radio[i]);
                    if (error)
                        return "Radio." + error;
                }
            }
            if (message.TV != null && message.hasOwnProperty("TV")) {
                if (!Array.isArray(message.TV))
                    return "TV: array expected";
                for (let i = 0; i < message.TV.length; ++i) {
                    let error = $root.mediaarchiver.Media.verify(message.TV[i]);
                    if (error)
                        return "TV." + error;
                }
            }
            return null;
        };

        /**
         * Creates an ArgumentsMedias message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsMedias
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsMedias} ArgumentsMedias
         */
        ArgumentsMedias.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsMedias)
                return object;
            let message = new $root.mediaarchiver.ArgumentsMedias();
            if (object.Radio) {
                if (!Array.isArray(object.Radio))
                    throw TypeError(".mediaarchiver.ArgumentsMedias.Radio: array expected");
                message.Radio = [];
                for (let i = 0; i < object.Radio.length; ++i) {
                    if (typeof object.Radio[i] !== "object")
                        throw TypeError(".mediaarchiver.ArgumentsMedias.Radio: object expected");
                    message.Radio[i] = $root.mediaarchiver.Media.fromObject(object.Radio[i]);
                }
            }
            if (object.TV) {
                if (!Array.isArray(object.TV))
                    throw TypeError(".mediaarchiver.ArgumentsMedias.TV: array expected");
                message.TV = [];
                for (let i = 0; i < object.TV.length; ++i) {
                    if (typeof object.TV[i] !== "object")
                        throw TypeError(".mediaarchiver.ArgumentsMedias.TV: object expected");
                    message.TV[i] = $root.mediaarchiver.Media.fromObject(object.TV[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsMedias message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsMedias
         * @static
         * @param {mediaarchiver.ArgumentsMedias} message ArgumentsMedias
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsMedias.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.Radio = [];
                object.TV = [];
            }
            if (message.Radio && message.Radio.length) {
                object.Radio = [];
                for (let j = 0; j < message.Radio.length; ++j)
                    object.Radio[j] = $root.mediaarchiver.Media.toObject(message.Radio[j], options);
            }
            if (message.TV && message.TV.length) {
                object.TV = [];
                for (let j = 0; j < message.TV.length; ++j)
                    object.TV[j] = $root.mediaarchiver.Media.toObject(message.TV[j], options);
            }
            return object;
        };

        /**
         * Converts this ArgumentsMedias to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsMedias
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsMedias.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsMedias;
    })();

    mediaarchiver.Media = (function() {

        /**
         * Properties of a Media.
         * @memberof mediaarchiver
         * @interface IMedia
         * @property {string|null} [CodeSacem] Media CodeSacem
         * @property {mediaarchiver.IMediaCountry|null} [Country] Media Country
         * @property {number|null} [ID] Media ID
         * @property {string|null} [Name] Media Name
         * @property {string|null} [ShortName] Media ShortName
         * @property {mediaarchiver.IMediaType|null} [Type] Media Type
         */

        /**
         * Constructs a new Media.
         * @memberof mediaarchiver
         * @classdesc Represents a Media.
         * @implements IMedia
         * @constructor
         * @param {mediaarchiver.IMedia=} [properties] Properties to set
         */
        function Media(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Media CodeSacem.
         * @member {string} CodeSacem
         * @memberof mediaarchiver.Media
         * @instance
         */
        Media.prototype.CodeSacem = "";

        /**
         * Media Country.
         * @member {mediaarchiver.IMediaCountry|null|undefined} Country
         * @memberof mediaarchiver.Media
         * @instance
         */
        Media.prototype.Country = null;

        /**
         * Media ID.
         * @member {number} ID
         * @memberof mediaarchiver.Media
         * @instance
         */
        Media.prototype.ID = 0;

        /**
         * Media Name.
         * @member {string} Name
         * @memberof mediaarchiver.Media
         * @instance
         */
        Media.prototype.Name = "";

        /**
         * Media ShortName.
         * @member {string} ShortName
         * @memberof mediaarchiver.Media
         * @instance
         */
        Media.prototype.ShortName = "";

        /**
         * Media Type.
         * @member {mediaarchiver.IMediaType|null|undefined} Type
         * @memberof mediaarchiver.Media
         * @instance
         */
        Media.prototype.Type = null;

        /**
         * Creates a new Media instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.Media
         * @static
         * @param {mediaarchiver.IMedia=} [properties] Properties to set
         * @returns {mediaarchiver.Media} Media instance
         */
        Media.create = function create(properties) {
            return new Media(properties);
        };

        /**
         * Encodes the specified Media message. Does not implicitly {@link mediaarchiver.Media.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.Media
         * @static
         * @param {mediaarchiver.IMedia} message Media message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Media.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.CodeSacem != null && Object.hasOwnProperty.call(message, "CodeSacem"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.CodeSacem);
            if (message.Country != null && Object.hasOwnProperty.call(message, "Country"))
                $root.mediaarchiver.MediaCountry.encode(message.Country, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ID);
            if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.Name);
            if (message.ShortName != null && Object.hasOwnProperty.call(message, "ShortName"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.ShortName);
            if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
                $root.mediaarchiver.MediaType.encode(message.Type, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Media message, length delimited. Does not implicitly {@link mediaarchiver.Media.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.Media
         * @static
         * @param {mediaarchiver.IMedia} message Media message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Media.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Media message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.Media
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.Media} Media
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Media.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.Media();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.CodeSacem = reader.string();
                    break;
                case 2:
                    message.Country = $root.mediaarchiver.MediaCountry.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.ID = reader.uint32();
                    break;
                case 4:
                    message.Name = reader.string();
                    break;
                case 5:
                    message.ShortName = reader.string();
                    break;
                case 6:
                    message.Type = $root.mediaarchiver.MediaType.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Media message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.Media
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.Media} Media
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Media.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Media message.
         * @function verify
         * @memberof mediaarchiver.Media
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Media.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.CodeSacem != null && message.hasOwnProperty("CodeSacem"))
                if (!$util.isString(message.CodeSacem))
                    return "CodeSacem: string expected";
            if (message.Country != null && message.hasOwnProperty("Country")) {
                let error = $root.mediaarchiver.MediaCountry.verify(message.Country);
                if (error)
                    return "Country." + error;
            }
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isInteger(message.ID))
                    return "ID: integer expected";
            if (message.Name != null && message.hasOwnProperty("Name"))
                if (!$util.isString(message.Name))
                    return "Name: string expected";
            if (message.ShortName != null && message.hasOwnProperty("ShortName"))
                if (!$util.isString(message.ShortName))
                    return "ShortName: string expected";
            if (message.Type != null && message.hasOwnProperty("Type")) {
                let error = $root.mediaarchiver.MediaType.verify(message.Type);
                if (error)
                    return "Type." + error;
            }
            return null;
        };

        /**
         * Creates a Media message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.Media
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.Media} Media
         */
        Media.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.Media)
                return object;
            let message = new $root.mediaarchiver.Media();
            if (object.CodeSacem != null)
                message.CodeSacem = String(object.CodeSacem);
            if (object.Country != null) {
                if (typeof object.Country !== "object")
                    throw TypeError(".mediaarchiver.Media.Country: object expected");
                message.Country = $root.mediaarchiver.MediaCountry.fromObject(object.Country);
            }
            if (object.ID != null)
                message.ID = object.ID >>> 0;
            if (object.Name != null)
                message.Name = String(object.Name);
            if (object.ShortName != null)
                message.ShortName = String(object.ShortName);
            if (object.Type != null) {
                if (typeof object.Type !== "object")
                    throw TypeError(".mediaarchiver.Media.Type: object expected");
                message.Type = $root.mediaarchiver.MediaType.fromObject(object.Type);
            }
            return message;
        };

        /**
         * Creates a plain object from a Media message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.Media
         * @static
         * @param {mediaarchiver.Media} message Media
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Media.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.CodeSacem = "";
                object.Country = null;
                object.ID = 0;
                object.Name = "";
                object.ShortName = "";
                object.Type = null;
            }
            if (message.CodeSacem != null && message.hasOwnProperty("CodeSacem"))
                object.CodeSacem = message.CodeSacem;
            if (message.Country != null && message.hasOwnProperty("Country"))
                object.Country = $root.mediaarchiver.MediaCountry.toObject(message.Country, options);
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            if (message.Name != null && message.hasOwnProperty("Name"))
                object.Name = message.Name;
            if (message.ShortName != null && message.hasOwnProperty("ShortName"))
                object.ShortName = message.ShortName;
            if (message.Type != null && message.hasOwnProperty("Type"))
                object.Type = $root.mediaarchiver.MediaType.toObject(message.Type, options);
            return object;
        };

        /**
         * Converts this Media to JSON.
         * @function toJSON
         * @memberof mediaarchiver.Media
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Media.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Media;
    })();

    mediaarchiver.MediaCountry = (function() {

        /**
         * Properties of a MediaCountry.
         * @memberof mediaarchiver
         * @interface IMediaCountry
         * @property {string|null} [ISO] MediaCountry ISO
         * @property {number|null} [ID] MediaCountry ID
         * @property {string|null} [Name] MediaCountry Name
         * @property {string|null} [Timezone] MediaCountry Timezone
         */

        /**
         * Constructs a new MediaCountry.
         * @memberof mediaarchiver
         * @classdesc Represents a MediaCountry.
         * @implements IMediaCountry
         * @constructor
         * @param {mediaarchiver.IMediaCountry=} [properties] Properties to set
         */
        function MediaCountry(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MediaCountry ISO.
         * @member {string} ISO
         * @memberof mediaarchiver.MediaCountry
         * @instance
         */
        MediaCountry.prototype.ISO = "";

        /**
         * MediaCountry ID.
         * @member {number} ID
         * @memberof mediaarchiver.MediaCountry
         * @instance
         */
        MediaCountry.prototype.ID = 0;

        /**
         * MediaCountry Name.
         * @member {string} Name
         * @memberof mediaarchiver.MediaCountry
         * @instance
         */
        MediaCountry.prototype.Name = "";

        /**
         * MediaCountry Timezone.
         * @member {string} Timezone
         * @memberof mediaarchiver.MediaCountry
         * @instance
         */
        MediaCountry.prototype.Timezone = "";

        /**
         * Creates a new MediaCountry instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.MediaCountry
         * @static
         * @param {mediaarchiver.IMediaCountry=} [properties] Properties to set
         * @returns {mediaarchiver.MediaCountry} MediaCountry instance
         */
        MediaCountry.create = function create(properties) {
            return new MediaCountry(properties);
        };

        /**
         * Encodes the specified MediaCountry message. Does not implicitly {@link mediaarchiver.MediaCountry.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.MediaCountry
         * @static
         * @param {mediaarchiver.IMediaCountry} message MediaCountry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaCountry.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ISO != null && Object.hasOwnProperty.call(message, "ISO"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.ISO);
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ID);
            if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.Name);
            if (message.Timezone != null && Object.hasOwnProperty.call(message, "Timezone"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.Timezone);
            return writer;
        };

        /**
         * Encodes the specified MediaCountry message, length delimited. Does not implicitly {@link mediaarchiver.MediaCountry.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.MediaCountry
         * @static
         * @param {mediaarchiver.IMediaCountry} message MediaCountry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaCountry.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MediaCountry message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.MediaCountry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.MediaCountry} MediaCountry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaCountry.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.MediaCountry();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ISO = reader.string();
                    break;
                case 2:
                    message.ID = reader.uint32();
                    break;
                case 3:
                    message.Name = reader.string();
                    break;
                case 4:
                    message.Timezone = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MediaCountry message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.MediaCountry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.MediaCountry} MediaCountry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaCountry.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MediaCountry message.
         * @function verify
         * @memberof mediaarchiver.MediaCountry
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MediaCountry.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ISO != null && message.hasOwnProperty("ISO"))
                if (!$util.isString(message.ISO))
                    return "ISO: string expected";
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isInteger(message.ID))
                    return "ID: integer expected";
            if (message.Name != null && message.hasOwnProperty("Name"))
                if (!$util.isString(message.Name))
                    return "Name: string expected";
            if (message.Timezone != null && message.hasOwnProperty("Timezone"))
                if (!$util.isString(message.Timezone))
                    return "Timezone: string expected";
            return null;
        };

        /**
         * Creates a MediaCountry message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.MediaCountry
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.MediaCountry} MediaCountry
         */
        MediaCountry.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.MediaCountry)
                return object;
            let message = new $root.mediaarchiver.MediaCountry();
            if (object.ISO != null)
                message.ISO = String(object.ISO);
            if (object.ID != null)
                message.ID = object.ID >>> 0;
            if (object.Name != null)
                message.Name = String(object.Name);
            if (object.Timezone != null)
                message.Timezone = String(object.Timezone);
            return message;
        };

        /**
         * Creates a plain object from a MediaCountry message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.MediaCountry
         * @static
         * @param {mediaarchiver.MediaCountry} message MediaCountry
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MediaCountry.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.ISO = "";
                object.ID = 0;
                object.Name = "";
                object.Timezone = "";
            }
            if (message.ISO != null && message.hasOwnProperty("ISO"))
                object.ISO = message.ISO;
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            if (message.Name != null && message.hasOwnProperty("Name"))
                object.Name = message.Name;
            if (message.Timezone != null && message.hasOwnProperty("Timezone"))
                object.Timezone = message.Timezone;
            return object;
        };

        /**
         * Converts this MediaCountry to JSON.
         * @function toJSON
         * @memberof mediaarchiver.MediaCountry
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MediaCountry.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MediaCountry;
    })();

    mediaarchiver.MediaType = (function() {

        /**
         * Properties of a MediaType.
         * @memberof mediaarchiver
         * @interface IMediaType
         * @property {number|null} [ID] MediaType ID
         * @property {string|null} [Label] MediaType Label
         */

        /**
         * Constructs a new MediaType.
         * @memberof mediaarchiver
         * @classdesc Represents a MediaType.
         * @implements IMediaType
         * @constructor
         * @param {mediaarchiver.IMediaType=} [properties] Properties to set
         */
        function MediaType(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MediaType ID.
         * @member {number} ID
         * @memberof mediaarchiver.MediaType
         * @instance
         */
        MediaType.prototype.ID = 0;

        /**
         * MediaType Label.
         * @member {string} Label
         * @memberof mediaarchiver.MediaType
         * @instance
         */
        MediaType.prototype.Label = "";

        /**
         * Creates a new MediaType instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.MediaType
         * @static
         * @param {mediaarchiver.IMediaType=} [properties] Properties to set
         * @returns {mediaarchiver.MediaType} MediaType instance
         */
        MediaType.create = function create(properties) {
            return new MediaType(properties);
        };

        /**
         * Encodes the specified MediaType message. Does not implicitly {@link mediaarchiver.MediaType.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.MediaType
         * @static
         * @param {mediaarchiver.IMediaType} message MediaType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ID);
            if (message.Label != null && Object.hasOwnProperty.call(message, "Label"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Label);
            return writer;
        };

        /**
         * Encodes the specified MediaType message, length delimited. Does not implicitly {@link mediaarchiver.MediaType.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.MediaType
         * @static
         * @param {mediaarchiver.IMediaType} message MediaType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MediaType message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.MediaType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.MediaType} MediaType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.MediaType();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ID = reader.uint32();
                    break;
                case 2:
                    message.Label = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MediaType message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.MediaType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.MediaType} MediaType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MediaType message.
         * @function verify
         * @memberof mediaarchiver.MediaType
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MediaType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isInteger(message.ID))
                    return "ID: integer expected";
            if (message.Label != null && message.hasOwnProperty("Label"))
                if (!$util.isString(message.Label))
                    return "Label: string expected";
            return null;
        };

        /**
         * Creates a MediaType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.MediaType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.MediaType} MediaType
         */
        MediaType.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.MediaType)
                return object;
            let message = new $root.mediaarchiver.MediaType();
            if (object.ID != null)
                message.ID = object.ID >>> 0;
            if (object.Label != null)
                message.Label = String(object.Label);
            return message;
        };

        /**
         * Creates a plain object from a MediaType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.MediaType
         * @static
         * @param {mediaarchiver.MediaType} message MediaType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MediaType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.ID = 0;
                object.Label = "";
            }
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            if (message.Label != null && message.hasOwnProperty("Label"))
                object.Label = message.Label;
            return object;
        };

        /**
         * Converts this MediaType to JSON.
         * @function toJSON
         * @memberof mediaarchiver.MediaType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MediaType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MediaType;
    })();

    mediaarchiver.ArgumentsGetEPG = (function() {

        /**
         * Properties of an ArgumentsGetEPG.
         * @memberof mediaarchiver
         * @interface IArgumentsGetEPG
         * @property {number|null} [MediaID] ArgumentsGetEPG MediaID
         * @property {number|Long|null} [From] ArgumentsGetEPG From
         * @property {number|Long|null} [To] ArgumentsGetEPG To
         * @property {Array.<mediaarchiver.EPGType>|null} [Types] ArgumentsGetEPG Types
         * @property {string|null} [Lang] ArgumentsGetEPG Lang
         */

        /**
         * Constructs a new ArgumentsGetEPG.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsGetEPG.
         * @implements IArgumentsGetEPG
         * @constructor
         * @param {mediaarchiver.IArgumentsGetEPG=} [properties] Properties to set
         */
        function ArgumentsGetEPG(properties) {
            this.Types = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsGetEPG MediaID.
         * @member {number} MediaID
         * @memberof mediaarchiver.ArgumentsGetEPG
         * @instance
         */
        ArgumentsGetEPG.prototype.MediaID = 0;

        /**
         * ArgumentsGetEPG From.
         * @member {number|Long} From
         * @memberof mediaarchiver.ArgumentsGetEPG
         * @instance
         */
        ArgumentsGetEPG.prototype.From = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ArgumentsGetEPG To.
         * @member {number|Long} To
         * @memberof mediaarchiver.ArgumentsGetEPG
         * @instance
         */
        ArgumentsGetEPG.prototype.To = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ArgumentsGetEPG Types.
         * @member {Array.<mediaarchiver.EPGType>} Types
         * @memberof mediaarchiver.ArgumentsGetEPG
         * @instance
         */
        ArgumentsGetEPG.prototype.Types = $util.emptyArray;

        /**
         * ArgumentsGetEPG Lang.
         * @member {string} Lang
         * @memberof mediaarchiver.ArgumentsGetEPG
         * @instance
         */
        ArgumentsGetEPG.prototype.Lang = "";

        /**
         * Creates a new ArgumentsGetEPG instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsGetEPG
         * @static
         * @param {mediaarchiver.IArgumentsGetEPG=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsGetEPG} ArgumentsGetEPG instance
         */
        ArgumentsGetEPG.create = function create(properties) {
            return new ArgumentsGetEPG(properties);
        };

        /**
         * Encodes the specified ArgumentsGetEPG message. Does not implicitly {@link mediaarchiver.ArgumentsGetEPG.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsGetEPG
         * @static
         * @param {mediaarchiver.IArgumentsGetEPG} message ArgumentsGetEPG message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetEPG.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.MediaID != null && Object.hasOwnProperty.call(message, "MediaID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.MediaID);
            if (message.From != null && Object.hasOwnProperty.call(message, "From"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.From);
            if (message.To != null && Object.hasOwnProperty.call(message, "To"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.To);
            if (message.Types != null && message.Types.length) {
                writer.uint32(/* id 4, wireType 2 =*/34).fork();
                for (let i = 0; i < message.Types.length; ++i)
                    writer.int32(message.Types[i]);
                writer.ldelim();
            }
            if (message.Lang != null && Object.hasOwnProperty.call(message, "Lang"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.Lang);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsGetEPG message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsGetEPG.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsGetEPG
         * @static
         * @param {mediaarchiver.IArgumentsGetEPG} message ArgumentsGetEPG message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetEPG.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsGetEPG message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsGetEPG
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsGetEPG} ArgumentsGetEPG
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetEPG.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsGetEPG();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.MediaID = reader.uint32();
                    break;
                case 2:
                    message.From = reader.int64();
                    break;
                case 3:
                    message.To = reader.int64();
                    break;
                case 4:
                    if (!(message.Types && message.Types.length))
                        message.Types = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.Types.push(reader.int32());
                    } else
                        message.Types.push(reader.int32());
                    break;
                case 5:
                    message.Lang = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsGetEPG message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsGetEPG
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsGetEPG} ArgumentsGetEPG
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetEPG.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsGetEPG message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsGetEPG
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsGetEPG.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.MediaID != null && message.hasOwnProperty("MediaID"))
                if (!$util.isInteger(message.MediaID))
                    return "MediaID: integer expected";
            if (message.From != null && message.hasOwnProperty("From"))
                if (!$util.isInteger(message.From) && !(message.From && $util.isInteger(message.From.low) && $util.isInteger(message.From.high)))
                    return "From: integer|Long expected";
            if (message.To != null && message.hasOwnProperty("To"))
                if (!$util.isInteger(message.To) && !(message.To && $util.isInteger(message.To.low) && $util.isInteger(message.To.high)))
                    return "To: integer|Long expected";
            if (message.Types != null && message.hasOwnProperty("Types")) {
                if (!Array.isArray(message.Types))
                    return "Types: array expected";
                for (let i = 0; i < message.Types.length; ++i)
                    switch (message.Types[i]) {
                    default:
                        return "Types: enum value[] expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 16:
                    case 17:
                    case 18:
                    case 19:
                    case 20:
                    case 21:
                    case 22:
                    case 23:
                    case 24:
                    case 25:
                    case 26:
                    case 27:
                    case 28:
                    case 29:
                    case 30:
                    case 31:
                    case 32:
                    case 33:
                    case 34:
                    case 35:
                    case 36:
                    case 37:
                    case 38:
                    case 39:
                    case 40:
                    case 41:
                    case 42:
                    case 43:
                        break;
                    }
            }
            if (message.Lang != null && message.hasOwnProperty("Lang"))
                if (!$util.isString(message.Lang))
                    return "Lang: string expected";
            return null;
        };

        /**
         * Creates an ArgumentsGetEPG message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsGetEPG
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsGetEPG} ArgumentsGetEPG
         */
        ArgumentsGetEPG.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsGetEPG)
                return object;
            let message = new $root.mediaarchiver.ArgumentsGetEPG();
            if (object.MediaID != null)
                message.MediaID = object.MediaID >>> 0;
            if (object.From != null)
                if ($util.Long)
                    (message.From = $util.Long.fromValue(object.From)).unsigned = false;
                else if (typeof object.From === "string")
                    message.From = parseInt(object.From, 10);
                else if (typeof object.From === "number")
                    message.From = object.From;
                else if (typeof object.From === "object")
                    message.From = new $util.LongBits(object.From.low >>> 0, object.From.high >>> 0).toNumber();
            if (object.To != null)
                if ($util.Long)
                    (message.To = $util.Long.fromValue(object.To)).unsigned = false;
                else if (typeof object.To === "string")
                    message.To = parseInt(object.To, 10);
                else if (typeof object.To === "number")
                    message.To = object.To;
                else if (typeof object.To === "object")
                    message.To = new $util.LongBits(object.To.low >>> 0, object.To.high >>> 0).toNumber();
            if (object.Types) {
                if (!Array.isArray(object.Types))
                    throw TypeError(".mediaarchiver.ArgumentsGetEPG.Types: array expected");
                message.Types = [];
                for (let i = 0; i < object.Types.length; ++i)
                    switch (object.Types[i]) {
                    default:
                    case "DECLARATIVE":
                    case 0:
                        message.Types[i] = 0;
                        break;
                    case "READJUSTED1":
                    case 1:
                        message.Types[i] = 1;
                        break;
                    case "READJUSTED2":
                    case 2:
                        message.Types[i] = 2;
                        break;
                    case "MUSIC":
                    case 3:
                        message.Types[i] = 3;
                        break;
                    case "TALK":
                    case 4:
                        message.Types[i] = 4;
                        break;
                    case "ANNOTATIONS":
                    case 5:
                        message.Types[i] = 5;
                        break;
                    case "AUDIENCE":
                    case 6:
                        message.Types[i] = 6;
                        break;
                    case "METADATA":
                    case 7:
                        message.Types[i] = 7;
                        break;
                    case "BACKGROUND":
                    case 8:
                        message.Types[i] = 8;
                        break;
                    case "STT":
                    case 9:
                        message.Types[i] = 9;
                        break;
                    case "BROADCASTER1":
                    case 10:
                        message.Types[i] = 10;
                        break;
                    case "BROADCASTER2":
                    case 11:
                        message.Types[i] = 11;
                        break;
                    case "DECLARATIVERADIO1":
                    case 12:
                        message.Types[i] = 12;
                        break;
                    case "DECLARATIVERADIO2":
                    case 13:
                        message.Types[i] = 13;
                        break;
                    case "CROSSBUCKET":
                    case 14:
                        message.Types[i] = 14;
                        break;
                    case "EXTRACTRESULTS":
                    case 15:
                        message.Types[i] = 15;
                        break;
                    case "BRUTPHONO1":
                    case 16:
                        message.Types[i] = 16;
                        break;
                    case "BRUTPHONO2":
                    case 17:
                        message.Types[i] = 17;
                        break;
                    case "BRUTPHONO3":
                    case 18:
                        message.Types[i] = 18;
                        break;
                    case "BRUTPHONO4":
                    case 19:
                        message.Types[i] = 19;
                        break;
                    case "LEONV11":
                    case 20:
                        message.Types[i] = 20;
                        break;
                    case "LEONV12":
                    case 21:
                        message.Types[i] = 21;
                        break;
                    case "LEONV13":
                    case 22:
                        message.Types[i] = 22;
                        break;
                    case "LEONV14":
                    case 23:
                        message.Types[i] = 23;
                        break;
                    case "NIKITAMONOBUCKET1":
                    case 24:
                        message.Types[i] = 24;
                        break;
                    case "NIKITAMONOBUCKET2":
                    case 25:
                        message.Types[i] = 25;
                        break;
                    case "NIKITAMONOBUCKET3":
                    case 26:
                        message.Types[i] = 26;
                        break;
                    case "NIKITAMONOBUCKET4":
                    case 27:
                        message.Types[i] = 27;
                        break;
                    case "ARPP":
                    case 28:
                        message.Types[i] = 28;
                        break;
                    case "BACKGROUNDSTG":
                    case 29:
                        message.Types[i] = 29;
                        break;
                    case "CROSSBUCKETSTG":
                    case 30:
                        message.Types[i] = 30;
                        break;
                    case "MNM0":
                    case 31:
                        message.Types[i] = 31;
                        break;
                    case "MNM1":
                    case 32:
                        message.Types[i] = 32;
                        break;
                    case "MNMXB0":
                    case 33:
                        message.Types[i] = 33;
                        break;
                    case "MNMXB1":
                    case 34:
                        message.Types[i] = 34;
                        break;
                    case "SPONSORING":
                    case 35:
                        message.Types[i] = 35;
                        break;
                    case "MNIONLY0":
                    case 36:
                        message.Types[i] = 36;
                        break;
                    case "MNIONLY1":
                    case 37:
                        message.Types[i] = 37;
                        break;
                    case "OCR1":
                    case 38:
                        message.Types[i] = 38;
                        break;
                    case "OCR2":
                    case 39:
                        message.Types[i] = 39;
                        break;
                    case "TALKDETAILS1":
                    case 40:
                        message.Types[i] = 40;
                        break;
                    case "TALKDETAILS2":
                    case 41:
                        message.Types[i] = 41;
                        break;
                    case "OCRTITLE1":
                    case 42:
                        message.Types[i] = 42;
                        break;
                    case "OCRTITLE2":
                    case 43:
                        message.Types[i] = 43;
                        break;
                    }
            }
            if (object.Lang != null)
                message.Lang = String(object.Lang);
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsGetEPG message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsGetEPG
         * @static
         * @param {mediaarchiver.ArgumentsGetEPG} message ArgumentsGetEPG
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsGetEPG.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Types = [];
            if (options.defaults) {
                object.MediaID = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.From = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.From = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.To = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.To = options.longs === String ? "0" : 0;
                object.Lang = "";
            }
            if (message.MediaID != null && message.hasOwnProperty("MediaID"))
                object.MediaID = message.MediaID;
            if (message.From != null && message.hasOwnProperty("From"))
                if (typeof message.From === "number")
                    object.From = options.longs === String ? String(message.From) : message.From;
                else
                    object.From = options.longs === String ? $util.Long.prototype.toString.call(message.From) : options.longs === Number ? new $util.LongBits(message.From.low >>> 0, message.From.high >>> 0).toNumber() : message.From;
            if (message.To != null && message.hasOwnProperty("To"))
                if (typeof message.To === "number")
                    object.To = options.longs === String ? String(message.To) : message.To;
                else
                    object.To = options.longs === String ? $util.Long.prototype.toString.call(message.To) : options.longs === Number ? new $util.LongBits(message.To.low >>> 0, message.To.high >>> 0).toNumber() : message.To;
            if (message.Types && message.Types.length) {
                object.Types = [];
                for (let j = 0; j < message.Types.length; ++j)
                    object.Types[j] = options.enums === String ? $root.mediaarchiver.EPGType[message.Types[j]] : message.Types[j];
            }
            if (message.Lang != null && message.hasOwnProperty("Lang"))
                object.Lang = message.Lang;
            return object;
        };

        /**
         * Converts this ArgumentsGetEPG to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsGetEPG
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsGetEPG.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsGetEPG;
    })();

    mediaarchiver.Contact = (function() {

        /**
         * Properties of a Contact.
         * @memberof mediaarchiver
         * @interface IContact
         * @property {string|null} [FirstName] Contact FirstName
         * @property {string|null} [LastName] Contact LastName
         * @property {string|null} [Email] Contact Email
         * @property {string|null} [ID] Contact ID
         * @property {number|null} [Owner] Contact Owner
         */

        /**
         * Constructs a new Contact.
         * @memberof mediaarchiver
         * @classdesc Represents a Contact.
         * @implements IContact
         * @constructor
         * @param {mediaarchiver.IContact=} [properties] Properties to set
         */
        function Contact(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Contact FirstName.
         * @member {string} FirstName
         * @memberof mediaarchiver.Contact
         * @instance
         */
        Contact.prototype.FirstName = "";

        /**
         * Contact LastName.
         * @member {string} LastName
         * @memberof mediaarchiver.Contact
         * @instance
         */
        Contact.prototype.LastName = "";

        /**
         * Contact Email.
         * @member {string} Email
         * @memberof mediaarchiver.Contact
         * @instance
         */
        Contact.prototype.Email = "";

        /**
         * Contact ID.
         * @member {string} ID
         * @memberof mediaarchiver.Contact
         * @instance
         */
        Contact.prototype.ID = "";

        /**
         * Contact Owner.
         * @member {number} Owner
         * @memberof mediaarchiver.Contact
         * @instance
         */
        Contact.prototype.Owner = 0;

        /**
         * Creates a new Contact instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.Contact
         * @static
         * @param {mediaarchiver.IContact=} [properties] Properties to set
         * @returns {mediaarchiver.Contact} Contact instance
         */
        Contact.create = function create(properties) {
            return new Contact(properties);
        };

        /**
         * Encodes the specified Contact message. Does not implicitly {@link mediaarchiver.Contact.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.Contact
         * @static
         * @param {mediaarchiver.IContact} message Contact message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Contact.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.FirstName != null && Object.hasOwnProperty.call(message, "FirstName"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.FirstName);
            if (message.LastName != null && Object.hasOwnProperty.call(message, "LastName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.LastName);
            if (message.Email != null && Object.hasOwnProperty.call(message, "Email"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.Email);
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.ID);
            if (message.Owner != null && Object.hasOwnProperty.call(message, "Owner"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.Owner);
            return writer;
        };

        /**
         * Encodes the specified Contact message, length delimited. Does not implicitly {@link mediaarchiver.Contact.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.Contact
         * @static
         * @param {mediaarchiver.IContact} message Contact message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Contact.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Contact message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.Contact
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.Contact} Contact
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Contact.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.Contact();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.FirstName = reader.string();
                    break;
                case 2:
                    message.LastName = reader.string();
                    break;
                case 3:
                    message.Email = reader.string();
                    break;
                case 4:
                    message.ID = reader.string();
                    break;
                case 5:
                    message.Owner = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Contact message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.Contact
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.Contact} Contact
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Contact.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Contact message.
         * @function verify
         * @memberof mediaarchiver.Contact
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Contact.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.FirstName != null && message.hasOwnProperty("FirstName"))
                if (!$util.isString(message.FirstName))
                    return "FirstName: string expected";
            if (message.LastName != null && message.hasOwnProperty("LastName"))
                if (!$util.isString(message.LastName))
                    return "LastName: string expected";
            if (message.Email != null && message.hasOwnProperty("Email"))
                if (!$util.isString(message.Email))
                    return "Email: string expected";
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isString(message.ID))
                    return "ID: string expected";
            if (message.Owner != null && message.hasOwnProperty("Owner"))
                if (!$util.isInteger(message.Owner))
                    return "Owner: integer expected";
            return null;
        };

        /**
         * Creates a Contact message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.Contact
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.Contact} Contact
         */
        Contact.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.Contact)
                return object;
            let message = new $root.mediaarchiver.Contact();
            if (object.FirstName != null)
                message.FirstName = String(object.FirstName);
            if (object.LastName != null)
                message.LastName = String(object.LastName);
            if (object.Email != null)
                message.Email = String(object.Email);
            if (object.ID != null)
                message.ID = String(object.ID);
            if (object.Owner != null)
                message.Owner = object.Owner >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Contact message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.Contact
         * @static
         * @param {mediaarchiver.Contact} message Contact
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Contact.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.FirstName = "";
                object.LastName = "";
                object.Email = "";
                object.ID = "";
                object.Owner = 0;
            }
            if (message.FirstName != null && message.hasOwnProperty("FirstName"))
                object.FirstName = message.FirstName;
            if (message.LastName != null && message.hasOwnProperty("LastName"))
                object.LastName = message.LastName;
            if (message.Email != null && message.hasOwnProperty("Email"))
                object.Email = message.Email;
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            if (message.Owner != null && message.hasOwnProperty("Owner"))
                object.Owner = message.Owner;
            return object;
        };

        /**
         * Converts this Contact to JSON.
         * @function toJSON
         * @memberof mediaarchiver.Contact
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Contact.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Contact;
    })();

    mediaarchiver.ArgumentsContacts = (function() {

        /**
         * Properties of an ArgumentsContacts.
         * @memberof mediaarchiver
         * @interface IArgumentsContacts
         * @property {number|null} [Offset] ArgumentsContacts Offset
         * @property {number|null} [Count] ArgumentsContacts Count
         * @property {Array.<mediaarchiver.IContact>|null} [Contacts] ArgumentsContacts Contacts
         */

        /**
         * Constructs a new ArgumentsContacts.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsContacts.
         * @implements IArgumentsContacts
         * @constructor
         * @param {mediaarchiver.IArgumentsContacts=} [properties] Properties to set
         */
        function ArgumentsContacts(properties) {
            this.Contacts = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsContacts Offset.
         * @member {number} Offset
         * @memberof mediaarchiver.ArgumentsContacts
         * @instance
         */
        ArgumentsContacts.prototype.Offset = 0;

        /**
         * ArgumentsContacts Count.
         * @member {number} Count
         * @memberof mediaarchiver.ArgumentsContacts
         * @instance
         */
        ArgumentsContacts.prototype.Count = 0;

        /**
         * ArgumentsContacts Contacts.
         * @member {Array.<mediaarchiver.IContact>} Contacts
         * @memberof mediaarchiver.ArgumentsContacts
         * @instance
         */
        ArgumentsContacts.prototype.Contacts = $util.emptyArray;

        /**
         * Creates a new ArgumentsContacts instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsContacts
         * @static
         * @param {mediaarchiver.IArgumentsContacts=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsContacts} ArgumentsContacts instance
         */
        ArgumentsContacts.create = function create(properties) {
            return new ArgumentsContacts(properties);
        };

        /**
         * Encodes the specified ArgumentsContacts message. Does not implicitly {@link mediaarchiver.ArgumentsContacts.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsContacts
         * @static
         * @param {mediaarchiver.IArgumentsContacts} message ArgumentsContacts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsContacts.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Offset != null && Object.hasOwnProperty.call(message, "Offset"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Offset);
            if (message.Count != null && Object.hasOwnProperty.call(message, "Count"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Count);
            if (message.Contacts != null && message.Contacts.length)
                for (let i = 0; i < message.Contacts.length; ++i)
                    $root.mediaarchiver.Contact.encode(message.Contacts[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ArgumentsContacts message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsContacts.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsContacts
         * @static
         * @param {mediaarchiver.IArgumentsContacts} message ArgumentsContacts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsContacts.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsContacts message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsContacts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsContacts} ArgumentsContacts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsContacts.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsContacts();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Offset = reader.uint32();
                    break;
                case 2:
                    message.Count = reader.uint32();
                    break;
                case 3:
                    if (!(message.Contacts && message.Contacts.length))
                        message.Contacts = [];
                    message.Contacts.push($root.mediaarchiver.Contact.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsContacts message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsContacts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsContacts} ArgumentsContacts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsContacts.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsContacts message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsContacts
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsContacts.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                if (!$util.isInteger(message.Offset))
                    return "Offset: integer expected";
            if (message.Count != null && message.hasOwnProperty("Count"))
                if (!$util.isInteger(message.Count))
                    return "Count: integer expected";
            if (message.Contacts != null && message.hasOwnProperty("Contacts")) {
                if (!Array.isArray(message.Contacts))
                    return "Contacts: array expected";
                for (let i = 0; i < message.Contacts.length; ++i) {
                    let error = $root.mediaarchiver.Contact.verify(message.Contacts[i]);
                    if (error)
                        return "Contacts." + error;
                }
            }
            return null;
        };

        /**
         * Creates an ArgumentsContacts message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsContacts
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsContacts} ArgumentsContacts
         */
        ArgumentsContacts.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsContacts)
                return object;
            let message = new $root.mediaarchiver.ArgumentsContacts();
            if (object.Offset != null)
                message.Offset = object.Offset >>> 0;
            if (object.Count != null)
                message.Count = object.Count >>> 0;
            if (object.Contacts) {
                if (!Array.isArray(object.Contacts))
                    throw TypeError(".mediaarchiver.ArgumentsContacts.Contacts: array expected");
                message.Contacts = [];
                for (let i = 0; i < object.Contacts.length; ++i) {
                    if (typeof object.Contacts[i] !== "object")
                        throw TypeError(".mediaarchiver.ArgumentsContacts.Contacts: object expected");
                    message.Contacts[i] = $root.mediaarchiver.Contact.fromObject(object.Contacts[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsContacts message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsContacts
         * @static
         * @param {mediaarchiver.ArgumentsContacts} message ArgumentsContacts
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsContacts.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Contacts = [];
            if (options.defaults) {
                object.Offset = 0;
                object.Count = 0;
            }
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                object.Offset = message.Offset;
            if (message.Count != null && message.hasOwnProperty("Count"))
                object.Count = message.Count;
            if (message.Contacts && message.Contacts.length) {
                object.Contacts = [];
                for (let j = 0; j < message.Contacts.length; ++j)
                    object.Contacts[j] = $root.mediaarchiver.Contact.toObject(message.Contacts[j], options);
            }
            return object;
        };

        /**
         * Converts this ArgumentsContacts to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsContacts
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsContacts.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsContacts;
    })();

    mediaarchiver.ArgumentsGetContacts = (function() {

        /**
         * Properties of an ArgumentsGetContacts.
         * @memberof mediaarchiver
         * @interface IArgumentsGetContacts
         * @property {number|null} [Limit] ArgumentsGetContacts Limit
         * @property {number|null} [Offset] ArgumentsGetContacts Offset
         */

        /**
         * Constructs a new ArgumentsGetContacts.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsGetContacts.
         * @implements IArgumentsGetContacts
         * @constructor
         * @param {mediaarchiver.IArgumentsGetContacts=} [properties] Properties to set
         */
        function ArgumentsGetContacts(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsGetContacts Limit.
         * @member {number} Limit
         * @memberof mediaarchiver.ArgumentsGetContacts
         * @instance
         */
        ArgumentsGetContacts.prototype.Limit = 0;

        /**
         * ArgumentsGetContacts Offset.
         * @member {number} Offset
         * @memberof mediaarchiver.ArgumentsGetContacts
         * @instance
         */
        ArgumentsGetContacts.prototype.Offset = 0;

        /**
         * Creates a new ArgumentsGetContacts instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsGetContacts
         * @static
         * @param {mediaarchiver.IArgumentsGetContacts=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsGetContacts} ArgumentsGetContacts instance
         */
        ArgumentsGetContacts.create = function create(properties) {
            return new ArgumentsGetContacts(properties);
        };

        /**
         * Encodes the specified ArgumentsGetContacts message. Does not implicitly {@link mediaarchiver.ArgumentsGetContacts.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsGetContacts
         * @static
         * @param {mediaarchiver.IArgumentsGetContacts} message ArgumentsGetContacts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetContacts.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Limit != null && Object.hasOwnProperty.call(message, "Limit"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Limit);
            if (message.Offset != null && Object.hasOwnProperty.call(message, "Offset"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Offset);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsGetContacts message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsGetContacts.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsGetContacts
         * @static
         * @param {mediaarchiver.IArgumentsGetContacts} message ArgumentsGetContacts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetContacts.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsGetContacts message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsGetContacts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsGetContacts} ArgumentsGetContacts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetContacts.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsGetContacts();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Limit = reader.uint32();
                    break;
                case 2:
                    message.Offset = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsGetContacts message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsGetContacts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsGetContacts} ArgumentsGetContacts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetContacts.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsGetContacts message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsGetContacts
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsGetContacts.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Limit != null && message.hasOwnProperty("Limit"))
                if (!$util.isInteger(message.Limit))
                    return "Limit: integer expected";
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                if (!$util.isInteger(message.Offset))
                    return "Offset: integer expected";
            return null;
        };

        /**
         * Creates an ArgumentsGetContacts message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsGetContacts
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsGetContacts} ArgumentsGetContacts
         */
        ArgumentsGetContacts.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsGetContacts)
                return object;
            let message = new $root.mediaarchiver.ArgumentsGetContacts();
            if (object.Limit != null)
                message.Limit = object.Limit >>> 0;
            if (object.Offset != null)
                message.Offset = object.Offset >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsGetContacts message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsGetContacts
         * @static
         * @param {mediaarchiver.ArgumentsGetContacts} message ArgumentsGetContacts
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsGetContacts.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.Limit = 0;
                object.Offset = 0;
            }
            if (message.Limit != null && message.hasOwnProperty("Limit"))
                object.Limit = message.Limit;
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                object.Offset = message.Offset;
            return object;
        };

        /**
         * Converts this ArgumentsGetContacts to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsGetContacts
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsGetContacts.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsGetContacts;
    })();

    mediaarchiver.ArgumentsCreateAnnotation = (function() {

        /**
         * Properties of an ArgumentsCreateAnnotation.
         * @memberof mediaarchiver
         * @interface IArgumentsCreateAnnotation
         * @property {number|Long|null} [MediaID] ArgumentsCreateAnnotation MediaID
         * @property {number|Long|null} [Start] ArgumentsCreateAnnotation Start
         * @property {number|Long|null} [End] ArgumentsCreateAnnotation End
         * @property {string|null} [Type] ArgumentsCreateAnnotation Type
         * @property {string|null} [Data] ArgumentsCreateAnnotation Data
         */

        /**
         * Constructs a new ArgumentsCreateAnnotation.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsCreateAnnotation.
         * @implements IArgumentsCreateAnnotation
         * @constructor
         * @param {mediaarchiver.IArgumentsCreateAnnotation=} [properties] Properties to set
         */
        function ArgumentsCreateAnnotation(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsCreateAnnotation MediaID.
         * @member {number|Long} MediaID
         * @memberof mediaarchiver.ArgumentsCreateAnnotation
         * @instance
         */
        ArgumentsCreateAnnotation.prototype.MediaID = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ArgumentsCreateAnnotation Start.
         * @member {number|Long} Start
         * @memberof mediaarchiver.ArgumentsCreateAnnotation
         * @instance
         */
        ArgumentsCreateAnnotation.prototype.Start = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ArgumentsCreateAnnotation End.
         * @member {number|Long} End
         * @memberof mediaarchiver.ArgumentsCreateAnnotation
         * @instance
         */
        ArgumentsCreateAnnotation.prototype.End = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ArgumentsCreateAnnotation Type.
         * @member {string} Type
         * @memberof mediaarchiver.ArgumentsCreateAnnotation
         * @instance
         */
        ArgumentsCreateAnnotation.prototype.Type = "";

        /**
         * ArgumentsCreateAnnotation Data.
         * @member {string} Data
         * @memberof mediaarchiver.ArgumentsCreateAnnotation
         * @instance
         */
        ArgumentsCreateAnnotation.prototype.Data = "";

        /**
         * Creates a new ArgumentsCreateAnnotation instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsCreateAnnotation
         * @static
         * @param {mediaarchiver.IArgumentsCreateAnnotation=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsCreateAnnotation} ArgumentsCreateAnnotation instance
         */
        ArgumentsCreateAnnotation.create = function create(properties) {
            return new ArgumentsCreateAnnotation(properties);
        };

        /**
         * Encodes the specified ArgumentsCreateAnnotation message. Does not implicitly {@link mediaarchiver.ArgumentsCreateAnnotation.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsCreateAnnotation
         * @static
         * @param {mediaarchiver.IArgumentsCreateAnnotation} message ArgumentsCreateAnnotation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsCreateAnnotation.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.MediaID != null && Object.hasOwnProperty.call(message, "MediaID"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.MediaID);
            if (message.Start != null && Object.hasOwnProperty.call(message, "Start"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.Start);
            if (message.End != null && Object.hasOwnProperty.call(message, "End"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.End);
            if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.Type);
            if (message.Data != null && Object.hasOwnProperty.call(message, "Data"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.Data);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsCreateAnnotation message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsCreateAnnotation.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsCreateAnnotation
         * @static
         * @param {mediaarchiver.IArgumentsCreateAnnotation} message ArgumentsCreateAnnotation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsCreateAnnotation.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsCreateAnnotation message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsCreateAnnotation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsCreateAnnotation} ArgumentsCreateAnnotation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsCreateAnnotation.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsCreateAnnotation();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.MediaID = reader.int64();
                    break;
                case 2:
                    message.Start = reader.int64();
                    break;
                case 3:
                    message.End = reader.int64();
                    break;
                case 4:
                    message.Type = reader.string();
                    break;
                case 5:
                    message.Data = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsCreateAnnotation message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsCreateAnnotation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsCreateAnnotation} ArgumentsCreateAnnotation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsCreateAnnotation.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsCreateAnnotation message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsCreateAnnotation
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsCreateAnnotation.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.MediaID != null && message.hasOwnProperty("MediaID"))
                if (!$util.isInteger(message.MediaID) && !(message.MediaID && $util.isInteger(message.MediaID.low) && $util.isInteger(message.MediaID.high)))
                    return "MediaID: integer|Long expected";
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (!$util.isInteger(message.Start) && !(message.Start && $util.isInteger(message.Start.low) && $util.isInteger(message.Start.high)))
                    return "Start: integer|Long expected";
            if (message.End != null && message.hasOwnProperty("End"))
                if (!$util.isInteger(message.End) && !(message.End && $util.isInteger(message.End.low) && $util.isInteger(message.End.high)))
                    return "End: integer|Long expected";
            if (message.Type != null && message.hasOwnProperty("Type"))
                if (!$util.isString(message.Type))
                    return "Type: string expected";
            if (message.Data != null && message.hasOwnProperty("Data"))
                if (!$util.isString(message.Data))
                    return "Data: string expected";
            return null;
        };

        /**
         * Creates an ArgumentsCreateAnnotation message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsCreateAnnotation
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsCreateAnnotation} ArgumentsCreateAnnotation
         */
        ArgumentsCreateAnnotation.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsCreateAnnotation)
                return object;
            let message = new $root.mediaarchiver.ArgumentsCreateAnnotation();
            if (object.MediaID != null)
                if ($util.Long)
                    (message.MediaID = $util.Long.fromValue(object.MediaID)).unsigned = false;
                else if (typeof object.MediaID === "string")
                    message.MediaID = parseInt(object.MediaID, 10);
                else if (typeof object.MediaID === "number")
                    message.MediaID = object.MediaID;
                else if (typeof object.MediaID === "object")
                    message.MediaID = new $util.LongBits(object.MediaID.low >>> 0, object.MediaID.high >>> 0).toNumber();
            if (object.Start != null)
                if ($util.Long)
                    (message.Start = $util.Long.fromValue(object.Start)).unsigned = false;
                else if (typeof object.Start === "string")
                    message.Start = parseInt(object.Start, 10);
                else if (typeof object.Start === "number")
                    message.Start = object.Start;
                else if (typeof object.Start === "object")
                    message.Start = new $util.LongBits(object.Start.low >>> 0, object.Start.high >>> 0).toNumber();
            if (object.End != null)
                if ($util.Long)
                    (message.End = $util.Long.fromValue(object.End)).unsigned = false;
                else if (typeof object.End === "string")
                    message.End = parseInt(object.End, 10);
                else if (typeof object.End === "number")
                    message.End = object.End;
                else if (typeof object.End === "object")
                    message.End = new $util.LongBits(object.End.low >>> 0, object.End.high >>> 0).toNumber();
            if (object.Type != null)
                message.Type = String(object.Type);
            if (object.Data != null)
                message.Data = String(object.Data);
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsCreateAnnotation message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsCreateAnnotation
         * @static
         * @param {mediaarchiver.ArgumentsCreateAnnotation} message ArgumentsCreateAnnotation
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsCreateAnnotation.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.MediaID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.MediaID = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.Start = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.Start = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.End = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.End = options.longs === String ? "0" : 0;
                object.Type = "";
                object.Data = "";
            }
            if (message.MediaID != null && message.hasOwnProperty("MediaID"))
                if (typeof message.MediaID === "number")
                    object.MediaID = options.longs === String ? String(message.MediaID) : message.MediaID;
                else
                    object.MediaID = options.longs === String ? $util.Long.prototype.toString.call(message.MediaID) : options.longs === Number ? new $util.LongBits(message.MediaID.low >>> 0, message.MediaID.high >>> 0).toNumber() : message.MediaID;
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (typeof message.Start === "number")
                    object.Start = options.longs === String ? String(message.Start) : message.Start;
                else
                    object.Start = options.longs === String ? $util.Long.prototype.toString.call(message.Start) : options.longs === Number ? new $util.LongBits(message.Start.low >>> 0, message.Start.high >>> 0).toNumber() : message.Start;
            if (message.End != null && message.hasOwnProperty("End"))
                if (typeof message.End === "number")
                    object.End = options.longs === String ? String(message.End) : message.End;
                else
                    object.End = options.longs === String ? $util.Long.prototype.toString.call(message.End) : options.longs === Number ? new $util.LongBits(message.End.low >>> 0, message.End.high >>> 0).toNumber() : message.End;
            if (message.Type != null && message.hasOwnProperty("Type"))
                object.Type = message.Type;
            if (message.Data != null && message.hasOwnProperty("Data"))
                object.Data = message.Data;
            return object;
        };

        /**
         * Converts this ArgumentsCreateAnnotation to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsCreateAnnotation
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsCreateAnnotation.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsCreateAnnotation;
    })();

    mediaarchiver.Annotation = (function() {

        /**
         * Properties of an Annotation.
         * @memberof mediaarchiver
         * @interface IAnnotation
         * @property {string|null} [ID] Annotation ID
         * @property {number|Long|null} [Start] Annotation Start
         * @property {number|null} [DurationMS] Annotation DurationMS
         * @property {number|null} [MediaID] Annotation MediaID
         * @property {string|null} [Data] Annotation Data
         * @property {string|null} [Type] Annotation Type
         * @property {number|null} [Owner] Annotation Owner
         * @property {number|null} [OwnerGroup] Annotation OwnerGroup
         * @property {string|null} [ShareLink] Annotation ShareLink
         */

        /**
         * Constructs a new Annotation.
         * @memberof mediaarchiver
         * @classdesc Represents an Annotation.
         * @implements IAnnotation
         * @constructor
         * @param {mediaarchiver.IAnnotation=} [properties] Properties to set
         */
        function Annotation(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Annotation ID.
         * @member {string} ID
         * @memberof mediaarchiver.Annotation
         * @instance
         */
        Annotation.prototype.ID = "";

        /**
         * Annotation Start.
         * @member {number|Long} Start
         * @memberof mediaarchiver.Annotation
         * @instance
         */
        Annotation.prototype.Start = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Annotation DurationMS.
         * @member {number} DurationMS
         * @memberof mediaarchiver.Annotation
         * @instance
         */
        Annotation.prototype.DurationMS = 0;

        /**
         * Annotation MediaID.
         * @member {number} MediaID
         * @memberof mediaarchiver.Annotation
         * @instance
         */
        Annotation.prototype.MediaID = 0;

        /**
         * Annotation Data.
         * @member {string} Data
         * @memberof mediaarchiver.Annotation
         * @instance
         */
        Annotation.prototype.Data = "";

        /**
         * Annotation Type.
         * @member {string} Type
         * @memberof mediaarchiver.Annotation
         * @instance
         */
        Annotation.prototype.Type = "";

        /**
         * Annotation Owner.
         * @member {number} Owner
         * @memberof mediaarchiver.Annotation
         * @instance
         */
        Annotation.prototype.Owner = 0;

        /**
         * Annotation OwnerGroup.
         * @member {number} OwnerGroup
         * @memberof mediaarchiver.Annotation
         * @instance
         */
        Annotation.prototype.OwnerGroup = 0;

        /**
         * Annotation ShareLink.
         * @member {string} ShareLink
         * @memberof mediaarchiver.Annotation
         * @instance
         */
        Annotation.prototype.ShareLink = "";

        /**
         * Creates a new Annotation instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.Annotation
         * @static
         * @param {mediaarchiver.IAnnotation=} [properties] Properties to set
         * @returns {mediaarchiver.Annotation} Annotation instance
         */
        Annotation.create = function create(properties) {
            return new Annotation(properties);
        };

        /**
         * Encodes the specified Annotation message. Does not implicitly {@link mediaarchiver.Annotation.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.Annotation
         * @static
         * @param {mediaarchiver.IAnnotation} message Annotation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Annotation.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.ID);
            if (message.Start != null && Object.hasOwnProperty.call(message, "Start"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.Start);
            if (message.DurationMS != null && Object.hasOwnProperty.call(message, "DurationMS"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.DurationMS);
            if (message.MediaID != null && Object.hasOwnProperty.call(message, "MediaID"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.MediaID);
            if (message.Data != null && Object.hasOwnProperty.call(message, "Data"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.Data);
            if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.Type);
            if (message.Owner != null && Object.hasOwnProperty.call(message, "Owner"))
                writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.Owner);
            if (message.OwnerGroup != null && Object.hasOwnProperty.call(message, "OwnerGroup"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.OwnerGroup);
            if (message.ShareLink != null && Object.hasOwnProperty.call(message, "ShareLink"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.ShareLink);
            return writer;
        };

        /**
         * Encodes the specified Annotation message, length delimited. Does not implicitly {@link mediaarchiver.Annotation.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.Annotation
         * @static
         * @param {mediaarchiver.IAnnotation} message Annotation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Annotation.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Annotation message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.Annotation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.Annotation} Annotation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Annotation.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.Annotation();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ID = reader.string();
                    break;
                case 2:
                    message.Start = reader.int64();
                    break;
                case 3:
                    message.DurationMS = reader.uint32();
                    break;
                case 4:
                    message.MediaID = reader.uint32();
                    break;
                case 5:
                    message.Data = reader.string();
                    break;
                case 6:
                    message.Type = reader.string();
                    break;
                case 7:
                    message.Owner = reader.uint32();
                    break;
                case 8:
                    message.OwnerGroup = reader.uint32();
                    break;
                case 9:
                    message.ShareLink = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Annotation message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.Annotation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.Annotation} Annotation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Annotation.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Annotation message.
         * @function verify
         * @memberof mediaarchiver.Annotation
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Annotation.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isString(message.ID))
                    return "ID: string expected";
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (!$util.isInteger(message.Start) && !(message.Start && $util.isInteger(message.Start.low) && $util.isInteger(message.Start.high)))
                    return "Start: integer|Long expected";
            if (message.DurationMS != null && message.hasOwnProperty("DurationMS"))
                if (!$util.isInteger(message.DurationMS))
                    return "DurationMS: integer expected";
            if (message.MediaID != null && message.hasOwnProperty("MediaID"))
                if (!$util.isInteger(message.MediaID))
                    return "MediaID: integer expected";
            if (message.Data != null && message.hasOwnProperty("Data"))
                if (!$util.isString(message.Data))
                    return "Data: string expected";
            if (message.Type != null && message.hasOwnProperty("Type"))
                if (!$util.isString(message.Type))
                    return "Type: string expected";
            if (message.Owner != null && message.hasOwnProperty("Owner"))
                if (!$util.isInteger(message.Owner))
                    return "Owner: integer expected";
            if (message.OwnerGroup != null && message.hasOwnProperty("OwnerGroup"))
                if (!$util.isInteger(message.OwnerGroup))
                    return "OwnerGroup: integer expected";
            if (message.ShareLink != null && message.hasOwnProperty("ShareLink"))
                if (!$util.isString(message.ShareLink))
                    return "ShareLink: string expected";
            return null;
        };

        /**
         * Creates an Annotation message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.Annotation
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.Annotation} Annotation
         */
        Annotation.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.Annotation)
                return object;
            let message = new $root.mediaarchiver.Annotation();
            if (object.ID != null)
                message.ID = String(object.ID);
            if (object.Start != null)
                if ($util.Long)
                    (message.Start = $util.Long.fromValue(object.Start)).unsigned = false;
                else if (typeof object.Start === "string")
                    message.Start = parseInt(object.Start, 10);
                else if (typeof object.Start === "number")
                    message.Start = object.Start;
                else if (typeof object.Start === "object")
                    message.Start = new $util.LongBits(object.Start.low >>> 0, object.Start.high >>> 0).toNumber();
            if (object.DurationMS != null)
                message.DurationMS = object.DurationMS >>> 0;
            if (object.MediaID != null)
                message.MediaID = object.MediaID >>> 0;
            if (object.Data != null)
                message.Data = String(object.Data);
            if (object.Type != null)
                message.Type = String(object.Type);
            if (object.Owner != null)
                message.Owner = object.Owner >>> 0;
            if (object.OwnerGroup != null)
                message.OwnerGroup = object.OwnerGroup >>> 0;
            if (object.ShareLink != null)
                message.ShareLink = String(object.ShareLink);
            return message;
        };

        /**
         * Creates a plain object from an Annotation message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.Annotation
         * @static
         * @param {mediaarchiver.Annotation} message Annotation
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Annotation.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.ID = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.Start = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.Start = options.longs === String ? "0" : 0;
                object.DurationMS = 0;
                object.MediaID = 0;
                object.Data = "";
                object.Type = "";
                object.Owner = 0;
                object.OwnerGroup = 0;
                object.ShareLink = "";
            }
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (typeof message.Start === "number")
                    object.Start = options.longs === String ? String(message.Start) : message.Start;
                else
                    object.Start = options.longs === String ? $util.Long.prototype.toString.call(message.Start) : options.longs === Number ? new $util.LongBits(message.Start.low >>> 0, message.Start.high >>> 0).toNumber() : message.Start;
            if (message.DurationMS != null && message.hasOwnProperty("DurationMS"))
                object.DurationMS = message.DurationMS;
            if (message.MediaID != null && message.hasOwnProperty("MediaID"))
                object.MediaID = message.MediaID;
            if (message.Data != null && message.hasOwnProperty("Data"))
                object.Data = message.Data;
            if (message.Type != null && message.hasOwnProperty("Type"))
                object.Type = message.Type;
            if (message.Owner != null && message.hasOwnProperty("Owner"))
                object.Owner = message.Owner;
            if (message.OwnerGroup != null && message.hasOwnProperty("OwnerGroup"))
                object.OwnerGroup = message.OwnerGroup;
            if (message.ShareLink != null && message.hasOwnProperty("ShareLink"))
                object.ShareLink = message.ShareLink;
            return object;
        };

        /**
         * Converts this Annotation to JSON.
         * @function toJSON
         * @memberof mediaarchiver.Annotation
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Annotation.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Annotation;
    })();

    mediaarchiver.ArgumentsAnnotations = (function() {

        /**
         * Properties of an ArgumentsAnnotations.
         * @memberof mediaarchiver
         * @interface IArgumentsAnnotations
         * @property {number|null} [Offset] ArgumentsAnnotations Offset
         * @property {number|null} [Count] ArgumentsAnnotations Count
         * @property {Array.<mediaarchiver.IAnnotation>|null} [Annotations] ArgumentsAnnotations Annotations
         */

        /**
         * Constructs a new ArgumentsAnnotations.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsAnnotations.
         * @implements IArgumentsAnnotations
         * @constructor
         * @param {mediaarchiver.IArgumentsAnnotations=} [properties] Properties to set
         */
        function ArgumentsAnnotations(properties) {
            this.Annotations = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsAnnotations Offset.
         * @member {number} Offset
         * @memberof mediaarchiver.ArgumentsAnnotations
         * @instance
         */
        ArgumentsAnnotations.prototype.Offset = 0;

        /**
         * ArgumentsAnnotations Count.
         * @member {number} Count
         * @memberof mediaarchiver.ArgumentsAnnotations
         * @instance
         */
        ArgumentsAnnotations.prototype.Count = 0;

        /**
         * ArgumentsAnnotations Annotations.
         * @member {Array.<mediaarchiver.IAnnotation>} Annotations
         * @memberof mediaarchiver.ArgumentsAnnotations
         * @instance
         */
        ArgumentsAnnotations.prototype.Annotations = $util.emptyArray;

        /**
         * Creates a new ArgumentsAnnotations instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsAnnotations
         * @static
         * @param {mediaarchiver.IArgumentsAnnotations=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsAnnotations} ArgumentsAnnotations instance
         */
        ArgumentsAnnotations.create = function create(properties) {
            return new ArgumentsAnnotations(properties);
        };

        /**
         * Encodes the specified ArgumentsAnnotations message. Does not implicitly {@link mediaarchiver.ArgumentsAnnotations.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsAnnotations
         * @static
         * @param {mediaarchiver.IArgumentsAnnotations} message ArgumentsAnnotations message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsAnnotations.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Offset != null && Object.hasOwnProperty.call(message, "Offset"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Offset);
            if (message.Count != null && Object.hasOwnProperty.call(message, "Count"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Count);
            if (message.Annotations != null && message.Annotations.length)
                for (let i = 0; i < message.Annotations.length; ++i)
                    $root.mediaarchiver.Annotation.encode(message.Annotations[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ArgumentsAnnotations message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsAnnotations.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsAnnotations
         * @static
         * @param {mediaarchiver.IArgumentsAnnotations} message ArgumentsAnnotations message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsAnnotations.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsAnnotations message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsAnnotations
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsAnnotations} ArgumentsAnnotations
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsAnnotations.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsAnnotations();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Offset = reader.uint32();
                    break;
                case 2:
                    message.Count = reader.uint32();
                    break;
                case 3:
                    if (!(message.Annotations && message.Annotations.length))
                        message.Annotations = [];
                    message.Annotations.push($root.mediaarchiver.Annotation.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsAnnotations message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsAnnotations
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsAnnotations} ArgumentsAnnotations
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsAnnotations.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsAnnotations message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsAnnotations
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsAnnotations.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                if (!$util.isInteger(message.Offset))
                    return "Offset: integer expected";
            if (message.Count != null && message.hasOwnProperty("Count"))
                if (!$util.isInteger(message.Count))
                    return "Count: integer expected";
            if (message.Annotations != null && message.hasOwnProperty("Annotations")) {
                if (!Array.isArray(message.Annotations))
                    return "Annotations: array expected";
                for (let i = 0; i < message.Annotations.length; ++i) {
                    let error = $root.mediaarchiver.Annotation.verify(message.Annotations[i]);
                    if (error)
                        return "Annotations." + error;
                }
            }
            return null;
        };

        /**
         * Creates an ArgumentsAnnotations message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsAnnotations
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsAnnotations} ArgumentsAnnotations
         */
        ArgumentsAnnotations.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsAnnotations)
                return object;
            let message = new $root.mediaarchiver.ArgumentsAnnotations();
            if (object.Offset != null)
                message.Offset = object.Offset >>> 0;
            if (object.Count != null)
                message.Count = object.Count >>> 0;
            if (object.Annotations) {
                if (!Array.isArray(object.Annotations))
                    throw TypeError(".mediaarchiver.ArgumentsAnnotations.Annotations: array expected");
                message.Annotations = [];
                for (let i = 0; i < object.Annotations.length; ++i) {
                    if (typeof object.Annotations[i] !== "object")
                        throw TypeError(".mediaarchiver.ArgumentsAnnotations.Annotations: object expected");
                    message.Annotations[i] = $root.mediaarchiver.Annotation.fromObject(object.Annotations[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsAnnotations message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsAnnotations
         * @static
         * @param {mediaarchiver.ArgumentsAnnotations} message ArgumentsAnnotations
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsAnnotations.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Annotations = [];
            if (options.defaults) {
                object.Offset = 0;
                object.Count = 0;
            }
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                object.Offset = message.Offset;
            if (message.Count != null && message.hasOwnProperty("Count"))
                object.Count = message.Count;
            if (message.Annotations && message.Annotations.length) {
                object.Annotations = [];
                for (let j = 0; j < message.Annotations.length; ++j)
                    object.Annotations[j] = $root.mediaarchiver.Annotation.toObject(message.Annotations[j], options);
            }
            return object;
        };

        /**
         * Converts this ArgumentsAnnotations to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsAnnotations
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsAnnotations.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsAnnotations;
    })();

    mediaarchiver.ArgumentsGetAnnotations = (function() {

        /**
         * Properties of an ArgumentsGetAnnotations.
         * @memberof mediaarchiver
         * @interface IArgumentsGetAnnotations
         * @property {Array.<number>|null} [Medias] ArgumentsGetAnnotations Medias
         * @property {string|null} [Type] ArgumentsGetAnnotations Type
         * @property {number|Long|null} [DateStart] ArgumentsGetAnnotations DateStart
         * @property {number|Long|null} [DateEnd] ArgumentsGetAnnotations DateEnd
         * @property {number|null} [Limit] ArgumentsGetAnnotations Limit
         * @property {number|null} [Offset] ArgumentsGetAnnotations Offset
         * @property {string|null} [Sort] ArgumentsGetAnnotations Sort
         * @property {boolean|null} [SortDesc] ArgumentsGetAnnotations SortDesc
         */

        /**
         * Constructs a new ArgumentsGetAnnotations.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsGetAnnotations.
         * @implements IArgumentsGetAnnotations
         * @constructor
         * @param {mediaarchiver.IArgumentsGetAnnotations=} [properties] Properties to set
         */
        function ArgumentsGetAnnotations(properties) {
            this.Medias = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsGetAnnotations Medias.
         * @member {Array.<number>} Medias
         * @memberof mediaarchiver.ArgumentsGetAnnotations
         * @instance
         */
        ArgumentsGetAnnotations.prototype.Medias = $util.emptyArray;

        /**
         * ArgumentsGetAnnotations Type.
         * @member {string} Type
         * @memberof mediaarchiver.ArgumentsGetAnnotations
         * @instance
         */
        ArgumentsGetAnnotations.prototype.Type = "";

        /**
         * ArgumentsGetAnnotations DateStart.
         * @member {number|Long} DateStart
         * @memberof mediaarchiver.ArgumentsGetAnnotations
         * @instance
         */
        ArgumentsGetAnnotations.prototype.DateStart = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ArgumentsGetAnnotations DateEnd.
         * @member {number|Long} DateEnd
         * @memberof mediaarchiver.ArgumentsGetAnnotations
         * @instance
         */
        ArgumentsGetAnnotations.prototype.DateEnd = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ArgumentsGetAnnotations Limit.
         * @member {number} Limit
         * @memberof mediaarchiver.ArgumentsGetAnnotations
         * @instance
         */
        ArgumentsGetAnnotations.prototype.Limit = 0;

        /**
         * ArgumentsGetAnnotations Offset.
         * @member {number} Offset
         * @memberof mediaarchiver.ArgumentsGetAnnotations
         * @instance
         */
        ArgumentsGetAnnotations.prototype.Offset = 0;

        /**
         * ArgumentsGetAnnotations Sort.
         * @member {string} Sort
         * @memberof mediaarchiver.ArgumentsGetAnnotations
         * @instance
         */
        ArgumentsGetAnnotations.prototype.Sort = "";

        /**
         * ArgumentsGetAnnotations SortDesc.
         * @member {boolean} SortDesc
         * @memberof mediaarchiver.ArgumentsGetAnnotations
         * @instance
         */
        ArgumentsGetAnnotations.prototype.SortDesc = false;

        /**
         * Creates a new ArgumentsGetAnnotations instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsGetAnnotations
         * @static
         * @param {mediaarchiver.IArgumentsGetAnnotations=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsGetAnnotations} ArgumentsGetAnnotations instance
         */
        ArgumentsGetAnnotations.create = function create(properties) {
            return new ArgumentsGetAnnotations(properties);
        };

        /**
         * Encodes the specified ArgumentsGetAnnotations message. Does not implicitly {@link mediaarchiver.ArgumentsGetAnnotations.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsGetAnnotations
         * @static
         * @param {mediaarchiver.IArgumentsGetAnnotations} message ArgumentsGetAnnotations message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetAnnotations.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Medias != null && message.Medias.length) {
                writer.uint32(/* id 1, wireType 2 =*/10).fork();
                for (let i = 0; i < message.Medias.length; ++i)
                    writer.uint32(message.Medias[i]);
                writer.ldelim();
            }
            if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Type);
            if (message.DateStart != null && Object.hasOwnProperty.call(message, "DateStart"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.DateStart);
            if (message.DateEnd != null && Object.hasOwnProperty.call(message, "DateEnd"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.DateEnd);
            if (message.Limit != null && Object.hasOwnProperty.call(message, "Limit"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.Limit);
            if (message.Offset != null && Object.hasOwnProperty.call(message, "Offset"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.Offset);
            if (message.Sort != null && Object.hasOwnProperty.call(message, "Sort"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.Sort);
            if (message.SortDesc != null && Object.hasOwnProperty.call(message, "SortDesc"))
                writer.uint32(/* id 8, wireType 0 =*/64).bool(message.SortDesc);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsGetAnnotations message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsGetAnnotations.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsGetAnnotations
         * @static
         * @param {mediaarchiver.IArgumentsGetAnnotations} message ArgumentsGetAnnotations message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetAnnotations.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsGetAnnotations message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsGetAnnotations
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsGetAnnotations} ArgumentsGetAnnotations
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetAnnotations.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsGetAnnotations();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.Medias && message.Medias.length))
                        message.Medias = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.Medias.push(reader.uint32());
                    } else
                        message.Medias.push(reader.uint32());
                    break;
                case 2:
                    message.Type = reader.string();
                    break;
                case 3:
                    message.DateStart = reader.int64();
                    break;
                case 4:
                    message.DateEnd = reader.int64();
                    break;
                case 5:
                    message.Limit = reader.uint32();
                    break;
                case 6:
                    message.Offset = reader.uint32();
                    break;
                case 7:
                    message.Sort = reader.string();
                    break;
                case 8:
                    message.SortDesc = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsGetAnnotations message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsGetAnnotations
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsGetAnnotations} ArgumentsGetAnnotations
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetAnnotations.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsGetAnnotations message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsGetAnnotations
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsGetAnnotations.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Medias != null && message.hasOwnProperty("Medias")) {
                if (!Array.isArray(message.Medias))
                    return "Medias: array expected";
                for (let i = 0; i < message.Medias.length; ++i)
                    if (!$util.isInteger(message.Medias[i]))
                        return "Medias: integer[] expected";
            }
            if (message.Type != null && message.hasOwnProperty("Type"))
                if (!$util.isString(message.Type))
                    return "Type: string expected";
            if (message.DateStart != null && message.hasOwnProperty("DateStart"))
                if (!$util.isInteger(message.DateStart) && !(message.DateStart && $util.isInteger(message.DateStart.low) && $util.isInteger(message.DateStart.high)))
                    return "DateStart: integer|Long expected";
            if (message.DateEnd != null && message.hasOwnProperty("DateEnd"))
                if (!$util.isInteger(message.DateEnd) && !(message.DateEnd && $util.isInteger(message.DateEnd.low) && $util.isInteger(message.DateEnd.high)))
                    return "DateEnd: integer|Long expected";
            if (message.Limit != null && message.hasOwnProperty("Limit"))
                if (!$util.isInteger(message.Limit))
                    return "Limit: integer expected";
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                if (!$util.isInteger(message.Offset))
                    return "Offset: integer expected";
            if (message.Sort != null && message.hasOwnProperty("Sort"))
                if (!$util.isString(message.Sort))
                    return "Sort: string expected";
            if (message.SortDesc != null && message.hasOwnProperty("SortDesc"))
                if (typeof message.SortDesc !== "boolean")
                    return "SortDesc: boolean expected";
            return null;
        };

        /**
         * Creates an ArgumentsGetAnnotations message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsGetAnnotations
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsGetAnnotations} ArgumentsGetAnnotations
         */
        ArgumentsGetAnnotations.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsGetAnnotations)
                return object;
            let message = new $root.mediaarchiver.ArgumentsGetAnnotations();
            if (object.Medias) {
                if (!Array.isArray(object.Medias))
                    throw TypeError(".mediaarchiver.ArgumentsGetAnnotations.Medias: array expected");
                message.Medias = [];
                for (let i = 0; i < object.Medias.length; ++i)
                    message.Medias[i] = object.Medias[i] >>> 0;
            }
            if (object.Type != null)
                message.Type = String(object.Type);
            if (object.DateStart != null)
                if ($util.Long)
                    (message.DateStart = $util.Long.fromValue(object.DateStart)).unsigned = false;
                else if (typeof object.DateStart === "string")
                    message.DateStart = parseInt(object.DateStart, 10);
                else if (typeof object.DateStart === "number")
                    message.DateStart = object.DateStart;
                else if (typeof object.DateStart === "object")
                    message.DateStart = new $util.LongBits(object.DateStart.low >>> 0, object.DateStart.high >>> 0).toNumber();
            if (object.DateEnd != null)
                if ($util.Long)
                    (message.DateEnd = $util.Long.fromValue(object.DateEnd)).unsigned = false;
                else if (typeof object.DateEnd === "string")
                    message.DateEnd = parseInt(object.DateEnd, 10);
                else if (typeof object.DateEnd === "number")
                    message.DateEnd = object.DateEnd;
                else if (typeof object.DateEnd === "object")
                    message.DateEnd = new $util.LongBits(object.DateEnd.low >>> 0, object.DateEnd.high >>> 0).toNumber();
            if (object.Limit != null)
                message.Limit = object.Limit >>> 0;
            if (object.Offset != null)
                message.Offset = object.Offset >>> 0;
            if (object.Sort != null)
                message.Sort = String(object.Sort);
            if (object.SortDesc != null)
                message.SortDesc = Boolean(object.SortDesc);
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsGetAnnotations message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsGetAnnotations
         * @static
         * @param {mediaarchiver.ArgumentsGetAnnotations} message ArgumentsGetAnnotations
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsGetAnnotations.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Medias = [];
            if (options.defaults) {
                object.Type = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.DateStart = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.DateStart = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.DateEnd = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.DateEnd = options.longs === String ? "0" : 0;
                object.Limit = 0;
                object.Offset = 0;
                object.Sort = "";
                object.SortDesc = false;
            }
            if (message.Medias && message.Medias.length) {
                object.Medias = [];
                for (let j = 0; j < message.Medias.length; ++j)
                    object.Medias[j] = message.Medias[j];
            }
            if (message.Type != null && message.hasOwnProperty("Type"))
                object.Type = message.Type;
            if (message.DateStart != null && message.hasOwnProperty("DateStart"))
                if (typeof message.DateStart === "number")
                    object.DateStart = options.longs === String ? String(message.DateStart) : message.DateStart;
                else
                    object.DateStart = options.longs === String ? $util.Long.prototype.toString.call(message.DateStart) : options.longs === Number ? new $util.LongBits(message.DateStart.low >>> 0, message.DateStart.high >>> 0).toNumber() : message.DateStart;
            if (message.DateEnd != null && message.hasOwnProperty("DateEnd"))
                if (typeof message.DateEnd === "number")
                    object.DateEnd = options.longs === String ? String(message.DateEnd) : message.DateEnd;
                else
                    object.DateEnd = options.longs === String ? $util.Long.prototype.toString.call(message.DateEnd) : options.longs === Number ? new $util.LongBits(message.DateEnd.low >>> 0, message.DateEnd.high >>> 0).toNumber() : message.DateEnd;
            if (message.Limit != null && message.hasOwnProperty("Limit"))
                object.Limit = message.Limit;
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                object.Offset = message.Offset;
            if (message.Sort != null && message.hasOwnProperty("Sort"))
                object.Sort = message.Sort;
            if (message.SortDesc != null && message.hasOwnProperty("SortDesc"))
                object.SortDesc = message.SortDesc;
            return object;
        };

        /**
         * Converts this ArgumentsGetAnnotations to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsGetAnnotations
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsGetAnnotations.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsGetAnnotations;
    })();

    mediaarchiver.ArgumentsExportAnnotations = (function() {

        /**
         * Properties of an ArgumentsExportAnnotations.
         * @memberof mediaarchiver
         * @interface IArgumentsExportAnnotations
         * @property {Array.<number>|null} [Medias] ArgumentsExportAnnotations Medias
         * @property {string|null} [Type] ArgumentsExportAnnotations Type
         * @property {number|Long|null} [DateStart] ArgumentsExportAnnotations DateStart
         * @property {number|Long|null} [DateEnd] ArgumentsExportAnnotations DateEnd
         */

        /**
         * Constructs a new ArgumentsExportAnnotations.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsExportAnnotations.
         * @implements IArgumentsExportAnnotations
         * @constructor
         * @param {mediaarchiver.IArgumentsExportAnnotations=} [properties] Properties to set
         */
        function ArgumentsExportAnnotations(properties) {
            this.Medias = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsExportAnnotations Medias.
         * @member {Array.<number>} Medias
         * @memberof mediaarchiver.ArgumentsExportAnnotations
         * @instance
         */
        ArgumentsExportAnnotations.prototype.Medias = $util.emptyArray;

        /**
         * ArgumentsExportAnnotations Type.
         * @member {string} Type
         * @memberof mediaarchiver.ArgumentsExportAnnotations
         * @instance
         */
        ArgumentsExportAnnotations.prototype.Type = "";

        /**
         * ArgumentsExportAnnotations DateStart.
         * @member {number|Long} DateStart
         * @memberof mediaarchiver.ArgumentsExportAnnotations
         * @instance
         */
        ArgumentsExportAnnotations.prototype.DateStart = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ArgumentsExportAnnotations DateEnd.
         * @member {number|Long} DateEnd
         * @memberof mediaarchiver.ArgumentsExportAnnotations
         * @instance
         */
        ArgumentsExportAnnotations.prototype.DateEnd = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new ArgumentsExportAnnotations instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsExportAnnotations
         * @static
         * @param {mediaarchiver.IArgumentsExportAnnotations=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsExportAnnotations} ArgumentsExportAnnotations instance
         */
        ArgumentsExportAnnotations.create = function create(properties) {
            return new ArgumentsExportAnnotations(properties);
        };

        /**
         * Encodes the specified ArgumentsExportAnnotations message. Does not implicitly {@link mediaarchiver.ArgumentsExportAnnotations.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsExportAnnotations
         * @static
         * @param {mediaarchiver.IArgumentsExportAnnotations} message ArgumentsExportAnnotations message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsExportAnnotations.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Medias != null && message.Medias.length) {
                writer.uint32(/* id 1, wireType 2 =*/10).fork();
                for (let i = 0; i < message.Medias.length; ++i)
                    writer.uint32(message.Medias[i]);
                writer.ldelim();
            }
            if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Type);
            if (message.DateStart != null && Object.hasOwnProperty.call(message, "DateStart"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.DateStart);
            if (message.DateEnd != null && Object.hasOwnProperty.call(message, "DateEnd"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.DateEnd);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsExportAnnotations message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsExportAnnotations.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsExportAnnotations
         * @static
         * @param {mediaarchiver.IArgumentsExportAnnotations} message ArgumentsExportAnnotations message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsExportAnnotations.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsExportAnnotations message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsExportAnnotations
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsExportAnnotations} ArgumentsExportAnnotations
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsExportAnnotations.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsExportAnnotations();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.Medias && message.Medias.length))
                        message.Medias = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.Medias.push(reader.uint32());
                    } else
                        message.Medias.push(reader.uint32());
                    break;
                case 2:
                    message.Type = reader.string();
                    break;
                case 3:
                    message.DateStart = reader.int64();
                    break;
                case 4:
                    message.DateEnd = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsExportAnnotations message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsExportAnnotations
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsExportAnnotations} ArgumentsExportAnnotations
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsExportAnnotations.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsExportAnnotations message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsExportAnnotations
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsExportAnnotations.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Medias != null && message.hasOwnProperty("Medias")) {
                if (!Array.isArray(message.Medias))
                    return "Medias: array expected";
                for (let i = 0; i < message.Medias.length; ++i)
                    if (!$util.isInteger(message.Medias[i]))
                        return "Medias: integer[] expected";
            }
            if (message.Type != null && message.hasOwnProperty("Type"))
                if (!$util.isString(message.Type))
                    return "Type: string expected";
            if (message.DateStart != null && message.hasOwnProperty("DateStart"))
                if (!$util.isInteger(message.DateStart) && !(message.DateStart && $util.isInteger(message.DateStart.low) && $util.isInteger(message.DateStart.high)))
                    return "DateStart: integer|Long expected";
            if (message.DateEnd != null && message.hasOwnProperty("DateEnd"))
                if (!$util.isInteger(message.DateEnd) && !(message.DateEnd && $util.isInteger(message.DateEnd.low) && $util.isInteger(message.DateEnd.high)))
                    return "DateEnd: integer|Long expected";
            return null;
        };

        /**
         * Creates an ArgumentsExportAnnotations message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsExportAnnotations
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsExportAnnotations} ArgumentsExportAnnotations
         */
        ArgumentsExportAnnotations.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsExportAnnotations)
                return object;
            let message = new $root.mediaarchiver.ArgumentsExportAnnotations();
            if (object.Medias) {
                if (!Array.isArray(object.Medias))
                    throw TypeError(".mediaarchiver.ArgumentsExportAnnotations.Medias: array expected");
                message.Medias = [];
                for (let i = 0; i < object.Medias.length; ++i)
                    message.Medias[i] = object.Medias[i] >>> 0;
            }
            if (object.Type != null)
                message.Type = String(object.Type);
            if (object.DateStart != null)
                if ($util.Long)
                    (message.DateStart = $util.Long.fromValue(object.DateStart)).unsigned = false;
                else if (typeof object.DateStart === "string")
                    message.DateStart = parseInt(object.DateStart, 10);
                else if (typeof object.DateStart === "number")
                    message.DateStart = object.DateStart;
                else if (typeof object.DateStart === "object")
                    message.DateStart = new $util.LongBits(object.DateStart.low >>> 0, object.DateStart.high >>> 0).toNumber();
            if (object.DateEnd != null)
                if ($util.Long)
                    (message.DateEnd = $util.Long.fromValue(object.DateEnd)).unsigned = false;
                else if (typeof object.DateEnd === "string")
                    message.DateEnd = parseInt(object.DateEnd, 10);
                else if (typeof object.DateEnd === "number")
                    message.DateEnd = object.DateEnd;
                else if (typeof object.DateEnd === "object")
                    message.DateEnd = new $util.LongBits(object.DateEnd.low >>> 0, object.DateEnd.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsExportAnnotations message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsExportAnnotations
         * @static
         * @param {mediaarchiver.ArgumentsExportAnnotations} message ArgumentsExportAnnotations
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsExportAnnotations.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Medias = [];
            if (options.defaults) {
                object.Type = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.DateStart = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.DateStart = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.DateEnd = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.DateEnd = options.longs === String ? "0" : 0;
            }
            if (message.Medias && message.Medias.length) {
                object.Medias = [];
                for (let j = 0; j < message.Medias.length; ++j)
                    object.Medias[j] = message.Medias[j];
            }
            if (message.Type != null && message.hasOwnProperty("Type"))
                object.Type = message.Type;
            if (message.DateStart != null && message.hasOwnProperty("DateStart"))
                if (typeof message.DateStart === "number")
                    object.DateStart = options.longs === String ? String(message.DateStart) : message.DateStart;
                else
                    object.DateStart = options.longs === String ? $util.Long.prototype.toString.call(message.DateStart) : options.longs === Number ? new $util.LongBits(message.DateStart.low >>> 0, message.DateStart.high >>> 0).toNumber() : message.DateStart;
            if (message.DateEnd != null && message.hasOwnProperty("DateEnd"))
                if (typeof message.DateEnd === "number")
                    object.DateEnd = options.longs === String ? String(message.DateEnd) : message.DateEnd;
                else
                    object.DateEnd = options.longs === String ? $util.Long.prototype.toString.call(message.DateEnd) : options.longs === Number ? new $util.LongBits(message.DateEnd.low >>> 0, message.DateEnd.high >>> 0).toNumber() : message.DateEnd;
            return object;
        };

        /**
         * Converts this ArgumentsExportAnnotations to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsExportAnnotations
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsExportAnnotations.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsExportAnnotations;
    })();

    mediaarchiver.ArgumentsDeleteAnnotation = (function() {

        /**
         * Properties of an ArgumentsDeleteAnnotation.
         * @memberof mediaarchiver
         * @interface IArgumentsDeleteAnnotation
         * @property {string|null} [ID] ArgumentsDeleteAnnotation ID
         */

        /**
         * Constructs a new ArgumentsDeleteAnnotation.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsDeleteAnnotation.
         * @implements IArgumentsDeleteAnnotation
         * @constructor
         * @param {mediaarchiver.IArgumentsDeleteAnnotation=} [properties] Properties to set
         */
        function ArgumentsDeleteAnnotation(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsDeleteAnnotation ID.
         * @member {string} ID
         * @memberof mediaarchiver.ArgumentsDeleteAnnotation
         * @instance
         */
        ArgumentsDeleteAnnotation.prototype.ID = "";

        /**
         * Creates a new ArgumentsDeleteAnnotation instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsDeleteAnnotation
         * @static
         * @param {mediaarchiver.IArgumentsDeleteAnnotation=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsDeleteAnnotation} ArgumentsDeleteAnnotation instance
         */
        ArgumentsDeleteAnnotation.create = function create(properties) {
            return new ArgumentsDeleteAnnotation(properties);
        };

        /**
         * Encodes the specified ArgumentsDeleteAnnotation message. Does not implicitly {@link mediaarchiver.ArgumentsDeleteAnnotation.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsDeleteAnnotation
         * @static
         * @param {mediaarchiver.IArgumentsDeleteAnnotation} message ArgumentsDeleteAnnotation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsDeleteAnnotation.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.ID);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsDeleteAnnotation message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsDeleteAnnotation.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsDeleteAnnotation
         * @static
         * @param {mediaarchiver.IArgumentsDeleteAnnotation} message ArgumentsDeleteAnnotation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsDeleteAnnotation.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsDeleteAnnotation message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsDeleteAnnotation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsDeleteAnnotation} ArgumentsDeleteAnnotation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsDeleteAnnotation.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsDeleteAnnotation();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ID = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsDeleteAnnotation message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsDeleteAnnotation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsDeleteAnnotation} ArgumentsDeleteAnnotation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsDeleteAnnotation.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsDeleteAnnotation message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsDeleteAnnotation
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsDeleteAnnotation.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isString(message.ID))
                    return "ID: string expected";
            return null;
        };

        /**
         * Creates an ArgumentsDeleteAnnotation message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsDeleteAnnotation
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsDeleteAnnotation} ArgumentsDeleteAnnotation
         */
        ArgumentsDeleteAnnotation.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsDeleteAnnotation)
                return object;
            let message = new $root.mediaarchiver.ArgumentsDeleteAnnotation();
            if (object.ID != null)
                message.ID = String(object.ID);
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsDeleteAnnotation message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsDeleteAnnotation
         * @static
         * @param {mediaarchiver.ArgumentsDeleteAnnotation} message ArgumentsDeleteAnnotation
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsDeleteAnnotation.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.ID = "";
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            return object;
        };

        /**
         * Converts this ArgumentsDeleteAnnotation to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsDeleteAnnotation
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsDeleteAnnotation.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsDeleteAnnotation;
    })();

    mediaarchiver.MediaList = (function() {

        /**
         * Properties of a MediaList.
         * @memberof mediaarchiver
         * @interface IMediaList
         * @property {Array.<number>|null} [Medias] MediaList Medias
         */

        /**
         * Constructs a new MediaList.
         * @memberof mediaarchiver
         * @classdesc Represents a MediaList.
         * @implements IMediaList
         * @constructor
         * @param {mediaarchiver.IMediaList=} [properties] Properties to set
         */
        function MediaList(properties) {
            this.Medias = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MediaList Medias.
         * @member {Array.<number>} Medias
         * @memberof mediaarchiver.MediaList
         * @instance
         */
        MediaList.prototype.Medias = $util.emptyArray;

        /**
         * Creates a new MediaList instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.MediaList
         * @static
         * @param {mediaarchiver.IMediaList=} [properties] Properties to set
         * @returns {mediaarchiver.MediaList} MediaList instance
         */
        MediaList.create = function create(properties) {
            return new MediaList(properties);
        };

        /**
         * Encodes the specified MediaList message. Does not implicitly {@link mediaarchiver.MediaList.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.MediaList
         * @static
         * @param {mediaarchiver.IMediaList} message MediaList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Medias != null && message.Medias.length) {
                writer.uint32(/* id 1, wireType 2 =*/10).fork();
                for (let i = 0; i < message.Medias.length; ++i)
                    writer.uint32(message.Medias[i]);
                writer.ldelim();
            }
            return writer;
        };

        /**
         * Encodes the specified MediaList message, length delimited. Does not implicitly {@link mediaarchiver.MediaList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.MediaList
         * @static
         * @param {mediaarchiver.IMediaList} message MediaList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MediaList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MediaList message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.MediaList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.MediaList} MediaList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.MediaList();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.Medias && message.Medias.length))
                        message.Medias = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.Medias.push(reader.uint32());
                    } else
                        message.Medias.push(reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MediaList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.MediaList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.MediaList} MediaList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MediaList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MediaList message.
         * @function verify
         * @memberof mediaarchiver.MediaList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MediaList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Medias != null && message.hasOwnProperty("Medias")) {
                if (!Array.isArray(message.Medias))
                    return "Medias: array expected";
                for (let i = 0; i < message.Medias.length; ++i)
                    if (!$util.isInteger(message.Medias[i]))
                        return "Medias: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a MediaList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.MediaList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.MediaList} MediaList
         */
        MediaList.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.MediaList)
                return object;
            let message = new $root.mediaarchiver.MediaList();
            if (object.Medias) {
                if (!Array.isArray(object.Medias))
                    throw TypeError(".mediaarchiver.MediaList.Medias: array expected");
                message.Medias = [];
                for (let i = 0; i < object.Medias.length; ++i)
                    message.Medias[i] = object.Medias[i] >>> 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a MediaList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.MediaList
         * @static
         * @param {mediaarchiver.MediaList} message MediaList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MediaList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Medias = [];
            if (message.Medias && message.Medias.length) {
                object.Medias = [];
                for (let j = 0; j < message.Medias.length; ++j)
                    object.Medias[j] = message.Medias[j];
            }
            return object;
        };

        /**
         * Converts this MediaList to JSON.
         * @function toJSON
         * @memberof mediaarchiver.MediaList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MediaList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MediaList;
    })();

    mediaarchiver.Panel = (function() {

        /**
         * Properties of a Panel.
         * @memberof mediaarchiver
         * @interface IPanel
         * @property {number|null} [ID] Panel ID
         * @property {string|null} [Name] Panel Name
         * @property {Array.<number>|null} [Medias] Panel Medias
         */

        /**
         * Constructs a new Panel.
         * @memberof mediaarchiver
         * @classdesc Represents a Panel.
         * @implements IPanel
         * @constructor
         * @param {mediaarchiver.IPanel=} [properties] Properties to set
         */
        function Panel(properties) {
            this.Medias = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Panel ID.
         * @member {number} ID
         * @memberof mediaarchiver.Panel
         * @instance
         */
        Panel.prototype.ID = 0;

        /**
         * Panel Name.
         * @member {string} Name
         * @memberof mediaarchiver.Panel
         * @instance
         */
        Panel.prototype.Name = "";

        /**
         * Panel Medias.
         * @member {Array.<number>} Medias
         * @memberof mediaarchiver.Panel
         * @instance
         */
        Panel.prototype.Medias = $util.emptyArray;

        /**
         * Creates a new Panel instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.Panel
         * @static
         * @param {mediaarchiver.IPanel=} [properties] Properties to set
         * @returns {mediaarchiver.Panel} Panel instance
         */
        Panel.create = function create(properties) {
            return new Panel(properties);
        };

        /**
         * Encodes the specified Panel message. Does not implicitly {@link mediaarchiver.Panel.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.Panel
         * @static
         * @param {mediaarchiver.IPanel} message Panel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Panel.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ID);
            if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
            if (message.Medias != null && message.Medias.length) {
                writer.uint32(/* id 3, wireType 2 =*/26).fork();
                for (let i = 0; i < message.Medias.length; ++i)
                    writer.uint32(message.Medias[i]);
                writer.ldelim();
            }
            return writer;
        };

        /**
         * Encodes the specified Panel message, length delimited. Does not implicitly {@link mediaarchiver.Panel.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.Panel
         * @static
         * @param {mediaarchiver.IPanel} message Panel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Panel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Panel message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.Panel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.Panel} Panel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Panel.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.Panel();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ID = reader.uint32();
                    break;
                case 2:
                    message.Name = reader.string();
                    break;
                case 3:
                    if (!(message.Medias && message.Medias.length))
                        message.Medias = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.Medias.push(reader.uint32());
                    } else
                        message.Medias.push(reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Panel message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.Panel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.Panel} Panel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Panel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Panel message.
         * @function verify
         * @memberof mediaarchiver.Panel
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Panel.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isInteger(message.ID))
                    return "ID: integer expected";
            if (message.Name != null && message.hasOwnProperty("Name"))
                if (!$util.isString(message.Name))
                    return "Name: string expected";
            if (message.Medias != null && message.hasOwnProperty("Medias")) {
                if (!Array.isArray(message.Medias))
                    return "Medias: array expected";
                for (let i = 0; i < message.Medias.length; ++i)
                    if (!$util.isInteger(message.Medias[i]))
                        return "Medias: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a Panel message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.Panel
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.Panel} Panel
         */
        Panel.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.Panel)
                return object;
            let message = new $root.mediaarchiver.Panel();
            if (object.ID != null)
                message.ID = object.ID >>> 0;
            if (object.Name != null)
                message.Name = String(object.Name);
            if (object.Medias) {
                if (!Array.isArray(object.Medias))
                    throw TypeError(".mediaarchiver.Panel.Medias: array expected");
                message.Medias = [];
                for (let i = 0; i < object.Medias.length; ++i)
                    message.Medias[i] = object.Medias[i] >>> 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a Panel message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.Panel
         * @static
         * @param {mediaarchiver.Panel} message Panel
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Panel.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Medias = [];
            if (options.defaults) {
                object.ID = 0;
                object.Name = "";
            }
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            if (message.Name != null && message.hasOwnProperty("Name"))
                object.Name = message.Name;
            if (message.Medias && message.Medias.length) {
                object.Medias = [];
                for (let j = 0; j < message.Medias.length; ++j)
                    object.Medias[j] = message.Medias[j];
            }
            return object;
        };

        /**
         * Converts this Panel to JSON.
         * @function toJSON
         * @memberof mediaarchiver.Panel
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Panel.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Panel;
    })();

    mediaarchiver.Panels = (function() {

        /**
         * Properties of a Panels.
         * @memberof mediaarchiver
         * @interface IPanels
         * @property {Array.<mediaarchiver.IPanel>|null} [Radio] Panels Radio
         * @property {Array.<mediaarchiver.IPanel>|null} [TV] Panels TV
         */

        /**
         * Constructs a new Panels.
         * @memberof mediaarchiver
         * @classdesc Represents a Panels.
         * @implements IPanels
         * @constructor
         * @param {mediaarchiver.IPanels=} [properties] Properties to set
         */
        function Panels(properties) {
            this.Radio = [];
            this.TV = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Panels Radio.
         * @member {Array.<mediaarchiver.IPanel>} Radio
         * @memberof mediaarchiver.Panels
         * @instance
         */
        Panels.prototype.Radio = $util.emptyArray;

        /**
         * Panels TV.
         * @member {Array.<mediaarchiver.IPanel>} TV
         * @memberof mediaarchiver.Panels
         * @instance
         */
        Panels.prototype.TV = $util.emptyArray;

        /**
         * Creates a new Panels instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.Panels
         * @static
         * @param {mediaarchiver.IPanels=} [properties] Properties to set
         * @returns {mediaarchiver.Panels} Panels instance
         */
        Panels.create = function create(properties) {
            return new Panels(properties);
        };

        /**
         * Encodes the specified Panels message. Does not implicitly {@link mediaarchiver.Panels.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.Panels
         * @static
         * @param {mediaarchiver.IPanels} message Panels message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Panels.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Radio != null && message.Radio.length)
                for (let i = 0; i < message.Radio.length; ++i)
                    $root.mediaarchiver.Panel.encode(message.Radio[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.TV != null && message.TV.length)
                for (let i = 0; i < message.TV.length; ++i)
                    $root.mediaarchiver.Panel.encode(message.TV[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Panels message, length delimited. Does not implicitly {@link mediaarchiver.Panels.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.Panels
         * @static
         * @param {mediaarchiver.IPanels} message Panels message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Panels.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Panels message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.Panels
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.Panels} Panels
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Panels.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.Panels();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.Radio && message.Radio.length))
                        message.Radio = [];
                    message.Radio.push($root.mediaarchiver.Panel.decode(reader, reader.uint32()));
                    break;
                case 2:
                    if (!(message.TV && message.TV.length))
                        message.TV = [];
                    message.TV.push($root.mediaarchiver.Panel.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Panels message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.Panels
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.Panels} Panels
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Panels.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Panels message.
         * @function verify
         * @memberof mediaarchiver.Panels
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Panels.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Radio != null && message.hasOwnProperty("Radio")) {
                if (!Array.isArray(message.Radio))
                    return "Radio: array expected";
                for (let i = 0; i < message.Radio.length; ++i) {
                    let error = $root.mediaarchiver.Panel.verify(message.Radio[i]);
                    if (error)
                        return "Radio." + error;
                }
            }
            if (message.TV != null && message.hasOwnProperty("TV")) {
                if (!Array.isArray(message.TV))
                    return "TV: array expected";
                for (let i = 0; i < message.TV.length; ++i) {
                    let error = $root.mediaarchiver.Panel.verify(message.TV[i]);
                    if (error)
                        return "TV." + error;
                }
            }
            return null;
        };

        /**
         * Creates a Panels message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.Panels
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.Panels} Panels
         */
        Panels.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.Panels)
                return object;
            let message = new $root.mediaarchiver.Panels();
            if (object.Radio) {
                if (!Array.isArray(object.Radio))
                    throw TypeError(".mediaarchiver.Panels.Radio: array expected");
                message.Radio = [];
                for (let i = 0; i < object.Radio.length; ++i) {
                    if (typeof object.Radio[i] !== "object")
                        throw TypeError(".mediaarchiver.Panels.Radio: object expected");
                    message.Radio[i] = $root.mediaarchiver.Panel.fromObject(object.Radio[i]);
                }
            }
            if (object.TV) {
                if (!Array.isArray(object.TV))
                    throw TypeError(".mediaarchiver.Panels.TV: array expected");
                message.TV = [];
                for (let i = 0; i < object.TV.length; ++i) {
                    if (typeof object.TV[i] !== "object")
                        throw TypeError(".mediaarchiver.Panels.TV: object expected");
                    message.TV[i] = $root.mediaarchiver.Panel.fromObject(object.TV[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a Panels message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.Panels
         * @static
         * @param {mediaarchiver.Panels} message Panels
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Panels.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.Radio = [];
                object.TV = [];
            }
            if (message.Radio && message.Radio.length) {
                object.Radio = [];
                for (let j = 0; j < message.Radio.length; ++j)
                    object.Radio[j] = $root.mediaarchiver.Panel.toObject(message.Radio[j], options);
            }
            if (message.TV && message.TV.length) {
                object.TV = [];
                for (let j = 0; j < message.TV.length; ++j)
                    object.TV[j] = $root.mediaarchiver.Panel.toObject(message.TV[j], options);
            }
            return object;
        };

        /**
         * Converts this Panels to JSON.
         * @function toJSON
         * @memberof mediaarchiver.Panels
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Panels.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Panels;
    })();

    /**
     * WSMessageType enum.
     * @name mediaarchiver.WSMessageType
     * @enum {number}
     * @property {number} MessageTypeUnknown=0 MessageTypeUnknown value
     * @property {number} MessageTypeAck=1 MessageTypeAck value
     * @property {number} MessageTypeLogin=256 MessageTypeLogin value
     * @property {number} MessageTypeLogout=257 MessageTypeLogout value
     * @property {number} MessageTypeRecover=258 MessageTypeRecover value
     * @property {number} MessageTypeGetEPG=259 MessageTypeGetEPG value
     * @property {number} MessageTypeGetChunk=260 MessageTypeGetChunk value
     * @property {number} MessageTypeGetMedias=261 MessageTypeGetMedias value
     * @property {number} MessageTypeGetContacts=262 MessageTypeGetContacts value
     * @property {number} MessageTypeGetContactsCount=263 MessageTypeGetContactsCount value
     * @property {number} MessageTypeCreateContact=264 MessageTypeCreateContact value
     * @property {number} MessageTypeEditContact=265 MessageTypeEditContact value
     * @property {number} MessageTypeDeleteContact=266 MessageTypeDeleteContact value
     * @property {number} MessageTypeGetAnnotationTypes=267 MessageTypeGetAnnotationTypes value
     * @property {number} MessageTypeGetAnnotationTypesCount=268 MessageTypeGetAnnotationTypesCount value
     * @property {number} MessageTypeCreateAnnotationType=269 MessageTypeCreateAnnotationType value
     * @property {number} MessageTypeEditAnnotationType=270 MessageTypeEditAnnotationType value
     * @property {number} MessageTypeDeleteAnnotationType=271 MessageTypeDeleteAnnotationType value
     * @property {number} MessageTypeCreateAnnotation=272 MessageTypeCreateAnnotation value
     * @property {number} MessageTypeGetStream=273 MessageTypeGetStream value
     * @property {number} MessageTypeSearchPrograms=274 MessageTypeSearchPrograms value
     * @property {number} MessageTypeGetFTPAccounts=275 MessageTypeGetFTPAccounts value
     * @property {number} MessageTypeGetFTPAccountsCount=276 MessageTypeGetFTPAccountsCount value
     * @property {number} MessageTypeCreateFTPAccount=277 MessageTypeCreateFTPAccount value
     * @property {number} MessageTypeEditFTPAccount=278 MessageTypeEditFTPAccount value
     * @property {number} MessageTypeDeleteFTPAccount=279 MessageTypeDeleteFTPAccount value
     * @property {number} MessageTypeGetSFTPAccounts=280 MessageTypeGetSFTPAccounts value
     * @property {number} MessageTypeGetSFTPAccountsCount=281 MessageTypeGetSFTPAccountsCount value
     * @property {number} MessageTypeCreateSFTPAccount=282 MessageTypeCreateSFTPAccount value
     * @property {number} MessageTypeEditSFTPAccount=283 MessageTypeEditSFTPAccount value
     * @property {number} MessageTypeDeleteSFTPAccount=284 MessageTypeDeleteSFTPAccount value
     * @property {number} MessageTypeSetAccountOptions=285 MessageTypeSetAccountOptions value
     * @property {number} MessageTypeGetAnnotations=286 MessageTypeGetAnnotations value
     * @property {number} MessageTypeDeleteAnnotation=287 MessageTypeDeleteAnnotation value
     * @property {number} MessageTypeCreateArchive=288 MessageTypeCreateArchive value
     * @property {number} MessageTypeGetArchives=289 MessageTypeGetArchives value
     * @property {number} MessageTypeGetArchivesCount=290 MessageTypeGetArchivesCount value
     * @property {number} MessageTypeEditArchive=291 MessageTypeEditArchive value
     * @property {number} MessageTypeDeleteArchive=292 MessageTypeDeleteArchive value
     * @property {number} MessageTypeGetArchiveTags=293 MessageTypeGetArchiveTags value
     * @property {number} MessageTypeGetArchive=294 MessageTypeGetArchive value
     * @property {number} MessageTypeGetReviews=295 MessageTypeGetReviews value
     * @property {number} MessageTypeGetReview=296 MessageTypeGetReview value
     * @property {number} MessageTypeCreateReview=297 MessageTypeCreateReview value
     * @property {number} MessageTypeEditReview=298 MessageTypeEditReview value
     * @property {number} MessageTypeDeleteReview=299 MessageTypeDeleteReview value
     * @property {number} MessageTypeIncArchiveCounter=300 MessageTypeIncArchiveCounter value
     * @property {number} MessageTypeGetMail=301 MessageTypeGetMail value
     * @property {number} MessageTypeBlockMail=302 MessageTypeBlockMail value
     * @property {number} MessageTypeEditAnnotation=303 MessageTypeEditAnnotation value
     * @property {number} MessageTypeGetPanels=304 MessageTypeGetPanels value
     * @property {number} MessageTypeSearchKinds=305 MessageTypeSearchKinds value
     * @property {number} MessageTypeDeleteMultipleAnnotations=306 MessageTypeDeleteMultipleAnnotations value
     * @property {number} MessageTypeGetAnnotationTypesOwned=307 MessageTypeGetAnnotationTypesOwned value
     * @property {number} MessageTypeGetAnnotationTypesOwnedCount=308 MessageTypeGetAnnotationTypesOwnedCount value
     * @property {number} MessageTypeRetryArchive=309 MessageTypeRetryArchive value
     * @property {number} MessageTypeShareArchive=310 MessageTypeShareArchive value
     * @property {number} MessageTypeExportAnnotations=311 MessageTypeExportAnnotations value
     * @property {number} MessageTypeAdminGetUser=312 MessageTypeAdminGetUser value
     * @property {number} MessageTypeAdminSearchUsers=313 MessageTypeAdminSearchUsers value
     * @property {number} MessageTypeAdminEditUser=314 MessageTypeAdminEditUser value
     * @property {number} MessageTypeAdminGetLastUsers=315 MessageTypeAdminGetLastUsers value
     * @property {number} MessageTypeTalkAutocompleteName=320 MessageTypeTalkAutocompleteName value
     * @property {number} MessageTypeTalkGetPerson=321 MessageTypeTalkGetPerson value
     * @property {number} MessageTypeTalkCreate=322 MessageTypeTalkCreate value
     * @property {number} MessageTypeTalkEdit=323 MessageTypeTalkEdit value
     * @property {number} MessageTypeTalkDelete=324 MessageTypeTalkDelete value
     * @property {number} MessageTypeGetTalks=325 MessageTypeGetTalks value
     * @property {number} MessageTypeDeleteMultipleTalks=326 MessageTypeDeleteMultipleTalks value
     * @property {number} MessageTypeExportTalks=327 MessageTypeExportTalks value
     * @property {number} MessageTypeSearchSpeeches=328 MessageTypeSearchSpeeches value
     * @property {number} MessageTypeSearchWords=329 MessageTypeSearchWords value
     * @property {number} MessageTypeTalkGetStudies=330 MessageTypeTalkGetStudies value
     * @property {number} MessageTypeTalkGetProgramTypes=331 MessageTypeTalkGetProgramTypes value
     * @property {number} MessageTypeTalkGetDistricts=332 MessageTypeTalkGetDistricts value
     * @property {number} MessageTypeTalkGetAllGroups=333 MessageTypeTalkGetAllGroups value
     * @property {number} MessageTypeTalkGetAllTitles=334 MessageTypeTalkGetAllTitles value
     * @property {number} MessageTypeTalkGetAllRegims=335 MessageTypeTalkGetAllRegims value
     * @property {number} MessageTypeGetTalkMedias=336 MessageTypeGetTalkMedias value
     * @property {number} MessageTypeSearchSpeechesDate=337 MessageTypeSearchSpeechesDate value
     * @property {number} MessageTypePlayerChunkStats=338 MessageTypePlayerChunkStats value
     * @property {number} MessageTypePlayerManifestStats=339 MessageTypePlayerManifestStats value
     * @property {number} MessageTypeGetMediasSTT=340 MessageTypeGetMediasSTT value
     * @property {number} MessageTypeGetMediasSTTid=341 MessageTypeGetMediasSTTid value
     * @property {number} MessageTypeReportBug=342 MessageTypeReportBug value
     * @property {number} MessageTypeGetMediasBackground=343 MessageTypeGetMediasBackground value
     * @property {number} MessageTypeGetMediasBackgroundid=344 MessageTypeGetMediasBackgroundid value
     * @property {number} MessageTypeGetMediasCrossBucket=345 MessageTypeGetMediasCrossBucket value
     * @property {number} MessageTypeGetMediasCrossBucketid=346 MessageTypeGetMediasCrossBucketid value
     * @property {number} MessageTypeWhoYouAre=512 MessageTypeWhoYouAre value
     * @property {number} MessageTypePermanentToken=513 MessageTypePermanentToken value
     * @property {number} MessageTypeEPG=514 MessageTypeEPG value
     * @property {number} MessageTypeChunk=515 MessageTypeChunk value
     * @property {number} MessageTypeMedias=516 MessageTypeMedias value
     * @property {number} MessageTypeContacts=517 MessageTypeContacts value
     * @property {number} MessageTypeContactsCount=518 MessageTypeContactsCount value
     * @property {number} MessageTypeAnnotationTypes=519 MessageTypeAnnotationTypes value
     * @property {number} MessageTypeAnnotationTypesCount=520 MessageTypeAnnotationTypesCount value
     * @property {number} MessageTypeStream=521 MessageTypeStream value
     * @property {number} MessageTypeSearchResults=522 MessageTypeSearchResults value
     * @property {number} MessageTypeFTPAccounts=523 MessageTypeFTPAccounts value
     * @property {number} MessageTypeFTPAccountsCount=524 MessageTypeFTPAccountsCount value
     * @property {number} MessageTypeSFTPAccounts=525 MessageTypeSFTPAccounts value
     * @property {number} MessageTypeSFTPAccountsCount=526 MessageTypeSFTPAccountsCount value
     * @property {number} MessageTypeAnnotations=527 MessageTypeAnnotations value
     * @property {number} MessageTypeArchives=528 MessageTypeArchives value
     * @property {number} MessageTypeArchivesCount=529 MessageTypeArchivesCount value
     * @property {number} MessageTypeArchiveTags=530 MessageTypeArchiveTags value
     * @property {number} MessageTypeArchive=531 MessageTypeArchive value
     * @property {number} MessageTypeReviews=532 MessageTypeReviews value
     * @property {number} MessageTypeReview=533 MessageTypeReview value
     * @property {number} MessageTypeContact=534 MessageTypeContact value
     * @property {number} MessageTypeFTPAccount=535 MessageTypeFTPAccount value
     * @property {number} MessageTypeSFTPAccount=536 MessageTypeSFTPAccount value
     * @property {number} MessageTypeMail=537 MessageTypeMail value
     * @property {number} MessageTypePanels=538 MessageTypePanels value
     * @property {number} MessageTypeSearchKindsResult=539 MessageTypeSearchKindsResult value
     * @property {number} MessageTypeAnnotationTypesOwned=540 MessageTypeAnnotationTypesOwned value
     * @property {number} MessageTypeAnnotationTypesOwnedCount=541 MessageTypeAnnotationTypesOwnedCount value
     * @property {number} MessageTypeAdminUser=542 MessageTypeAdminUser value
     * @property {number} MessageTypeAdminSearchUsersResult=543 MessageTypeAdminSearchUsersResult value
     * @property {number} MessageTypeAdminLastUsers=544 MessageTypeAdminLastUsers value
     * @property {number} MessageTypeInlineAnnotations=545 MessageTypeInlineAnnotations value
     * @property {number} MessageTypeTalkAutocompleteNameSuggs=560 MessageTypeTalkAutocompleteNameSuggs value
     * @property {number} MessageTypeTalkPerson=561 MessageTypeTalkPerson value
     * @property {number} MessageTypeTalks=562 MessageTypeTalks value
     * @property {number} MessageTypeSearchSpeechesResult=563 MessageTypeSearchSpeechesResult value
     * @property {number} MessageTypeAnnotationDirect=564 MessageTypeAnnotationDirect value
     * @property {number} MessageTypeExpiringToken=565 MessageTypeExpiringToken value
     * @property {number} MessageTypeSearchWordsResult=566 MessageTypeSearchWordsResult value
     * @property {number} MessageTypeTalkStudies=567 MessageTypeTalkStudies value
     * @property {number} MessageTypeTalkProgramTypes=568 MessageTypeTalkProgramTypes value
     * @property {number} MessageTypeTalkDistricts=569 MessageTypeTalkDistricts value
     * @property {number} MessageTypeTalkAllGroups=570 MessageTypeTalkAllGroups value
     * @property {number} MessageTypeTalkAllTitles=571 MessageTypeTalkAllTitles value
     * @property {number} MessageTypeTalkAllRegims=572 MessageTypeTalkAllRegims value
     * @property {number} MessageTypeTalkMedias=573 MessageTypeTalkMedias value
     * @property {number} MessageTypeTalkExportedTalks=574 MessageTypeTalkExportedTalks value
     * @property {number} MessageTypeSearchSpeechesDateResult=575 MessageTypeSearchSpeechesDateResult value
     * @property {number} MessageTypeMediasSTT=576 MessageTypeMediasSTT value
     * @property {number} MessageTypeMediasSTTid=577 MessageTypeMediasSTTid value
     * @property {number} MessageTypeMediasBackground=578 MessageTypeMediasBackground value
     * @property {number} MessageTypeMediasBackgroundid=579 MessageTypeMediasBackgroundid value
     * @property {number} MessageTypeMediasCrossBucket=580 MessageTypeMediasCrossBucket value
     * @property {number} MessageTypeMediasCrossBucketid=581 MessageTypeMediasCrossBucketid value
     */
    mediaarchiver.WSMessageType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MessageTypeUnknown"] = 0;
        values[valuesById[1] = "MessageTypeAck"] = 1;
        values[valuesById[256] = "MessageTypeLogin"] = 256;
        values[valuesById[257] = "MessageTypeLogout"] = 257;
        values[valuesById[258] = "MessageTypeRecover"] = 258;
        values[valuesById[259] = "MessageTypeGetEPG"] = 259;
        values[valuesById[260] = "MessageTypeGetChunk"] = 260;
        values[valuesById[261] = "MessageTypeGetMedias"] = 261;
        values[valuesById[262] = "MessageTypeGetContacts"] = 262;
        values[valuesById[263] = "MessageTypeGetContactsCount"] = 263;
        values[valuesById[264] = "MessageTypeCreateContact"] = 264;
        values[valuesById[265] = "MessageTypeEditContact"] = 265;
        values[valuesById[266] = "MessageTypeDeleteContact"] = 266;
        values[valuesById[267] = "MessageTypeGetAnnotationTypes"] = 267;
        values[valuesById[268] = "MessageTypeGetAnnotationTypesCount"] = 268;
        values[valuesById[269] = "MessageTypeCreateAnnotationType"] = 269;
        values[valuesById[270] = "MessageTypeEditAnnotationType"] = 270;
        values[valuesById[271] = "MessageTypeDeleteAnnotationType"] = 271;
        values[valuesById[272] = "MessageTypeCreateAnnotation"] = 272;
        values[valuesById[273] = "MessageTypeGetStream"] = 273;
        values[valuesById[274] = "MessageTypeSearchPrograms"] = 274;
        values[valuesById[275] = "MessageTypeGetFTPAccounts"] = 275;
        values[valuesById[276] = "MessageTypeGetFTPAccountsCount"] = 276;
        values[valuesById[277] = "MessageTypeCreateFTPAccount"] = 277;
        values[valuesById[278] = "MessageTypeEditFTPAccount"] = 278;
        values[valuesById[279] = "MessageTypeDeleteFTPAccount"] = 279;
        values[valuesById[280] = "MessageTypeGetSFTPAccounts"] = 280;
        values[valuesById[281] = "MessageTypeGetSFTPAccountsCount"] = 281;
        values[valuesById[282] = "MessageTypeCreateSFTPAccount"] = 282;
        values[valuesById[283] = "MessageTypeEditSFTPAccount"] = 283;
        values[valuesById[284] = "MessageTypeDeleteSFTPAccount"] = 284;
        values[valuesById[285] = "MessageTypeSetAccountOptions"] = 285;
        values[valuesById[286] = "MessageTypeGetAnnotations"] = 286;
        values[valuesById[287] = "MessageTypeDeleteAnnotation"] = 287;
        values[valuesById[288] = "MessageTypeCreateArchive"] = 288;
        values[valuesById[289] = "MessageTypeGetArchives"] = 289;
        values[valuesById[290] = "MessageTypeGetArchivesCount"] = 290;
        values[valuesById[291] = "MessageTypeEditArchive"] = 291;
        values[valuesById[292] = "MessageTypeDeleteArchive"] = 292;
        values[valuesById[293] = "MessageTypeGetArchiveTags"] = 293;
        values[valuesById[294] = "MessageTypeGetArchive"] = 294;
        values[valuesById[295] = "MessageTypeGetReviews"] = 295;
        values[valuesById[296] = "MessageTypeGetReview"] = 296;
        values[valuesById[297] = "MessageTypeCreateReview"] = 297;
        values[valuesById[298] = "MessageTypeEditReview"] = 298;
        values[valuesById[299] = "MessageTypeDeleteReview"] = 299;
        values[valuesById[300] = "MessageTypeIncArchiveCounter"] = 300;
        values[valuesById[301] = "MessageTypeGetMail"] = 301;
        values[valuesById[302] = "MessageTypeBlockMail"] = 302;
        values[valuesById[303] = "MessageTypeEditAnnotation"] = 303;
        values[valuesById[304] = "MessageTypeGetPanels"] = 304;
        values[valuesById[305] = "MessageTypeSearchKinds"] = 305;
        values[valuesById[306] = "MessageTypeDeleteMultipleAnnotations"] = 306;
        values[valuesById[307] = "MessageTypeGetAnnotationTypesOwned"] = 307;
        values[valuesById[308] = "MessageTypeGetAnnotationTypesOwnedCount"] = 308;
        values[valuesById[309] = "MessageTypeRetryArchive"] = 309;
        values[valuesById[310] = "MessageTypeShareArchive"] = 310;
        values[valuesById[311] = "MessageTypeExportAnnotations"] = 311;
        values[valuesById[312] = "MessageTypeAdminGetUser"] = 312;
        values[valuesById[313] = "MessageTypeAdminSearchUsers"] = 313;
        values[valuesById[314] = "MessageTypeAdminEditUser"] = 314;
        values[valuesById[315] = "MessageTypeAdminGetLastUsers"] = 315;
        values[valuesById[320] = "MessageTypeTalkAutocompleteName"] = 320;
        values[valuesById[321] = "MessageTypeTalkGetPerson"] = 321;
        values[valuesById[322] = "MessageTypeTalkCreate"] = 322;
        values[valuesById[323] = "MessageTypeTalkEdit"] = 323;
        values[valuesById[324] = "MessageTypeTalkDelete"] = 324;
        values[valuesById[325] = "MessageTypeGetTalks"] = 325;
        values[valuesById[326] = "MessageTypeDeleteMultipleTalks"] = 326;
        values[valuesById[327] = "MessageTypeExportTalks"] = 327;
        values[valuesById[328] = "MessageTypeSearchSpeeches"] = 328;
        values[valuesById[329] = "MessageTypeSearchWords"] = 329;
        values[valuesById[330] = "MessageTypeTalkGetStudies"] = 330;
        values[valuesById[331] = "MessageTypeTalkGetProgramTypes"] = 331;
        values[valuesById[332] = "MessageTypeTalkGetDistricts"] = 332;
        values[valuesById[333] = "MessageTypeTalkGetAllGroups"] = 333;
        values[valuesById[334] = "MessageTypeTalkGetAllTitles"] = 334;
        values[valuesById[335] = "MessageTypeTalkGetAllRegims"] = 335;
        values[valuesById[336] = "MessageTypeGetTalkMedias"] = 336;
        values[valuesById[337] = "MessageTypeSearchSpeechesDate"] = 337;
        values[valuesById[338] = "MessageTypePlayerChunkStats"] = 338;
        values[valuesById[339] = "MessageTypePlayerManifestStats"] = 339;
        values[valuesById[340] = "MessageTypeGetMediasSTT"] = 340;
        values[valuesById[341] = "MessageTypeGetMediasSTTid"] = 341;
        values[valuesById[342] = "MessageTypeReportBug"] = 342;
        values[valuesById[343] = "MessageTypeGetMediasBackground"] = 343;
        values[valuesById[344] = "MessageTypeGetMediasBackgroundid"] = 344;
        values[valuesById[345] = "MessageTypeGetMediasCrossBucket"] = 345;
        values[valuesById[346] = "MessageTypeGetMediasCrossBucketid"] = 346;
        values[valuesById[512] = "MessageTypeWhoYouAre"] = 512;
        values[valuesById[513] = "MessageTypePermanentToken"] = 513;
        values[valuesById[514] = "MessageTypeEPG"] = 514;
        values[valuesById[515] = "MessageTypeChunk"] = 515;
        values[valuesById[516] = "MessageTypeMedias"] = 516;
        values[valuesById[517] = "MessageTypeContacts"] = 517;
        values[valuesById[518] = "MessageTypeContactsCount"] = 518;
        values[valuesById[519] = "MessageTypeAnnotationTypes"] = 519;
        values[valuesById[520] = "MessageTypeAnnotationTypesCount"] = 520;
        values[valuesById[521] = "MessageTypeStream"] = 521;
        values[valuesById[522] = "MessageTypeSearchResults"] = 522;
        values[valuesById[523] = "MessageTypeFTPAccounts"] = 523;
        values[valuesById[524] = "MessageTypeFTPAccountsCount"] = 524;
        values[valuesById[525] = "MessageTypeSFTPAccounts"] = 525;
        values[valuesById[526] = "MessageTypeSFTPAccountsCount"] = 526;
        values[valuesById[527] = "MessageTypeAnnotations"] = 527;
        values[valuesById[528] = "MessageTypeArchives"] = 528;
        values[valuesById[529] = "MessageTypeArchivesCount"] = 529;
        values[valuesById[530] = "MessageTypeArchiveTags"] = 530;
        values[valuesById[531] = "MessageTypeArchive"] = 531;
        values[valuesById[532] = "MessageTypeReviews"] = 532;
        values[valuesById[533] = "MessageTypeReview"] = 533;
        values[valuesById[534] = "MessageTypeContact"] = 534;
        values[valuesById[535] = "MessageTypeFTPAccount"] = 535;
        values[valuesById[536] = "MessageTypeSFTPAccount"] = 536;
        values[valuesById[537] = "MessageTypeMail"] = 537;
        values[valuesById[538] = "MessageTypePanels"] = 538;
        values[valuesById[539] = "MessageTypeSearchKindsResult"] = 539;
        values[valuesById[540] = "MessageTypeAnnotationTypesOwned"] = 540;
        values[valuesById[541] = "MessageTypeAnnotationTypesOwnedCount"] = 541;
        values[valuesById[542] = "MessageTypeAdminUser"] = 542;
        values[valuesById[543] = "MessageTypeAdminSearchUsersResult"] = 543;
        values[valuesById[544] = "MessageTypeAdminLastUsers"] = 544;
        values[valuesById[545] = "MessageTypeInlineAnnotations"] = 545;
        values[valuesById[560] = "MessageTypeTalkAutocompleteNameSuggs"] = 560;
        values[valuesById[561] = "MessageTypeTalkPerson"] = 561;
        values[valuesById[562] = "MessageTypeTalks"] = 562;
        values[valuesById[563] = "MessageTypeSearchSpeechesResult"] = 563;
        values[valuesById[564] = "MessageTypeAnnotationDirect"] = 564;
        values[valuesById[565] = "MessageTypeExpiringToken"] = 565;
        values[valuesById[566] = "MessageTypeSearchWordsResult"] = 566;
        values[valuesById[567] = "MessageTypeTalkStudies"] = 567;
        values[valuesById[568] = "MessageTypeTalkProgramTypes"] = 568;
        values[valuesById[569] = "MessageTypeTalkDistricts"] = 569;
        values[valuesById[570] = "MessageTypeTalkAllGroups"] = 570;
        values[valuesById[571] = "MessageTypeTalkAllTitles"] = 571;
        values[valuesById[572] = "MessageTypeTalkAllRegims"] = 572;
        values[valuesById[573] = "MessageTypeTalkMedias"] = 573;
        values[valuesById[574] = "MessageTypeTalkExportedTalks"] = 574;
        values[valuesById[575] = "MessageTypeSearchSpeechesDateResult"] = 575;
        values[valuesById[576] = "MessageTypeMediasSTT"] = 576;
        values[valuesById[577] = "MessageTypeMediasSTTid"] = 577;
        values[valuesById[578] = "MessageTypeMediasBackground"] = 578;
        values[valuesById[579] = "MessageTypeMediasBackgroundid"] = 579;
        values[valuesById[580] = "MessageTypeMediasCrossBucket"] = 580;
        values[valuesById[581] = "MessageTypeMediasCrossBucketid"] = 581;
        return values;
    })();

    mediaarchiver.MultipleIDs = (function() {

        /**
         * Properties of a MultipleIDs.
         * @memberof mediaarchiver
         * @interface IMultipleIDs
         * @property {Array.<string>|null} [IDs] MultipleIDs IDs
         */

        /**
         * Constructs a new MultipleIDs.
         * @memberof mediaarchiver
         * @classdesc Represents a MultipleIDs.
         * @implements IMultipleIDs
         * @constructor
         * @param {mediaarchiver.IMultipleIDs=} [properties] Properties to set
         */
        function MultipleIDs(properties) {
            this.IDs = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MultipleIDs IDs.
         * @member {Array.<string>} IDs
         * @memberof mediaarchiver.MultipleIDs
         * @instance
         */
        MultipleIDs.prototype.IDs = $util.emptyArray;

        /**
         * Creates a new MultipleIDs instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.MultipleIDs
         * @static
         * @param {mediaarchiver.IMultipleIDs=} [properties] Properties to set
         * @returns {mediaarchiver.MultipleIDs} MultipleIDs instance
         */
        MultipleIDs.create = function create(properties) {
            return new MultipleIDs(properties);
        };

        /**
         * Encodes the specified MultipleIDs message. Does not implicitly {@link mediaarchiver.MultipleIDs.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.MultipleIDs
         * @static
         * @param {mediaarchiver.IMultipleIDs} message MultipleIDs message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MultipleIDs.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.IDs != null && message.IDs.length)
                for (let i = 0; i < message.IDs.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.IDs[i]);
            return writer;
        };

        /**
         * Encodes the specified MultipleIDs message, length delimited. Does not implicitly {@link mediaarchiver.MultipleIDs.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.MultipleIDs
         * @static
         * @param {mediaarchiver.IMultipleIDs} message MultipleIDs message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MultipleIDs.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MultipleIDs message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.MultipleIDs
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.MultipleIDs} MultipleIDs
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MultipleIDs.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.MultipleIDs();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.IDs && message.IDs.length))
                        message.IDs = [];
                    message.IDs.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MultipleIDs message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.MultipleIDs
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.MultipleIDs} MultipleIDs
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MultipleIDs.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MultipleIDs message.
         * @function verify
         * @memberof mediaarchiver.MultipleIDs
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MultipleIDs.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.IDs != null && message.hasOwnProperty("IDs")) {
                if (!Array.isArray(message.IDs))
                    return "IDs: array expected";
                for (let i = 0; i < message.IDs.length; ++i)
                    if (!$util.isString(message.IDs[i]))
                        return "IDs: string[] expected";
            }
            return null;
        };

        /**
         * Creates a MultipleIDs message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.MultipleIDs
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.MultipleIDs} MultipleIDs
         */
        MultipleIDs.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.MultipleIDs)
                return object;
            let message = new $root.mediaarchiver.MultipleIDs();
            if (object.IDs) {
                if (!Array.isArray(object.IDs))
                    throw TypeError(".mediaarchiver.MultipleIDs.IDs: array expected");
                message.IDs = [];
                for (let i = 0; i < object.IDs.length; ++i)
                    message.IDs[i] = String(object.IDs[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a MultipleIDs message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.MultipleIDs
         * @static
         * @param {mediaarchiver.MultipleIDs} message MultipleIDs
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MultipleIDs.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.IDs = [];
            if (message.IDs && message.IDs.length) {
                object.IDs = [];
                for (let j = 0; j < message.IDs.length; ++j)
                    object.IDs[j] = message.IDs[j];
            }
            return object;
        };

        /**
         * Converts this MultipleIDs to JSON.
         * @function toJSON
         * @memberof mediaarchiver.MultipleIDs
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MultipleIDs.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MultipleIDs;
    })();

    mediaarchiver.WSMessage = (function() {

        /**
         * Properties of a WSMessage.
         * @memberof mediaarchiver
         * @interface IWSMessage
         * @property {mediaarchiver.WSMessageType|null} [Type] WSMessage Type
         * @property {string|null} [MessageID] WSMessage MessageID
         * @property {string|null} [ID] WSMessage ID
         * @property {mediaarchiver.IArgumentsLogin|null} [LoginArgs] WSMessage LoginArgs
         * @property {mediaarchiver.IArgumentsMessageAck|null} [MessageAckArgs] WSMessage MessageAckArgs
         * @property {mediaarchiver.IArgumentsWhoYouAre|null} [WhoYouAreArgs] WSMessage WhoYouAreArgs
         * @property {string|null} [TokenArg] WSMessage TokenArg
         * @property {mediaarchiver.IArgumentsGetMedias|null} [GetMediasArgs] WSMessage GetMediasArgs
         * @property {mediaarchiver.IArgumentsMedias|null} [MediasArg] WSMessage MediasArg
         * @property {mediaarchiver.IArgumentsGetEPG|null} [GetEPGArgs] WSMessage GetEPGArgs
         * @property {mediaarchiver.IArgumentsEPG|null} [EPGArgs] WSMessage EPGArgs
         * @property {mediaarchiver.IArgumentsGetChunk|null} [GetChunkArgs] WSMessage GetChunkArgs
         * @property {mediaarchiver.IArgumentsChunk|null} [ChunkArgs] WSMessage ChunkArgs
         * @property {mediaarchiver.IArgumentsGetContacts|null} [GetContactsArgs] WSMessage GetContactsArgs
         * @property {mediaarchiver.IArgumentsContacts|null} [ContactsArgs] WSMessage ContactsArgs
         * @property {number|null} [ContactsCountArg] WSMessage ContactsCountArg
         * @property {mediaarchiver.IContact|null} [CreateContactArgs] WSMessage CreateContactArgs
         * @property {mediaarchiver.IContact|null} [EditContactArgs] WSMessage EditContactArgs
         * @property {mediaarchiver.IArgumentsGetAnnotationTypes|null} [GetAnnotationTypesArgs] WSMessage GetAnnotationTypesArgs
         * @property {mediaarchiver.IArgumentsAnnotationTypes|null} [AnnotationTypesArgs] WSMessage AnnotationTypesArgs
         * @property {number|null} [AnnotationTypesCountArg] WSMessage AnnotationTypesCountArg
         * @property {mediaarchiver.IAnnotationType|null} [CreateAnnotationTypeArgs] WSMessage CreateAnnotationTypeArgs
         * @property {mediaarchiver.IAnnotationType|null} [EditAnnotationTypeArgs] WSMessage EditAnnotationTypeArgs
         * @property {string|null} [DeleteAnnotationTypeArg] WSMessage DeleteAnnotationTypeArg
         * @property {mediaarchiver.IArgumentsCreateAnnotation|null} [CreateAnnotationArg] WSMessage CreateAnnotationArg
         * @property {mediaarchiver.IArgumentsGetStream|null} [GetStreamArg] WSMessage GetStreamArg
         * @property {mediaarchiver.IArgumentsStream|null} [StreamArg] WSMessage StreamArg
         * @property {mediaarchiver.IArgumentsSearchPrograms|null} [SearchProgramArgs] WSMessage SearchProgramArgs
         * @property {mediaarchiver.IArgumentsSearchResults|null} [SearchResultsArgs] WSMessage SearchResultsArgs
         * @property {mediaarchiver.IArgumentsGetFTPAccounts|null} [GetFTPAccountsArgs] WSMessage GetFTPAccountsArgs
         * @property {mediaarchiver.IArgumentsFTPAccounts|null} [FTPAccountsArgs] WSMessage FTPAccountsArgs
         * @property {number|null} [FTPAccountsCountArg] WSMessage FTPAccountsCountArg
         * @property {mediaarchiver.IFTPAccount|null} [CreateFTPAccountArgs] WSMessage CreateFTPAccountArgs
         * @property {mediaarchiver.IFTPAccount|null} [EditFTPAccountArgs] WSMessage EditFTPAccountArgs
         * @property {string|null} [DeleteFTPAccountArg] WSMessage DeleteFTPAccountArg
         * @property {mediaarchiver.IArgumentsGetSFTPAccounts|null} [GetSFTPAccountsArgs] WSMessage GetSFTPAccountsArgs
         * @property {mediaarchiver.IArgumentsSFTPAccounts|null} [SFTPAccountsArgs] WSMessage SFTPAccountsArgs
         * @property {number|null} [SFTPAccountsCountArg] WSMessage SFTPAccountsCountArg
         * @property {mediaarchiver.ISFTPAccount|null} [CreateSFTPAccountArgs] WSMessage CreateSFTPAccountArgs
         * @property {mediaarchiver.ISFTPAccount|null} [EditSFTPAccountArgs] WSMessage EditSFTPAccountArgs
         * @property {string|null} [DeleteSFTPAccountArg] WSMessage DeleteSFTPAccountArg
         * @property {mediaarchiver.IUserOptionsList|null} [SetAccountOptionsArg] WSMessage SetAccountOptionsArg
         * @property {mediaarchiver.IArgumentsAnnotations|null} [AnnotationsArg] WSMessage AnnotationsArg
         * @property {mediaarchiver.IArgumentsGetAnnotations|null} [GetAnnotationsArg] WSMessage GetAnnotationsArg
         * @property {mediaarchiver.IArgumentsDeleteAnnotation|null} [DeleteAnnotationArg] WSMessage DeleteAnnotationArg
         * @property {mediaarchiver.IArchive|null} [CreateArchiveArg] WSMessage CreateArchiveArg
         * @property {mediaarchiver.IArgumentsGetArchives|null} [GetArchivesArg] WSMessage GetArchivesArg
         * @property {mediaarchiver.IArchive|null} [EditArchiveArg] WSMessage EditArchiveArg
         * @property {string|null} [DeleteArchiveArg] WSMessage DeleteArchiveArg
         * @property {mediaarchiver.IArgumentsArchives|null} [ArchivesArg] WSMessage ArchivesArg
         * @property {mediaarchiver.IArgumentsArchivesCount|null} [ArchivesCountArg] WSMessage ArchivesCountArg
         * @property {string|null} [GetArchiveArg] WSMessage GetArchiveArg
         * @property {mediaarchiver.IArchive|null} [ArchiveArg] WSMessage ArchiveArg
         * @property {mediaarchiver.IArgumentsGetReviews|null} [GetReviewsArg] WSMessage GetReviewsArg
         * @property {mediaarchiver.IArgumentsReviews|null} [ReviewsArg] WSMessage ReviewsArg
         * @property {mediaarchiver.IReview|null} [ReviewArg] WSMessage ReviewArg
         * @property {mediaarchiver.IContact|null} [ContactArg] WSMessage ContactArg
         * @property {mediaarchiver.IFTPAccount|null} [FTPAccountArg] WSMessage FTPAccountArg
         * @property {mediaarchiver.ISFTPAccount|null} [SFTPAccountArg] WSMessage SFTPAccountArg
         * @property {string|null} [DeleteContactArg] WSMessage DeleteContactArg
         * @property {mediaarchiver.IArgumentsIncArchiveCounter|null} [IncArchiveCounterArg] WSMessage IncArchiveCounterArg
         * @property {string|null} [GetMailArg] WSMessage GetMailArg
         * @property {string|null} [MailArg] WSMessage MailArg
         * @property {mediaarchiver.IArgumentsBlockMail|null} [BlockMailArg] WSMessage BlockMailArg
         * @property {mediaarchiver.IAnnotation|null} [EditAnnotationArg] WSMessage EditAnnotationArg
         * @property {mediaarchiver.IPanels|null} [PanelsArg] WSMessage PanelsArg
         * @property {string|null} [SearchKindArg] WSMessage SearchKindArg
         * @property {mediaarchiver.ISearchKindResult|null} [SearchKindResultsArg] WSMessage SearchKindResultsArg
         * @property {mediaarchiver.IMultipleIDs|null} [DeleteMultipleAnnotationsArg] WSMessage DeleteMultipleAnnotationsArg
         * @property {mediaarchiver.IArgumentsGetAnnotationTypes|null} [GetAnnotationTypesOwnedArgs] WSMessage GetAnnotationTypesOwnedArgs
         * @property {mediaarchiver.IArgumentsAnnotationTypes|null} [AnnotationTypesOwnedArgs] WSMessage AnnotationTypesOwnedArgs
         * @property {number|null} [AnnotationTypesOwnedCountArg] WSMessage AnnotationTypesOwnedCountArg
         * @property {string|null} [RetryArchiveArg] WSMessage RetryArchiveArg
         * @property {mediaarchiver.IArgumentsShareArchive|null} [ShareArchiveArg] WSMessage ShareArchiveArg
         * @property {mediaarchiver.IArgumentsExportAnnotations|null} [ExportAnnotationArg] WSMessage ExportAnnotationArg
         * @property {number|null} [AdminGetUserArg] WSMessage AdminGetUserArg
         * @property {mediaarchiver.IAdminSearchUsers|null} [AdminSearchUsersArgs] WSMessage AdminSearchUsersArgs
         * @property {mediaarchiver.IAdminUser|null} [AdminEditUserArg] WSMessage AdminEditUserArg
         * @property {mediaarchiver.IAdminUser|null} [AdminUserArg] WSMessage AdminUserArg
         * @property {mediaarchiver.IAdminUsers|null} [AdminSearchUsersResultArg] WSMessage AdminSearchUsersResultArg
         * @property {mediaarchiver.IAdminUsers|null} [AdminLastUsersArg] WSMessage AdminLastUsersArg
         * @property {string|null} [InlineAnnotationsArg] WSMessage InlineAnnotationsArg
         * @property {mediaarchiver.ITalkAutocompleteName|null} [TalkAutocompleteNameArg] WSMessage TalkAutocompleteNameArg
         * @property {string|null} [TalkGetPersonArg] WSMessage TalkGetPersonArg
         * @property {mediaarchiver.ITalkPersonSuggs|null} [TalkAutocompleteNameSuggsArgs] WSMessage TalkAutocompleteNameSuggsArgs
         * @property {mediaarchiver.ITalkPerson|null} [TalkPersonArg] WSMessage TalkPersonArg
         * @property {mediaarchiver.ITalk|null} [TalkCreateArg] WSMessage TalkCreateArg
         * @property {mediaarchiver.ITalk|null} [TalkEditArg] WSMessage TalkEditArg
         * @property {string|null} [TalkDeleteArg] WSMessage TalkDeleteArg
         * @property {mediaarchiver.IArgumentsTalks|null} [TalksArg] WSMessage TalksArg
         * @property {mediaarchiver.IArgumentsGetTalks|null} [GetTalksArg] WSMessage GetTalksArg
         * @property {mediaarchiver.IMultipleIDs|null} [DeleteMultipleTalksArg] WSMessage DeleteMultipleTalksArg
         * @property {mediaarchiver.IArgumentsExportTalks|null} [ExportTalksArg] WSMessage ExportTalksArg
         * @property {mediaarchiver.ISearchSpeeches|null} [SearchSpeechesArgs] WSMessage SearchSpeechesArgs
         * @property {mediaarchiver.ISearchSpeechesResult|null} [SearchSpeechesResultArgs] WSMessage SearchSpeechesResultArgs
         * @property {string|null} [AnnotationDirectArg] WSMessage AnnotationDirectArg
         * @property {mediaarchiver.IExpiringToken|null} [ExpiringTokenArg] WSMessage ExpiringTokenArg
         * @property {mediaarchiver.ISearchWords|null} [SearchWordsArgs] WSMessage SearchWordsArgs
         * @property {mediaarchiver.ISearchWordsResult|null} [SearchWordsResultArgs] WSMessage SearchWordsResultArgs
         * @property {mediaarchiver.ITalkStudies|null} [TalkStudiesArgs] WSMessage TalkStudiesArgs
         * @property {mediaarchiver.ITalkProgramTypes|null} [TalkProgramTypesArgs] WSMessage TalkProgramTypesArgs
         * @property {mediaarchiver.ITalkDistricts|null} [TalkDistrictsArgs] WSMessage TalkDistrictsArgs
         * @property {mediaarchiver.ITalkGetDistricts|null} [TalkGetDistrictsArg] WSMessage TalkGetDistrictsArg
         * @property {mediaarchiver.ITalkGroups|null} [TalkAllGroupsArg] WSMessage TalkAllGroupsArg
         * @property {mediaarchiver.ITalkRegims|null} [TalkAllRegimsArg] WSMessage TalkAllRegimsArg
         * @property {mediaarchiver.ITalkTitles|null} [TalkAllTitlesArg] WSMessage TalkAllTitlesArg
         * @property {mediaarchiver.IMediaList|null} [TalkMediasArg] WSMessage TalkMediasArg
         * @property {string|null} [TalkExportedTalksArg] WSMessage TalkExportedTalksArg
         * @property {mediaarchiver.ISearchSpeechesDate|null} [SearchSpeechesDateArgs] WSMessage SearchSpeechesDateArgs
         * @property {mediaarchiver.ISearchSpeechesDateResult|null} [SearchSpeechesDateResultArgs] WSMessage SearchSpeechesDateResultArgs
         * @property {mediaarchiver.IPlayerStatsChunks|null} [PlayerChunksStatsArg] WSMessage PlayerChunksStatsArg
         * @property {mediaarchiver.IPlayerStatsManifest|null} [PlayerManifestStatsArg] WSMessage PlayerManifestStatsArg
         * @property {mediaarchiver.IArgumentsGetMediasSTT|null} [GetMediasSTTArgs] WSMessage GetMediasSTTArgs
         * @property {mediaarchiver.IMediaList|null} [STTMediasArg] WSMessage STTMediasArg
         * @property {mediaarchiver.IReportedBug|null} [ReportBugArg] WSMessage ReportBugArg
         * @property {mediaarchiver.IArgumentsGetMediasBackground|null} [GetMediasBackgroundArgs] WSMessage GetMediasBackgroundArgs
         * @property {mediaarchiver.IMediaList|null} [BackgroundMediasArg] WSMessage BackgroundMediasArg
         * @property {mediaarchiver.IArgumentsGetMediasCrossBucket|null} [GetMediasCrossBucketArgs] WSMessage GetMediasCrossBucketArgs
         * @property {mediaarchiver.IMediaList|null} [CrossBucketMediasArg] WSMessage CrossBucketMediasArg
         */

        /**
         * Constructs a new WSMessage.
         * @memberof mediaarchiver
         * @classdesc Represents a WSMessage.
         * @implements IWSMessage
         * @constructor
         * @param {mediaarchiver.IWSMessage=} [properties] Properties to set
         */
        function WSMessage(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * WSMessage Type.
         * @member {mediaarchiver.WSMessageType} Type
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.Type = 0;

        /**
         * WSMessage MessageID.
         * @member {string} MessageID
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.MessageID = "";

        /**
         * WSMessage ID.
         * @member {string|null|undefined} ID
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.ID = null;

        /**
         * WSMessage LoginArgs.
         * @member {mediaarchiver.IArgumentsLogin|null|undefined} LoginArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.LoginArgs = null;

        /**
         * WSMessage MessageAckArgs.
         * @member {mediaarchiver.IArgumentsMessageAck|null|undefined} MessageAckArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.MessageAckArgs = null;

        /**
         * WSMessage WhoYouAreArgs.
         * @member {mediaarchiver.IArgumentsWhoYouAre|null|undefined} WhoYouAreArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.WhoYouAreArgs = null;

        /**
         * WSMessage TokenArg.
         * @member {string|null|undefined} TokenArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.TokenArg = null;

        /**
         * WSMessage GetMediasArgs.
         * @member {mediaarchiver.IArgumentsGetMedias|null|undefined} GetMediasArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.GetMediasArgs = null;

        /**
         * WSMessage MediasArg.
         * @member {mediaarchiver.IArgumentsMedias|null|undefined} MediasArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.MediasArg = null;

        /**
         * WSMessage GetEPGArgs.
         * @member {mediaarchiver.IArgumentsGetEPG|null|undefined} GetEPGArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.GetEPGArgs = null;

        /**
         * WSMessage EPGArgs.
         * @member {mediaarchiver.IArgumentsEPG|null|undefined} EPGArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.EPGArgs = null;

        /**
         * WSMessage GetChunkArgs.
         * @member {mediaarchiver.IArgumentsGetChunk|null|undefined} GetChunkArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.GetChunkArgs = null;

        /**
         * WSMessage ChunkArgs.
         * @member {mediaarchiver.IArgumentsChunk|null|undefined} ChunkArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.ChunkArgs = null;

        /**
         * WSMessage GetContactsArgs.
         * @member {mediaarchiver.IArgumentsGetContacts|null|undefined} GetContactsArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.GetContactsArgs = null;

        /**
         * WSMessage ContactsArgs.
         * @member {mediaarchiver.IArgumentsContacts|null|undefined} ContactsArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.ContactsArgs = null;

        /**
         * WSMessage ContactsCountArg.
         * @member {number|null|undefined} ContactsCountArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.ContactsCountArg = null;

        /**
         * WSMessage CreateContactArgs.
         * @member {mediaarchiver.IContact|null|undefined} CreateContactArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.CreateContactArgs = null;

        /**
         * WSMessage EditContactArgs.
         * @member {mediaarchiver.IContact|null|undefined} EditContactArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.EditContactArgs = null;

        /**
         * WSMessage GetAnnotationTypesArgs.
         * @member {mediaarchiver.IArgumentsGetAnnotationTypes|null|undefined} GetAnnotationTypesArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.GetAnnotationTypesArgs = null;

        /**
         * WSMessage AnnotationTypesArgs.
         * @member {mediaarchiver.IArgumentsAnnotationTypes|null|undefined} AnnotationTypesArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.AnnotationTypesArgs = null;

        /**
         * WSMessage AnnotationTypesCountArg.
         * @member {number|null|undefined} AnnotationTypesCountArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.AnnotationTypesCountArg = null;

        /**
         * WSMessage CreateAnnotationTypeArgs.
         * @member {mediaarchiver.IAnnotationType|null|undefined} CreateAnnotationTypeArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.CreateAnnotationTypeArgs = null;

        /**
         * WSMessage EditAnnotationTypeArgs.
         * @member {mediaarchiver.IAnnotationType|null|undefined} EditAnnotationTypeArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.EditAnnotationTypeArgs = null;

        /**
         * WSMessage DeleteAnnotationTypeArg.
         * @member {string|null|undefined} DeleteAnnotationTypeArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.DeleteAnnotationTypeArg = null;

        /**
         * WSMessage CreateAnnotationArg.
         * @member {mediaarchiver.IArgumentsCreateAnnotation|null|undefined} CreateAnnotationArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.CreateAnnotationArg = null;

        /**
         * WSMessage GetStreamArg.
         * @member {mediaarchiver.IArgumentsGetStream|null|undefined} GetStreamArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.GetStreamArg = null;

        /**
         * WSMessage StreamArg.
         * @member {mediaarchiver.IArgumentsStream|null|undefined} StreamArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.StreamArg = null;

        /**
         * WSMessage SearchProgramArgs.
         * @member {mediaarchiver.IArgumentsSearchPrograms|null|undefined} SearchProgramArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.SearchProgramArgs = null;

        /**
         * WSMessage SearchResultsArgs.
         * @member {mediaarchiver.IArgumentsSearchResults|null|undefined} SearchResultsArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.SearchResultsArgs = null;

        /**
         * WSMessage GetFTPAccountsArgs.
         * @member {mediaarchiver.IArgumentsGetFTPAccounts|null|undefined} GetFTPAccountsArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.GetFTPAccountsArgs = null;

        /**
         * WSMessage FTPAccountsArgs.
         * @member {mediaarchiver.IArgumentsFTPAccounts|null|undefined} FTPAccountsArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.FTPAccountsArgs = null;

        /**
         * WSMessage FTPAccountsCountArg.
         * @member {number|null|undefined} FTPAccountsCountArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.FTPAccountsCountArg = null;

        /**
         * WSMessage CreateFTPAccountArgs.
         * @member {mediaarchiver.IFTPAccount|null|undefined} CreateFTPAccountArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.CreateFTPAccountArgs = null;

        /**
         * WSMessage EditFTPAccountArgs.
         * @member {mediaarchiver.IFTPAccount|null|undefined} EditFTPAccountArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.EditFTPAccountArgs = null;

        /**
         * WSMessage DeleteFTPAccountArg.
         * @member {string|null|undefined} DeleteFTPAccountArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.DeleteFTPAccountArg = null;

        /**
         * WSMessage GetSFTPAccountsArgs.
         * @member {mediaarchiver.IArgumentsGetSFTPAccounts|null|undefined} GetSFTPAccountsArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.GetSFTPAccountsArgs = null;

        /**
         * WSMessage SFTPAccountsArgs.
         * @member {mediaarchiver.IArgumentsSFTPAccounts|null|undefined} SFTPAccountsArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.SFTPAccountsArgs = null;

        /**
         * WSMessage SFTPAccountsCountArg.
         * @member {number|null|undefined} SFTPAccountsCountArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.SFTPAccountsCountArg = null;

        /**
         * WSMessage CreateSFTPAccountArgs.
         * @member {mediaarchiver.ISFTPAccount|null|undefined} CreateSFTPAccountArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.CreateSFTPAccountArgs = null;

        /**
         * WSMessage EditSFTPAccountArgs.
         * @member {mediaarchiver.ISFTPAccount|null|undefined} EditSFTPAccountArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.EditSFTPAccountArgs = null;

        /**
         * WSMessage DeleteSFTPAccountArg.
         * @member {string|null|undefined} DeleteSFTPAccountArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.DeleteSFTPAccountArg = null;

        /**
         * WSMessage SetAccountOptionsArg.
         * @member {mediaarchiver.IUserOptionsList|null|undefined} SetAccountOptionsArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.SetAccountOptionsArg = null;

        /**
         * WSMessage AnnotationsArg.
         * @member {mediaarchiver.IArgumentsAnnotations|null|undefined} AnnotationsArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.AnnotationsArg = null;

        /**
         * WSMessage GetAnnotationsArg.
         * @member {mediaarchiver.IArgumentsGetAnnotations|null|undefined} GetAnnotationsArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.GetAnnotationsArg = null;

        /**
         * WSMessage DeleteAnnotationArg.
         * @member {mediaarchiver.IArgumentsDeleteAnnotation|null|undefined} DeleteAnnotationArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.DeleteAnnotationArg = null;

        /**
         * WSMessage CreateArchiveArg.
         * @member {mediaarchiver.IArchive|null|undefined} CreateArchiveArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.CreateArchiveArg = null;

        /**
         * WSMessage GetArchivesArg.
         * @member {mediaarchiver.IArgumentsGetArchives|null|undefined} GetArchivesArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.GetArchivesArg = null;

        /**
         * WSMessage EditArchiveArg.
         * @member {mediaarchiver.IArchive|null|undefined} EditArchiveArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.EditArchiveArg = null;

        /**
         * WSMessage DeleteArchiveArg.
         * @member {string|null|undefined} DeleteArchiveArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.DeleteArchiveArg = null;

        /**
         * WSMessage ArchivesArg.
         * @member {mediaarchiver.IArgumentsArchives|null|undefined} ArchivesArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.ArchivesArg = null;

        /**
         * WSMessage ArchivesCountArg.
         * @member {mediaarchiver.IArgumentsArchivesCount|null|undefined} ArchivesCountArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.ArchivesCountArg = null;

        /**
         * WSMessage GetArchiveArg.
         * @member {string|null|undefined} GetArchiveArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.GetArchiveArg = null;

        /**
         * WSMessage ArchiveArg.
         * @member {mediaarchiver.IArchive|null|undefined} ArchiveArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.ArchiveArg = null;

        /**
         * WSMessage GetReviewsArg.
         * @member {mediaarchiver.IArgumentsGetReviews|null|undefined} GetReviewsArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.GetReviewsArg = null;

        /**
         * WSMessage ReviewsArg.
         * @member {mediaarchiver.IArgumentsReviews|null|undefined} ReviewsArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.ReviewsArg = null;

        /**
         * WSMessage ReviewArg.
         * @member {mediaarchiver.IReview|null|undefined} ReviewArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.ReviewArg = null;

        /**
         * WSMessage ContactArg.
         * @member {mediaarchiver.IContact|null|undefined} ContactArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.ContactArg = null;

        /**
         * WSMessage FTPAccountArg.
         * @member {mediaarchiver.IFTPAccount|null|undefined} FTPAccountArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.FTPAccountArg = null;

        /**
         * WSMessage SFTPAccountArg.
         * @member {mediaarchiver.ISFTPAccount|null|undefined} SFTPAccountArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.SFTPAccountArg = null;

        /**
         * WSMessage DeleteContactArg.
         * @member {string|null|undefined} DeleteContactArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.DeleteContactArg = null;

        /**
         * WSMessage IncArchiveCounterArg.
         * @member {mediaarchiver.IArgumentsIncArchiveCounter|null|undefined} IncArchiveCounterArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.IncArchiveCounterArg = null;

        /**
         * WSMessage GetMailArg.
         * @member {string|null|undefined} GetMailArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.GetMailArg = null;

        /**
         * WSMessage MailArg.
         * @member {string|null|undefined} MailArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.MailArg = null;

        /**
         * WSMessage BlockMailArg.
         * @member {mediaarchiver.IArgumentsBlockMail|null|undefined} BlockMailArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.BlockMailArg = null;

        /**
         * WSMessage EditAnnotationArg.
         * @member {mediaarchiver.IAnnotation|null|undefined} EditAnnotationArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.EditAnnotationArg = null;

        /**
         * WSMessage PanelsArg.
         * @member {mediaarchiver.IPanels|null|undefined} PanelsArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.PanelsArg = null;

        /**
         * WSMessage SearchKindArg.
         * @member {string|null|undefined} SearchKindArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.SearchKindArg = null;

        /**
         * WSMessage SearchKindResultsArg.
         * @member {mediaarchiver.ISearchKindResult|null|undefined} SearchKindResultsArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.SearchKindResultsArg = null;

        /**
         * WSMessage DeleteMultipleAnnotationsArg.
         * @member {mediaarchiver.IMultipleIDs|null|undefined} DeleteMultipleAnnotationsArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.DeleteMultipleAnnotationsArg = null;

        /**
         * WSMessage GetAnnotationTypesOwnedArgs.
         * @member {mediaarchiver.IArgumentsGetAnnotationTypes|null|undefined} GetAnnotationTypesOwnedArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.GetAnnotationTypesOwnedArgs = null;

        /**
         * WSMessage AnnotationTypesOwnedArgs.
         * @member {mediaarchiver.IArgumentsAnnotationTypes|null|undefined} AnnotationTypesOwnedArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.AnnotationTypesOwnedArgs = null;

        /**
         * WSMessage AnnotationTypesOwnedCountArg.
         * @member {number|null|undefined} AnnotationTypesOwnedCountArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.AnnotationTypesOwnedCountArg = null;

        /**
         * WSMessage RetryArchiveArg.
         * @member {string|null|undefined} RetryArchiveArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.RetryArchiveArg = null;

        /**
         * WSMessage ShareArchiveArg.
         * @member {mediaarchiver.IArgumentsShareArchive|null|undefined} ShareArchiveArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.ShareArchiveArg = null;

        /**
         * WSMessage ExportAnnotationArg.
         * @member {mediaarchiver.IArgumentsExportAnnotations|null|undefined} ExportAnnotationArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.ExportAnnotationArg = null;

        /**
         * WSMessage AdminGetUserArg.
         * @member {number|null|undefined} AdminGetUserArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.AdminGetUserArg = null;

        /**
         * WSMessage AdminSearchUsersArgs.
         * @member {mediaarchiver.IAdminSearchUsers|null|undefined} AdminSearchUsersArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.AdminSearchUsersArgs = null;

        /**
         * WSMessage AdminEditUserArg.
         * @member {mediaarchiver.IAdminUser|null|undefined} AdminEditUserArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.AdminEditUserArg = null;

        /**
         * WSMessage AdminUserArg.
         * @member {mediaarchiver.IAdminUser|null|undefined} AdminUserArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.AdminUserArg = null;

        /**
         * WSMessage AdminSearchUsersResultArg.
         * @member {mediaarchiver.IAdminUsers|null|undefined} AdminSearchUsersResultArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.AdminSearchUsersResultArg = null;

        /**
         * WSMessage AdminLastUsersArg.
         * @member {mediaarchiver.IAdminUsers|null|undefined} AdminLastUsersArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.AdminLastUsersArg = null;

        /**
         * WSMessage InlineAnnotationsArg.
         * @member {string|null|undefined} InlineAnnotationsArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.InlineAnnotationsArg = null;

        /**
         * WSMessage TalkAutocompleteNameArg.
         * @member {mediaarchiver.ITalkAutocompleteName|null|undefined} TalkAutocompleteNameArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.TalkAutocompleteNameArg = null;

        /**
         * WSMessage TalkGetPersonArg.
         * @member {string|null|undefined} TalkGetPersonArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.TalkGetPersonArg = null;

        /**
         * WSMessage TalkAutocompleteNameSuggsArgs.
         * @member {mediaarchiver.ITalkPersonSuggs|null|undefined} TalkAutocompleteNameSuggsArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.TalkAutocompleteNameSuggsArgs = null;

        /**
         * WSMessage TalkPersonArg.
         * @member {mediaarchiver.ITalkPerson|null|undefined} TalkPersonArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.TalkPersonArg = null;

        /**
         * WSMessage TalkCreateArg.
         * @member {mediaarchiver.ITalk|null|undefined} TalkCreateArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.TalkCreateArg = null;

        /**
         * WSMessage TalkEditArg.
         * @member {mediaarchiver.ITalk|null|undefined} TalkEditArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.TalkEditArg = null;

        /**
         * WSMessage TalkDeleteArg.
         * @member {string|null|undefined} TalkDeleteArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.TalkDeleteArg = null;

        /**
         * WSMessage TalksArg.
         * @member {mediaarchiver.IArgumentsTalks|null|undefined} TalksArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.TalksArg = null;

        /**
         * WSMessage GetTalksArg.
         * @member {mediaarchiver.IArgumentsGetTalks|null|undefined} GetTalksArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.GetTalksArg = null;

        /**
         * WSMessage DeleteMultipleTalksArg.
         * @member {mediaarchiver.IMultipleIDs|null|undefined} DeleteMultipleTalksArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.DeleteMultipleTalksArg = null;

        /**
         * WSMessage ExportTalksArg.
         * @member {mediaarchiver.IArgumentsExportTalks|null|undefined} ExportTalksArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.ExportTalksArg = null;

        /**
         * WSMessage SearchSpeechesArgs.
         * @member {mediaarchiver.ISearchSpeeches|null|undefined} SearchSpeechesArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.SearchSpeechesArgs = null;

        /**
         * WSMessage SearchSpeechesResultArgs.
         * @member {mediaarchiver.ISearchSpeechesResult|null|undefined} SearchSpeechesResultArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.SearchSpeechesResultArgs = null;

        /**
         * WSMessage AnnotationDirectArg.
         * @member {string|null|undefined} AnnotationDirectArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.AnnotationDirectArg = null;

        /**
         * WSMessage ExpiringTokenArg.
         * @member {mediaarchiver.IExpiringToken|null|undefined} ExpiringTokenArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.ExpiringTokenArg = null;

        /**
         * WSMessage SearchWordsArgs.
         * @member {mediaarchiver.ISearchWords|null|undefined} SearchWordsArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.SearchWordsArgs = null;

        /**
         * WSMessage SearchWordsResultArgs.
         * @member {mediaarchiver.ISearchWordsResult|null|undefined} SearchWordsResultArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.SearchWordsResultArgs = null;

        /**
         * WSMessage TalkStudiesArgs.
         * @member {mediaarchiver.ITalkStudies|null|undefined} TalkStudiesArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.TalkStudiesArgs = null;

        /**
         * WSMessage TalkProgramTypesArgs.
         * @member {mediaarchiver.ITalkProgramTypes|null|undefined} TalkProgramTypesArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.TalkProgramTypesArgs = null;

        /**
         * WSMessage TalkDistrictsArgs.
         * @member {mediaarchiver.ITalkDistricts|null|undefined} TalkDistrictsArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.TalkDistrictsArgs = null;

        /**
         * WSMessage TalkGetDistrictsArg.
         * @member {mediaarchiver.ITalkGetDistricts|null|undefined} TalkGetDistrictsArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.TalkGetDistrictsArg = null;

        /**
         * WSMessage TalkAllGroupsArg.
         * @member {mediaarchiver.ITalkGroups|null|undefined} TalkAllGroupsArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.TalkAllGroupsArg = null;

        /**
         * WSMessage TalkAllRegimsArg.
         * @member {mediaarchiver.ITalkRegims|null|undefined} TalkAllRegimsArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.TalkAllRegimsArg = null;

        /**
         * WSMessage TalkAllTitlesArg.
         * @member {mediaarchiver.ITalkTitles|null|undefined} TalkAllTitlesArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.TalkAllTitlesArg = null;

        /**
         * WSMessage TalkMediasArg.
         * @member {mediaarchiver.IMediaList|null|undefined} TalkMediasArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.TalkMediasArg = null;

        /**
         * WSMessage TalkExportedTalksArg.
         * @member {string|null|undefined} TalkExportedTalksArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.TalkExportedTalksArg = null;

        /**
         * WSMessage SearchSpeechesDateArgs.
         * @member {mediaarchiver.ISearchSpeechesDate|null|undefined} SearchSpeechesDateArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.SearchSpeechesDateArgs = null;

        /**
         * WSMessage SearchSpeechesDateResultArgs.
         * @member {mediaarchiver.ISearchSpeechesDateResult|null|undefined} SearchSpeechesDateResultArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.SearchSpeechesDateResultArgs = null;

        /**
         * WSMessage PlayerChunksStatsArg.
         * @member {mediaarchiver.IPlayerStatsChunks|null|undefined} PlayerChunksStatsArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.PlayerChunksStatsArg = null;

        /**
         * WSMessage PlayerManifestStatsArg.
         * @member {mediaarchiver.IPlayerStatsManifest|null|undefined} PlayerManifestStatsArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.PlayerManifestStatsArg = null;

        /**
         * WSMessage GetMediasSTTArgs.
         * @member {mediaarchiver.IArgumentsGetMediasSTT|null|undefined} GetMediasSTTArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.GetMediasSTTArgs = null;

        /**
         * WSMessage STTMediasArg.
         * @member {mediaarchiver.IMediaList|null|undefined} STTMediasArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.STTMediasArg = null;

        /**
         * WSMessage ReportBugArg.
         * @member {mediaarchiver.IReportedBug|null|undefined} ReportBugArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.ReportBugArg = null;

        /**
         * WSMessage GetMediasBackgroundArgs.
         * @member {mediaarchiver.IArgumentsGetMediasBackground|null|undefined} GetMediasBackgroundArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.GetMediasBackgroundArgs = null;

        /**
         * WSMessage BackgroundMediasArg.
         * @member {mediaarchiver.IMediaList|null|undefined} BackgroundMediasArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.BackgroundMediasArg = null;

        /**
         * WSMessage GetMediasCrossBucketArgs.
         * @member {mediaarchiver.IArgumentsGetMediasCrossBucket|null|undefined} GetMediasCrossBucketArgs
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.GetMediasCrossBucketArgs = null;

        /**
         * WSMessage CrossBucketMediasArg.
         * @member {mediaarchiver.IMediaList|null|undefined} CrossBucketMediasArg
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        WSMessage.prototype.CrossBucketMediasArg = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * WSMessage Arguments.
         * @member {"ID"|"LoginArgs"|"MessageAckArgs"|"WhoYouAreArgs"|"TokenArg"|"GetMediasArgs"|"MediasArg"|"GetEPGArgs"|"EPGArgs"|"GetChunkArgs"|"ChunkArgs"|"GetContactsArgs"|"ContactsArgs"|"ContactsCountArg"|"CreateContactArgs"|"EditContactArgs"|"GetAnnotationTypesArgs"|"AnnotationTypesArgs"|"AnnotationTypesCountArg"|"CreateAnnotationTypeArgs"|"EditAnnotationTypeArgs"|"DeleteAnnotationTypeArg"|"CreateAnnotationArg"|"GetStreamArg"|"StreamArg"|"SearchProgramArgs"|"SearchResultsArgs"|"GetFTPAccountsArgs"|"FTPAccountsArgs"|"FTPAccountsCountArg"|"CreateFTPAccountArgs"|"EditFTPAccountArgs"|"DeleteFTPAccountArg"|"GetSFTPAccountsArgs"|"SFTPAccountsArgs"|"SFTPAccountsCountArg"|"CreateSFTPAccountArgs"|"EditSFTPAccountArgs"|"DeleteSFTPAccountArg"|"SetAccountOptionsArg"|"AnnotationsArg"|"GetAnnotationsArg"|"DeleteAnnotationArg"|"CreateArchiveArg"|"GetArchivesArg"|"EditArchiveArg"|"DeleteArchiveArg"|"ArchivesArg"|"ArchivesCountArg"|"GetArchiveArg"|"ArchiveArg"|"GetReviewsArg"|"ReviewsArg"|"ReviewArg"|"ContactArg"|"FTPAccountArg"|"SFTPAccountArg"|"DeleteContactArg"|"IncArchiveCounterArg"|"GetMailArg"|"MailArg"|"BlockMailArg"|"EditAnnotationArg"|"PanelsArg"|"SearchKindArg"|"SearchKindResultsArg"|"DeleteMultipleAnnotationsArg"|"GetAnnotationTypesOwnedArgs"|"AnnotationTypesOwnedArgs"|"AnnotationTypesOwnedCountArg"|"RetryArchiveArg"|"ShareArchiveArg"|"ExportAnnotationArg"|"AdminGetUserArg"|"AdminSearchUsersArgs"|"AdminEditUserArg"|"AdminUserArg"|"AdminSearchUsersResultArg"|"AdminLastUsersArg"|"InlineAnnotationsArg"|"TalkAutocompleteNameArg"|"TalkGetPersonArg"|"TalkAutocompleteNameSuggsArgs"|"TalkPersonArg"|"TalkCreateArg"|"TalkEditArg"|"TalkDeleteArg"|"TalksArg"|"GetTalksArg"|"DeleteMultipleTalksArg"|"ExportTalksArg"|"SearchSpeechesArgs"|"SearchSpeechesResultArgs"|"AnnotationDirectArg"|"ExpiringTokenArg"|"SearchWordsArgs"|"SearchWordsResultArgs"|"TalkStudiesArgs"|"TalkProgramTypesArgs"|"TalkDistrictsArgs"|"TalkGetDistrictsArg"|"TalkAllGroupsArg"|"TalkAllRegimsArg"|"TalkAllTitlesArg"|"TalkMediasArg"|"TalkExportedTalksArg"|"SearchSpeechesDateArgs"|"SearchSpeechesDateResultArgs"|"PlayerChunksStatsArg"|"PlayerManifestStatsArg"|"GetMediasSTTArgs"|"STTMediasArg"|"ReportBugArg"|"GetMediasBackgroundArgs"|"BackgroundMediasArg"|"GetMediasCrossBucketArgs"|"CrossBucketMediasArg"|undefined} Arguments
         * @memberof mediaarchiver.WSMessage
         * @instance
         */
        Object.defineProperty(WSMessage.prototype, "Arguments", {
            get: $util.oneOfGetter($oneOfFields = ["ID", "LoginArgs", "MessageAckArgs", "WhoYouAreArgs", "TokenArg", "GetMediasArgs", "MediasArg", "GetEPGArgs", "EPGArgs", "GetChunkArgs", "ChunkArgs", "GetContactsArgs", "ContactsArgs", "ContactsCountArg", "CreateContactArgs", "EditContactArgs", "GetAnnotationTypesArgs", "AnnotationTypesArgs", "AnnotationTypesCountArg", "CreateAnnotationTypeArgs", "EditAnnotationTypeArgs", "DeleteAnnotationTypeArg", "CreateAnnotationArg", "GetStreamArg", "StreamArg", "SearchProgramArgs", "SearchResultsArgs", "GetFTPAccountsArgs", "FTPAccountsArgs", "FTPAccountsCountArg", "CreateFTPAccountArgs", "EditFTPAccountArgs", "DeleteFTPAccountArg", "GetSFTPAccountsArgs", "SFTPAccountsArgs", "SFTPAccountsCountArg", "CreateSFTPAccountArgs", "EditSFTPAccountArgs", "DeleteSFTPAccountArg", "SetAccountOptionsArg", "AnnotationsArg", "GetAnnotationsArg", "DeleteAnnotationArg", "CreateArchiveArg", "GetArchivesArg", "EditArchiveArg", "DeleteArchiveArg", "ArchivesArg", "ArchivesCountArg", "GetArchiveArg", "ArchiveArg", "GetReviewsArg", "ReviewsArg", "ReviewArg", "ContactArg", "FTPAccountArg", "SFTPAccountArg", "DeleteContactArg", "IncArchiveCounterArg", "GetMailArg", "MailArg", "BlockMailArg", "EditAnnotationArg", "PanelsArg", "SearchKindArg", "SearchKindResultsArg", "DeleteMultipleAnnotationsArg", "GetAnnotationTypesOwnedArgs", "AnnotationTypesOwnedArgs", "AnnotationTypesOwnedCountArg", "RetryArchiveArg", "ShareArchiveArg", "ExportAnnotationArg", "AdminGetUserArg", "AdminSearchUsersArgs", "AdminEditUserArg", "AdminUserArg", "AdminSearchUsersResultArg", "AdminLastUsersArg", "InlineAnnotationsArg", "TalkAutocompleteNameArg", "TalkGetPersonArg", "TalkAutocompleteNameSuggsArgs", "TalkPersonArg", "TalkCreateArg", "TalkEditArg", "TalkDeleteArg", "TalksArg", "GetTalksArg", "DeleteMultipleTalksArg", "ExportTalksArg", "SearchSpeechesArgs", "SearchSpeechesResultArgs", "AnnotationDirectArg", "ExpiringTokenArg", "SearchWordsArgs", "SearchWordsResultArgs", "TalkStudiesArgs", "TalkProgramTypesArgs", "TalkDistrictsArgs", "TalkGetDistrictsArg", "TalkAllGroupsArg", "TalkAllRegimsArg", "TalkAllTitlesArg", "TalkMediasArg", "TalkExportedTalksArg", "SearchSpeechesDateArgs", "SearchSpeechesDateResultArgs", "PlayerChunksStatsArg", "PlayerManifestStatsArg", "GetMediasSTTArgs", "STTMediasArg", "ReportBugArg", "GetMediasBackgroundArgs", "BackgroundMediasArg", "GetMediasCrossBucketArgs", "CrossBucketMediasArg"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new WSMessage instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.WSMessage
         * @static
         * @param {mediaarchiver.IWSMessage=} [properties] Properties to set
         * @returns {mediaarchiver.WSMessage} WSMessage instance
         */
        WSMessage.create = function create(properties) {
            return new WSMessage(properties);
        };

        /**
         * Encodes the specified WSMessage message. Does not implicitly {@link mediaarchiver.WSMessage.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.WSMessage
         * @static
         * @param {mediaarchiver.IWSMessage} message WSMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        WSMessage.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Type);
            if (message.MessageID != null && Object.hasOwnProperty.call(message, "MessageID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.MessageID);
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.ID);
            if (message.LoginArgs != null && Object.hasOwnProperty.call(message, "LoginArgs"))
                $root.mediaarchiver.ArgumentsLogin.encode(message.LoginArgs, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
            if (message.MessageAckArgs != null && Object.hasOwnProperty.call(message, "MessageAckArgs"))
                $root.mediaarchiver.ArgumentsMessageAck.encode(message.MessageAckArgs, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
            if (message.WhoYouAreArgs != null && Object.hasOwnProperty.call(message, "WhoYouAreArgs"))
                $root.mediaarchiver.ArgumentsWhoYouAre.encode(message.WhoYouAreArgs, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
            if (message.TokenArg != null && Object.hasOwnProperty.call(message, "TokenArg"))
                writer.uint32(/* id 19, wireType 2 =*/154).string(message.TokenArg);
            if (message.GetMediasArgs != null && Object.hasOwnProperty.call(message, "GetMediasArgs"))
                $root.mediaarchiver.ArgumentsGetMedias.encode(message.GetMediasArgs, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
            if (message.MediasArg != null && Object.hasOwnProperty.call(message, "MediasArg"))
                $root.mediaarchiver.ArgumentsMedias.encode(message.MediasArg, writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
            if (message.GetEPGArgs != null && Object.hasOwnProperty.call(message, "GetEPGArgs"))
                $root.mediaarchiver.ArgumentsGetEPG.encode(message.GetEPGArgs, writer.uint32(/* id 22, wireType 2 =*/178).fork()).ldelim();
            if (message.EPGArgs != null && Object.hasOwnProperty.call(message, "EPGArgs"))
                $root.mediaarchiver.ArgumentsEPG.encode(message.EPGArgs, writer.uint32(/* id 23, wireType 2 =*/186).fork()).ldelim();
            if (message.GetChunkArgs != null && Object.hasOwnProperty.call(message, "GetChunkArgs"))
                $root.mediaarchiver.ArgumentsGetChunk.encode(message.GetChunkArgs, writer.uint32(/* id 24, wireType 2 =*/194).fork()).ldelim();
            if (message.ChunkArgs != null && Object.hasOwnProperty.call(message, "ChunkArgs"))
                $root.mediaarchiver.ArgumentsChunk.encode(message.ChunkArgs, writer.uint32(/* id 25, wireType 2 =*/202).fork()).ldelim();
            if (message.GetContactsArgs != null && Object.hasOwnProperty.call(message, "GetContactsArgs"))
                $root.mediaarchiver.ArgumentsGetContacts.encode(message.GetContactsArgs, writer.uint32(/* id 26, wireType 2 =*/210).fork()).ldelim();
            if (message.ContactsArgs != null && Object.hasOwnProperty.call(message, "ContactsArgs"))
                $root.mediaarchiver.ArgumentsContacts.encode(message.ContactsArgs, writer.uint32(/* id 27, wireType 2 =*/218).fork()).ldelim();
            if (message.ContactsCountArg != null && Object.hasOwnProperty.call(message, "ContactsCountArg"))
                writer.uint32(/* id 28, wireType 0 =*/224).uint32(message.ContactsCountArg);
            if (message.CreateContactArgs != null && Object.hasOwnProperty.call(message, "CreateContactArgs"))
                $root.mediaarchiver.Contact.encode(message.CreateContactArgs, writer.uint32(/* id 29, wireType 2 =*/234).fork()).ldelim();
            if (message.EditContactArgs != null && Object.hasOwnProperty.call(message, "EditContactArgs"))
                $root.mediaarchiver.Contact.encode(message.EditContactArgs, writer.uint32(/* id 30, wireType 2 =*/242).fork()).ldelim();
            if (message.GetAnnotationTypesArgs != null && Object.hasOwnProperty.call(message, "GetAnnotationTypesArgs"))
                $root.mediaarchiver.ArgumentsGetAnnotationTypes.encode(message.GetAnnotationTypesArgs, writer.uint32(/* id 31, wireType 2 =*/250).fork()).ldelim();
            if (message.AnnotationTypesArgs != null && Object.hasOwnProperty.call(message, "AnnotationTypesArgs"))
                $root.mediaarchiver.ArgumentsAnnotationTypes.encode(message.AnnotationTypesArgs, writer.uint32(/* id 32, wireType 2 =*/258).fork()).ldelim();
            if (message.AnnotationTypesCountArg != null && Object.hasOwnProperty.call(message, "AnnotationTypesCountArg"))
                writer.uint32(/* id 33, wireType 0 =*/264).uint32(message.AnnotationTypesCountArg);
            if (message.CreateAnnotationTypeArgs != null && Object.hasOwnProperty.call(message, "CreateAnnotationTypeArgs"))
                $root.mediaarchiver.AnnotationType.encode(message.CreateAnnotationTypeArgs, writer.uint32(/* id 34, wireType 2 =*/274).fork()).ldelim();
            if (message.EditAnnotationTypeArgs != null && Object.hasOwnProperty.call(message, "EditAnnotationTypeArgs"))
                $root.mediaarchiver.AnnotationType.encode(message.EditAnnotationTypeArgs, writer.uint32(/* id 35, wireType 2 =*/282).fork()).ldelim();
            if (message.DeleteAnnotationTypeArg != null && Object.hasOwnProperty.call(message, "DeleteAnnotationTypeArg"))
                writer.uint32(/* id 36, wireType 2 =*/290).string(message.DeleteAnnotationTypeArg);
            if (message.CreateAnnotationArg != null && Object.hasOwnProperty.call(message, "CreateAnnotationArg"))
                $root.mediaarchiver.ArgumentsCreateAnnotation.encode(message.CreateAnnotationArg, writer.uint32(/* id 37, wireType 2 =*/298).fork()).ldelim();
            if (message.GetStreamArg != null && Object.hasOwnProperty.call(message, "GetStreamArg"))
                $root.mediaarchiver.ArgumentsGetStream.encode(message.GetStreamArg, writer.uint32(/* id 38, wireType 2 =*/306).fork()).ldelim();
            if (message.StreamArg != null && Object.hasOwnProperty.call(message, "StreamArg"))
                $root.mediaarchiver.ArgumentsStream.encode(message.StreamArg, writer.uint32(/* id 39, wireType 2 =*/314).fork()).ldelim();
            if (message.SearchProgramArgs != null && Object.hasOwnProperty.call(message, "SearchProgramArgs"))
                $root.mediaarchiver.ArgumentsSearchPrograms.encode(message.SearchProgramArgs, writer.uint32(/* id 40, wireType 2 =*/322).fork()).ldelim();
            if (message.SearchResultsArgs != null && Object.hasOwnProperty.call(message, "SearchResultsArgs"))
                $root.mediaarchiver.ArgumentsSearchResults.encode(message.SearchResultsArgs, writer.uint32(/* id 41, wireType 2 =*/330).fork()).ldelim();
            if (message.GetFTPAccountsArgs != null && Object.hasOwnProperty.call(message, "GetFTPAccountsArgs"))
                $root.mediaarchiver.ArgumentsGetFTPAccounts.encode(message.GetFTPAccountsArgs, writer.uint32(/* id 42, wireType 2 =*/338).fork()).ldelim();
            if (message.FTPAccountsArgs != null && Object.hasOwnProperty.call(message, "FTPAccountsArgs"))
                $root.mediaarchiver.ArgumentsFTPAccounts.encode(message.FTPAccountsArgs, writer.uint32(/* id 43, wireType 2 =*/346).fork()).ldelim();
            if (message.FTPAccountsCountArg != null && Object.hasOwnProperty.call(message, "FTPAccountsCountArg"))
                writer.uint32(/* id 44, wireType 0 =*/352).uint32(message.FTPAccountsCountArg);
            if (message.CreateFTPAccountArgs != null && Object.hasOwnProperty.call(message, "CreateFTPAccountArgs"))
                $root.mediaarchiver.FTPAccount.encode(message.CreateFTPAccountArgs, writer.uint32(/* id 45, wireType 2 =*/362).fork()).ldelim();
            if (message.EditFTPAccountArgs != null && Object.hasOwnProperty.call(message, "EditFTPAccountArgs"))
                $root.mediaarchiver.FTPAccount.encode(message.EditFTPAccountArgs, writer.uint32(/* id 46, wireType 2 =*/370).fork()).ldelim();
            if (message.DeleteFTPAccountArg != null && Object.hasOwnProperty.call(message, "DeleteFTPAccountArg"))
                writer.uint32(/* id 47, wireType 2 =*/378).string(message.DeleteFTPAccountArg);
            if (message.GetSFTPAccountsArgs != null && Object.hasOwnProperty.call(message, "GetSFTPAccountsArgs"))
                $root.mediaarchiver.ArgumentsGetSFTPAccounts.encode(message.GetSFTPAccountsArgs, writer.uint32(/* id 48, wireType 2 =*/386).fork()).ldelim();
            if (message.SFTPAccountsArgs != null && Object.hasOwnProperty.call(message, "SFTPAccountsArgs"))
                $root.mediaarchiver.ArgumentsSFTPAccounts.encode(message.SFTPAccountsArgs, writer.uint32(/* id 49, wireType 2 =*/394).fork()).ldelim();
            if (message.SFTPAccountsCountArg != null && Object.hasOwnProperty.call(message, "SFTPAccountsCountArg"))
                writer.uint32(/* id 50, wireType 0 =*/400).uint32(message.SFTPAccountsCountArg);
            if (message.CreateSFTPAccountArgs != null && Object.hasOwnProperty.call(message, "CreateSFTPAccountArgs"))
                $root.mediaarchiver.SFTPAccount.encode(message.CreateSFTPAccountArgs, writer.uint32(/* id 51, wireType 2 =*/410).fork()).ldelim();
            if (message.EditSFTPAccountArgs != null && Object.hasOwnProperty.call(message, "EditSFTPAccountArgs"))
                $root.mediaarchiver.SFTPAccount.encode(message.EditSFTPAccountArgs, writer.uint32(/* id 52, wireType 2 =*/418).fork()).ldelim();
            if (message.DeleteSFTPAccountArg != null && Object.hasOwnProperty.call(message, "DeleteSFTPAccountArg"))
                writer.uint32(/* id 53, wireType 2 =*/426).string(message.DeleteSFTPAccountArg);
            if (message.SetAccountOptionsArg != null && Object.hasOwnProperty.call(message, "SetAccountOptionsArg"))
                $root.mediaarchiver.UserOptionsList.encode(message.SetAccountOptionsArg, writer.uint32(/* id 54, wireType 2 =*/434).fork()).ldelim();
            if (message.AnnotationsArg != null && Object.hasOwnProperty.call(message, "AnnotationsArg"))
                $root.mediaarchiver.ArgumentsAnnotations.encode(message.AnnotationsArg, writer.uint32(/* id 55, wireType 2 =*/442).fork()).ldelim();
            if (message.GetAnnotationsArg != null && Object.hasOwnProperty.call(message, "GetAnnotationsArg"))
                $root.mediaarchiver.ArgumentsGetAnnotations.encode(message.GetAnnotationsArg, writer.uint32(/* id 56, wireType 2 =*/450).fork()).ldelim();
            if (message.DeleteAnnotationArg != null && Object.hasOwnProperty.call(message, "DeleteAnnotationArg"))
                $root.mediaarchiver.ArgumentsDeleteAnnotation.encode(message.DeleteAnnotationArg, writer.uint32(/* id 57, wireType 2 =*/458).fork()).ldelim();
            if (message.CreateArchiveArg != null && Object.hasOwnProperty.call(message, "CreateArchiveArg"))
                $root.mediaarchiver.Archive.encode(message.CreateArchiveArg, writer.uint32(/* id 58, wireType 2 =*/466).fork()).ldelim();
            if (message.GetArchivesArg != null && Object.hasOwnProperty.call(message, "GetArchivesArg"))
                $root.mediaarchiver.ArgumentsGetArchives.encode(message.GetArchivesArg, writer.uint32(/* id 59, wireType 2 =*/474).fork()).ldelim();
            if (message.EditArchiveArg != null && Object.hasOwnProperty.call(message, "EditArchiveArg"))
                $root.mediaarchiver.Archive.encode(message.EditArchiveArg, writer.uint32(/* id 60, wireType 2 =*/482).fork()).ldelim();
            if (message.DeleteArchiveArg != null && Object.hasOwnProperty.call(message, "DeleteArchiveArg"))
                writer.uint32(/* id 61, wireType 2 =*/490).string(message.DeleteArchiveArg);
            if (message.ArchivesArg != null && Object.hasOwnProperty.call(message, "ArchivesArg"))
                $root.mediaarchiver.ArgumentsArchives.encode(message.ArchivesArg, writer.uint32(/* id 62, wireType 2 =*/498).fork()).ldelim();
            if (message.ArchivesCountArg != null && Object.hasOwnProperty.call(message, "ArchivesCountArg"))
                $root.mediaarchiver.ArgumentsArchivesCount.encode(message.ArchivesCountArg, writer.uint32(/* id 63, wireType 2 =*/506).fork()).ldelim();
            if (message.GetArchiveArg != null && Object.hasOwnProperty.call(message, "GetArchiveArg"))
                writer.uint32(/* id 64, wireType 2 =*/514).string(message.GetArchiveArg);
            if (message.ArchiveArg != null && Object.hasOwnProperty.call(message, "ArchiveArg"))
                $root.mediaarchiver.Archive.encode(message.ArchiveArg, writer.uint32(/* id 65, wireType 2 =*/522).fork()).ldelim();
            if (message.GetReviewsArg != null && Object.hasOwnProperty.call(message, "GetReviewsArg"))
                $root.mediaarchiver.ArgumentsGetReviews.encode(message.GetReviewsArg, writer.uint32(/* id 66, wireType 2 =*/530).fork()).ldelim();
            if (message.ReviewsArg != null && Object.hasOwnProperty.call(message, "ReviewsArg"))
                $root.mediaarchiver.ArgumentsReviews.encode(message.ReviewsArg, writer.uint32(/* id 67, wireType 2 =*/538).fork()).ldelim();
            if (message.ReviewArg != null && Object.hasOwnProperty.call(message, "ReviewArg"))
                $root.mediaarchiver.Review.encode(message.ReviewArg, writer.uint32(/* id 68, wireType 2 =*/546).fork()).ldelim();
            if (message.ContactArg != null && Object.hasOwnProperty.call(message, "ContactArg"))
                $root.mediaarchiver.Contact.encode(message.ContactArg, writer.uint32(/* id 69, wireType 2 =*/554).fork()).ldelim();
            if (message.FTPAccountArg != null && Object.hasOwnProperty.call(message, "FTPAccountArg"))
                $root.mediaarchiver.FTPAccount.encode(message.FTPAccountArg, writer.uint32(/* id 70, wireType 2 =*/562).fork()).ldelim();
            if (message.SFTPAccountArg != null && Object.hasOwnProperty.call(message, "SFTPAccountArg"))
                $root.mediaarchiver.SFTPAccount.encode(message.SFTPAccountArg, writer.uint32(/* id 71, wireType 2 =*/570).fork()).ldelim();
            if (message.DeleteContactArg != null && Object.hasOwnProperty.call(message, "DeleteContactArg"))
                writer.uint32(/* id 72, wireType 2 =*/578).string(message.DeleteContactArg);
            if (message.IncArchiveCounterArg != null && Object.hasOwnProperty.call(message, "IncArchiveCounterArg"))
                $root.mediaarchiver.ArgumentsIncArchiveCounter.encode(message.IncArchiveCounterArg, writer.uint32(/* id 73, wireType 2 =*/586).fork()).ldelim();
            if (message.GetMailArg != null && Object.hasOwnProperty.call(message, "GetMailArg"))
                writer.uint32(/* id 74, wireType 2 =*/594).string(message.GetMailArg);
            if (message.MailArg != null && Object.hasOwnProperty.call(message, "MailArg"))
                writer.uint32(/* id 75, wireType 2 =*/602).string(message.MailArg);
            if (message.BlockMailArg != null && Object.hasOwnProperty.call(message, "BlockMailArg"))
                $root.mediaarchiver.ArgumentsBlockMail.encode(message.BlockMailArg, writer.uint32(/* id 76, wireType 2 =*/610).fork()).ldelim();
            if (message.EditAnnotationArg != null && Object.hasOwnProperty.call(message, "EditAnnotationArg"))
                $root.mediaarchiver.Annotation.encode(message.EditAnnotationArg, writer.uint32(/* id 77, wireType 2 =*/618).fork()).ldelim();
            if (message.PanelsArg != null && Object.hasOwnProperty.call(message, "PanelsArg"))
                $root.mediaarchiver.Panels.encode(message.PanelsArg, writer.uint32(/* id 78, wireType 2 =*/626).fork()).ldelim();
            if (message.SearchKindArg != null && Object.hasOwnProperty.call(message, "SearchKindArg"))
                writer.uint32(/* id 79, wireType 2 =*/634).string(message.SearchKindArg);
            if (message.SearchKindResultsArg != null && Object.hasOwnProperty.call(message, "SearchKindResultsArg"))
                $root.mediaarchiver.SearchKindResult.encode(message.SearchKindResultsArg, writer.uint32(/* id 80, wireType 2 =*/642).fork()).ldelim();
            if (message.DeleteMultipleAnnotationsArg != null && Object.hasOwnProperty.call(message, "DeleteMultipleAnnotationsArg"))
                $root.mediaarchiver.MultipleIDs.encode(message.DeleteMultipleAnnotationsArg, writer.uint32(/* id 81, wireType 2 =*/650).fork()).ldelim();
            if (message.GetAnnotationTypesOwnedArgs != null && Object.hasOwnProperty.call(message, "GetAnnotationTypesOwnedArgs"))
                $root.mediaarchiver.ArgumentsGetAnnotationTypes.encode(message.GetAnnotationTypesOwnedArgs, writer.uint32(/* id 82, wireType 2 =*/658).fork()).ldelim();
            if (message.AnnotationTypesOwnedArgs != null && Object.hasOwnProperty.call(message, "AnnotationTypesOwnedArgs"))
                $root.mediaarchiver.ArgumentsAnnotationTypes.encode(message.AnnotationTypesOwnedArgs, writer.uint32(/* id 83, wireType 2 =*/666).fork()).ldelim();
            if (message.AnnotationTypesOwnedCountArg != null && Object.hasOwnProperty.call(message, "AnnotationTypesOwnedCountArg"))
                writer.uint32(/* id 84, wireType 0 =*/672).uint32(message.AnnotationTypesOwnedCountArg);
            if (message.RetryArchiveArg != null && Object.hasOwnProperty.call(message, "RetryArchiveArg"))
                writer.uint32(/* id 85, wireType 2 =*/682).string(message.RetryArchiveArg);
            if (message.ShareArchiveArg != null && Object.hasOwnProperty.call(message, "ShareArchiveArg"))
                $root.mediaarchiver.ArgumentsShareArchive.encode(message.ShareArchiveArg, writer.uint32(/* id 86, wireType 2 =*/690).fork()).ldelim();
            if (message.ExportAnnotationArg != null && Object.hasOwnProperty.call(message, "ExportAnnotationArg"))
                $root.mediaarchiver.ArgumentsExportAnnotations.encode(message.ExportAnnotationArg, writer.uint32(/* id 87, wireType 2 =*/698).fork()).ldelim();
            if (message.AdminGetUserArg != null && Object.hasOwnProperty.call(message, "AdminGetUserArg"))
                writer.uint32(/* id 88, wireType 0 =*/704).uint32(message.AdminGetUserArg);
            if (message.AdminSearchUsersArgs != null && Object.hasOwnProperty.call(message, "AdminSearchUsersArgs"))
                $root.mediaarchiver.AdminSearchUsers.encode(message.AdminSearchUsersArgs, writer.uint32(/* id 89, wireType 2 =*/714).fork()).ldelim();
            if (message.AdminEditUserArg != null && Object.hasOwnProperty.call(message, "AdminEditUserArg"))
                $root.mediaarchiver.AdminUser.encode(message.AdminEditUserArg, writer.uint32(/* id 90, wireType 2 =*/722).fork()).ldelim();
            if (message.AdminUserArg != null && Object.hasOwnProperty.call(message, "AdminUserArg"))
                $root.mediaarchiver.AdminUser.encode(message.AdminUserArg, writer.uint32(/* id 91, wireType 2 =*/730).fork()).ldelim();
            if (message.AdminSearchUsersResultArg != null && Object.hasOwnProperty.call(message, "AdminSearchUsersResultArg"))
                $root.mediaarchiver.AdminUsers.encode(message.AdminSearchUsersResultArg, writer.uint32(/* id 92, wireType 2 =*/738).fork()).ldelim();
            if (message.AdminLastUsersArg != null && Object.hasOwnProperty.call(message, "AdminLastUsersArg"))
                $root.mediaarchiver.AdminUsers.encode(message.AdminLastUsersArg, writer.uint32(/* id 93, wireType 2 =*/746).fork()).ldelim();
            if (message.InlineAnnotationsArg != null && Object.hasOwnProperty.call(message, "InlineAnnotationsArg"))
                writer.uint32(/* id 94, wireType 2 =*/754).string(message.InlineAnnotationsArg);
            if (message.TalkAutocompleteNameArg != null && Object.hasOwnProperty.call(message, "TalkAutocompleteNameArg"))
                $root.mediaarchiver.TalkAutocompleteName.encode(message.TalkAutocompleteNameArg, writer.uint32(/* id 96, wireType 2 =*/770).fork()).ldelim();
            if (message.TalkGetPersonArg != null && Object.hasOwnProperty.call(message, "TalkGetPersonArg"))
                writer.uint32(/* id 97, wireType 2 =*/778).string(message.TalkGetPersonArg);
            if (message.TalkAutocompleteNameSuggsArgs != null && Object.hasOwnProperty.call(message, "TalkAutocompleteNameSuggsArgs"))
                $root.mediaarchiver.TalkPersonSuggs.encode(message.TalkAutocompleteNameSuggsArgs, writer.uint32(/* id 98, wireType 2 =*/786).fork()).ldelim();
            if (message.TalkPersonArg != null && Object.hasOwnProperty.call(message, "TalkPersonArg"))
                $root.mediaarchiver.TalkPerson.encode(message.TalkPersonArg, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
            if (message.TalkCreateArg != null && Object.hasOwnProperty.call(message, "TalkCreateArg"))
                $root.mediaarchiver.Talk.encode(message.TalkCreateArg, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
            if (message.TalkEditArg != null && Object.hasOwnProperty.call(message, "TalkEditArg"))
                $root.mediaarchiver.Talk.encode(message.TalkEditArg, writer.uint32(/* id 101, wireType 2 =*/810).fork()).ldelim();
            if (message.TalkDeleteArg != null && Object.hasOwnProperty.call(message, "TalkDeleteArg"))
                writer.uint32(/* id 102, wireType 2 =*/818).string(message.TalkDeleteArg);
            if (message.TalksArg != null && Object.hasOwnProperty.call(message, "TalksArg"))
                $root.mediaarchiver.ArgumentsTalks.encode(message.TalksArg, writer.uint32(/* id 103, wireType 2 =*/826).fork()).ldelim();
            if (message.GetTalksArg != null && Object.hasOwnProperty.call(message, "GetTalksArg"))
                $root.mediaarchiver.ArgumentsGetTalks.encode(message.GetTalksArg, writer.uint32(/* id 104, wireType 2 =*/834).fork()).ldelim();
            if (message.DeleteMultipleTalksArg != null && Object.hasOwnProperty.call(message, "DeleteMultipleTalksArg"))
                $root.mediaarchiver.MultipleIDs.encode(message.DeleteMultipleTalksArg, writer.uint32(/* id 105, wireType 2 =*/842).fork()).ldelim();
            if (message.ExportTalksArg != null && Object.hasOwnProperty.call(message, "ExportTalksArg"))
                $root.mediaarchiver.ArgumentsExportTalks.encode(message.ExportTalksArg, writer.uint32(/* id 106, wireType 2 =*/850).fork()).ldelim();
            if (message.SearchSpeechesArgs != null && Object.hasOwnProperty.call(message, "SearchSpeechesArgs"))
                $root.mediaarchiver.SearchSpeeches.encode(message.SearchSpeechesArgs, writer.uint32(/* id 107, wireType 2 =*/858).fork()).ldelim();
            if (message.SearchSpeechesResultArgs != null && Object.hasOwnProperty.call(message, "SearchSpeechesResultArgs"))
                $root.mediaarchiver.SearchSpeechesResult.encode(message.SearchSpeechesResultArgs, writer.uint32(/* id 108, wireType 2 =*/866).fork()).ldelim();
            if (message.AnnotationDirectArg != null && Object.hasOwnProperty.call(message, "AnnotationDirectArg"))
                writer.uint32(/* id 109, wireType 2 =*/874).string(message.AnnotationDirectArg);
            if (message.ExpiringTokenArg != null && Object.hasOwnProperty.call(message, "ExpiringTokenArg"))
                $root.mediaarchiver.ExpiringToken.encode(message.ExpiringTokenArg, writer.uint32(/* id 110, wireType 2 =*/882).fork()).ldelim();
            if (message.SearchWordsArgs != null && Object.hasOwnProperty.call(message, "SearchWordsArgs"))
                $root.mediaarchiver.SearchWords.encode(message.SearchWordsArgs, writer.uint32(/* id 111, wireType 2 =*/890).fork()).ldelim();
            if (message.SearchWordsResultArgs != null && Object.hasOwnProperty.call(message, "SearchWordsResultArgs"))
                $root.mediaarchiver.SearchWordsResult.encode(message.SearchWordsResultArgs, writer.uint32(/* id 112, wireType 2 =*/898).fork()).ldelim();
            if (message.TalkStudiesArgs != null && Object.hasOwnProperty.call(message, "TalkStudiesArgs"))
                $root.mediaarchiver.TalkStudies.encode(message.TalkStudiesArgs, writer.uint32(/* id 113, wireType 2 =*/906).fork()).ldelim();
            if (message.TalkProgramTypesArgs != null && Object.hasOwnProperty.call(message, "TalkProgramTypesArgs"))
                $root.mediaarchiver.TalkProgramTypes.encode(message.TalkProgramTypesArgs, writer.uint32(/* id 114, wireType 2 =*/914).fork()).ldelim();
            if (message.TalkDistrictsArgs != null && Object.hasOwnProperty.call(message, "TalkDistrictsArgs"))
                $root.mediaarchiver.TalkDistricts.encode(message.TalkDistrictsArgs, writer.uint32(/* id 115, wireType 2 =*/922).fork()).ldelim();
            if (message.TalkGetDistrictsArg != null && Object.hasOwnProperty.call(message, "TalkGetDistrictsArg"))
                $root.mediaarchiver.TalkGetDistricts.encode(message.TalkGetDistrictsArg, writer.uint32(/* id 116, wireType 2 =*/930).fork()).ldelim();
            if (message.TalkAllGroupsArg != null && Object.hasOwnProperty.call(message, "TalkAllGroupsArg"))
                $root.mediaarchiver.TalkGroups.encode(message.TalkAllGroupsArg, writer.uint32(/* id 117, wireType 2 =*/938).fork()).ldelim();
            if (message.TalkAllRegimsArg != null && Object.hasOwnProperty.call(message, "TalkAllRegimsArg"))
                $root.mediaarchiver.TalkRegims.encode(message.TalkAllRegimsArg, writer.uint32(/* id 118, wireType 2 =*/946).fork()).ldelim();
            if (message.TalkAllTitlesArg != null && Object.hasOwnProperty.call(message, "TalkAllTitlesArg"))
                $root.mediaarchiver.TalkTitles.encode(message.TalkAllTitlesArg, writer.uint32(/* id 119, wireType 2 =*/954).fork()).ldelim();
            if (message.TalkMediasArg != null && Object.hasOwnProperty.call(message, "TalkMediasArg"))
                $root.mediaarchiver.MediaList.encode(message.TalkMediasArg, writer.uint32(/* id 120, wireType 2 =*/962).fork()).ldelim();
            if (message.TalkExportedTalksArg != null && Object.hasOwnProperty.call(message, "TalkExportedTalksArg"))
                writer.uint32(/* id 121, wireType 2 =*/970).string(message.TalkExportedTalksArg);
            if (message.SearchSpeechesDateArgs != null && Object.hasOwnProperty.call(message, "SearchSpeechesDateArgs"))
                $root.mediaarchiver.SearchSpeechesDate.encode(message.SearchSpeechesDateArgs, writer.uint32(/* id 122, wireType 2 =*/978).fork()).ldelim();
            if (message.SearchSpeechesDateResultArgs != null && Object.hasOwnProperty.call(message, "SearchSpeechesDateResultArgs"))
                $root.mediaarchiver.SearchSpeechesDateResult.encode(message.SearchSpeechesDateResultArgs, writer.uint32(/* id 123, wireType 2 =*/986).fork()).ldelim();
            if (message.PlayerChunksStatsArg != null && Object.hasOwnProperty.call(message, "PlayerChunksStatsArg"))
                $root.mediaarchiver.PlayerStatsChunks.encode(message.PlayerChunksStatsArg, writer.uint32(/* id 124, wireType 2 =*/994).fork()).ldelim();
            if (message.PlayerManifestStatsArg != null && Object.hasOwnProperty.call(message, "PlayerManifestStatsArg"))
                $root.mediaarchiver.PlayerStatsManifest.encode(message.PlayerManifestStatsArg, writer.uint32(/* id 125, wireType 2 =*/1002).fork()).ldelim();
            if (message.GetMediasSTTArgs != null && Object.hasOwnProperty.call(message, "GetMediasSTTArgs"))
                $root.mediaarchiver.ArgumentsGetMediasSTT.encode(message.GetMediasSTTArgs, writer.uint32(/* id 126, wireType 2 =*/1010).fork()).ldelim();
            if (message.STTMediasArg != null && Object.hasOwnProperty.call(message, "STTMediasArg"))
                $root.mediaarchiver.MediaList.encode(message.STTMediasArg, writer.uint32(/* id 127, wireType 2 =*/1018).fork()).ldelim();
            if (message.ReportBugArg != null && Object.hasOwnProperty.call(message, "ReportBugArg"))
                $root.mediaarchiver.ReportedBug.encode(message.ReportBugArg, writer.uint32(/* id 128, wireType 2 =*/1026).fork()).ldelim();
            if (message.GetMediasBackgroundArgs != null && Object.hasOwnProperty.call(message, "GetMediasBackgroundArgs"))
                $root.mediaarchiver.ArgumentsGetMediasBackground.encode(message.GetMediasBackgroundArgs, writer.uint32(/* id 129, wireType 2 =*/1034).fork()).ldelim();
            if (message.BackgroundMediasArg != null && Object.hasOwnProperty.call(message, "BackgroundMediasArg"))
                $root.mediaarchiver.MediaList.encode(message.BackgroundMediasArg, writer.uint32(/* id 130, wireType 2 =*/1042).fork()).ldelim();
            if (message.GetMediasCrossBucketArgs != null && Object.hasOwnProperty.call(message, "GetMediasCrossBucketArgs"))
                $root.mediaarchiver.ArgumentsGetMediasCrossBucket.encode(message.GetMediasCrossBucketArgs, writer.uint32(/* id 131, wireType 2 =*/1050).fork()).ldelim();
            if (message.CrossBucketMediasArg != null && Object.hasOwnProperty.call(message, "CrossBucketMediasArg"))
                $root.mediaarchiver.MediaList.encode(message.CrossBucketMediasArg, writer.uint32(/* id 132, wireType 2 =*/1058).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified WSMessage message, length delimited. Does not implicitly {@link mediaarchiver.WSMessage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.WSMessage
         * @static
         * @param {mediaarchiver.IWSMessage} message WSMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        WSMessage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a WSMessage message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.WSMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.WSMessage} WSMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        WSMessage.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.WSMessage();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Type = reader.int32();
                    break;
                case 2:
                    message.MessageID = reader.string();
                    break;
                case 3:
                    message.ID = reader.string();
                    break;
                case 16:
                    message.LoginArgs = $root.mediaarchiver.ArgumentsLogin.decode(reader, reader.uint32());
                    break;
                case 17:
                    message.MessageAckArgs = $root.mediaarchiver.ArgumentsMessageAck.decode(reader, reader.uint32());
                    break;
                case 18:
                    message.WhoYouAreArgs = $root.mediaarchiver.ArgumentsWhoYouAre.decode(reader, reader.uint32());
                    break;
                case 19:
                    message.TokenArg = reader.string();
                    break;
                case 20:
                    message.GetMediasArgs = $root.mediaarchiver.ArgumentsGetMedias.decode(reader, reader.uint32());
                    break;
                case 21:
                    message.MediasArg = $root.mediaarchiver.ArgumentsMedias.decode(reader, reader.uint32());
                    break;
                case 22:
                    message.GetEPGArgs = $root.mediaarchiver.ArgumentsGetEPG.decode(reader, reader.uint32());
                    break;
                case 23:
                    message.EPGArgs = $root.mediaarchiver.ArgumentsEPG.decode(reader, reader.uint32());
                    break;
                case 24:
                    message.GetChunkArgs = $root.mediaarchiver.ArgumentsGetChunk.decode(reader, reader.uint32());
                    break;
                case 25:
                    message.ChunkArgs = $root.mediaarchiver.ArgumentsChunk.decode(reader, reader.uint32());
                    break;
                case 26:
                    message.GetContactsArgs = $root.mediaarchiver.ArgumentsGetContacts.decode(reader, reader.uint32());
                    break;
                case 27:
                    message.ContactsArgs = $root.mediaarchiver.ArgumentsContacts.decode(reader, reader.uint32());
                    break;
                case 28:
                    message.ContactsCountArg = reader.uint32();
                    break;
                case 29:
                    message.CreateContactArgs = $root.mediaarchiver.Contact.decode(reader, reader.uint32());
                    break;
                case 30:
                    message.EditContactArgs = $root.mediaarchiver.Contact.decode(reader, reader.uint32());
                    break;
                case 31:
                    message.GetAnnotationTypesArgs = $root.mediaarchiver.ArgumentsGetAnnotationTypes.decode(reader, reader.uint32());
                    break;
                case 32:
                    message.AnnotationTypesArgs = $root.mediaarchiver.ArgumentsAnnotationTypes.decode(reader, reader.uint32());
                    break;
                case 33:
                    message.AnnotationTypesCountArg = reader.uint32();
                    break;
                case 34:
                    message.CreateAnnotationTypeArgs = $root.mediaarchiver.AnnotationType.decode(reader, reader.uint32());
                    break;
                case 35:
                    message.EditAnnotationTypeArgs = $root.mediaarchiver.AnnotationType.decode(reader, reader.uint32());
                    break;
                case 36:
                    message.DeleteAnnotationTypeArg = reader.string();
                    break;
                case 37:
                    message.CreateAnnotationArg = $root.mediaarchiver.ArgumentsCreateAnnotation.decode(reader, reader.uint32());
                    break;
                case 38:
                    message.GetStreamArg = $root.mediaarchiver.ArgumentsGetStream.decode(reader, reader.uint32());
                    break;
                case 39:
                    message.StreamArg = $root.mediaarchiver.ArgumentsStream.decode(reader, reader.uint32());
                    break;
                case 40:
                    message.SearchProgramArgs = $root.mediaarchiver.ArgumentsSearchPrograms.decode(reader, reader.uint32());
                    break;
                case 41:
                    message.SearchResultsArgs = $root.mediaarchiver.ArgumentsSearchResults.decode(reader, reader.uint32());
                    break;
                case 42:
                    message.GetFTPAccountsArgs = $root.mediaarchiver.ArgumentsGetFTPAccounts.decode(reader, reader.uint32());
                    break;
                case 43:
                    message.FTPAccountsArgs = $root.mediaarchiver.ArgumentsFTPAccounts.decode(reader, reader.uint32());
                    break;
                case 44:
                    message.FTPAccountsCountArg = reader.uint32();
                    break;
                case 45:
                    message.CreateFTPAccountArgs = $root.mediaarchiver.FTPAccount.decode(reader, reader.uint32());
                    break;
                case 46:
                    message.EditFTPAccountArgs = $root.mediaarchiver.FTPAccount.decode(reader, reader.uint32());
                    break;
                case 47:
                    message.DeleteFTPAccountArg = reader.string();
                    break;
                case 48:
                    message.GetSFTPAccountsArgs = $root.mediaarchiver.ArgumentsGetSFTPAccounts.decode(reader, reader.uint32());
                    break;
                case 49:
                    message.SFTPAccountsArgs = $root.mediaarchiver.ArgumentsSFTPAccounts.decode(reader, reader.uint32());
                    break;
                case 50:
                    message.SFTPAccountsCountArg = reader.uint32();
                    break;
                case 51:
                    message.CreateSFTPAccountArgs = $root.mediaarchiver.SFTPAccount.decode(reader, reader.uint32());
                    break;
                case 52:
                    message.EditSFTPAccountArgs = $root.mediaarchiver.SFTPAccount.decode(reader, reader.uint32());
                    break;
                case 53:
                    message.DeleteSFTPAccountArg = reader.string();
                    break;
                case 54:
                    message.SetAccountOptionsArg = $root.mediaarchiver.UserOptionsList.decode(reader, reader.uint32());
                    break;
                case 55:
                    message.AnnotationsArg = $root.mediaarchiver.ArgumentsAnnotations.decode(reader, reader.uint32());
                    break;
                case 56:
                    message.GetAnnotationsArg = $root.mediaarchiver.ArgumentsGetAnnotations.decode(reader, reader.uint32());
                    break;
                case 57:
                    message.DeleteAnnotationArg = $root.mediaarchiver.ArgumentsDeleteAnnotation.decode(reader, reader.uint32());
                    break;
                case 58:
                    message.CreateArchiveArg = $root.mediaarchiver.Archive.decode(reader, reader.uint32());
                    break;
                case 59:
                    message.GetArchivesArg = $root.mediaarchiver.ArgumentsGetArchives.decode(reader, reader.uint32());
                    break;
                case 60:
                    message.EditArchiveArg = $root.mediaarchiver.Archive.decode(reader, reader.uint32());
                    break;
                case 61:
                    message.DeleteArchiveArg = reader.string();
                    break;
                case 62:
                    message.ArchivesArg = $root.mediaarchiver.ArgumentsArchives.decode(reader, reader.uint32());
                    break;
                case 63:
                    message.ArchivesCountArg = $root.mediaarchiver.ArgumentsArchivesCount.decode(reader, reader.uint32());
                    break;
                case 64:
                    message.GetArchiveArg = reader.string();
                    break;
                case 65:
                    message.ArchiveArg = $root.mediaarchiver.Archive.decode(reader, reader.uint32());
                    break;
                case 66:
                    message.GetReviewsArg = $root.mediaarchiver.ArgumentsGetReviews.decode(reader, reader.uint32());
                    break;
                case 67:
                    message.ReviewsArg = $root.mediaarchiver.ArgumentsReviews.decode(reader, reader.uint32());
                    break;
                case 68:
                    message.ReviewArg = $root.mediaarchiver.Review.decode(reader, reader.uint32());
                    break;
                case 69:
                    message.ContactArg = $root.mediaarchiver.Contact.decode(reader, reader.uint32());
                    break;
                case 70:
                    message.FTPAccountArg = $root.mediaarchiver.FTPAccount.decode(reader, reader.uint32());
                    break;
                case 71:
                    message.SFTPAccountArg = $root.mediaarchiver.SFTPAccount.decode(reader, reader.uint32());
                    break;
                case 72:
                    message.DeleteContactArg = reader.string();
                    break;
                case 73:
                    message.IncArchiveCounterArg = $root.mediaarchiver.ArgumentsIncArchiveCounter.decode(reader, reader.uint32());
                    break;
                case 74:
                    message.GetMailArg = reader.string();
                    break;
                case 75:
                    message.MailArg = reader.string();
                    break;
                case 76:
                    message.BlockMailArg = $root.mediaarchiver.ArgumentsBlockMail.decode(reader, reader.uint32());
                    break;
                case 77:
                    message.EditAnnotationArg = $root.mediaarchiver.Annotation.decode(reader, reader.uint32());
                    break;
                case 78:
                    message.PanelsArg = $root.mediaarchiver.Panels.decode(reader, reader.uint32());
                    break;
                case 79:
                    message.SearchKindArg = reader.string();
                    break;
                case 80:
                    message.SearchKindResultsArg = $root.mediaarchiver.SearchKindResult.decode(reader, reader.uint32());
                    break;
                case 81:
                    message.DeleteMultipleAnnotationsArg = $root.mediaarchiver.MultipleIDs.decode(reader, reader.uint32());
                    break;
                case 82:
                    message.GetAnnotationTypesOwnedArgs = $root.mediaarchiver.ArgumentsGetAnnotationTypes.decode(reader, reader.uint32());
                    break;
                case 83:
                    message.AnnotationTypesOwnedArgs = $root.mediaarchiver.ArgumentsAnnotationTypes.decode(reader, reader.uint32());
                    break;
                case 84:
                    message.AnnotationTypesOwnedCountArg = reader.uint32();
                    break;
                case 85:
                    message.RetryArchiveArg = reader.string();
                    break;
                case 86:
                    message.ShareArchiveArg = $root.mediaarchiver.ArgumentsShareArchive.decode(reader, reader.uint32());
                    break;
                case 87:
                    message.ExportAnnotationArg = $root.mediaarchiver.ArgumentsExportAnnotations.decode(reader, reader.uint32());
                    break;
                case 88:
                    message.AdminGetUserArg = reader.uint32();
                    break;
                case 89:
                    message.AdminSearchUsersArgs = $root.mediaarchiver.AdminSearchUsers.decode(reader, reader.uint32());
                    break;
                case 90:
                    message.AdminEditUserArg = $root.mediaarchiver.AdminUser.decode(reader, reader.uint32());
                    break;
                case 91:
                    message.AdminUserArg = $root.mediaarchiver.AdminUser.decode(reader, reader.uint32());
                    break;
                case 92:
                    message.AdminSearchUsersResultArg = $root.mediaarchiver.AdminUsers.decode(reader, reader.uint32());
                    break;
                case 93:
                    message.AdminLastUsersArg = $root.mediaarchiver.AdminUsers.decode(reader, reader.uint32());
                    break;
                case 94:
                    message.InlineAnnotationsArg = reader.string();
                    break;
                case 96:
                    message.TalkAutocompleteNameArg = $root.mediaarchiver.TalkAutocompleteName.decode(reader, reader.uint32());
                    break;
                case 97:
                    message.TalkGetPersonArg = reader.string();
                    break;
                case 98:
                    message.TalkAutocompleteNameSuggsArgs = $root.mediaarchiver.TalkPersonSuggs.decode(reader, reader.uint32());
                    break;
                case 99:
                    message.TalkPersonArg = $root.mediaarchiver.TalkPerson.decode(reader, reader.uint32());
                    break;
                case 100:
                    message.TalkCreateArg = $root.mediaarchiver.Talk.decode(reader, reader.uint32());
                    break;
                case 101:
                    message.TalkEditArg = $root.mediaarchiver.Talk.decode(reader, reader.uint32());
                    break;
                case 102:
                    message.TalkDeleteArg = reader.string();
                    break;
                case 103:
                    message.TalksArg = $root.mediaarchiver.ArgumentsTalks.decode(reader, reader.uint32());
                    break;
                case 104:
                    message.GetTalksArg = $root.mediaarchiver.ArgumentsGetTalks.decode(reader, reader.uint32());
                    break;
                case 105:
                    message.DeleteMultipleTalksArg = $root.mediaarchiver.MultipleIDs.decode(reader, reader.uint32());
                    break;
                case 106:
                    message.ExportTalksArg = $root.mediaarchiver.ArgumentsExportTalks.decode(reader, reader.uint32());
                    break;
                case 107:
                    message.SearchSpeechesArgs = $root.mediaarchiver.SearchSpeeches.decode(reader, reader.uint32());
                    break;
                case 108:
                    message.SearchSpeechesResultArgs = $root.mediaarchiver.SearchSpeechesResult.decode(reader, reader.uint32());
                    break;
                case 109:
                    message.AnnotationDirectArg = reader.string();
                    break;
                case 110:
                    message.ExpiringTokenArg = $root.mediaarchiver.ExpiringToken.decode(reader, reader.uint32());
                    break;
                case 111:
                    message.SearchWordsArgs = $root.mediaarchiver.SearchWords.decode(reader, reader.uint32());
                    break;
                case 112:
                    message.SearchWordsResultArgs = $root.mediaarchiver.SearchWordsResult.decode(reader, reader.uint32());
                    break;
                case 113:
                    message.TalkStudiesArgs = $root.mediaarchiver.TalkStudies.decode(reader, reader.uint32());
                    break;
                case 114:
                    message.TalkProgramTypesArgs = $root.mediaarchiver.TalkProgramTypes.decode(reader, reader.uint32());
                    break;
                case 115:
                    message.TalkDistrictsArgs = $root.mediaarchiver.TalkDistricts.decode(reader, reader.uint32());
                    break;
                case 116:
                    message.TalkGetDistrictsArg = $root.mediaarchiver.TalkGetDistricts.decode(reader, reader.uint32());
                    break;
                case 117:
                    message.TalkAllGroupsArg = $root.mediaarchiver.TalkGroups.decode(reader, reader.uint32());
                    break;
                case 118:
                    message.TalkAllRegimsArg = $root.mediaarchiver.TalkRegims.decode(reader, reader.uint32());
                    break;
                case 119:
                    message.TalkAllTitlesArg = $root.mediaarchiver.TalkTitles.decode(reader, reader.uint32());
                    break;
                case 120:
                    message.TalkMediasArg = $root.mediaarchiver.MediaList.decode(reader, reader.uint32());
                    break;
                case 121:
                    message.TalkExportedTalksArg = reader.string();
                    break;
                case 122:
                    message.SearchSpeechesDateArgs = $root.mediaarchiver.SearchSpeechesDate.decode(reader, reader.uint32());
                    break;
                case 123:
                    message.SearchSpeechesDateResultArgs = $root.mediaarchiver.SearchSpeechesDateResult.decode(reader, reader.uint32());
                    break;
                case 124:
                    message.PlayerChunksStatsArg = $root.mediaarchiver.PlayerStatsChunks.decode(reader, reader.uint32());
                    break;
                case 125:
                    message.PlayerManifestStatsArg = $root.mediaarchiver.PlayerStatsManifest.decode(reader, reader.uint32());
                    break;
                case 126:
                    message.GetMediasSTTArgs = $root.mediaarchiver.ArgumentsGetMediasSTT.decode(reader, reader.uint32());
                    break;
                case 127:
                    message.STTMediasArg = $root.mediaarchiver.MediaList.decode(reader, reader.uint32());
                    break;
                case 128:
                    message.ReportBugArg = $root.mediaarchiver.ReportedBug.decode(reader, reader.uint32());
                    break;
                case 129:
                    message.GetMediasBackgroundArgs = $root.mediaarchiver.ArgumentsGetMediasBackground.decode(reader, reader.uint32());
                    break;
                case 130:
                    message.BackgroundMediasArg = $root.mediaarchiver.MediaList.decode(reader, reader.uint32());
                    break;
                case 131:
                    message.GetMediasCrossBucketArgs = $root.mediaarchiver.ArgumentsGetMediasCrossBucket.decode(reader, reader.uint32());
                    break;
                case 132:
                    message.CrossBucketMediasArg = $root.mediaarchiver.MediaList.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a WSMessage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.WSMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.WSMessage} WSMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        WSMessage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a WSMessage message.
         * @function verify
         * @memberof mediaarchiver.WSMessage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        WSMessage.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.Type != null && message.hasOwnProperty("Type"))
                switch (message.Type) {
                default:
                    return "Type: enum value expected";
                case 0:
                case 1:
                case 256:
                case 257:
                case 258:
                case 259:
                case 260:
                case 261:
                case 262:
                case 263:
                case 264:
                case 265:
                case 266:
                case 267:
                case 268:
                case 269:
                case 270:
                case 271:
                case 272:
                case 273:
                case 274:
                case 275:
                case 276:
                case 277:
                case 278:
                case 279:
                case 280:
                case 281:
                case 282:
                case 283:
                case 284:
                case 285:
                case 286:
                case 287:
                case 288:
                case 289:
                case 290:
                case 291:
                case 292:
                case 293:
                case 294:
                case 295:
                case 296:
                case 297:
                case 298:
                case 299:
                case 300:
                case 301:
                case 302:
                case 303:
                case 304:
                case 305:
                case 306:
                case 307:
                case 308:
                case 309:
                case 310:
                case 311:
                case 312:
                case 313:
                case 314:
                case 315:
                case 320:
                case 321:
                case 322:
                case 323:
                case 324:
                case 325:
                case 326:
                case 327:
                case 328:
                case 329:
                case 330:
                case 331:
                case 332:
                case 333:
                case 334:
                case 335:
                case 336:
                case 337:
                case 338:
                case 339:
                case 340:
                case 341:
                case 342:
                case 343:
                case 344:
                case 345:
                case 346:
                case 512:
                case 513:
                case 514:
                case 515:
                case 516:
                case 517:
                case 518:
                case 519:
                case 520:
                case 521:
                case 522:
                case 523:
                case 524:
                case 525:
                case 526:
                case 527:
                case 528:
                case 529:
                case 530:
                case 531:
                case 532:
                case 533:
                case 534:
                case 535:
                case 536:
                case 537:
                case 538:
                case 539:
                case 540:
                case 541:
                case 542:
                case 543:
                case 544:
                case 545:
                case 560:
                case 561:
                case 562:
                case 563:
                case 564:
                case 565:
                case 566:
                case 567:
                case 568:
                case 569:
                case 570:
                case 571:
                case 572:
                case 573:
                case 574:
                case 575:
                case 576:
                case 577:
                case 578:
                case 579:
                case 580:
                case 581:
                    break;
                }
            if (message.MessageID != null && message.hasOwnProperty("MessageID"))
                if (!$util.isString(message.MessageID))
                    return "MessageID: string expected";
            if (message.ID != null && message.hasOwnProperty("ID")) {
                properties.Arguments = 1;
                if (!$util.isString(message.ID))
                    return "ID: string expected";
            }
            if (message.LoginArgs != null && message.hasOwnProperty("LoginArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsLogin.verify(message.LoginArgs);
                    if (error)
                        return "LoginArgs." + error;
                }
            }
            if (message.MessageAckArgs != null && message.hasOwnProperty("MessageAckArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsMessageAck.verify(message.MessageAckArgs);
                    if (error)
                        return "MessageAckArgs." + error;
                }
            }
            if (message.WhoYouAreArgs != null && message.hasOwnProperty("WhoYouAreArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsWhoYouAre.verify(message.WhoYouAreArgs);
                    if (error)
                        return "WhoYouAreArgs." + error;
                }
            }
            if (message.TokenArg != null && message.hasOwnProperty("TokenArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                if (!$util.isString(message.TokenArg))
                    return "TokenArg: string expected";
            }
            if (message.GetMediasArgs != null && message.hasOwnProperty("GetMediasArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsGetMedias.verify(message.GetMediasArgs);
                    if (error)
                        return "GetMediasArgs." + error;
                }
            }
            if (message.MediasArg != null && message.hasOwnProperty("MediasArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsMedias.verify(message.MediasArg);
                    if (error)
                        return "MediasArg." + error;
                }
            }
            if (message.GetEPGArgs != null && message.hasOwnProperty("GetEPGArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsGetEPG.verify(message.GetEPGArgs);
                    if (error)
                        return "GetEPGArgs." + error;
                }
            }
            if (message.EPGArgs != null && message.hasOwnProperty("EPGArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsEPG.verify(message.EPGArgs);
                    if (error)
                        return "EPGArgs." + error;
                }
            }
            if (message.GetChunkArgs != null && message.hasOwnProperty("GetChunkArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsGetChunk.verify(message.GetChunkArgs);
                    if (error)
                        return "GetChunkArgs." + error;
                }
            }
            if (message.ChunkArgs != null && message.hasOwnProperty("ChunkArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsChunk.verify(message.ChunkArgs);
                    if (error)
                        return "ChunkArgs." + error;
                }
            }
            if (message.GetContactsArgs != null && message.hasOwnProperty("GetContactsArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsGetContacts.verify(message.GetContactsArgs);
                    if (error)
                        return "GetContactsArgs." + error;
                }
            }
            if (message.ContactsArgs != null && message.hasOwnProperty("ContactsArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsContacts.verify(message.ContactsArgs);
                    if (error)
                        return "ContactsArgs." + error;
                }
            }
            if (message.ContactsCountArg != null && message.hasOwnProperty("ContactsCountArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                if (!$util.isInteger(message.ContactsCountArg))
                    return "ContactsCountArg: integer expected";
            }
            if (message.CreateContactArgs != null && message.hasOwnProperty("CreateContactArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.Contact.verify(message.CreateContactArgs);
                    if (error)
                        return "CreateContactArgs." + error;
                }
            }
            if (message.EditContactArgs != null && message.hasOwnProperty("EditContactArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.Contact.verify(message.EditContactArgs);
                    if (error)
                        return "EditContactArgs." + error;
                }
            }
            if (message.GetAnnotationTypesArgs != null && message.hasOwnProperty("GetAnnotationTypesArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsGetAnnotationTypes.verify(message.GetAnnotationTypesArgs);
                    if (error)
                        return "GetAnnotationTypesArgs." + error;
                }
            }
            if (message.AnnotationTypesArgs != null && message.hasOwnProperty("AnnotationTypesArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsAnnotationTypes.verify(message.AnnotationTypesArgs);
                    if (error)
                        return "AnnotationTypesArgs." + error;
                }
            }
            if (message.AnnotationTypesCountArg != null && message.hasOwnProperty("AnnotationTypesCountArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                if (!$util.isInteger(message.AnnotationTypesCountArg))
                    return "AnnotationTypesCountArg: integer expected";
            }
            if (message.CreateAnnotationTypeArgs != null && message.hasOwnProperty("CreateAnnotationTypeArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.AnnotationType.verify(message.CreateAnnotationTypeArgs);
                    if (error)
                        return "CreateAnnotationTypeArgs." + error;
                }
            }
            if (message.EditAnnotationTypeArgs != null && message.hasOwnProperty("EditAnnotationTypeArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.AnnotationType.verify(message.EditAnnotationTypeArgs);
                    if (error)
                        return "EditAnnotationTypeArgs." + error;
                }
            }
            if (message.DeleteAnnotationTypeArg != null && message.hasOwnProperty("DeleteAnnotationTypeArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                if (!$util.isString(message.DeleteAnnotationTypeArg))
                    return "DeleteAnnotationTypeArg: string expected";
            }
            if (message.CreateAnnotationArg != null && message.hasOwnProperty("CreateAnnotationArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsCreateAnnotation.verify(message.CreateAnnotationArg);
                    if (error)
                        return "CreateAnnotationArg." + error;
                }
            }
            if (message.GetStreamArg != null && message.hasOwnProperty("GetStreamArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsGetStream.verify(message.GetStreamArg);
                    if (error)
                        return "GetStreamArg." + error;
                }
            }
            if (message.StreamArg != null && message.hasOwnProperty("StreamArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsStream.verify(message.StreamArg);
                    if (error)
                        return "StreamArg." + error;
                }
            }
            if (message.SearchProgramArgs != null && message.hasOwnProperty("SearchProgramArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsSearchPrograms.verify(message.SearchProgramArgs);
                    if (error)
                        return "SearchProgramArgs." + error;
                }
            }
            if (message.SearchResultsArgs != null && message.hasOwnProperty("SearchResultsArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsSearchResults.verify(message.SearchResultsArgs);
                    if (error)
                        return "SearchResultsArgs." + error;
                }
            }
            if (message.GetFTPAccountsArgs != null && message.hasOwnProperty("GetFTPAccountsArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsGetFTPAccounts.verify(message.GetFTPAccountsArgs);
                    if (error)
                        return "GetFTPAccountsArgs." + error;
                }
            }
            if (message.FTPAccountsArgs != null && message.hasOwnProperty("FTPAccountsArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsFTPAccounts.verify(message.FTPAccountsArgs);
                    if (error)
                        return "FTPAccountsArgs." + error;
                }
            }
            if (message.FTPAccountsCountArg != null && message.hasOwnProperty("FTPAccountsCountArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                if (!$util.isInteger(message.FTPAccountsCountArg))
                    return "FTPAccountsCountArg: integer expected";
            }
            if (message.CreateFTPAccountArgs != null && message.hasOwnProperty("CreateFTPAccountArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.FTPAccount.verify(message.CreateFTPAccountArgs);
                    if (error)
                        return "CreateFTPAccountArgs." + error;
                }
            }
            if (message.EditFTPAccountArgs != null && message.hasOwnProperty("EditFTPAccountArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.FTPAccount.verify(message.EditFTPAccountArgs);
                    if (error)
                        return "EditFTPAccountArgs." + error;
                }
            }
            if (message.DeleteFTPAccountArg != null && message.hasOwnProperty("DeleteFTPAccountArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                if (!$util.isString(message.DeleteFTPAccountArg))
                    return "DeleteFTPAccountArg: string expected";
            }
            if (message.GetSFTPAccountsArgs != null && message.hasOwnProperty("GetSFTPAccountsArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsGetSFTPAccounts.verify(message.GetSFTPAccountsArgs);
                    if (error)
                        return "GetSFTPAccountsArgs." + error;
                }
            }
            if (message.SFTPAccountsArgs != null && message.hasOwnProperty("SFTPAccountsArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsSFTPAccounts.verify(message.SFTPAccountsArgs);
                    if (error)
                        return "SFTPAccountsArgs." + error;
                }
            }
            if (message.SFTPAccountsCountArg != null && message.hasOwnProperty("SFTPAccountsCountArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                if (!$util.isInteger(message.SFTPAccountsCountArg))
                    return "SFTPAccountsCountArg: integer expected";
            }
            if (message.CreateSFTPAccountArgs != null && message.hasOwnProperty("CreateSFTPAccountArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.SFTPAccount.verify(message.CreateSFTPAccountArgs);
                    if (error)
                        return "CreateSFTPAccountArgs." + error;
                }
            }
            if (message.EditSFTPAccountArgs != null && message.hasOwnProperty("EditSFTPAccountArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.SFTPAccount.verify(message.EditSFTPAccountArgs);
                    if (error)
                        return "EditSFTPAccountArgs." + error;
                }
            }
            if (message.DeleteSFTPAccountArg != null && message.hasOwnProperty("DeleteSFTPAccountArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                if (!$util.isString(message.DeleteSFTPAccountArg))
                    return "DeleteSFTPAccountArg: string expected";
            }
            if (message.SetAccountOptionsArg != null && message.hasOwnProperty("SetAccountOptionsArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.UserOptionsList.verify(message.SetAccountOptionsArg);
                    if (error)
                        return "SetAccountOptionsArg." + error;
                }
            }
            if (message.AnnotationsArg != null && message.hasOwnProperty("AnnotationsArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsAnnotations.verify(message.AnnotationsArg);
                    if (error)
                        return "AnnotationsArg." + error;
                }
            }
            if (message.GetAnnotationsArg != null && message.hasOwnProperty("GetAnnotationsArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsGetAnnotations.verify(message.GetAnnotationsArg);
                    if (error)
                        return "GetAnnotationsArg." + error;
                }
            }
            if (message.DeleteAnnotationArg != null && message.hasOwnProperty("DeleteAnnotationArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsDeleteAnnotation.verify(message.DeleteAnnotationArg);
                    if (error)
                        return "DeleteAnnotationArg." + error;
                }
            }
            if (message.CreateArchiveArg != null && message.hasOwnProperty("CreateArchiveArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.Archive.verify(message.CreateArchiveArg);
                    if (error)
                        return "CreateArchiveArg." + error;
                }
            }
            if (message.GetArchivesArg != null && message.hasOwnProperty("GetArchivesArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsGetArchives.verify(message.GetArchivesArg);
                    if (error)
                        return "GetArchivesArg." + error;
                }
            }
            if (message.EditArchiveArg != null && message.hasOwnProperty("EditArchiveArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.Archive.verify(message.EditArchiveArg);
                    if (error)
                        return "EditArchiveArg." + error;
                }
            }
            if (message.DeleteArchiveArg != null && message.hasOwnProperty("DeleteArchiveArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                if (!$util.isString(message.DeleteArchiveArg))
                    return "DeleteArchiveArg: string expected";
            }
            if (message.ArchivesArg != null && message.hasOwnProperty("ArchivesArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsArchives.verify(message.ArchivesArg);
                    if (error)
                        return "ArchivesArg." + error;
                }
            }
            if (message.ArchivesCountArg != null && message.hasOwnProperty("ArchivesCountArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsArchivesCount.verify(message.ArchivesCountArg);
                    if (error)
                        return "ArchivesCountArg." + error;
                }
            }
            if (message.GetArchiveArg != null && message.hasOwnProperty("GetArchiveArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                if (!$util.isString(message.GetArchiveArg))
                    return "GetArchiveArg: string expected";
            }
            if (message.ArchiveArg != null && message.hasOwnProperty("ArchiveArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.Archive.verify(message.ArchiveArg);
                    if (error)
                        return "ArchiveArg." + error;
                }
            }
            if (message.GetReviewsArg != null && message.hasOwnProperty("GetReviewsArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsGetReviews.verify(message.GetReviewsArg);
                    if (error)
                        return "GetReviewsArg." + error;
                }
            }
            if (message.ReviewsArg != null && message.hasOwnProperty("ReviewsArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsReviews.verify(message.ReviewsArg);
                    if (error)
                        return "ReviewsArg." + error;
                }
            }
            if (message.ReviewArg != null && message.hasOwnProperty("ReviewArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.Review.verify(message.ReviewArg);
                    if (error)
                        return "ReviewArg." + error;
                }
            }
            if (message.ContactArg != null && message.hasOwnProperty("ContactArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.Contact.verify(message.ContactArg);
                    if (error)
                        return "ContactArg." + error;
                }
            }
            if (message.FTPAccountArg != null && message.hasOwnProperty("FTPAccountArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.FTPAccount.verify(message.FTPAccountArg);
                    if (error)
                        return "FTPAccountArg." + error;
                }
            }
            if (message.SFTPAccountArg != null && message.hasOwnProperty("SFTPAccountArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.SFTPAccount.verify(message.SFTPAccountArg);
                    if (error)
                        return "SFTPAccountArg." + error;
                }
            }
            if (message.DeleteContactArg != null && message.hasOwnProperty("DeleteContactArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                if (!$util.isString(message.DeleteContactArg))
                    return "DeleteContactArg: string expected";
            }
            if (message.IncArchiveCounterArg != null && message.hasOwnProperty("IncArchiveCounterArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsIncArchiveCounter.verify(message.IncArchiveCounterArg);
                    if (error)
                        return "IncArchiveCounterArg." + error;
                }
            }
            if (message.GetMailArg != null && message.hasOwnProperty("GetMailArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                if (!$util.isString(message.GetMailArg))
                    return "GetMailArg: string expected";
            }
            if (message.MailArg != null && message.hasOwnProperty("MailArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                if (!$util.isString(message.MailArg))
                    return "MailArg: string expected";
            }
            if (message.BlockMailArg != null && message.hasOwnProperty("BlockMailArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsBlockMail.verify(message.BlockMailArg);
                    if (error)
                        return "BlockMailArg." + error;
                }
            }
            if (message.EditAnnotationArg != null && message.hasOwnProperty("EditAnnotationArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.Annotation.verify(message.EditAnnotationArg);
                    if (error)
                        return "EditAnnotationArg." + error;
                }
            }
            if (message.PanelsArg != null && message.hasOwnProperty("PanelsArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.Panels.verify(message.PanelsArg);
                    if (error)
                        return "PanelsArg." + error;
                }
            }
            if (message.SearchKindArg != null && message.hasOwnProperty("SearchKindArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                if (!$util.isString(message.SearchKindArg))
                    return "SearchKindArg: string expected";
            }
            if (message.SearchKindResultsArg != null && message.hasOwnProperty("SearchKindResultsArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.SearchKindResult.verify(message.SearchKindResultsArg);
                    if (error)
                        return "SearchKindResultsArg." + error;
                }
            }
            if (message.DeleteMultipleAnnotationsArg != null && message.hasOwnProperty("DeleteMultipleAnnotationsArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.MultipleIDs.verify(message.DeleteMultipleAnnotationsArg);
                    if (error)
                        return "DeleteMultipleAnnotationsArg." + error;
                }
            }
            if (message.GetAnnotationTypesOwnedArgs != null && message.hasOwnProperty("GetAnnotationTypesOwnedArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsGetAnnotationTypes.verify(message.GetAnnotationTypesOwnedArgs);
                    if (error)
                        return "GetAnnotationTypesOwnedArgs." + error;
                }
            }
            if (message.AnnotationTypesOwnedArgs != null && message.hasOwnProperty("AnnotationTypesOwnedArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsAnnotationTypes.verify(message.AnnotationTypesOwnedArgs);
                    if (error)
                        return "AnnotationTypesOwnedArgs." + error;
                }
            }
            if (message.AnnotationTypesOwnedCountArg != null && message.hasOwnProperty("AnnotationTypesOwnedCountArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                if (!$util.isInteger(message.AnnotationTypesOwnedCountArg))
                    return "AnnotationTypesOwnedCountArg: integer expected";
            }
            if (message.RetryArchiveArg != null && message.hasOwnProperty("RetryArchiveArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                if (!$util.isString(message.RetryArchiveArg))
                    return "RetryArchiveArg: string expected";
            }
            if (message.ShareArchiveArg != null && message.hasOwnProperty("ShareArchiveArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsShareArchive.verify(message.ShareArchiveArg);
                    if (error)
                        return "ShareArchiveArg." + error;
                }
            }
            if (message.ExportAnnotationArg != null && message.hasOwnProperty("ExportAnnotationArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsExportAnnotations.verify(message.ExportAnnotationArg);
                    if (error)
                        return "ExportAnnotationArg." + error;
                }
            }
            if (message.AdminGetUserArg != null && message.hasOwnProperty("AdminGetUserArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                if (!$util.isInteger(message.AdminGetUserArg))
                    return "AdminGetUserArg: integer expected";
            }
            if (message.AdminSearchUsersArgs != null && message.hasOwnProperty("AdminSearchUsersArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.AdminSearchUsers.verify(message.AdminSearchUsersArgs);
                    if (error)
                        return "AdminSearchUsersArgs." + error;
                }
            }
            if (message.AdminEditUserArg != null && message.hasOwnProperty("AdminEditUserArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.AdminUser.verify(message.AdminEditUserArg);
                    if (error)
                        return "AdminEditUserArg." + error;
                }
            }
            if (message.AdminUserArg != null && message.hasOwnProperty("AdminUserArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.AdminUser.verify(message.AdminUserArg);
                    if (error)
                        return "AdminUserArg." + error;
                }
            }
            if (message.AdminSearchUsersResultArg != null && message.hasOwnProperty("AdminSearchUsersResultArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.AdminUsers.verify(message.AdminSearchUsersResultArg);
                    if (error)
                        return "AdminSearchUsersResultArg." + error;
                }
            }
            if (message.AdminLastUsersArg != null && message.hasOwnProperty("AdminLastUsersArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.AdminUsers.verify(message.AdminLastUsersArg);
                    if (error)
                        return "AdminLastUsersArg." + error;
                }
            }
            if (message.InlineAnnotationsArg != null && message.hasOwnProperty("InlineAnnotationsArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                if (!$util.isString(message.InlineAnnotationsArg))
                    return "InlineAnnotationsArg: string expected";
            }
            if (message.TalkAutocompleteNameArg != null && message.hasOwnProperty("TalkAutocompleteNameArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.TalkAutocompleteName.verify(message.TalkAutocompleteNameArg);
                    if (error)
                        return "TalkAutocompleteNameArg." + error;
                }
            }
            if (message.TalkGetPersonArg != null && message.hasOwnProperty("TalkGetPersonArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                if (!$util.isString(message.TalkGetPersonArg))
                    return "TalkGetPersonArg: string expected";
            }
            if (message.TalkAutocompleteNameSuggsArgs != null && message.hasOwnProperty("TalkAutocompleteNameSuggsArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.TalkPersonSuggs.verify(message.TalkAutocompleteNameSuggsArgs);
                    if (error)
                        return "TalkAutocompleteNameSuggsArgs." + error;
                }
            }
            if (message.TalkPersonArg != null && message.hasOwnProperty("TalkPersonArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.TalkPerson.verify(message.TalkPersonArg);
                    if (error)
                        return "TalkPersonArg." + error;
                }
            }
            if (message.TalkCreateArg != null && message.hasOwnProperty("TalkCreateArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.Talk.verify(message.TalkCreateArg);
                    if (error)
                        return "TalkCreateArg." + error;
                }
            }
            if (message.TalkEditArg != null && message.hasOwnProperty("TalkEditArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.Talk.verify(message.TalkEditArg);
                    if (error)
                        return "TalkEditArg." + error;
                }
            }
            if (message.TalkDeleteArg != null && message.hasOwnProperty("TalkDeleteArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                if (!$util.isString(message.TalkDeleteArg))
                    return "TalkDeleteArg: string expected";
            }
            if (message.TalksArg != null && message.hasOwnProperty("TalksArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsTalks.verify(message.TalksArg);
                    if (error)
                        return "TalksArg." + error;
                }
            }
            if (message.GetTalksArg != null && message.hasOwnProperty("GetTalksArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsGetTalks.verify(message.GetTalksArg);
                    if (error)
                        return "GetTalksArg." + error;
                }
            }
            if (message.DeleteMultipleTalksArg != null && message.hasOwnProperty("DeleteMultipleTalksArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.MultipleIDs.verify(message.DeleteMultipleTalksArg);
                    if (error)
                        return "DeleteMultipleTalksArg." + error;
                }
            }
            if (message.ExportTalksArg != null && message.hasOwnProperty("ExportTalksArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsExportTalks.verify(message.ExportTalksArg);
                    if (error)
                        return "ExportTalksArg." + error;
                }
            }
            if (message.SearchSpeechesArgs != null && message.hasOwnProperty("SearchSpeechesArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.SearchSpeeches.verify(message.SearchSpeechesArgs);
                    if (error)
                        return "SearchSpeechesArgs." + error;
                }
            }
            if (message.SearchSpeechesResultArgs != null && message.hasOwnProperty("SearchSpeechesResultArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.SearchSpeechesResult.verify(message.SearchSpeechesResultArgs);
                    if (error)
                        return "SearchSpeechesResultArgs." + error;
                }
            }
            if (message.AnnotationDirectArg != null && message.hasOwnProperty("AnnotationDirectArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                if (!$util.isString(message.AnnotationDirectArg))
                    return "AnnotationDirectArg: string expected";
            }
            if (message.ExpiringTokenArg != null && message.hasOwnProperty("ExpiringTokenArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ExpiringToken.verify(message.ExpiringTokenArg);
                    if (error)
                        return "ExpiringTokenArg." + error;
                }
            }
            if (message.SearchWordsArgs != null && message.hasOwnProperty("SearchWordsArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.SearchWords.verify(message.SearchWordsArgs);
                    if (error)
                        return "SearchWordsArgs." + error;
                }
            }
            if (message.SearchWordsResultArgs != null && message.hasOwnProperty("SearchWordsResultArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.SearchWordsResult.verify(message.SearchWordsResultArgs);
                    if (error)
                        return "SearchWordsResultArgs." + error;
                }
            }
            if (message.TalkStudiesArgs != null && message.hasOwnProperty("TalkStudiesArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.TalkStudies.verify(message.TalkStudiesArgs);
                    if (error)
                        return "TalkStudiesArgs." + error;
                }
            }
            if (message.TalkProgramTypesArgs != null && message.hasOwnProperty("TalkProgramTypesArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.TalkProgramTypes.verify(message.TalkProgramTypesArgs);
                    if (error)
                        return "TalkProgramTypesArgs." + error;
                }
            }
            if (message.TalkDistrictsArgs != null && message.hasOwnProperty("TalkDistrictsArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.TalkDistricts.verify(message.TalkDistrictsArgs);
                    if (error)
                        return "TalkDistrictsArgs." + error;
                }
            }
            if (message.TalkGetDistrictsArg != null && message.hasOwnProperty("TalkGetDistrictsArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.TalkGetDistricts.verify(message.TalkGetDistrictsArg);
                    if (error)
                        return "TalkGetDistrictsArg." + error;
                }
            }
            if (message.TalkAllGroupsArg != null && message.hasOwnProperty("TalkAllGroupsArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.TalkGroups.verify(message.TalkAllGroupsArg);
                    if (error)
                        return "TalkAllGroupsArg." + error;
                }
            }
            if (message.TalkAllRegimsArg != null && message.hasOwnProperty("TalkAllRegimsArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.TalkRegims.verify(message.TalkAllRegimsArg);
                    if (error)
                        return "TalkAllRegimsArg." + error;
                }
            }
            if (message.TalkAllTitlesArg != null && message.hasOwnProperty("TalkAllTitlesArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.TalkTitles.verify(message.TalkAllTitlesArg);
                    if (error)
                        return "TalkAllTitlesArg." + error;
                }
            }
            if (message.TalkMediasArg != null && message.hasOwnProperty("TalkMediasArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.MediaList.verify(message.TalkMediasArg);
                    if (error)
                        return "TalkMediasArg." + error;
                }
            }
            if (message.TalkExportedTalksArg != null && message.hasOwnProperty("TalkExportedTalksArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                if (!$util.isString(message.TalkExportedTalksArg))
                    return "TalkExportedTalksArg: string expected";
            }
            if (message.SearchSpeechesDateArgs != null && message.hasOwnProperty("SearchSpeechesDateArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.SearchSpeechesDate.verify(message.SearchSpeechesDateArgs);
                    if (error)
                        return "SearchSpeechesDateArgs." + error;
                }
            }
            if (message.SearchSpeechesDateResultArgs != null && message.hasOwnProperty("SearchSpeechesDateResultArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.SearchSpeechesDateResult.verify(message.SearchSpeechesDateResultArgs);
                    if (error)
                        return "SearchSpeechesDateResultArgs." + error;
                }
            }
            if (message.PlayerChunksStatsArg != null && message.hasOwnProperty("PlayerChunksStatsArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.PlayerStatsChunks.verify(message.PlayerChunksStatsArg);
                    if (error)
                        return "PlayerChunksStatsArg." + error;
                }
            }
            if (message.PlayerManifestStatsArg != null && message.hasOwnProperty("PlayerManifestStatsArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.PlayerStatsManifest.verify(message.PlayerManifestStatsArg);
                    if (error)
                        return "PlayerManifestStatsArg." + error;
                }
            }
            if (message.GetMediasSTTArgs != null && message.hasOwnProperty("GetMediasSTTArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsGetMediasSTT.verify(message.GetMediasSTTArgs);
                    if (error)
                        return "GetMediasSTTArgs." + error;
                }
            }
            if (message.STTMediasArg != null && message.hasOwnProperty("STTMediasArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.MediaList.verify(message.STTMediasArg);
                    if (error)
                        return "STTMediasArg." + error;
                }
            }
            if (message.ReportBugArg != null && message.hasOwnProperty("ReportBugArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ReportedBug.verify(message.ReportBugArg);
                    if (error)
                        return "ReportBugArg." + error;
                }
            }
            if (message.GetMediasBackgroundArgs != null && message.hasOwnProperty("GetMediasBackgroundArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsGetMediasBackground.verify(message.GetMediasBackgroundArgs);
                    if (error)
                        return "GetMediasBackgroundArgs." + error;
                }
            }
            if (message.BackgroundMediasArg != null && message.hasOwnProperty("BackgroundMediasArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.MediaList.verify(message.BackgroundMediasArg);
                    if (error)
                        return "BackgroundMediasArg." + error;
                }
            }
            if (message.GetMediasCrossBucketArgs != null && message.hasOwnProperty("GetMediasCrossBucketArgs")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.ArgumentsGetMediasCrossBucket.verify(message.GetMediasCrossBucketArgs);
                    if (error)
                        return "GetMediasCrossBucketArgs." + error;
                }
            }
            if (message.CrossBucketMediasArg != null && message.hasOwnProperty("CrossBucketMediasArg")) {
                if (properties.Arguments === 1)
                    return "Arguments: multiple values";
                properties.Arguments = 1;
                {
                    let error = $root.mediaarchiver.MediaList.verify(message.CrossBucketMediasArg);
                    if (error)
                        return "CrossBucketMediasArg." + error;
                }
            }
            return null;
        };

        /**
         * Creates a WSMessage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.WSMessage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.WSMessage} WSMessage
         */
        WSMessage.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.WSMessage)
                return object;
            let message = new $root.mediaarchiver.WSMessage();
            switch (object.Type) {
            case "MessageTypeUnknown":
            case 0:
                message.Type = 0;
                break;
            case "MessageTypeAck":
            case 1:
                message.Type = 1;
                break;
            case "MessageTypeLogin":
            case 256:
                message.Type = 256;
                break;
            case "MessageTypeLogout":
            case 257:
                message.Type = 257;
                break;
            case "MessageTypeRecover":
            case 258:
                message.Type = 258;
                break;
            case "MessageTypeGetEPG":
            case 259:
                message.Type = 259;
                break;
            case "MessageTypeGetChunk":
            case 260:
                message.Type = 260;
                break;
            case "MessageTypeGetMedias":
            case 261:
                message.Type = 261;
                break;
            case "MessageTypeGetContacts":
            case 262:
                message.Type = 262;
                break;
            case "MessageTypeGetContactsCount":
            case 263:
                message.Type = 263;
                break;
            case "MessageTypeCreateContact":
            case 264:
                message.Type = 264;
                break;
            case "MessageTypeEditContact":
            case 265:
                message.Type = 265;
                break;
            case "MessageTypeDeleteContact":
            case 266:
                message.Type = 266;
                break;
            case "MessageTypeGetAnnotationTypes":
            case 267:
                message.Type = 267;
                break;
            case "MessageTypeGetAnnotationTypesCount":
            case 268:
                message.Type = 268;
                break;
            case "MessageTypeCreateAnnotationType":
            case 269:
                message.Type = 269;
                break;
            case "MessageTypeEditAnnotationType":
            case 270:
                message.Type = 270;
                break;
            case "MessageTypeDeleteAnnotationType":
            case 271:
                message.Type = 271;
                break;
            case "MessageTypeCreateAnnotation":
            case 272:
                message.Type = 272;
                break;
            case "MessageTypeGetStream":
            case 273:
                message.Type = 273;
                break;
            case "MessageTypeSearchPrograms":
            case 274:
                message.Type = 274;
                break;
            case "MessageTypeGetFTPAccounts":
            case 275:
                message.Type = 275;
                break;
            case "MessageTypeGetFTPAccountsCount":
            case 276:
                message.Type = 276;
                break;
            case "MessageTypeCreateFTPAccount":
            case 277:
                message.Type = 277;
                break;
            case "MessageTypeEditFTPAccount":
            case 278:
                message.Type = 278;
                break;
            case "MessageTypeDeleteFTPAccount":
            case 279:
                message.Type = 279;
                break;
            case "MessageTypeGetSFTPAccounts":
            case 280:
                message.Type = 280;
                break;
            case "MessageTypeGetSFTPAccountsCount":
            case 281:
                message.Type = 281;
                break;
            case "MessageTypeCreateSFTPAccount":
            case 282:
                message.Type = 282;
                break;
            case "MessageTypeEditSFTPAccount":
            case 283:
                message.Type = 283;
                break;
            case "MessageTypeDeleteSFTPAccount":
            case 284:
                message.Type = 284;
                break;
            case "MessageTypeSetAccountOptions":
            case 285:
                message.Type = 285;
                break;
            case "MessageTypeGetAnnotations":
            case 286:
                message.Type = 286;
                break;
            case "MessageTypeDeleteAnnotation":
            case 287:
                message.Type = 287;
                break;
            case "MessageTypeCreateArchive":
            case 288:
                message.Type = 288;
                break;
            case "MessageTypeGetArchives":
            case 289:
                message.Type = 289;
                break;
            case "MessageTypeGetArchivesCount":
            case 290:
                message.Type = 290;
                break;
            case "MessageTypeEditArchive":
            case 291:
                message.Type = 291;
                break;
            case "MessageTypeDeleteArchive":
            case 292:
                message.Type = 292;
                break;
            case "MessageTypeGetArchiveTags":
            case 293:
                message.Type = 293;
                break;
            case "MessageTypeGetArchive":
            case 294:
                message.Type = 294;
                break;
            case "MessageTypeGetReviews":
            case 295:
                message.Type = 295;
                break;
            case "MessageTypeGetReview":
            case 296:
                message.Type = 296;
                break;
            case "MessageTypeCreateReview":
            case 297:
                message.Type = 297;
                break;
            case "MessageTypeEditReview":
            case 298:
                message.Type = 298;
                break;
            case "MessageTypeDeleteReview":
            case 299:
                message.Type = 299;
                break;
            case "MessageTypeIncArchiveCounter":
            case 300:
                message.Type = 300;
                break;
            case "MessageTypeGetMail":
            case 301:
                message.Type = 301;
                break;
            case "MessageTypeBlockMail":
            case 302:
                message.Type = 302;
                break;
            case "MessageTypeEditAnnotation":
            case 303:
                message.Type = 303;
                break;
            case "MessageTypeGetPanels":
            case 304:
                message.Type = 304;
                break;
            case "MessageTypeSearchKinds":
            case 305:
                message.Type = 305;
                break;
            case "MessageTypeDeleteMultipleAnnotations":
            case 306:
                message.Type = 306;
                break;
            case "MessageTypeGetAnnotationTypesOwned":
            case 307:
                message.Type = 307;
                break;
            case "MessageTypeGetAnnotationTypesOwnedCount":
            case 308:
                message.Type = 308;
                break;
            case "MessageTypeRetryArchive":
            case 309:
                message.Type = 309;
                break;
            case "MessageTypeShareArchive":
            case 310:
                message.Type = 310;
                break;
            case "MessageTypeExportAnnotations":
            case 311:
                message.Type = 311;
                break;
            case "MessageTypeAdminGetUser":
            case 312:
                message.Type = 312;
                break;
            case "MessageTypeAdminSearchUsers":
            case 313:
                message.Type = 313;
                break;
            case "MessageTypeAdminEditUser":
            case 314:
                message.Type = 314;
                break;
            case "MessageTypeAdminGetLastUsers":
            case 315:
                message.Type = 315;
                break;
            case "MessageTypeTalkAutocompleteName":
            case 320:
                message.Type = 320;
                break;
            case "MessageTypeTalkGetPerson":
            case 321:
                message.Type = 321;
                break;
            case "MessageTypeTalkCreate":
            case 322:
                message.Type = 322;
                break;
            case "MessageTypeTalkEdit":
            case 323:
                message.Type = 323;
                break;
            case "MessageTypeTalkDelete":
            case 324:
                message.Type = 324;
                break;
            case "MessageTypeGetTalks":
            case 325:
                message.Type = 325;
                break;
            case "MessageTypeDeleteMultipleTalks":
            case 326:
                message.Type = 326;
                break;
            case "MessageTypeExportTalks":
            case 327:
                message.Type = 327;
                break;
            case "MessageTypeSearchSpeeches":
            case 328:
                message.Type = 328;
                break;
            case "MessageTypeSearchWords":
            case 329:
                message.Type = 329;
                break;
            case "MessageTypeTalkGetStudies":
            case 330:
                message.Type = 330;
                break;
            case "MessageTypeTalkGetProgramTypes":
            case 331:
                message.Type = 331;
                break;
            case "MessageTypeTalkGetDistricts":
            case 332:
                message.Type = 332;
                break;
            case "MessageTypeTalkGetAllGroups":
            case 333:
                message.Type = 333;
                break;
            case "MessageTypeTalkGetAllTitles":
            case 334:
                message.Type = 334;
                break;
            case "MessageTypeTalkGetAllRegims":
            case 335:
                message.Type = 335;
                break;
            case "MessageTypeGetTalkMedias":
            case 336:
                message.Type = 336;
                break;
            case "MessageTypeSearchSpeechesDate":
            case 337:
                message.Type = 337;
                break;
            case "MessageTypePlayerChunkStats":
            case 338:
                message.Type = 338;
                break;
            case "MessageTypePlayerManifestStats":
            case 339:
                message.Type = 339;
                break;
            case "MessageTypeGetMediasSTT":
            case 340:
                message.Type = 340;
                break;
            case "MessageTypeGetMediasSTTid":
            case 341:
                message.Type = 341;
                break;
            case "MessageTypeReportBug":
            case 342:
                message.Type = 342;
                break;
            case "MessageTypeGetMediasBackground":
            case 343:
                message.Type = 343;
                break;
            case "MessageTypeGetMediasBackgroundid":
            case 344:
                message.Type = 344;
                break;
            case "MessageTypeGetMediasCrossBucket":
            case 345:
                message.Type = 345;
                break;
            case "MessageTypeGetMediasCrossBucketid":
            case 346:
                message.Type = 346;
                break;
            case "MessageTypeWhoYouAre":
            case 512:
                message.Type = 512;
                break;
            case "MessageTypePermanentToken":
            case 513:
                message.Type = 513;
                break;
            case "MessageTypeEPG":
            case 514:
                message.Type = 514;
                break;
            case "MessageTypeChunk":
            case 515:
                message.Type = 515;
                break;
            case "MessageTypeMedias":
            case 516:
                message.Type = 516;
                break;
            case "MessageTypeContacts":
            case 517:
                message.Type = 517;
                break;
            case "MessageTypeContactsCount":
            case 518:
                message.Type = 518;
                break;
            case "MessageTypeAnnotationTypes":
            case 519:
                message.Type = 519;
                break;
            case "MessageTypeAnnotationTypesCount":
            case 520:
                message.Type = 520;
                break;
            case "MessageTypeStream":
            case 521:
                message.Type = 521;
                break;
            case "MessageTypeSearchResults":
            case 522:
                message.Type = 522;
                break;
            case "MessageTypeFTPAccounts":
            case 523:
                message.Type = 523;
                break;
            case "MessageTypeFTPAccountsCount":
            case 524:
                message.Type = 524;
                break;
            case "MessageTypeSFTPAccounts":
            case 525:
                message.Type = 525;
                break;
            case "MessageTypeSFTPAccountsCount":
            case 526:
                message.Type = 526;
                break;
            case "MessageTypeAnnotations":
            case 527:
                message.Type = 527;
                break;
            case "MessageTypeArchives":
            case 528:
                message.Type = 528;
                break;
            case "MessageTypeArchivesCount":
            case 529:
                message.Type = 529;
                break;
            case "MessageTypeArchiveTags":
            case 530:
                message.Type = 530;
                break;
            case "MessageTypeArchive":
            case 531:
                message.Type = 531;
                break;
            case "MessageTypeReviews":
            case 532:
                message.Type = 532;
                break;
            case "MessageTypeReview":
            case 533:
                message.Type = 533;
                break;
            case "MessageTypeContact":
            case 534:
                message.Type = 534;
                break;
            case "MessageTypeFTPAccount":
            case 535:
                message.Type = 535;
                break;
            case "MessageTypeSFTPAccount":
            case 536:
                message.Type = 536;
                break;
            case "MessageTypeMail":
            case 537:
                message.Type = 537;
                break;
            case "MessageTypePanels":
            case 538:
                message.Type = 538;
                break;
            case "MessageTypeSearchKindsResult":
            case 539:
                message.Type = 539;
                break;
            case "MessageTypeAnnotationTypesOwned":
            case 540:
                message.Type = 540;
                break;
            case "MessageTypeAnnotationTypesOwnedCount":
            case 541:
                message.Type = 541;
                break;
            case "MessageTypeAdminUser":
            case 542:
                message.Type = 542;
                break;
            case "MessageTypeAdminSearchUsersResult":
            case 543:
                message.Type = 543;
                break;
            case "MessageTypeAdminLastUsers":
            case 544:
                message.Type = 544;
                break;
            case "MessageTypeInlineAnnotations":
            case 545:
                message.Type = 545;
                break;
            case "MessageTypeTalkAutocompleteNameSuggs":
            case 560:
                message.Type = 560;
                break;
            case "MessageTypeTalkPerson":
            case 561:
                message.Type = 561;
                break;
            case "MessageTypeTalks":
            case 562:
                message.Type = 562;
                break;
            case "MessageTypeSearchSpeechesResult":
            case 563:
                message.Type = 563;
                break;
            case "MessageTypeAnnotationDirect":
            case 564:
                message.Type = 564;
                break;
            case "MessageTypeExpiringToken":
            case 565:
                message.Type = 565;
                break;
            case "MessageTypeSearchWordsResult":
            case 566:
                message.Type = 566;
                break;
            case "MessageTypeTalkStudies":
            case 567:
                message.Type = 567;
                break;
            case "MessageTypeTalkProgramTypes":
            case 568:
                message.Type = 568;
                break;
            case "MessageTypeTalkDistricts":
            case 569:
                message.Type = 569;
                break;
            case "MessageTypeTalkAllGroups":
            case 570:
                message.Type = 570;
                break;
            case "MessageTypeTalkAllTitles":
            case 571:
                message.Type = 571;
                break;
            case "MessageTypeTalkAllRegims":
            case 572:
                message.Type = 572;
                break;
            case "MessageTypeTalkMedias":
            case 573:
                message.Type = 573;
                break;
            case "MessageTypeTalkExportedTalks":
            case 574:
                message.Type = 574;
                break;
            case "MessageTypeSearchSpeechesDateResult":
            case 575:
                message.Type = 575;
                break;
            case "MessageTypeMediasSTT":
            case 576:
                message.Type = 576;
                break;
            case "MessageTypeMediasSTTid":
            case 577:
                message.Type = 577;
                break;
            case "MessageTypeMediasBackground":
            case 578:
                message.Type = 578;
                break;
            case "MessageTypeMediasBackgroundid":
            case 579:
                message.Type = 579;
                break;
            case "MessageTypeMediasCrossBucket":
            case 580:
                message.Type = 580;
                break;
            case "MessageTypeMediasCrossBucketid":
            case 581:
                message.Type = 581;
                break;
            }
            if (object.MessageID != null)
                message.MessageID = String(object.MessageID);
            if (object.ID != null)
                message.ID = String(object.ID);
            if (object.LoginArgs != null) {
                if (typeof object.LoginArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.LoginArgs: object expected");
                message.LoginArgs = $root.mediaarchiver.ArgumentsLogin.fromObject(object.LoginArgs);
            }
            if (object.MessageAckArgs != null) {
                if (typeof object.MessageAckArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.MessageAckArgs: object expected");
                message.MessageAckArgs = $root.mediaarchiver.ArgumentsMessageAck.fromObject(object.MessageAckArgs);
            }
            if (object.WhoYouAreArgs != null) {
                if (typeof object.WhoYouAreArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.WhoYouAreArgs: object expected");
                message.WhoYouAreArgs = $root.mediaarchiver.ArgumentsWhoYouAre.fromObject(object.WhoYouAreArgs);
            }
            if (object.TokenArg != null)
                message.TokenArg = String(object.TokenArg);
            if (object.GetMediasArgs != null) {
                if (typeof object.GetMediasArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.GetMediasArgs: object expected");
                message.GetMediasArgs = $root.mediaarchiver.ArgumentsGetMedias.fromObject(object.GetMediasArgs);
            }
            if (object.MediasArg != null) {
                if (typeof object.MediasArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.MediasArg: object expected");
                message.MediasArg = $root.mediaarchiver.ArgumentsMedias.fromObject(object.MediasArg);
            }
            if (object.GetEPGArgs != null) {
                if (typeof object.GetEPGArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.GetEPGArgs: object expected");
                message.GetEPGArgs = $root.mediaarchiver.ArgumentsGetEPG.fromObject(object.GetEPGArgs);
            }
            if (object.EPGArgs != null) {
                if (typeof object.EPGArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.EPGArgs: object expected");
                message.EPGArgs = $root.mediaarchiver.ArgumentsEPG.fromObject(object.EPGArgs);
            }
            if (object.GetChunkArgs != null) {
                if (typeof object.GetChunkArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.GetChunkArgs: object expected");
                message.GetChunkArgs = $root.mediaarchiver.ArgumentsGetChunk.fromObject(object.GetChunkArgs);
            }
            if (object.ChunkArgs != null) {
                if (typeof object.ChunkArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.ChunkArgs: object expected");
                message.ChunkArgs = $root.mediaarchiver.ArgumentsChunk.fromObject(object.ChunkArgs);
            }
            if (object.GetContactsArgs != null) {
                if (typeof object.GetContactsArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.GetContactsArgs: object expected");
                message.GetContactsArgs = $root.mediaarchiver.ArgumentsGetContacts.fromObject(object.GetContactsArgs);
            }
            if (object.ContactsArgs != null) {
                if (typeof object.ContactsArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.ContactsArgs: object expected");
                message.ContactsArgs = $root.mediaarchiver.ArgumentsContacts.fromObject(object.ContactsArgs);
            }
            if (object.ContactsCountArg != null)
                message.ContactsCountArg = object.ContactsCountArg >>> 0;
            if (object.CreateContactArgs != null) {
                if (typeof object.CreateContactArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.CreateContactArgs: object expected");
                message.CreateContactArgs = $root.mediaarchiver.Contact.fromObject(object.CreateContactArgs);
            }
            if (object.EditContactArgs != null) {
                if (typeof object.EditContactArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.EditContactArgs: object expected");
                message.EditContactArgs = $root.mediaarchiver.Contact.fromObject(object.EditContactArgs);
            }
            if (object.GetAnnotationTypesArgs != null) {
                if (typeof object.GetAnnotationTypesArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.GetAnnotationTypesArgs: object expected");
                message.GetAnnotationTypesArgs = $root.mediaarchiver.ArgumentsGetAnnotationTypes.fromObject(object.GetAnnotationTypesArgs);
            }
            if (object.AnnotationTypesArgs != null) {
                if (typeof object.AnnotationTypesArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.AnnotationTypesArgs: object expected");
                message.AnnotationTypesArgs = $root.mediaarchiver.ArgumentsAnnotationTypes.fromObject(object.AnnotationTypesArgs);
            }
            if (object.AnnotationTypesCountArg != null)
                message.AnnotationTypesCountArg = object.AnnotationTypesCountArg >>> 0;
            if (object.CreateAnnotationTypeArgs != null) {
                if (typeof object.CreateAnnotationTypeArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.CreateAnnotationTypeArgs: object expected");
                message.CreateAnnotationTypeArgs = $root.mediaarchiver.AnnotationType.fromObject(object.CreateAnnotationTypeArgs);
            }
            if (object.EditAnnotationTypeArgs != null) {
                if (typeof object.EditAnnotationTypeArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.EditAnnotationTypeArgs: object expected");
                message.EditAnnotationTypeArgs = $root.mediaarchiver.AnnotationType.fromObject(object.EditAnnotationTypeArgs);
            }
            if (object.DeleteAnnotationTypeArg != null)
                message.DeleteAnnotationTypeArg = String(object.DeleteAnnotationTypeArg);
            if (object.CreateAnnotationArg != null) {
                if (typeof object.CreateAnnotationArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.CreateAnnotationArg: object expected");
                message.CreateAnnotationArg = $root.mediaarchiver.ArgumentsCreateAnnotation.fromObject(object.CreateAnnotationArg);
            }
            if (object.GetStreamArg != null) {
                if (typeof object.GetStreamArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.GetStreamArg: object expected");
                message.GetStreamArg = $root.mediaarchiver.ArgumentsGetStream.fromObject(object.GetStreamArg);
            }
            if (object.StreamArg != null) {
                if (typeof object.StreamArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.StreamArg: object expected");
                message.StreamArg = $root.mediaarchiver.ArgumentsStream.fromObject(object.StreamArg);
            }
            if (object.SearchProgramArgs != null) {
                if (typeof object.SearchProgramArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.SearchProgramArgs: object expected");
                message.SearchProgramArgs = $root.mediaarchiver.ArgumentsSearchPrograms.fromObject(object.SearchProgramArgs);
            }
            if (object.SearchResultsArgs != null) {
                if (typeof object.SearchResultsArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.SearchResultsArgs: object expected");
                message.SearchResultsArgs = $root.mediaarchiver.ArgumentsSearchResults.fromObject(object.SearchResultsArgs);
            }
            if (object.GetFTPAccountsArgs != null) {
                if (typeof object.GetFTPAccountsArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.GetFTPAccountsArgs: object expected");
                message.GetFTPAccountsArgs = $root.mediaarchiver.ArgumentsGetFTPAccounts.fromObject(object.GetFTPAccountsArgs);
            }
            if (object.FTPAccountsArgs != null) {
                if (typeof object.FTPAccountsArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.FTPAccountsArgs: object expected");
                message.FTPAccountsArgs = $root.mediaarchiver.ArgumentsFTPAccounts.fromObject(object.FTPAccountsArgs);
            }
            if (object.FTPAccountsCountArg != null)
                message.FTPAccountsCountArg = object.FTPAccountsCountArg >>> 0;
            if (object.CreateFTPAccountArgs != null) {
                if (typeof object.CreateFTPAccountArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.CreateFTPAccountArgs: object expected");
                message.CreateFTPAccountArgs = $root.mediaarchiver.FTPAccount.fromObject(object.CreateFTPAccountArgs);
            }
            if (object.EditFTPAccountArgs != null) {
                if (typeof object.EditFTPAccountArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.EditFTPAccountArgs: object expected");
                message.EditFTPAccountArgs = $root.mediaarchiver.FTPAccount.fromObject(object.EditFTPAccountArgs);
            }
            if (object.DeleteFTPAccountArg != null)
                message.DeleteFTPAccountArg = String(object.DeleteFTPAccountArg);
            if (object.GetSFTPAccountsArgs != null) {
                if (typeof object.GetSFTPAccountsArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.GetSFTPAccountsArgs: object expected");
                message.GetSFTPAccountsArgs = $root.mediaarchiver.ArgumentsGetSFTPAccounts.fromObject(object.GetSFTPAccountsArgs);
            }
            if (object.SFTPAccountsArgs != null) {
                if (typeof object.SFTPAccountsArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.SFTPAccountsArgs: object expected");
                message.SFTPAccountsArgs = $root.mediaarchiver.ArgumentsSFTPAccounts.fromObject(object.SFTPAccountsArgs);
            }
            if (object.SFTPAccountsCountArg != null)
                message.SFTPAccountsCountArg = object.SFTPAccountsCountArg >>> 0;
            if (object.CreateSFTPAccountArgs != null) {
                if (typeof object.CreateSFTPAccountArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.CreateSFTPAccountArgs: object expected");
                message.CreateSFTPAccountArgs = $root.mediaarchiver.SFTPAccount.fromObject(object.CreateSFTPAccountArgs);
            }
            if (object.EditSFTPAccountArgs != null) {
                if (typeof object.EditSFTPAccountArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.EditSFTPAccountArgs: object expected");
                message.EditSFTPAccountArgs = $root.mediaarchiver.SFTPAccount.fromObject(object.EditSFTPAccountArgs);
            }
            if (object.DeleteSFTPAccountArg != null)
                message.DeleteSFTPAccountArg = String(object.DeleteSFTPAccountArg);
            if (object.SetAccountOptionsArg != null) {
                if (typeof object.SetAccountOptionsArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.SetAccountOptionsArg: object expected");
                message.SetAccountOptionsArg = $root.mediaarchiver.UserOptionsList.fromObject(object.SetAccountOptionsArg);
            }
            if (object.AnnotationsArg != null) {
                if (typeof object.AnnotationsArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.AnnotationsArg: object expected");
                message.AnnotationsArg = $root.mediaarchiver.ArgumentsAnnotations.fromObject(object.AnnotationsArg);
            }
            if (object.GetAnnotationsArg != null) {
                if (typeof object.GetAnnotationsArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.GetAnnotationsArg: object expected");
                message.GetAnnotationsArg = $root.mediaarchiver.ArgumentsGetAnnotations.fromObject(object.GetAnnotationsArg);
            }
            if (object.DeleteAnnotationArg != null) {
                if (typeof object.DeleteAnnotationArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.DeleteAnnotationArg: object expected");
                message.DeleteAnnotationArg = $root.mediaarchiver.ArgumentsDeleteAnnotation.fromObject(object.DeleteAnnotationArg);
            }
            if (object.CreateArchiveArg != null) {
                if (typeof object.CreateArchiveArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.CreateArchiveArg: object expected");
                message.CreateArchiveArg = $root.mediaarchiver.Archive.fromObject(object.CreateArchiveArg);
            }
            if (object.GetArchivesArg != null) {
                if (typeof object.GetArchivesArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.GetArchivesArg: object expected");
                message.GetArchivesArg = $root.mediaarchiver.ArgumentsGetArchives.fromObject(object.GetArchivesArg);
            }
            if (object.EditArchiveArg != null) {
                if (typeof object.EditArchiveArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.EditArchiveArg: object expected");
                message.EditArchiveArg = $root.mediaarchiver.Archive.fromObject(object.EditArchiveArg);
            }
            if (object.DeleteArchiveArg != null)
                message.DeleteArchiveArg = String(object.DeleteArchiveArg);
            if (object.ArchivesArg != null) {
                if (typeof object.ArchivesArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.ArchivesArg: object expected");
                message.ArchivesArg = $root.mediaarchiver.ArgumentsArchives.fromObject(object.ArchivesArg);
            }
            if (object.ArchivesCountArg != null) {
                if (typeof object.ArchivesCountArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.ArchivesCountArg: object expected");
                message.ArchivesCountArg = $root.mediaarchiver.ArgumentsArchivesCount.fromObject(object.ArchivesCountArg);
            }
            if (object.GetArchiveArg != null)
                message.GetArchiveArg = String(object.GetArchiveArg);
            if (object.ArchiveArg != null) {
                if (typeof object.ArchiveArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.ArchiveArg: object expected");
                message.ArchiveArg = $root.mediaarchiver.Archive.fromObject(object.ArchiveArg);
            }
            if (object.GetReviewsArg != null) {
                if (typeof object.GetReviewsArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.GetReviewsArg: object expected");
                message.GetReviewsArg = $root.mediaarchiver.ArgumentsGetReviews.fromObject(object.GetReviewsArg);
            }
            if (object.ReviewsArg != null) {
                if (typeof object.ReviewsArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.ReviewsArg: object expected");
                message.ReviewsArg = $root.mediaarchiver.ArgumentsReviews.fromObject(object.ReviewsArg);
            }
            if (object.ReviewArg != null) {
                if (typeof object.ReviewArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.ReviewArg: object expected");
                message.ReviewArg = $root.mediaarchiver.Review.fromObject(object.ReviewArg);
            }
            if (object.ContactArg != null) {
                if (typeof object.ContactArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.ContactArg: object expected");
                message.ContactArg = $root.mediaarchiver.Contact.fromObject(object.ContactArg);
            }
            if (object.FTPAccountArg != null) {
                if (typeof object.FTPAccountArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.FTPAccountArg: object expected");
                message.FTPAccountArg = $root.mediaarchiver.FTPAccount.fromObject(object.FTPAccountArg);
            }
            if (object.SFTPAccountArg != null) {
                if (typeof object.SFTPAccountArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.SFTPAccountArg: object expected");
                message.SFTPAccountArg = $root.mediaarchiver.SFTPAccount.fromObject(object.SFTPAccountArg);
            }
            if (object.DeleteContactArg != null)
                message.DeleteContactArg = String(object.DeleteContactArg);
            if (object.IncArchiveCounterArg != null) {
                if (typeof object.IncArchiveCounterArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.IncArchiveCounterArg: object expected");
                message.IncArchiveCounterArg = $root.mediaarchiver.ArgumentsIncArchiveCounter.fromObject(object.IncArchiveCounterArg);
            }
            if (object.GetMailArg != null)
                message.GetMailArg = String(object.GetMailArg);
            if (object.MailArg != null)
                message.MailArg = String(object.MailArg);
            if (object.BlockMailArg != null) {
                if (typeof object.BlockMailArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.BlockMailArg: object expected");
                message.BlockMailArg = $root.mediaarchiver.ArgumentsBlockMail.fromObject(object.BlockMailArg);
            }
            if (object.EditAnnotationArg != null) {
                if (typeof object.EditAnnotationArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.EditAnnotationArg: object expected");
                message.EditAnnotationArg = $root.mediaarchiver.Annotation.fromObject(object.EditAnnotationArg);
            }
            if (object.PanelsArg != null) {
                if (typeof object.PanelsArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.PanelsArg: object expected");
                message.PanelsArg = $root.mediaarchiver.Panels.fromObject(object.PanelsArg);
            }
            if (object.SearchKindArg != null)
                message.SearchKindArg = String(object.SearchKindArg);
            if (object.SearchKindResultsArg != null) {
                if (typeof object.SearchKindResultsArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.SearchKindResultsArg: object expected");
                message.SearchKindResultsArg = $root.mediaarchiver.SearchKindResult.fromObject(object.SearchKindResultsArg);
            }
            if (object.DeleteMultipleAnnotationsArg != null) {
                if (typeof object.DeleteMultipleAnnotationsArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.DeleteMultipleAnnotationsArg: object expected");
                message.DeleteMultipleAnnotationsArg = $root.mediaarchiver.MultipleIDs.fromObject(object.DeleteMultipleAnnotationsArg);
            }
            if (object.GetAnnotationTypesOwnedArgs != null) {
                if (typeof object.GetAnnotationTypesOwnedArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.GetAnnotationTypesOwnedArgs: object expected");
                message.GetAnnotationTypesOwnedArgs = $root.mediaarchiver.ArgumentsGetAnnotationTypes.fromObject(object.GetAnnotationTypesOwnedArgs);
            }
            if (object.AnnotationTypesOwnedArgs != null) {
                if (typeof object.AnnotationTypesOwnedArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.AnnotationTypesOwnedArgs: object expected");
                message.AnnotationTypesOwnedArgs = $root.mediaarchiver.ArgumentsAnnotationTypes.fromObject(object.AnnotationTypesOwnedArgs);
            }
            if (object.AnnotationTypesOwnedCountArg != null)
                message.AnnotationTypesOwnedCountArg = object.AnnotationTypesOwnedCountArg >>> 0;
            if (object.RetryArchiveArg != null)
                message.RetryArchiveArg = String(object.RetryArchiveArg);
            if (object.ShareArchiveArg != null) {
                if (typeof object.ShareArchiveArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.ShareArchiveArg: object expected");
                message.ShareArchiveArg = $root.mediaarchiver.ArgumentsShareArchive.fromObject(object.ShareArchiveArg);
            }
            if (object.ExportAnnotationArg != null) {
                if (typeof object.ExportAnnotationArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.ExportAnnotationArg: object expected");
                message.ExportAnnotationArg = $root.mediaarchiver.ArgumentsExportAnnotations.fromObject(object.ExportAnnotationArg);
            }
            if (object.AdminGetUserArg != null)
                message.AdminGetUserArg = object.AdminGetUserArg >>> 0;
            if (object.AdminSearchUsersArgs != null) {
                if (typeof object.AdminSearchUsersArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.AdminSearchUsersArgs: object expected");
                message.AdminSearchUsersArgs = $root.mediaarchiver.AdminSearchUsers.fromObject(object.AdminSearchUsersArgs);
            }
            if (object.AdminEditUserArg != null) {
                if (typeof object.AdminEditUserArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.AdminEditUserArg: object expected");
                message.AdminEditUserArg = $root.mediaarchiver.AdminUser.fromObject(object.AdminEditUserArg);
            }
            if (object.AdminUserArg != null) {
                if (typeof object.AdminUserArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.AdminUserArg: object expected");
                message.AdminUserArg = $root.mediaarchiver.AdminUser.fromObject(object.AdminUserArg);
            }
            if (object.AdminSearchUsersResultArg != null) {
                if (typeof object.AdminSearchUsersResultArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.AdminSearchUsersResultArg: object expected");
                message.AdminSearchUsersResultArg = $root.mediaarchiver.AdminUsers.fromObject(object.AdminSearchUsersResultArg);
            }
            if (object.AdminLastUsersArg != null) {
                if (typeof object.AdminLastUsersArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.AdminLastUsersArg: object expected");
                message.AdminLastUsersArg = $root.mediaarchiver.AdminUsers.fromObject(object.AdminLastUsersArg);
            }
            if (object.InlineAnnotationsArg != null)
                message.InlineAnnotationsArg = String(object.InlineAnnotationsArg);
            if (object.TalkAutocompleteNameArg != null) {
                if (typeof object.TalkAutocompleteNameArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.TalkAutocompleteNameArg: object expected");
                message.TalkAutocompleteNameArg = $root.mediaarchiver.TalkAutocompleteName.fromObject(object.TalkAutocompleteNameArg);
            }
            if (object.TalkGetPersonArg != null)
                message.TalkGetPersonArg = String(object.TalkGetPersonArg);
            if (object.TalkAutocompleteNameSuggsArgs != null) {
                if (typeof object.TalkAutocompleteNameSuggsArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.TalkAutocompleteNameSuggsArgs: object expected");
                message.TalkAutocompleteNameSuggsArgs = $root.mediaarchiver.TalkPersonSuggs.fromObject(object.TalkAutocompleteNameSuggsArgs);
            }
            if (object.TalkPersonArg != null) {
                if (typeof object.TalkPersonArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.TalkPersonArg: object expected");
                message.TalkPersonArg = $root.mediaarchiver.TalkPerson.fromObject(object.TalkPersonArg);
            }
            if (object.TalkCreateArg != null) {
                if (typeof object.TalkCreateArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.TalkCreateArg: object expected");
                message.TalkCreateArg = $root.mediaarchiver.Talk.fromObject(object.TalkCreateArg);
            }
            if (object.TalkEditArg != null) {
                if (typeof object.TalkEditArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.TalkEditArg: object expected");
                message.TalkEditArg = $root.mediaarchiver.Talk.fromObject(object.TalkEditArg);
            }
            if (object.TalkDeleteArg != null)
                message.TalkDeleteArg = String(object.TalkDeleteArg);
            if (object.TalksArg != null) {
                if (typeof object.TalksArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.TalksArg: object expected");
                message.TalksArg = $root.mediaarchiver.ArgumentsTalks.fromObject(object.TalksArg);
            }
            if (object.GetTalksArg != null) {
                if (typeof object.GetTalksArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.GetTalksArg: object expected");
                message.GetTalksArg = $root.mediaarchiver.ArgumentsGetTalks.fromObject(object.GetTalksArg);
            }
            if (object.DeleteMultipleTalksArg != null) {
                if (typeof object.DeleteMultipleTalksArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.DeleteMultipleTalksArg: object expected");
                message.DeleteMultipleTalksArg = $root.mediaarchiver.MultipleIDs.fromObject(object.DeleteMultipleTalksArg);
            }
            if (object.ExportTalksArg != null) {
                if (typeof object.ExportTalksArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.ExportTalksArg: object expected");
                message.ExportTalksArg = $root.mediaarchiver.ArgumentsExportTalks.fromObject(object.ExportTalksArg);
            }
            if (object.SearchSpeechesArgs != null) {
                if (typeof object.SearchSpeechesArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.SearchSpeechesArgs: object expected");
                message.SearchSpeechesArgs = $root.mediaarchiver.SearchSpeeches.fromObject(object.SearchSpeechesArgs);
            }
            if (object.SearchSpeechesResultArgs != null) {
                if (typeof object.SearchSpeechesResultArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.SearchSpeechesResultArgs: object expected");
                message.SearchSpeechesResultArgs = $root.mediaarchiver.SearchSpeechesResult.fromObject(object.SearchSpeechesResultArgs);
            }
            if (object.AnnotationDirectArg != null)
                message.AnnotationDirectArg = String(object.AnnotationDirectArg);
            if (object.ExpiringTokenArg != null) {
                if (typeof object.ExpiringTokenArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.ExpiringTokenArg: object expected");
                message.ExpiringTokenArg = $root.mediaarchiver.ExpiringToken.fromObject(object.ExpiringTokenArg);
            }
            if (object.SearchWordsArgs != null) {
                if (typeof object.SearchWordsArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.SearchWordsArgs: object expected");
                message.SearchWordsArgs = $root.mediaarchiver.SearchWords.fromObject(object.SearchWordsArgs);
            }
            if (object.SearchWordsResultArgs != null) {
                if (typeof object.SearchWordsResultArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.SearchWordsResultArgs: object expected");
                message.SearchWordsResultArgs = $root.mediaarchiver.SearchWordsResult.fromObject(object.SearchWordsResultArgs);
            }
            if (object.TalkStudiesArgs != null) {
                if (typeof object.TalkStudiesArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.TalkStudiesArgs: object expected");
                message.TalkStudiesArgs = $root.mediaarchiver.TalkStudies.fromObject(object.TalkStudiesArgs);
            }
            if (object.TalkProgramTypesArgs != null) {
                if (typeof object.TalkProgramTypesArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.TalkProgramTypesArgs: object expected");
                message.TalkProgramTypesArgs = $root.mediaarchiver.TalkProgramTypes.fromObject(object.TalkProgramTypesArgs);
            }
            if (object.TalkDistrictsArgs != null) {
                if (typeof object.TalkDistrictsArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.TalkDistrictsArgs: object expected");
                message.TalkDistrictsArgs = $root.mediaarchiver.TalkDistricts.fromObject(object.TalkDistrictsArgs);
            }
            if (object.TalkGetDistrictsArg != null) {
                if (typeof object.TalkGetDistrictsArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.TalkGetDistrictsArg: object expected");
                message.TalkGetDistrictsArg = $root.mediaarchiver.TalkGetDistricts.fromObject(object.TalkGetDistrictsArg);
            }
            if (object.TalkAllGroupsArg != null) {
                if (typeof object.TalkAllGroupsArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.TalkAllGroupsArg: object expected");
                message.TalkAllGroupsArg = $root.mediaarchiver.TalkGroups.fromObject(object.TalkAllGroupsArg);
            }
            if (object.TalkAllRegimsArg != null) {
                if (typeof object.TalkAllRegimsArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.TalkAllRegimsArg: object expected");
                message.TalkAllRegimsArg = $root.mediaarchiver.TalkRegims.fromObject(object.TalkAllRegimsArg);
            }
            if (object.TalkAllTitlesArg != null) {
                if (typeof object.TalkAllTitlesArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.TalkAllTitlesArg: object expected");
                message.TalkAllTitlesArg = $root.mediaarchiver.TalkTitles.fromObject(object.TalkAllTitlesArg);
            }
            if (object.TalkMediasArg != null) {
                if (typeof object.TalkMediasArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.TalkMediasArg: object expected");
                message.TalkMediasArg = $root.mediaarchiver.MediaList.fromObject(object.TalkMediasArg);
            }
            if (object.TalkExportedTalksArg != null)
                message.TalkExportedTalksArg = String(object.TalkExportedTalksArg);
            if (object.SearchSpeechesDateArgs != null) {
                if (typeof object.SearchSpeechesDateArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.SearchSpeechesDateArgs: object expected");
                message.SearchSpeechesDateArgs = $root.mediaarchiver.SearchSpeechesDate.fromObject(object.SearchSpeechesDateArgs);
            }
            if (object.SearchSpeechesDateResultArgs != null) {
                if (typeof object.SearchSpeechesDateResultArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.SearchSpeechesDateResultArgs: object expected");
                message.SearchSpeechesDateResultArgs = $root.mediaarchiver.SearchSpeechesDateResult.fromObject(object.SearchSpeechesDateResultArgs);
            }
            if (object.PlayerChunksStatsArg != null) {
                if (typeof object.PlayerChunksStatsArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.PlayerChunksStatsArg: object expected");
                message.PlayerChunksStatsArg = $root.mediaarchiver.PlayerStatsChunks.fromObject(object.PlayerChunksStatsArg);
            }
            if (object.PlayerManifestStatsArg != null) {
                if (typeof object.PlayerManifestStatsArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.PlayerManifestStatsArg: object expected");
                message.PlayerManifestStatsArg = $root.mediaarchiver.PlayerStatsManifest.fromObject(object.PlayerManifestStatsArg);
            }
            if (object.GetMediasSTTArgs != null) {
                if (typeof object.GetMediasSTTArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.GetMediasSTTArgs: object expected");
                message.GetMediasSTTArgs = $root.mediaarchiver.ArgumentsGetMediasSTT.fromObject(object.GetMediasSTTArgs);
            }
            if (object.STTMediasArg != null) {
                if (typeof object.STTMediasArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.STTMediasArg: object expected");
                message.STTMediasArg = $root.mediaarchiver.MediaList.fromObject(object.STTMediasArg);
            }
            if (object.ReportBugArg != null) {
                if (typeof object.ReportBugArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.ReportBugArg: object expected");
                message.ReportBugArg = $root.mediaarchiver.ReportedBug.fromObject(object.ReportBugArg);
            }
            if (object.GetMediasBackgroundArgs != null) {
                if (typeof object.GetMediasBackgroundArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.GetMediasBackgroundArgs: object expected");
                message.GetMediasBackgroundArgs = $root.mediaarchiver.ArgumentsGetMediasBackground.fromObject(object.GetMediasBackgroundArgs);
            }
            if (object.BackgroundMediasArg != null) {
                if (typeof object.BackgroundMediasArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.BackgroundMediasArg: object expected");
                message.BackgroundMediasArg = $root.mediaarchiver.MediaList.fromObject(object.BackgroundMediasArg);
            }
            if (object.GetMediasCrossBucketArgs != null) {
                if (typeof object.GetMediasCrossBucketArgs !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.GetMediasCrossBucketArgs: object expected");
                message.GetMediasCrossBucketArgs = $root.mediaarchiver.ArgumentsGetMediasCrossBucket.fromObject(object.GetMediasCrossBucketArgs);
            }
            if (object.CrossBucketMediasArg != null) {
                if (typeof object.CrossBucketMediasArg !== "object")
                    throw TypeError(".mediaarchiver.WSMessage.CrossBucketMediasArg: object expected");
                message.CrossBucketMediasArg = $root.mediaarchiver.MediaList.fromObject(object.CrossBucketMediasArg);
            }
            return message;
        };

        /**
         * Creates a plain object from a WSMessage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.WSMessage
         * @static
         * @param {mediaarchiver.WSMessage} message WSMessage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        WSMessage.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.Type = options.enums === String ? "MessageTypeUnknown" : 0;
                object.MessageID = "";
            }
            if (message.Type != null && message.hasOwnProperty("Type"))
                object.Type = options.enums === String ? $root.mediaarchiver.WSMessageType[message.Type] : message.Type;
            if (message.MessageID != null && message.hasOwnProperty("MessageID"))
                object.MessageID = message.MessageID;
            if (message.ID != null && message.hasOwnProperty("ID")) {
                object.ID = message.ID;
                if (options.oneofs)
                    object.Arguments = "ID";
            }
            if (message.LoginArgs != null && message.hasOwnProperty("LoginArgs")) {
                object.LoginArgs = $root.mediaarchiver.ArgumentsLogin.toObject(message.LoginArgs, options);
                if (options.oneofs)
                    object.Arguments = "LoginArgs";
            }
            if (message.MessageAckArgs != null && message.hasOwnProperty("MessageAckArgs")) {
                object.MessageAckArgs = $root.mediaarchiver.ArgumentsMessageAck.toObject(message.MessageAckArgs, options);
                if (options.oneofs)
                    object.Arguments = "MessageAckArgs";
            }
            if (message.WhoYouAreArgs != null && message.hasOwnProperty("WhoYouAreArgs")) {
                object.WhoYouAreArgs = $root.mediaarchiver.ArgumentsWhoYouAre.toObject(message.WhoYouAreArgs, options);
                if (options.oneofs)
                    object.Arguments = "WhoYouAreArgs";
            }
            if (message.TokenArg != null && message.hasOwnProperty("TokenArg")) {
                object.TokenArg = message.TokenArg;
                if (options.oneofs)
                    object.Arguments = "TokenArg";
            }
            if (message.GetMediasArgs != null && message.hasOwnProperty("GetMediasArgs")) {
                object.GetMediasArgs = $root.mediaarchiver.ArgumentsGetMedias.toObject(message.GetMediasArgs, options);
                if (options.oneofs)
                    object.Arguments = "GetMediasArgs";
            }
            if (message.MediasArg != null && message.hasOwnProperty("MediasArg")) {
                object.MediasArg = $root.mediaarchiver.ArgumentsMedias.toObject(message.MediasArg, options);
                if (options.oneofs)
                    object.Arguments = "MediasArg";
            }
            if (message.GetEPGArgs != null && message.hasOwnProperty("GetEPGArgs")) {
                object.GetEPGArgs = $root.mediaarchiver.ArgumentsGetEPG.toObject(message.GetEPGArgs, options);
                if (options.oneofs)
                    object.Arguments = "GetEPGArgs";
            }
            if (message.EPGArgs != null && message.hasOwnProperty("EPGArgs")) {
                object.EPGArgs = $root.mediaarchiver.ArgumentsEPG.toObject(message.EPGArgs, options);
                if (options.oneofs)
                    object.Arguments = "EPGArgs";
            }
            if (message.GetChunkArgs != null && message.hasOwnProperty("GetChunkArgs")) {
                object.GetChunkArgs = $root.mediaarchiver.ArgumentsGetChunk.toObject(message.GetChunkArgs, options);
                if (options.oneofs)
                    object.Arguments = "GetChunkArgs";
            }
            if (message.ChunkArgs != null && message.hasOwnProperty("ChunkArgs")) {
                object.ChunkArgs = $root.mediaarchiver.ArgumentsChunk.toObject(message.ChunkArgs, options);
                if (options.oneofs)
                    object.Arguments = "ChunkArgs";
            }
            if (message.GetContactsArgs != null && message.hasOwnProperty("GetContactsArgs")) {
                object.GetContactsArgs = $root.mediaarchiver.ArgumentsGetContacts.toObject(message.GetContactsArgs, options);
                if (options.oneofs)
                    object.Arguments = "GetContactsArgs";
            }
            if (message.ContactsArgs != null && message.hasOwnProperty("ContactsArgs")) {
                object.ContactsArgs = $root.mediaarchiver.ArgumentsContacts.toObject(message.ContactsArgs, options);
                if (options.oneofs)
                    object.Arguments = "ContactsArgs";
            }
            if (message.ContactsCountArg != null && message.hasOwnProperty("ContactsCountArg")) {
                object.ContactsCountArg = message.ContactsCountArg;
                if (options.oneofs)
                    object.Arguments = "ContactsCountArg";
            }
            if (message.CreateContactArgs != null && message.hasOwnProperty("CreateContactArgs")) {
                object.CreateContactArgs = $root.mediaarchiver.Contact.toObject(message.CreateContactArgs, options);
                if (options.oneofs)
                    object.Arguments = "CreateContactArgs";
            }
            if (message.EditContactArgs != null && message.hasOwnProperty("EditContactArgs")) {
                object.EditContactArgs = $root.mediaarchiver.Contact.toObject(message.EditContactArgs, options);
                if (options.oneofs)
                    object.Arguments = "EditContactArgs";
            }
            if (message.GetAnnotationTypesArgs != null && message.hasOwnProperty("GetAnnotationTypesArgs")) {
                object.GetAnnotationTypesArgs = $root.mediaarchiver.ArgumentsGetAnnotationTypes.toObject(message.GetAnnotationTypesArgs, options);
                if (options.oneofs)
                    object.Arguments = "GetAnnotationTypesArgs";
            }
            if (message.AnnotationTypesArgs != null && message.hasOwnProperty("AnnotationTypesArgs")) {
                object.AnnotationTypesArgs = $root.mediaarchiver.ArgumentsAnnotationTypes.toObject(message.AnnotationTypesArgs, options);
                if (options.oneofs)
                    object.Arguments = "AnnotationTypesArgs";
            }
            if (message.AnnotationTypesCountArg != null && message.hasOwnProperty("AnnotationTypesCountArg")) {
                object.AnnotationTypesCountArg = message.AnnotationTypesCountArg;
                if (options.oneofs)
                    object.Arguments = "AnnotationTypesCountArg";
            }
            if (message.CreateAnnotationTypeArgs != null && message.hasOwnProperty("CreateAnnotationTypeArgs")) {
                object.CreateAnnotationTypeArgs = $root.mediaarchiver.AnnotationType.toObject(message.CreateAnnotationTypeArgs, options);
                if (options.oneofs)
                    object.Arguments = "CreateAnnotationTypeArgs";
            }
            if (message.EditAnnotationTypeArgs != null && message.hasOwnProperty("EditAnnotationTypeArgs")) {
                object.EditAnnotationTypeArgs = $root.mediaarchiver.AnnotationType.toObject(message.EditAnnotationTypeArgs, options);
                if (options.oneofs)
                    object.Arguments = "EditAnnotationTypeArgs";
            }
            if (message.DeleteAnnotationTypeArg != null && message.hasOwnProperty("DeleteAnnotationTypeArg")) {
                object.DeleteAnnotationTypeArg = message.DeleteAnnotationTypeArg;
                if (options.oneofs)
                    object.Arguments = "DeleteAnnotationTypeArg";
            }
            if (message.CreateAnnotationArg != null && message.hasOwnProperty("CreateAnnotationArg")) {
                object.CreateAnnotationArg = $root.mediaarchiver.ArgumentsCreateAnnotation.toObject(message.CreateAnnotationArg, options);
                if (options.oneofs)
                    object.Arguments = "CreateAnnotationArg";
            }
            if (message.GetStreamArg != null && message.hasOwnProperty("GetStreamArg")) {
                object.GetStreamArg = $root.mediaarchiver.ArgumentsGetStream.toObject(message.GetStreamArg, options);
                if (options.oneofs)
                    object.Arguments = "GetStreamArg";
            }
            if (message.StreamArg != null && message.hasOwnProperty("StreamArg")) {
                object.StreamArg = $root.mediaarchiver.ArgumentsStream.toObject(message.StreamArg, options);
                if (options.oneofs)
                    object.Arguments = "StreamArg";
            }
            if (message.SearchProgramArgs != null && message.hasOwnProperty("SearchProgramArgs")) {
                object.SearchProgramArgs = $root.mediaarchiver.ArgumentsSearchPrograms.toObject(message.SearchProgramArgs, options);
                if (options.oneofs)
                    object.Arguments = "SearchProgramArgs";
            }
            if (message.SearchResultsArgs != null && message.hasOwnProperty("SearchResultsArgs")) {
                object.SearchResultsArgs = $root.mediaarchiver.ArgumentsSearchResults.toObject(message.SearchResultsArgs, options);
                if (options.oneofs)
                    object.Arguments = "SearchResultsArgs";
            }
            if (message.GetFTPAccountsArgs != null && message.hasOwnProperty("GetFTPAccountsArgs")) {
                object.GetFTPAccountsArgs = $root.mediaarchiver.ArgumentsGetFTPAccounts.toObject(message.GetFTPAccountsArgs, options);
                if (options.oneofs)
                    object.Arguments = "GetFTPAccountsArgs";
            }
            if (message.FTPAccountsArgs != null && message.hasOwnProperty("FTPAccountsArgs")) {
                object.FTPAccountsArgs = $root.mediaarchiver.ArgumentsFTPAccounts.toObject(message.FTPAccountsArgs, options);
                if (options.oneofs)
                    object.Arguments = "FTPAccountsArgs";
            }
            if (message.FTPAccountsCountArg != null && message.hasOwnProperty("FTPAccountsCountArg")) {
                object.FTPAccountsCountArg = message.FTPAccountsCountArg;
                if (options.oneofs)
                    object.Arguments = "FTPAccountsCountArg";
            }
            if (message.CreateFTPAccountArgs != null && message.hasOwnProperty("CreateFTPAccountArgs")) {
                object.CreateFTPAccountArgs = $root.mediaarchiver.FTPAccount.toObject(message.CreateFTPAccountArgs, options);
                if (options.oneofs)
                    object.Arguments = "CreateFTPAccountArgs";
            }
            if (message.EditFTPAccountArgs != null && message.hasOwnProperty("EditFTPAccountArgs")) {
                object.EditFTPAccountArgs = $root.mediaarchiver.FTPAccount.toObject(message.EditFTPAccountArgs, options);
                if (options.oneofs)
                    object.Arguments = "EditFTPAccountArgs";
            }
            if (message.DeleteFTPAccountArg != null && message.hasOwnProperty("DeleteFTPAccountArg")) {
                object.DeleteFTPAccountArg = message.DeleteFTPAccountArg;
                if (options.oneofs)
                    object.Arguments = "DeleteFTPAccountArg";
            }
            if (message.GetSFTPAccountsArgs != null && message.hasOwnProperty("GetSFTPAccountsArgs")) {
                object.GetSFTPAccountsArgs = $root.mediaarchiver.ArgumentsGetSFTPAccounts.toObject(message.GetSFTPAccountsArgs, options);
                if (options.oneofs)
                    object.Arguments = "GetSFTPAccountsArgs";
            }
            if (message.SFTPAccountsArgs != null && message.hasOwnProperty("SFTPAccountsArgs")) {
                object.SFTPAccountsArgs = $root.mediaarchiver.ArgumentsSFTPAccounts.toObject(message.SFTPAccountsArgs, options);
                if (options.oneofs)
                    object.Arguments = "SFTPAccountsArgs";
            }
            if (message.SFTPAccountsCountArg != null && message.hasOwnProperty("SFTPAccountsCountArg")) {
                object.SFTPAccountsCountArg = message.SFTPAccountsCountArg;
                if (options.oneofs)
                    object.Arguments = "SFTPAccountsCountArg";
            }
            if (message.CreateSFTPAccountArgs != null && message.hasOwnProperty("CreateSFTPAccountArgs")) {
                object.CreateSFTPAccountArgs = $root.mediaarchiver.SFTPAccount.toObject(message.CreateSFTPAccountArgs, options);
                if (options.oneofs)
                    object.Arguments = "CreateSFTPAccountArgs";
            }
            if (message.EditSFTPAccountArgs != null && message.hasOwnProperty("EditSFTPAccountArgs")) {
                object.EditSFTPAccountArgs = $root.mediaarchiver.SFTPAccount.toObject(message.EditSFTPAccountArgs, options);
                if (options.oneofs)
                    object.Arguments = "EditSFTPAccountArgs";
            }
            if (message.DeleteSFTPAccountArg != null && message.hasOwnProperty("DeleteSFTPAccountArg")) {
                object.DeleteSFTPAccountArg = message.DeleteSFTPAccountArg;
                if (options.oneofs)
                    object.Arguments = "DeleteSFTPAccountArg";
            }
            if (message.SetAccountOptionsArg != null && message.hasOwnProperty("SetAccountOptionsArg")) {
                object.SetAccountOptionsArg = $root.mediaarchiver.UserOptionsList.toObject(message.SetAccountOptionsArg, options);
                if (options.oneofs)
                    object.Arguments = "SetAccountOptionsArg";
            }
            if (message.AnnotationsArg != null && message.hasOwnProperty("AnnotationsArg")) {
                object.AnnotationsArg = $root.mediaarchiver.ArgumentsAnnotations.toObject(message.AnnotationsArg, options);
                if (options.oneofs)
                    object.Arguments = "AnnotationsArg";
            }
            if (message.GetAnnotationsArg != null && message.hasOwnProperty("GetAnnotationsArg")) {
                object.GetAnnotationsArg = $root.mediaarchiver.ArgumentsGetAnnotations.toObject(message.GetAnnotationsArg, options);
                if (options.oneofs)
                    object.Arguments = "GetAnnotationsArg";
            }
            if (message.DeleteAnnotationArg != null && message.hasOwnProperty("DeleteAnnotationArg")) {
                object.DeleteAnnotationArg = $root.mediaarchiver.ArgumentsDeleteAnnotation.toObject(message.DeleteAnnotationArg, options);
                if (options.oneofs)
                    object.Arguments = "DeleteAnnotationArg";
            }
            if (message.CreateArchiveArg != null && message.hasOwnProperty("CreateArchiveArg")) {
                object.CreateArchiveArg = $root.mediaarchiver.Archive.toObject(message.CreateArchiveArg, options);
                if (options.oneofs)
                    object.Arguments = "CreateArchiveArg";
            }
            if (message.GetArchivesArg != null && message.hasOwnProperty("GetArchivesArg")) {
                object.GetArchivesArg = $root.mediaarchiver.ArgumentsGetArchives.toObject(message.GetArchivesArg, options);
                if (options.oneofs)
                    object.Arguments = "GetArchivesArg";
            }
            if (message.EditArchiveArg != null && message.hasOwnProperty("EditArchiveArg")) {
                object.EditArchiveArg = $root.mediaarchiver.Archive.toObject(message.EditArchiveArg, options);
                if (options.oneofs)
                    object.Arguments = "EditArchiveArg";
            }
            if (message.DeleteArchiveArg != null && message.hasOwnProperty("DeleteArchiveArg")) {
                object.DeleteArchiveArg = message.DeleteArchiveArg;
                if (options.oneofs)
                    object.Arguments = "DeleteArchiveArg";
            }
            if (message.ArchivesArg != null && message.hasOwnProperty("ArchivesArg")) {
                object.ArchivesArg = $root.mediaarchiver.ArgumentsArchives.toObject(message.ArchivesArg, options);
                if (options.oneofs)
                    object.Arguments = "ArchivesArg";
            }
            if (message.ArchivesCountArg != null && message.hasOwnProperty("ArchivesCountArg")) {
                object.ArchivesCountArg = $root.mediaarchiver.ArgumentsArchivesCount.toObject(message.ArchivesCountArg, options);
                if (options.oneofs)
                    object.Arguments = "ArchivesCountArg";
            }
            if (message.GetArchiveArg != null && message.hasOwnProperty("GetArchiveArg")) {
                object.GetArchiveArg = message.GetArchiveArg;
                if (options.oneofs)
                    object.Arguments = "GetArchiveArg";
            }
            if (message.ArchiveArg != null && message.hasOwnProperty("ArchiveArg")) {
                object.ArchiveArg = $root.mediaarchiver.Archive.toObject(message.ArchiveArg, options);
                if (options.oneofs)
                    object.Arguments = "ArchiveArg";
            }
            if (message.GetReviewsArg != null && message.hasOwnProperty("GetReviewsArg")) {
                object.GetReviewsArg = $root.mediaarchiver.ArgumentsGetReviews.toObject(message.GetReviewsArg, options);
                if (options.oneofs)
                    object.Arguments = "GetReviewsArg";
            }
            if (message.ReviewsArg != null && message.hasOwnProperty("ReviewsArg")) {
                object.ReviewsArg = $root.mediaarchiver.ArgumentsReviews.toObject(message.ReviewsArg, options);
                if (options.oneofs)
                    object.Arguments = "ReviewsArg";
            }
            if (message.ReviewArg != null && message.hasOwnProperty("ReviewArg")) {
                object.ReviewArg = $root.mediaarchiver.Review.toObject(message.ReviewArg, options);
                if (options.oneofs)
                    object.Arguments = "ReviewArg";
            }
            if (message.ContactArg != null && message.hasOwnProperty("ContactArg")) {
                object.ContactArg = $root.mediaarchiver.Contact.toObject(message.ContactArg, options);
                if (options.oneofs)
                    object.Arguments = "ContactArg";
            }
            if (message.FTPAccountArg != null && message.hasOwnProperty("FTPAccountArg")) {
                object.FTPAccountArg = $root.mediaarchiver.FTPAccount.toObject(message.FTPAccountArg, options);
                if (options.oneofs)
                    object.Arguments = "FTPAccountArg";
            }
            if (message.SFTPAccountArg != null && message.hasOwnProperty("SFTPAccountArg")) {
                object.SFTPAccountArg = $root.mediaarchiver.SFTPAccount.toObject(message.SFTPAccountArg, options);
                if (options.oneofs)
                    object.Arguments = "SFTPAccountArg";
            }
            if (message.DeleteContactArg != null && message.hasOwnProperty("DeleteContactArg")) {
                object.DeleteContactArg = message.DeleteContactArg;
                if (options.oneofs)
                    object.Arguments = "DeleteContactArg";
            }
            if (message.IncArchiveCounterArg != null && message.hasOwnProperty("IncArchiveCounterArg")) {
                object.IncArchiveCounterArg = $root.mediaarchiver.ArgumentsIncArchiveCounter.toObject(message.IncArchiveCounterArg, options);
                if (options.oneofs)
                    object.Arguments = "IncArchiveCounterArg";
            }
            if (message.GetMailArg != null && message.hasOwnProperty("GetMailArg")) {
                object.GetMailArg = message.GetMailArg;
                if (options.oneofs)
                    object.Arguments = "GetMailArg";
            }
            if (message.MailArg != null && message.hasOwnProperty("MailArg")) {
                object.MailArg = message.MailArg;
                if (options.oneofs)
                    object.Arguments = "MailArg";
            }
            if (message.BlockMailArg != null && message.hasOwnProperty("BlockMailArg")) {
                object.BlockMailArg = $root.mediaarchiver.ArgumentsBlockMail.toObject(message.BlockMailArg, options);
                if (options.oneofs)
                    object.Arguments = "BlockMailArg";
            }
            if (message.EditAnnotationArg != null && message.hasOwnProperty("EditAnnotationArg")) {
                object.EditAnnotationArg = $root.mediaarchiver.Annotation.toObject(message.EditAnnotationArg, options);
                if (options.oneofs)
                    object.Arguments = "EditAnnotationArg";
            }
            if (message.PanelsArg != null && message.hasOwnProperty("PanelsArg")) {
                object.PanelsArg = $root.mediaarchiver.Panels.toObject(message.PanelsArg, options);
                if (options.oneofs)
                    object.Arguments = "PanelsArg";
            }
            if (message.SearchKindArg != null && message.hasOwnProperty("SearchKindArg")) {
                object.SearchKindArg = message.SearchKindArg;
                if (options.oneofs)
                    object.Arguments = "SearchKindArg";
            }
            if (message.SearchKindResultsArg != null && message.hasOwnProperty("SearchKindResultsArg")) {
                object.SearchKindResultsArg = $root.mediaarchiver.SearchKindResult.toObject(message.SearchKindResultsArg, options);
                if (options.oneofs)
                    object.Arguments = "SearchKindResultsArg";
            }
            if (message.DeleteMultipleAnnotationsArg != null && message.hasOwnProperty("DeleteMultipleAnnotationsArg")) {
                object.DeleteMultipleAnnotationsArg = $root.mediaarchiver.MultipleIDs.toObject(message.DeleteMultipleAnnotationsArg, options);
                if (options.oneofs)
                    object.Arguments = "DeleteMultipleAnnotationsArg";
            }
            if (message.GetAnnotationTypesOwnedArgs != null && message.hasOwnProperty("GetAnnotationTypesOwnedArgs")) {
                object.GetAnnotationTypesOwnedArgs = $root.mediaarchiver.ArgumentsGetAnnotationTypes.toObject(message.GetAnnotationTypesOwnedArgs, options);
                if (options.oneofs)
                    object.Arguments = "GetAnnotationTypesOwnedArgs";
            }
            if (message.AnnotationTypesOwnedArgs != null && message.hasOwnProperty("AnnotationTypesOwnedArgs")) {
                object.AnnotationTypesOwnedArgs = $root.mediaarchiver.ArgumentsAnnotationTypes.toObject(message.AnnotationTypesOwnedArgs, options);
                if (options.oneofs)
                    object.Arguments = "AnnotationTypesOwnedArgs";
            }
            if (message.AnnotationTypesOwnedCountArg != null && message.hasOwnProperty("AnnotationTypesOwnedCountArg")) {
                object.AnnotationTypesOwnedCountArg = message.AnnotationTypesOwnedCountArg;
                if (options.oneofs)
                    object.Arguments = "AnnotationTypesOwnedCountArg";
            }
            if (message.RetryArchiveArg != null && message.hasOwnProperty("RetryArchiveArg")) {
                object.RetryArchiveArg = message.RetryArchiveArg;
                if (options.oneofs)
                    object.Arguments = "RetryArchiveArg";
            }
            if (message.ShareArchiveArg != null && message.hasOwnProperty("ShareArchiveArg")) {
                object.ShareArchiveArg = $root.mediaarchiver.ArgumentsShareArchive.toObject(message.ShareArchiveArg, options);
                if (options.oneofs)
                    object.Arguments = "ShareArchiveArg";
            }
            if (message.ExportAnnotationArg != null && message.hasOwnProperty("ExportAnnotationArg")) {
                object.ExportAnnotationArg = $root.mediaarchiver.ArgumentsExportAnnotations.toObject(message.ExportAnnotationArg, options);
                if (options.oneofs)
                    object.Arguments = "ExportAnnotationArg";
            }
            if (message.AdminGetUserArg != null && message.hasOwnProperty("AdminGetUserArg")) {
                object.AdminGetUserArg = message.AdminGetUserArg;
                if (options.oneofs)
                    object.Arguments = "AdminGetUserArg";
            }
            if (message.AdminSearchUsersArgs != null && message.hasOwnProperty("AdminSearchUsersArgs")) {
                object.AdminSearchUsersArgs = $root.mediaarchiver.AdminSearchUsers.toObject(message.AdminSearchUsersArgs, options);
                if (options.oneofs)
                    object.Arguments = "AdminSearchUsersArgs";
            }
            if (message.AdminEditUserArg != null && message.hasOwnProperty("AdminEditUserArg")) {
                object.AdminEditUserArg = $root.mediaarchiver.AdminUser.toObject(message.AdminEditUserArg, options);
                if (options.oneofs)
                    object.Arguments = "AdminEditUserArg";
            }
            if (message.AdminUserArg != null && message.hasOwnProperty("AdminUserArg")) {
                object.AdminUserArg = $root.mediaarchiver.AdminUser.toObject(message.AdminUserArg, options);
                if (options.oneofs)
                    object.Arguments = "AdminUserArg";
            }
            if (message.AdminSearchUsersResultArg != null && message.hasOwnProperty("AdminSearchUsersResultArg")) {
                object.AdminSearchUsersResultArg = $root.mediaarchiver.AdminUsers.toObject(message.AdminSearchUsersResultArg, options);
                if (options.oneofs)
                    object.Arguments = "AdminSearchUsersResultArg";
            }
            if (message.AdminLastUsersArg != null && message.hasOwnProperty("AdminLastUsersArg")) {
                object.AdminLastUsersArg = $root.mediaarchiver.AdminUsers.toObject(message.AdminLastUsersArg, options);
                if (options.oneofs)
                    object.Arguments = "AdminLastUsersArg";
            }
            if (message.InlineAnnotationsArg != null && message.hasOwnProperty("InlineAnnotationsArg")) {
                object.InlineAnnotationsArg = message.InlineAnnotationsArg;
                if (options.oneofs)
                    object.Arguments = "InlineAnnotationsArg";
            }
            if (message.TalkAutocompleteNameArg != null && message.hasOwnProperty("TalkAutocompleteNameArg")) {
                object.TalkAutocompleteNameArg = $root.mediaarchiver.TalkAutocompleteName.toObject(message.TalkAutocompleteNameArg, options);
                if (options.oneofs)
                    object.Arguments = "TalkAutocompleteNameArg";
            }
            if (message.TalkGetPersonArg != null && message.hasOwnProperty("TalkGetPersonArg")) {
                object.TalkGetPersonArg = message.TalkGetPersonArg;
                if (options.oneofs)
                    object.Arguments = "TalkGetPersonArg";
            }
            if (message.TalkAutocompleteNameSuggsArgs != null && message.hasOwnProperty("TalkAutocompleteNameSuggsArgs")) {
                object.TalkAutocompleteNameSuggsArgs = $root.mediaarchiver.TalkPersonSuggs.toObject(message.TalkAutocompleteNameSuggsArgs, options);
                if (options.oneofs)
                    object.Arguments = "TalkAutocompleteNameSuggsArgs";
            }
            if (message.TalkPersonArg != null && message.hasOwnProperty("TalkPersonArg")) {
                object.TalkPersonArg = $root.mediaarchiver.TalkPerson.toObject(message.TalkPersonArg, options);
                if (options.oneofs)
                    object.Arguments = "TalkPersonArg";
            }
            if (message.TalkCreateArg != null && message.hasOwnProperty("TalkCreateArg")) {
                object.TalkCreateArg = $root.mediaarchiver.Talk.toObject(message.TalkCreateArg, options);
                if (options.oneofs)
                    object.Arguments = "TalkCreateArg";
            }
            if (message.TalkEditArg != null && message.hasOwnProperty("TalkEditArg")) {
                object.TalkEditArg = $root.mediaarchiver.Talk.toObject(message.TalkEditArg, options);
                if (options.oneofs)
                    object.Arguments = "TalkEditArg";
            }
            if (message.TalkDeleteArg != null && message.hasOwnProperty("TalkDeleteArg")) {
                object.TalkDeleteArg = message.TalkDeleteArg;
                if (options.oneofs)
                    object.Arguments = "TalkDeleteArg";
            }
            if (message.TalksArg != null && message.hasOwnProperty("TalksArg")) {
                object.TalksArg = $root.mediaarchiver.ArgumentsTalks.toObject(message.TalksArg, options);
                if (options.oneofs)
                    object.Arguments = "TalksArg";
            }
            if (message.GetTalksArg != null && message.hasOwnProperty("GetTalksArg")) {
                object.GetTalksArg = $root.mediaarchiver.ArgumentsGetTalks.toObject(message.GetTalksArg, options);
                if (options.oneofs)
                    object.Arguments = "GetTalksArg";
            }
            if (message.DeleteMultipleTalksArg != null && message.hasOwnProperty("DeleteMultipleTalksArg")) {
                object.DeleteMultipleTalksArg = $root.mediaarchiver.MultipleIDs.toObject(message.DeleteMultipleTalksArg, options);
                if (options.oneofs)
                    object.Arguments = "DeleteMultipleTalksArg";
            }
            if (message.ExportTalksArg != null && message.hasOwnProperty("ExportTalksArg")) {
                object.ExportTalksArg = $root.mediaarchiver.ArgumentsExportTalks.toObject(message.ExportTalksArg, options);
                if (options.oneofs)
                    object.Arguments = "ExportTalksArg";
            }
            if (message.SearchSpeechesArgs != null && message.hasOwnProperty("SearchSpeechesArgs")) {
                object.SearchSpeechesArgs = $root.mediaarchiver.SearchSpeeches.toObject(message.SearchSpeechesArgs, options);
                if (options.oneofs)
                    object.Arguments = "SearchSpeechesArgs";
            }
            if (message.SearchSpeechesResultArgs != null && message.hasOwnProperty("SearchSpeechesResultArgs")) {
                object.SearchSpeechesResultArgs = $root.mediaarchiver.SearchSpeechesResult.toObject(message.SearchSpeechesResultArgs, options);
                if (options.oneofs)
                    object.Arguments = "SearchSpeechesResultArgs";
            }
            if (message.AnnotationDirectArg != null && message.hasOwnProperty("AnnotationDirectArg")) {
                object.AnnotationDirectArg = message.AnnotationDirectArg;
                if (options.oneofs)
                    object.Arguments = "AnnotationDirectArg";
            }
            if (message.ExpiringTokenArg != null && message.hasOwnProperty("ExpiringTokenArg")) {
                object.ExpiringTokenArg = $root.mediaarchiver.ExpiringToken.toObject(message.ExpiringTokenArg, options);
                if (options.oneofs)
                    object.Arguments = "ExpiringTokenArg";
            }
            if (message.SearchWordsArgs != null && message.hasOwnProperty("SearchWordsArgs")) {
                object.SearchWordsArgs = $root.mediaarchiver.SearchWords.toObject(message.SearchWordsArgs, options);
                if (options.oneofs)
                    object.Arguments = "SearchWordsArgs";
            }
            if (message.SearchWordsResultArgs != null && message.hasOwnProperty("SearchWordsResultArgs")) {
                object.SearchWordsResultArgs = $root.mediaarchiver.SearchWordsResult.toObject(message.SearchWordsResultArgs, options);
                if (options.oneofs)
                    object.Arguments = "SearchWordsResultArgs";
            }
            if (message.TalkStudiesArgs != null && message.hasOwnProperty("TalkStudiesArgs")) {
                object.TalkStudiesArgs = $root.mediaarchiver.TalkStudies.toObject(message.TalkStudiesArgs, options);
                if (options.oneofs)
                    object.Arguments = "TalkStudiesArgs";
            }
            if (message.TalkProgramTypesArgs != null && message.hasOwnProperty("TalkProgramTypesArgs")) {
                object.TalkProgramTypesArgs = $root.mediaarchiver.TalkProgramTypes.toObject(message.TalkProgramTypesArgs, options);
                if (options.oneofs)
                    object.Arguments = "TalkProgramTypesArgs";
            }
            if (message.TalkDistrictsArgs != null && message.hasOwnProperty("TalkDistrictsArgs")) {
                object.TalkDistrictsArgs = $root.mediaarchiver.TalkDistricts.toObject(message.TalkDistrictsArgs, options);
                if (options.oneofs)
                    object.Arguments = "TalkDistrictsArgs";
            }
            if (message.TalkGetDistrictsArg != null && message.hasOwnProperty("TalkGetDistrictsArg")) {
                object.TalkGetDistrictsArg = $root.mediaarchiver.TalkGetDistricts.toObject(message.TalkGetDistrictsArg, options);
                if (options.oneofs)
                    object.Arguments = "TalkGetDistrictsArg";
            }
            if (message.TalkAllGroupsArg != null && message.hasOwnProperty("TalkAllGroupsArg")) {
                object.TalkAllGroupsArg = $root.mediaarchiver.TalkGroups.toObject(message.TalkAllGroupsArg, options);
                if (options.oneofs)
                    object.Arguments = "TalkAllGroupsArg";
            }
            if (message.TalkAllRegimsArg != null && message.hasOwnProperty("TalkAllRegimsArg")) {
                object.TalkAllRegimsArg = $root.mediaarchiver.TalkRegims.toObject(message.TalkAllRegimsArg, options);
                if (options.oneofs)
                    object.Arguments = "TalkAllRegimsArg";
            }
            if (message.TalkAllTitlesArg != null && message.hasOwnProperty("TalkAllTitlesArg")) {
                object.TalkAllTitlesArg = $root.mediaarchiver.TalkTitles.toObject(message.TalkAllTitlesArg, options);
                if (options.oneofs)
                    object.Arguments = "TalkAllTitlesArg";
            }
            if (message.TalkMediasArg != null && message.hasOwnProperty("TalkMediasArg")) {
                object.TalkMediasArg = $root.mediaarchiver.MediaList.toObject(message.TalkMediasArg, options);
                if (options.oneofs)
                    object.Arguments = "TalkMediasArg";
            }
            if (message.TalkExportedTalksArg != null && message.hasOwnProperty("TalkExportedTalksArg")) {
                object.TalkExportedTalksArg = message.TalkExportedTalksArg;
                if (options.oneofs)
                    object.Arguments = "TalkExportedTalksArg";
            }
            if (message.SearchSpeechesDateArgs != null && message.hasOwnProperty("SearchSpeechesDateArgs")) {
                object.SearchSpeechesDateArgs = $root.mediaarchiver.SearchSpeechesDate.toObject(message.SearchSpeechesDateArgs, options);
                if (options.oneofs)
                    object.Arguments = "SearchSpeechesDateArgs";
            }
            if (message.SearchSpeechesDateResultArgs != null && message.hasOwnProperty("SearchSpeechesDateResultArgs")) {
                object.SearchSpeechesDateResultArgs = $root.mediaarchiver.SearchSpeechesDateResult.toObject(message.SearchSpeechesDateResultArgs, options);
                if (options.oneofs)
                    object.Arguments = "SearchSpeechesDateResultArgs";
            }
            if (message.PlayerChunksStatsArg != null && message.hasOwnProperty("PlayerChunksStatsArg")) {
                object.PlayerChunksStatsArg = $root.mediaarchiver.PlayerStatsChunks.toObject(message.PlayerChunksStatsArg, options);
                if (options.oneofs)
                    object.Arguments = "PlayerChunksStatsArg";
            }
            if (message.PlayerManifestStatsArg != null && message.hasOwnProperty("PlayerManifestStatsArg")) {
                object.PlayerManifestStatsArg = $root.mediaarchiver.PlayerStatsManifest.toObject(message.PlayerManifestStatsArg, options);
                if (options.oneofs)
                    object.Arguments = "PlayerManifestStatsArg";
            }
            if (message.GetMediasSTTArgs != null && message.hasOwnProperty("GetMediasSTTArgs")) {
                object.GetMediasSTTArgs = $root.mediaarchiver.ArgumentsGetMediasSTT.toObject(message.GetMediasSTTArgs, options);
                if (options.oneofs)
                    object.Arguments = "GetMediasSTTArgs";
            }
            if (message.STTMediasArg != null && message.hasOwnProperty("STTMediasArg")) {
                object.STTMediasArg = $root.mediaarchiver.MediaList.toObject(message.STTMediasArg, options);
                if (options.oneofs)
                    object.Arguments = "STTMediasArg";
            }
            if (message.ReportBugArg != null && message.hasOwnProperty("ReportBugArg")) {
                object.ReportBugArg = $root.mediaarchiver.ReportedBug.toObject(message.ReportBugArg, options);
                if (options.oneofs)
                    object.Arguments = "ReportBugArg";
            }
            if (message.GetMediasBackgroundArgs != null && message.hasOwnProperty("GetMediasBackgroundArgs")) {
                object.GetMediasBackgroundArgs = $root.mediaarchiver.ArgumentsGetMediasBackground.toObject(message.GetMediasBackgroundArgs, options);
                if (options.oneofs)
                    object.Arguments = "GetMediasBackgroundArgs";
            }
            if (message.BackgroundMediasArg != null && message.hasOwnProperty("BackgroundMediasArg")) {
                object.BackgroundMediasArg = $root.mediaarchiver.MediaList.toObject(message.BackgroundMediasArg, options);
                if (options.oneofs)
                    object.Arguments = "BackgroundMediasArg";
            }
            if (message.GetMediasCrossBucketArgs != null && message.hasOwnProperty("GetMediasCrossBucketArgs")) {
                object.GetMediasCrossBucketArgs = $root.mediaarchiver.ArgumentsGetMediasCrossBucket.toObject(message.GetMediasCrossBucketArgs, options);
                if (options.oneofs)
                    object.Arguments = "GetMediasCrossBucketArgs";
            }
            if (message.CrossBucketMediasArg != null && message.hasOwnProperty("CrossBucketMediasArg")) {
                object.CrossBucketMediasArg = $root.mediaarchiver.MediaList.toObject(message.CrossBucketMediasArg, options);
                if (options.oneofs)
                    object.Arguments = "CrossBucketMediasArg";
            }
            return object;
        };

        /**
         * Converts this WSMessage to JSON.
         * @function toJSON
         * @memberof mediaarchiver.WSMessage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        WSMessage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return WSMessage;
    })();

    mediaarchiver.AdminUser = (function() {

        /**
         * Properties of an AdminUser.
         * @memberof mediaarchiver
         * @interface IAdminUser
         * @property {number|null} [ID] AdminUser ID
         * @property {string|null} [Name] AdminUser Name
         * @property {number|null} [GroupName] AdminUser GroupName
         * @property {Array.<number>|null} [Medias] AdminUser Medias
         * @property {Array.<number>|null} [GroupMedias] AdminUser GroupMedias
         * @property {number|Long|null} [LastAction] AdminUser LastAction
         */

        /**
         * Constructs a new AdminUser.
         * @memberof mediaarchiver
         * @classdesc Represents an AdminUser.
         * @implements IAdminUser
         * @constructor
         * @param {mediaarchiver.IAdminUser=} [properties] Properties to set
         */
        function AdminUser(properties) {
            this.Medias = [];
            this.GroupMedias = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AdminUser ID.
         * @member {number} ID
         * @memberof mediaarchiver.AdminUser
         * @instance
         */
        AdminUser.prototype.ID = 0;

        /**
         * AdminUser Name.
         * @member {string} Name
         * @memberof mediaarchiver.AdminUser
         * @instance
         */
        AdminUser.prototype.Name = "";

        /**
         * AdminUser GroupName.
         * @member {number} GroupName
         * @memberof mediaarchiver.AdminUser
         * @instance
         */
        AdminUser.prototype.GroupName = 0;

        /**
         * AdminUser Medias.
         * @member {Array.<number>} Medias
         * @memberof mediaarchiver.AdminUser
         * @instance
         */
        AdminUser.prototype.Medias = $util.emptyArray;

        /**
         * AdminUser GroupMedias.
         * @member {Array.<number>} GroupMedias
         * @memberof mediaarchiver.AdminUser
         * @instance
         */
        AdminUser.prototype.GroupMedias = $util.emptyArray;

        /**
         * AdminUser LastAction.
         * @member {number|Long} LastAction
         * @memberof mediaarchiver.AdminUser
         * @instance
         */
        AdminUser.prototype.LastAction = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new AdminUser instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.AdminUser
         * @static
         * @param {mediaarchiver.IAdminUser=} [properties] Properties to set
         * @returns {mediaarchiver.AdminUser} AdminUser instance
         */
        AdminUser.create = function create(properties) {
            return new AdminUser(properties);
        };

        /**
         * Encodes the specified AdminUser message. Does not implicitly {@link mediaarchiver.AdminUser.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.AdminUser
         * @static
         * @param {mediaarchiver.IAdminUser} message AdminUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AdminUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.ID);
            if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
            if (message.GroupName != null && Object.hasOwnProperty.call(message, "GroupName"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.GroupName);
            if (message.Medias != null && message.Medias.length) {
                writer.uint32(/* id 4, wireType 2 =*/34).fork();
                for (let i = 0; i < message.Medias.length; ++i)
                    writer.uint32(message.Medias[i]);
                writer.ldelim();
            }
            if (message.GroupMedias != null && message.GroupMedias.length) {
                writer.uint32(/* id 5, wireType 2 =*/42).fork();
                for (let i = 0; i < message.GroupMedias.length; ++i)
                    writer.uint32(message.GroupMedias[i]);
                writer.ldelim();
            }
            if (message.LastAction != null && Object.hasOwnProperty.call(message, "LastAction"))
                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.LastAction);
            return writer;
        };

        /**
         * Encodes the specified AdminUser message, length delimited. Does not implicitly {@link mediaarchiver.AdminUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.AdminUser
         * @static
         * @param {mediaarchiver.IAdminUser} message AdminUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AdminUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AdminUser message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.AdminUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.AdminUser} AdminUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AdminUser.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.AdminUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ID = reader.uint32();
                    break;
                case 2:
                    message.Name = reader.string();
                    break;
                case 3:
                    message.GroupName = reader.uint32();
                    break;
                case 4:
                    if (!(message.Medias && message.Medias.length))
                        message.Medias = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.Medias.push(reader.uint32());
                    } else
                        message.Medias.push(reader.uint32());
                    break;
                case 5:
                    if (!(message.GroupMedias && message.GroupMedias.length))
                        message.GroupMedias = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.GroupMedias.push(reader.uint32());
                    } else
                        message.GroupMedias.push(reader.uint32());
                    break;
                case 6:
                    message.LastAction = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AdminUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.AdminUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.AdminUser} AdminUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AdminUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AdminUser message.
         * @function verify
         * @memberof mediaarchiver.AdminUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AdminUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isInteger(message.ID))
                    return "ID: integer expected";
            if (message.Name != null && message.hasOwnProperty("Name"))
                if (!$util.isString(message.Name))
                    return "Name: string expected";
            if (message.GroupName != null && message.hasOwnProperty("GroupName"))
                if (!$util.isInteger(message.GroupName))
                    return "GroupName: integer expected";
            if (message.Medias != null && message.hasOwnProperty("Medias")) {
                if (!Array.isArray(message.Medias))
                    return "Medias: array expected";
                for (let i = 0; i < message.Medias.length; ++i)
                    if (!$util.isInteger(message.Medias[i]))
                        return "Medias: integer[] expected";
            }
            if (message.GroupMedias != null && message.hasOwnProperty("GroupMedias")) {
                if (!Array.isArray(message.GroupMedias))
                    return "GroupMedias: array expected";
                for (let i = 0; i < message.GroupMedias.length; ++i)
                    if (!$util.isInteger(message.GroupMedias[i]))
                        return "GroupMedias: integer[] expected";
            }
            if (message.LastAction != null && message.hasOwnProperty("LastAction"))
                if (!$util.isInteger(message.LastAction) && !(message.LastAction && $util.isInteger(message.LastAction.low) && $util.isInteger(message.LastAction.high)))
                    return "LastAction: integer|Long expected";
            return null;
        };

        /**
         * Creates an AdminUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.AdminUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.AdminUser} AdminUser
         */
        AdminUser.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.AdminUser)
                return object;
            let message = new $root.mediaarchiver.AdminUser();
            if (object.ID != null)
                message.ID = object.ID >>> 0;
            if (object.Name != null)
                message.Name = String(object.Name);
            if (object.GroupName != null)
                message.GroupName = object.GroupName >>> 0;
            if (object.Medias) {
                if (!Array.isArray(object.Medias))
                    throw TypeError(".mediaarchiver.AdminUser.Medias: array expected");
                message.Medias = [];
                for (let i = 0; i < object.Medias.length; ++i)
                    message.Medias[i] = object.Medias[i] >>> 0;
            }
            if (object.GroupMedias) {
                if (!Array.isArray(object.GroupMedias))
                    throw TypeError(".mediaarchiver.AdminUser.GroupMedias: array expected");
                message.GroupMedias = [];
                for (let i = 0; i < object.GroupMedias.length; ++i)
                    message.GroupMedias[i] = object.GroupMedias[i] >>> 0;
            }
            if (object.LastAction != null)
                if ($util.Long)
                    (message.LastAction = $util.Long.fromValue(object.LastAction)).unsigned = false;
                else if (typeof object.LastAction === "string")
                    message.LastAction = parseInt(object.LastAction, 10);
                else if (typeof object.LastAction === "number")
                    message.LastAction = object.LastAction;
                else if (typeof object.LastAction === "object")
                    message.LastAction = new $util.LongBits(object.LastAction.low >>> 0, object.LastAction.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from an AdminUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.AdminUser
         * @static
         * @param {mediaarchiver.AdminUser} message AdminUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AdminUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.Medias = [];
                object.GroupMedias = [];
            }
            if (options.defaults) {
                object.ID = 0;
                object.Name = "";
                object.GroupName = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.LastAction = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.LastAction = options.longs === String ? "0" : 0;
            }
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            if (message.Name != null && message.hasOwnProperty("Name"))
                object.Name = message.Name;
            if (message.GroupName != null && message.hasOwnProperty("GroupName"))
                object.GroupName = message.GroupName;
            if (message.Medias && message.Medias.length) {
                object.Medias = [];
                for (let j = 0; j < message.Medias.length; ++j)
                    object.Medias[j] = message.Medias[j];
            }
            if (message.GroupMedias && message.GroupMedias.length) {
                object.GroupMedias = [];
                for (let j = 0; j < message.GroupMedias.length; ++j)
                    object.GroupMedias[j] = message.GroupMedias[j];
            }
            if (message.LastAction != null && message.hasOwnProperty("LastAction"))
                if (typeof message.LastAction === "number")
                    object.LastAction = options.longs === String ? String(message.LastAction) : message.LastAction;
                else
                    object.LastAction = options.longs === String ? $util.Long.prototype.toString.call(message.LastAction) : options.longs === Number ? new $util.LongBits(message.LastAction.low >>> 0, message.LastAction.high >>> 0).toNumber() : message.LastAction;
            return object;
        };

        /**
         * Converts this AdminUser to JSON.
         * @function toJSON
         * @memberof mediaarchiver.AdminUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AdminUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AdminUser;
    })();

    mediaarchiver.AdminUsers = (function() {

        /**
         * Properties of an AdminUsers.
         * @memberof mediaarchiver
         * @interface IAdminUsers
         * @property {Array.<mediaarchiver.IAdminUser>|null} [Users] AdminUsers Users
         * @property {number|null} [Total] AdminUsers Total
         */

        /**
         * Constructs a new AdminUsers.
         * @memberof mediaarchiver
         * @classdesc Represents an AdminUsers.
         * @implements IAdminUsers
         * @constructor
         * @param {mediaarchiver.IAdminUsers=} [properties] Properties to set
         */
        function AdminUsers(properties) {
            this.Users = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AdminUsers Users.
         * @member {Array.<mediaarchiver.IAdminUser>} Users
         * @memberof mediaarchiver.AdminUsers
         * @instance
         */
        AdminUsers.prototype.Users = $util.emptyArray;

        /**
         * AdminUsers Total.
         * @member {number} Total
         * @memberof mediaarchiver.AdminUsers
         * @instance
         */
        AdminUsers.prototype.Total = 0;

        /**
         * Creates a new AdminUsers instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.AdminUsers
         * @static
         * @param {mediaarchiver.IAdminUsers=} [properties] Properties to set
         * @returns {mediaarchiver.AdminUsers} AdminUsers instance
         */
        AdminUsers.create = function create(properties) {
            return new AdminUsers(properties);
        };

        /**
         * Encodes the specified AdminUsers message. Does not implicitly {@link mediaarchiver.AdminUsers.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.AdminUsers
         * @static
         * @param {mediaarchiver.IAdminUsers} message AdminUsers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AdminUsers.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Users != null && message.Users.length)
                for (let i = 0; i < message.Users.length; ++i)
                    $root.mediaarchiver.AdminUser.encode(message.Users[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.Total != null && Object.hasOwnProperty.call(message, "Total"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Total);
            return writer;
        };

        /**
         * Encodes the specified AdminUsers message, length delimited. Does not implicitly {@link mediaarchiver.AdminUsers.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.AdminUsers
         * @static
         * @param {mediaarchiver.IAdminUsers} message AdminUsers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AdminUsers.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AdminUsers message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.AdminUsers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.AdminUsers} AdminUsers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AdminUsers.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.AdminUsers();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.Users && message.Users.length))
                        message.Users = [];
                    message.Users.push($root.mediaarchiver.AdminUser.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.Total = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AdminUsers message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.AdminUsers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.AdminUsers} AdminUsers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AdminUsers.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AdminUsers message.
         * @function verify
         * @memberof mediaarchiver.AdminUsers
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AdminUsers.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Users != null && message.hasOwnProperty("Users")) {
                if (!Array.isArray(message.Users))
                    return "Users: array expected";
                for (let i = 0; i < message.Users.length; ++i) {
                    let error = $root.mediaarchiver.AdminUser.verify(message.Users[i]);
                    if (error)
                        return "Users." + error;
                }
            }
            if (message.Total != null && message.hasOwnProperty("Total"))
                if (!$util.isInteger(message.Total))
                    return "Total: integer expected";
            return null;
        };

        /**
         * Creates an AdminUsers message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.AdminUsers
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.AdminUsers} AdminUsers
         */
        AdminUsers.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.AdminUsers)
                return object;
            let message = new $root.mediaarchiver.AdminUsers();
            if (object.Users) {
                if (!Array.isArray(object.Users))
                    throw TypeError(".mediaarchiver.AdminUsers.Users: array expected");
                message.Users = [];
                for (let i = 0; i < object.Users.length; ++i) {
                    if (typeof object.Users[i] !== "object")
                        throw TypeError(".mediaarchiver.AdminUsers.Users: object expected");
                    message.Users[i] = $root.mediaarchiver.AdminUser.fromObject(object.Users[i]);
                }
            }
            if (object.Total != null)
                message.Total = object.Total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an AdminUsers message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.AdminUsers
         * @static
         * @param {mediaarchiver.AdminUsers} message AdminUsers
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AdminUsers.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Users = [];
            if (options.defaults)
                object.Total = 0;
            if (message.Users && message.Users.length) {
                object.Users = [];
                for (let j = 0; j < message.Users.length; ++j)
                    object.Users[j] = $root.mediaarchiver.AdminUser.toObject(message.Users[j], options);
            }
            if (message.Total != null && message.hasOwnProperty("Total"))
                object.Total = message.Total;
            return object;
        };

        /**
         * Converts this AdminUsers to JSON.
         * @function toJSON
         * @memberof mediaarchiver.AdminUsers
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AdminUsers.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AdminUsers;
    })();

    mediaarchiver.AdminSearchUsers = (function() {

        /**
         * Properties of an AdminSearchUsers.
         * @memberof mediaarchiver
         * @interface IAdminSearchUsers
         * @property {string|null} [Name] AdminSearchUsers Name
         * @property {string|null} [GroupName] AdminSearchUsers GroupName
         */

        /**
         * Constructs a new AdminSearchUsers.
         * @memberof mediaarchiver
         * @classdesc Represents an AdminSearchUsers.
         * @implements IAdminSearchUsers
         * @constructor
         * @param {mediaarchiver.IAdminSearchUsers=} [properties] Properties to set
         */
        function AdminSearchUsers(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AdminSearchUsers Name.
         * @member {string} Name
         * @memberof mediaarchiver.AdminSearchUsers
         * @instance
         */
        AdminSearchUsers.prototype.Name = "";

        /**
         * AdminSearchUsers GroupName.
         * @member {string} GroupName
         * @memberof mediaarchiver.AdminSearchUsers
         * @instance
         */
        AdminSearchUsers.prototype.GroupName = "";

        /**
         * Creates a new AdminSearchUsers instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.AdminSearchUsers
         * @static
         * @param {mediaarchiver.IAdminSearchUsers=} [properties] Properties to set
         * @returns {mediaarchiver.AdminSearchUsers} AdminSearchUsers instance
         */
        AdminSearchUsers.create = function create(properties) {
            return new AdminSearchUsers(properties);
        };

        /**
         * Encodes the specified AdminSearchUsers message. Does not implicitly {@link mediaarchiver.AdminSearchUsers.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.AdminSearchUsers
         * @static
         * @param {mediaarchiver.IAdminSearchUsers} message AdminSearchUsers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AdminSearchUsers.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Name);
            if (message.GroupName != null && Object.hasOwnProperty.call(message, "GroupName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.GroupName);
            return writer;
        };

        /**
         * Encodes the specified AdminSearchUsers message, length delimited. Does not implicitly {@link mediaarchiver.AdminSearchUsers.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.AdminSearchUsers
         * @static
         * @param {mediaarchiver.IAdminSearchUsers} message AdminSearchUsers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AdminSearchUsers.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AdminSearchUsers message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.AdminSearchUsers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.AdminSearchUsers} AdminSearchUsers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AdminSearchUsers.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.AdminSearchUsers();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Name = reader.string();
                    break;
                case 2:
                    message.GroupName = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AdminSearchUsers message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.AdminSearchUsers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.AdminSearchUsers} AdminSearchUsers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AdminSearchUsers.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AdminSearchUsers message.
         * @function verify
         * @memberof mediaarchiver.AdminSearchUsers
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AdminSearchUsers.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Name != null && message.hasOwnProperty("Name"))
                if (!$util.isString(message.Name))
                    return "Name: string expected";
            if (message.GroupName != null && message.hasOwnProperty("GroupName"))
                if (!$util.isString(message.GroupName))
                    return "GroupName: string expected";
            return null;
        };

        /**
         * Creates an AdminSearchUsers message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.AdminSearchUsers
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.AdminSearchUsers} AdminSearchUsers
         */
        AdminSearchUsers.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.AdminSearchUsers)
                return object;
            let message = new $root.mediaarchiver.AdminSearchUsers();
            if (object.Name != null)
                message.Name = String(object.Name);
            if (object.GroupName != null)
                message.GroupName = String(object.GroupName);
            return message;
        };

        /**
         * Creates a plain object from an AdminSearchUsers message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.AdminSearchUsers
         * @static
         * @param {mediaarchiver.AdminSearchUsers} message AdminSearchUsers
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AdminSearchUsers.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.Name = "";
                object.GroupName = "";
            }
            if (message.Name != null && message.hasOwnProperty("Name"))
                object.Name = message.Name;
            if (message.GroupName != null && message.hasOwnProperty("GroupName"))
                object.GroupName = message.GroupName;
            return object;
        };

        /**
         * Converts this AdminSearchUsers to JSON.
         * @function toJSON
         * @memberof mediaarchiver.AdminSearchUsers
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AdminSearchUsers.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AdminSearchUsers;
    })();

    mediaarchiver.ArgumentsGetChunk = (function() {

        /**
         * Properties of an ArgumentsGetChunk.
         * @memberof mediaarchiver
         * @interface IArgumentsGetChunk
         * @property {number|null} [MediaID] ArgumentsGetChunk MediaID
         * @property {number|Long|null} [Start] ArgumentsGetChunk Start
         */

        /**
         * Constructs a new ArgumentsGetChunk.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsGetChunk.
         * @implements IArgumentsGetChunk
         * @constructor
         * @param {mediaarchiver.IArgumentsGetChunk=} [properties] Properties to set
         */
        function ArgumentsGetChunk(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsGetChunk MediaID.
         * @member {number} MediaID
         * @memberof mediaarchiver.ArgumentsGetChunk
         * @instance
         */
        ArgumentsGetChunk.prototype.MediaID = 0;

        /**
         * ArgumentsGetChunk Start.
         * @member {number|Long} Start
         * @memberof mediaarchiver.ArgumentsGetChunk
         * @instance
         */
        ArgumentsGetChunk.prototype.Start = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new ArgumentsGetChunk instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsGetChunk
         * @static
         * @param {mediaarchiver.IArgumentsGetChunk=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsGetChunk} ArgumentsGetChunk instance
         */
        ArgumentsGetChunk.create = function create(properties) {
            return new ArgumentsGetChunk(properties);
        };

        /**
         * Encodes the specified ArgumentsGetChunk message. Does not implicitly {@link mediaarchiver.ArgumentsGetChunk.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsGetChunk
         * @static
         * @param {mediaarchiver.IArgumentsGetChunk} message ArgumentsGetChunk message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetChunk.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.MediaID != null && Object.hasOwnProperty.call(message, "MediaID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.MediaID);
            if (message.Start != null && Object.hasOwnProperty.call(message, "Start"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.Start);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsGetChunk message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsGetChunk.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsGetChunk
         * @static
         * @param {mediaarchiver.IArgumentsGetChunk} message ArgumentsGetChunk message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetChunk.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsGetChunk message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsGetChunk
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsGetChunk} ArgumentsGetChunk
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetChunk.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsGetChunk();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.MediaID = reader.uint32();
                    break;
                case 2:
                    message.Start = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsGetChunk message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsGetChunk
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsGetChunk} ArgumentsGetChunk
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetChunk.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsGetChunk message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsGetChunk
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsGetChunk.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.MediaID != null && message.hasOwnProperty("MediaID"))
                if (!$util.isInteger(message.MediaID))
                    return "MediaID: integer expected";
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (!$util.isInteger(message.Start) && !(message.Start && $util.isInteger(message.Start.low) && $util.isInteger(message.Start.high)))
                    return "Start: integer|Long expected";
            return null;
        };

        /**
         * Creates an ArgumentsGetChunk message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsGetChunk
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsGetChunk} ArgumentsGetChunk
         */
        ArgumentsGetChunk.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsGetChunk)
                return object;
            let message = new $root.mediaarchiver.ArgumentsGetChunk();
            if (object.MediaID != null)
                message.MediaID = object.MediaID >>> 0;
            if (object.Start != null)
                if ($util.Long)
                    (message.Start = $util.Long.fromValue(object.Start)).unsigned = false;
                else if (typeof object.Start === "string")
                    message.Start = parseInt(object.Start, 10);
                else if (typeof object.Start === "number")
                    message.Start = object.Start;
                else if (typeof object.Start === "object")
                    message.Start = new $util.LongBits(object.Start.low >>> 0, object.Start.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsGetChunk message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsGetChunk
         * @static
         * @param {mediaarchiver.ArgumentsGetChunk} message ArgumentsGetChunk
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsGetChunk.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.MediaID = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.Start = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.Start = options.longs === String ? "0" : 0;
            }
            if (message.MediaID != null && message.hasOwnProperty("MediaID"))
                object.MediaID = message.MediaID;
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (typeof message.Start === "number")
                    object.Start = options.longs === String ? String(message.Start) : message.Start;
                else
                    object.Start = options.longs === String ? $util.Long.prototype.toString.call(message.Start) : options.longs === Number ? new $util.LongBits(message.Start.low >>> 0, message.Start.high >>> 0).toNumber() : message.Start;
            return object;
        };

        /**
         * Converts this ArgumentsGetChunk to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsGetChunk
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsGetChunk.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsGetChunk;
    })();

    mediaarchiver.ArgumentsGetMedias = (function() {

        /**
         * Properties of an ArgumentsGetMedias.
         * @memberof mediaarchiver
         * @interface IArgumentsGetMedias
         * @property {boolean|null} [TV] ArgumentsGetMedias TV
         * @property {boolean|null} [Radio] ArgumentsGetMedias Radio
         */

        /**
         * Constructs a new ArgumentsGetMedias.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsGetMedias.
         * @implements IArgumentsGetMedias
         * @constructor
         * @param {mediaarchiver.IArgumentsGetMedias=} [properties] Properties to set
         */
        function ArgumentsGetMedias(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsGetMedias TV.
         * @member {boolean} TV
         * @memberof mediaarchiver.ArgumentsGetMedias
         * @instance
         */
        ArgumentsGetMedias.prototype.TV = false;

        /**
         * ArgumentsGetMedias Radio.
         * @member {boolean} Radio
         * @memberof mediaarchiver.ArgumentsGetMedias
         * @instance
         */
        ArgumentsGetMedias.prototype.Radio = false;

        /**
         * Creates a new ArgumentsGetMedias instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsGetMedias
         * @static
         * @param {mediaarchiver.IArgumentsGetMedias=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsGetMedias} ArgumentsGetMedias instance
         */
        ArgumentsGetMedias.create = function create(properties) {
            return new ArgumentsGetMedias(properties);
        };

        /**
         * Encodes the specified ArgumentsGetMedias message. Does not implicitly {@link mediaarchiver.ArgumentsGetMedias.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsGetMedias
         * @static
         * @param {mediaarchiver.IArgumentsGetMedias} message ArgumentsGetMedias message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetMedias.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.TV != null && Object.hasOwnProperty.call(message, "TV"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.TV);
            if (message.Radio != null && Object.hasOwnProperty.call(message, "Radio"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.Radio);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsGetMedias message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsGetMedias.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsGetMedias
         * @static
         * @param {mediaarchiver.IArgumentsGetMedias} message ArgumentsGetMedias message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetMedias.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsGetMedias message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsGetMedias
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsGetMedias} ArgumentsGetMedias
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetMedias.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsGetMedias();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.TV = reader.bool();
                    break;
                case 2:
                    message.Radio = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsGetMedias message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsGetMedias
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsGetMedias} ArgumentsGetMedias
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetMedias.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsGetMedias message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsGetMedias
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsGetMedias.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.TV != null && message.hasOwnProperty("TV"))
                if (typeof message.TV !== "boolean")
                    return "TV: boolean expected";
            if (message.Radio != null && message.hasOwnProperty("Radio"))
                if (typeof message.Radio !== "boolean")
                    return "Radio: boolean expected";
            return null;
        };

        /**
         * Creates an ArgumentsGetMedias message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsGetMedias
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsGetMedias} ArgumentsGetMedias
         */
        ArgumentsGetMedias.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsGetMedias)
                return object;
            let message = new $root.mediaarchiver.ArgumentsGetMedias();
            if (object.TV != null)
                message.TV = Boolean(object.TV);
            if (object.Radio != null)
                message.Radio = Boolean(object.Radio);
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsGetMedias message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsGetMedias
         * @static
         * @param {mediaarchiver.ArgumentsGetMedias} message ArgumentsGetMedias
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsGetMedias.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.TV = false;
                object.Radio = false;
            }
            if (message.TV != null && message.hasOwnProperty("TV"))
                object.TV = message.TV;
            if (message.Radio != null && message.hasOwnProperty("Radio"))
                object.Radio = message.Radio;
            return object;
        };

        /**
         * Converts this ArgumentsGetMedias to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsGetMedias
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsGetMedias.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsGetMedias;
    })();

    mediaarchiver.ArgumentsGetStream = (function() {

        /**
         * Properties of an ArgumentsGetStream.
         * @memberof mediaarchiver
         * @interface IArgumentsGetStream
         * @property {number|null} [MediaID] ArgumentsGetStream MediaID
         * @property {number|Long|null} [Start] ArgumentsGetStream Start
         */

        /**
         * Constructs a new ArgumentsGetStream.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsGetStream.
         * @implements IArgumentsGetStream
         * @constructor
         * @param {mediaarchiver.IArgumentsGetStream=} [properties] Properties to set
         */
        function ArgumentsGetStream(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsGetStream MediaID.
         * @member {number} MediaID
         * @memberof mediaarchiver.ArgumentsGetStream
         * @instance
         */
        ArgumentsGetStream.prototype.MediaID = 0;

        /**
         * ArgumentsGetStream Start.
         * @member {number|Long} Start
         * @memberof mediaarchiver.ArgumentsGetStream
         * @instance
         */
        ArgumentsGetStream.prototype.Start = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new ArgumentsGetStream instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsGetStream
         * @static
         * @param {mediaarchiver.IArgumentsGetStream=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsGetStream} ArgumentsGetStream instance
         */
        ArgumentsGetStream.create = function create(properties) {
            return new ArgumentsGetStream(properties);
        };

        /**
         * Encodes the specified ArgumentsGetStream message. Does not implicitly {@link mediaarchiver.ArgumentsGetStream.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsGetStream
         * @static
         * @param {mediaarchiver.IArgumentsGetStream} message ArgumentsGetStream message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetStream.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.MediaID != null && Object.hasOwnProperty.call(message, "MediaID"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.MediaID);
            if (message.Start != null && Object.hasOwnProperty.call(message, "Start"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.Start);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsGetStream message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsGetStream.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsGetStream
         * @static
         * @param {mediaarchiver.IArgumentsGetStream} message ArgumentsGetStream message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetStream.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsGetStream message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsGetStream
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsGetStream} ArgumentsGetStream
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetStream.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsGetStream();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.MediaID = reader.uint32();
                    break;
                case 2:
                    message.Start = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsGetStream message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsGetStream
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsGetStream} ArgumentsGetStream
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetStream.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsGetStream message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsGetStream
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsGetStream.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.MediaID != null && message.hasOwnProperty("MediaID"))
                if (!$util.isInteger(message.MediaID))
                    return "MediaID: integer expected";
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (!$util.isInteger(message.Start) && !(message.Start && $util.isInteger(message.Start.low) && $util.isInteger(message.Start.high)))
                    return "Start: integer|Long expected";
            return null;
        };

        /**
         * Creates an ArgumentsGetStream message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsGetStream
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsGetStream} ArgumentsGetStream
         */
        ArgumentsGetStream.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsGetStream)
                return object;
            let message = new $root.mediaarchiver.ArgumentsGetStream();
            if (object.MediaID != null)
                message.MediaID = object.MediaID >>> 0;
            if (object.Start != null)
                if ($util.Long)
                    (message.Start = $util.Long.fromValue(object.Start)).unsigned = false;
                else if (typeof object.Start === "string")
                    message.Start = parseInt(object.Start, 10);
                else if (typeof object.Start === "number")
                    message.Start = object.Start;
                else if (typeof object.Start === "object")
                    message.Start = new $util.LongBits(object.Start.low >>> 0, object.Start.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsGetStream message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsGetStream
         * @static
         * @param {mediaarchiver.ArgumentsGetStream} message ArgumentsGetStream
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsGetStream.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.MediaID = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.Start = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.Start = options.longs === String ? "0" : 0;
            }
            if (message.MediaID != null && message.hasOwnProperty("MediaID"))
                object.MediaID = message.MediaID;
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (typeof message.Start === "number")
                    object.Start = options.longs === String ? String(message.Start) : message.Start;
                else
                    object.Start = options.longs === String ? $util.Long.prototype.toString.call(message.Start) : options.longs === Number ? new $util.LongBits(message.Start.low >>> 0, message.Start.high >>> 0).toNumber() : message.Start;
            return object;
        };

        /**
         * Converts this ArgumentsGetStream to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsGetStream
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsGetStream.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsGetStream;
    })();

    mediaarchiver.ArgumentsLogin = (function() {

        /**
         * Properties of an ArgumentsLogin.
         * @memberof mediaarchiver
         * @interface IArgumentsLogin
         * @property {string|null} [Login] ArgumentsLogin Login
         * @property {string|null} [Password] ArgumentsLogin Password
         * @property {boolean|null} [Remember] ArgumentsLogin Remember
         */

        /**
         * Constructs a new ArgumentsLogin.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsLogin.
         * @implements IArgumentsLogin
         * @constructor
         * @param {mediaarchiver.IArgumentsLogin=} [properties] Properties to set
         */
        function ArgumentsLogin(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsLogin Login.
         * @member {string} Login
         * @memberof mediaarchiver.ArgumentsLogin
         * @instance
         */
        ArgumentsLogin.prototype.Login = "";

        /**
         * ArgumentsLogin Password.
         * @member {string} Password
         * @memberof mediaarchiver.ArgumentsLogin
         * @instance
         */
        ArgumentsLogin.prototype.Password = "";

        /**
         * ArgumentsLogin Remember.
         * @member {boolean} Remember
         * @memberof mediaarchiver.ArgumentsLogin
         * @instance
         */
        ArgumentsLogin.prototype.Remember = false;

        /**
         * Creates a new ArgumentsLogin instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsLogin
         * @static
         * @param {mediaarchiver.IArgumentsLogin=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsLogin} ArgumentsLogin instance
         */
        ArgumentsLogin.create = function create(properties) {
            return new ArgumentsLogin(properties);
        };

        /**
         * Encodes the specified ArgumentsLogin message. Does not implicitly {@link mediaarchiver.ArgumentsLogin.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsLogin
         * @static
         * @param {mediaarchiver.IArgumentsLogin} message ArgumentsLogin message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsLogin.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Login != null && Object.hasOwnProperty.call(message, "Login"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Login);
            if (message.Password != null && Object.hasOwnProperty.call(message, "Password"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Password);
            if (message.Remember != null && Object.hasOwnProperty.call(message, "Remember"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.Remember);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsLogin message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsLogin.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsLogin
         * @static
         * @param {mediaarchiver.IArgumentsLogin} message ArgumentsLogin message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsLogin.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsLogin message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsLogin
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsLogin} ArgumentsLogin
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsLogin.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsLogin();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Login = reader.string();
                    break;
                case 2:
                    message.Password = reader.string();
                    break;
                case 3:
                    message.Remember = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsLogin message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsLogin
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsLogin} ArgumentsLogin
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsLogin.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsLogin message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsLogin
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsLogin.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Login != null && message.hasOwnProperty("Login"))
                if (!$util.isString(message.Login))
                    return "Login: string expected";
            if (message.Password != null && message.hasOwnProperty("Password"))
                if (!$util.isString(message.Password))
                    return "Password: string expected";
            if (message.Remember != null && message.hasOwnProperty("Remember"))
                if (typeof message.Remember !== "boolean")
                    return "Remember: boolean expected";
            return null;
        };

        /**
         * Creates an ArgumentsLogin message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsLogin
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsLogin} ArgumentsLogin
         */
        ArgumentsLogin.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsLogin)
                return object;
            let message = new $root.mediaarchiver.ArgumentsLogin();
            if (object.Login != null)
                message.Login = String(object.Login);
            if (object.Password != null)
                message.Password = String(object.Password);
            if (object.Remember != null)
                message.Remember = Boolean(object.Remember);
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsLogin message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsLogin
         * @static
         * @param {mediaarchiver.ArgumentsLogin} message ArgumentsLogin
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsLogin.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.Login = "";
                object.Password = "";
                object.Remember = false;
            }
            if (message.Login != null && message.hasOwnProperty("Login"))
                object.Login = message.Login;
            if (message.Password != null && message.hasOwnProperty("Password"))
                object.Password = message.Password;
            if (message.Remember != null && message.hasOwnProperty("Remember"))
                object.Remember = message.Remember;
            return object;
        };

        /**
         * Converts this ArgumentsLogin to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsLogin
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsLogin.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsLogin;
    })();

    mediaarchiver.ReportedBug = (function() {

        /**
         * Properties of a ReportedBug.
         * @memberof mediaarchiver
         * @interface IReportedBug
         * @property {string|null} [FromMail] ReportedBug FromMail
         * @property {string|null} [FromName] ReportedBug FromName
         * @property {string|null} [FromCompany] ReportedBug FromCompany
         * @property {string|null} [FromPhone] ReportedBug FromPhone
         * @property {string|null} [Message] ReportedBug Message
         * @property {number|null} [Media] ReportedBug Media
         * @property {number|null} [TS] ReportedBug TS
         * @property {Object.<string,string>|null} [DebugInfos] ReportedBug DebugInfos
         */

        /**
         * Constructs a new ReportedBug.
         * @memberof mediaarchiver
         * @classdesc Represents a ReportedBug.
         * @implements IReportedBug
         * @constructor
         * @param {mediaarchiver.IReportedBug=} [properties] Properties to set
         */
        function ReportedBug(properties) {
            this.DebugInfos = {};
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ReportedBug FromMail.
         * @member {string} FromMail
         * @memberof mediaarchiver.ReportedBug
         * @instance
         */
        ReportedBug.prototype.FromMail = "";

        /**
         * ReportedBug FromName.
         * @member {string} FromName
         * @memberof mediaarchiver.ReportedBug
         * @instance
         */
        ReportedBug.prototype.FromName = "";

        /**
         * ReportedBug FromCompany.
         * @member {string} FromCompany
         * @memberof mediaarchiver.ReportedBug
         * @instance
         */
        ReportedBug.prototype.FromCompany = "";

        /**
         * ReportedBug FromPhone.
         * @member {string} FromPhone
         * @memberof mediaarchiver.ReportedBug
         * @instance
         */
        ReportedBug.prototype.FromPhone = "";

        /**
         * ReportedBug Message.
         * @member {string} Message
         * @memberof mediaarchiver.ReportedBug
         * @instance
         */
        ReportedBug.prototype.Message = "";

        /**
         * ReportedBug Media.
         * @member {number} Media
         * @memberof mediaarchiver.ReportedBug
         * @instance
         */
        ReportedBug.prototype.Media = 0;

        /**
         * ReportedBug TS.
         * @member {number} TS
         * @memberof mediaarchiver.ReportedBug
         * @instance
         */
        ReportedBug.prototype.TS = 0;

        /**
         * ReportedBug DebugInfos.
         * @member {Object.<string,string>} DebugInfos
         * @memberof mediaarchiver.ReportedBug
         * @instance
         */
        ReportedBug.prototype.DebugInfos = $util.emptyObject;

        /**
         * Creates a new ReportedBug instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ReportedBug
         * @static
         * @param {mediaarchiver.IReportedBug=} [properties] Properties to set
         * @returns {mediaarchiver.ReportedBug} ReportedBug instance
         */
        ReportedBug.create = function create(properties) {
            return new ReportedBug(properties);
        };

        /**
         * Encodes the specified ReportedBug message. Does not implicitly {@link mediaarchiver.ReportedBug.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ReportedBug
         * @static
         * @param {mediaarchiver.IReportedBug} message ReportedBug message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReportedBug.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.FromMail != null && Object.hasOwnProperty.call(message, "FromMail"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.FromMail);
            if (message.FromName != null && Object.hasOwnProperty.call(message, "FromName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.FromName);
            if (message.FromCompany != null && Object.hasOwnProperty.call(message, "FromCompany"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.FromCompany);
            if (message.FromPhone != null && Object.hasOwnProperty.call(message, "FromPhone"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.FromPhone);
            if (message.Message != null && Object.hasOwnProperty.call(message, "Message"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.Message);
            if (message.Media != null && Object.hasOwnProperty.call(message, "Media"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.Media);
            if (message.TS != null && Object.hasOwnProperty.call(message, "TS"))
                writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.TS);
            if (message.DebugInfos != null && Object.hasOwnProperty.call(message, "DebugInfos"))
                for (let keys = Object.keys(message.DebugInfos), i = 0; i < keys.length; ++i)
                    writer.uint32(/* id 8, wireType 2 =*/66).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.DebugInfos[keys[i]]).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ReportedBug message, length delimited. Does not implicitly {@link mediaarchiver.ReportedBug.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ReportedBug
         * @static
         * @param {mediaarchiver.IReportedBug} message ReportedBug message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReportedBug.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ReportedBug message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ReportedBug
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ReportedBug} ReportedBug
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReportedBug.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ReportedBug(), key, value;
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.FromMail = reader.string();
                    break;
                case 2:
                    message.FromName = reader.string();
                    break;
                case 3:
                    message.FromCompany = reader.string();
                    break;
                case 4:
                    message.FromPhone = reader.string();
                    break;
                case 5:
                    message.Message = reader.string();
                    break;
                case 6:
                    message.Media = reader.uint32();
                    break;
                case 7:
                    message.TS = reader.uint32();
                    break;
                case 8:
                    if (message.DebugInfos === $util.emptyObject)
                        message.DebugInfos = {};
                    let end2 = reader.uint32() + reader.pos;
                    key = "";
                    value = "";
                    while (reader.pos < end2) {
                        let tag2 = reader.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            key = reader.string();
                            break;
                        case 2:
                            value = reader.string();
                            break;
                        default:
                            reader.skipType(tag2 & 7);
                            break;
                        }
                    }
                    message.DebugInfos[key] = value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ReportedBug message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ReportedBug
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ReportedBug} ReportedBug
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReportedBug.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ReportedBug message.
         * @function verify
         * @memberof mediaarchiver.ReportedBug
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ReportedBug.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.FromMail != null && message.hasOwnProperty("FromMail"))
                if (!$util.isString(message.FromMail))
                    return "FromMail: string expected";
            if (message.FromName != null && message.hasOwnProperty("FromName"))
                if (!$util.isString(message.FromName))
                    return "FromName: string expected";
            if (message.FromCompany != null && message.hasOwnProperty("FromCompany"))
                if (!$util.isString(message.FromCompany))
                    return "FromCompany: string expected";
            if (message.FromPhone != null && message.hasOwnProperty("FromPhone"))
                if (!$util.isString(message.FromPhone))
                    return "FromPhone: string expected";
            if (message.Message != null && message.hasOwnProperty("Message"))
                if (!$util.isString(message.Message))
                    return "Message: string expected";
            if (message.Media != null && message.hasOwnProperty("Media"))
                if (!$util.isInteger(message.Media))
                    return "Media: integer expected";
            if (message.TS != null && message.hasOwnProperty("TS"))
                if (!$util.isInteger(message.TS))
                    return "TS: integer expected";
            if (message.DebugInfos != null && message.hasOwnProperty("DebugInfos")) {
                if (!$util.isObject(message.DebugInfos))
                    return "DebugInfos: object expected";
                let key = Object.keys(message.DebugInfos);
                for (let i = 0; i < key.length; ++i)
                    if (!$util.isString(message.DebugInfos[key[i]]))
                        return "DebugInfos: string{k:string} expected";
            }
            return null;
        };

        /**
         * Creates a ReportedBug message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ReportedBug
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ReportedBug} ReportedBug
         */
        ReportedBug.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ReportedBug)
                return object;
            let message = new $root.mediaarchiver.ReportedBug();
            if (object.FromMail != null)
                message.FromMail = String(object.FromMail);
            if (object.FromName != null)
                message.FromName = String(object.FromName);
            if (object.FromCompany != null)
                message.FromCompany = String(object.FromCompany);
            if (object.FromPhone != null)
                message.FromPhone = String(object.FromPhone);
            if (object.Message != null)
                message.Message = String(object.Message);
            if (object.Media != null)
                message.Media = object.Media >>> 0;
            if (object.TS != null)
                message.TS = object.TS >>> 0;
            if (object.DebugInfos) {
                if (typeof object.DebugInfos !== "object")
                    throw TypeError(".mediaarchiver.ReportedBug.DebugInfos: object expected");
                message.DebugInfos = {};
                for (let keys = Object.keys(object.DebugInfos), i = 0; i < keys.length; ++i)
                    message.DebugInfos[keys[i]] = String(object.DebugInfos[keys[i]]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ReportedBug message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ReportedBug
         * @static
         * @param {mediaarchiver.ReportedBug} message ReportedBug
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ReportedBug.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.objects || options.defaults)
                object.DebugInfos = {};
            if (options.defaults) {
                object.FromMail = "";
                object.FromName = "";
                object.FromCompany = "";
                object.FromPhone = "";
                object.Message = "";
                object.Media = 0;
                object.TS = 0;
            }
            if (message.FromMail != null && message.hasOwnProperty("FromMail"))
                object.FromMail = message.FromMail;
            if (message.FromName != null && message.hasOwnProperty("FromName"))
                object.FromName = message.FromName;
            if (message.FromCompany != null && message.hasOwnProperty("FromCompany"))
                object.FromCompany = message.FromCompany;
            if (message.FromPhone != null && message.hasOwnProperty("FromPhone"))
                object.FromPhone = message.FromPhone;
            if (message.Message != null && message.hasOwnProperty("Message"))
                object.Message = message.Message;
            if (message.Media != null && message.hasOwnProperty("Media"))
                object.Media = message.Media;
            if (message.TS != null && message.hasOwnProperty("TS"))
                object.TS = message.TS;
            let keys2;
            if (message.DebugInfos && (keys2 = Object.keys(message.DebugInfos)).length) {
                object.DebugInfos = {};
                for (let j = 0; j < keys2.length; ++j)
                    object.DebugInfos[keys2[j]] = message.DebugInfos[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this ReportedBug to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ReportedBug
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ReportedBug.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ReportedBug;
    })();

    mediaarchiver.SFTPAccount = (function() {

        /**
         * Properties of a SFTPAccount.
         * @memberof mediaarchiver
         * @interface ISFTPAccount
         * @property {string|null} [ID] SFTPAccount ID
         * @property {string|null} [Name] SFTPAccount Name
         * @property {string|null} [Hostname] SFTPAccount Hostname
         * @property {number|null} [Port] SFTPAccount Port
         * @property {string|null} [Login] SFTPAccount Login
         * @property {string|null} [Password] SFTPAccount Password
         * @property {string|null} [Directory] SFTPAccount Directory
         * @property {number|null} [Owner] SFTPAccount Owner
         */

        /**
         * Constructs a new SFTPAccount.
         * @memberof mediaarchiver
         * @classdesc Represents a SFTPAccount.
         * @implements ISFTPAccount
         * @constructor
         * @param {mediaarchiver.ISFTPAccount=} [properties] Properties to set
         */
        function SFTPAccount(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SFTPAccount ID.
         * @member {string} ID
         * @memberof mediaarchiver.SFTPAccount
         * @instance
         */
        SFTPAccount.prototype.ID = "";

        /**
         * SFTPAccount Name.
         * @member {string} Name
         * @memberof mediaarchiver.SFTPAccount
         * @instance
         */
        SFTPAccount.prototype.Name = "";

        /**
         * SFTPAccount Hostname.
         * @member {string} Hostname
         * @memberof mediaarchiver.SFTPAccount
         * @instance
         */
        SFTPAccount.prototype.Hostname = "";

        /**
         * SFTPAccount Port.
         * @member {number} Port
         * @memberof mediaarchiver.SFTPAccount
         * @instance
         */
        SFTPAccount.prototype.Port = 0;

        /**
         * SFTPAccount Login.
         * @member {string} Login
         * @memberof mediaarchiver.SFTPAccount
         * @instance
         */
        SFTPAccount.prototype.Login = "";

        /**
         * SFTPAccount Password.
         * @member {string} Password
         * @memberof mediaarchiver.SFTPAccount
         * @instance
         */
        SFTPAccount.prototype.Password = "";

        /**
         * SFTPAccount Directory.
         * @member {string} Directory
         * @memberof mediaarchiver.SFTPAccount
         * @instance
         */
        SFTPAccount.prototype.Directory = "";

        /**
         * SFTPAccount Owner.
         * @member {number} Owner
         * @memberof mediaarchiver.SFTPAccount
         * @instance
         */
        SFTPAccount.prototype.Owner = 0;

        /**
         * Creates a new SFTPAccount instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.SFTPAccount
         * @static
         * @param {mediaarchiver.ISFTPAccount=} [properties] Properties to set
         * @returns {mediaarchiver.SFTPAccount} SFTPAccount instance
         */
        SFTPAccount.create = function create(properties) {
            return new SFTPAccount(properties);
        };

        /**
         * Encodes the specified SFTPAccount message. Does not implicitly {@link mediaarchiver.SFTPAccount.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.SFTPAccount
         * @static
         * @param {mediaarchiver.ISFTPAccount} message SFTPAccount message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SFTPAccount.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.ID);
            if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
            if (message.Hostname != null && Object.hasOwnProperty.call(message, "Hostname"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.Hostname);
            if (message.Port != null && Object.hasOwnProperty.call(message, "Port"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.Port);
            if (message.Login != null && Object.hasOwnProperty.call(message, "Login"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.Login);
            if (message.Password != null && Object.hasOwnProperty.call(message, "Password"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.Password);
            if (message.Directory != null && Object.hasOwnProperty.call(message, "Directory"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.Directory);
            if (message.Owner != null && Object.hasOwnProperty.call(message, "Owner"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.Owner);
            return writer;
        };

        /**
         * Encodes the specified SFTPAccount message, length delimited. Does not implicitly {@link mediaarchiver.SFTPAccount.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.SFTPAccount
         * @static
         * @param {mediaarchiver.ISFTPAccount} message SFTPAccount message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SFTPAccount.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SFTPAccount message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.SFTPAccount
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.SFTPAccount} SFTPAccount
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SFTPAccount.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.SFTPAccount();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ID = reader.string();
                    break;
                case 2:
                    message.Name = reader.string();
                    break;
                case 3:
                    message.Hostname = reader.string();
                    break;
                case 4:
                    message.Port = reader.uint32();
                    break;
                case 5:
                    message.Login = reader.string();
                    break;
                case 6:
                    message.Password = reader.string();
                    break;
                case 7:
                    message.Directory = reader.string();
                    break;
                case 8:
                    message.Owner = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SFTPAccount message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.SFTPAccount
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.SFTPAccount} SFTPAccount
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SFTPAccount.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SFTPAccount message.
         * @function verify
         * @memberof mediaarchiver.SFTPAccount
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SFTPAccount.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isString(message.ID))
                    return "ID: string expected";
            if (message.Name != null && message.hasOwnProperty("Name"))
                if (!$util.isString(message.Name))
                    return "Name: string expected";
            if (message.Hostname != null && message.hasOwnProperty("Hostname"))
                if (!$util.isString(message.Hostname))
                    return "Hostname: string expected";
            if (message.Port != null && message.hasOwnProperty("Port"))
                if (!$util.isInteger(message.Port))
                    return "Port: integer expected";
            if (message.Login != null && message.hasOwnProperty("Login"))
                if (!$util.isString(message.Login))
                    return "Login: string expected";
            if (message.Password != null && message.hasOwnProperty("Password"))
                if (!$util.isString(message.Password))
                    return "Password: string expected";
            if (message.Directory != null && message.hasOwnProperty("Directory"))
                if (!$util.isString(message.Directory))
                    return "Directory: string expected";
            if (message.Owner != null && message.hasOwnProperty("Owner"))
                if (!$util.isInteger(message.Owner))
                    return "Owner: integer expected";
            return null;
        };

        /**
         * Creates a SFTPAccount message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.SFTPAccount
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.SFTPAccount} SFTPAccount
         */
        SFTPAccount.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.SFTPAccount)
                return object;
            let message = new $root.mediaarchiver.SFTPAccount();
            if (object.ID != null)
                message.ID = String(object.ID);
            if (object.Name != null)
                message.Name = String(object.Name);
            if (object.Hostname != null)
                message.Hostname = String(object.Hostname);
            if (object.Port != null)
                message.Port = object.Port >>> 0;
            if (object.Login != null)
                message.Login = String(object.Login);
            if (object.Password != null)
                message.Password = String(object.Password);
            if (object.Directory != null)
                message.Directory = String(object.Directory);
            if (object.Owner != null)
                message.Owner = object.Owner >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a SFTPAccount message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.SFTPAccount
         * @static
         * @param {mediaarchiver.SFTPAccount} message SFTPAccount
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SFTPAccount.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.ID = "";
                object.Name = "";
                object.Hostname = "";
                object.Port = 0;
                object.Login = "";
                object.Password = "";
                object.Directory = "";
                object.Owner = 0;
            }
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            if (message.Name != null && message.hasOwnProperty("Name"))
                object.Name = message.Name;
            if (message.Hostname != null && message.hasOwnProperty("Hostname"))
                object.Hostname = message.Hostname;
            if (message.Port != null && message.hasOwnProperty("Port"))
                object.Port = message.Port;
            if (message.Login != null && message.hasOwnProperty("Login"))
                object.Login = message.Login;
            if (message.Password != null && message.hasOwnProperty("Password"))
                object.Password = message.Password;
            if (message.Directory != null && message.hasOwnProperty("Directory"))
                object.Directory = message.Directory;
            if (message.Owner != null && message.hasOwnProperty("Owner"))
                object.Owner = message.Owner;
            return object;
        };

        /**
         * Converts this SFTPAccount to JSON.
         * @function toJSON
         * @memberof mediaarchiver.SFTPAccount
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SFTPAccount.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SFTPAccount;
    })();

    mediaarchiver.ArgumentsSFTPAccounts = (function() {

        /**
         * Properties of an ArgumentsSFTPAccounts.
         * @memberof mediaarchiver
         * @interface IArgumentsSFTPAccounts
         * @property {number|null} [Offset] ArgumentsSFTPAccounts Offset
         * @property {number|null} [Count] ArgumentsSFTPAccounts Count
         * @property {Array.<mediaarchiver.ISFTPAccount>|null} [Accounts] ArgumentsSFTPAccounts Accounts
         */

        /**
         * Constructs a new ArgumentsSFTPAccounts.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsSFTPAccounts.
         * @implements IArgumentsSFTPAccounts
         * @constructor
         * @param {mediaarchiver.IArgumentsSFTPAccounts=} [properties] Properties to set
         */
        function ArgumentsSFTPAccounts(properties) {
            this.Accounts = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsSFTPAccounts Offset.
         * @member {number} Offset
         * @memberof mediaarchiver.ArgumentsSFTPAccounts
         * @instance
         */
        ArgumentsSFTPAccounts.prototype.Offset = 0;

        /**
         * ArgumentsSFTPAccounts Count.
         * @member {number} Count
         * @memberof mediaarchiver.ArgumentsSFTPAccounts
         * @instance
         */
        ArgumentsSFTPAccounts.prototype.Count = 0;

        /**
         * ArgumentsSFTPAccounts Accounts.
         * @member {Array.<mediaarchiver.ISFTPAccount>} Accounts
         * @memberof mediaarchiver.ArgumentsSFTPAccounts
         * @instance
         */
        ArgumentsSFTPAccounts.prototype.Accounts = $util.emptyArray;

        /**
         * Creates a new ArgumentsSFTPAccounts instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsSFTPAccounts
         * @static
         * @param {mediaarchiver.IArgumentsSFTPAccounts=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsSFTPAccounts} ArgumentsSFTPAccounts instance
         */
        ArgumentsSFTPAccounts.create = function create(properties) {
            return new ArgumentsSFTPAccounts(properties);
        };

        /**
         * Encodes the specified ArgumentsSFTPAccounts message. Does not implicitly {@link mediaarchiver.ArgumentsSFTPAccounts.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsSFTPAccounts
         * @static
         * @param {mediaarchiver.IArgumentsSFTPAccounts} message ArgumentsSFTPAccounts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsSFTPAccounts.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Offset != null && Object.hasOwnProperty.call(message, "Offset"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Offset);
            if (message.Count != null && Object.hasOwnProperty.call(message, "Count"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Count);
            if (message.Accounts != null && message.Accounts.length)
                for (let i = 0; i < message.Accounts.length; ++i)
                    $root.mediaarchiver.SFTPAccount.encode(message.Accounts[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ArgumentsSFTPAccounts message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsSFTPAccounts.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsSFTPAccounts
         * @static
         * @param {mediaarchiver.IArgumentsSFTPAccounts} message ArgumentsSFTPAccounts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsSFTPAccounts.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsSFTPAccounts message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsSFTPAccounts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsSFTPAccounts} ArgumentsSFTPAccounts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsSFTPAccounts.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsSFTPAccounts();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Offset = reader.uint32();
                    break;
                case 2:
                    message.Count = reader.uint32();
                    break;
                case 3:
                    if (!(message.Accounts && message.Accounts.length))
                        message.Accounts = [];
                    message.Accounts.push($root.mediaarchiver.SFTPAccount.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsSFTPAccounts message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsSFTPAccounts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsSFTPAccounts} ArgumentsSFTPAccounts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsSFTPAccounts.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsSFTPAccounts message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsSFTPAccounts
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsSFTPAccounts.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                if (!$util.isInteger(message.Offset))
                    return "Offset: integer expected";
            if (message.Count != null && message.hasOwnProperty("Count"))
                if (!$util.isInteger(message.Count))
                    return "Count: integer expected";
            if (message.Accounts != null && message.hasOwnProperty("Accounts")) {
                if (!Array.isArray(message.Accounts))
                    return "Accounts: array expected";
                for (let i = 0; i < message.Accounts.length; ++i) {
                    let error = $root.mediaarchiver.SFTPAccount.verify(message.Accounts[i]);
                    if (error)
                        return "Accounts." + error;
                }
            }
            return null;
        };

        /**
         * Creates an ArgumentsSFTPAccounts message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsSFTPAccounts
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsSFTPAccounts} ArgumentsSFTPAccounts
         */
        ArgumentsSFTPAccounts.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsSFTPAccounts)
                return object;
            let message = new $root.mediaarchiver.ArgumentsSFTPAccounts();
            if (object.Offset != null)
                message.Offset = object.Offset >>> 0;
            if (object.Count != null)
                message.Count = object.Count >>> 0;
            if (object.Accounts) {
                if (!Array.isArray(object.Accounts))
                    throw TypeError(".mediaarchiver.ArgumentsSFTPAccounts.Accounts: array expected");
                message.Accounts = [];
                for (let i = 0; i < object.Accounts.length; ++i) {
                    if (typeof object.Accounts[i] !== "object")
                        throw TypeError(".mediaarchiver.ArgumentsSFTPAccounts.Accounts: object expected");
                    message.Accounts[i] = $root.mediaarchiver.SFTPAccount.fromObject(object.Accounts[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsSFTPAccounts message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsSFTPAccounts
         * @static
         * @param {mediaarchiver.ArgumentsSFTPAccounts} message ArgumentsSFTPAccounts
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsSFTPAccounts.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Accounts = [];
            if (options.defaults) {
                object.Offset = 0;
                object.Count = 0;
            }
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                object.Offset = message.Offset;
            if (message.Count != null && message.hasOwnProperty("Count"))
                object.Count = message.Count;
            if (message.Accounts && message.Accounts.length) {
                object.Accounts = [];
                for (let j = 0; j < message.Accounts.length; ++j)
                    object.Accounts[j] = $root.mediaarchiver.SFTPAccount.toObject(message.Accounts[j], options);
            }
            return object;
        };

        /**
         * Converts this ArgumentsSFTPAccounts to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsSFTPAccounts
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsSFTPAccounts.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsSFTPAccounts;
    })();

    mediaarchiver.ArgumentsGetSFTPAccounts = (function() {

        /**
         * Properties of an ArgumentsGetSFTPAccounts.
         * @memberof mediaarchiver
         * @interface IArgumentsGetSFTPAccounts
         * @property {number|null} [Limit] ArgumentsGetSFTPAccounts Limit
         * @property {number|null} [Offset] ArgumentsGetSFTPAccounts Offset
         */

        /**
         * Constructs a new ArgumentsGetSFTPAccounts.
         * @memberof mediaarchiver
         * @classdesc Represents an ArgumentsGetSFTPAccounts.
         * @implements IArgumentsGetSFTPAccounts
         * @constructor
         * @param {mediaarchiver.IArgumentsGetSFTPAccounts=} [properties] Properties to set
         */
        function ArgumentsGetSFTPAccounts(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ArgumentsGetSFTPAccounts Limit.
         * @member {number} Limit
         * @memberof mediaarchiver.ArgumentsGetSFTPAccounts
         * @instance
         */
        ArgumentsGetSFTPAccounts.prototype.Limit = 0;

        /**
         * ArgumentsGetSFTPAccounts Offset.
         * @member {number} Offset
         * @memberof mediaarchiver.ArgumentsGetSFTPAccounts
         * @instance
         */
        ArgumentsGetSFTPAccounts.prototype.Offset = 0;

        /**
         * Creates a new ArgumentsGetSFTPAccounts instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.ArgumentsGetSFTPAccounts
         * @static
         * @param {mediaarchiver.IArgumentsGetSFTPAccounts=} [properties] Properties to set
         * @returns {mediaarchiver.ArgumentsGetSFTPAccounts} ArgumentsGetSFTPAccounts instance
         */
        ArgumentsGetSFTPAccounts.create = function create(properties) {
            return new ArgumentsGetSFTPAccounts(properties);
        };

        /**
         * Encodes the specified ArgumentsGetSFTPAccounts message. Does not implicitly {@link mediaarchiver.ArgumentsGetSFTPAccounts.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.ArgumentsGetSFTPAccounts
         * @static
         * @param {mediaarchiver.IArgumentsGetSFTPAccounts} message ArgumentsGetSFTPAccounts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetSFTPAccounts.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Limit != null && Object.hasOwnProperty.call(message, "Limit"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Limit);
            if (message.Offset != null && Object.hasOwnProperty.call(message, "Offset"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Offset);
            return writer;
        };

        /**
         * Encodes the specified ArgumentsGetSFTPAccounts message, length delimited. Does not implicitly {@link mediaarchiver.ArgumentsGetSFTPAccounts.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.ArgumentsGetSFTPAccounts
         * @static
         * @param {mediaarchiver.IArgumentsGetSFTPAccounts} message ArgumentsGetSFTPAccounts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ArgumentsGetSFTPAccounts.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ArgumentsGetSFTPAccounts message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.ArgumentsGetSFTPAccounts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.ArgumentsGetSFTPAccounts} ArgumentsGetSFTPAccounts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetSFTPAccounts.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.ArgumentsGetSFTPAccounts();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Limit = reader.uint32();
                    break;
                case 2:
                    message.Offset = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ArgumentsGetSFTPAccounts message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.ArgumentsGetSFTPAccounts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.ArgumentsGetSFTPAccounts} ArgumentsGetSFTPAccounts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ArgumentsGetSFTPAccounts.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ArgumentsGetSFTPAccounts message.
         * @function verify
         * @memberof mediaarchiver.ArgumentsGetSFTPAccounts
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ArgumentsGetSFTPAccounts.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Limit != null && message.hasOwnProperty("Limit"))
                if (!$util.isInteger(message.Limit))
                    return "Limit: integer expected";
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                if (!$util.isInteger(message.Offset))
                    return "Offset: integer expected";
            return null;
        };

        /**
         * Creates an ArgumentsGetSFTPAccounts message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.ArgumentsGetSFTPAccounts
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.ArgumentsGetSFTPAccounts} ArgumentsGetSFTPAccounts
         */
        ArgumentsGetSFTPAccounts.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.ArgumentsGetSFTPAccounts)
                return object;
            let message = new $root.mediaarchiver.ArgumentsGetSFTPAccounts();
            if (object.Limit != null)
                message.Limit = object.Limit >>> 0;
            if (object.Offset != null)
                message.Offset = object.Offset >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an ArgumentsGetSFTPAccounts message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.ArgumentsGetSFTPAccounts
         * @static
         * @param {mediaarchiver.ArgumentsGetSFTPAccounts} message ArgumentsGetSFTPAccounts
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ArgumentsGetSFTPAccounts.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.Limit = 0;
                object.Offset = 0;
            }
            if (message.Limit != null && message.hasOwnProperty("Limit"))
                object.Limit = message.Limit;
            if (message.Offset != null && message.hasOwnProperty("Offset"))
                object.Offset = message.Offset;
            return object;
        };

        /**
         * Converts this ArgumentsGetSFTPAccounts to JSON.
         * @function toJSON
         * @memberof mediaarchiver.ArgumentsGetSFTPAccounts
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ArgumentsGetSFTPAccounts.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ArgumentsGetSFTPAccounts;
    })();

    /**
     * SearchSpeechesLogic enum.
     * @name mediaarchiver.SearchSpeechesLogic
     * @enum {number}
     * @property {number} SPEECH_SEARCH_LOGIC_UNKNOWN=0 SPEECH_SEARCH_LOGIC_UNKNOWN value
     * @property {number} SPEECH_SEARCH_LOGIC_AND=1 SPEECH_SEARCH_LOGIC_AND value
     * @property {number} SPEECH_SEARCH_LOGIC_OR=2 SPEECH_SEARCH_LOGIC_OR value
     * @property {number} SPEECH_SEARCH_LOGIC_PHRASE=3 SPEECH_SEARCH_LOGIC_PHRASE value
     */
    mediaarchiver.SearchSpeechesLogic = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SPEECH_SEARCH_LOGIC_UNKNOWN"] = 0;
        values[valuesById[1] = "SPEECH_SEARCH_LOGIC_AND"] = 1;
        values[valuesById[2] = "SPEECH_SEARCH_LOGIC_OR"] = 2;
        values[valuesById[3] = "SPEECH_SEARCH_LOGIC_PHRASE"] = 3;
        return values;
    })();

    mediaarchiver.SearchSpeeches = (function() {

        /**
         * Properties of a SearchSpeeches.
         * @memberof mediaarchiver
         * @interface ISearchSpeeches
         * @property {string|null} [Search] SearchSpeeches Search
         * @property {mediaarchiver.SearchSpeechesLogic|null} [Logic] SearchSpeeches Logic
         * @property {Array.<number>|null} [Medias] SearchSpeeches Medias
         * @property {number|null} [Start] SearchSpeeches Start
         * @property {number|null} [End] SearchSpeeches End
         * @property {number|null} [Rows] SearchSpeeches Rows
         * @property {number|null} [Page] SearchSpeeches Page
         */

        /**
         * Constructs a new SearchSpeeches.
         * @memberof mediaarchiver
         * @classdesc Represents a SearchSpeeches.
         * @implements ISearchSpeeches
         * @constructor
         * @param {mediaarchiver.ISearchSpeeches=} [properties] Properties to set
         */
        function SearchSpeeches(properties) {
            this.Medias = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SearchSpeeches Search.
         * @member {string} Search
         * @memberof mediaarchiver.SearchSpeeches
         * @instance
         */
        SearchSpeeches.prototype.Search = "";

        /**
         * SearchSpeeches Logic.
         * @member {mediaarchiver.SearchSpeechesLogic} Logic
         * @memberof mediaarchiver.SearchSpeeches
         * @instance
         */
        SearchSpeeches.prototype.Logic = 0;

        /**
         * SearchSpeeches Medias.
         * @member {Array.<number>} Medias
         * @memberof mediaarchiver.SearchSpeeches
         * @instance
         */
        SearchSpeeches.prototype.Medias = $util.emptyArray;

        /**
         * SearchSpeeches Start.
         * @member {number} Start
         * @memberof mediaarchiver.SearchSpeeches
         * @instance
         */
        SearchSpeeches.prototype.Start = 0;

        /**
         * SearchSpeeches End.
         * @member {number} End
         * @memberof mediaarchiver.SearchSpeeches
         * @instance
         */
        SearchSpeeches.prototype.End = 0;

        /**
         * SearchSpeeches Rows.
         * @member {number} Rows
         * @memberof mediaarchiver.SearchSpeeches
         * @instance
         */
        SearchSpeeches.prototype.Rows = 0;

        /**
         * SearchSpeeches Page.
         * @member {number} Page
         * @memberof mediaarchiver.SearchSpeeches
         * @instance
         */
        SearchSpeeches.prototype.Page = 0;

        /**
         * Creates a new SearchSpeeches instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.SearchSpeeches
         * @static
         * @param {mediaarchiver.ISearchSpeeches=} [properties] Properties to set
         * @returns {mediaarchiver.SearchSpeeches} SearchSpeeches instance
         */
        SearchSpeeches.create = function create(properties) {
            return new SearchSpeeches(properties);
        };

        /**
         * Encodes the specified SearchSpeeches message. Does not implicitly {@link mediaarchiver.SearchSpeeches.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.SearchSpeeches
         * @static
         * @param {mediaarchiver.ISearchSpeeches} message SearchSpeeches message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchSpeeches.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Search != null && Object.hasOwnProperty.call(message, "Search"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Search);
            if (message.Logic != null && Object.hasOwnProperty.call(message, "Logic"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.Logic);
            if (message.Medias != null && message.Medias.length) {
                writer.uint32(/* id 3, wireType 2 =*/26).fork();
                for (let i = 0; i < message.Medias.length; ++i)
                    writer.uint32(message.Medias[i]);
                writer.ldelim();
            }
            if (message.Start != null && Object.hasOwnProperty.call(message, "Start"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.Start);
            if (message.End != null && Object.hasOwnProperty.call(message, "End"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.End);
            if (message.Rows != null && Object.hasOwnProperty.call(message, "Rows"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.Rows);
            if (message.Page != null && Object.hasOwnProperty.call(message, "Page"))
                writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.Page);
            return writer;
        };

        /**
         * Encodes the specified SearchSpeeches message, length delimited. Does not implicitly {@link mediaarchiver.SearchSpeeches.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.SearchSpeeches
         * @static
         * @param {mediaarchiver.ISearchSpeeches} message SearchSpeeches message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchSpeeches.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SearchSpeeches message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.SearchSpeeches
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.SearchSpeeches} SearchSpeeches
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchSpeeches.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.SearchSpeeches();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Search = reader.string();
                    break;
                case 2:
                    message.Logic = reader.int32();
                    break;
                case 3:
                    if (!(message.Medias && message.Medias.length))
                        message.Medias = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.Medias.push(reader.uint32());
                    } else
                        message.Medias.push(reader.uint32());
                    break;
                case 4:
                    message.Start = reader.uint32();
                    break;
                case 5:
                    message.End = reader.uint32();
                    break;
                case 6:
                    message.Rows = reader.uint32();
                    break;
                case 7:
                    message.Page = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SearchSpeeches message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.SearchSpeeches
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.SearchSpeeches} SearchSpeeches
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchSpeeches.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SearchSpeeches message.
         * @function verify
         * @memberof mediaarchiver.SearchSpeeches
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SearchSpeeches.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Search != null && message.hasOwnProperty("Search"))
                if (!$util.isString(message.Search))
                    return "Search: string expected";
            if (message.Logic != null && message.hasOwnProperty("Logic"))
                switch (message.Logic) {
                default:
                    return "Logic: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.Medias != null && message.hasOwnProperty("Medias")) {
                if (!Array.isArray(message.Medias))
                    return "Medias: array expected";
                for (let i = 0; i < message.Medias.length; ++i)
                    if (!$util.isInteger(message.Medias[i]))
                        return "Medias: integer[] expected";
            }
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (!$util.isInteger(message.Start))
                    return "Start: integer expected";
            if (message.End != null && message.hasOwnProperty("End"))
                if (!$util.isInteger(message.End))
                    return "End: integer expected";
            if (message.Rows != null && message.hasOwnProperty("Rows"))
                if (!$util.isInteger(message.Rows))
                    return "Rows: integer expected";
            if (message.Page != null && message.hasOwnProperty("Page"))
                if (!$util.isInteger(message.Page))
                    return "Page: integer expected";
            return null;
        };

        /**
         * Creates a SearchSpeeches message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.SearchSpeeches
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.SearchSpeeches} SearchSpeeches
         */
        SearchSpeeches.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.SearchSpeeches)
                return object;
            let message = new $root.mediaarchiver.SearchSpeeches();
            if (object.Search != null)
                message.Search = String(object.Search);
            switch (object.Logic) {
            case "SPEECH_SEARCH_LOGIC_UNKNOWN":
            case 0:
                message.Logic = 0;
                break;
            case "SPEECH_SEARCH_LOGIC_AND":
            case 1:
                message.Logic = 1;
                break;
            case "SPEECH_SEARCH_LOGIC_OR":
            case 2:
                message.Logic = 2;
                break;
            case "SPEECH_SEARCH_LOGIC_PHRASE":
            case 3:
                message.Logic = 3;
                break;
            }
            if (object.Medias) {
                if (!Array.isArray(object.Medias))
                    throw TypeError(".mediaarchiver.SearchSpeeches.Medias: array expected");
                message.Medias = [];
                for (let i = 0; i < object.Medias.length; ++i)
                    message.Medias[i] = object.Medias[i] >>> 0;
            }
            if (object.Start != null)
                message.Start = object.Start >>> 0;
            if (object.End != null)
                message.End = object.End >>> 0;
            if (object.Rows != null)
                message.Rows = object.Rows >>> 0;
            if (object.Page != null)
                message.Page = object.Page >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a SearchSpeeches message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.SearchSpeeches
         * @static
         * @param {mediaarchiver.SearchSpeeches} message SearchSpeeches
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SearchSpeeches.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Medias = [];
            if (options.defaults) {
                object.Search = "";
                object.Logic = options.enums === String ? "SPEECH_SEARCH_LOGIC_UNKNOWN" : 0;
                object.Start = 0;
                object.End = 0;
                object.Rows = 0;
                object.Page = 0;
            }
            if (message.Search != null && message.hasOwnProperty("Search"))
                object.Search = message.Search;
            if (message.Logic != null && message.hasOwnProperty("Logic"))
                object.Logic = options.enums === String ? $root.mediaarchiver.SearchSpeechesLogic[message.Logic] : message.Logic;
            if (message.Medias && message.Medias.length) {
                object.Medias = [];
                for (let j = 0; j < message.Medias.length; ++j)
                    object.Medias[j] = message.Medias[j];
            }
            if (message.Start != null && message.hasOwnProperty("Start"))
                object.Start = message.Start;
            if (message.End != null && message.hasOwnProperty("End"))
                object.End = message.End;
            if (message.Rows != null && message.hasOwnProperty("Rows"))
                object.Rows = message.Rows;
            if (message.Page != null && message.hasOwnProperty("Page"))
                object.Page = message.Page;
            return object;
        };

        /**
         * Converts this SearchSpeeches to JSON.
         * @function toJSON
         * @memberof mediaarchiver.SearchSpeeches
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SearchSpeeches.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SearchSpeeches;
    })();

    mediaarchiver.SearchSpeechesDate = (function() {

        /**
         * Properties of a SearchSpeechesDate.
         * @memberof mediaarchiver
         * @interface ISearchSpeechesDate
         * @property {number|null} [Medias] SearchSpeechesDate Medias
         * @property {number|null} [Start] SearchSpeechesDate Start
         * @property {number|null} [End] SearchSpeechesDate End
         */

        /**
         * Constructs a new SearchSpeechesDate.
         * @memberof mediaarchiver
         * @classdesc Represents a SearchSpeechesDate.
         * @implements ISearchSpeechesDate
         * @constructor
         * @param {mediaarchiver.ISearchSpeechesDate=} [properties] Properties to set
         */
        function SearchSpeechesDate(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SearchSpeechesDate Medias.
         * @member {number} Medias
         * @memberof mediaarchiver.SearchSpeechesDate
         * @instance
         */
        SearchSpeechesDate.prototype.Medias = 0;

        /**
         * SearchSpeechesDate Start.
         * @member {number} Start
         * @memberof mediaarchiver.SearchSpeechesDate
         * @instance
         */
        SearchSpeechesDate.prototype.Start = 0;

        /**
         * SearchSpeechesDate End.
         * @member {number} End
         * @memberof mediaarchiver.SearchSpeechesDate
         * @instance
         */
        SearchSpeechesDate.prototype.End = 0;

        /**
         * Creates a new SearchSpeechesDate instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.SearchSpeechesDate
         * @static
         * @param {mediaarchiver.ISearchSpeechesDate=} [properties] Properties to set
         * @returns {mediaarchiver.SearchSpeechesDate} SearchSpeechesDate instance
         */
        SearchSpeechesDate.create = function create(properties) {
            return new SearchSpeechesDate(properties);
        };

        /**
         * Encodes the specified SearchSpeechesDate message. Does not implicitly {@link mediaarchiver.SearchSpeechesDate.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.SearchSpeechesDate
         * @static
         * @param {mediaarchiver.ISearchSpeechesDate} message SearchSpeechesDate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchSpeechesDate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Medias != null && Object.hasOwnProperty.call(message, "Medias"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Medias);
            if (message.Start != null && Object.hasOwnProperty.call(message, "Start"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.Start);
            if (message.End != null && Object.hasOwnProperty.call(message, "End"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.End);
            return writer;
        };

        /**
         * Encodes the specified SearchSpeechesDate message, length delimited. Does not implicitly {@link mediaarchiver.SearchSpeechesDate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.SearchSpeechesDate
         * @static
         * @param {mediaarchiver.ISearchSpeechesDate} message SearchSpeechesDate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchSpeechesDate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SearchSpeechesDate message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.SearchSpeechesDate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.SearchSpeechesDate} SearchSpeechesDate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchSpeechesDate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.SearchSpeechesDate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Medias = reader.uint32();
                    break;
                case 2:
                    message.Start = reader.uint32();
                    break;
                case 3:
                    message.End = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SearchSpeechesDate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.SearchSpeechesDate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.SearchSpeechesDate} SearchSpeechesDate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchSpeechesDate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SearchSpeechesDate message.
         * @function verify
         * @memberof mediaarchiver.SearchSpeechesDate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SearchSpeechesDate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Medias != null && message.hasOwnProperty("Medias"))
                if (!$util.isInteger(message.Medias))
                    return "Medias: integer expected";
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (!$util.isInteger(message.Start))
                    return "Start: integer expected";
            if (message.End != null && message.hasOwnProperty("End"))
                if (!$util.isInteger(message.End))
                    return "End: integer expected";
            return null;
        };

        /**
         * Creates a SearchSpeechesDate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.SearchSpeechesDate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.SearchSpeechesDate} SearchSpeechesDate
         */
        SearchSpeechesDate.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.SearchSpeechesDate)
                return object;
            let message = new $root.mediaarchiver.SearchSpeechesDate();
            if (object.Medias != null)
                message.Medias = object.Medias >>> 0;
            if (object.Start != null)
                message.Start = object.Start >>> 0;
            if (object.End != null)
                message.End = object.End >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a SearchSpeechesDate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.SearchSpeechesDate
         * @static
         * @param {mediaarchiver.SearchSpeechesDate} message SearchSpeechesDate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SearchSpeechesDate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.Medias = 0;
                object.Start = 0;
                object.End = 0;
            }
            if (message.Medias != null && message.hasOwnProperty("Medias"))
                object.Medias = message.Medias;
            if (message.Start != null && message.hasOwnProperty("Start"))
                object.Start = message.Start;
            if (message.End != null && message.hasOwnProperty("End"))
                object.End = message.End;
            return object;
        };

        /**
         * Converts this SearchSpeechesDate to JSON.
         * @function toJSON
         * @memberof mediaarchiver.SearchSpeechesDate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SearchSpeechesDate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SearchSpeechesDate;
    })();

    mediaarchiver.SearchSpeechesWord = (function() {

        /**
         * Properties of a SearchSpeechesWord.
         * @memberof mediaarchiver
         * @interface ISearchSpeechesWord
         * @property {string|null} [MediaLongID] SearchSpeechesWord MediaLongID
         * @property {string|null} [Word] SearchSpeechesWord Word
         * @property {string|null} [WordUID] SearchSpeechesWord WordUID
         * @property {number|null} [Dts] SearchSpeechesWord Dts
         * @property {number|null} [Dte] SearchSpeechesWord Dte
         */

        /**
         * Constructs a new SearchSpeechesWord.
         * @memberof mediaarchiver
         * @classdesc Represents a SearchSpeechesWord.
         * @implements ISearchSpeechesWord
         * @constructor
         * @param {mediaarchiver.ISearchSpeechesWord=} [properties] Properties to set
         */
        function SearchSpeechesWord(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SearchSpeechesWord MediaLongID.
         * @member {string} MediaLongID
         * @memberof mediaarchiver.SearchSpeechesWord
         * @instance
         */
        SearchSpeechesWord.prototype.MediaLongID = "";

        /**
         * SearchSpeechesWord Word.
         * @member {string} Word
         * @memberof mediaarchiver.SearchSpeechesWord
         * @instance
         */
        SearchSpeechesWord.prototype.Word = "";

        /**
         * SearchSpeechesWord WordUID.
         * @member {string} WordUID
         * @memberof mediaarchiver.SearchSpeechesWord
         * @instance
         */
        SearchSpeechesWord.prototype.WordUID = "";

        /**
         * SearchSpeechesWord Dts.
         * @member {number} Dts
         * @memberof mediaarchiver.SearchSpeechesWord
         * @instance
         */
        SearchSpeechesWord.prototype.Dts = 0;

        /**
         * SearchSpeechesWord Dte.
         * @member {number} Dte
         * @memberof mediaarchiver.SearchSpeechesWord
         * @instance
         */
        SearchSpeechesWord.prototype.Dte = 0;

        /**
         * Creates a new SearchSpeechesWord instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.SearchSpeechesWord
         * @static
         * @param {mediaarchiver.ISearchSpeechesWord=} [properties] Properties to set
         * @returns {mediaarchiver.SearchSpeechesWord} SearchSpeechesWord instance
         */
        SearchSpeechesWord.create = function create(properties) {
            return new SearchSpeechesWord(properties);
        };

        /**
         * Encodes the specified SearchSpeechesWord message. Does not implicitly {@link mediaarchiver.SearchSpeechesWord.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.SearchSpeechesWord
         * @static
         * @param {mediaarchiver.ISearchSpeechesWord} message SearchSpeechesWord message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchSpeechesWord.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.MediaLongID != null && Object.hasOwnProperty.call(message, "MediaLongID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.MediaLongID);
            if (message.Word != null && Object.hasOwnProperty.call(message, "Word"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Word);
            if (message.WordUID != null && Object.hasOwnProperty.call(message, "WordUID"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.WordUID);
            if (message.Dts != null && Object.hasOwnProperty.call(message, "Dts"))
                writer.uint32(/* id 5, wireType 1 =*/41).double(message.Dts);
            if (message.Dte != null && Object.hasOwnProperty.call(message, "Dte"))
                writer.uint32(/* id 6, wireType 1 =*/49).double(message.Dte);
            return writer;
        };

        /**
         * Encodes the specified SearchSpeechesWord message, length delimited. Does not implicitly {@link mediaarchiver.SearchSpeechesWord.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.SearchSpeechesWord
         * @static
         * @param {mediaarchiver.ISearchSpeechesWord} message SearchSpeechesWord message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchSpeechesWord.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SearchSpeechesWord message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.SearchSpeechesWord
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.SearchSpeechesWord} SearchSpeechesWord
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchSpeechesWord.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.SearchSpeechesWord();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.MediaLongID = reader.string();
                    break;
                case 2:
                    message.Word = reader.string();
                    break;
                case 3:
                    message.WordUID = reader.string();
                    break;
                case 5:
                    message.Dts = reader.double();
                    break;
                case 6:
                    message.Dte = reader.double();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SearchSpeechesWord message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.SearchSpeechesWord
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.SearchSpeechesWord} SearchSpeechesWord
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchSpeechesWord.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SearchSpeechesWord message.
         * @function verify
         * @memberof mediaarchiver.SearchSpeechesWord
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SearchSpeechesWord.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.MediaLongID != null && message.hasOwnProperty("MediaLongID"))
                if (!$util.isString(message.MediaLongID))
                    return "MediaLongID: string expected";
            if (message.Word != null && message.hasOwnProperty("Word"))
                if (!$util.isString(message.Word))
                    return "Word: string expected";
            if (message.WordUID != null && message.hasOwnProperty("WordUID"))
                if (!$util.isString(message.WordUID))
                    return "WordUID: string expected";
            if (message.Dts != null && message.hasOwnProperty("Dts"))
                if (typeof message.Dts !== "number")
                    return "Dts: number expected";
            if (message.Dte != null && message.hasOwnProperty("Dte"))
                if (typeof message.Dte !== "number")
                    return "Dte: number expected";
            return null;
        };

        /**
         * Creates a SearchSpeechesWord message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.SearchSpeechesWord
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.SearchSpeechesWord} SearchSpeechesWord
         */
        SearchSpeechesWord.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.SearchSpeechesWord)
                return object;
            let message = new $root.mediaarchiver.SearchSpeechesWord();
            if (object.MediaLongID != null)
                message.MediaLongID = String(object.MediaLongID);
            if (object.Word != null)
                message.Word = String(object.Word);
            if (object.WordUID != null)
                message.WordUID = String(object.WordUID);
            if (object.Dts != null)
                message.Dts = Number(object.Dts);
            if (object.Dte != null)
                message.Dte = Number(object.Dte);
            return message;
        };

        /**
         * Creates a plain object from a SearchSpeechesWord message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.SearchSpeechesWord
         * @static
         * @param {mediaarchiver.SearchSpeechesWord} message SearchSpeechesWord
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SearchSpeechesWord.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.MediaLongID = "";
                object.Word = "";
                object.WordUID = "";
                object.Dts = 0;
                object.Dte = 0;
            }
            if (message.MediaLongID != null && message.hasOwnProperty("MediaLongID"))
                object.MediaLongID = message.MediaLongID;
            if (message.Word != null && message.hasOwnProperty("Word"))
                object.Word = message.Word;
            if (message.WordUID != null && message.hasOwnProperty("WordUID"))
                object.WordUID = message.WordUID;
            if (message.Dts != null && message.hasOwnProperty("Dts"))
                object.Dts = options.json && !isFinite(message.Dts) ? String(message.Dts) : message.Dts;
            if (message.Dte != null && message.hasOwnProperty("Dte"))
                object.Dte = options.json && !isFinite(message.Dte) ? String(message.Dte) : message.Dte;
            return object;
        };

        /**
         * Converts this SearchSpeechesWord to JSON.
         * @function toJSON
         * @memberof mediaarchiver.SearchSpeechesWord
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SearchSpeechesWord.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SearchSpeechesWord;
    })();

    mediaarchiver.SearchSpeechResultpeaker = (function() {

        /**
         * Properties of a SearchSpeechResultpeaker.
         * @memberof mediaarchiver
         * @interface ISearchSpeechResultpeaker
         * @property {string|null} [UID] SearchSpeechResultpeaker UID
         * @property {string|null} [Gender] SearchSpeechResultpeaker Gender
         * @property {string|null} [Language] SearchSpeechResultpeaker Language
         */

        /**
         * Constructs a new SearchSpeechResultpeaker.
         * @memberof mediaarchiver
         * @classdesc Represents a SearchSpeechResultpeaker.
         * @implements ISearchSpeechResultpeaker
         * @constructor
         * @param {mediaarchiver.ISearchSpeechResultpeaker=} [properties] Properties to set
         */
        function SearchSpeechResultpeaker(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SearchSpeechResultpeaker UID.
         * @member {string} UID
         * @memberof mediaarchiver.SearchSpeechResultpeaker
         * @instance
         */
        SearchSpeechResultpeaker.prototype.UID = "";

        /**
         * SearchSpeechResultpeaker Gender.
         * @member {string} Gender
         * @memberof mediaarchiver.SearchSpeechResultpeaker
         * @instance
         */
        SearchSpeechResultpeaker.prototype.Gender = "";

        /**
         * SearchSpeechResultpeaker Language.
         * @member {string} Language
         * @memberof mediaarchiver.SearchSpeechResultpeaker
         * @instance
         */
        SearchSpeechResultpeaker.prototype.Language = "";

        /**
         * Creates a new SearchSpeechResultpeaker instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.SearchSpeechResultpeaker
         * @static
         * @param {mediaarchiver.ISearchSpeechResultpeaker=} [properties] Properties to set
         * @returns {mediaarchiver.SearchSpeechResultpeaker} SearchSpeechResultpeaker instance
         */
        SearchSpeechResultpeaker.create = function create(properties) {
            return new SearchSpeechResultpeaker(properties);
        };

        /**
         * Encodes the specified SearchSpeechResultpeaker message. Does not implicitly {@link mediaarchiver.SearchSpeechResultpeaker.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.SearchSpeechResultpeaker
         * @static
         * @param {mediaarchiver.ISearchSpeechResultpeaker} message SearchSpeechResultpeaker message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchSpeechResultpeaker.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.UID != null && Object.hasOwnProperty.call(message, "UID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.UID);
            if (message.Gender != null && Object.hasOwnProperty.call(message, "Gender"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Gender);
            if (message.Language != null && Object.hasOwnProperty.call(message, "Language"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.Language);
            return writer;
        };

        /**
         * Encodes the specified SearchSpeechResultpeaker message, length delimited. Does not implicitly {@link mediaarchiver.SearchSpeechResultpeaker.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.SearchSpeechResultpeaker
         * @static
         * @param {mediaarchiver.ISearchSpeechResultpeaker} message SearchSpeechResultpeaker message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchSpeechResultpeaker.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SearchSpeechResultpeaker message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.SearchSpeechResultpeaker
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.SearchSpeechResultpeaker} SearchSpeechResultpeaker
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchSpeechResultpeaker.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.SearchSpeechResultpeaker();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.UID = reader.string();
                    break;
                case 2:
                    message.Gender = reader.string();
                    break;
                case 3:
                    message.Language = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SearchSpeechResultpeaker message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.SearchSpeechResultpeaker
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.SearchSpeechResultpeaker} SearchSpeechResultpeaker
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchSpeechResultpeaker.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SearchSpeechResultpeaker message.
         * @function verify
         * @memberof mediaarchiver.SearchSpeechResultpeaker
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SearchSpeechResultpeaker.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.UID != null && message.hasOwnProperty("UID"))
                if (!$util.isString(message.UID))
                    return "UID: string expected";
            if (message.Gender != null && message.hasOwnProperty("Gender"))
                if (!$util.isString(message.Gender))
                    return "Gender: string expected";
            if (message.Language != null && message.hasOwnProperty("Language"))
                if (!$util.isString(message.Language))
                    return "Language: string expected";
            return null;
        };

        /**
         * Creates a SearchSpeechResultpeaker message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.SearchSpeechResultpeaker
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.SearchSpeechResultpeaker} SearchSpeechResultpeaker
         */
        SearchSpeechResultpeaker.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.SearchSpeechResultpeaker)
                return object;
            let message = new $root.mediaarchiver.SearchSpeechResultpeaker();
            if (object.UID != null)
                message.UID = String(object.UID);
            if (object.Gender != null)
                message.Gender = String(object.Gender);
            if (object.Language != null)
                message.Language = String(object.Language);
            return message;
        };

        /**
         * Creates a plain object from a SearchSpeechResultpeaker message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.SearchSpeechResultpeaker
         * @static
         * @param {mediaarchiver.SearchSpeechResultpeaker} message SearchSpeechResultpeaker
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SearchSpeechResultpeaker.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.UID = "";
                object.Gender = "";
                object.Language = "";
            }
            if (message.UID != null && message.hasOwnProperty("UID"))
                object.UID = message.UID;
            if (message.Gender != null && message.hasOwnProperty("Gender"))
                object.Gender = message.Gender;
            if (message.Language != null && message.hasOwnProperty("Language"))
                object.Language = message.Language;
            return object;
        };

        /**
         * Converts this SearchSpeechResultpeaker to JSON.
         * @function toJSON
         * @memberof mediaarchiver.SearchSpeechResultpeaker
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SearchSpeechResultpeaker.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SearchSpeechResultpeaker;
    })();

    mediaarchiver.SearchSpeechResult = (function() {

        /**
         * Properties of a SearchSpeechResult.
         * @memberof mediaarchiver
         * @interface ISearchSpeechResult
         * @property {string|null} [ID] SearchSpeechResult ID
         * @property {number|null} [Media] SearchSpeechResult Media
         * @property {Array.<string>|null} [Matches] SearchSpeechResult Matches
         * @property {number|null} [Start] SearchSpeechResult Start
         * @property {number|null} [End] SearchSpeechResult End
         * @property {Array.<mediaarchiver.ISearchSpeechesWord>|null} [Fullwords] SearchSpeechResult Fullwords
         * @property {mediaarchiver.ISearchSpeechResultpeaker|null} [Speaker] SearchSpeechResult Speaker
         */

        /**
         * Constructs a new SearchSpeechResult.
         * @memberof mediaarchiver
         * @classdesc Represents a SearchSpeechResult.
         * @implements ISearchSpeechResult
         * @constructor
         * @param {mediaarchiver.ISearchSpeechResult=} [properties] Properties to set
         */
        function SearchSpeechResult(properties) {
            this.Matches = [];
            this.Fullwords = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SearchSpeechResult ID.
         * @member {string} ID
         * @memberof mediaarchiver.SearchSpeechResult
         * @instance
         */
        SearchSpeechResult.prototype.ID = "";

        /**
         * SearchSpeechResult Media.
         * @member {number} Media
         * @memberof mediaarchiver.SearchSpeechResult
         * @instance
         */
        SearchSpeechResult.prototype.Media = 0;

        /**
         * SearchSpeechResult Matches.
         * @member {Array.<string>} Matches
         * @memberof mediaarchiver.SearchSpeechResult
         * @instance
         */
        SearchSpeechResult.prototype.Matches = $util.emptyArray;

        /**
         * SearchSpeechResult Start.
         * @member {number} Start
         * @memberof mediaarchiver.SearchSpeechResult
         * @instance
         */
        SearchSpeechResult.prototype.Start = 0;

        /**
         * SearchSpeechResult End.
         * @member {number} End
         * @memberof mediaarchiver.SearchSpeechResult
         * @instance
         */
        SearchSpeechResult.prototype.End = 0;

        /**
         * SearchSpeechResult Fullwords.
         * @member {Array.<mediaarchiver.ISearchSpeechesWord>} Fullwords
         * @memberof mediaarchiver.SearchSpeechResult
         * @instance
         */
        SearchSpeechResult.prototype.Fullwords = $util.emptyArray;

        /**
         * SearchSpeechResult Speaker.
         * @member {mediaarchiver.ISearchSpeechResultpeaker|null|undefined} Speaker
         * @memberof mediaarchiver.SearchSpeechResult
         * @instance
         */
        SearchSpeechResult.prototype.Speaker = null;

        /**
         * Creates a new SearchSpeechResult instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.SearchSpeechResult
         * @static
         * @param {mediaarchiver.ISearchSpeechResult=} [properties] Properties to set
         * @returns {mediaarchiver.SearchSpeechResult} SearchSpeechResult instance
         */
        SearchSpeechResult.create = function create(properties) {
            return new SearchSpeechResult(properties);
        };

        /**
         * Encodes the specified SearchSpeechResult message. Does not implicitly {@link mediaarchiver.SearchSpeechResult.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.SearchSpeechResult
         * @static
         * @param {mediaarchiver.ISearchSpeechResult} message SearchSpeechResult message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchSpeechResult.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.ID);
            if (message.Media != null && Object.hasOwnProperty.call(message, "Media"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.Media);
            if (message.Matches != null && message.Matches.length)
                for (let i = 0; i < message.Matches.length; ++i)
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.Matches[i]);
            if (message.Start != null && Object.hasOwnProperty.call(message, "Start"))
                writer.uint32(/* id 5, wireType 1 =*/41).double(message.Start);
            if (message.End != null && Object.hasOwnProperty.call(message, "End"))
                writer.uint32(/* id 6, wireType 1 =*/49).double(message.End);
            if (message.Fullwords != null && message.Fullwords.length)
                for (let i = 0; i < message.Fullwords.length; ++i)
                    $root.mediaarchiver.SearchSpeechesWord.encode(message.Fullwords[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
            if (message.Speaker != null && Object.hasOwnProperty.call(message, "Speaker"))
                $root.mediaarchiver.SearchSpeechResultpeaker.encode(message.Speaker, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SearchSpeechResult message, length delimited. Does not implicitly {@link mediaarchiver.SearchSpeechResult.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.SearchSpeechResult
         * @static
         * @param {mediaarchiver.ISearchSpeechResult} message SearchSpeechResult message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchSpeechResult.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SearchSpeechResult message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.SearchSpeechResult
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.SearchSpeechResult} SearchSpeechResult
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchSpeechResult.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.SearchSpeechResult();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ID = reader.string();
                    break;
                case 3:
                    message.Media = reader.uint32();
                    break;
                case 4:
                    if (!(message.Matches && message.Matches.length))
                        message.Matches = [];
                    message.Matches.push(reader.string());
                    break;
                case 5:
                    message.Start = reader.double();
                    break;
                case 6:
                    message.End = reader.double();
                    break;
                case 8:
                    if (!(message.Fullwords && message.Fullwords.length))
                        message.Fullwords = [];
                    message.Fullwords.push($root.mediaarchiver.SearchSpeechesWord.decode(reader, reader.uint32()));
                    break;
                case 10:
                    message.Speaker = $root.mediaarchiver.SearchSpeechResultpeaker.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SearchSpeechResult message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.SearchSpeechResult
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.SearchSpeechResult} SearchSpeechResult
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchSpeechResult.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SearchSpeechResult message.
         * @function verify
         * @memberof mediaarchiver.SearchSpeechResult
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SearchSpeechResult.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isString(message.ID))
                    return "ID: string expected";
            if (message.Media != null && message.hasOwnProperty("Media"))
                if (!$util.isInteger(message.Media))
                    return "Media: integer expected";
            if (message.Matches != null && message.hasOwnProperty("Matches")) {
                if (!Array.isArray(message.Matches))
                    return "Matches: array expected";
                for (let i = 0; i < message.Matches.length; ++i)
                    if (!$util.isString(message.Matches[i]))
                        return "Matches: string[] expected";
            }
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (typeof message.Start !== "number")
                    return "Start: number expected";
            if (message.End != null && message.hasOwnProperty("End"))
                if (typeof message.End !== "number")
                    return "End: number expected";
            if (message.Fullwords != null && message.hasOwnProperty("Fullwords")) {
                if (!Array.isArray(message.Fullwords))
                    return "Fullwords: array expected";
                for (let i = 0; i < message.Fullwords.length; ++i) {
                    let error = $root.mediaarchiver.SearchSpeechesWord.verify(message.Fullwords[i]);
                    if (error)
                        return "Fullwords." + error;
                }
            }
            if (message.Speaker != null && message.hasOwnProperty("Speaker")) {
                let error = $root.mediaarchiver.SearchSpeechResultpeaker.verify(message.Speaker);
                if (error)
                    return "Speaker." + error;
            }
            return null;
        };

        /**
         * Creates a SearchSpeechResult message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.SearchSpeechResult
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.SearchSpeechResult} SearchSpeechResult
         */
        SearchSpeechResult.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.SearchSpeechResult)
                return object;
            let message = new $root.mediaarchiver.SearchSpeechResult();
            if (object.ID != null)
                message.ID = String(object.ID);
            if (object.Media != null)
                message.Media = object.Media >>> 0;
            if (object.Matches) {
                if (!Array.isArray(object.Matches))
                    throw TypeError(".mediaarchiver.SearchSpeechResult.Matches: array expected");
                message.Matches = [];
                for (let i = 0; i < object.Matches.length; ++i)
                    message.Matches[i] = String(object.Matches[i]);
            }
            if (object.Start != null)
                message.Start = Number(object.Start);
            if (object.End != null)
                message.End = Number(object.End);
            if (object.Fullwords) {
                if (!Array.isArray(object.Fullwords))
                    throw TypeError(".mediaarchiver.SearchSpeechResult.Fullwords: array expected");
                message.Fullwords = [];
                for (let i = 0; i < object.Fullwords.length; ++i) {
                    if (typeof object.Fullwords[i] !== "object")
                        throw TypeError(".mediaarchiver.SearchSpeechResult.Fullwords: object expected");
                    message.Fullwords[i] = $root.mediaarchiver.SearchSpeechesWord.fromObject(object.Fullwords[i]);
                }
            }
            if (object.Speaker != null) {
                if (typeof object.Speaker !== "object")
                    throw TypeError(".mediaarchiver.SearchSpeechResult.Speaker: object expected");
                message.Speaker = $root.mediaarchiver.SearchSpeechResultpeaker.fromObject(object.Speaker);
            }
            return message;
        };

        /**
         * Creates a plain object from a SearchSpeechResult message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.SearchSpeechResult
         * @static
         * @param {mediaarchiver.SearchSpeechResult} message SearchSpeechResult
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SearchSpeechResult.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.Matches = [];
                object.Fullwords = [];
            }
            if (options.defaults) {
                object.ID = "";
                object.Media = 0;
                object.Start = 0;
                object.End = 0;
                object.Speaker = null;
            }
            if (message.ID != null && message.hasOwnProperty("ID"))
                object.ID = message.ID;
            if (message.Media != null && message.hasOwnProperty("Media"))
                object.Media = message.Media;
            if (message.Matches && message.Matches.length) {
                object.Matches = [];
                for (let j = 0; j < message.Matches.length; ++j)
                    object.Matches[j] = message.Matches[j];
            }
            if (message.Start != null && message.hasOwnProperty("Start"))
                object.Start = options.json && !isFinite(message.Start) ? String(message.Start) : message.Start;
            if (message.End != null && message.hasOwnProperty("End"))
                object.End = options.json && !isFinite(message.End) ? String(message.End) : message.End;
            if (message.Fullwords && message.Fullwords.length) {
                object.Fullwords = [];
                for (let j = 0; j < message.Fullwords.length; ++j)
                    object.Fullwords[j] = $root.mediaarchiver.SearchSpeechesWord.toObject(message.Fullwords[j], options);
            }
            if (message.Speaker != null && message.hasOwnProperty("Speaker"))
                object.Speaker = $root.mediaarchiver.SearchSpeechResultpeaker.toObject(message.Speaker, options);
            return object;
        };

        /**
         * Converts this SearchSpeechResult to JSON.
         * @function toJSON
         * @memberof mediaarchiver.SearchSpeechResult
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SearchSpeechResult.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SearchSpeechResult;
    })();

    mediaarchiver.SearchSpeechesResult = (function() {

        /**
         * Properties of a SearchSpeechesResult.
         * @memberof mediaarchiver
         * @interface ISearchSpeechesResult
         * @property {number|null} [Count] SearchSpeechesResult Count
         * @property {Array.<mediaarchiver.ISearchSpeechResult>|null} [Result] SearchSpeechesResult Result
         */

        /**
         * Constructs a new SearchSpeechesResult.
         * @memberof mediaarchiver
         * @classdesc Represents a SearchSpeechesResult.
         * @implements ISearchSpeechesResult
         * @constructor
         * @param {mediaarchiver.ISearchSpeechesResult=} [properties] Properties to set
         */
        function SearchSpeechesResult(properties) {
            this.Result = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SearchSpeechesResult Count.
         * @member {number} Count
         * @memberof mediaarchiver.SearchSpeechesResult
         * @instance
         */
        SearchSpeechesResult.prototype.Count = 0;

        /**
         * SearchSpeechesResult Result.
         * @member {Array.<mediaarchiver.ISearchSpeechResult>} Result
         * @memberof mediaarchiver.SearchSpeechesResult
         * @instance
         */
        SearchSpeechesResult.prototype.Result = $util.emptyArray;

        /**
         * Creates a new SearchSpeechesResult instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.SearchSpeechesResult
         * @static
         * @param {mediaarchiver.ISearchSpeechesResult=} [properties] Properties to set
         * @returns {mediaarchiver.SearchSpeechesResult} SearchSpeechesResult instance
         */
        SearchSpeechesResult.create = function create(properties) {
            return new SearchSpeechesResult(properties);
        };

        /**
         * Encodes the specified SearchSpeechesResult message. Does not implicitly {@link mediaarchiver.SearchSpeechesResult.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.SearchSpeechesResult
         * @static
         * @param {mediaarchiver.ISearchSpeechesResult} message SearchSpeechesResult message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchSpeechesResult.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Count != null && Object.hasOwnProperty.call(message, "Count"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Count);
            if (message.Result != null && message.Result.length)
                for (let i = 0; i < message.Result.length; ++i)
                    $root.mediaarchiver.SearchSpeechResult.encode(message.Result[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SearchSpeechesResult message, length delimited. Does not implicitly {@link mediaarchiver.SearchSpeechesResult.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.SearchSpeechesResult
         * @static
         * @param {mediaarchiver.ISearchSpeechesResult} message SearchSpeechesResult message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchSpeechesResult.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SearchSpeechesResult message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.SearchSpeechesResult
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.SearchSpeechesResult} SearchSpeechesResult
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchSpeechesResult.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.SearchSpeechesResult();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Count = reader.uint32();
                    break;
                case 2:
                    if (!(message.Result && message.Result.length))
                        message.Result = [];
                    message.Result.push($root.mediaarchiver.SearchSpeechResult.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SearchSpeechesResult message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.SearchSpeechesResult
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.SearchSpeechesResult} SearchSpeechesResult
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchSpeechesResult.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SearchSpeechesResult message.
         * @function verify
         * @memberof mediaarchiver.SearchSpeechesResult
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SearchSpeechesResult.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Count != null && message.hasOwnProperty("Count"))
                if (!$util.isInteger(message.Count))
                    return "Count: integer expected";
            if (message.Result != null && message.hasOwnProperty("Result")) {
                if (!Array.isArray(message.Result))
                    return "Result: array expected";
                for (let i = 0; i < message.Result.length; ++i) {
                    let error = $root.mediaarchiver.SearchSpeechResult.verify(message.Result[i]);
                    if (error)
                        return "Result." + error;
                }
            }
            return null;
        };

        /**
         * Creates a SearchSpeechesResult message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.SearchSpeechesResult
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.SearchSpeechesResult} SearchSpeechesResult
         */
        SearchSpeechesResult.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.SearchSpeechesResult)
                return object;
            let message = new $root.mediaarchiver.SearchSpeechesResult();
            if (object.Count != null)
                message.Count = object.Count >>> 0;
            if (object.Result) {
                if (!Array.isArray(object.Result))
                    throw TypeError(".mediaarchiver.SearchSpeechesResult.Result: array expected");
                message.Result = [];
                for (let i = 0; i < object.Result.length; ++i) {
                    if (typeof object.Result[i] !== "object")
                        throw TypeError(".mediaarchiver.SearchSpeechesResult.Result: object expected");
                    message.Result[i] = $root.mediaarchiver.SearchSpeechResult.fromObject(object.Result[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a SearchSpeechesResult message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.SearchSpeechesResult
         * @static
         * @param {mediaarchiver.SearchSpeechesResult} message SearchSpeechesResult
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SearchSpeechesResult.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Result = [];
            if (options.defaults)
                object.Count = 0;
            if (message.Count != null && message.hasOwnProperty("Count"))
                object.Count = message.Count;
            if (message.Result && message.Result.length) {
                object.Result = [];
                for (let j = 0; j < message.Result.length; ++j)
                    object.Result[j] = $root.mediaarchiver.SearchSpeechResult.toObject(message.Result[j], options);
            }
            return object;
        };

        /**
         * Converts this SearchSpeechesResult to JSON.
         * @function toJSON
         * @memberof mediaarchiver.SearchSpeechesResult
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SearchSpeechesResult.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SearchSpeechesResult;
    })();

    mediaarchiver.SearchSpeechesDateResult = (function() {

        /**
         * Properties of a SearchSpeechesDateResult.
         * @memberof mediaarchiver
         * @interface ISearchSpeechesDateResult
         * @property {number|null} [Count] SearchSpeechesDateResult Count
         * @property {Array.<mediaarchiver.ISearchSpeechesWord>|null} [Result] SearchSpeechesDateResult Result
         */

        /**
         * Constructs a new SearchSpeechesDateResult.
         * @memberof mediaarchiver
         * @classdesc Represents a SearchSpeechesDateResult.
         * @implements ISearchSpeechesDateResult
         * @constructor
         * @param {mediaarchiver.ISearchSpeechesDateResult=} [properties] Properties to set
         */
        function SearchSpeechesDateResult(properties) {
            this.Result = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SearchSpeechesDateResult Count.
         * @member {number} Count
         * @memberof mediaarchiver.SearchSpeechesDateResult
         * @instance
         */
        SearchSpeechesDateResult.prototype.Count = 0;

        /**
         * SearchSpeechesDateResult Result.
         * @member {Array.<mediaarchiver.ISearchSpeechesWord>} Result
         * @memberof mediaarchiver.SearchSpeechesDateResult
         * @instance
         */
        SearchSpeechesDateResult.prototype.Result = $util.emptyArray;

        /**
         * Creates a new SearchSpeechesDateResult instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.SearchSpeechesDateResult
         * @static
         * @param {mediaarchiver.ISearchSpeechesDateResult=} [properties] Properties to set
         * @returns {mediaarchiver.SearchSpeechesDateResult} SearchSpeechesDateResult instance
         */
        SearchSpeechesDateResult.create = function create(properties) {
            return new SearchSpeechesDateResult(properties);
        };

        /**
         * Encodes the specified SearchSpeechesDateResult message. Does not implicitly {@link mediaarchiver.SearchSpeechesDateResult.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.SearchSpeechesDateResult
         * @static
         * @param {mediaarchiver.ISearchSpeechesDateResult} message SearchSpeechesDateResult message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchSpeechesDateResult.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Count != null && Object.hasOwnProperty.call(message, "Count"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.Count);
            if (message.Result != null && message.Result.length)
                for (let i = 0; i < message.Result.length; ++i)
                    $root.mediaarchiver.SearchSpeechesWord.encode(message.Result[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SearchSpeechesDateResult message, length delimited. Does not implicitly {@link mediaarchiver.SearchSpeechesDateResult.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.SearchSpeechesDateResult
         * @static
         * @param {mediaarchiver.ISearchSpeechesDateResult} message SearchSpeechesDateResult message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchSpeechesDateResult.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SearchSpeechesDateResult message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.SearchSpeechesDateResult
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.SearchSpeechesDateResult} SearchSpeechesDateResult
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchSpeechesDateResult.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.SearchSpeechesDateResult();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Count = reader.uint32();
                    break;
                case 2:
                    if (!(message.Result && message.Result.length))
                        message.Result = [];
                    message.Result.push($root.mediaarchiver.SearchSpeechesWord.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SearchSpeechesDateResult message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.SearchSpeechesDateResult
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.SearchSpeechesDateResult} SearchSpeechesDateResult
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchSpeechesDateResult.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SearchSpeechesDateResult message.
         * @function verify
         * @memberof mediaarchiver.SearchSpeechesDateResult
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SearchSpeechesDateResult.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Count != null && message.hasOwnProperty("Count"))
                if (!$util.isInteger(message.Count))
                    return "Count: integer expected";
            if (message.Result != null && message.hasOwnProperty("Result")) {
                if (!Array.isArray(message.Result))
                    return "Result: array expected";
                for (let i = 0; i < message.Result.length; ++i) {
                    let error = $root.mediaarchiver.SearchSpeechesWord.verify(message.Result[i]);
                    if (error)
                        return "Result." + error;
                }
            }
            return null;
        };

        /**
         * Creates a SearchSpeechesDateResult message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.SearchSpeechesDateResult
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.SearchSpeechesDateResult} SearchSpeechesDateResult
         */
        SearchSpeechesDateResult.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.SearchSpeechesDateResult)
                return object;
            let message = new $root.mediaarchiver.SearchSpeechesDateResult();
            if (object.Count != null)
                message.Count = object.Count >>> 0;
            if (object.Result) {
                if (!Array.isArray(object.Result))
                    throw TypeError(".mediaarchiver.SearchSpeechesDateResult.Result: array expected");
                message.Result = [];
                for (let i = 0; i < object.Result.length; ++i) {
                    if (typeof object.Result[i] !== "object")
                        throw TypeError(".mediaarchiver.SearchSpeechesDateResult.Result: object expected");
                    message.Result[i] = $root.mediaarchiver.SearchSpeechesWord.fromObject(object.Result[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a SearchSpeechesDateResult message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.SearchSpeechesDateResult
         * @static
         * @param {mediaarchiver.SearchSpeechesDateResult} message SearchSpeechesDateResult
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SearchSpeechesDateResult.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Result = [];
            if (options.defaults)
                object.Count = 0;
            if (message.Count != null && message.hasOwnProperty("Count"))
                object.Count = message.Count;
            if (message.Result && message.Result.length) {
                object.Result = [];
                for (let j = 0; j < message.Result.length; ++j)
                    object.Result[j] = $root.mediaarchiver.SearchSpeechesWord.toObject(message.Result[j], options);
            }
            return object;
        };

        /**
         * Converts this SearchSpeechesDateResult to JSON.
         * @function toJSON
         * @memberof mediaarchiver.SearchSpeechesDateResult
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SearchSpeechesDateResult.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SearchSpeechesDateResult;
    })();

    mediaarchiver.SearchWords = (function() {

        /**
         * Properties of a SearchWords.
         * @memberof mediaarchiver
         * @interface ISearchWords
         * @property {Array.<string>|null} [WordsUID] SearchWords WordsUID
         * @property {string|null} [MediaUID] SearchWords MediaUID
         */

        /**
         * Constructs a new SearchWords.
         * @memberof mediaarchiver
         * @classdesc Represents a SearchWords.
         * @implements ISearchWords
         * @constructor
         * @param {mediaarchiver.ISearchWords=} [properties] Properties to set
         */
        function SearchWords(properties) {
            this.WordsUID = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SearchWords WordsUID.
         * @member {Array.<string>} WordsUID
         * @memberof mediaarchiver.SearchWords
         * @instance
         */
        SearchWords.prototype.WordsUID = $util.emptyArray;

        /**
         * SearchWords MediaUID.
         * @member {string} MediaUID
         * @memberof mediaarchiver.SearchWords
         * @instance
         */
        SearchWords.prototype.MediaUID = "";

        /**
         * Creates a new SearchWords instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.SearchWords
         * @static
         * @param {mediaarchiver.ISearchWords=} [properties] Properties to set
         * @returns {mediaarchiver.SearchWords} SearchWords instance
         */
        SearchWords.create = function create(properties) {
            return new SearchWords(properties);
        };

        /**
         * Encodes the specified SearchWords message. Does not implicitly {@link mediaarchiver.SearchWords.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.SearchWords
         * @static
         * @param {mediaarchiver.ISearchWords} message SearchWords message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchWords.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.WordsUID != null && message.WordsUID.length)
                for (let i = 0; i < message.WordsUID.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.WordsUID[i]);
            if (message.MediaUID != null && Object.hasOwnProperty.call(message, "MediaUID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.MediaUID);
            return writer;
        };

        /**
         * Encodes the specified SearchWords message, length delimited. Does not implicitly {@link mediaarchiver.SearchWords.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.SearchWords
         * @static
         * @param {mediaarchiver.ISearchWords} message SearchWords message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchWords.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SearchWords message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.SearchWords
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.SearchWords} SearchWords
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchWords.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.SearchWords();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.WordsUID && message.WordsUID.length))
                        message.WordsUID = [];
                    message.WordsUID.push(reader.string());
                    break;
                case 2:
                    message.MediaUID = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SearchWords message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.SearchWords
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.SearchWords} SearchWords
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchWords.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SearchWords message.
         * @function verify
         * @memberof mediaarchiver.SearchWords
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SearchWords.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.WordsUID != null && message.hasOwnProperty("WordsUID")) {
                if (!Array.isArray(message.WordsUID))
                    return "WordsUID: array expected";
                for (let i = 0; i < message.WordsUID.length; ++i)
                    if (!$util.isString(message.WordsUID[i]))
                        return "WordsUID: string[] expected";
            }
            if (message.MediaUID != null && message.hasOwnProperty("MediaUID"))
                if (!$util.isString(message.MediaUID))
                    return "MediaUID: string expected";
            return null;
        };

        /**
         * Creates a SearchWords message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.SearchWords
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.SearchWords} SearchWords
         */
        SearchWords.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.SearchWords)
                return object;
            let message = new $root.mediaarchiver.SearchWords();
            if (object.WordsUID) {
                if (!Array.isArray(object.WordsUID))
                    throw TypeError(".mediaarchiver.SearchWords.WordsUID: array expected");
                message.WordsUID = [];
                for (let i = 0; i < object.WordsUID.length; ++i)
                    message.WordsUID[i] = String(object.WordsUID[i]);
            }
            if (object.MediaUID != null)
                message.MediaUID = String(object.MediaUID);
            return message;
        };

        /**
         * Creates a plain object from a SearchWords message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.SearchWords
         * @static
         * @param {mediaarchiver.SearchWords} message SearchWords
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SearchWords.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.WordsUID = [];
            if (options.defaults)
                object.MediaUID = "";
            if (message.WordsUID && message.WordsUID.length) {
                object.WordsUID = [];
                for (let j = 0; j < message.WordsUID.length; ++j)
                    object.WordsUID[j] = message.WordsUID[j];
            }
            if (message.MediaUID != null && message.hasOwnProperty("MediaUID"))
                object.MediaUID = message.MediaUID;
            return object;
        };

        /**
         * Converts this SearchWords to JSON.
         * @function toJSON
         * @memberof mediaarchiver.SearchWords
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SearchWords.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SearchWords;
    })();

    mediaarchiver.SearchWordResult = (function() {

        /**
         * Properties of a SearchWordResult.
         * @memberof mediaarchiver
         * @interface ISearchWordResult
         * @property {string|null} [Media] SearchWordResult Media
         * @property {string|null} [Word] SearchWordResult Word
         * @property {string|null} [UID] SearchWordResult UID
         * @property {number|Long|null} [Start] SearchWordResult Start
         * @property {number|Long|null} [End] SearchWordResult End
         */

        /**
         * Constructs a new SearchWordResult.
         * @memberof mediaarchiver
         * @classdesc Represents a SearchWordResult.
         * @implements ISearchWordResult
         * @constructor
         * @param {mediaarchiver.ISearchWordResult=} [properties] Properties to set
         */
        function SearchWordResult(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SearchWordResult Media.
         * @member {string} Media
         * @memberof mediaarchiver.SearchWordResult
         * @instance
         */
        SearchWordResult.prototype.Media = "";

        /**
         * SearchWordResult Word.
         * @member {string} Word
         * @memberof mediaarchiver.SearchWordResult
         * @instance
         */
        SearchWordResult.prototype.Word = "";

        /**
         * SearchWordResult UID.
         * @member {string} UID
         * @memberof mediaarchiver.SearchWordResult
         * @instance
         */
        SearchWordResult.prototype.UID = "";

        /**
         * SearchWordResult Start.
         * @member {number|Long} Start
         * @memberof mediaarchiver.SearchWordResult
         * @instance
         */
        SearchWordResult.prototype.Start = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SearchWordResult End.
         * @member {number|Long} End
         * @memberof mediaarchiver.SearchWordResult
         * @instance
         */
        SearchWordResult.prototype.End = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new SearchWordResult instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.SearchWordResult
         * @static
         * @param {mediaarchiver.ISearchWordResult=} [properties] Properties to set
         * @returns {mediaarchiver.SearchWordResult} SearchWordResult instance
         */
        SearchWordResult.create = function create(properties) {
            return new SearchWordResult(properties);
        };

        /**
         * Encodes the specified SearchWordResult message. Does not implicitly {@link mediaarchiver.SearchWordResult.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.SearchWordResult
         * @static
         * @param {mediaarchiver.ISearchWordResult} message SearchWordResult message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchWordResult.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Media != null && Object.hasOwnProperty.call(message, "Media"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Media);
            if (message.Word != null && Object.hasOwnProperty.call(message, "Word"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Word);
            if (message.UID != null && Object.hasOwnProperty.call(message, "UID"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.UID);
            if (message.Start != null && Object.hasOwnProperty.call(message, "Start"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.Start);
            if (message.End != null && Object.hasOwnProperty.call(message, "End"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.End);
            return writer;
        };

        /**
         * Encodes the specified SearchWordResult message, length delimited. Does not implicitly {@link mediaarchiver.SearchWordResult.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.SearchWordResult
         * @static
         * @param {mediaarchiver.ISearchWordResult} message SearchWordResult message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchWordResult.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SearchWordResult message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.SearchWordResult
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.SearchWordResult} SearchWordResult
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchWordResult.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.SearchWordResult();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Media = reader.string();
                    break;
                case 2:
                    message.Word = reader.string();
                    break;
                case 3:
                    message.UID = reader.string();
                    break;
                case 4:
                    message.Start = reader.uint64();
                    break;
                case 5:
                    message.End = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SearchWordResult message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.SearchWordResult
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.SearchWordResult} SearchWordResult
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchWordResult.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SearchWordResult message.
         * @function verify
         * @memberof mediaarchiver.SearchWordResult
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SearchWordResult.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Media != null && message.hasOwnProperty("Media"))
                if (!$util.isString(message.Media))
                    return "Media: string expected";
            if (message.Word != null && message.hasOwnProperty("Word"))
                if (!$util.isString(message.Word))
                    return "Word: string expected";
            if (message.UID != null && message.hasOwnProperty("UID"))
                if (!$util.isString(message.UID))
                    return "UID: string expected";
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (!$util.isInteger(message.Start) && !(message.Start && $util.isInteger(message.Start.low) && $util.isInteger(message.Start.high)))
                    return "Start: integer|Long expected";
            if (message.End != null && message.hasOwnProperty("End"))
                if (!$util.isInteger(message.End) && !(message.End && $util.isInteger(message.End.low) && $util.isInteger(message.End.high)))
                    return "End: integer|Long expected";
            return null;
        };

        /**
         * Creates a SearchWordResult message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.SearchWordResult
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.SearchWordResult} SearchWordResult
         */
        SearchWordResult.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.SearchWordResult)
                return object;
            let message = new $root.mediaarchiver.SearchWordResult();
            if (object.Media != null)
                message.Media = String(object.Media);
            if (object.Word != null)
                message.Word = String(object.Word);
            if (object.UID != null)
                message.UID = String(object.UID);
            if (object.Start != null)
                if ($util.Long)
                    (message.Start = $util.Long.fromValue(object.Start)).unsigned = true;
                else if (typeof object.Start === "string")
                    message.Start = parseInt(object.Start, 10);
                else if (typeof object.Start === "number")
                    message.Start = object.Start;
                else if (typeof object.Start === "object")
                    message.Start = new $util.LongBits(object.Start.low >>> 0, object.Start.high >>> 0).toNumber(true);
            if (object.End != null)
                if ($util.Long)
                    (message.End = $util.Long.fromValue(object.End)).unsigned = true;
                else if (typeof object.End === "string")
                    message.End = parseInt(object.End, 10);
                else if (typeof object.End === "number")
                    message.End = object.End;
                else if (typeof object.End === "object")
                    message.End = new $util.LongBits(object.End.low >>> 0, object.End.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a SearchWordResult message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.SearchWordResult
         * @static
         * @param {mediaarchiver.SearchWordResult} message SearchWordResult
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SearchWordResult.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.Media = "";
                object.Word = "";
                object.UID = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.Start = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.Start = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.End = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.End = options.longs === String ? "0" : 0;
            }
            if (message.Media != null && message.hasOwnProperty("Media"))
                object.Media = message.Media;
            if (message.Word != null && message.hasOwnProperty("Word"))
                object.Word = message.Word;
            if (message.UID != null && message.hasOwnProperty("UID"))
                object.UID = message.UID;
            if (message.Start != null && message.hasOwnProperty("Start"))
                if (typeof message.Start === "number")
                    object.Start = options.longs === String ? String(message.Start) : message.Start;
                else
                    object.Start = options.longs === String ? $util.Long.prototype.toString.call(message.Start) : options.longs === Number ? new $util.LongBits(message.Start.low >>> 0, message.Start.high >>> 0).toNumber(true) : message.Start;
            if (message.End != null && message.hasOwnProperty("End"))
                if (typeof message.End === "number")
                    object.End = options.longs === String ? String(message.End) : message.End;
                else
                    object.End = options.longs === String ? $util.Long.prototype.toString.call(message.End) : options.longs === Number ? new $util.LongBits(message.End.low >>> 0, message.End.high >>> 0).toNumber(true) : message.End;
            return object;
        };

        /**
         * Converts this SearchWordResult to JSON.
         * @function toJSON
         * @memberof mediaarchiver.SearchWordResult
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SearchWordResult.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SearchWordResult;
    })();

    mediaarchiver.SearchWordsResult = (function() {

        /**
         * Properties of a SearchWordsResult.
         * @memberof mediaarchiver
         * @interface ISearchWordsResult
         * @property {Array.<mediaarchiver.ISearchWordResult>|null} [Words] SearchWordsResult Words
         */

        /**
         * Constructs a new SearchWordsResult.
         * @memberof mediaarchiver
         * @classdesc Represents a SearchWordsResult.
         * @implements ISearchWordsResult
         * @constructor
         * @param {mediaarchiver.ISearchWordsResult=} [properties] Properties to set
         */
        function SearchWordsResult(properties) {
            this.Words = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SearchWordsResult Words.
         * @member {Array.<mediaarchiver.ISearchWordResult>} Words
         * @memberof mediaarchiver.SearchWordsResult
         * @instance
         */
        SearchWordsResult.prototype.Words = $util.emptyArray;

        /**
         * Creates a new SearchWordsResult instance using the specified properties.
         * @function create
         * @memberof mediaarchiver.SearchWordsResult
         * @static
         * @param {mediaarchiver.ISearchWordsResult=} [properties] Properties to set
         * @returns {mediaarchiver.SearchWordsResult} SearchWordsResult instance
         */
        SearchWordsResult.create = function create(properties) {
            return new SearchWordsResult(properties);
        };

        /**
         * Encodes the specified SearchWordsResult message. Does not implicitly {@link mediaarchiver.SearchWordsResult.verify|verify} messages.
         * @function encode
         * @memberof mediaarchiver.SearchWordsResult
         * @static
         * @param {mediaarchiver.ISearchWordsResult} message SearchWordsResult message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchWordsResult.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Words != null && message.Words.length)
                for (let i = 0; i < message.Words.length; ++i)
                    $root.mediaarchiver.SearchWordResult.encode(message.Words[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SearchWordsResult message, length delimited. Does not implicitly {@link mediaarchiver.SearchWordsResult.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mediaarchiver.SearchWordsResult
         * @static
         * @param {mediaarchiver.ISearchWordsResult} message SearchWordsResult message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchWordsResult.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SearchWordsResult message from the specified reader or buffer.
         * @function decode
         * @memberof mediaarchiver.SearchWordsResult
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mediaarchiver.SearchWordsResult} SearchWordsResult
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchWordsResult.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mediaarchiver.SearchWordsResult();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.Words && message.Words.length))
                        message.Words = [];
                    message.Words.push($root.mediaarchiver.SearchWordResult.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SearchWordsResult message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mediaarchiver.SearchWordsResult
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mediaarchiver.SearchWordsResult} SearchWordsResult
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchWordsResult.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SearchWordsResult message.
         * @function verify
         * @memberof mediaarchiver.SearchWordsResult
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SearchWordsResult.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Words != null && message.hasOwnProperty("Words")) {
                if (!Array.isArray(message.Words))
                    return "Words: array expected";
                for (let i = 0; i < message.Words.length; ++i) {
                    let error = $root.mediaarchiver.SearchWordResult.verify(message.Words[i]);
                    if (error)
                        return "Words." + error;
                }
            }
            return null;
        };

        /**
         * Creates a SearchWordsResult message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mediaarchiver.SearchWordsResult
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mediaarchiver.SearchWordsResult} SearchWordsResult
         */
        SearchWordsResult.fromObject = function fromObject(object) {
            if (object instanceof $root.mediaarchiver.SearchWordsResult)
                return object;
            let message = new $root.mediaarchiver.SearchWordsResult();
            if (object.Words) {
                if (!Array.isArray(object.Words))
                    throw TypeError(".mediaarchiver.SearchWordsResult.Words: array expected");
                message.Words = [];
                for (let i = 0; i < object.Words.length; ++i) {
                    if (typeof object.Words[i] !== "object")
                        throw TypeError(".mediaarchiver.SearchWordsResult.Words: object expected");
                    message.Words[i] = $root.mediaarchiver.SearchWordResult.fromObject(object.Words[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a SearchWordsResult message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mediaarchiver.SearchWordsResult
         * @static
         * @param {mediaarchiver.SearchWordsResult} message SearchWordsResult
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SearchWordsResult.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.Words = [];
            if (message.Words && message.Words.length) {
                object.Words = [];
                for (let j = 0; j < message.Words.length; ++j)
                    object.Words[j] = $root.mediaarchiver.SearchWordResult.toObject(message.Words[j], options);
            }
            return object;
        };

        /**
         * Converts this SearchWordsResult to JSON.
         * @function toJSON
         * @memberof mediaarchiver.SearchWordsResult
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SearchWordsResult.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SearchWordsResult;
    })();

    return mediaarchiver;
})();

export { $root as default };
